/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: any; output: any; }
  /** A single JSON value optionally encoded with a Sage Forest addition */
  DecisionTreesJSON: { input: any; output: any; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Parses input as and serializes output to ISO 8601 durations */
  Iso8601Duration: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  /**
   * A GraphQL::Types::Int to be used with the MoneyType. The difference here is that
   * the MAX integer size is mapped to Javascript's MAX_SAFE_INTEGER which is bigger
   * than the default one of 32 bits.This way we will be safer when dealing with
   * currencies that are devaluedor that have very small subunits
   */
  MoneyInt: { input: any; output: any; }
  /**
   * This scalar takes Times and transmits them as strings,
   *     encoding them according to ISO 8601 (extended format) without seconds and
   *     time zone
   */
  TimeWithoutSecondsAndTz: { input: any; output: any; }
};

export type AccountMappingInput = {
  /** Id of the account record which will be associated with the given payroll type */
  accountId: Scalars['ID']['input'];
  /** Id of the cost center which will be associated with the given payroll type and account */
  costCenterId?: InputMaybe<Scalars['ID']['input']>;
  /** The Oyster specific identifier, that represents a payroll component type */
  payrollType: PayrollComponentTypeEnum;
};

export type AccountingAccountType = {
  __typename?: 'AccountingAccountType';
  currency?: Maybe<Scalars['String']['output']>;
  default: Scalars['Boolean']['output'];
  /** Identifier of the account provided by Codat, unique for the Codat company */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AccountingContractorMappingType = {
  __typename?: 'AccountingContractorMappingType';
  contractCurrencyCode?: Maybe<CurrencyEnum>;
  contractor: User;
  linked: Scalars['Boolean']['output'];
};

export type AccountingIntegrationType = {
  __typename?: 'AccountingIntegrationType';
  /** Accounts are the categories a business uses to record transactions */
  accounts: Array<AccountingAccountType>;
  /** The list of Oyster payroll types as they are mapped to their corresponding accounts */
  accountsPayrollTypesMapping: Array<AccountingPayrollTypeToAccountMappingType>;
  alerts: Array<Alert>;
  /** Name of the underlying company, organization or account from the connected integration */
  connectionName: Scalars['String']['output'];
  /** List of contractors with the information if they are linked to a vendor or not in the accounting platform */
  contractorsMapping: Array<AccountingContractorMappingType>;
  creditAccount?: Maybe<AccountingAccountType>;
  defaultAccount?: Maybe<AccountingAccountType>;
  /** Integration platform identifier which represents certain integration (e.g. quickbooksonline) */
  platform: Scalars['String']['output'];
  /** Integration setup values which describes setup state for uploading data to this integration */
  setupState: AccountingSetupStateType;
  /** Integration state which describes if integration is active, pending etc */
  state: Scalars['String']['output'];
  /** Useful stats about the integration, such as last-synced-at timestamps */
  stats: AccountingStatsType;
  trackingCategories: Array<AccountingTrackingCategoryType>;
  /** The list of tracking categories as they are mapped to their corresponding cost centers */
  trackingCategoriesMapping: Array<AccountingTrackingCategoryMappingType>;
  trackingCategoryGroups: Array<AccountingTrackingCategoryGroupType>;
  vendors: Array<AccountingVendorType>;
};

export type AccountingPayrollTypeToAccountMappingType = {
  __typename?: 'AccountingPayrollTypeToAccountMappingType';
  accountId: Scalars['ID']['output'];
  accountName: Scalars['String']['output'];
  costCenterId?: Maybe<Scalars['ID']['output']>;
  /** Oyster payroll component type */
  payrollType?: Maybe<PayrollComponentTypeEnum>;
};

export type AccountingSetupStateType = {
  __typename?: 'AccountingSetupStateType';
  /** Last timestamp in which the company's accounts have been synced */
  accountsLastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Has set the default account to use for unmapped payroll types */
  hasDefaultAccount: Scalars['Boolean']['output'];
  /** Have the company's accounts been mapped to payroll types? */
  hasMappedAccounts: Scalars['Boolean']['output'];
  /**
   * Primary vendor in Oyster context means that integration knows
   * on behalf of which vendor it can upload billing data.
   * If option is true - means that integration knows which vendor to use.
   */
  hasPrimaryVendor: Scalars['Boolean']['output'];
  /** Last timestamp in which the company's vendors have been synced */
  vendorsLastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type AccountingStatsType = {
  __typename?: 'AccountingStatsType';
  /** Last timestamp in which the company's accounts have been synced */
  accountsLastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last timestamp in which contractors were mapped to vendors */
  contractorsLastMappedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last time at which an invoice was synced to the accounting platform */
  invoiceLastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last timestamp in which the company's vendors have been synced */
  vendorsLastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum AccountingSyncDataTypeEnum {
  Accounts = 'ACCOUNTS',
  Vendors = 'VENDORS'
}

export type AccountingTrackingCategoryGroupType = {
  __typename?: 'AccountingTrackingCategoryGroupType';
  /** Identifier of the tracking category group provided by Codat, unique for the Codat company */
  id: Scalars['ID']['output'];
  /** Name of the tracking category group (e.g. Departments, Region) */
  name: Scalars['String']['output'];
};

export type AccountingTrackingCategoryMappingType = {
  __typename?: 'AccountingTrackingCategoryMappingType';
  costCenterId: Scalars['ID']['output'];
  trackingCategoryId: Scalars['ID']['output'];
  trackingCategoryName: Scalars['String']['output'];
};

export type AccountingTrackingCategoryType = {
  __typename?: 'AccountingTrackingCategoryType';
  /** Name of the tracking category prepended by the name of all of its parents (e.g. US: California: San Francisco) */
  fullName: Scalars['String']['output'];
  /** Identifier of the tracking category group to which this tracking belongs to */
  groupId: Scalars['ID']['output'];
  /** Identifier of the tracking category provided by Codat, unique for the Codat company */
  id: Scalars['ID']['output'];
  /** Name of the tracking category (e.g. San Francisco) */
  name: Scalars['String']['output'];
};

export type AccountingVendorType = {
  __typename?: 'AccountingVendorType';
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  /** Identifier of the vendor provided by Codat, unique for the Codat company */
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * Primary vendor in Oyster context means that integration knows
   * on behalf of which vendor it can upload billing data.
   */
  primary: Scalars['Boolean']['output'];
};

export type AccrualCycleSpan = {
  __typename?: 'AccrualCycleSpan';
  endDate: Scalars['ISO8601Date']['output'];
  startDate: Scalars['ISO8601Date']['output'];
};

/** Autogenerated input type of ActivateAdpWorkforceNowIntegration */
export type ActivateAdpWorkforceNowIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of ActivateAdpWorkforceNowIntegration. */
export type ActivateAdpWorkforceNowIntegrationPayload = {
  __typename?: 'ActivateAdpWorkforceNowIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  setupToken: Scalars['String']['output'];
};

/** Autogenerated input type of ActivateDirectDebitEnforcement */
export type ActivateDirectDebitEnforcementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of ActivateDirectDebitEnforcement. */
export type ActivateDirectDebitEnforcementPayload = {
  __typename?: 'ActivateDirectDebitEnforcementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ActivateDiscount */
export type ActivateDiscountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  discountId: Scalars['String']['input'];
};

/** Autogenerated return type of ActivateDiscount. */
export type ActivateDiscountPayload = {
  __typename?: 'ActivateDiscountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discountActivation?: Maybe<DiscountActivation>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ActivateTrinetIntegration */
export type ActivateTrinetIntegrationInput = {
  clientId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientSecret: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  integrationCompanyId: Scalars['String']['input'];
};

/** Autogenerated return type of ActivateTrinetIntegration. */
export type ActivateTrinetIntegrationPayload = {
  __typename?: 'ActivateTrinetIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type ActiveRecordError = {
  __typename?: 'ActiveRecordError';
  attribute: Scalars['String']['output'];
  fullMessage: Scalars['String']['output'];
};

export type Actor = {
  __typename?: 'Actor';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isOysterStaff: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: ActorType;
};

export enum ActorType {
  System = 'SYSTEM',
  /** System actor, that triggers actions via scheduled jobs */
  SystemScheduler = 'SYSTEM_SCHEDULER',
  UnknownUser = 'UNKNOWN_USER',
  /** An actor that is a real User, having entry in the users table */
  User = 'USER'
}

/** Autogenerated input type of AddBillingEmailAddress */
export type AddBillingEmailAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

/** Autogenerated return type of AddBillingEmailAddress. */
export type AddBillingEmailAddressPayload = {
  __typename?: 'AddBillingEmailAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AddCartaIDsToEngagements */
export type AddCartaIDsToEngagementsInput = {
  cartaEngagementIds: Array<CartaEngagementId>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddCartaIDsToEngagements. */
export type AddCartaIDsToEngagementsPayload = {
  __typename?: 'AddCartaIDsToEngagementsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AddCompanyAdmin */
export type AddCompanyAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

/** Autogenerated return type of AddCompanyAdmin. */
export type AddCompanyAdminPayload = {
  __typename?: 'AddCompanyAdminPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
  invitation?: Maybe<Invitation>;
};

/** Autogenerated input type of AddDependentToEnrollment */
export type AddDependentToEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverageStartDate: Scalars['ISO8601Date']['input'];
  dependentId: Scalars['ID']['input'];
  enrollmentId: Scalars['ID']['input'];
  enrollmentPrices?: InputMaybe<Array<BenefitsEnrollmentPriceInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddDependentToEnrollment. */
export type AddDependentToEnrollmentPayload = {
  __typename?: 'AddDependentToEnrollmentPayload';
  benefitEnrollment: BenefitsEnrollmentBase;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dependent: Dependent;
  dependentEnrollment: BenefitsDependentEnrollment;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AddInvoicesToPaymentsGroup */
export type AddInvoicesToPaymentsGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceIds: Array<Scalars['ID']['input']>;
  paymentsGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddInvoicesToPaymentsGroup. */
export type AddInvoicesToPaymentsGroupPayload = {
  __typename?: 'AddInvoicesToPaymentsGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentsGroup?: Maybe<PaymentsGroup>;
};

export type AddOn = {
  __typename?: 'AddOn';
  authorizations?: Maybe<Authorization>;
  claimedPrice: ClaimedPrice;
  deactivatedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  description: Scalars['String']['output'];
  expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeactivated: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  isRecurring: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nextBillingDate: Scalars['ISO8601Date']['output'];
  plan: NewPlan;
  startsOn: Scalars['ISO8601Date']['output'];
  trialDaysRemaining: Scalars['Int']['output'];
};

export type AddOnCollection = {
  __typename?: 'AddOnCollection';
  collection: Array<AddOn>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of AddOnDeactivate */
export type AddOnDeactivateInput = {
  addOnId: Scalars['String']['input'];
  cancelNow?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddOnDeactivate. */
export type AddOnDeactivatePayload = {
  __typename?: 'AddOnDeactivatePayload';
  addOn?: Maybe<AddOn>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deactivatedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AddOnStartTrial */
export type AddOnStartTrialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expiresOn: Scalars['ISO8601Date']['input'];
  planId: Scalars['String']['input'];
  startsOn: Scalars['ISO8601Date']['input'];
  targetId: Scalars['String']['input'];
};

/** Autogenerated return type of AddOnStartTrial. */
export type AddOnStartTrialPayload = {
  __typename?: 'AddOnStartTrialPayload';
  addOn?: Maybe<AddOn>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AddOnSubscribe */
export type AddOnSubscribeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
  startsOn: Scalars['ISO8601Date']['input'];
  targetId: Scalars['String']['input'];
};

/** Autogenerated return type of AddOnSubscribe. */
export type AddOnSubscribePayload = {
  __typename?: 'AddOnSubscribePayload';
  addOn?: Maybe<AddOn>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AddSignatoryPointOfContact */
export type AddSignatoryPointOfContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddSignatoryPointOfContact. */
export type AddSignatoryPointOfContactPayload = {
  __typename?: 'AddSignatoryPointOfContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  signatoryPointOfContact?: Maybe<ExternalPointOfContact>;
};

/** Autogenerated input type of AddTmsToInProgressBulkOffboading */
export type AddTmsToInProgressBulkOffboadingInput = {
  bulkOffboardingId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  params: Array<BulkAddToInProgressTerminationInputType>;
};

/** Autogenerated return type of AddTmsToInProgressBulkOffboading. */
export type AddTmsToInProgressBulkOffboadingPayload = {
  __typename?: 'AddTmsToInProgressBulkOffboadingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type AdditionalCosts = {
  __typename?: 'AdditionalCosts';
  bonus: Scalars['Float']['output'];
  commission: Scalars['Float']['output'];
  expenses: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type AdditionalTerminationPayment = {
  __typename?: 'AdditionalTerminationPayment';
  allowance?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amountAsPercentage?: Maybe<Scalars['Float']['output']>;
  amountType: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  errors: Array<ActiveRecordError>;
  id: Scalars['ID']['output'];
  numRecurringPayments?: Maybe<Scalars['Int']['output']>;
  offboardingPayType?: Maybe<OffboardingPayType>;
  paymentFrequency?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  periodDuration?: Maybe<Scalars['Int']['output']>;
  redundancyPaymentType?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AdditionalTerminationPaymentCreate */
export type AdditionalTerminationPaymentCreateInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountAsPercentage?: InputMaybe<Scalars['Float']['input']>;
  amountType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  numRecurringPayments?: InputMaybe<Scalars['Int']['input']>;
  payTypeId?: InputMaybe<Scalars['ID']['input']>;
  paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdditionalTerminationPaymentCreate. */
export type AdditionalTerminationPaymentCreatePayload = {
  __typename?: 'AdditionalTerminationPaymentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

/** Autogenerated input type of AdditionalTerminationPaymentDestroy */
export type AdditionalTerminationPaymentDestroyInput = {
  additionalTerminationPaymentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdditionalTerminationPaymentDestroy. */
export type AdditionalTerminationPaymentDestroyPayload = {
  __typename?: 'AdditionalTerminationPaymentDestroyPayload';
  additionalTerminationPayment: AdditionalTerminationPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type AdditionalTerminationPaymentInput = {
  additionalTerminationPayment?: InputMaybe<Scalars['ID']['input']>;
  allowance?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountType?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  offboardingPayType?: InputMaybe<Scalars['ID']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  periodDuration?: InputMaybe<Scalars['Int']['input']>;
  redundancyPaymentType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of AdditionalTerminationPaymentUpdate */
export type AdditionalTerminationPaymentUpdateInput = {
  additionalTerminationPaymentId: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountAsPercentage?: InputMaybe<Scalars['Float']['input']>;
  amountType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  numRecurringPayments?: InputMaybe<Scalars['Int']['input']>;
  payTypeId?: InputMaybe<Scalars['ID']['input']>;
  paymentFrequency?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AdditionalTerminationPaymentUpdate. */
export type AdditionalTerminationPaymentUpdatePayload = {
  __typename?: 'AdditionalTerminationPaymentUpdatePayload';
  additionalTerminationPayment: AdditionalTerminationPayment;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type Address = {
  __typename?: 'Address';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  authorizations?: Maybe<Authorization>;
  city?: Maybe<Scalars['String']['output']>;
  complete: Scalars['Boolean']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  pushedFields?: Maybe<Array<Scalars['String']['output']>>;
  region?: Maybe<Scalars['String']['output']>;
  syncedFields?: Maybe<Array<Scalars['String']['output']>>;
};

export type AddressArguments = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  kind?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  region: Scalars['String']['input'];
};

/** Objects which may have an address */
export type AddressSubject = Company | Contract | User;

/** Autogenerated input type of AdjustChargeStateManually */
export type AdjustChargeStateManuallyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  event: ChargeStateTransition;
  paymentRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdjustChargeStateManually. */
export type AdjustChargeStateManuallyPayload = {
  __typename?: 'AdjustChargeStateManuallyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentRequest: ChargePaymentRequest;
};

/** Autogenerated input type of AdjustPayoutStateManually */
export type AdjustPayoutStateManuallyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  event: PayoutStateTransition;
  paymentRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of AdjustPayoutStateManually. */
export type AdjustPayoutStateManuallyPayload = {
  __typename?: 'AdjustPayoutStateManuallyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentRequest: PayoutPaymentRequest;
};

/** Autogenerated input type of AgreeToTerms */
export type AgreeToTermsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of AgreeToTerms. */
export type AgreeToTermsPayload = {
  __typename?: 'AgreeToTermsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

export type Agreement = {
  __typename?: 'Agreement';
  agreementType: AgreementTypeEnum;
  automation?: Maybe<AgreementAutomation>;
  envelope?: Maybe<Envelope>;
  events?: Maybe<Array<AgreementEventType>>;
  id: Scalars['ID']['output'];
  isAutomated: Scalars['Boolean']['output'];
  isESignEnabled: Scalars['Boolean']['output'];
  isSynced: Scalars['Boolean']['output'];
  lastUpdate?: Maybe<AgreementIteration>;
  lastVerifiedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  parties: Array<AgreementPartyTypeEnum>;
  reasonForBecomingManual?: Maybe<AgreementReasonForBecomingManualEnum>;
  requiredPlaceholders?: Maybe<Array<AgreementPlaceholderEnum>>;
  state: AgreementStateEnum;
  templateVariables?: Maybe<Array<AgreementTemplateVariable>>;
};

export type AgreementAutomation = {
  __typename?: 'AgreementAutomation';
  state?: Maybe<AgreementAutomationStateEnum>;
};

export enum AgreementAutomationStateEnum {
  Disabled = 'DISABLED',
  Failed = 'FAILED',
  Generated = 'GENERATED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum AgreementESignTypeEnum {
  AdvancedESign = 'ADVANCED_E_SIGN',
  QualifiedESign = 'QUALIFIED_E_SIGN',
  SimpleESign = 'SIMPLE_E_SIGN'
}

export type AgreementEventType = {
  __typename?: 'AgreementEventType';
  actorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventType: AgreementEventTypeEnum;
};

export enum AgreementEventTypeEnum {
  AutomationDisabled = 'AUTOMATION_DISABLED',
  AutomationEnabled = 'AUTOMATION_ENABLED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  ESignDisabled = 'E_SIGN_DISABLED',
  Generated = 'GENERATED',
  Signed = 'SIGNED',
  Uploaded = 'UPLOADED',
  Verified = 'VERIFIED'
}

export type AgreementIteration = {
  __typename?: 'AgreementIteration';
  authorizations?: Maybe<Authorization>;
  file: DownloadLink;
  fileDocx?: Maybe<DownloadLink>;
  fileSignable?: Maybe<DownloadLink>;
  party: AgreementPartyTypeEnum;
  timestamp: Scalars['ISO8601DateTime']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  viewedByMe: Scalars['Boolean']['output'];
};

export enum AgreementPartyTypeEnum {
  Employee = 'EMPLOYEE',
  Employer = 'EMPLOYER',
  OysterStaff = 'OYSTER_STAFF'
}

export enum AgreementPlaceholderEnum {
  CustomerName = 'CUSTOMER_NAME',
  CustomerSignature = 'CUSTOMER_SIGNATURE',
  CustomerSignDate = 'CUSTOMER_SIGN_DATE',
  CustomerTitle = 'CUSTOMER_TITLE',
  OysterSignatoryName = 'OYSTER_SIGNATORY_NAME',
  OysterSignatorySignature = 'OYSTER_SIGNATORY_SIGNATURE',
  OysterSignatorySignDate = 'OYSTER_SIGNATORY_SIGN_DATE',
  OysterSignatoryTitle = 'OYSTER_SIGNATORY_TITLE',
  TmSignature = 'TM_SIGNATURE',
  TmSignDate = 'TM_SIGN_DATE'
}

export enum AgreementReasonForBecomingManualEnum {
  AutomationDisabledByUpload = 'AUTOMATION_DISABLED_BY_UPLOAD',
  NotAutomated = 'NOT_AUTOMATED',
  OptedOut = 'OPTED_OUT'
}

export enum AgreementStateEnum {
  Disabled = 'DISABLED',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  ReadyToSign = 'READY_TO_SIGN',
  Signed = 'SIGNED',
  Verified = 'VERIFIED'
}

/** Variable value can be String or array of Strings */
export type AgreementTemplateVariable = AgreementTemplateVariableArrayType | AgreementTemplateVariableStringType;

export type AgreementTemplateVariableArrayType = {
  __typename?: 'AgreementTemplateVariableArrayType';
  name: Scalars['String']['output'];
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export type AgreementTemplateVariableStringType = {
  __typename?: 'AgreementTemplateVariableStringType';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum AgreementTypeEnum {
  ConfidentialityAndIntellectualProperty = 'CONFIDENTIALITY_AND_INTELLECTUAL_PROPERTY',
  ContractorAgreementAmendment = 'CONTRACTOR_AGREEMENT_AMENDMENT',
  ContractCipa = 'CONTRACT_CIPA',
  ContractMerged = 'CONTRACT_MERGED',
  EmploymentAgreement = 'EMPLOYMENT_AGREEMENT',
  EmploymentAgreementAmendment = 'EMPLOYMENT_AGREEMENT_AMENDMENT',
  IntentLetter = 'INTENT_LETTER',
  OysterServiceAgreement = 'OYSTER_SERVICE_AGREEMENT',
  ProfessionalServiceAgreement = 'PROFESSIONAL_SERVICE_AGREEMENT',
  RemoteWork = 'REMOTE_WORK',
  RestrictiveCovenant = 'RESTRICTIVE_COVENANT',
  SepaMandateAgreement = 'SEPA_MANDATE_AGREEMENT',
  StandardPerl = 'STANDARD_PERL',
  StandardPerlWithSalary = 'STANDARD_PERL_WITH_SALARY',
  StatementOfWork = 'STATEMENT_OF_WORK',
  TerminationOfServiceAgreement = 'TERMINATION_OF_SERVICE_AGREEMENT'
}

export type Alert = {
  __typename?: 'Alert';
  cause: Scalars['String']['output'];
  contextMessages: Array<Scalars['String']['output']>;
  contextReference?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['ISO8601DateTime']['output'];
  type: AlertTypeEnum;
};

export type AlertCollection = {
  __typename?: 'AlertCollection';
  collection: Array<Alert>;
  metadata: CollectionMetadata;
};

export enum AlertTypeEnum {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export type Allowance = {
  __typename?: 'Allowance';
  amountAsPercentage?: Maybe<Scalars['String']['output']>;
  amountType: Scalars['String']['output'];
  customLabel?: Maybe<Scalars['String']['output']>;
  fixedAmount?: Maybe<FixedAmount>;
  guaranteed?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includedInGrossSalary?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  paymentFrequency: PaymentFrequencyEnum;
  prorated?: Maybe<Scalars['Boolean']['output']>;
  selectedMonths: Array<MonthsEnum>;
  statutory?: Maybe<Scalars['Boolean']['output']>;
  systemGenerated?: Maybe<Scalars['Boolean']['output']>;
};

export type AllowanceInput = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  amountAsPercentage?: InputMaybe<Scalars['String']['input']>;
  amountType: Scalars['String']['input'];
  customLabel?: InputMaybe<Scalars['String']['input']>;
  fixedAmount?: InputMaybe<FixedAmountInput>;
  includedInGrossSalary?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  paymentFrequency: PaymentFrequencyEnum;
  selectedMonths?: InputMaybe<Array<MonthsEnum>>;
  statutory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AllowancesAndBenefits = {
  __typename?: 'AllowancesAndBenefits';
  healthAndWellbeing: Scalars['Float']['output'];
  healthInsurance: Scalars['Float']['output'];
  sustenance: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  travel: Scalars['Float']['output'];
  workFromHome: Scalars['Float']['output'];
};

export type AmendmentFlow = {
  __typename?: 'AmendmentFlow';
  automatedTm: Scalars['Boolean']['output'];
};

export enum AmendmentProcessStateEnumType {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  DraftGenerated = 'DRAFT_GENERATED',
  EnvelopeCreated = 'ENVELOPE_CREATED',
  Started = 'STARTED',
  Verified = 'VERIFIED',
  WaitingForSignatures = 'WAITING_FOR_SIGNATURES'
}

export type AmendmentProcessType = {
  __typename?: 'AmendmentProcessType';
  agreement?: Maybe<Agreement>;
  authorizations?: Maybe<Authorization>;
  createdAt: Scalars['ISO8601Date']['output'];
  engagement: Engagement;
  engagementChangeTypes: Array<EngagementChangeChangeType>;
  extensionEngagementChange?: Maybe<EngagementChange>;
  id: Scalars['ID']['output'];
  isShared: Scalars['Boolean']['output'];
  modificationEngagementChange?: Maybe<EngagementChange>;
  requester: User;
  requesterName: Scalars['String']['output'];
  state: AmendmentProcessStateEnumType;
  strongId: Scalars['String']['output'];
};

export type AmountData = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
};

export type Answer = {
  __typename?: 'Answer';
  authorizations?: Maybe<Authorization>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  riskScore?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

/** Autogenerated input type of ApplyCreditNote */
export type ApplyCreditNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  creditNoteId: Scalars['String']['input'];
  invoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of ApplyCreditNote. */
export type ApplyCreditNotePayload = {
  __typename?: 'ApplyCreditNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ApproveEngagementChange */
export type ApproveEngagementChangeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementChangeId: Scalars['ID']['input'];
};

/** Autogenerated return type of ApproveEngagementChange. */
export type ApproveEngagementChangePayload = {
  __typename?: 'ApproveEngagementChangePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagementChange?: Maybe<EngagementChange>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ApproveExpenses */
export type ApproveExpensesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expenseIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ApproveExpenses. */
export type ApproveExpensesPayload = {
  __typename?: 'ApproveExpensesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  failedExpenses?: Maybe<Array<Expense>>;
  successfulExpenses?: Maybe<Array<Expense>>;
};

/** Autogenerated input type of Approve */
export type ApproveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  searchAttributes: InvoiceFiltersAttributes;
  timestamp: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated input type of ApproveInvoices */
export type ApproveInvoicesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ApproveInvoices. */
export type ApproveInvoicesPayload = {
  __typename?: 'ApproveInvoicesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of Approve. */
export type ApprovePayload = {
  __typename?: 'ApprovePayload';
  backgroundProcessParent: BackgroundProcessParent;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ApproveResignationCancellation */
export type ApproveResignationCancellationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of ApproveResignationCancellation. */
export type ApproveResignationCancellationPayload = {
  __typename?: 'ApproveResignationCancellationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

export type Aspect = CompanyAspect | ContractAspect | EmploymentAspect | StaffAspect;

export type AspectInterface = {
  company?: Maybe<Company>;
  engagement?: Maybe<Engagement>;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Autogenerated input type of AssignCostCenterToEngagement */
export type AssignCostCenterToEngagementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['ID']['input']>;
  engagementId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignCostCenterToEngagement. */
export type AssignCostCenterToEngagementPayload = {
  __typename?: 'AssignCostCenterToEngagementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AssignDepartment */
export type AssignDepartmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  engagementId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignDepartment. */
export type AssignDepartmentPayload = {
  __typename?: 'AssignDepartmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement: Engagement;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AssignSignatoryPointOfContact */
export type AssignSignatoryPointOfContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['String']['input'];
  externalPointOfContactId: Scalars['String']['input'];
  makeCompanyDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of AssignSignatoryPointOfContact. */
export type AssignSignatoryPointOfContactPayload = {
  __typename?: 'AssignSignatoryPointOfContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  engagement?: Maybe<Engagement>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of AssignStaffMembers */
export type AssignStaffMembersInput = {
  accountManagerId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  creditControlSpecialistId?: InputMaybe<Scalars['ID']['input']>;
  customerSuccessManagerId?: InputMaybe<Scalars['ID']['input']>;
  staffSalesRepresentativeId?: InputMaybe<Scalars['ID']['input']>;
  tier?: InputMaybe<CompanyTier>;
};

/** Autogenerated return type of AssignStaffMembers. */
export type AssignStaffMembersPayload = {
  __typename?: 'AssignStaffMembersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AssignTeamMemberDirectManager */
export type AssignTeamMemberDirectManagerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  directManagerId: Scalars['ID']['input'];
  permissions?: InputMaybe<Array<DirectManagerPermissionEnumType>>;
  teamMemberId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssignTeamMemberDirectManager. */
export type AssignTeamMemberDirectManagerPayload = {
  __typename?: 'AssignTeamMemberDirectManagerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  teamMemberDirectManager?: Maybe<TeamMemberDirectManager>;
};

export type AuditItem = {
  __typename?: 'AuditItem';
  by: Actor;
  changes: Array<AuditItemChanges>;
  event: Scalars['String']['output'];
  when: Scalars['ISO8601DateTime']['output'];
};

export type AuditItemChanges = {
  __typename?: 'AuditItemChanges';
  from: Scalars['String']['output'];
  humanFieldName: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type AuditableObject = {
  auditHistory: Array<AuditItem>;
};


export type AuditableObjectAuditHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  only?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Authorization = {
  __typename?: 'Authorization';
  actions: Array<Scalars['String']['output']>;
  fields: Array<Scalars['String']['output']>;
};


export type AuthorizationActionsArgs = {
  requestedActions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated input type of AuthorizationAcceptTerms */
export type AuthorizationAcceptTermsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['ID']['input'];
};

/** Autogenerated return type of AuthorizationAcceptTerms. */
export type AuthorizationAcceptTermsPayload = {
  __typename?: 'AuthorizationAcceptTermsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export enum AuthorizationRoleEnumType {
  Admin = 'ADMIN',
  ClientRepresentative = 'CLIENT_REPRESENTATIVE',
  DirectManager = 'DIRECT_MANAGER',
  ExpensesAdmin = 'EXPENSES_ADMIN',
  ExternalRecruiter = 'EXTERNAL_RECRUITER',
  InvoicesAdmin = 'INVOICES_ADMIN',
  PayrollAdmin = 'PAYROLL_ADMIN',
  ResellerAdmin = 'RESELLER_ADMIN',
  ResellerRepresentative = 'RESELLER_REPRESENTATIVE',
  TimeOffAdmin = 'TIME_OFF_ADMIN'
}

export enum AuthorizationRoleResourceEnumType {
  Company = 'COMPANY',
  User = 'USER'
}

export type AuthorizationRoleType = {
  __typename?: 'AuthorizationRoleType';
  authorizations?: Maybe<Authorization>;
  company?: Maybe<Company>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  resourceType?: Maybe<AuthorizationRoleResourceEnumType>;
  role: AuthorizationRoleEnumType;
  termsPath?: Maybe<Scalars['String']['output']>;
  termsRequired?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type AuthorizationRoleTypeCollection = {
  __typename?: 'AuthorizationRoleTypeCollection';
  collection: Array<AuthorizationRoleType>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of AuthorizeDirectDebitOnPaymentMethod */
export type AuthorizeDirectDebitOnPaymentMethodInput = {
  authorized: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

/** Autogenerated return type of AuthorizeDirectDebitOnPaymentMethod. */
export type AuthorizeDirectDebitOnPaymentMethodPayload = {
  __typename?: 'AuthorizeDirectDebitOnPaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod: PaymentMethod;
};

export type AvailableIntegration = {
  __typename?: 'AvailableIntegration';
  /** About the integration */
  about?: Maybe<Scalars['JSON']['output']>;
  beta: Scalars['Boolean']['output'];
  /** Description of the integration */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the integration is enabled and can be connected
   * (some categories only allow one active integration at a time).
   */
  enabled: Scalars['Boolean']['output'];
  /** The integration's go-to url */
  gotoUrl?: Maybe<Scalars['String']['output']>;
  /** The integration's logo url */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the integration */
  name: Scalars['String']['output'];
  /** Integration platform identifier which represents certain integration (e.g. slack) */
  platform: Scalars['String']['output'];
  /**
   * The type of the integrated platform e.g.:
   * COMMUNICATION, ACCOUNTING or HRIS
   */
  platformType: PlatformTypeEnum;
  /**
   * Integration provider which is responsible for this integration instance
   * e.g. codat or app
   */
  provider: Scalars['String']['output'];
};

export type B2BPaymentMethod = PaymentMethodsCustomerBankAccountAchType | PaymentMethodsCustomerBankAccountSepaType;

/** Autogenerated input type of BackdateEngagementChange */
export type BackdateEngagementChangeInput = {
  applicableFrom: Scalars['ISO8601Date']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementChangeId: Scalars['ID']['input'];
  retroactivePayment?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of BackdateEngagementChange. */
export type BackdateEngagementChangePayload = {
  __typename?: 'BackdateEngagementChangePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagementChange?: Maybe<EngagementChange>;
  errors: Array<Scalars['String']['output']>;
};

export type BackgroundProcessChild = {
  __typename?: 'BackgroundProcessChild';
  company?: Maybe<Company>;
  done: Scalars['Boolean']['output'];
  errored: Scalars['Boolean']['output'];
  errors: Array<Scalars['String']['output']>;
  rowNumber?: Maybe<Scalars['Int']['output']>;
  steps: Array<BackgroundProcessChildStep>;
  succeeded: Scalars['Boolean']['output'];
  targetId?: Maybe<Scalars['ID']['output']>;
};

export type BackgroundProcessChildCollection = {
  __typename?: 'BackgroundProcessChildCollection';
  collection: Array<BackgroundProcessChild>;
  metadata: CollectionMetadata;
};

export type BackgroundProcessChildStep = {
  __typename?: 'BackgroundProcessChildStep';
  doneAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  errored?: Maybe<Scalars['Boolean']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  succeeded?: Maybe<Scalars['Boolean']['output']>;
};

export type BackgroundProcessParent = {
  __typename?: 'BackgroundProcessParent';
  allChildrenValidated: Scalars['Boolean']['output'];
  authorizations?: Maybe<Authorization>;
  children: BackgroundProcessChildCollection;
  childrenFailedAfterValidationTotal: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  initiatedBy: Actor;
  initiatedOn: Scalars['ISO8601DateTime']['output'];
  invalidChildrenTotal: Scalars['Int']['output'];
  processType: BackgroundProcessParentProcessType;
  status: Scalars['String']['output'];
  totalFailedCount: Scalars['Int']['output'];
};


export type BackgroundProcessParentChildrenArgs = {
  errored?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
  validationSucceeded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BackgroundProcessParentCollection = {
  __typename?: 'BackgroundProcessParentCollection';
  collection: Array<BackgroundProcessParent>;
  metadata: CollectionMetadata;
};

export enum BackgroundProcessParentProcessType {
  ContractorsFeesInvoiceGeneration = 'CONTRACTORS_FEES_INVOICE_GENERATION',
  ContractorInvoiceGeneration = 'CONTRACTOR_INVOICE_GENERATION',
  ContractorInvoiceRegeneration = 'CONTRACTOR_INVOICE_REGENERATION',
  CountryPayrollImport = 'COUNTRY_PAYROLL_IMPORT',
  DepositInvoiceRegeneration = 'DEPOSIT_INVOICE_REGENERATION',
  InvoicesBulkApproval = 'INVOICES_BULK_APPROVAL',
  InvoiceGeneration = 'INVOICE_GENERATION',
  InvoicePreFundingGeneration = 'INVOICE_PRE_FUNDING_GENERATION',
  OysterInvoiceRegeneration = 'OYSTER_INVOICE_REGENERATION',
  PayrollImport = 'PAYROLL_IMPORT',
  PayAsYouGoBulkInvoiceCreation = 'PAY_AS_YOU_GO_BULK_INVOICE_CREATION',
  SendInvoices = 'SEND_INVOICES'
}

export enum BadDebtCategory {
  InDebt = 'IN_DEBT',
  MajorDelays = 'MAJOR_DELAYS',
  MinorDelays = 'MINOR_DELAYS',
  UpToDate = 'UP_TO_DATE'
}

export type BankAccountRecipientField = {
  __typename?: 'BankAccountRecipientField';
  errorMessage?: Maybe<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  regex?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
};

export type BankAccountRecipientRequirements = {
  __typename?: 'BankAccountRecipientRequirements';
  currencyCode: Scalars['String']['output'];
  fields: Array<BankAccountRecipientField>;
  id: Scalars['String']['output'];
  name?: Maybe<Name>;
};

export enum BannerTypeEnum {
  UnsupportedAutomationCreateBanner = 'UNSUPPORTED_AUTOMATION_CREATE_BANNER',
  UnsupportedAutomationUpdateBanner = 'UNSUPPORTED_AUTOMATION_UPDATE_BANNER'
}

export enum BenefitTier {
  Base = 'BASE',
  Good = 'GOOD',
  Statutory = 'STATUTORY',
  Top = 'TOP'
}

export type BenefitsCensusDataReport = {
  __typename?: 'BenefitsCensusDataReport';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  csv?: Maybe<DownloadLink>;
  enrollmentFilterCriteria?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  requester: User;
  status: CensusDataReportState;
};

export enum BenefitsCoverageTypeEnum {
  HealthDental = 'HEALTH_DENTAL',
  HealthInpatient = 'HEALTH_INPATIENT',
  HealthOutpatient = 'HEALTH_OUTPATIENT',
  HealthVision = 'HEALTH_VISION',
  Life = 'LIFE',
  LongTermDisability = 'LONG_TERM_DISABILITY',
  Pension = 'PENSION',
  ShortTermDisability = 'SHORT_TERM_DISABILITY'
}

export type BenefitsDependentEnrollment = {
  __typename?: 'BenefitsDependentEnrollment';
  availableEvents: Array<BenefitsEnrollmentTransitionEventEnum>;
  cancellationReason?: Maybe<BenefitsEnrollmentCancellationReasonEnum>;
  cancelledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  coverageEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  coverageStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  currentPrice?: Maybe<BenefitsEnrollmentPrice>;
  dependent: Dependent;
  enrolledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  enrollment: BenefitsEnrollment;
  enrollmentPrices?: Maybe<BenefitsEnrollmentPriceCollection>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  plan: BenefitsPlan;
  pricePaidProvider?: Maybe<Money>;
  recommendedEmployerContribution: Scalars['Float']['output'];
  state: BenefitsEnrollmentStateEnum;
};


export type BenefitsDependentEnrollmentEnrollmentPricesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type BenefitsDependentEnrollmentCollection = {
  __typename?: 'BenefitsDependentEnrollmentCollection';
  collection: Array<BenefitsDependentEnrollment>;
  metadata: CollectionMetadata;
};

export enum BenefitsDependentsConfigTypeEnumType {
  /** Client is free to allow dependents enrollments */
  Allowed = 'ALLOWED',
  /** Client can't choose to enroll dependents */
  Disallowed = 'DISALLOWED',
  /** Dependents are allowed, and we should not even ask */
  Enforced = 'ENFORCED',
  /** dependentsConfig couldn't be found for the selected plan and country */
  Unknown = 'UNKNOWN'
}

export type BenefitsEnrolledPackage = {
  __typename?: 'BenefitsEnrolledPackage';
  createdAt: Scalars['ISO8601DateTime']['output'];
  enrollments: BenefitsEnrollmentCollection;
  id: Scalars['ID']['output'];
  provisionedEnrollments: BenefitsProvisionedEnrollmentCollection;
  tier: BenefitsTier;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type BenefitsEnrolledPackageEnrollmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrolledPackageProvisionedEnrollmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrolledPackageTierArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  useSalaryCurrencyCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BenefitsEnrolledPackageCollection = {
  __typename?: 'BenefitsEnrolledPackageCollection';
  collection: Array<BenefitsEnrolledPackage>;
  metadata: CollectionMetadata;
};

export type BenefitsEnrollment = BenefitsEnrollmentInterface & {
  __typename?: 'BenefitsEnrollment';
  authorizations?: Maybe<Authorization>;
  availableBenefitPlans: BenefitsPlanCollection;
  availableEvents: Array<BenefitsEnrollmentTransitionEventEnum>;
  cancellationReason?: Maybe<BenefitsEnrollmentCancellationReasonEnum>;
  cancelledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  company: Company;
  coverageEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  coverageStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  currentPrice?: Maybe<BenefitsEnrollmentPrice>;
  dependentEnrollments?: Maybe<BenefitsDependentEnrollmentCollection>;
  dependents: DependentCollection;
  dependentsEmployerContribution: Scalars['Float']['output'];
  dependentsEmployerContributionMaxCount?: Maybe<Scalars['Int']['output']>;
  dependentsRecommendedEmployerContribution: Scalars['Int']['output'];
  detailedHistory?: Maybe<Array<EnrollmentHistoryEntry>>;
  employerContribution: Scalars['Float']['output'];
  engagement: Engagement;
  enrolledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  enrollmentCostContributions?: Maybe<BenefitsEnrollmentCostContributionCollection>;
  enrollmentPrices?: Maybe<BenefitsEnrollmentPriceCollection>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  plan: BenefitsPlan;
  priceInvoicedCompany?: Maybe<Money>;
  pricePaidProvider?: Maybe<Money>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  state: BenefitsEnrollmentStateEnum;
  tier?: Maybe<BenefitsTier>;
  totalPrice?: Maybe<Money>;
  totalPriceInvoicedCompany?: Maybe<Money>;
  totalPriceInvoicedTm?: Maybe<Money>;
  type: Scalars['String']['output'];
};


export type BenefitsEnrollmentAvailableBenefitPlansArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentDependentEnrollmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentDependentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentEnrollmentCostContributionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentEnrollmentPricesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentPlanArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  useSalaryCurrencyCode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BenefitsEnrollmentTierArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  useSalaryCurrencyCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BenefitsEnrollmentBase = BenefitsEnrollmentInterface & {
  __typename?: 'BenefitsEnrollmentBase';
  authorizations?: Maybe<Authorization>;
  availableBenefitPlans: BenefitsPlanCollection;
  cancellationReason?: Maybe<BenefitsEnrollmentCancellationReasonEnum>;
  cancelledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  company: Company;
  coverageEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  coverageStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  currentPrice?: Maybe<BenefitsEnrollmentPrice>;
  dependentEnrollments?: Maybe<BenefitsDependentEnrollmentCollection>;
  dependents: DependentCollection;
  dependentsEmployerContribution: Scalars['Float']['output'];
  dependentsEmployerContributionMaxCount?: Maybe<Scalars['Int']['output']>;
  detailedHistory?: Maybe<Array<EnrollmentHistoryEntry>>;
  employerContribution: Scalars['Float']['output'];
  engagement: Engagement;
  enrolledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  enrollmentCostContributions?: Maybe<BenefitsEnrollmentCostContributionCollection>;
  enrollmentPrices?: Maybe<BenefitsEnrollmentPriceCollection>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  plan: BenefitsPlan;
  priceInvoicedCompany?: Maybe<Money>;
  pricePaidProvider?: Maybe<Money>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  state: BenefitsEnrollmentStateEnum;
  tier?: Maybe<BenefitsTier>;
  totalPrice?: Maybe<Money>;
  totalPriceInvoicedCompany?: Maybe<Money>;
  totalPriceInvoicedTm?: Maybe<Money>;
  type: Scalars['String']['output'];
};


export type BenefitsEnrollmentBaseAvailableBenefitPlansArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentBaseDependentEnrollmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentBaseDependentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentBaseEnrollmentCostContributionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentBaseEnrollmentPricesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentBasePlanArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  useSalaryCurrencyCode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BenefitsEnrollmentBaseTierArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  useSalaryCurrencyCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BenefitsEnrollmentCancellationReasonEnum {
  CustomerRequest = 'CUSTOMER_REQUEST',
  Mistake = 'MISTAKE',
  Moved = 'MOVED',
  OptOut = 'OPT_OUT',
  Reconciliation = 'RECONCILIATION',
  Termination = 'TERMINATION'
}

export type BenefitsEnrollmentCollection = {
  __typename?: 'BenefitsEnrollmentCollection';
  collection: Array<BenefitsEnrollment>;
  metadata: CollectionMetadata;
};

export type BenefitsEnrollmentCostContribution = {
  __typename?: 'BenefitsEnrollmentCostContribution';
  amount?: Maybe<Scalars['BigInt']['output']>;
  amountAsPercentage?: Maybe<Scalars['Float']['output']>;
  contributor: BenefitsEnrollmentCostContributorEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BenefitsEnrollmentCostContributionCollection = {
  __typename?: 'BenefitsEnrollmentCostContributionCollection';
  collection: Array<BenefitsEnrollmentCostContribution>;
  metadata: CollectionMetadata;
};

export type BenefitsEnrollmentCostContributionInput = {
  dependentsEmployerContribution?: InputMaybe<Scalars['Float']['input']>;
  dependentsEmployerContributionMaxCount?: InputMaybe<Scalars['Int']['input']>;
  employerContribution?: InputMaybe<Scalars['Float']['input']>;
  planId: Scalars['ID']['input'];
};

export enum BenefitsEnrollmentCostContributorEnum {
  Company = 'COMPANY',
  Engagement = 'ENGAGEMENT'
}

export type BenefitsEnrollmentCostContributorInput = {
  amount?: InputMaybe<Scalars['BigInt']['input']>;
  amountAsPercentage?: InputMaybe<Scalars['Float']['input']>;
  contributor: BenefitsEnrollmentCostContributorEnum;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BenefitsEnrollmentInterface = {
  availableBenefitPlans: BenefitsPlanCollection;
  cancellationReason?: Maybe<BenefitsEnrollmentCancellationReasonEnum>;
  cancelledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  company: Company;
  coverageEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  coverageStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  currentPrice?: Maybe<BenefitsEnrollmentPrice>;
  dependentEnrollments?: Maybe<BenefitsDependentEnrollmentCollection>;
  dependents: DependentCollection;
  dependentsEmployerContribution: Scalars['Float']['output'];
  dependentsEmployerContributionMaxCount?: Maybe<Scalars['Int']['output']>;
  detailedHistory?: Maybe<Array<EnrollmentHistoryEntry>>;
  employerContribution: Scalars['Float']['output'];
  engagement: Engagement;
  enrolledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  enrollmentCostContributions?: Maybe<BenefitsEnrollmentCostContributionCollection>;
  enrollmentPrices?: Maybe<BenefitsEnrollmentPriceCollection>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  plan: BenefitsPlan;
  priceInvoicedCompany?: Maybe<Money>;
  pricePaidProvider?: Maybe<Money>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  state: BenefitsEnrollmentStateEnum;
  tier?: Maybe<BenefitsTier>;
  totalPrice?: Maybe<Money>;
  totalPriceInvoicedCompany?: Maybe<Money>;
  totalPriceInvoicedTm?: Maybe<Money>;
  type: Scalars['String']['output'];
};


export type BenefitsEnrollmentInterfaceAvailableBenefitPlansArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentInterfaceDependentEnrollmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentInterfaceDependentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentInterfaceEnrollmentCostContributionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentInterfaceEnrollmentPricesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsEnrollmentInterfacePlanArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  useSalaryCurrencyCode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BenefitsEnrollmentInterfaceTierArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  useSalaryCurrencyCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BenefitsEnrollmentPensionInput = {
  costContribution?: InputMaybe<BenefitsEnrollmentCostContributorInput>;
  planId: Scalars['ID']['input'];
};

export type BenefitsEnrollmentPrice = {
  __typename?: 'BenefitsEnrollmentPrice';
  effectiveDate: Scalars['ISO8601Date']['output'];
  employerContribution: Money;
  id: Scalars['ID']['output'];
  priceInvoicedCompany: Money;
  pricePaidProvider: Money;
  tmContribution: Money;
  tmInvoicedContribution: Money;
};

export type BenefitsEnrollmentPriceCollection = {
  __typename?: 'BenefitsEnrollmentPriceCollection';
  collection: Array<BenefitsEnrollmentPrice>;
  metadata: CollectionMetadata;
};

export type BenefitsEnrollmentPriceInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  employerContributionSubunit?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  pricePaidProvider?: InputMaybe<Scalars['Float']['input']>;
  pricePaidProviderCurrencyCode?: InputMaybe<Scalars['String']['input']>;
};

export enum BenefitsEnrollmentStateEnum {
  Applied = 'APPLIED',
  AwaitingAcceptance = 'AWAITING_ACCEPTANCE',
  AwaitingToBeFinished = 'AWAITING_TO_BE_FINISHED',
  Cancelled = 'CANCELLED',
  Denied = 'DENIED',
  Enrolled = 'ENROLLED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS',
  ModifiedEnrollment = 'MODIFIED_ENROLLMENT',
  OptedOut = 'OPTED_OUT',
  Provisioned = 'PROVISIONED',
  Requested = 'REQUESTED'
}

export type BenefitsEnrollmentTemplateInput = {
  enrollmentTemplateId?: InputMaybe<Scalars['ID']['input']>;
  pensions?: InputMaybe<Array<BenefitsEnrollmentTemplatePensionInput>>;
  preferredCostSplit?: InputMaybe<Array<BenefitsEnrollmentTemplatePreferredCostSplitInput>>;
  supplementaryBenefitsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tierId?: InputMaybe<Scalars['ID']['input']>;
};

export type BenefitsEnrollmentTemplatePensionCostContributionType = {
  __typename?: 'BenefitsEnrollmentTemplatePensionCostContributionType';
  amountAsPercentage: Scalars['Float']['output'];
  contributor: BenefitsEnrollmentCostContributorEnum;
};

export type BenefitsEnrollmentTemplatePensionInput = {
  costContribution?: InputMaybe<BenefitsEnrollmentCostContributorInput>;
  planId: Scalars['ID']['input'];
};

export type BenefitsEnrollmentTemplatePensionType = {
  __typename?: 'BenefitsEnrollmentTemplatePensionType';
  costContribution?: Maybe<BenefitsEnrollmentTemplatePensionCostContributionType>;
  plan: BenefitsPlan;
};

export type BenefitsEnrollmentTemplatePreferredCostSplitInput = {
  dependentsEmployerContribution: Scalars['Float']['input'];
  dependentsEmployerContributionMaxCount: Scalars['Int']['input'];
  employerContribution: Scalars['Float']['input'];
  planId: Scalars['ID']['input'];
};

export type BenefitsEnrollmentTemplateType = {
  __typename?: 'BenefitsEnrollmentTemplateType';
  countryCode?: Maybe<Scalars['String']['output']>;
  employmentTemplate: EmploymentTemplate;
  id: Scalars['ID']['output'];
  pensions?: Maybe<Array<BenefitsEnrollmentTemplatePensionType>>;
  preferredCostSplit?: Maybe<Array<CostSplitSetting>>;
  supplementaryBenefits?: Maybe<Array<BenefitsPlan>>;
  tier?: Maybe<BenefitsTier>;
};

export enum BenefitsEnrollmentTransitionEventEnum {
  Apply = 'APPLY',
  ApplyWithAcceptance = 'APPLY_WITH_ACCEPTANCE',
  Cancel = 'CANCEL',
  DenyBenefit = 'DENY_BENEFIT',
  Enroll = 'ENROLL',
  Finish = 'FINISH',
  InitiateProcess = 'INITIATE_PROCESS',
  OptIn = 'OPT_IN',
  OptOut = 'OPT_OUT'
}

export type BenefitsEnrollmentsChangesReport = {
  __typename?: 'BenefitsEnrollmentsChangesReport';
  cancellationsCount: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated Use csv_enrollments or csv_cancellations */
  csv: DownloadLink;
  csvCancellations?: Maybe<DownloadLink>;
  csvEnrollments?: Maybe<DownloadLink>;
  enrollmentsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  provider: BenefitsProvider;
};

export type BenefitsEnrollmentsChangesReportCollection = {
  __typename?: 'BenefitsEnrollmentsChangesReportCollection';
  collection: Array<BenefitsEnrollmentsChangesReport>;
  metadata: CollectionMetadata;
};

export type BenefitsOffer = {
  __typename?: 'BenefitsOffer';
  addons: BenefitsPlanCollection;
  availableBenefitPlans: BenefitsPlanCollection;
  tiers: BenefitsTierCollection;
};


export type BenefitsOfferAddonsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsOfferAvailableBenefitPlansArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsOfferTiersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type BenefitsPlan = {
  __typename?: 'BenefitsPlan';
  category: Scalars['String']['output'];
  copy?: Maybe<Scalars['String']['output']>;
  costSplitAllowed: Scalars['Boolean']['output'];
  countries: Array<Scalars['String']['output']>;
  coverageTypes: Array<BenefitsCoverageTypeEnum>;
  currencies: Array<Currency>;
  dependentsConfig: BenefitsDependentsConfigTypeEnumType;
  descriptiveName: Scalars['String']['output'];
  externalLink?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Array<Money>>;
  guideUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  maxDependents?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  planContributionSetting?: Maybe<BenefitsPlanContributionSettingType>;
  priceEstimate?: Maybe<BenefitsPlanPrice>;
  prices: Array<BenefitsPlanPrice>;
  provider: BenefitsProvider;
};


export type BenefitsPlanFeeArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  useSalaryCurrencyCode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BenefitsPlanPriceEstimateArgs = {
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  engagementType?: InputMaybe<Scalars['String']['input']>;
};

export type BenefitsPlanCollection = {
  __typename?: 'BenefitsPlanCollection';
  collection: Array<BenefitsPlan>;
  metadata: CollectionMetadata;
};

export type BenefitsPlanContributionSettingType = {
  __typename?: 'BenefitsPlanContributionSettingType';
  amount?: Maybe<Scalars['Int']['output']>;
  employerCanCustomize: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maximumAmountSubunit?: Maybe<Scalars['Int']['output']>;
  maximumPercentage?: Maybe<Scalars['Float']['output']>;
  minimumAmountSubunit?: Maybe<Scalars['Int']['output']>;
  minimumPercentage?: Maybe<Scalars['Float']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type BenefitsPlanPrice = {
  __typename?: 'BenefitsPlanPrice';
  currencies: Array<Money>;
  endAge?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  startAge?: Maybe<Scalars['Int']['output']>;
};

export type BenefitsProvider = {
  __typename?: 'BenefitsProvider';
  automated?: Maybe<Scalars['Boolean']['output']>;
  descriptiveName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BenefitsProviderCollection = {
  __typename?: 'BenefitsProviderCollection';
  collection: Array<BenefitsProvider>;
  metadata: CollectionMetadata;
};

export type BenefitsProvisionedEnrollment = BenefitsEnrollmentInterface & {
  __typename?: 'BenefitsProvisionedEnrollment';
  authorizations?: Maybe<Authorization>;
  availableBenefitPlans: BenefitsPlanCollection;
  availableEvents: Array<BenefitsEnrollmentTransitionEventEnum>;
  cancellationReason?: Maybe<BenefitsEnrollmentCancellationReasonEnum>;
  cancelledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  company: Company;
  coverageEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  coverageStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  currentPrice?: Maybe<BenefitsEnrollmentPrice>;
  dependentEnrollments?: Maybe<BenefitsDependentEnrollmentCollection>;
  dependents: DependentCollection;
  dependentsEmployerContribution: Scalars['Float']['output'];
  dependentsEmployerContributionMaxCount?: Maybe<Scalars['Int']['output']>;
  detailedHistory?: Maybe<Array<EnrollmentHistoryEntry>>;
  employerContribution: Scalars['Float']['output'];
  engagement: Engagement;
  enrolledAt?: Maybe<Scalars['ISO8601Date']['output']>;
  enrollmentCostContributions?: Maybe<BenefitsEnrollmentCostContributionCollection>;
  enrollmentPrices?: Maybe<BenefitsEnrollmentPriceCollection>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  plan: BenefitsPlan;
  priceInvoicedCompany?: Maybe<Money>;
  pricePaidProvider?: Maybe<Money>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  state: BenefitsEnrollmentStateEnum;
  tier?: Maybe<BenefitsTier>;
  totalPrice?: Maybe<Money>;
  totalPriceInvoicedCompany?: Maybe<Money>;
  totalPriceInvoicedTm?: Maybe<Money>;
  type: Scalars['String']['output'];
};


export type BenefitsProvisionedEnrollmentAvailableBenefitPlansArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsProvisionedEnrollmentDependentEnrollmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsProvisionedEnrollmentDependentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsProvisionedEnrollmentEnrollmentCostContributionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsProvisionedEnrollmentEnrollmentPricesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsProvisionedEnrollmentPlanArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  useSalaryCurrencyCode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BenefitsProvisionedEnrollmentTierArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  useSalaryCurrencyCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BenefitsProvisionedEnrollmentCollection = {
  __typename?: 'BenefitsProvisionedEnrollmentCollection';
  collection: Array<BenefitsProvisionedEnrollment>;
  metadata: CollectionMetadata;
};

export enum BenefitsProvisionedEnrollmentTransitionEventEnum {
  Apply = 'APPLY',
  ApplyWithAcceptance = 'APPLY_WITH_ACCEPTANCE',
  OptIn = 'OPT_IN',
  OptOut = 'OPT_OUT'
}

export type BenefitsReconciliationRun = {
  __typename?: 'BenefitsReconciliationRun';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  input: DownloadLink;
  output?: Maybe<DownloadLink>;
  provider?: Maybe<BenefitsProvider>;
  requester: User;
  status: BenefitsReconciliationRunStates;
};

export type BenefitsReconciliationRunCollection = {
  __typename?: 'BenefitsReconciliationRunCollection';
  collection: Array<BenefitsReconciliationRun>;
  metadata: CollectionMetadata;
};

export enum BenefitsReconciliationRunStates {
  Done = 'DONE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Requested = 'REQUESTED'
}

export type BenefitsTemplateOffer = {
  __typename?: 'BenefitsTemplateOffer';
  addons: BenefitsPlanCollection;
  tiers: BenefitsTierCollection;
};


export type BenefitsTemplateOfferAddonsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type BenefitsTemplateOfferTiersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type BenefitsTier = {
  __typename?: 'BenefitsTier';
  fee?: Maybe<Array<Money>>;
  id: Scalars['ID']['output'];
  includedPlans: Array<BenefitsPlan>;
  name: Scalars['String']['output'];
};


export type BenefitsTierFeeArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  useSalaryCurrencyCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BenefitsTierCollection = {
  __typename?: 'BenefitsTierCollection';
  collection: Array<BenefitsTier>;
  metadata: CollectionMetadata;
};

export enum BestInClassAttribute {
  PaidHolidayDays = 'PAID_HOLIDAY_DAYS',
  ProbationPeriod = 'PROBATION_PERIOD'
}

export type BestInClassInsightType = {
  __typename?: 'BestInClassInsightType';
  attribute: BestInClassAttribute;
  valueForMaxScore?: Maybe<Scalars['String']['output']>;
};

export type BestInClassScore = {
  __typename?: 'BestInClassScore';
  insights: Array<BestInClassInsightType>;
  score: Scalars['Int']['output'];
};

export type BillingEmailAddress = {
  __typename?: 'BillingEmailAddress';
  authorizations?: Maybe<Authorization>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum BillingFrequencyEnum {
  Monthly = 'monthly',
  OneTime = 'one_time',
  Yearly = 'yearly'
}

export enum BirthSex {
  Female = 'FEMALE',
  Male = 'MALE',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

/** Autogenerated input type of BlockAutomatedPayments */
export type BlockAutomatedPaymentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

/** Autogenerated return type of BlockAutomatedPayments. */
export type BlockAutomatedPaymentsPayload = {
  __typename?: 'BlockAutomatedPaymentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

export type Bonus = {
  __typename?: 'Bonus';
  amountAsPercentage?: Maybe<Scalars['String']['output']>;
  amountType: Scalars['String']['output'];
  customLabel?: Maybe<Scalars['String']['output']>;
  fixedAmount?: Maybe<FixedAmount>;
  guaranteed?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  includedInGrossSalary?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  paymentFrequency: PaymentFrequencyEnum;
  prorated?: Maybe<Scalars['Boolean']['output']>;
  selectedMonths: Array<MonthsEnum>;
  statutory?: Maybe<Scalars['Boolean']['output']>;
  systemGenerated?: Maybe<Scalars['Boolean']['output']>;
};

export type BonusInput = {
  ID?: InputMaybe<Scalars['ID']['input']>;
  amountAsPercentage?: InputMaybe<Scalars['String']['input']>;
  amountType: Scalars['String']['input'];
  customLabel?: InputMaybe<Scalars['String']['input']>;
  fixedAmount?: InputMaybe<FixedAmountInput>;
  guaranteed?: InputMaybe<Scalars['Boolean']['input']>;
  includedInGrossSalary?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  paymentFrequency: PaymentFrequencyEnum;
  prorated?: InputMaybe<Scalars['Boolean']['input']>;
  selectedMonths?: InputMaybe<Array<MonthsEnum>>;
  statutory?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of BookDemo */
export type BookDemoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  marketingConsent: Scalars['Boolean']['input'];
};

/** Autogenerated return type of BookDemo. */
export type BookDemoPayload = {
  __typename?: 'BookDemoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type BulkAddToInProgressPaymentInputType = {
  amountAsPercentage?: InputMaybe<Scalars['Float']['input']>;
  amountData?: InputMaybe<AmountData>;
  details?: InputMaybe<Scalars['String']['input']>;
  numRecurringPayments?: InputMaybe<Scalars['Int']['input']>;
  payType: Scalars['ID']['input'];
  paymentFrequency: Scalars['String']['input'];
};

export type BulkAddToInProgressTerminationInputType = {
  additionalTerminationPayments?: InputMaybe<Array<BulkAddToInProgressPaymentInputType>>;
  communicatedWithEmployee: Scalars['Boolean']['input'];
  documents?: InputMaybe<Array<DocumentInput>>;
  employment: Scalars['ID']['input'];
  intendedDaysOff?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offboardingCategory: Scalars['ID']['input'];
  onLeave: Scalars['Boolean']['input'];
  proposedDate: Scalars['String']['input'];
  ptoAccurate: Scalars['Boolean']['input'];
  ptoInaccurateNote?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type BulkApprovalSummary = {
  __typename?: 'BulkApprovalSummary';
  timestamp?: Maybe<Scalars['ISO8601DateTime']['output']>;
  totalAmounts?: Maybe<MoneyCollection>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type BulkApprovalSummaryTotalAmountsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of BulkCreate */
export type BulkCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  /** List of team members to offboard, empty list will offboard all engaged team members */
  teamMemberIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated input type of BulkCreatePaySupplements */
export type BulkCreatePaySupplementsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endingMonth?: InputMaybe<Scalars['Int']['input']>;
  endingYear?: InputMaybe<Scalars['Int']['input']>;
  engagementId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paySupplementId?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaySupplementAvailablePaymentTypeEnum>;
  startingMonth?: InputMaybe<Scalars['Int']['input']>;
  startingYear?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<PaySupplementStateEnumType>;
};

/** Autogenerated return type of BulkCreatePaySupplements. */
export type BulkCreatePaySupplementsPayload = {
  __typename?: 'BulkCreatePaySupplementsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of BulkCreate. */
export type BulkCreatePayload = {
  __typename?: 'BulkCreatePayload';
  bulkOffboarding?: Maybe<BulkOffboarding>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type BulkEngagementChange = {
  __typename?: 'BulkEngagementChange';
  authorizations?: Maybe<Authorization>;
  canEdit: Scalars['Boolean']['output'];
  canSubmit: Scalars['Boolean']['output'];
  cancellationReason?: Maybe<Scalars['String']['output']>;
  company: Company;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator: User;
  effectiveFrom: Scalars['ISO8601Date']['output'];
  entries?: Maybe<BulkEngagementChangeEntryCollection>;
  id: Scalars['ID']['output'];
  serializedErrors: Array<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  status: Scalars['String']['output'];
  strongId: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


export type BulkEngagementChangeEntriesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkEngagementChangeCollection = {
  __typename?: 'BulkEngagementChangeCollection';
  collection: Array<BulkEngagementChange>;
  metadata: CollectionMetadata;
};

export type BulkEngagementChangeEntry = {
  __typename?: 'BulkEngagementChangeEntry';
  applicableFrom: Scalars['ISO8601Date']['output'];
  authorizations?: Maybe<Authorization>;
  bulkEngagementChange: BulkEngagementChange;
  effectiveFrom: Scalars['ISO8601Date']['output'];
  engagement: Engagement;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  payrollChange: PayrollChange;
  retroactivePayment?: Maybe<Scalars['Float']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  salaryCurrencyCode: Scalars['String']['output'];
  serializedErrors: Array<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  status: Scalars['String']['output'];
  strongId: Scalars['String']['output'];
};

export type BulkEngagementChangeEntryCollection = {
  __typename?: 'BulkEngagementChangeEntryCollection';
  collection: Array<BulkEngagementChangeEntry>;
  metadata: CollectionMetadata;
};

export type BulkEngagementChangeEntryInput = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  retroactivePayment?: InputMaybe<Scalars['Float']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
};

export type BulkEngagementChangeError = {
  __typename?: 'BulkEngagementChangeError';
  field: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum BulkEngagementChangeSortByEnum {
  EffectiveFrom = 'effective_from',
  Status = 'status'
}

export type BulkImport = {
  __typename?: 'BulkImport';
  authorizations?: Maybe<Authorization>;
  backgroundProcess: BackgroundProcessParent;
  id: Scalars['ID']['output'];
  rows: BulkImportRowCollection;
};


export type BulkImportRowsArgs = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  errored?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  succeeded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkImportRow = {
  __typename?: 'BulkImportRow';
  backgroundProcess: BackgroundProcessChild;
  number: Scalars['Int']['output'];
};

export type BulkImportRowCollection = {
  __typename?: 'BulkImportRowCollection';
  collection: Array<BulkImportRow>;
  metadata: CollectionMetadata;
};

export enum BulkImportTypeEnum {
  Payroll = 'PAYROLL',
  SendInvoices = 'SEND_INVOICES'
}

export type BulkOffboarding = {
  __typename?: 'BulkOffboarding';
  company: Company;
  id: Scalars['ID']['output'];
  includesAllEngagedTeamMembers: Scalars['Boolean']['output'];
  initiatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state: BulkOffboardingState;
  terminations: Array<Termination>;
};


export type BulkOffboardingTerminationsArgs = {
  states?: InputMaybe<Array<TerminationState>>;
};

export type BulkOffboardingCollection = {
  __typename?: 'BulkOffboardingCollection';
  collection: Array<BulkOffboarding>;
  metadata: CollectionMetadata;
};

export enum BulkOffboardingState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS'
}

export type BulkOnboarding = {
  __typename?: 'BulkOnboarding';
  /** The total number of items that were processed. */
  countTotal?: Maybe<Scalars['Int']['output']>;
  engagementType: BulkOnboardingEngagementType;
  id: Scalars['ID']['output'];
  initiatedOn: Scalars['ISO8601DateTime']['output'];
  /** The processing mode used. */
  mode: BulkOnboardingModeEnum;
  performer: User;
  report: BulkOnboardingReport;
  state: BulkOnboardingStateEnum;
  strongId: Scalars['String']['output'];
};

export type BulkOnboardingCollection = {
  __typename?: 'BulkOnboardingCollection';
  collection: Array<BulkOnboarding>;
  metadata: CollectionMetadata;
};

export enum BulkOnboardingEngagementType {
  Contract = 'CONTRACT',
  Employment = 'EMPLOYMENT',
  Payroll = 'PAYROLL',
  Peo = 'PEO'
}

export enum BulkOnboardingModeEnum {
  Create = 'CREATE',
  Update = 'UPDATE'
}

export type BulkOnboardingReport = {
  __typename?: 'BulkOnboardingReport';
  completed?: Maybe<Array<BulkOnboardingReportItem>>;
  /** List of execution errors that prevented the whole import from running. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  failed?: Maybe<Array<BulkOnboardingReportItem>>;
};

export type BulkOnboardingReportItem = {
  __typename?: 'BulkOnboardingReportItem';
  countryCode?: Maybe<CountryIsoCode>;
  email?: Maybe<Scalars['String']['output']>;
  /** The list of errors that occurred during the import of this team member. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  strongId?: Maybe<Scalars['String']['output']>;
};

export enum BulkOnboardingStateEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

/** Autogenerated input type of BulkUpdate */
export type BulkUpdateInput = {
  bulkOffboardingId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  generateTosa?: InputMaybe<Scalars['Boolean']['input']>;
  notifyCustomerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BulkUpdate. */
export type BulkUpdatePayload = {
  __typename?: 'BulkUpdatePayload';
  additionalTerminationPayments: Array<AdditionalTerminationPayment>;
  bulkOffboarding: BulkOffboarding;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  terminations: Array<Termination>;
};

/** Autogenerated input type of BulkUpdateTerminations */
export type BulkUpdateTerminationsInput = {
  bulkOffboardingId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communicatedWithEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  copyPaymentsFromTerminationId?: InputMaybe<Scalars['ID']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  intendedDaysOff?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notifyCustomerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  onLeave?: InputMaybe<Scalars['Boolean']['input']>;
  primaryCategoryId?: InputMaybe<Scalars['ID']['input']>;
  proposedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  ptoAccurate?: InputMaybe<Scalars['Boolean']['input']>;
  ptoInaccurateNote?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  secondaryCategoryId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<TerminationState>;
};

/** Autogenerated return type of BulkUpdateTerminations. */
export type BulkUpdateTerminationsPayload = {
  __typename?: 'BulkUpdateTerminationsPayload';
  bulkOffboarding: BulkOffboarding;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of BulkUpdateTm */
export type BulkUpdateTmInput = {
  bulkOffboardingId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  teamMemberIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of BulkUpdateTm. */
export type BulkUpdateTmPayload = {
  __typename?: 'BulkUpdateTmPayload';
  bulkOffboarding: BulkOffboarding;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of BypassKybVerification */
export type BypassKybVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of BypassKybVerification. */
export type BypassKybVerificationPayload = {
  __typename?: 'BypassKybVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  kybVerification?: Maybe<KybVerification>;
};

export enum CcFailureTypeEnum {
  IntegrationFailedSync = 'INTEGRATION_FAILED_SYNC',
  IntegrationMaxAttempts = 'INTEGRATION_MAX_ATTEMPTS',
  IntegrationPartialSync = 'INTEGRATION_PARTIAL_SYNC',
  IntegrationRequestFailed = 'INTEGRATION_REQUEST_FAILED'
}

export enum CcReportCategoryGroupEnum {
  CountryInsights = 'COUNTRY_INSIGHTS',
  NeedsAttention = 'NEEDS_ATTENTION',
  Statutory = 'STATUTORY'
}

export enum CcReportCategoryKindEnum {
  LocalEmploymentRegulations = 'LOCAL_EMPLOYMENT_REGULATIONS',
  MinimumWage = 'MINIMUM_WAGE',
  PaidTimeOff = 'PAID_TIME_OFF',
  ParentalLeave = 'PARENTAL_LEAVE',
  PensionFund = 'PENSION_FUND',
  SickLeave = 'SICK_LEAVE',
  StateHealthInsurance = 'STATE_HEALTH_INSURANCE'
}

export enum CcReportCategoryStateEnum {
  Failure = 'FAILURE',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

export type CcRuleChecked = {
  __typename?: 'CCRuleChecked';
  countryCode: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hrisData?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  regulationRequirement?: Maybe<Scalars['String']['output']>;
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  subdivisionName?: Maybe<Scalars['String']['output']>;
  tmName?: Maybe<Scalars['String']['output']>;
};

export type CcRuleCheckedCollection = {
  __typename?: 'CCRuleCheckedCollection';
  collection: Array<CcRuleChecked>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of CalculateDepositRecord */
export type CalculateDepositRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  engagementId: Scalars['ID']['input'];
};

/** Autogenerated return type of CalculateDepositRecord. */
export type CalculateDepositRecordPayload = {
  __typename?: 'CalculateDepositRecordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  depositRecord: PayrollDepositRecord;
  errors: Array<Scalars['String']['output']>;
};

export enum CalculationDependencyTypeEnum {
  ExpatAndLocal = 'EXPAT_AND_LOCAL',
  FixedFee = 'FIXED_FEE',
  General = 'GENERAL',
  SalaryPercentage = 'SALARY_PERCENTAGE'
}

export type CalendarDuration = {
  __typename?: 'CalendarDuration';
  unit: CalendarDurationType;
  /** This will be null when unit is INFINITE */
  value?: Maybe<Scalars['Int']['output']>;
};

export type CalendarDurationInput = {
  unit: CalendarDurationType;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CalendarDurationRange = {
  __typename?: 'CalendarDurationRange';
  max?: Maybe<CalendarDuration>;
  min?: Maybe<CalendarDuration>;
};

export enum CalendarDurationType {
  Days = 'DAYS',
  Infinite = 'INFINITE',
  Months = 'MONTHS',
  Weeks = 'WEEKS',
  Years = 'YEARS'
}

/** Autogenerated input type of CancelBulkEngagementChangeEntry */
export type CancelBulkEngagementChangeEntryInput = {
  cancellationReason: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelBulkEngagementChangeEntry. */
export type CancelBulkEngagementChangeEntryPayload = {
  __typename?: 'CancelBulkEngagementChangeEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<BulkEngagementChangeEntry>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CancelBulkEngagementChange */
export type CancelBulkEngagementChangeInput = {
  bulkEngagementChangeId: Scalars['ID']['input'];
  cancellationReason: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CancelBulkEngagementChange. */
export type CancelBulkEngagementChangePayload = {
  __typename?: 'CancelBulkEngagementChangePayload';
  bulkEngagementChange?: Maybe<BulkEngagementChange>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  partiallyFailed?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of CancelEngagementChange */
export type CancelEngagementChangeInput = {
  cancellationReason: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementChangeId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelEngagementChange. */
export type CancelEngagementChangePayload = {
  __typename?: 'CancelEngagementChangePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagementChange?: Maybe<EngagementChange>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CancelOysterSafe */
export type CancelOysterSafeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  oysterSafeId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelOysterSafe. */
export type CancelOysterSafePayload = {
  __typename?: 'CancelOysterSafePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  oysterSafe?: Maybe<ContractOysterSafe>;
};

/** Autogenerated input type of CancelVariableCompensation */
export type CancelVariableCompensationInput = {
  changeReason: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * A date representing a month after which this change will be effective.
   *
   * Only required if the engagement is engaged.
   */
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  variableCompensationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelVariableCompensation. */
export type CancelVariableCompensationPayload = {
  __typename?: 'CancelVariableCompensationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export enum CarryoverAmountLimitationPolicyEnum {
  CountryDefault = 'COUNTRY_DEFAULT',
  MaxCarryoverDays = 'MAX_CARRYOVER_DAYS',
  MaxDaysByCoefficientOfPaidHolidayDays = 'MAX_DAYS_BY_COEFFICIENT_OF_PAID_HOLIDAY_DAYS',
  MinDaysToUse = 'MIN_DAYS_TO_USE',
  Unlimited = 'UNLIMITED'
}

export enum CarryoverExpirationPeriodPolicyEnum {
  CountryDefault = 'COUNTRY_DEFAULT',
  Decrease = 'DECREASE',
  ExpirationEnabled = 'EXPIRATION_ENABLED',
  Extend = 'EXTEND',
  Unlimited = 'UNLIMITED'
}

export type CartaEngagementId = {
  cartaId: Scalars['ID']['input'];
  strongId: Scalars['ID']['input'];
};

export type Category = {
  __typename?: 'Category';
  items: Array<Item>;
  name: PayrollComponentCategoryEnum;
  title: Scalars['String']['output'];
};

export enum CensusDataReportState {
  Done = 'DONE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Requested = 'REQUESTED'
}

export type Change = {
  __typename?: 'Change';
  field: Scalars['String']['output'];
  fromValue?: Maybe<Scalars['String']['output']>;
  toValue?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ChangeAccount */
export type ChangeAccountInput = {
  avatarSignedId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of ChangeAccount. */
export type ChangeAccountPayload = {
  __typename?: 'ChangeAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of ChangeAccountingPrimaryVendor */
export type ChangeAccountingPrimaryVendorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Oyster company identifier (only company admins or staff) */
  companyId: Scalars['ID']['input'];
  /** Vendor object reference (Accounting::VendorType.id). If null, will unset all primary. */
  vendorId: Scalars['ID']['input'];
};

/** Autogenerated return type of ChangeAccountingPrimaryVendor. */
export type ChangeAccountingPrimaryVendorPayload = {
  __typename?: 'ChangeAccountingPrimaryVendorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  vendor?: Maybe<AccountingVendorType>;
};

/** Autogenerated input type of ChangeAddress */
export type ChangeAddressInput = {
  addressKind: Scalars['String']['input'];
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  addressSubjectId: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ChangeAddress. */
export type ChangeAddressPayload = {
  __typename?: 'ChangeAddressPayload';
  addressSubject: AddressSubject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ChangeCompany */
export type ChangeCompanyInput = {
  approverId?: InputMaybe<Scalars['ID']['input']>;
  avatarSignedId?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<AddressArguments>;
  businessControllers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Specify which countries a company sells in for VAT purposes. */
  countrySales?: InputMaybe<CountrySalesInput>;
  dummy?: InputMaybe<Scalars['Boolean']['input']>;
  legallyRegisteredName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingFirstHireTimescale?: InputMaybe<Array<CompanyFirstHireTimescale>>;
  onboardingNumberOfHiresPlanned?: InputMaybe<CompanyPlannedHires>;
  onboardingPlannedCountriesToHireFrom?: InputMaybe<Array<Scalars['String']['input']>>;
  onboardingPurpose?: InputMaybe<Array<CompanyPurpose>>;
  paymentCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  publicUrl?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<CompanySize>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  timeOffManagementTool?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ChangeCompany. */
export type ChangeCompanyPayload = {
  __typename?: 'ChangeCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ChangeCustomerBankAccountSigner */
export type ChangeCustomerBankAccountSignerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerBankAccountId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  userNotSigner: Scalars['Boolean']['input'];
};

/** Autogenerated return type of ChangeCustomerBankAccountSigner. */
export type ChangeCustomerBankAccountSignerPayload = {
  __typename?: 'ChangeCustomerBankAccountSignerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerBankAccount: B2BPaymentMethod;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ChangeEmail */
export type ChangeEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  skipReconfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of ChangeEmail. */
export type ChangeEmailPayload = {
  __typename?: 'ChangeEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  newEmail?: Maybe<Scalars['String']['output']>;
  oldEmail?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of ChangeEquityPlan */
export type ChangeEquityPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  enroll: Scalars['Boolean']['input'];
  equityPlan?: InputMaybe<CompanyEquityPlanEnumType>;
};

/** Autogenerated return type of ChangeEquityPlan. */
export type ChangeEquityPlanPayload = {
  __typename?: 'ChangeEquityPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ChangeOysterAdminProfile */
export type ChangeOysterAdminProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of ChangeOysterAdminProfile. */
export type ChangeOysterAdminProfilePayload = {
  __typename?: 'ChangeOysterAdminProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of ChangePackage */
export type ChangePackageInput = {
  cancellationReason?: InputMaybe<BenefitsEnrollmentCancellationReasonEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  enrollmentsToBeCancelled?: InputMaybe<Array<EnrollmentCancellationInput>>;
  newPackageId: Scalars['ID']['input'];
  plansCostContribution?: InputMaybe<Array<BenefitsEnrollmentCostContributionInput>>;
};

/** Autogenerated return type of ChangePackage. */
export type ChangePackagePayload = {
  __typename?: 'ChangePackagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

export type ChangeReason = {
  __typename?: 'ChangeReason';
  changeType: ChangeTypeEnum;
  id?: Maybe<Scalars['ID']['output']>;
  reasonMessage?: Maybe<Scalars['String']['output']>;
  reasonType: ReasonTypeEnum;
};

export type ChangeReasonPayloadInputType = {
  changeType: ChangeTypeEnum;
  reasonMessage?: InputMaybe<Scalars['String']['input']>;
  reasonType: ReasonTypeEnum;
};

/** Autogenerated input type of ChangeState */
export type ChangeStateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  creditNoteId: Scalars['ID']['input'];
  event: InvoicingCreditNoteTransitionEventEnum;
};

/** Autogenerated return type of ChangeState. */
export type ChangeStatePayload = {
  __typename?: 'ChangeStatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditNote?: Maybe<CreditNote>;
  errors: Array<Scalars['String']['output']>;
};

export enum ChangeTypeEnum {
  CompetitionCancelation = 'COMPETITION_CANCELATION',
  CustomerCancelation = 'CUSTOMER_CANCELATION',
  CustomerOnHold = 'CUSTOMER_ON_HOLD',
  HiringProcessCancelation = 'HIRING_PROCESS_CANCELATION',
  HiringProcessOnHold = 'HIRING_PROCESS_ON_HOLD',
  TmCancelation = 'TM_CANCELATION',
  TmOnHold = 'TM_ON_HOLD'
}

/** Autogenerated input type of ChangeUserBan */
export type ChangeUserBanInput = {
  banned: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of ChangeUserBan. */
export type ChangeUserBanPayload = {
  __typename?: 'ChangeUserBanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of ChangeUserPersonalInfo */
export type ChangeUserPersonalInfoInput = {
  citizenships: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  emergencyPhoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  emergencyPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of ChangeUserPersonalInfo. */
export type ChangeUserPersonalInfoPayload = {
  __typename?: 'ChangeUserPersonalInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of ChargeInvoices */
export type ChargeInvoicesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of ChargeInvoices. */
export type ChargeInvoicesPayload = {
  __typename?: 'ChargeInvoicesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type ChargePaymentRequest = {
  __typename?: 'ChargePaymentRequest';
  authorizations?: Maybe<Authorization>;
  canInitiateAutomaticPayment: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  orders: Array<PaymentOrder>;
  ordersState: ChargeState;
  targetAmount: Money;
};


export type ChargePaymentRequestOrdersArgs = {
  states?: InputMaybe<Array<PaymentOrderState>>;
};

export enum ChargeState {
  AutomatedProcessConfirmed = 'AUTOMATED_PROCESS_CONFIRMED',
  AutomatedProcessFailed = 'AUTOMATED_PROCESS_FAILED',
  AutomatedProcessInProgress = 'AUTOMATED_PROCESS_IN_PROGRESS',
  ChargedBack = 'CHARGED_BACK',
  ManualProcessNotPaid = 'MANUAL_PROCESS_NOT_PAID',
  NoPayment = 'NO_PAYMENT',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Pending = 'PENDING',
  Voided = 'VOIDED'
}

export enum ChargeStateTransition {
  FulfillManualChargeProcess = 'FULFILL_MANUAL_CHARGE_PROCESS',
  ReturnToManualProcessAsNotPaid = 'RETURN_TO_MANUAL_PROCESS_AS_NOT_PAID'
}

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  sessionId: Scalars['String']['output'];
};

export type ClaimedPrice = {
  __typename?: 'ClaimedPrice';
  amount: Money;
  authorizations?: Maybe<Authorization>;
  id: Scalars['String']['output'];
  plan: NewPlan;
  planPrice: PlanPrice;
};

export type ClaimedPriceCollection = {
  __typename?: 'ClaimedPriceCollection';
  collection: Array<ClaimedPrice>;
  metadata: CollectionMetadata;
};

export type ClmValidationRequest = {
  __typename?: 'ClmValidationRequest';
  authorizations?: Maybe<Authorization>;
  /** The id of the template in AVVOKA */
  clmTemplateId: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Hiring confidence in this country, can be Low, Medium or High */
  createdById: Scalars['String']['output'];
  dataset: Array<AgreementTemplateVariable>;
  id: Scalars['String']['output'];
  /** Placeholder variables that are required by the agreement type but missing in the AVVOKA template */
  missingKeywords: Array<Scalars['String']['output']>;
  partyEditRightsConfigured: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The names of the placeholder variables used in AVVOKA to interpolate data in the template */
  variableNames: Array<Scalars['String']['output']>;
  /** The options available for the data of each placeholder variable */
  variableOptions: Array<AgreementTemplateVariable>;
};

export type Cobranding = {
  __typename?: 'Cobranding';
  assets: CobrandingAssets;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  theme: CobrandingTheme;
};

export type CobrandingAssets = {
  __typename?: 'CobrandingAssets';
  logoBlackUrl: Scalars['String']['output'];
  logoWhiteUrl: Scalars['String']['output'];
};

export type CobrandingTheme = {
  __typename?: 'CobrandingTheme';
  accentBase: Scalars['String']['output'];
  accentLighten100: Scalars['String']['output'];
  primaryBase: Scalars['String']['output'];
  primaryDarken100: Scalars['String']['output'];
  primaryLighten50: Scalars['String']['output'];
  primaryLighten100: Scalars['String']['output'];
};

export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  currentPage: Scalars['Int']['output'];
  limitValue: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CollectionMetadataPayroll = {
  __typename?: 'CollectionMetadataPayroll';
  totalCount: Scalars['Int']['output'];
};

export type CollectionPayroll = {
  __typename?: 'CollectionPayroll';
  collection?: Maybe<Array<Payroll>>;
  metadata: CollectionMetadataPayroll;
};

export type Company = {
  __typename?: 'Company';
  accountManager?: Maybe<User>;
  activeAddOns?: Maybe<AddOnCollection>;
  activeDiscountActivations: Array<DiscountActivation>;
  activeEmploymentCount: Scalars['Int']['output'];
  activeEmploymentCountryCount: Scalars['Int']['output'];
  activeOrPendingScaleSubscription?: Maybe<ScaleSubscription>;
  activeScaleSubscription?: Maybe<ScaleSubscription>;
  address?: Maybe<Address>;
  adminUser?: Maybe<User>;
  admins: UserCollection;
  agreementsFields: Array<Scalars['String']['output']>;
  approver?: Maybe<User>;
  authorizationRoles?: Maybe<Array<AuthorizationRoleType>>;
  authorizations?: Maybe<Authorization>;
  availableAddOnPlans?: Maybe<NewPlanCollection>;
  availableCreditSum: CreditSum;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  backgroundProcesses?: Maybe<BackgroundProcessParentCollection>;
  beta?: Maybe<Scalars['Boolean']['output']>;
  billingAddress?: Maybe<Address>;
  billingEmailAddresses: Array<BillingEmailAddress>;
  bulkEngagementChanges?: Maybe<BulkEngagementChangeCollection>;
  bulkOnboardings?: Maybe<BulkOnboardingCollection>;
  businessControllers?: Maybe<Array<Scalars['String']['output']>>;
  cartaSyncErrors: Array<EquitySyncError>;
  clients?: Maybe<Array<Company>>;
  cobrandingToApply?: Maybe<Cobranding>;
  companyEquityWithholdingEngagements?: Maybe<EngagementCollection>;
  companyOnboardingFinished: Scalars['Boolean']['output'];
  companyProducts?: Maybe<Array<CompanyProduct>>;
  complianceCheckerIntegration?: Maybe<ComplianceCheckerIntegration>;
  complianceCheckerIntegrationMappings?: Maybe<Array<ComplianceCheckerIntegrationMapping>>;
  contractorAgreementsFields: Array<Scalars['String']['output']>;
  contractorsInvoicesGenerationDay: Scalars['Int']['output'];
  costCenters: Array<CostCenter>;
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Tracks which countries a company sells in for VAT purposes. Null if we have no information. */
  countrySales?: Maybe<CountrySales>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creditControlSpecialist?: Maybe<User>;
  creditNotes?: Maybe<CreditNoteCollection>;
  creditNotesMonthYear?: Maybe<CreditNotesMonthYearCollection>;
  customer: Company;
  customerBankAccount?: Maybe<B2BPaymentMethod>;
  customerSuccessManager?: Maybe<User>;
  customerUsersPendingInvitations: Array<Invitation>;
  dateOfFirstHire?: Maybe<Scalars['ISO8601Date']['output']>;
  deactivatedAddOns?: Maybe<AddOnCollection>;
  deactivatedDirectDebitEnforcement?: Maybe<DeactivatedDirectDebitEnforcement>;
  departments: Array<Department>;
  depositInvoiceRequired: Scalars['Boolean']['output'];
  /** Indicates if the company has an authorized and trusted direct debit payment method */
  directDebitAuthorized: Scalars['Boolean']['output'];
  /** Indicates if the company is in a country that supports direct debit and company not blocked for direct debit */
  directDebitAvailable: Scalars['Boolean']['output'];
  /** Returns direct debit state */
  directDebitConstraint?: Maybe<DirectDebitConstraint>;
  /** Returns possible direct debit currencies for company */
  directDebitCurrencies: Array<CompanyCurrencyEnumType>;
  /** Indicates if the company has an enabled feature of direct_debit_enforced */
  directDebitEnforced: Scalars['Boolean']['output'];
  /** Indicates if the company is in a country that supports direct debit */
  directDebitSupported: Scalars['Boolean']['output'];
  documents: DocumentCollection;
  dummy: Scalars['Boolean']['output'];
  employmentTemplates: Array<EmploymentTemplate>;
  employments: Array<Employment>;
  enabledFeatures: Array<CompanyAvailableFeatures>;
  engagementChangesExist: Scalars['Boolean']['output'];
  engagements?: Maybe<EngagementCollection>;
  engagementsWithCartaGrants: Array<Engagement>;
  engagementsWithEngagementChanges?: Maybe<EngagementCollection>;
  engagementsWithGrants: Array<Engagement>;
  engagementsWithSyncErrors: Array<Engagement>;
  equityCartaIntegration?: Maybe<EquityCartaIntegration>;
  equityCompanyPlan?: Maybe<EquityCompanyPlan>;
  equityCompanyPlans: Array<EquityCompanyPlan>;
  equityCompanyValuation?: Maybe<EquityCompanyValuation>;
  equityCompanyValuations: Array<EquityCompanyValuation>;
  equityPlan?: Maybe<CompanyEquityPlanEnumType>;
  /** Timestamp when the customer admin agreed to Oyster Equity terms */
  equityTermsDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Customer admin who agreed on Oyster Equity terms */
  equityTermsUser?: Maybe<User>;
  expenseReimbursementBalances: Array<ExpenseReimbursementBalance>;
  expenses: ExpenseCollection;
  expiredAddOns?: Maybe<AddOnCollection>;
  fxMarkupAdjustment?: Maybe<FxMarkupAdjustment>;
  grants: AuthorizationRoleTypeCollection;
  hasAnyEngagements: Scalars['Boolean']['output'];
  hasContractorPromotion: Scalars['Boolean']['output'];
  hiringBulkProcessings?: Maybe<HiringBulkProcessingCollection>;
  id: Scalars['String']['output'];
  /** Returns all integration hires for all integrations */
  integrationHires: Array<Hires>;
  /** Returns all integrations for company */
  integrations: Array<Integration>;
  invitations: Array<Invitation>;
  invoice?: Maybe<Invoice>;
  invoices: InvoiceCollection;
  invoicesBulkApprovalSummary: BulkApprovalSummary;
  invoicesMonthYear?: Maybe<InvoicesMonthYearCollection>;
  invoicesSummary: InvoicesTotalAmountSum;
  /** Returns invoice settings for company */
  invoicingSettings?: Maybe<InvoicingCompanySettings>;
  isClient: Scalars['Boolean']['output'];
  isCustomer: Scalars['Boolean']['output'];
  isDirectManagerWithTeamMembers?: Maybe<Scalars['Boolean']['output']>;
  /** Returns kyb verifications for company */
  kybVerifications: Array<KybVerification>;
  latestComplianceCheckerReport?: Maybe<ComplianceCheckerReport>;
  latestNonFinishedComplianceCheckerReport?: Maybe<ComplianceCheckerReport>;
  legallyRegisteredName?: Maybe<Scalars['String']['output']>;
  modeName: CompanyModeNameType;
  name?: Maybe<Scalars['String']['output']>;
  oktaCredential?: Maybe<OktaCredential>;
  onboardingFirstHireTimescale?: Maybe<Array<Scalars['String']['output']>>;
  onboardingNumberOfHiresPlanned?: Maybe<Scalars['String']['output']>;
  onboardingPlannedCountriesToHireFrom?: Maybe<Array<Scalars['String']['output']>>;
  onboardingPurpose?: Maybe<Array<Scalars['String']['output']>>;
  oysterExpensesEnabled: Scalars['Boolean']['output'];
  oysterTemplates?: Maybe<Array<EmploymentTemplate>>;
  pastPayrolls?: Maybe<CollectionPayroll>;
  paySupplements?: Maybe<PaySupplementTypeCollection>;
  paymentCurrencyCode?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<CorePaymentMethod>;
  paymentsGroups?: Maybe<PaymentsGroupCollection>;
  paymentsSettings?: Maybe<PaymentsSettings>;
  payroll?: Maybe<Payroll>;
  payrollEntities: EmployerOfRecordCollection;
  payrollPeriods: Array<PayrollPeriod>;
  pendingAddOns?: Maybe<AddOnCollection>;
  pendingScaleSubscription?: Maybe<ScaleSubscription>;
  planPrices?: Maybe<PlanPriceCollection>;
  pointsOfContact: ExternalPointOfContactCollection;
  pointsOfContactForCustomer: ExternalPointOfContactCollection;
  preferences?: Maybe<CompanyPreferences>;
  primaryContact?: Maybe<User>;
  publicUrl?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  requiredForms: Array<RequiredForm>;
  restricted?: Maybe<Scalars['Boolean']['output']>;
  sageAssistantCountryList: Array<SageAssistantCountryListTypeEnum>;
  selectableTeamMembers: UserCollection;
  signatoryPointOfContact?: Maybe<ExternalPointOfContact>;
  size?: Maybe<CompanySize>;
  slackIntegration?: Maybe<SlackIntegration>;
  staffSalesRepresentative?: Maybe<User>;
  supportCategoryOptionsType: Array<SupportCategoryOptionsTypeEnum>;
  /** Details of a team */
  team?: Maybe<Team>;
  /** List of the company's teams */
  teams?: Maybe<TeamCollection>;
  tier?: Maybe<CompanyTier>;
  timeOffEntitlementCounts: EngagementCollection;
  timeOffIntegrationPlatformName?: Maybe<IntegrationPlatformNameEnum>;
  timeOffManagementTool: Scalars['Boolean']['output'];
  timeOffRequests: TimeOffRequestCollection;
  timeSheets: TimeSheetCollection;
  transactions?: Maybe<Array<Transaction>>;
  unpaidInvoicesAmount: InvoicesTotalAmountSum;
  usersAndInvites: UserGrantsCollection;
  visitedCostCalculator?: Maybe<Scalars['Boolean']['output']>;
};


export type CompanyActiveAddOnsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAdminsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyAvailableAddOnPlansArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyBackgroundProcessesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  processIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<BackgroundProcessParentProcessType>;
};


export type CompanyBillingEmailAddressesArgs = {
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type CompanyBulkEngagementChangesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<BulkEngagementChangeSortByEnum>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type CompanyBulkOnboardingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyCompanyEquityWithholdingEngagementsArgs = {
  equityWithholdingId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyCompanyProductsArgs = {
  companyId: Scalars['ID']['input'];
};


export type CompanyCreditNotesArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  creditNotesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  kinds?: InputMaybe<Array<CreditNoteKind>>;
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<CreditNoteState>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyCreditNotesMonthYearArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyDeactivatedAddOnsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyDocumentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyEngagementsArgs = {
  contractorsBillingTypes?: InputMaybe<Array<ContractBilling>>;
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  engagementType?: InputMaybe<EngagementType>;
  engagementTypes?: InputMaybe<Array<FilterEngagementType>>;
  includesAddress?: InputMaybe<Scalars['Boolean']['input']>;
  onlyEquitySupportedCountries?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
  states?: InputMaybe<Array<EngagementState>>;
};


export type CompanyEngagementsWithEngagementChangesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyEquityCompanyValuationArgs = {
  companyValuationId?: InputMaybe<Scalars['ID']['input']>;
};


export type CompanyExpenseReimbursementBalancesArgs = {
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type CompanyExpensesArgs = {
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type CompanyExpiredAddOnsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyGrantsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyHiringBulkProcessingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyInvoiceArgs = {
  invoiceId: Scalars['ID']['input'];
};


export type CompanyInvoicesArgs = {
  chargeCurrency?: InputMaybe<Scalars['String']['input']>;
  chargeStates?: InputMaybe<Array<ChargeState>>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  createdByUserType?: InputMaybe<Array<CreatedByUserEnum>>;
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceBusinessStates?: InputMaybe<Array<InvoiceBusinessState>>;
  invoiceStates?: InputMaybe<Array<InvoiceState>>;
  notInPaymentsGroup?: InputMaybe<Scalars['Boolean']['input']>;
  onlyKind?: InputMaybe<InvoiceKind>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentPeriodEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentPeriodStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentsGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  payoutStates?: InputMaybe<Array<PayoutViewState>>;
  payrollDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  payrollEntityId?: InputMaybe<Scalars['ID']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subkinds?: InputMaybe<Array<InvoiceSubkind>>;
};


export type CompanyInvoicesBulkApprovalSummaryArgs = {
  chargeCurrency?: InputMaybe<Scalars['String']['input']>;
  chargeStates?: InputMaybe<Array<ChargeState>>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  createdByUserType?: InputMaybe<Array<CreatedByUserEnum>>;
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceBusinessStates?: InputMaybe<Array<InvoiceBusinessState>>;
  invoiceStates?: InputMaybe<Array<InvoiceState>>;
  notInPaymentsGroup?: InputMaybe<Scalars['Boolean']['input']>;
  onlyKind?: InputMaybe<InvoiceKind>;
  paymentPeriodEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentPeriodStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentsGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  payoutStates?: InputMaybe<Array<PayoutViewState>>;
  payrollDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  payrollEntityId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subkinds?: InputMaybe<Array<InvoiceSubkind>>;
};


export type CompanyInvoicesMonthYearArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  kinds?: InputMaybe<Array<InvoiceKind>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  subkinds?: InputMaybe<Array<InvoiceSubkind>>;
};


export type CompanyInvoicesSummaryArgs = {
  chargeStates?: InputMaybe<Array<ChargeState>>;
  queryType: InvoiceSummaryQueryKind;
};


export type CompanyOysterTemplatesArgs = {
  countryCode?: InputMaybe<CountryIsoCode>;
};


export type CompanyPastPayrollsArgs = {
  engagementTypes: Array<PayrollRecordTypeEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyPaySupplementsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  engagementType?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyPaymentsGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  referenceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyPayrollArgs = {
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  engagementTypes?: InputMaybe<Array<PayrollRecordTypeEnum>>;
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type CompanyPayrollEntitiesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortByEnum>;
};


export type CompanyPayrollPeriodsArgs = {
  engagementId: Scalars['ID']['input'];
};


export type CompanyPendingAddOnsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyPlanPricesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyPointsOfContactArgs = {
  areaOfDomain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyPointsOfContactForCustomerArgs = {
  areaOfDomain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanySelectableTeamMembersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type CompanyTeamsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTimeOffEntitlementCountsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  engagementType?: InputMaybe<FilterEngagementType>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTimeOffRequestsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
  statuses?: InputMaybe<Array<TimeOffRequestStateEnumType>>;
  timeOffTypes?: InputMaybe<Array<TimeOffTypeEnum>>;
};


export type CompanyTimeSheetsArgs = {
  combinedStatuses?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  employersOfRecordIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employmentTypes?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
  timeSheetCreation?: InputMaybe<Scalars['String']['input']>;
  timeSheetType?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyUnpaidInvoicesAmountArgs = {
  chargeStates?: InputMaybe<Array<ChargeState>>;
  onlyKind?: InputMaybe<InvoiceKind>;
  queryType?: InvoiceSummaryQueryKind;
  subkinds?: InputMaybe<Array<InvoiceSubkind>>;
};


export type CompanyUsersAndInvitesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyAspect = AspectInterface & {
  __typename?: 'CompanyAspect';
  authorizations?: Maybe<Authorization>;
  company?: Maybe<Company>;
  engagement?: Maybe<Engagement>;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CompanyAspectCollection = {
  __typename?: 'CompanyAspectCollection';
  collection: Array<CompanyAspect>;
  metadata: CollectionMetadata;
};

export enum CompanyAvailableFeatures {
  AccountingAutomaticContractorVendorCreation = 'ACCOUNTING_AUTOMATIC_CONTRACTOR_VENDOR_CREATION',
  AccountingIntegration = 'ACCOUNTING_INTEGRATION',
  AccountingTrackingCategoryMapping = 'ACCOUNTING_TRACKING_CATEGORY_MAPPING',
  DirectDebitEnforced = 'DIRECT_DEBIT_ENFORCED',
  ExpensesIntegration = 'EXPENSES_INTEGRATION',
  ExtendedPaidSickTime = 'EXTENDED_PAID_SICK_TIME'
}

export type CompanyCode = {
  __typename?: 'CompanyCode';
  name: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
  type: CompanyCodeTypeEnum;
};

export enum CompanyCodeTypeEnum {
  OnboardingTemplate = 'ONBOARDING_TEMPLATE'
}

export type CompanyCollection = {
  __typename?: 'CompanyCollection';
  collection: Array<Company>;
  metadata: CollectionMetadata;
};

export enum CompanyCurrencyEnumType {
  Cad = 'CAD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export enum CompanyEquityPlanEnumType {
  Base = 'BASE',
  Premium = 'PREMIUM'
}

export enum CompanyFirstHireTimescale {
  Asap = 'ASAP',
  FewMonths = 'FEW_MONTHS',
  FewWeeks = 'FEW_WEEKS',
  Future = 'FUTURE'
}

export enum CompanyModeNameType {
  /** Direct customer */
  DirectCustomer = 'DIRECT_CUSTOMER',
  /** Reseller */
  Reseller = 'RESELLER',
  /** Reseller end client */
  ResellerEndClient = 'RESELLER_END_CLIENT'
}

/** Autogenerated input type of CompanyOidcSsoEnable */
export type CompanyOidcSsoEnableInput = {
  clientId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientSecret: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  discoveryUrl: Scalars['String']['input'];
};

/** Autogenerated return type of CompanyOidcSsoEnable. */
export type CompanyOidcSsoEnablePayload = {
  __typename?: 'CompanyOidcSsoEnablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  failedToCreateConnection: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CompanyOktaSsoEnable */
export type CompanyOktaSsoEnableInput = {
  clientId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientSecret: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  domain: Scalars['String']['input'];
};

/** Autogenerated return type of CompanyOktaSsoEnable. */
export type CompanyOktaSsoEnablePayload = {
  __typename?: 'CompanyOktaSsoEnablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  failedToCreateConnection: Scalars['Boolean']['output'];
};

export enum CompanyPlannedHires {
  Range_1 = 'RANGE_1',
  Range_2_3 = 'RANGE_2_3',
  Range_4_10 = 'RANGE_4_10',
  Range_10 = 'RANGE_10_'
}

export type CompanyPreferences = {
  __typename?: 'CompanyPreferences';
  addCustomAgreements?: Maybe<Scalars['Boolean']['output']>;
  addionalClausesToEmpyoymentAgreement?: Maybe<Scalars['Boolean']['output']>;
  additionalClauses?: Maybe<Scalars['String']['output']>;
  additionalInfo?: Maybe<Scalars['String']['output']>;
  ccCustomer?: Maybe<Scalars['Boolean']['output']>;
  ccCustomerEmail?: Maybe<Scalars['String']['output']>;
  customTerms?: Maybe<Scalars['String']['output']>;
  editedCcip?: Maybe<Scalars['Boolean']['output']>;
  experienceFeedback?: Maybe<Scalars['String']['output']>;
  holidayDays?: Maybe<Scalars['String']['output']>;
  includePublicHolidays?: Maybe<Scalars['Boolean']['output']>;
  nonCompetePreference?: Maybe<Scalars['Boolean']['output']>;
  noticePeriodDays?: Maybe<Scalars['String']['output']>;
  ownAbsenceLoggingPlatform?: Maybe<Scalars['Boolean']['output']>;
  ownCcipDocument?: Maybe<Scalars['Boolean']['output']>;
  ownEaaSDocument?: Maybe<Scalars['Boolean']['output']>;
  ownExpensePlatform?: Maybe<Scalars['Boolean']['output']>;
  probationPeriodDays?: Maybe<Scalars['String']['output']>;
  signer?: Maybe<Scalars['String']['output']>;
  standardOfficeStripend?: Maybe<Scalars['String']['output']>;
};

export type CompanyProduct = {
  __typename?: 'CompanyProduct';
  billingCycle: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  perUnit: Money;
  perUnitTotal: Money;
  subscriptionCount: Scalars['Int']['output'];
};

export enum CompanyPurpose {
  AccessSalaryInsights = 'ACCESS_SALARY_INSIGHTS',
  Exploring = 'EXPLORING',
  HireManagePayContractors = 'HIRE_MANAGE_PAY_CONTRACTORS',
  HireManagePayFullTimeTeamMembers = 'HIRE_MANAGE_PAY_FULL_TIME_TEAM_MEMBERS',
  MoveExistingContractorsToFullTime = 'MOVE_EXISTING_CONTRACTORS_TO_FULL_TIME'
}

/** Autogenerated input type of CompanySamlSsoEnable */
export type CompanySamlSsoEnableInput = {
  certificateSignedId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  signInUrl: Scalars['String']['input'];
};

/** Autogenerated return type of CompanySamlSsoEnable. */
export type CompanySamlSsoEnablePayload = {
  __typename?: 'CompanySamlSsoEnablePayload';
  audience?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  failedToCreateConnection: Scalars['Boolean']['output'];
};

export enum CompanySize {
  Range_1_10 = 'RANGE_1_10',
  Range_11_50 = 'RANGE_11_50',
  Range_51_100 = 'RANGE_51_100',
  Range_101 = 'RANGE_101_'
}

/** Autogenerated input type of CompanySsoDisable */
export type CompanySsoDisableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of CompanySsoDisable. */
export type CompanySsoDisablePayload = {
  __typename?: 'CompanySsoDisablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

export enum CompanyStatusTransitionEnum {
  ApproveDocumentsReview = 'APPROVE_DOCUMENTS_REVIEW',
  Complete = 'COMPLETE',
  CompleteDraftDetails = 'COMPLETE_DRAFT_DETAILS',
  GoBack = 'GO_BACK',
  InviteTeamMember = 'INVITE_TEAM_MEMBER',
  SendDocumentsBackForReview = 'SEND_DOCUMENTS_BACK_FOR_REVIEW',
  SendDocumentsForReview = 'SEND_DOCUMENTS_FOR_REVIEW',
  SendDocumentsForSignature = 'SEND_DOCUMENTS_FOR_SIGNATURE'
}

export enum CompanyTier {
  None = 'NONE',
  Tier_1 = 'TIER_1',
  Tier_2 = 'TIER_2',
  Tier_3 = 'TIER_3'
}

export enum CompanyUserRoleType {
  Admin = 'ADMIN',
  ClientRepresentative = 'CLIENT_REPRESENTATIVE',
  DirectManager = 'DIRECT_MANAGER',
  ExpensesAdmin = 'EXPENSES_ADMIN',
  ExternalRecruiter = 'EXTERNAL_RECRUITER',
  InvoicesAdmin = 'INVOICES_ADMIN',
  PayrollAdmin = 'PAYROLL_ADMIN',
  ResellerAdmin = 'RESELLER_ADMIN',
  TimeOffAdmin = 'TIME_OFF_ADMIN'
}

/** Autogenerated input type of CompanyWaadSsoEnable */
export type CompanyWaadSsoEnableInput = {
  clientId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientSecret: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  domain: Scalars['String']['input'];
};

/** Autogenerated return type of CompanyWaadSsoEnable. */
export type CompanyWaadSsoEnablePayload = {
  __typename?: 'CompanyWaadSsoEnablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  failedToCreateConnection: Scalars['Boolean']['output'];
};

export type CompensationInsights = {
  __typename?: 'CompensationInsights';
  oysterBandIndexes: Array<OysterBandIndexCountry>;
  roleTypes: RoleTypeCollection;
  salaryBenchmarks: Array<SalaryBenchmark>;
  salaryBenchmarksForAdjacentLevels: Array<SalaryBenchmark>;
  salaryBenchmarksForAllLevels: Array<SalaryBenchmark>;
  seniorityLevels: SeniorityLevelCollection;
  supportedCountries: Array<CountryIsoCode>;
  supportedLevels: Array<EngagementSeniorityLevelType>;
};


export type CompensationInsightsOysterBandIndexesArgs = {
  countryCodes: Array<CountryIsoCode>;
};


export type CompensationInsightsRoleTypesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  providerIds: Array<ProvidersEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type CompensationInsightsSalaryBenchmarksArgs = {
  budgetAmount?: InputMaybe<Scalars['Float']['input']>;
  compensationInsightsSeniorityLevelId?: InputMaybe<Scalars['ID']['input']>;
  countryCode: CountryIsoCode;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  providerIds: Array<ProvidersEnum>;
  roleTypeId: Scalars['ID']['input'];
  seniorityLevel?: InputMaybe<EngagementSeniorityLevelType>;
};


export type CompensationInsightsSalaryBenchmarksForAdjacentLevelsArgs = {
  budgetAmount?: InputMaybe<Scalars['Float']['input']>;
  compensationInsightsSeniorityLevelId: Scalars['ID']['input'];
  countryCode: CountryIsoCode;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  providerIds: Array<ProvidersEnum>;
  roleTypeId: Scalars['ID']['input'];
};


export type CompensationInsightsSalaryBenchmarksForAllLevelsArgs = {
  budgetAmount?: InputMaybe<Scalars['Float']['input']>;
  compensationInsightsSeniorityLevelId?: InputMaybe<Scalars['ID']['input']>;
  countryCode: CountryIsoCode;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  providerIds: Array<ProvidersEnum>;
  roleTypeId: Scalars['ID']['input'];
  seniorityLevel?: InputMaybe<EngagementSeniorityLevelType>;
};


export type CompensationInsightsSeniorityLevelsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CompensationInsightsSupportedCountriesArgs = {
  providerIds: Array<ProvidersEnum>;
};


export type CompensationInsightsSupportedLevelsArgs = {
  providerIds: Array<ProvidersEnum>;
};

/** Autogenerated input type of CompleteAdpWorkforceNowConfiguration */
export type CompleteAdpWorkforceNowConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
  onboardingTemplateRemoteId: Scalars['String']['input'];
};

/** Autogenerated return type of CompleteAdpWorkforceNowConfiguration. */
export type CompleteAdpWorkforceNowConfigurationPayload = {
  __typename?: 'CompleteAdpWorkforceNowConfigurationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  integration?: Maybe<HrisIntegration>;
};

/** Autogenerated input type of CompleteGrant */
export type CompleteGrantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equityGrantId: Scalars['ID']['input'];
};

/** Autogenerated return type of CompleteGrant. */
export type CompleteGrantPayload = {
  __typename?: 'CompleteGrantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityGrant: EquityGrant;
  errors: Array<Scalars['String']['output']>;
};

export type CompleteHireSession = {
  __typename?: 'CompleteHireSession';
  employment?: Maybe<Employment>;
  id: Scalars['ID']['output'];
  partner: Partner;
  returnUrl?: Maybe<Scalars['String']['output']>;
};

export type ComplianceCheckerFailure = {
  __typename?: 'ComplianceCheckerFailure';
  failureType: CcFailureTypeEnum;
  id: Scalars['ID']['output'];
};

export enum ComplianceCheckerHrisPlatformTypeEnum {
  Adpworkforcenow = 'adpworkforcenow',
  Bamboohr = 'bamboohr',
  Gusto = 'gusto',
  Hibob = 'hibob',
  Humaans = 'humaans',
  Oraclehcm = 'oraclehcm',
  Paylocity = 'paylocity',
  Sagehr = 'sagehr',
  Sapsuccessfactors = 'sapsuccessfactors',
  Workday = 'workday'
}

export type ComplianceCheckerIntegration = {
  __typename?: 'ComplianceCheckerIntegration';
  id: Scalars['ID']['output'];
  platformName: ComplianceCheckerHrisPlatformTypeEnum;
  status: ComplianceCheckerIntegrationStatusEnum;
};

export type ComplianceCheckerIntegrationMapping = {
  __typename?: 'ComplianceCheckerIntegrationMapping';
  externalKey: Scalars['String']['output'];
  fieldType: ComplianceCheckerMappingFieldTypeEnum;
  id: Scalars['ID']['output'];
  internalKey?: Maybe<ComplianceCheckerMappingInternalKeyEnum>;
};

export enum ComplianceCheckerIntegrationStatusEnum {
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export enum ComplianceCheckerMappingFieldTypeEnum {
  EmploymentType = 'EMPLOYMENT_TYPE',
  TimeOffPolicy = 'TIME_OFF_POLICY'
}

export enum ComplianceCheckerMappingInternalKeyEnum {
  FullTime = 'FULL_TIME',
  ParentalLeave = 'PARENTAL_LEAVE',
  PartTime = 'PART_TIME',
  SickLeave = 'SICK_LEAVE',
  Vacations = 'VACATIONS'
}

export type ComplianceCheckerMergeLink = {
  __typename?: 'ComplianceCheckerMergeLink';
  token: Scalars['String']['output'];
};

export type ComplianceCheckerReport = {
  __typename?: 'ComplianceCheckerReport';
  canSubmitFeedback?: Maybe<Scalars['Boolean']['output']>;
  failures?: Maybe<Array<ComplianceCheckerFailure>>;
  generatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  issuesCount?: Maybe<Scalars['Int']['output']>;
  reportCategories?: Maybe<Array<ComplianceCheckerReportCategory>>;
  state: ComplianceCheckerReportStateEnum;
  totalRecordsChecked?: Maybe<Scalars['Int']['output']>;
  userFeedbackMessage?: Maybe<Scalars['String']['output']>;
  userFeedbackUseful?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ComplianceCheckerReportCategory = {
  __typename?: 'ComplianceCheckerReportCategory';
  affectedCount?: Maybe<Scalars['Int']['output']>;
  countryCodes: Array<Scalars['String']['output']>;
  group: CcReportCategoryGroupEnum;
  id: Scalars['ID']['output'];
  kind: CcReportCategoryKindEnum;
  mostAffectedCountry?: Maybe<Scalars['String']['output']>;
  mostAffectedTmCount?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  state: CcReportCategoryStateEnum;
};

export enum ComplianceCheckerReportStateEnum {
  CheckingRegulations = 'CHECKING_REGULATIONS',
  Failed = 'FAILED',
  FetchingData = 'FETCHING_DATA',
  Finished = 'FINISHED',
  Initiated = 'INITIATED',
  Obsolete = 'OBSOLETE',
  WaitingForPlatformSync = 'WAITING_FOR_PLATFORM_SYNC'
}

export type ComplianceCheckerUpdateIntegrationMappingsInput = {
  internalKey: ComplianceCheckerMappingInternalKeyEnum;
  mappingIds: Array<Scalars['ID']['input']>;
};

export type ComponentInput = {
  amount: MoneyInput;
  identifier: PayrollComponentTypeEnum;
};

export type ConcurDataCenterType = {
  __typename?: 'ConcurDataCenterType';
  /** The URL to redirect to our app listing in SAP Concur App Center */
  connectUrl: Scalars['String']['output'];
  /** Data Center location (e.g. US/EU) that defines the URL to connect to SAP Concur */
  location: Scalars['String']['output'];
};

export type ConcurIntegrationType = {
  __typename?: 'ConcurIntegrationType';
  /** List of alerts for the current integration */
  alerts: AlertCollection;
  engagementsMappings: ExpensesEngagementMappingTypeCollection;
  /** Integration platform identifier which represents certain integration (e.g. concur) */
  platform: Scalars['String']['output'];
  /** Integration state which describes if integration is active, pending etc */
  state: Scalars['String']['output'];
  /** Useful stats about the integration, such as last-synced-at timestamps */
  stats: ConcurStatsType;
};


export type ConcurIntegrationTypeAlertsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type ConcurIntegrationTypeEngagementsMappingsArgs = {
  mapped?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type ConcurStatsType = {
  __typename?: 'ConcurStatsType';
  /** Last timestamp in which engagements were mapped to employees */
  engagementsLastMappedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of engagements that are mapped in Concur */
  mappedEngagementsCount?: Maybe<Scalars['Int']['output']>;
  /** Number of engagements that are unmapped in Concur */
  unmappedEngagementsCount?: Maybe<Scalars['Int']['output']>;
};

export type ConfigurationBooleanField = {
  __typename?: 'ConfigurationBooleanField';
  /** Default pre-selected value for the field. */
  default: Scalars['Boolean']['output'];
  /** True if the user should be able to change the value of the field, false otherwise. */
  editable: Scalars['Boolean']['output'];
};

export type ConfigurationPaymentFrequencyEnumField = {
  __typename?: 'ConfigurationPaymentFrequencyEnumField';
  /**
   * Default pre-selected value for the field. Null indicates the field should not
   * have a pre-selected value, though the field may still require a non-null value.
   */
  default?: Maybe<PaymentFrequencyEnum>;
  /** True if the user should be able to change the value of the field, false otherwise. */
  editable: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ConfirmEngagementChangeCancellation */
export type ConfirmEngagementChangeCancellationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementChangeId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfirmEngagementChangeCancellation. */
export type ConfirmEngagementChangeCancellationPayload = {
  __typename?: 'ConfirmEngagementChangeCancellationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagementChange?: Maybe<EngagementChange>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ConfirmMandateLodging */
export type ConfirmMandateLodgingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mandateId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfirmMandateLodging. */
export type ConfirmMandateLodgingPayload = {
  __typename?: 'ConfirmMandateLodgingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  mandate?: Maybe<PaymentMethodsCustomerBankAccountMandateType>;
};

/** Autogenerated input type of ConfirmTimeSheet */
export type ConfirmTimeSheetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  timeSheetId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConfirmTimeSheet. */
export type ConfirmTimeSheetPayload = {
  __typename?: 'ConfirmTimeSheetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeSheet?: Maybe<TimeSheet>;
};

/** Autogenerated input type of ConnectAccountingPlatform */
export type ConnectAccountingPlatformInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  platform: Scalars['String']['input'];
};

/** Autogenerated return type of ConnectAccountingPlatform. */
export type ConnectAccountingPlatformPayload = {
  __typename?: 'ConnectAccountingPlatformPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  connection?: Maybe<ConnectionInfo>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ConnectExpensesPlatform */
export type ConnectExpensesPlatformInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  expensifyCredentials: ExpensifyCredentialsInput;
  platform: Scalars['String']['input'];
};

/** Autogenerated return type of ConnectExpensesPlatform. */
export type ConnectExpensesPlatformPayload = {
  __typename?: 'ConnectExpensesPlatformPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of ConnectToMergeIntegration */
export type ConnectToMergeIntegrationInput = {
  addOns: Array<IntegrationAddOnInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  linkType: Scalars['String']['input'];
  platformName: IntegrationPlatformNameEnum;
  publicToken: Scalars['String']['input'];
};

/** Autogenerated return type of ConnectToMergeIntegration. */
export type ConnectToMergeIntegrationPayload = {
  __typename?: 'ConnectToMergeIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type ConnectionInfo = {
  __typename?: 'ConnectionInfo';
  connectUrl?: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum ConsentTypeEnum {
  Report = 'REPORT',
  Tool = 'TOOL'
}

export enum ContentDisposition {
  Attachment = 'ATTACHMENT',
  Inline = 'INLINE'
}

export type Contract = {
  __typename?: 'Contract';
  additionalTerms?: Maybe<Scalars['String']['output']>;
  agreements: Array<Agreement>;
  allContractorInfoProvided: Scalars['Boolean']['output'];
  allCustomerInfoProvided: Scalars['Boolean']['output'];
  /** @deprecated Favor engagement.allowedToSubmitExpenses instead */
  allowedToSubmitExpenses?: Maybe<Scalars['Boolean']['output']>;
  assuredContractor: Scalars['Boolean']['output'];
  authorizations?: Maybe<Authorization>;
  billingType: ContractBilling;
  birthSex?: Maybe<ContractBirthSex>;
  commissionFile?: Maybe<DownloadLink>;
  company?: Maybe<Company>;
  companyAddress?: Maybe<Address>;
  companyAdminSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  companyContactName?: Maybe<Scalars['String']['output']>;
  companyKind?: Maybe<ContractCompanyKind>;
  companyLegalName?: Maybe<Scalars['String']['output']>;
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  companyVatReferenceNumber?: Maybe<Scalars['String']['output']>;
  contractDocumentReviewable: Scalars['Boolean']['output'];
  contractEmail?: Maybe<Scalars['String']['output']>;
  contractorAgreementsFields: Array<Scalars['String']['output']>;
  contractorInvited: Scalars['Boolean']['output'];
  contractorInvoicingSettings?: Maybe<ContractorSettings>;
  contractorKind?: Maybe<ContractContractorKind>;
  contractorSignedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /**
   * Returns individualTaxResidenceCountryCode if contractorKind is Individual. If
   * contractorKind is Company, returns companyAddress.countryCode
   */
  contractorTaxResidenceCountryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currencyCode?: Maybe<Scalars['String']['output']>;
  customerProvidedCountryCode: Scalars['String']['output'];
  daysOfNotice?: Maybe<Scalars['Int']['output']>;
  daysToCure?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Department>;
  effectiveDateOfTaxResidency?: Maybe<Scalars['ISO8601Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  engagement: Engagement;
  engagementId: Scalars['ID']['output'];
  expenseLimit?: Maybe<Scalars['Float']['output']>;
  expenseLimitCurrencyCode?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstPayment?: Maybe<Scalars['Float']['output']>;
  firstPaymentCurrencyCode?: Maybe<Scalars['String']['output']>;
  hiringProcess?: Maybe<ContractHiringProcess>;
  id: Scalars['ID']['output'];
  individualAddress?: Maybe<Address>;
  individualCitizenshipCountryCode?: Maybe<Scalars['String']['output']>;
  individualDateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  individualIdDocumentNumber?: Maybe<Scalars['String']['output']>;
  individualTaxResidenceCountryCode?: Maybe<Scalars['String']['output']>;
  invoiceDefaultTaxRate?: Maybe<Scalars['Float']['output']>;
  ipClause?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPayment?: Maybe<Scalars['Float']['output']>;
  lastPaymentCurrencyCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otherServiceType?: Maybe<Scalars['String']['output']>;
  ownContractFile?: Maybe<DownloadLink>;
  oysterSafe?: Maybe<ContractOysterSafe>;
  paygBillingType?: Maybe<ContractPaygBilling>;
  paymentFrequency?: Maybe<ContractPaymentFrequency>;
  paymentStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preexistingInventions?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  rateCurrencyCode?: Maybe<Scalars['String']['output']>;
  rateUnit?: Maybe<ContractRateUnit>;
  readyForCustomerToSign: Scalars['Boolean']['output'];
  readyToInviteContractor: Scalars['Boolean']['output'];
  role?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  salaryCurrencyCode?: Maybe<Scalars['String']['output']>;
  scopeOfWork?: Maybe<Scalars['String']['output']>;
  serviceEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  serviceType?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  state: Scalars['String']['output'];
  supervisorEmail?: Maybe<Scalars['String']['output']>;
  supervisorName?: Maybe<Scalars['String']['output']>;
  taxIdNumber?: Maybe<Scalars['String']['output']>;
  teamMember?: Maybe<User>;
  terminationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  useOysterTemplate?: Maybe<Scalars['Boolean']['output']>;
  workEmail?: Maybe<Scalars['String']['output']>;
};

export type ContractAspect = AspectInterface & {
  __typename?: 'ContractAspect';
  authorizations?: Maybe<Authorization>;
  company?: Maybe<Company>;
  engagement?: Maybe<Engagement>;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum ContractBilling {
  Fixed = 'FIXED',
  Milestone = 'MILESTONE',
  PayAsYouGo = 'PAY_AS_YOU_GO'
}

export enum ContractBirthSex {
  Female = 'FEMALE',
  Male = 'MALE',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export enum ContractCompanyKind {
  DefaultNonProfit = 'DEFAULT_NON_PROFIT',
  DefaultPartnership = 'DEFAULT_PARTNERSHIP',
  DefaultPrivateCompany = 'DEFAULT_PRIVATE_COMPANY',
  DefaultPublicCompany = 'DEFAULT_PUBLIC_COMPANY',
  DefaultSoleTrader = 'DEFAULT_SOLE_TRADER',
  Other = 'OTHER',
  UkPartnership = 'UK_PARTNERSHIP',
  UkPrivateLimitedCompany = 'UK_PRIVATE_LIMITED_COMPANY',
  UkPublicLimitedCompany = 'UK_PUBLIC_LIMITED_COMPANY',
  UkSolePropietorship = 'UK_SOLE_PROPIETORSHIP',
  UkUnlimitedCompany = 'UK_UNLIMITED_COMPANY',
  UsCorporation = 'US_CORPORATION',
  UsLlc = 'US_LLC',
  UsPartnership = 'US_PARTNERSHIP',
  UsSolePropietorship = 'US_SOLE_PROPIETORSHIP'
}

export enum ContractContractorKind {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL'
}

export type ContractHiringProcess = {
  __typename?: 'ContractHiringProcess';
  customerTasks: Array<TodoTasksTask>;
  manualAgreement: Scalars['Boolean']['output'];
};

export type ContractOysterSafe = {
  __typename?: 'ContractOysterSafe';
  /** The subscription instance. */
  addOn?: Maybe<AddOn>;
  /** The list of comments of the current review cycle, ordered by most recent last. */
  comments: StaffNoteConnection;
  eligibilityCheckStatus: EligibilityCheckStatus;
  eligibilityCheckValidFrom?: Maybe<Scalars['ISO8601Date']['output']>;
  eligibilityCheckValidUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Whether the contractor has agreed to the eligibility check or not. */
  hasContractorAgreed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isEligibilityCheckWithinValidity: Scalars['Boolean']['output'];
  /** Whether the Oyster Shell (Oyster Safe) option has been toggled in the hiring form or not. */
  isEnabled: Scalars['Boolean']['output'];
  /** The plan schema used to create the subscription instance. */
  plan?: Maybe<NewPlan>;
  /** Add-on created if the customer subscribed again before the existing add-on got deactivated. */
  renewalAddOn?: Maybe<AddOn>;
};


export type ContractOysterSafeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContractPaygBilling {
  CommissionBased = 'COMMISSION_BASED',
  FixedRate = 'FIXED_RATE',
  PayPerTask = 'PAY_PER_TASK'
}

export enum ContractPaymentFrequency {
  Monthly = 'MONTHLY'
}

export enum ContractRateUnit {
  PerDay = 'PER_DAY',
  PerHour = 'PER_HOUR',
  PerMonth = 'PER_MONTH',
  PerWeek = 'PER_WEEK'
}

/** Autogenerated input type of ContractorAgreesOysterSafe */
export type ContractorAgreesOysterSafeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  oysterSafeId: Scalars['ID']['input'];
};

/** Autogenerated return type of ContractorAgreesOysterSafe. */
export type ContractorAgreesOysterSafePayload = {
  __typename?: 'ContractorAgreesOysterSafePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  oysterSafe?: Maybe<ContractOysterSafe>;
};

/** Autogenerated input type of ContractorDisagreesOysterSafe */
export type ContractorDisagreesOysterSafeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  postingContext: Scalars['ID']['input'];
};

/** Autogenerated return type of ContractorDisagreesOysterSafe. */
export type ContractorDisagreesOysterSafePayload = {
  __typename?: 'ContractorDisagreesOysterSafePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  oysterSafe?: Maybe<ContractOysterSafe>;
};

export type ContractorSettings = {
  __typename?: 'ContractorSettings';
  authorizations?: Maybe<Authorization>;
  companyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  contract: Contract;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customNotes?: Maybe<Scalars['String']['output']>;
  hideAddressOnInvoice: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoicingEnabled: Scalars['Boolean']['output'];
  salaryItemDescription?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of ContractorsTerminationCreate */
export type ContractorsTerminationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  lastPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
  lastPaymentCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  proposedDate: Scalars['ISO8601Date']['input'];
  signedDocumentId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ContractorsTerminationCreate. */
export type ContractorsTerminationCreatePayload = {
  __typename?: 'ContractorsTerminationCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

export type ContractualResignation = {
  __typename?: 'ContractualResignation';
  /**
   * Indicates the length of a contractual resignation for a team member, and is
   * required when the resignationType field is set to fixed_duration,
   * while it should be null when the resignationType field is set to follow_statutory_rules.
   */
  duration?: Maybe<CalendarDuration>;
  /**
   * Indicates whether the team member's employment contractual resignation is of
   * the fixed_duration type, in which case the duration field specifies the length
   * of the fixed term,
   * or whether it follows the follow_statutory_rules type, in which case the
   * duration field is null and the resignation will be governed by the rules for
   * resignation that are
   * legally required in the team member's country.
   */
  type: TypesEngagementContractualResignationTypeEnum;
};

export type ContractualTermination = {
  __typename?: 'ContractualTermination';
  /**
   * Indicates the length of a contractual termination for a team member, and is
   * required when the terminationType field is set to fixed_duration,
   * while it should be null when the terminationType field is set to follow_statutory_rules.
   */
  duration?: Maybe<CalendarDuration>;
  /**
   * Indicates whether the team member's employment contractual termination is of
   * the fixed_duration type, in which case the duration field specifies the length
   * of the fixed term,
   * or whether it follows the follow_statutory_rules type, in which case the
   * duration field is null and the termination will be governed by the rules for
   * termination that are
   * legally required in the team member's country.
   */
  type: TypesEngagementContractualTerminationTypeEnum;
};

export type CorePaymentMethod = PaymentMethodStripeAch | PaymentMethodStripeBacs | PaymentMethodStripePad | PaymentMethodStripeSepa;

export type CostCenter = {
  __typename?: 'CostCenter';
  authorizations?: Maybe<Authorization>;
  creator?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  engagementsCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CostOfOffboarding = {
  __typename?: 'CostOfOffboarding';
  additionalCosts: AdditionalCosts;
  allowancesAndBenefits: AllowancesAndBenefits;
  currency: Scalars['String']['output'];
  mandatoryCosts: MandatoryCosts;
  monthlySalary: Scalars['Float']['output'];
  proratedFinalMonthSalary: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type CostSplitSetting = {
  __typename?: 'CostSplitSetting';
  dependentsEmployerContribution: Scalars['Float']['output'];
  dependentsEmployerContributionMaxCount: Scalars['Int']['output'];
  employerContribution: Scalars['Float']['output'];
  plan: BenefitsPlan;
  planId: Scalars['ID']['output'];
};

export type CountriesWithEmployerOfRecords = {
  __typename?: 'CountriesWithEmployerOfRecords';
  authorizations?: Maybe<Authorization>;
  /** A list of operated countries */
  countries: EmployerOfRecordCountryCollection;
  /** A list of employer of records */
  vendors: EmployerOfRecordCollection;
};


export type CountriesWithEmployerOfRecordsCountriesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CountriesWithEmployerOfRecordsVendorsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  employmentCostRange: Scalars['String']['output'];
  liability?: Maybe<CountryLiability>;
  name: Scalars['String']['output'];
  notes?: Maybe<Array<CountryNoteGroup>>;
  tzinfo?: Maybe<CountryTimeZone>;
};

export type CountryBenefits = {
  __typename?: 'CountryBenefits';
  authorizations?: Maybe<Authorization>;
  benefit: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  tier: BenefitTier;
};

export type CountryBenefitsCollection = {
  __typename?: 'CountryBenefitsCollection';
  collection: Array<CountryBenefits>;
  metadata: CollectionMetadata;
};

export type CountryIntelligence = {
  __typename?: 'CountryIntelligence';
  additionalSalariesRules: CountryIntelligenceRulesAdditionalSalaries;
  allowancesRules: Array<CountryIntelligenceRulesAllowances>;
  companyAreaOfBusinessFieldForSubdivisionCodes?: Maybe<Array<Scalars['String']['output']>>;
  companyAreaOfBusinessFieldRequired: Scalars['Boolean']['output'];
  contractualResignationRules: Array<CountryIntelligenceRulesContractualResignation>;
  contractualTerminationRules: Array<CountryIntelligenceRulesContractualTermination>;
  /** Contains country benefits ordered by country ISO code and tier */
  countryBenefits: CountryBenefitsCollection;
  flagUtf8?: Maybe<Scalars['String']['output']>;
  isoAlpha2Code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nationalHolidaysPerYear?: Maybe<Scalars['Int']['output']>;
  probationRules: Array<CountryIntelligenceRulesProbation>;
  resignationRules: Array<CountryIntelligenceRulesResignation>;
  restrictiveCovenants: CountryIntelligenceRulesRestrictiveCovenants;
  sickPayRule: CountryIntelligenceRulesSickPay;
  subdivisionCodeHiringRequired?: Maybe<Scalars['Boolean']['output']>;
  subdivisionCodes?: Maybe<Array<Scalars['String']['output']>>;
  terminationRules: Array<CountryIntelligenceRulesTermination>;
  timeOffRules: Array<CountryIntelligenceRulesTimeOff>;
  visaRequired: Scalars['Boolean']['output'];
  workingHourRules: Array<CountryIntelligenceRulesWorkingHour>;
};


export type CountryIntelligenceAllowancesRulesArgs = {
  partOfGrossSalary?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CountryIntelligenceCountryBenefitsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  statutory?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CountryIntelligenceProbationRulesArgs = {
  employmentType?: InputMaybe<CountryIntelligenceEmploymentType>;
  oysterScore?: InputMaybe<CountryIntelligenceOysterScore>;
  teamMemberSeniority?: InputMaybe<CountryIntelligenceTeamMemberSeniority>;
};


export type CountryIntelligenceTimeOffRulesArgs = {
  oysterScore?: InputMaybe<CountryIntelligenceOysterScore>;
  type?: InputMaybe<CountryIntelligenceRulesTimeOffType>;
};


export type CountryIntelligenceVisaRequiredArgs = {
  nationality?: InputMaybe<Scalars['String']['input']>;
};


export type CountryIntelligenceWorkingHourRulesArgs = {
  employmentType?: InputMaybe<CountryIntelligenceEmploymentType>;
};

export type CountryIntelligenceCollection = {
  __typename?: 'CountryIntelligenceCollection';
  collection: Array<CountryIntelligence>;
  metadata: CollectionMetadata;
};

export enum CountryIntelligenceEmploymentType {
  Permanent = 'PERMANENT',
  Temporary = 'TEMPORARY'
}

export enum CountryIntelligenceOysterScore {
  Customary = 'CUSTOMARY',
  Recommended = 'RECOMMENDED',
  Statutory = 'STATUTORY',
  TopOfMarket = 'TOP_OF_MARKET'
}

export type CountryIntelligenceRulesAdditionalSalaries = {
  __typename?: 'CountryIntelligenceRulesAdditionalSalaries';
  customerInfoMessage?: Maybe<Scalars['String']['output']>;
  customerInfoTitle?: Maybe<Scalars['String']['output']>;
  salaries?: Maybe<Array<CountryIntelligenceRulesAdditionalSalariesSalaries>>;
};

export type CountryIntelligenceRulesAdditionalSalariesSalaries = {
  __typename?: 'CountryIntelligenceRulesAdditionalSalariesSalaries';
  allowedMonths: Array<Scalars['Int']['output']>;
  alwaysSelectedMonths?: Maybe<Array<Scalars['Int']['output']>>;
  arePaymentMonthsEditable: Scalars['Boolean']['output'];
  canBeProrated: Scalars['Boolean']['output'];
  canBeSoleAdditionalSalary: Scalars['Boolean']['output'];
  defaultSelectedMonths: Array<Scalars['Int']['output']>;
  isDefaultEnabled: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  isPartOfGrossSalary: Scalars['Boolean']['output'];
  maxSelectedMonths: Scalars['Int']['output'];
  salary: Scalars['Int']['output'];
  staffMonthTooltip?: Maybe<Scalars['String']['output']>;
  staffSalaryTooltip?: Maybe<Scalars['String']['output']>;
};

export type CountryIntelligenceRulesAllowances = {
  __typename?: 'CountryIntelligenceRulesAllowances';
  approximation: Scalars['Boolean']['output'];
  oysterScore: CountryIntelligenceOysterScore;
  paidWhen?: Maybe<CountryIntelligenceRulesAllowancesPaidWhen>;
  partOfGrossSalary: Scalars['Boolean']['output'];
  type: CountryIntelligenceRulesAllowancesType;
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export enum CountryIntelligenceRulesAllowancesPaidWhen {
  Anytime = 'ANYTIME',
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  Monthly = 'MONTHLY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  OneTime = 'ONE_TIME',
  September = 'SEPTEMBER',
  Yearly = 'YEARLY'
}

export enum CountryIntelligenceRulesAllowancesType {
  DepositSaving = 'DEPOSIT_SAVING',
  Pension = 'PENSION',
  PerformanceBonus = 'PERFORMANCE_BONUS',
  ProfitSharing = 'PROFIT_SHARING',
  VacationBonus = 'VACATION_BONUS',
  WfhAllowance = 'WFH_ALLOWANCE'
}

export type CountryIntelligenceRulesContractualResignation = {
  __typename?: 'CountryIntelligenceRulesContractualResignation';
  notice?: Maybe<CalendarDuration>;
  optionType: TypesEngagementContractualResignationTypeEnum;
  oysterScore: CountryIntelligenceOysterScore;
};

export type CountryIntelligenceRulesContractualTermination = {
  __typename?: 'CountryIntelligenceRulesContractualTermination';
  notice?: Maybe<CalendarDuration>;
  optionType: TypesEngagementContractualTerminationTypeEnum;
  oysterScore: CountryIntelligenceOysterScore;
};

export type CountryIntelligenceRulesProbation = {
  __typename?: 'CountryIntelligenceRulesProbation';
  duration: CalendarDuration;
  employmentType: CountryIntelligenceEmploymentType;
  extension?: Maybe<CountryIntelligenceRulesProbationExtension>;
  oysterScore: CountryIntelligenceOysterScore;
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  teamMemberLevel?: Maybe<CountryIntelligenceTeamMemberLevel>;
  teamMemberSeniorities?: Maybe<Array<CountryIntelligenceTeamMemberSeniority>>;
  tenureRange?: Maybe<CalendarDurationRange>;
};

export type CountryIntelligenceRulesProbationExtension = {
  __typename?: 'CountryIntelligenceRulesProbationExtension';
  deadline?: Maybe<CalendarDuration>;
  maxAdditionalDuration?: Maybe<CalendarDuration>;
};

export type CountryIntelligenceRulesResignation = {
  __typename?: 'CountryIntelligenceRulesResignation';
  duringProbation: Scalars['Boolean']['output'];
  notice: CalendarDuration;
  oysterScore: CountryIntelligenceOysterScore;
  tenureRange?: Maybe<CalendarDurationRange>;
};

export type CountryIntelligenceRulesRestrictiveCovenants = {
  __typename?: 'CountryIntelligenceRulesRestrictiveCovenants';
  postTermination?: Maybe<CountryIntelligenceRulesRestrictiveCovenantsPostTermination>;
  restrictedClauses?: Maybe<RestrictedClauses>;
};


export type CountryIntelligenceRulesRestrictiveCovenantsPostTerminationArgs = {
  nonCompetition?: InputMaybe<Scalars['Boolean']['input']>;
  nonSolicitationCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  nonSolicitationEmployees?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CountryIntelligenceRulesRestrictiveCovenantsRestrictedClausesArgs = {
  countryCode: Scalars['String']['input'];
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
};

export type CountryIntelligenceRulesRestrictiveCovenantsPostTermination = {
  __typename?: 'CountryIntelligenceRulesRestrictiveCovenantsPostTermination';
  maxDuration?: Maybe<CalendarDuration>;
  paymentRequired: Scalars['Boolean']['output'];
  paymentRules: Array<PostTerminationPaymentRule>;
  suggestedDurations: Array<CalendarDuration>;
};

export type CountryIntelligenceRulesSickPay = {
  __typename?: 'CountryIntelligenceRulesSickPay';
  customDurationOption?: Maybe<Scalars['String']['output']>;
  maxCustomDuration?: Maybe<CalendarDuration>;
  options?: Maybe<Array<Scalars['String']['output']>>;
};

export type CountryIntelligenceRulesTermination = {
  __typename?: 'CountryIntelligenceRulesTermination';
  duringProbation: Scalars['Boolean']['output'];
  notice: CalendarDuration;
  oysterScore: CountryIntelligenceOysterScore;
  tenureRange?: Maybe<CalendarDurationRange>;
};

export type CountryIntelligenceRulesTimeOff = {
  __typename?: 'CountryIntelligenceRulesTimeOff';
  amountPerYear?: Maybe<CalendarDuration>;
  oysterScore?: Maybe<CountryIntelligenceOysterScore>;
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CountryIntelligenceRulesTimeOffType>;
};

export type CountryIntelligenceRulesTimeOffCollection = {
  __typename?: 'CountryIntelligenceRulesTimeOffCollection';
  collection: Array<CountryIntelligenceRulesTimeOff>;
  metadata: CollectionMetadata;
};

export enum CountryIntelligenceRulesTimeOffType {
  Maternity = 'MATERNITY',
  ParentsLeave = 'PARENTS_LEAVE',
  Paternity = 'PATERNITY',
  SickLeave = 'SICK_LEAVE',
  SuppressedNationalHolidays = 'SUPPRESSED_NATIONAL_HOLIDAYS',
  TimeReductionCompensation = 'TIME_REDUCTION_COMPENSATION',
  Vacations = 'VACATIONS'
}

export type CountryIntelligenceRulesWorkingHour = {
  __typename?: 'CountryIntelligenceRulesWorkingHour';
  employmentType: CountryIntelligenceEmploymentType;
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  workingWeek?: Maybe<CountryIntelligenceRulesWorkingHourWorkingWeek>;
};

export type CountryIntelligenceRulesWorkingHourWorkingWeek = {
  __typename?: 'CountryIntelligenceRulesWorkingHourWorkingWeek';
  maxDuration: Scalars['Float']['output'];
  minDuration: Scalars['Float']['output'];
  standardDuration: Scalars['Float']['output'];
};

export enum CountryIntelligenceTeamMemberLevel {
  Executive = 'EXECUTIVE',
  NonExecutive = 'NON_EXECUTIVE'
}

export enum CountryIntelligenceTeamMemberSeniority {
  Csuite = 'CSUITE',
  Director = 'DIRECTOR',
  Head = 'HEAD',
  Junior = 'JUNIOR',
  Lead = 'LEAD',
  Mid = 'MID',
  Principal = 'PRINCIPAL',
  Senior = 'SENIOR',
  Vp = 'VP'
}

export enum CountryIsoCode {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei Darussalam */
  Bn = 'BN',
  /** Bolivia */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** Congo, The Democratic Republic of the */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cabo Verde */
  Cv = 'CV',
  /** Curaçao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czechia */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands (Malvinas) */
  Fk = 'FK',
  /** Micronesia, Federated States of */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard Island and McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** North Korea */
  Kp = 'KP',
  /** South Korea */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Lao People's Democratic Republic */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin (French part) */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** North Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macao */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestine, State of */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Réunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russian Federation */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena, Ascension and Tristan da Cunha */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten (Dutch part) */
  Sx = 'SX',
  /** Syrian Arab Republic */
  Sy = 'SY',
  /** Eswatini */
  Sz = 'SZ',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Turkey */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan */
  Tw = 'TW',
  /** Tanzania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States Minor Outlying Islands */
  Um = 'UM',
  /** United States */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Holy See (Vatican City State) */
  Va = 'VA',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** Virgin Islands, British */
  Vg = 'VG',
  /** Virgin Islands, U.S. */
  Vi = 'VI',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Kosovo */
  Xk = 'XK',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

export type CountryLiability = {
  __typename?: 'CountryLiability';
  link: Scalars['String']['output'];
  tier: CountryLiabilityEnumType;
};

export enum CountryLiabilityEnumType {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type CountryNoteGroup = {
  __typename?: 'CountryNoteGroup';
  name: Scalars['String']['output'];
  notes: Array<Scalars['String']['output']>;
};

export enum CountryPayrollStateEnumType {
  Approved = 'APPROVED',
  Downloaded = 'DOWNLOADED',
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum CountryPayrollTransitionEvent {
  Download = 'DOWNLOAD',
  Pay = 'PAY',
  Unpay = 'UNPAY'
}

export type CountrySales = {
  __typename?: 'CountrySales';
  /** True if company has existing or potential sales in Bolivia, false if not. Null if unknown. */
  mightSellInBolivia?: Maybe<Scalars['Boolean']['output']>;
  /** True if company has existing or potential sales in China, false if not. Null if unknown. */
  mightSellInChina?: Maybe<Scalars['Boolean']['output']>;
  /** True if company has existing or potential sales in Colombia, false if not. Null if unknown. */
  mightSellInColombia?: Maybe<Scalars['Boolean']['output']>;
  /** True if company has existing or potential sales in Israel, false if not. Null if unknown. */
  mightSellInIsrael?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Sales in Spain as a percentage of total sales globally. Represented as a float between
   * 0.00 and 100.00%. This will be 0 null if there are actually no sales in Spain.
   */
  percentageTotalSalesInSpain?: Maybe<Scalars['Float']['output']>;
  /** True if company has existing sales in Spain, false if not. Null if unknown. */
  sellsInSpain?: Maybe<Scalars['Boolean']['output']>;
};

export type CountrySalesInput = {
  /** True if company has existing or potential sales in Bolivia, false if not. Null if unknown. */
  mightSellInBolivia?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if company has existing or potential sales in China, false if not. Null if unknown. */
  mightSellInChina?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if company has existing or potential sales in Colombia, false if not. Null if unknown. */
  mightSellInColombia?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if company has existing or potential sales in Israel, false if not. Null if unknown. */
  mightSellInIsrael?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sales in Spain as a percentage of total sales globally. Expects a float between
   * 0.00 and 100.00%. This should be null if there are actually no sales in Spain.
   */
  percentageTotalSalesInSpain?: InputMaybe<Scalars['Float']['input']>;
  /** True if company has existing sales in Spain, false if not. Null if unknown. */
  sellsInSpain?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountryTimeZone = {
  __typename?: 'CountryTimeZone';
  /** The maximum UTC offset, in minutes for all the timezones in queried country */
  maxUtcOffset?: Maybe<Scalars['Int']['output']>;
  /** The minimum UTC offset, in minutes, for all timezones for the queried country */
  minUtcOffset?: Maybe<Scalars['Int']['output']>;
  /** List of standard time zone names for the queried country (e.g. [Pacific/Auckland, Pacific/Chatham] for New Zealand) */
  zones?: Maybe<Array<TimeZone>>;
};

/** Autogenerated input type of CreateAccountingVendorsForUnlinkedContractors */
export type CreateAccountingVendorsForUnlinkedContractorsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  platform: Scalars['String']['input'];
};

/** Autogenerated return type of CreateAccountingVendorsForUnlinkedContractors. */
export type CreateAccountingVendorsForUnlinkedContractorsPayload = {
  __typename?: 'CreateAccountingVendorsForUnlinkedContractorsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateAmendmentTimeSheetMutation */
export type CreateAmendmentTimeSheetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  timeSheetId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateAmendmentTimeSheetMutation. */
export type CreateAmendmentTimeSheetMutationPayload = {
  __typename?: 'CreateAmendmentTimeSheetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeSheet?: Maybe<TimeSheet>;
};

/** Autogenerated input type of CreateBacsCheckoutSession */
export type CreateBacsCheckoutSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateBacsCheckoutSession. */
export type CreateBacsCheckoutSessionPayload = {
  __typename?: 'CreateBacsCheckoutSessionPayload';
  checkoutSession?: Maybe<CheckoutSession>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateBankAccountPaymentMethod */
export type CreateBankAccountPaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currencyCode: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
  ownerId: Scalars['ID']['input'];
  rulesetId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateBankAccountPaymentMethod. */
export type CreateBankAccountPaymentMethodPayload = {
  __typename?: 'CreateBankAccountPaymentMethodPayload';
  bankAccountPaymentMethod?: Maybe<EngagementBankAccount>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateBulkEngagementChange */
export type CreateBulkEngagementChangeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  effectiveFrom: Scalars['ISO8601DateTime']['input'];
  entriesInput: Array<BulkEngagementChangeEntryInput>;
};

/** Autogenerated return type of CreateBulkEngagementChange. */
export type CreateBulkEngagementChangePayload = {
  __typename?: 'CreateBulkEngagementChangePayload';
  bulkEngagementChange?: Maybe<BulkEngagementChange>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  createErrors: Array<BulkEngagementChangeError>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateBulkOnboarding */
export type CreateBulkOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  fileSignedId: Scalars['String']['input'];
  /** The processing mode to be used. */
  mode?: InputMaybe<BulkOnboardingModeEnum>;
  performerId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateBulkOnboarding. */
export type CreateBulkOnboardingPayload = {
  __typename?: 'CreateBulkOnboardingPayload';
  bulkOnboarding?: Maybe<BulkOnboarding>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCobranding */
export type CreateCobrandingInput = {
  blackLogoSignedId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  theme: ThemeInput;
  whiteLogoSignedId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCobranding. */
export type CreateCobrandingPayload = {
  __typename?: 'CreateCobrandingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCompanyPlan */
export type CreateCompanyPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonJobTitle?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  equityManagementSoftwareName?: InputMaybe<Array<Scalars['String']['input']>>;
  grantorName?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  vestingCliffMonths?: InputMaybe<Scalars['Int']['input']>;
  vestingCliffShares?: InputMaybe<Scalars['Float']['input']>;
  vestingScheduleMonths?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateCompanyPlan. */
export type CreateCompanyPlanPayload = {
  __typename?: 'CreateCompanyPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityPlan: EquityCompanyPlan;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCompanyValuation */
export type CreateCompanyValuationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  equityGrantId?: InputMaybe<Scalars['ID']['input']>;
  valuation?: InputMaybe<Scalars['Float']['input']>;
  valuationCurrency?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCompanyValuation. */
export type CreateCompanyValuationPayload = {
  __typename?: 'CreateCompanyValuationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityCompanyValuation: EquityCompanyValuation;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateContract */
export type CreateContractInput = {
  additionalTerms?: InputMaybe<Scalars['String']['input']>;
  allowedToSubmitExpenses?: InputMaybe<Scalars['Boolean']['input']>;
  assuredContractor?: InputMaybe<Scalars['Boolean']['input']>;
  billingType?: InputMaybe<ContractBilling>;
  birthSex?: InputMaybe<ContractBirthSex>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commissionFileSignedId?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<AddressArguments>;
  companyContactName?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  companyKind?: InputMaybe<ContractCompanyKind>;
  companyLegalName?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  companyVatReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  contractorKind?: InputMaybe<ContractContractorKind>;
  customerProvidedCountryCode?: InputMaybe<Scalars['String']['input']>;
  daysOfNotice?: InputMaybe<Scalars['Int']['input']>;
  daysToCure?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expenseLimit?: InputMaybe<Scalars['Float']['input']>;
  expenseLimitCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstPayment?: InputMaybe<Scalars['Float']['input']>;
  firstPaymentCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  individualAddress?: InputMaybe<AddressArguments>;
  individualCitizenshipCountryCode?: InputMaybe<Scalars['String']['input']>;
  individualDateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  individualIdDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  individualTaxResidenceCountryCode?: InputMaybe<Scalars['String']['input']>;
  integrationMetadata?: InputMaybe<EmployerIntegrationMetadata>;
  invoiceDefaultTaxRate?: InputMaybe<Scalars['Float']['input']>;
  ipClause?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPayment?: InputMaybe<Scalars['Float']['input']>;
  lastPaymentCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  monetizationAttributes?: InputMaybe<MonetizationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherServiceType?: InputMaybe<Scalars['String']['input']>;
  ownContractFileSignedId?: InputMaybe<Scalars['String']['input']>;
  oysterSafeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  paygBillingType?: InputMaybe<ContractPaygBilling>;
  paymentFrequency?: InputMaybe<ContractPaymentFrequency>;
  paymentStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preexistingInventions?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  rateUnit?: InputMaybe<ContractRateUnit>;
  role?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  salaryCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  scopeOfWork?: InputMaybe<Scalars['String']['input']>;
  serviceEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
  supervisorEmail?: InputMaybe<Scalars['String']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
  taxIdNumber?: InputMaybe<Scalars['String']['input']>;
  useOysterTemplate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateContract. */
export type CreateContractPayload = {
  __typename?: 'CreateContractPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateContractorInvoice */
export type CreateContractorInvoiceInput = {
  amountCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  invoiceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lineItems?: InputMaybe<Array<InvoiceLineItemInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentPeriodEndDate: Scalars['ISO8601Date']['input'];
  paymentPeriodStartDate: Scalars['ISO8601Date']['input'];
  taxRate?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of CreateContractorInvoice. */
export type CreateContractorInvoicePayload = {
  __typename?: 'CreateContractorInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  invoice?: Maybe<Invoice>;
};

/** Autogenerated input type of CreateCostCenter */
export type CreateCostCenterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCostCenter. */
export type CreateCostCenterPayload = {
  __typename?: 'CreateCostCenterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  costCenter?: Maybe<CostCenter>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCustomPrice */
export type CreateCustomPriceInput = {
  amount: MoneyInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  createdById: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  planId: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCustomPrice. */
export type CreateCustomPricePayload = {
  __typename?: 'CreateCustomPricePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customPrice?: Maybe<PlanPrice>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCustomReasonMappings */
export type CreateCustomReasonMappingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customTimeOffMappings?: InputMaybe<Array<CustomReasonMappingInput>>;
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCustomReasonMappings. */
export type CreateCustomReasonMappingsPayload = {
  __typename?: 'CreateCustomReasonMappingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCustomTimeOffMappings */
export type CreateCustomTimeOffMappingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customSubtype?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
  oysterType: Scalars['String']['input'];
  remoteRequestTypes: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCustomTimeOffMappings. */
export type CreateCustomTimeOffMappingsPayload = {
  __typename?: 'CreateCustomTimeOffMappingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCustomerBankAccount */
export type CreateCustomerBankAccountInput = {
  bankDetails: PaymentMethodsCustomerBankAccountDetailsInput;
  billingAddress?: InputMaybe<AddressArguments>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['ID']['input'];
  paymentMethodType: PaymentMethodsCustomerBankAccountEnumType;
  userNotSigner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateCustomerBankAccount. */
export type CreateCustomerBankAccountPayload = {
  __typename?: 'CreateCustomerBankAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerBankAccount?: Maybe<B2BPaymentMethod>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateDependent */
export type CreateDependentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  fieldsWithValues?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of CreateDependent. */
export type CreateDependentPayload = {
  __typename?: 'CreateDependentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement: Engagement;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateDocument */
export type CreateDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  signedDocumentId: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateDocument. */
export type CreateDocumentPayload = {
  __typename?: 'CreateDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  document?: Maybe<Document>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateDraftGrant */
export type CreateDraftGrantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  equitySubType?: InputMaybe<EquitySubTypeEnum>;
  equityType: EquityTypeEnum;
  grantAmount?: InputMaybe<Scalars['Float']['input']>;
  grantAmountCurrency?: InputMaybe<Scalars['String']['input']>;
  grantDate: Scalars['ISO8601Date']['input'];
  grantShares?: InputMaybe<Scalars['Float']['input']>;
  planType: EquityPlanTypeEnum;
  vestingCliffMonths?: InputMaybe<Scalars['Int']['input']>;
  vestingCliffShares?: InputMaybe<Scalars['Float']['input']>;
  vestingScheduleMonths?: InputMaybe<Scalars['Int']['input']>;
  vestingStartDate: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of CreateDraftGrant. */
export type CreateDraftGrantPayload = {
  __typename?: 'CreateDraftGrantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityGrant: EquityGrant;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateEmployerOfRecordCountry */
export type CreateEmployerOfRecordCountryInput = {
  alpha2: Scalars['String']['input'];
  averageTimeToHire?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  concurrentHireDescription?: InputMaybe<Scalars['String']['input']>;
  hiringConfidence?: InputMaybe<EorCountryHiringConfidenceEnumType>;
  needToKnows?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateEmployerOfRecordCountry. */
export type CreateEmployerOfRecordCountryPayload = {
  __typename?: 'CreateEmployerOfRecordCountryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employerOfRecordCountry?: Maybe<EmployerOfRecordCountry>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateEmployerOfRecord */
export type CreateEmployerOfRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  cutOffMonthDay: Scalars['Int']['input'];
  direct?: InputMaybe<Scalars['Boolean']['input']>;
  employerOfRecordCountryByAlpha2?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordCountryId?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordDetailAttributes?: InputMaybe<EmployerOfRecordDetailsAttributesInput>;
  entityType?: InputMaybe<GlobalPayrollEorEntityTypeEnum>;
  externalToolsAttributes?: InputMaybe<Array<ExternalToolInputType>>;
  financeEmail?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateEmployerOfRecord. */
export type CreateEmployerOfRecordPayload = {
  __typename?: 'CreateEmployerOfRecordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employerOfRecord?: Maybe<EmployerOfRecord>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateEmployment */
export type CreateEmploymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordId?: InputMaybe<Scalars['String']['input']>;
  employmentComplianceCheck?: InputMaybe<Scalars['Boolean']['input']>;
  employmentComplianceDetails?: InputMaybe<Scalars['String']['input']>;
  employmentTemplateId?: InputMaybe<Scalars['ID']['input']>;
  personalInfoAttributes?: InputMaybe<EmploymentPersonalInfoAttributesInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  salaryAmount?: InputMaybe<Scalars['Float']['input']>;
  salaryCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateEmployment. */
export type CreateEmploymentPayload = {
  __typename?: 'CreateEmploymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  employment?: Maybe<Employment>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateEmploymentTemplate */
export type CreateEmploymentTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  countryCode?: InputMaybe<CountryIsoCode>;
  description?: InputMaybe<Scalars['String']['input']>;
  equityOffered?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  paidHolidayDays?: InputMaybe<Scalars['Float']['input']>;
  probationPeriod?: InputMaybe<Scalars['Iso8601Duration']['input']>;
  remoteWorkCosts?: InputMaybe<EngagementRemoteWorkCostInputType>;
};

/** Autogenerated return type of CreateEmploymentTemplate. */
export type CreateEmploymentTemplatePayload = {
  __typename?: 'CreateEmploymentTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employmentTemplate?: Maybe<EmploymentTemplate>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors: Array<FormFieldError>;
};

/** Autogenerated input type of CreateEnrollmentTemplate */
export type CreateEnrollmentTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employmentTemplateId: Scalars['ID']['input'];
  enrollmentTemplateInput: BenefitsEnrollmentTemplateInput;
};

/** Autogenerated return type of CreateEnrollmentTemplate. */
export type CreateEnrollmentTemplatePayload = {
  __typename?: 'CreateEnrollmentTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employmentTemplate?: Maybe<EmploymentTemplate>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateExpense */
export type CreateExpenseInput = {
  amount: Scalars['Float']['input'];
  amountCurrencyCode: Scalars['String']['input'];
  category: ExpenseCategory;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  expenseDate: Scalars['ISO8601Date']['input'];
  payout?: InputMaybe<MoneyInput>;
  receiptId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateExpense. */
export type CreateExpensePayload = {
  __typename?: 'CreateExpensePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  expense?: Maybe<Expense>;
};

/** Autogenerated input type of CreateExternalPointOfContact */
export type CreateExternalPointOfContactInput = {
  areasOfDomain: Array<Scalars['String']['input']>;
  backupEmail?: InputMaybe<Scalars['String']['input']>;
  backupJobTitle?: InputMaybe<Scalars['String']['input']>;
  backupName?: InputMaybe<Scalars['String']['input']>;
  backupPhoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  backupPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  countries: Array<Scalars['String']['input']>;
  customerNotes?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  includedInServiceComms: Scalars['Boolean']['input'];
  jobTitle: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateExternalPointOfContact. */
export type CreateExternalPointOfContactPayload = {
  __typename?: 'CreateExternalPointOfContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  externalPointOfContact?: Maybe<ExternalPointOfContact>;
};

export type CreateGenerationInput = {
  documentTemplateIds: Array<Scalars['String']['input']>;
  engagementId: Scalars['String']['input'];
};

/** Autogenerated input type of CreateGrant */
export type CreateGrantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyValuationId: Scalars['ID']['input'];
  countryCode: Scalars['String']['input'];
  earlyExerciseEvent?: InputMaybe<Array<Scalars['String']['input']>>;
  engagementId: Scalars['ID']['input'];
  equitySubType?: InputMaybe<EquitySubTypeEnum>;
  equityType: EquityTypeEnum;
  grantAmount?: InputMaybe<Scalars['Float']['input']>;
  grantAmountCurrency?: InputMaybe<Scalars['String']['input']>;
  grantDate: Scalars['ISO8601Date']['input'];
  grantShares?: InputMaybe<Scalars['Float']['input']>;
  grantedInSoftware: Scalars['Boolean']['input'];
  planType: EquityPlanTypeEnum;
  recurring: Scalars['Boolean']['input'];
  vestingCliffMonths?: InputMaybe<Scalars['Int']['input']>;
  vestingCliffShares?: InputMaybe<Scalars['Float']['input']>;
  vestingScheduleMonths?: InputMaybe<Scalars['Int']['input']>;
  vestingStartDate: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of CreateGrant. */
export type CreateGrantPayload = {
  __typename?: 'CreateGrantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityGrant: EquityGrant;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of Create */
export type CreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  engagementId: Scalars['ID']['input'];
  saveAsDraft?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of CreateInvoice */
export type CreateInvoiceInput = {
  amount: Scalars['Float']['input'];
  amountCurrencyCode: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  dueDate: Scalars['ISO8601Date']['input'];
  invoiceDate: Scalars['ISO8601Date']['input'];
  kind: InvoiceKind;
  lineItems?: InputMaybe<Array<InvoiceLineItemInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  referenceCode: Scalars['String']['input'];
  signedDocumentId: Scalars['String']['input'];
  signedSupportingDocumentId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateInvoice. */
export type CreateInvoicePayload = {
  __typename?: 'CreateInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  invoice?: Maybe<Invoice>;
};

/** Autogenerated input type of CreateJobRoleSearch */
export type CreateJobRoleSearchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  keywordScore?: InputMaybe<RoleKeywordScoreType>;
  roleTypeId?: InputMaybe<Scalars['ID']['input']>;
  searchInput: Scalars['String']['input'];
};

/** Autogenerated return type of CreateJobRoleSearch. */
export type CreateJobRoleSearchPayload = {
  __typename?: 'CreateJobRoleSearchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateManualKycVerification */
export type CreateManualKycVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  status: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateManualKycVerification. */
export type CreateManualKycVerificationPayload = {
  __typename?: 'CreateManualKycVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  kycVerification?: Maybe<KycVerification>;
  user?: Maybe<User>;
};

/** Autogenerated input type of CreateMergeHire */
export type CreateMergeHireInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  employmentAttributes?: InputMaybe<EmployerEmploymentInput>;
  integrationMetadata?: InputMaybe<EmployerIntegrationMetadata>;
  personalInfoAttributes?: InputMaybe<EmployerEmploymentsPersonalInfoAttributesInput>;
};

/** Autogenerated return type of CreateMergeHire. */
export type CreateMergeHirePayload = {
  __typename?: 'CreateMergeHirePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<FormFieldError>>;
};

/** Autogenerated input type of CreateOauthApplication */
export type CreateOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  developerTermsAccepted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of CreateOauthApplication. */
export type CreateOauthApplicationPayload = {
  __typename?: 'CreateOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  oauthApplication?: Maybe<OauthApplication>;
};

/** Autogenerated input type of CreateOktaCredential */
export type CreateOktaCredentialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  oktaClientId: Scalars['String']['input'];
  oktaClientSecret: Scalars['String']['input'];
  oktaIssuerUrl: Scalars['String']['input'];
};

/** Autogenerated return type of CreateOktaCredential. */
export type CreateOktaCredentialPayload = {
  __typename?: 'CreateOktaCredentialPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  oktaCredential?: Maybe<OktaCredential>;
};

/** Autogenerated input type of CreateOrUpdateSeniorityLevelMatch */
export type CreateOrUpdateSeniorityLevelMatchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  internalSeniorityLevelId: Scalars['ID']['input'];
  seniorityLevelId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateOrUpdateSeniorityLevelMatch. */
export type CreateOrUpdateSeniorityLevelMatchPayload = {
  __typename?: 'CreateOrUpdateSeniorityLevelMatchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  seniorityLevel: WorkforceReportSeniorityLevel;
};

/** Autogenerated input type of CreatePadCheckoutSession */
export type CreatePadCheckoutSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePadCheckoutSession. */
export type CreatePadCheckoutSessionPayload = {
  __typename?: 'CreatePadCheckoutSessionPayload';
  checkoutSession?: Maybe<CheckoutSession>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of Create. */
export type CreatePayload = {
  __typename?: 'CreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  invoice?: Maybe<Invoice>;
};

/** Autogenerated input type of CreatePaymentMethodStripeAch */
export type CreatePaymentMethodStripeAchInput = {
  accountHolderName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['ID']['input'];
  routingNumber: Scalars['String']['input'];
  stripeBankToken: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePaymentMethodStripeAch. */
export type CreatePaymentMethodStripeAchPayload = {
  __typename?: 'CreatePaymentMethodStripeAchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethodStripeAch>;
};

/** Autogenerated input type of CreatePaymentMethodStripeAchViaPlaid */
export type CreatePaymentMethodStripeAchViaPlaidInput = {
  account: Scalars['JSON']['input'];
  accounts: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePaymentMethodStripeAchViaPlaid. */
export type CreatePaymentMethodStripeAchViaPlaidPayload = {
  __typename?: 'CreatePaymentMethodStripeAchViaPlaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethodStripeAch>;
};

/** Autogenerated input type of CreatePaymentMethodStripeSepa */
export type CreatePaymentMethodStripeSepaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['ID']['input'];
  setupIntentId: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePaymentMethodStripeSepa. */
export type CreatePaymentMethodStripeSepaPayload = {
  __typename?: 'CreatePaymentMethodStripeSepaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethodStripeSepa>;
};

/** Autogenerated input type of CreatePaymentsGroup */
export type CreatePaymentsGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  invoiceIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreatePaymentsGroup. */
export type CreatePaymentsGroupPayload = {
  __typename?: 'CreatePaymentsGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentsGroup?: Maybe<PaymentsGroup>;
};

/** Autogenerated input type of CreatePayrollCycleDocument */
export type CreatePayrollCycleDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentType: PayrollCycleDocumentTypeEnum;
  payrollCycleId: Scalars['ID']['input'];
  signedDocumentId: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePayrollCycleDocument. */
export type CreatePayrollCycleDocumentPayload = {
  __typename?: 'CreatePayrollCycleDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  payrollCycleDocument: PayrollCycleDocument;
};

/** Autogenerated input type of CreatePayrollEntity */
export type CreatePayrollEntityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  cutOffMonthDay: Scalars['Int']['input'];
  direct?: InputMaybe<Scalars['Boolean']['input']>;
  employerOfRecordCountryByAlpha2?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordCountryId?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordDetailAttributes?: InputMaybe<EmployerOfRecordDetailsAttributesInput>;
  externalToolsAttributes?: InputMaybe<Array<ExternalToolInputType>>;
  financeEmail?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  payrollCycleType?: InputMaybe<GlobalPayrollPayrollCycleTypeEnum>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreatePayrollEntity. */
export type CreatePayrollEntityPayload = {
  __typename?: 'CreatePayrollEntityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employerOfRecord?: Maybe<EmployerOfRecord>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreatePerlRequest */
export type CreatePerlRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  letterType?: InputMaybe<PerlTypeEnum>;
  requestedPersonalization?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreatePerlRequest. */
export type CreatePerlRequestPayload = {
  __typename?: 'CreatePerlRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateReimbursementBudget */
export type CreateReimbursementBudgetInput = {
  amountSubunit: Scalars['MoneyInt']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Provide a label to be used for reimbursement budget when the "other" label is selected. */
  customLabel?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  engagementId: Scalars['ID']['input'];
  label: ReimbursementBudgetLabelEnum;
  resetFrequency: ResetFrequencyEnum;
};

/** Autogenerated return type of CreateReimbursementBudget. */
export type CreateReimbursementBudgetPayload = {
  __typename?: 'CreateReimbursementBudgetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  reimbursementBudget?: Maybe<ReimbursementBudget>;
};

/** Autogenerated input type of CreateResellerEndClient */
export type CreateResellerEndClientInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  publicUrl: Scalars['String']['input'];
  region: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
  resellerId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateResellerEndClient. */
export type CreateResellerEndClientPayload = {
  __typename?: 'CreateResellerEndClientPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateSageAssistantChat */
export type CreateSageAssistantChatInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  question: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSageAssistantChat. */
export type CreateSageAssistantChatPayload = {
  __typename?: 'CreateSageAssistantChatPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  response?: Maybe<SageAssistantChatResponse>;
};

/** Autogenerated input type of CreateScaleSubscription */
export type CreateScaleSubscriptionInput = {
  autoInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  contractDurationInMonths: Scalars['Int']['input'];
  numberOfSeats: Scalars['Int']['input'];
  paymentSchedule?: InputMaybe<PaymentScheduleEnum>;
  paymentTermsInDays: Scalars['Int']['input'];
  pricePerSeat: MoneyInput;
  signedOn: Scalars['ISO8601Date']['input'];
  startsOn: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of CreateScaleSubscription. */
export type CreateScaleSubscriptionPayload = {
  __typename?: 'CreateScaleSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  scaleSubscription?: Maybe<ScaleSubscription>;
};

/** Autogenerated input type of CreateSeedEngagement */
export type CreateSeedEngagementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  countryCode: Scalars['String']['input'];
  seedEngagementType: SeedEngagementEnum;
};

/** Autogenerated return type of CreateSeedEngagement. */
export type CreateSeedEngagementPayload = {
  __typename?: 'CreateSeedEngagementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateSepaSetupIntent */
export type CreateSepaSetupIntentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateSepaSetupIntent. */
export type CreateSepaSetupIntentPayload = {
  __typename?: 'CreateSepaSetupIntentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  setupIntent?: Maybe<SepaSetupIntent>;
};

/** Autogenerated input type of CreateServiceAgreementChangeAcknowledgement */
export type CreateServiceAgreementChangeAcknowledgementInput = {
  acknowledgerId: Scalars['ID']['input'];
  changeType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveDate: Scalars['ISO8601Date']['input'];
  engagementId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateServiceAgreementChangeAcknowledgement. */
export type CreateServiceAgreementChangeAcknowledgementPayload = {
  __typename?: 'CreateServiceAgreementChangeAcknowledgementPayload';
  acknowledgement?: Maybe<ServiceAgreementChangeAcknowledgement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateTimeSheetEntry */
export type CreateTimeSheetEntryInput = {
  breakIntervalFrom?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
  breakIntervalTo?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['ISO8601Date']['input'];
  from: Scalars['TimeWithoutSecondsAndTz']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  timeSheetId: Scalars['ID']['input'];
  to: Scalars['TimeWithoutSecondsAndTz']['input'];
};

/** Autogenerated return type of CreateTimeSheetEntry. */
export type CreateTimeSheetEntryPayload = {
  __typename?: 'CreateTimeSheetEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeSheetEntry?: Maybe<TimeSheetEntry>;
};

/** Autogenerated input type of CreateTimeSheetMutation */
export type CreateTimeSheetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  timePeriod: Scalars['ISO8601Date']['input'];
  workSchedule: Array<ScheduleDayInput>;
  workScheduleSetAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateTimeSheetMutation. */
export type CreateTimeSheetMutationPayload = {
  __typename?: 'CreateTimeSheetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeSheet?: Maybe<TimeSheet>;
};

/** Autogenerated input type of CreateToolLegalConsent */
export type CreateToolLegalConsentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateToolLegalConsent. */
export type CreateToolLegalConsentPayload = {
  __typename?: 'CreateToolLegalConsentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  legalConsent: WorkforceLegalConsent;
};

/** Autogenerated input type of CreateVariableCompensation */
export type CreateVariableCompensationInput = {
  amountAsPercentage?: InputMaybe<Scalars['Float']['input']>;
  amountSubunit?: InputMaybe<Scalars['MoneyInt']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  compensationType: VariableCompensationTypeEnum;
  /**
   * Provide a label to be used for the variable compensation or commission when the variable compensation label "other"
   * is selected.
   */
  customLabel?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  engagementId: Scalars['ID']['input'];
  guaranteed?: InputMaybe<Scalars['Boolean']['input']>;
  includedInGrossSalary?: InputMaybe<Scalars['Boolean']['input']>;
  label: VariableCompensationLabelEnum;
  paymentFrequency: PaymentFrequencyEnum;
  prorated?: InputMaybe<Scalars['Boolean']['input']>;
  selectedMonths?: InputMaybe<Array<MonthsEnum>>;
  statutory?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CreateVariableCompensation. */
export type CreateVariableCompensationPayload = {
  __typename?: 'CreateVariableCompensationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  variableCompensation?: Maybe<VariableCompensation>;
};

/** Autogenerated input type of CreateVariableCompensationTemplate */
export type CreateVariableCompensationTemplateInput = {
  amount?: InputMaybe<MoneyInput>;
  amountAsPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  compensationType: VariableCompensationTypeEnum;
  employmentTemplateId: Scalars['ID']['input'];
  guaranteed?: InputMaybe<Scalars['Boolean']['input']>;
  label: VariableCompensationLabelEnum;
  paymentFrequency: PaymentFrequencyEnum;
  prorated?: InputMaybe<Scalars['Boolean']['input']>;
  selectedMonths?: InputMaybe<Array<MonthsEnum>>;
};

/** Autogenerated return type of CreateVariableCompensationTemplate. */
export type CreateVariableCompensationTemplatePayload = {
  __typename?: 'CreateVariableCompensationTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  variableCompensationTemplate?: Maybe<VariableCompensationTemplate>;
};

/** Autogenerated input type of CreateWithholdingRequest */
export type CreateWithholdingRequestInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyValuationId?: InputMaybe<Scalars['ID']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  earlyExerciseEvent?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  exerciseDate: Scalars['ISO8601Date']['input'];
  fairMarketValue: Scalars['Float']['input'];
  fairMarketValueCurrencyCode: Scalars['String']['input'];
  grantId: Scalars['ID']['input'];
  shares: Scalars['Float']['input'];
};

/** Autogenerated return type of CreateWithholdingRequest. */
export type CreateWithholdingRequestPayload = {
  __typename?: 'CreateWithholdingRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityWithholdingRequest: EquityWithholdingRequest;
  errors: Array<Scalars['String']['output']>;
};

export enum CreatedByUserEnum {
  Company = 'COMPANY',
  Contractor = 'CONTRACTOR',
  Staff = 'STAFF'
}

export enum CreationOriginEnum {
  Api = 'API',
  Web = 'WEB'
}

export type CreditNote = {
  __typename?: 'CreditNote';
  affectedInvoices?: Maybe<InvoiceCollection>;
  amount: Money;
  authorizations?: Maybe<Authorization>;
  availableAmount: Money;
  client: Company;
  company: Company;
  creditNoteApplications?: Maybe<CreditNoteApplicationCollection>;
  file?: Maybe<DownloadLink>;
  id: Scalars['ID']['output'];
  issueDate: Scalars['ISO8601Date']['output'];
  kind: CreditNoteKind;
  month?: Maybe<Scalars['Int']['output']>;
  referenceCode: Scalars['String']['output'];
  refundStartedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  state: CreditNoteState;
  strongId: Scalars['String']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};


export type CreditNoteAffectedInvoicesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type CreditNoteCreditNoteApplicationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type CreditNoteApplication = {
  __typename?: 'CreditNoteApplication';
  affectedInvoice: Invoice;
  amountUsed: Money;
  appliedBy?: Maybe<Actor>;
  appliedCreditNote: CreditNote;
  authorizations?: Maybe<Authorization>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  strongId: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CreditNoteApplicationCollection = {
  __typename?: 'CreditNoteApplicationCollection';
  collection: Array<CreditNoteApplication>;
  metadata: CollectionMetadata;
};

export type CreditNoteCollection = {
  __typename?: 'CreditNoteCollection';
  collection: Array<CreditNote>;
  metadata: CollectionMetadata;
};

export type CreditNoteItemInput = {
  amount: MoneyInput;
  components?: InputMaybe<Array<ComponentInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  fxOysterRateId?: InputMaybe<Scalars['ID']['input']>;
};

export enum CreditNoteKind {
  ClosingInvoice = 'CLOSING_INVOICE',
  CreditAdjustment = 'CREDIT_ADJUSTMENT',
  DepositRefund = 'DEPOSIT_REFUND',
  Manual = 'MANUAL',
  PreFundingRefund = 'PRE_FUNDING_REFUND'
}

export enum CreditNoteState {
  Applied = 'APPLIED',
  Draft = 'DRAFT',
  Issued = 'ISSUED',
  PartiallyApplied = 'PARTIALLY_APPLIED',
  Processing = 'PROCESSING',
  Refunded = 'REFUNDED',
  RefundFailed = 'REFUND_FAILED',
  Voided = 'VOIDED'
}

export type CreditNotesMonthYear = {
  __typename?: 'CreditNotesMonthYear';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type CreditNotesMonthYearCollection = {
  __typename?: 'CreditNotesMonthYearCollection';
  collection: Array<CreditNotesMonthYear>;
  metadata: CollectionMetadata;
};

export type CreditSum = {
  __typename?: 'CreditSum';
  amount: Money;
  count: Scalars['Int']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subunitToUnit: Scalars['Int']['output'];
};

export type CurrencyConversion = {
  __typename?: 'CurrencyConversion';
  factor: Scalars['Float']['output'];
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export enum CurrencyEnum {
  /** United Arab Emirates Dirham */
  Aed = 'AED',
  /** Afghan Afghani */
  Afn = 'AFN',
  /** Albanian Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Gulden */
  Ang = 'ANG',
  /** Angolan Kwanza */
  Aoa = 'AOA',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijani Manat */
  Azn = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark */
  Bam = 'BAM',
  /** Barbadian Dollar */
  Bbd = 'BBD',
  /** Bangladeshi Taka */
  Bdt = 'BDT',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundian Franc */
  Bif = 'BIF',
  /** Bermudian Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Bolivian Boliviano */
  Bob = 'BOB',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum */
  Btn = 'BTN',
  /** Botswana Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble */
  Byn = 'BYN',
  /** Belarusian Ruble */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** Swiss Franc */
  Chf = 'CHF',
  /** Unidad de Fomento */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Chinese Renminbi Yuan */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Costa Rican Colón */
  Crc = 'CRC',
  /** Cuban Convertible Peso */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verdean Escudo */
  Cve = 'CVE',
  /** Czech Koruna */
  Czk = 'CZK',
  /** Djiboutian Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Eritrean Nakfa */
  Ern = 'ERN',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Fijian Dollar */
  Fjd = 'FJD',
  /** Falkland Pound */
  Fkp = 'FKP',
  /** British Pound */
  Gbp = 'GBP',
  /** Georgian Lari */
  Gel = 'GEL',
  /** Ghanaian Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Gambian Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Guatemalan Quetzal */
  Gtq = 'GTQ',
  /** Guyanese Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Honduran Lempira */
  Hnl = 'HNL',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Haitian Gourde */
  Htg = 'HTG',
  /** Hungarian Forint */
  Huf = 'HUF',
  /** Indonesian Rupiah */
  Idr = 'IDR',
  /** Israeli New Sheqel */
  Ils = 'ILS',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Icelandic Króna */
  Isk = 'ISK',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Japanese Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Kyrgyzstani Som */
  Kgs = 'KGS',
  /** Cambodian Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** South Korean Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Kazakhstani Tenge */
  Kzt = 'KZT',
  /** Lao Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lankan Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Lesotho Loti */
  Lsl = 'LSL',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Macedonian Denar */
  Mkd = 'MKD',
  /** Myanmar Kyat */
  Mmk = 'MMK',
  /** Mongolian Tögrög */
  Mnt = 'MNT',
  /** Macanese Pataca */
  Mop = 'MOP',
  /** Mauritanian Ouguiya */
  Mru = 'MRU',
  /** Mauritian Rupee */
  Mur = 'MUR',
  /** Maldivian Rufiyaa */
  Mvr = 'MVR',
  /** Malawian Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambican Metical */
  Mzn = 'MZN',
  /** Namibian Dollar */
  Nad = 'NAD',
  /** Nigerian Naira */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba */
  Nio = 'NIO',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Omani Rial */
  Omr = 'OMR',
  /** Panamanian Balboa */
  Pab = 'PAB',
  /** Peruvian Sol */
  Pen = 'PEN',
  /** Papua New Guinean Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistani Rupee */
  Pkr = 'PKR',
  /** Polish Złoty */
  Pln = 'PLN',
  /** Paraguayan Guaraní */
  Pyg = 'PYG',
  /** Qatari Riyal */
  Qar = 'QAR',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Rwandan Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychellois Rupee */
  Scr = 'SCR',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Saint Helenian Pound */
  Shp = 'SHP',
  /** Slovak Koruna */
  Skk = 'SKK',
  /** Sierra Leonean Leone */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinamese Dollar */
  Srd = 'SRD',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** São Tomé and Príncipe Dobra */
  Std = 'STD',
  /** Salvadoran Colón */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Swazi Lilangeni */
  Szl = 'SZL',
  /** Thai Baht */
  Thb = 'THB',
  /** Tajikistani Somoni */
  Tjs = 'TJS',
  /** Turkmenistani Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Tongan Paʻanga */
  Top = 'TOP',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd = 'TTD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia */
  Uah = 'UAH',
  /** Ugandan Shilling */
  Ugx = 'UGX',
  /** United States Dollar */
  Usd = 'USD',
  /** Uruguayan Peso */
  Uyu = 'UYU',
  /** Uzbekistan Som */
  Uzs = 'UZS',
  /** Venezuelan Bolívar Soberano */
  Ves = 'VES',
  /** Vietnamese Đồng */
  Vnd = 'VND',
  /** Vanuatu Vatu */
  Vuv = 'VUV',
  /** Samoan Tala */
  Wst = 'WST',
  /** Central African Cfa Franc */
  Xaf = 'XAF',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** West African Cfa Franc */
  Xof = 'XOF',
  /** Yemeni Rial */
  Yer = 'YER',
  /** South African Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha */
  Zmk = 'ZMK',
  /** Zambian Kwacha */
  Zmw = 'ZMW',
  /** Zimbabwean Dollar */
  Zwl = 'ZWL'
}

/** Autogenerated input type of CustomDiscount */
export type CustomDiscountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discountPercentage: Scalars['Float']['input'];
  durationInMonths?: InputMaybe<Scalars['Int']['input']>;
  engagementId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of CustomDiscount. */
export type CustomDiscountPayload = {
  __typename?: 'CustomDiscountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discountOverride?: Maybe<DiscountOverride>;
  errors: Array<Scalars['String']['output']>;
};

export type CustomFormsResponse = {
  __typename?: 'CustomFormsResponse';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  pageResponse: CustomFormsResponsePage;
  pageResponses: Array<CustomFormsResponsePage>;
  schema: CustomFormsSchema;
  state: CustomFormsResponseState;
};


export type CustomFormsResponsePageResponseArgs = {
  pageId?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomFormsResponseAnswerInterface = {
  id: Scalars['ID']['output'];
};

export type CustomFormsResponseBankAccountAnswer = CustomFormsResponseAnswerInterface & {
  __typename?: 'CustomFormsResponseBankAccountAnswer';
  id: Scalars['ID']['output'];
  value: Scalars['Boolean']['output'];
};

export type CustomFormsResponseFileAnswer = CustomFormsResponseAnswerInterface & {
  __typename?: 'CustomFormsResponseFileAnswer';
  id: Scalars['ID']['output'];
  value: CustomFormsResponseFileAnswerValue;
};

export type CustomFormsResponseFileAnswerValue = {
  __typename?: 'CustomFormsResponseFileAnswerValue';
  description?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<DownloadLink>;
  filename: Scalars['String']['output'];
  signedDocumentId: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CustomFormsResponseMultiStringAnswer = CustomFormsResponseAnswerInterface & {
  __typename?: 'CustomFormsResponseMultiStringAnswer';
  id: Scalars['ID']['output'];
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export type CustomFormsResponsePage = {
  __typename?: 'CustomFormsResponsePage';
  answers: Array<CustomFormsResponseAnswerInterface>;
  schema: CustomFormsSchemaPage;
  state: CustomFormsResponseState;
};

export enum CustomFormsResponseState {
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Unstarted = 'UNSTARTED'
}

export type CustomFormsResponseStringAnswer = CustomFormsResponseAnswerInterface & {
  __typename?: 'CustomFormsResponseStringAnswer';
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomFormsSchema = {
  __typename?: 'CustomFormsSchema';
  id: Scalars['ID']['output'];
  page: CustomFormsSchemaPage;
  pages: Array<CustomFormsSchemaPage>;
  totalPagesCount: Scalars['Int']['output'];
};


export type CustomFormsSchemaPageArgs = {
  id: Scalars['ID']['input'];
};

export type CustomFormsSchemaFieldGroup = CustomFormsSchemaFieldInterface & {
  __typename?: 'CustomFormsSchemaFieldGroup';
  assistiveText?: Maybe<Scalars['String']['output']>;
  fields: Array<CustomFormsSchemaFieldInterface>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: CustomFormsSchemaFieldType;
};

export type CustomFormsSchemaFieldInterface = {
  id: Scalars['ID']['output'];
  type: CustomFormsSchemaFieldType;
};

export enum CustomFormsSchemaFieldType {
  BankAccount = 'BANK_ACCOUNT',
  CheckboxGroup = 'CHECKBOX_GROUP',
  Country = 'COUNTRY',
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  FieldGroup = 'FIELD_GROUP',
  File = 'FILE',
  Radio = 'RADIO',
  Text = 'TEXT',
  TextArea = 'TEXT_AREA'
}

export type CustomFormsSchemaInputConfigurationUnion = CustomFormsSchemaInputSingleChoiceConfiguration;

export type CustomFormsSchemaInputField = CustomFormsSchemaFieldInterface & {
  __typename?: 'CustomFormsSchemaInputField';
  assistiveText?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<CustomFormsSchemaInputConfigurationUnion>;
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
  type: CustomFormsSchemaFieldType;
};

export type CustomFormsSchemaInputSingleChoiceConfiguration = {
  __typename?: 'CustomFormsSchemaInputSingleChoiceConfiguration';
  choices: Array<CustomFormsSchemaInputSingleChoiceConfigurationChoice>;
};

export type CustomFormsSchemaInputSingleChoiceConfigurationChoice = {
  __typename?: 'CustomFormsSchemaInputSingleChoiceConfigurationChoice';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type CustomFormsSchemaPage = {
  __typename?: 'CustomFormsSchemaPage';
  fields: Array<CustomFormsSchemaFieldInterface>;
  id: Scalars['ID']['output'];
  pageNumber: Scalars['Int']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CustomReasonMappingInput = {
  key: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export enum CustomerAccountCheckEnumType {
  NotStarted = 'NOT_STARTED',
  Paid = 'PAID',
  PendingPayment = 'PENDING_PAYMENT'
}

export enum CustomerBankAccountMandateStateEnumType {
  Active = 'ACTIVE',
  Initialized = 'INITIALIZED',
  Lodged = 'LODGED',
  Signed = 'SIGNED'
}

export type Dashboard = {
  __typename?: 'Dashboard';
  authorizations?: Maybe<Authorization>;
  widgets: Array<Widget>;
};

export enum DayOfWeekEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** Autogenerated input type of DeactivateAdpWorkforceNowIntegration */
export type DeactivateAdpWorkforceNowIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeactivateAdpWorkforceNowIntegration. */
export type DeactivateAdpWorkforceNowIntegrationPayload = {
  __typename?: 'DeactivateAdpWorkforceNowIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeactivateCustomPrice */
export type DeactivateCustomPriceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  planPriceId: Scalars['String']['input'];
};

/** Autogenerated return type of DeactivateCustomPrice. */
export type DeactivateCustomPricePayload = {
  __typename?: 'DeactivateCustomPricePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  planPrice?: Maybe<PlanPrice>;
};

/** Autogenerated input type of DeactivateDirectDebitEnforcement */
export type DeactivateDirectDebitEnforcementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  untilWhen?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of DeactivateDirectDebitEnforcement. */
export type DeactivateDirectDebitEnforcementPayload = {
  __typename?: 'DeactivateDirectDebitEnforcementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeactivateDiscount */
export type DeactivateDiscountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  discountId: Scalars['String']['input'];
};

/** Autogenerated input type of DeactivateDiscountOverride */
export type DeactivateDiscountOverrideInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discountOverrideId: Scalars['String']['input'];
};

/** Autogenerated return type of DeactivateDiscountOverride. */
export type DeactivateDiscountOverridePayload = {
  __typename?: 'DeactivateDiscountOverridePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discountOverride?: Maybe<DiscountOverride>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of DeactivateDiscount. */
export type DeactivateDiscountPayload = {
  __typename?: 'DeactivateDiscountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discountActivation?: Maybe<DiscountActivation>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeactivateDiscountRedemption */
export type DeactivateDiscountRedemptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discountRedemptionId: Scalars['String']['input'];
};

/** Autogenerated return type of DeactivateDiscountRedemption. */
export type DeactivateDiscountRedemptionPayload = {
  __typename?: 'DeactivateDiscountRedemptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discountRedemption?: Maybe<DiscountRedemption>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeactivateScaleSubscription */
export type DeactivateScaleSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  scaleSubscriptionId: Scalars['String']['input'];
};

/** Autogenerated return type of DeactivateScaleSubscription. */
export type DeactivateScaleSubscriptionPayload = {
  __typename?: 'DeactivateScaleSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deactivatedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  errors: Array<Scalars['String']['output']>;
  scaleSubscription: ScaleSubscription;
};

/** Autogenerated input type of DeactivateTrinetIntegration */
export type DeactivateTrinetIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeactivateTrinetIntegration. */
export type DeactivateTrinetIntegrationPayload = {
  __typename?: 'DeactivateTrinetIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type DeactivatedDirectDebitEnforcement = {
  __typename?: 'DeactivatedDirectDebitEnforcement';
  authorizations?: Maybe<Authorization>;
  effective: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  untilWhen?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type DecisionTrees = {
  __typename?: 'DecisionTrees';
  levels: Array<DecisionTreesLevel>;
  root: DecisionTreesNode;
};


export type DecisionTreesRootArgs = {
  skipDiscardedLevels?: InputMaybe<Scalars['Int']['input']>;
};

export enum DecisionTreesBindingState {
  Bound = 'BOUND',
  Discarded = 'DISCARDED',
  Failed = 'FAILED',
  Free = 'FREE'
}

export type DecisionTreesLevel = {
  __typename?: 'DecisionTreesLevel';
  humanizedValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Favor this field over 'id' when displaying to the end user. */
  label: Scalars['String']['output'];
  state: DecisionTreesLevelQueryState;
  value?: Maybe<Scalars['DecisionTreesJSON']['output']>;
};

export type DecisionTreesLevelInput = {
  id: Scalars['String']['input'];
  value?: InputMaybe<Scalars['DecisionTreesJSON']['input']>;
};

export enum DecisionTreesLevelQueryState {
  Bound = 'BOUND',
  Failed = 'FAILED',
  Free = 'FREE'
}

export enum DecisionTreesName {
  BenefitsPackages = 'BENEFITS_PACKAGES',
  BenefitsStatutory = 'BENEFITS_STATUTORY',
  BonusAndAllowances = 'BONUS_AND_ALLOWANCES',
  ProbationPeriod = 'PROBATION_PERIOD',
  RemoteWorkReimbursement = 'REMOTE_WORK_REIMBURSEMENT',
  ResignationNotice = 'RESIGNATION_NOTICE',
  SickPay = 'SICK_PAY',
  TerminationNotice = 'TERMINATION_NOTICE',
  TimeOff = 'TIME_OFF',
  VatRules = 'VAT_RULES',
  WorkingHour = 'WORKING_HOUR'
}

export type DecisionTreesNode = {
  __typename?: 'DecisionTreesNode';
  attributes: DecisionTreesNodeAttributes;
  children: Array<DecisionTreesNode>;
  name: Scalars['String']['output'];
};

export type DecisionTreesNodeAttributes = {
  __typename?: 'DecisionTreesNodeAttributes';
  humanizedValue?: Maybe<Scalars['String']['output']>;
  levelId?: Maybe<Scalars['String']['output']>;
  state: DecisionTreesBindingState;
  value?: Maybe<Scalars['DecisionTreesJSON']['output']>;
};

/** Autogenerated input type of DeleteAccountingIntegration */
export type DeleteAccountingIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Oyster company identifier (only company admins or staff) */
  companyId: Scalars['ID']['input'];
  /** Codat platform key reference (e.g. quickbooksonline) */
  platform: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteAccountingIntegration. */
export type DeleteAccountingIntegrationPayload = {
  __typename?: 'DeleteAccountingIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The time when integration was deleted */
  deletedAt: Scalars['String']['output'];
  /** The identifier of a user deleted the integration */
  deletedBy: Scalars['Int']['output'];
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteCobranding */
export type DeleteCobrandingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCobranding. */
export type DeleteCobrandingPayload = {
  __typename?: 'DeleteCobrandingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteCustomTimeOffMappings */
export type DeleteCustomTimeOffMappingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customSubtypeIds: Array<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCustomTimeOffMappings. */
export type DeleteCustomTimeOffMappingsPayload = {
  __typename?: 'DeleteCustomTimeOffMappingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteExpensesIntegration */
export type DeleteExpensesIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Oyster company identifier (only company admins or staff) */
  companyId: Scalars['ID']['input'];
  /** integration key reference (e.g. expensify) */
  platform: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteExpensesIntegration. */
export type DeleteExpensesIntegrationPayload = {
  __typename?: 'DeleteExpensesIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The time when integration was deleted */
  deletedAt: Scalars['String']['output'];
  /** The identifier of a user deleted the integration */
  deletedBy: User;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteFXMarkupAdjustment */
export type DeleteFxMarkupAdjustmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFXMarkupAdjustment. */
export type DeleteFxMarkupAdjustmentPayload = {
  __typename?: 'DeleteFXMarkupAdjustmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteMergeIntegration */
export type DeleteMergeIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  integrationType: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteMergeIntegration. */
export type DeleteMergeIntegrationPayload = {
  __typename?: 'DeleteMergeIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeletePaymentsGroup */
export type DeletePaymentsGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentsGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePaymentsGroup. */
export type DeletePaymentsGroupPayload = {
  __typename?: 'DeletePaymentsGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentsGroup: PaymentsGroup;
};

export type Department = {
  __typename?: 'Department';
  authorizations?: Maybe<Authorization>;
  creator?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  engagementsCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  syncedFields?: Maybe<Array<Scalars['String']['output']>>;
  teamMembers: Array<User>;
};

/** Autogenerated input type of DepartmentCreate */
export type DepartmentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of DepartmentCreate. */
export type DepartmentCreatePayload = {
  __typename?: 'DepartmentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  department?: Maybe<Department>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DepartmentDestroy */
export type DepartmentDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of DepartmentDestroy. */
export type DepartmentDestroyPayload = {
  __typename?: 'DepartmentDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DepartmentUpdate */
export type DepartmentUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  departmentId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DepartmentUpdate. */
export type DepartmentUpdatePayload = {
  __typename?: 'DepartmentUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  department: Department;
  errors: Array<Scalars['String']['output']>;
};

export type Dependent = {
  __typename?: 'Dependent';
  authorizations?: Maybe<Authorization>;
  engagement: Engagement;
  fieldsWithValues: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
};

export type DependentCollection = {
  __typename?: 'DependentCollection';
  collection: Array<Dependent>;
  metadata: CollectionMetadata;
};

export enum DepositRefundStatusEnumType {
  Completed = 'COMPLETED',
  InReview = 'IN_REVIEW',
  NotStarted = 'NOT_STARTED'
}

/** Autogenerated input type of DestroyAddress */
export type DestroyAddressInput = {
  addressId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DestroyAddress. */
export type DestroyAddressPayload = {
  __typename?: 'DestroyAddressPayload';
  addressSubject: AddressSubject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyComplianceCheckerSetupAndData */
export type DestroyComplianceCheckerSetupAndDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyComplianceCheckerSetupAndData. */
export type DestroyComplianceCheckerSetupAndDataPayload = {
  __typename?: 'DestroyComplianceCheckerSetupAndDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyContract */
export type DestroyContractInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyContract. */
export type DestroyContractPayload = {
  __typename?: 'DestroyContractPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyContractorInvoice */
export type DestroyContractorInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyContractorInvoice. */
export type DestroyContractorInvoicePayload = {
  __typename?: 'DestroyContractorInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyCostCenter */
export type DestroyCostCenterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  costCenterId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyCostCenter. */
export type DestroyCostCenterPayload = {
  __typename?: 'DestroyCostCenterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyCreditNote */
export type DestroyCreditNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  creditNoteId: Scalars['String']['input'];
};

/** Autogenerated return type of DestroyCreditNote. */
export type DestroyCreditNotePayload = {
  __typename?: 'DestroyCreditNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyDependent */
export type DestroyDependentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dependentId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyDependent. */
export type DestroyDependentPayload = {
  __typename?: 'DestroyDependentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement: Engagement;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyDocument */
export type DestroyDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['String']['input'];
};

/** Autogenerated return type of DestroyDocument. */
export type DestroyDocumentPayload = {
  __typename?: 'DestroyDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyEmployerOfRecord */
export type DestroyEmployerOfRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyEmployerOfRecord. */
export type DestroyEmployerOfRecordPayload = {
  __typename?: 'DestroyEmployerOfRecordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyEmployment */
export type DestroyEmploymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyEmployment. */
export type DestroyEmploymentPayload = {
  __typename?: 'DestroyEmploymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyEmploymentTemplate */
export type DestroyEmploymentTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyEmploymentTemplate. */
export type DestroyEmploymentTemplatePayload = {
  __typename?: 'DestroyEmploymentTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyEquityWithholdingRequest */
export type DestroyEquityWithholdingRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equityWithholdingRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyEquityWithholdingRequest. */
export type DestroyEquityWithholdingRequestPayload = {
  __typename?: 'DestroyEquityWithholdingRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityWithholdingRequest?: Maybe<EquityWithholdingRequest>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyExpense */
export type DestroyExpenseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expenseId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyExpense. */
export type DestroyExpensePayload = {
  __typename?: 'DestroyExpensePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyExternalPointOfContact */
export type DestroyExternalPointOfContactInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  externalPointOfContactId: Scalars['String']['input'];
};

/** Autogenerated return type of DestroyExternalPointOfContact. */
export type DestroyExternalPointOfContactPayload = {
  __typename?: 'DestroyExternalPointOfContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  externalPointsOfContact?: Maybe<Array<ExternalPointOfContact>>;
};

/** Autogenerated input type of DestroyGrant */
export type DestroyGrantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equityGrantId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyGrant. */
export type DestroyGrantPayload = {
  __typename?: 'DestroyGrantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityGrant: EquityGrant;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyIntegrationHire */
export type DestroyIntegrationHireInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hireId: Scalars['String']['input'];
};

/** Autogenerated return type of DestroyIntegrationHire. */
export type DestroyIntegrationHirePayload = {
  __typename?: 'DestroyIntegrationHirePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyInvoice */
export type DestroyInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
};

/** Autogenerated return type of DestroyInvoice. */
export type DestroyInvoicePayload = {
  __typename?: 'DestroyInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyOauthApplication */
export type DestroyOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  oauthApplicationId: Scalars['String']['input'];
};

/** Autogenerated return type of DestroyOauthApplication. */
export type DestroyOauthApplicationPayload = {
  __typename?: 'DestroyOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyOysterAdminProfile */
export type DestroyOysterAdminProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of DestroyOysterAdminProfile. */
export type DestroyOysterAdminProfilePayload = {
  __typename?: 'DestroyOysterAdminProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of DestroyPaySupplement */
export type DestroyPaySupplementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paySupplementId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyPaySupplement. */
export type DestroyPaySupplementPayload = {
  __typename?: 'DestroyPaySupplementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyPaymentMethod */
export type DestroyPaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyPaymentMethod. */
export type DestroyPaymentMethodPayload = {
  __typename?: 'DestroyPaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod: PaymentMethod;
};

/** Autogenerated input type of DestroyPayrollCycleDocuments */
export type DestroyPayrollCycleDocumentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  payrollCycleDocumentIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of DestroyPayrollCycleDocuments. */
export type DestroyPayrollCycleDocumentsPayload = {
  __typename?: 'DestroyPayrollCycleDocumentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  payrollCycleDocuments: Array<PayrollCycleDocument>;
};

/** Autogenerated input type of DestroyReimbursementBudget */
export type DestroyReimbursementBudgetInput = {
  changeReason: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reimbursementBudgetId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyReimbursementBudget. */
export type DestroyReimbursementBudgetPayload = {
  __typename?: 'DestroyReimbursementBudgetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  reimbursementBudget?: Maybe<ReimbursementBudget>;
};

/** Autogenerated input type of DestroyTimeSheetEntry */
export type DestroyTimeSheetEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  timeSheetEntryId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyTimeSheetEntry. */
export type DestroyTimeSheetEntryPayload = {
  __typename?: 'DestroyTimeSheetEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyTimeSheetMutation */
export type DestroyTimeSheetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  timeSheetId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyTimeSheetMutation. */
export type DestroyTimeSheetMutationPayload = {
  __typename?: 'DestroyTimeSheetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyVariableCompensationTemplate */
export type DestroyVariableCompensationTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyVariableCompensationTemplate. */
export type DestroyVariableCompensationTemplatePayload = {
  __typename?: 'DestroyVariableCompensationTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type DirectDebitConstraint = {
  __typename?: 'DirectDebitConstraint';
  authorizations?: Maybe<Authorization>;
  blocked: Scalars['Boolean']['output'];
  blockedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  blockedBy?: Maybe<User>;
  /** History of changes in chronological descending order */
  changesetHistory?: Maybe<Array<HistoricEvent>>;
  reason?: Maybe<Scalars['String']['output']>;
};

export enum DirectManagerPermissionEnumType {
  ApproveExpenses = 'APPROVE_EXPENSES',
  ApproveTimeOffs = 'APPROVE_TIME_OFFS'
}

/** Autogenerated input type of DisableAccountingContractorVendorCreation */
export type DisableAccountingContractorVendorCreationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of DisableAccountingContractorVendorCreation. */
export type DisableAccountingContractorVendorCreationPayload = {
  __typename?: 'DisableAccountingContractorVendorCreationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
  feature: CompanyAvailableFeatures;
};

/** Autogenerated input type of DisableAccountingTrackingCategories */
export type DisableAccountingTrackingCategoriesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of DisableAccountingTrackingCategories. */
export type DisableAccountingTrackingCategoriesPayload = {
  __typename?: 'DisableAccountingTrackingCategoriesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
  feature: CompanyAvailableFeatures;
};

/** Autogenerated input type of DisableAgreement */
export type DisableAgreementInput = {
  agreementType: AgreementTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiringId: Scalars['ID']['input'];
};

/** Autogenerated return type of DisableAgreement. */
export type DisableAgreementPayload = {
  __typename?: 'DisableAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of DisableESign */
export type DisableESignInput = {
  agreementId: Scalars['ID']['input'];
  agreementType: AgreementTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DisableESignOsa */
export type DisableESignOsaInput = {
  approverId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiringId: Scalars['ID']['input'];
  notes: Scalars['String']['input'];
};

/** Autogenerated return type of DisableESignOsa. */
export type DisableESignOsaPayload = {
  __typename?: 'DisableESignOsaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated return type of DisableESign. */
export type DisableESignPayload = {
  __typename?: 'DisableESignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  owner: Owner;
};

/** Autogenerated input type of DisableFeature */
export type DisableFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  feature: CompanyAvailableFeatures;
};

/** Autogenerated return type of DisableFeature. */
export type DisableFeaturePayload = {
  __typename?: 'DisableFeaturePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
  feature: CompanyAvailableFeatures;
};

/** Autogenerated input type of DisableOffboardingESign */
export type DisableOffboardingESignInput = {
  agreementId: Scalars['ID']['input'];
  approverId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes: Scalars['String']['input'];
};

/** Autogenerated return type of DisableOffboardingESign. */
export type DisableOffboardingESignPayload = {
  __typename?: 'DisableOffboardingESignPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  owner: Owner;
};

export type Discount = {
  __typename?: 'Discount';
  authorizations?: Maybe<Authorization>;
  availableFrom: Scalars['ISO8601DateTime']['output'];
  availableUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  discountPercentage: Scalars['Int']['output'];
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  maximumNumberOfRedemptions?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type DiscountActivation = {
  __typename?: 'DiscountActivation';
  activatedAt: Scalars['ISO8601DateTime']['output'];
  authorizations?: Maybe<Authorization>;
  deactivatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  discount: Discount;
};

export type DiscountCollection = {
  __typename?: 'DiscountCollection';
  collection: Array<Discount>;
  metadata: CollectionMetadata;
};

export type DiscountOverride = {
  __typename?: 'DiscountOverride';
  authorizations?: Maybe<Authorization>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discountPercentage: Scalars['Float']['output'];
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  overriddenBy?: Maybe<User>;
  startsOn: Scalars['ISO8601Date']['output'];
  status: DiscountStatus;
};

export type DiscountOverrideCollection = {
  __typename?: 'DiscountOverrideCollection';
  collection: Array<DiscountOverride>;
  metadata: CollectionMetadata;
};

export type DiscountRedemption = {
  __typename?: 'DiscountRedemption';
  authorizations?: Maybe<Authorization>;
  deactivatedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  discount: Discount;
  discountPercentage: Scalars['Float']['output'];
  expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  startsOn: Scalars['ISO8601Date']['output'];
  status: DiscountStatus;
};

export type DiscountRedemptionCollection = {
  __typename?: 'DiscountRedemptionCollection';
  collection: Array<DiscountRedemption>;
  metadata: CollectionMetadata;
};

export enum DiscountStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type Document = {
  __typename?: 'Document';
  authorizations?: Maybe<Authorization>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  tags: Array<Scalars['String']['output']>;
  termination?: Maybe<Termination>;
  title: Scalars['String']['output'];
};

export type DocumentCollection = {
  __typename?: 'DocumentCollection';
  collection: Array<Document>;
  metadata: CollectionMetadata;
};

export type DocumentInput = {
  description: Scalars['String']['input'];
  signedDocumentId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export enum DocumentStateEnum {
  Failed = 'FAILED',
  Generated = 'GENERATED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type DocumentTemplate = {
  __typename?: 'DocumentTemplate';
  clmTemplateId: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  documentType: AgreementTypeEnum;
  eSignEnabled?: Maybe<Scalars['Boolean']['output']>;
  eSignType?: Maybe<AgreementESignTypeEnum>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type DocumentTemplateCollection = {
  __typename?: 'DocumentTemplateCollection';
  collection: Array<DocumentTemplate>;
  metadata: CollectionMetadata;
};

export type DownloadLink = {
  __typename?: 'DownloadLink';
  base64?: Maybe<Scalars['String']['output']>;
  byteSize: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  documentId?: Maybe<Scalars['ID']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DraftCreditNote */
export type DraftCreditNoteInput = {
  amount: MoneyInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  items: Array<CreditNoteItemInput>;
  kind: CreditNoteKind;
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DraftCreditNote. */
export type DraftCreditNotePayload = {
  __typename?: 'DraftCreditNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditNote?: Maybe<CreditNote>;
  errors: Array<Scalars['String']['output']>;
};

export enum ESignStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Partial = 'PARTIAL'
}

/** Autogenerated input type of EditCompanySubscription */
export type EditCompanySubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  numberOfSeats: Scalars['Int']['input'];
  pricePerSeat?: InputMaybe<MoneyInput>;
};

/** Autogenerated return type of EditCompanySubscription. */
export type EditCompanySubscriptionPayload = {
  __typename?: 'EditCompanySubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of EditCreditNote */
export type EditCreditNoteInput = {
  amount: Scalars['Float']['input'];
  amountCurrencyCode: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  creditNoteId: Scalars['ID']['input'];
  itemDescription: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EditCreditNote. */
export type EditCreditNotePayload = {
  __typename?: 'EditCreditNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditNote?: Maybe<CreditNote>;
  errors: Array<Scalars['String']['output']>;
};

export enum EligibilityCheckStatus {
  Failed = 'FAILED',
  Success = 'SUCCESS',
  Unstarted = 'UNSTARTED'
}

export enum EmployeeStatusTransitionEnum {
  ApproveDocumentsReview = 'APPROVE_DOCUMENTS_REVIEW',
  Complete = 'COMPLETE',
  CompleteOnboarding = 'COMPLETE_ONBOARDING',
  GoBack = 'GO_BACK',
  SendDocumentsForReview = 'SEND_DOCUMENTS_FOR_REVIEW',
  SendDocumentsForSignature = 'SEND_DOCUMENTS_FOR_SIGNATURE'
}

export type EmployerBenefitEnrollmentInput = {
  plan?: InputMaybe<Scalars['String']['input']>;
};

export type EmployerCommissionPlanInput = {
  commissionPlanSignedId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of EmployerCreateHire */
export type EmployerCreateHireInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  employmentAttributes?: InputMaybe<EmployerEmploymentInput>;
  employmentTemplateId?: InputMaybe<Scalars['ID']['input']>;
  monetizationAttributes?: InputMaybe<MonetizationInput>;
  /** Oyster score to build an Oyster Employment Template with. */
  oysterScore?: InputMaybe<CountryIntelligenceOysterScore>;
  personalInfoAttributes?: InputMaybe<EmployerEmploymentsPersonalInfoAttributesInput>;
  visaAttributes?: InputMaybe<EmployerEmploymentVisaInput>;
};

/** Autogenerated return type of EmployerCreateHire. */
export type EmployerCreateHirePayload = {
  __typename?: 'EmployerCreateHirePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<FormFieldError>>;
  subscription?: Maybe<Subscription>;
};

export type EmployerEmploymentInput = {
  benefitsDescription?: InputMaybe<Scalars['String']['input']>;
  commissionPlanOffered?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dailyResponsibility?: InputMaybe<Scalars['String']['input']>;
  decisionMakingAuthority?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  employmentComplianceCheck?: InputMaybe<Scalars['Boolean']['input']>;
  employmentComplianceDetails?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  equityOffered?: InputMaybe<Scalars['Boolean']['input']>;
  fullTimeHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  initialStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  managerEmailAddress?: InputMaybe<Scalars['String']['input']>;
  managerIsExpenseApprover?: InputMaybe<Scalars['Boolean']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  managerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  managerRole?: InputMaybe<Scalars['String']['input']>;
  mergeId?: InputMaybe<Scalars['String']['input']>;
  minimumQualification?: InputMaybe<Scalars['String']['input']>;
  newHireStatus?: InputMaybe<EngagementNewHireStatusType>;
  paidHolidayDays?: InputMaybe<Scalars['Float']['input']>;
  partTimeDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Format like 6.4 hours represents 6h and 24m.
   * For example, 5 days with 6.4h per day is equivalent to 32h per week.
   * Maximum input value is 24 hours. Maximum number of digits after the decimal point is 1.
   */
  partTimeHoursPerDay?: InputMaybe<Scalars['Float']['input']>;
  primaryDuty?: InputMaybe<Scalars['String']['input']>;
  privateNotes?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Duplicates startDate and probationPeriod */
  probationEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  probationPeriod?: InputMaybe<Scalars['Iso8601Duration']['input']>;
  /** @deprecated Use probationPeriod for ISO 8601 compliance */
  probationPeriodType?: InputMaybe<EngagementProbationPeriodType>;
  /** @deprecated Use probationPeriod for ISO 8601 compliance */
  probationPeriodValue?: InputMaybe<Scalars['Int']['input']>;
  providedEquipmentList?: InputMaybe<Array<EquipmentListEnum>>;
  providedEquipmentOther?: InputMaybe<Scalars['String']['input']>;
  providedEquipmentPolicy?: InputMaybe<EquipmentPolicyEnum>;
  providedEquipmentPolicyBudgetAmount?: InputMaybe<Scalars['MoneyInt']['input']>;
  reimbursementPolicy?: InputMaybe<ReimbursementPolicyInput>;
  remoteWorkCosts?: InputMaybe<EngagementRemoteWorkCostInputType>;
  role?: InputMaybe<Scalars['String']['input']>;
  roleTypeId?: InputMaybe<Scalars['ID']['input']>;
  salaryAmount?: InputMaybe<Scalars['Float']['input']>;
  salaryCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  seniorityLevel?: InputMaybe<EngagementSeniorityLevelType>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
  /** True if the Team Member's day-to-day work is focused on providing or supporting services within the country of residence. */
  workFocusedWithinCountryOfResidence?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployerEmploymentVisaInput = {
  documentSignedUrl?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployerEmploymentsPersonalInfoAttributesInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fullLegalName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<CountryIsoCode>;
};

export type EmployerIntegrationMetadata = {
  integrationHireId: Scalars['String']['input'];
};

export type EmployerOfRecord = {
  __typename?: 'EmployerOfRecord';
  authorizations?: Maybe<Authorization>;
  /** Number of colleagues that are engaged with this vendor */
  colleaguesEngagedCount: Scalars['Int']['output'];
  company?: Maybe<Company>;
  /** The vendor email of contact */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Contact name of the vendor */
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The cut-off day in the month */
  cutOffMonthDay: Scalars['Int']['output'];
  /** Tells if the cut-off day is set. Needed because cutOffMonthDay is a non-null Integer */
  cutOffMonthDayIsSet: Scalars['Boolean']['output'];
  /** Other details for this vendor */
  details?: Maybe<EmployerOfRecordDetail>;
  /** The country it operates. This will replace `countries` */
  employerOfRecordCountry?: Maybe<EmployerOfRecordCountry>;
  /**
   * Indicates the type of Employer of Record:
   * - direct => Payroll Provider
   * - indirect => Employer of Record
   * - payroll => Global Payroll
   */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Integration Tools set up for this vendor */
  externalTools?: Maybe<ExternalToolCollection>;
  /** The vendor finance related email */
  financeEmail?: Maybe<Scalars['String']['output']>;
  /** Composite ID of the vendor */
  id: Scalars['ID']['output'];
  /** Protects from deletion if false */
  isDeletable: Scalars['Boolean']['output'];
  /** Details for Direct EOR from Klea legal software */
  kleaSubsidiary?: Maybe<EmployerOfRecordKleaSubsidiary>;
  monthlyFee?: Maybe<MonthlyFee>;
  /** Name of the vendor */
  name: Scalars['String']['output'];
  /** Some notes about the vendor */
  notes?: Maybe<Scalars['String']['output']>;
  /** Type of payroll cycle in case of payroll entity if it is 'monthly' or 'semi_monthly' */
  payrollCycleType?: Maybe<GlobalPayrollPayrollCycleTypeEnum>;
  /** Position in the operated country */
  position?: Maybe<Scalars['Int']['output']>;
};


export type EmployerOfRecordExternalToolsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployerOfRecordCollection = {
  __typename?: 'EmployerOfRecordCollection';
  collection: Array<EmployerOfRecord>;
  metadata: CollectionMetadata;
};

export type EmployerOfRecordCountry = {
  __typename?: 'EmployerOfRecordCountry';
  /** The country ISO3166 */
  alpha2: Scalars['String']['output'];
  authorizations?: Maybe<Authorization>;
  /** How long does a "average case" hire take? */
  averageTimeToHire?: Maybe<Scalars['String']['output']>;
  /** Status, details and source */
  concurrentHireDescription?: Maybe<Scalars['String']['output']>;
  /** The number of engagements in this country */
  engagementsCount: Scalars['Int']['output'];
  /** Hiring confidence in this country, can be Low, Medium or High */
  hiringConfidence: EorCountryHiringConfidenceEnumType;
  /** The strong ID of this vendor */
  id: Scalars['ID']['output'];
  /** Key "need to knows" about employing in this country and what can cause delays */
  needToKnows?: Maybe<Scalars['String']['output']>;
  /** Describe if any vendor is ready to hire in this country */
  readyToHire: EorCountryReadyToHireEnum;
  /** List of vendors in this country */
  vendors: Array<EmployerOfRecord>;
};

export type EmployerOfRecordCountryCollection = {
  __typename?: 'EmployerOfRecordCountryCollection';
  collection: Array<EmployerOfRecordCountry>;
  metadata: CollectionMetadata;
};

export type EmployerOfRecordDetail = {
  __typename?: 'EmployerOfRecordDetail';
  authorizations?: Maybe<Authorization>;
  /** List of emails for company contact. Not used for daily operation. */
  companyContactEmails: Array<Scalars['String']['output']>;
  /** Notes on company contact emails */
  companyContactNotes?: Maybe<Scalars['String']['output']>;
  /** List of emails for daily operations */
  contactEmails: Array<Scalars['String']['output']>;
  /** Notes on daily operation emails */
  contactNotes: Scalars['String']['output'];
  /** Any information on deposit */
  deposit?: Maybe<Scalars['String']['output']>;
  documentsForVisa?: Maybe<Scalars['String']['output']>;
  /** A link to the employment agreement document */
  employmentAgreementLink?: Maybe<Scalars['String']['output']>;
  /** Notes on employment agreement */
  employmentAgreementNotes?: Maybe<Scalars['String']['output']>;
  /** The type of entity: Own entity/Sub-contractor/Not known */
  entityType?: Maybe<EmployerOfRecordEntityTypeEnum>;
  /** Free text indicating the fee for advancing funds */
  eorAdvancingFundsFee?: Maybe<Scalars['String']['output']>;
  /** List of emails for escalation */
  escalationEmails: Array<Scalars['String']['output']>;
  /** Escalation notes instructions */
  escalationNotes?: Maybe<Scalars['String']['output']>;
  /** List of emails for expenses/payroll notifications */
  expensesAndPayrollNotificationsEmails: Array<Scalars['String']['output']>;
  /** Notes about expenses/payroll notifications */
  expensesAndPayrollNotificationsNotes?: Maybe<Scalars['String']['output']>;
  /** Expenses process (Oyster or own?) */
  expensesProcessLink?: Maybe<Scalars['String']['output']>;
  /** Notes on expenses process */
  expensesProcessNotes?: Maybe<Scalars['String']['output']>;
  /** Extra fee */
  extraFee?: Maybe<Scalars['String']['output']>;
  /** List of emails for general enquiries */
  generalEnquiriesEmails: Array<Scalars['String']['output']>;
  /** Notes on general enquiries emails */
  generalEnquiriesNotes?: Maybe<Scalars['String']['output']>;
  /** List of emails for generic finance, used in daily operation */
  genericFinanceQuestionEmails: Array<Scalars['String']['output']>;
  /** Notes on generic finance */
  genericFinanceQuestionNotes?: Maybe<Scalars['String']['output']>;
  /** The currency used for global payroll invoicing */
  globalPayrollInvoicingCurrency?: Maybe<EmployerOfRecordGlobalPayrollInvoicingCurrencyEnum>;
  /** Free text to indicate the leaver fee */
  leaverFee?: Maybe<Scalars['String']['output']>;
  /** The legal address of the employer of record */
  legalAddress?: Maybe<Scalars['String']['output']>;
  /** The legal name of the employer of record */
  legalName?: Maybe<Scalars['String']['output']>;
  /** An indicator summarizing if its status */
  liveIndicator: EmployerOfRecordLiveIndicatorEnum;
  /**
   * The live status of the EOR, can be:
   *   * Yes - Experienced
   *   * Yes - Experienced (sub-contractor) - HIRING ONLY AFTER APPROVAL
   *   * Yes - New country request
   *   * Yes - New country request (sub-contractor) - HIRING ONLY AFTER APPROVAL
   *   * No
   *   * Launch in Progress
   */
  liveStatus?: Maybe<EmployerOfRecordLiveStatusEnum>;
  /** Free text to indicate monthly fee */
  monthlyFee?: Maybe<Scalars['String']['output']>;
  /** List of emails to send for new hires onboarding */
  newHiresOnboardingEmails: Array<Scalars['String']['output']>;
  /** Notes on new hires onboarding */
  newHiresOnboardingNotes?: Maybe<Scalars['String']['output']>;
  /** Free text to indicate the new starter fee */
  newStarterFee?: Maybe<Scalars['String']['output']>;
  /** Free text to indicate off cycle payment fee */
  offCyclePaymentFee?: Maybe<Scalars['String']['output']>;
  /** A link to the document for onboarding process */
  onboardingProcessLink?: Maybe<Scalars['String']['output']>;
  /** Notes about onboarding process */
  onboardingProcessNotes?: Maybe<Scalars['String']['output']>;
  /** A link to the document for oyster benefits */
  oysterBenefitsLink?: Maybe<Scalars['String']['output']>;
  /** Notes about oyster benefits */
  oysterBenefitsNotes?: Maybe<Scalars['String']['output']>;
  payrollSpecialistRecipients: Array<Scalars['String']['output']>;
  payrollSpecialistRecipientsNotes?: Maybe<Scalars['String']['output']>;
  /** Who is liable for pension payment */
  pensionPayment?: Maybe<EmployerOfRecordLiablePartyEnum>;
  /** List of emails for any quote request */
  quoteRequestEmails: Array<Scalars['String']['output']>;
  /** Notes on quote request */
  quoteRequestNotes?: Maybe<Scalars['String']['output']>;
  /** Contact emails for daily operations */
  supportEmails: Array<Scalars['String']['output']>;
  /** Notes on support emails */
  supportNotes?: Maybe<Scalars['String']['output']>;
  /** Who is liable for taxes statutory payment */
  taxesStatutoryPayment?: Maybe<EmployerOfRecordLiablePartyEnum>;
  /** List of emails to send time-off monthly reports to */
  timeOffMonthlyReportEmails: Array<Scalars['String']['output']>;
  /** Notes on time-off monthly reports */
  timeOffMonthlyReportNotes?: Maybe<Scalars['String']['output']>;
  /** List of emails to send time-off notifications to */
  timeOffNotificationsEmails: Array<Scalars['String']['output']>;
  /** Notes on time-off notifications */
  timeOffNotificationsNotes?: Maybe<Scalars['String']['output']>;
  /** A link to the document for time off process */
  timeOffProcessLink?: Maybe<Scalars['String']['output']>;
  /** Notes on time off process */
  timeOffProcessNotes?: Maybe<Scalars['String']['output']>;
  /** Who is liable for salary payment */
  tmSalaryPayment?: Maybe<EmployerOfRecordLiablePartyEnum>;
  /**
   * If the vendor offers visa support, values can be:
   * * Yes
   * * No
   * * Maybe (check notes)
   */
  visaSupport?: Maybe<EmployerOfRecordVisaSupportEnum>;
  /** Notes on visa support */
  visaSupportDetails?: Maybe<Scalars['String']['output']>;
  visaWorkPermitProcessLink?: Maybe<Scalars['String']['output']>;
  visaWorkPermitProcessNotes?: Maybe<Scalars['String']['output']>;
};

export type EmployerOfRecordDetailsAttributesInput = {
  companyContactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  companyContactNotes?: InputMaybe<Scalars['String']['input']>;
  contactEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  contactNotes?: InputMaybe<Scalars['String']['input']>;
  deposit?: InputMaybe<Scalars['String']['input']>;
  documentsForVisa?: InputMaybe<Scalars['String']['input']>;
  employmentAgreementLink?: InputMaybe<Scalars['String']['input']>;
  employmentAgreementNotes?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EmployerOfRecordEntityTypeEnum>;
  eorAdvancingFundsFee?: InputMaybe<Scalars['String']['input']>;
  escalationEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  escalationNotes?: InputMaybe<Scalars['String']['input']>;
  expensesAndPayrollNotificationsEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  expensesAndPayrollNotificationsNotes?: InputMaybe<Scalars['String']['input']>;
  expensesProcessLink?: InputMaybe<Scalars['String']['input']>;
  expensesProcessNotes?: InputMaybe<Scalars['String']['input']>;
  extraFee?: InputMaybe<Scalars['String']['input']>;
  generalEnquiriesEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  generalEnquiriesNotes?: InputMaybe<Scalars['String']['input']>;
  genericFinanceQuestionEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  genericFinanceQuestionNotes?: InputMaybe<Scalars['String']['input']>;
  globalPayrollInvoicingCurrency?: InputMaybe<EmployerOfRecordGlobalPayrollInvoicingCurrencyEnum>;
  leaverFee?: InputMaybe<Scalars['String']['input']>;
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  liveStatus?: InputMaybe<EmployerOfRecordLiveStatusEnum>;
  monthlyFee?: InputMaybe<Scalars['String']['input']>;
  newHiresOnboardingEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  newHiresOnboardingNotes?: InputMaybe<Scalars['String']['input']>;
  newStarterFee?: InputMaybe<Scalars['String']['input']>;
  offCyclePaymentFee?: InputMaybe<Scalars['String']['input']>;
  onboardingProcessLink?: InputMaybe<Scalars['String']['input']>;
  onboardingProcessNotes?: InputMaybe<Scalars['String']['input']>;
  oysterBenefitsLink?: InputMaybe<Scalars['String']['input']>;
  oysterBenefitsNotes?: InputMaybe<Scalars['String']['input']>;
  payrollSpecialistRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  payrollSpecialistRecipientsNotes?: InputMaybe<Scalars['String']['input']>;
  pensionPayment?: InputMaybe<EmployerOfRecordLiablePartyEnum>;
  quoteRequestEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  quoteRequestNotes?: InputMaybe<Scalars['String']['input']>;
  supportEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  supportNotes?: InputMaybe<Scalars['String']['input']>;
  taxesStatutoryPayment?: InputMaybe<EmployerOfRecordLiablePartyEnum>;
  timeOffMonthlyReportEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  timeOffMonthlyReportNotes?: InputMaybe<Scalars['String']['input']>;
  timeOffNotificationsEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  timeOffNotificationsNotes?: InputMaybe<Scalars['String']['input']>;
  timeOffProcessLink?: InputMaybe<Scalars['String']['input']>;
  timeOffProcessNotes?: InputMaybe<Scalars['String']['input']>;
  tmSalaryPayment?: InputMaybe<EmployerOfRecordLiablePartyEnum>;
  visaSupport?: InputMaybe<EmployerOfRecordVisaSupportEnum>;
  visaSupportDetails?: InputMaybe<Scalars['String']['input']>;
  visaWorkPermitProcessLink?: InputMaybe<Scalars['String']['input']>;
  visaWorkPermitProcessNotes?: InputMaybe<Scalars['String']['input']>;
};

export enum EmployerOfRecordEntityTypeEnum {
  OwnEntity = 'OWN_ENTITY',
  Subcontractor = 'SUBCONTRACTOR',
  Unknown = 'UNKNOWN'
}

export enum EmployerOfRecordGlobalPayrollInvoicingCurrencyEnum {
  Cad = 'CAD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type EmployerOfRecordKleaSubsidiary = {
  __typename?: 'EmployerOfRecordKleaSubsidiary';
  authorizations?: Maybe<Authorization>;
  /** Company ID on Klea */
  kleaIdentifier?: Maybe<Scalars['String']['output']>;
  /** Legal Name on Klea */
  kleaLegalName?: Maybe<Scalars['String']['output']>;
  /** Statutory Address */
  statutoryAddress?: Maybe<Scalars['String']['output']>;
  /** Statutory Country */
  statutoryCountry?: Maybe<Scalars['String']['output']>;
  /** Statutory Location */
  statutoryLocation?: Maybe<Scalars['String']['output']>;
};

export type EmployerOfRecordKleaSubsidiaryAttributesInput = {
  kleaIdentifier?: InputMaybe<Scalars['String']['input']>;
  kleaLegalName?: InputMaybe<Scalars['String']['input']>;
  statutoryAddress?: InputMaybe<Scalars['String']['input']>;
  statutoryCountry?: InputMaybe<Scalars['String']['input']>;
  statutoryLocation?: InputMaybe<Scalars['String']['input']>;
};

export enum EmployerOfRecordLiablePartyEnum {
  Customer = 'CUSTOMER',
  Oyster = 'OYSTER'
}

export enum EmployerOfRecordLiveIndicatorEnum {
  LaunchInProgress = 'LAUNCH_IN_PROGRESS',
  Live = 'LIVE',
  LiveConditional = 'LIVE_CONDITIONAL',
  NotLive = 'NOT_LIVE'
}

export enum EmployerOfRecordLiveStatusEnum {
  LaunchInProgress = 'LAUNCH_IN_PROGRESS',
  No = 'NO',
  YesExperienced = 'YES_EXPERIENCED',
  YesExperiencedSubcontractor = 'YES_EXPERIENCED_SUBCONTRACTOR',
  YesNewCountry = 'YES_NEW_COUNTRY',
  YesNewCountrySubcontractor = 'YES_NEW_COUNTRY_SUBCONTRACTOR'
}

export enum EmployerOfRecordVisaSupportEnum {
  Maybe = 'MAYBE',
  No = 'NO',
  Yes = 'YES'
}

export type EmployerTypesResignationNoticeInputType = {
  duration?: InputMaybe<CalendarDurationInput>;
  type: TypesEngagementContractualResignationTypeEnum;
};

export type EmployerTypesTerminationNoticeInputType = {
  duration?: InputMaybe<CalendarDurationInput>;
  type: TypesEngagementContractualTerminationTypeEnum;
};

/** Autogenerated input type of EmployerUpdateHire */
export type EmployerUpdateHireInput = {
  benefitsProvisionedEnrollmentAttributes?: InputMaybe<EmployerBenefitEnrollmentInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commissionPlanAttributes?: InputMaybe<EmployerCommissionPlanInput>;
  contractedTerminationNoticeAttributes?: InputMaybe<EmployerTypesTerminationNoticeInputType>;
  contractedTerminationNoticePeriod?: InputMaybe<CalendarDurationInput>;
  employmentAttributes?: InputMaybe<EmployerEmploymentInput>;
  employmentId: Scalars['String']['input'];
  personalInfoAttributes?: InputMaybe<EmployerEmploymentsPersonalInfoAttributesInput>;
  resignationNoticeAttributes?: InputMaybe<EmployerTypesResignationNoticeInputType>;
  resignationNoticePeriod?: InputMaybe<CalendarDurationInput>;
  restrictiveCovenantsAttributes?: InputMaybe<RestrictiveCovenantsInput>;
  sickPayAttributes?: InputMaybe<SickPayInput>;
  visaAttributes?: InputMaybe<EmployerEmploymentVisaInput>;
  workSchedules?: InputMaybe<Array<WorkScheduleInput>>;
};

/** Autogenerated return type of EmployerUpdateHire. */
export type EmployerUpdateHirePayload = {
  __typename?: 'EmployerUpdateHirePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<FormFieldError>>;
};

export type Employment = {
  __typename?: 'Employment';
  agreementsFields: Array<Scalars['String']['output']>;
  annualBonusType?: Maybe<Scalars['String']['output']>;
  assignedStaff?: Maybe<User>;
  authorizations?: Maybe<Authorization>;
  availableAllowancePolicies: Array<ReimbursementPolicyEnum>;
  benefitsDescription?: Maybe<Scalars['String']['output']>;
  benefitsEnrollments: BenefitsEnrollmentCollection;
  benefitsProvisionedEnrollments: BenefitsProvisionedEnrollmentCollection;
  bonusAmount?: Maybe<Scalars['Float']['output']>;
  bonusCurrencyCode?: Maybe<Scalars['String']['output']>;
  canSubmitToOysterAsEmployment: Scalars['Boolean']['output'];
  cbaLevel?: Maybe<Scalars['String']['output']>;
  coEmployee?: Maybe<User>;
  commissionPlan?: Maybe<Document>;
  commissionPlanOffered?: Maybe<Scalars['Boolean']['output']>;
  company: Company;
  contractedSeveranceRequired?: Maybe<Scalars['String']['output']>;
  contractedTerminationNotice?: Maybe<ContractualTermination>;
  contractedTerminationNoticePeriod?: Maybe<CalendarDuration>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy?: Maybe<User>;
  cutoffMonthDay: Scalars['Int']['output'];
  dailyResponsibility?: Maybe<Scalars['String']['output']>;
  decisionMakingAuthority?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Department>;
  depositBeforeLiability?: Maybe<Scalars['Boolean']['output']>;
  documents: Array<Document>;
  /** @deprecated Use personalInfo.email instead */
  email?: Maybe<Scalars['String']['output']>;
  employerOfRecord?: Maybe<EmployerOfRecord>;
  employerTaxesAndContributionsAmount?: Maybe<Scalars['Float']['output']>;
  employerTaxesAndContributionsCurrencyCode?: Maybe<Scalars['String']['output']>;
  employmentComplianceCheck?: Maybe<Scalars['Boolean']['output']>;
  employmentComplianceDetails?: Maybe<Scalars['String']['output']>;
  employmentTemplate?: Maybe<EmploymentTemplate>;
  employmentType?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  engagementChange?: Maybe<EngagementChange>;
  engagementType: EngagementType;
  entityName?: Maybe<Scalars['String']['output']>;
  equityOffered?: Maybe<Scalars['Boolean']['output']>;
  fullTimeHoursPerWeek?: Maybe<Scalars['Float']['output']>;
  grossSalary?: Maybe<Scalars['Float']['output']>;
  hiring?: Maybe<Hiring>;
  hiringSuccessLead?: Maybe<User>;
  /** Non-nil value means that the employment is paid by the hour */
  hourlyRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  /** The actual start date of employment if prior to engagement via Oyster */
  initialStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  internalBulkImport: Scalars['Boolean']['output'];
  internalMigration: Scalars['Boolean']['output'];
  invitation?: Maybe<Invitation>;
  /** Returns invoice settings for employee */
  invoicingEmployeeSettings?: Maybe<InvoicingEmployeeSettings>;
  is13thSalaryEnabled: Scalars['Boolean']['output'];
  is14thSalaryEnabled: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
  isPayrollTeamMember: Scalars['Boolean']['output'];
  isPeoTeamMember: Scalars['Boolean']['output'];
  /** Whether a USA-based employee is not eligible (exempt) or eligible (non-exempt) for overtime pay. */
  isUsaExemptEmployee?: Maybe<Scalars['Boolean']['output']>;
  jobDescription?: Maybe<Scalars['String']['output']>;
  jobDescriptionTranslation?: Maybe<Scalars['String']['output']>;
  jobRoleTranslation?: Maybe<Scalars['String']['output']>;
  knowledgeBasePageUrl?: Maybe<Scalars['String']['output']>;
  lastDayOn?: Maybe<Scalars['ISO8601Date']['output']>;
  lastSubmittedOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastWorkingDay?: Maybe<Scalars['ISO8601Date']['output']>;
  latestSalaryCurrencyConversion?: Maybe<SalaryCurrencyConversion>;
  localEmployerCostMonthlyAmount?: Maybe<Scalars['Float']['output']>;
  localEmployerCostMonthlyCurrencyCode?: Maybe<Scalars['String']['output']>;
  localEmployerCostOneoffAmount?: Maybe<Scalars['Float']['output']>;
  localEmployerCostOneoffCurrencyCode?: Maybe<Scalars['String']['output']>;
  /**
   * The currency code that this employment salary is locked at.
   * If null, salary currency code can be changed at will.
   *
   * An employment may have its currency code locked at a given currency to conform with
   * country-specific local regulations. A few examples are countries that specify:
   *   - Statutory bonuses/allowances in their official currencies;
   *   - Compensation in a specific currency for restrictive covenants clauses.
   */
  lockedCurrencyCode?: Maybe<CurrencyEnum>;
  managerEmailAddress?: Maybe<Scalars['String']['output']>;
  managerIsExpenseApprover: Scalars['Boolean']['output'];
  managerName?: Maybe<Scalars['String']['output']>;
  managerPhoneNumber?: Maybe<Scalars['String']['output']>;
  managerRole?: Maybe<Scalars['String']['output']>;
  minimumQualification?: Maybe<Scalars['String']['output']>;
  missingInfoForSubmitToOysterAsEmployment: Array<Scalars['String']['output']>;
  monthlyCommission?: Maybe<Scalars['String']['output']>;
  monthsFor13thSalary: Array<MonthsEnum>;
  monthsFor14thSalary: Array<MonthsEnum>;
  /** @deprecated Use personalInfo.full_legal_name instead */
  name?: Maybe<Scalars['String']['output']>;
  newHireStatus: EngagementNewHireStatusType;
  notes?: Maybe<Scalars['String']['output']>;
  notice?: Maybe<EmploymentNotice>;
  offboardingSpecialist?: Maybe<User>;
  offerLetterSendRequested: Scalars['Boolean']['output'];
  paidHolidayDays?: Maybe<Scalars['Float']['output']>;
  partTimeDaysPerWeek?: Maybe<Scalars['Int']['output']>;
  partTimeHoursPerDay?: Maybe<Scalars['Float']['output']>;
  paymentCadence?: Maybe<Scalars['String']['output']>;
  paymentDay?: Maybe<EngagementPaymentDayType>;
  payrollSpecialist?: Maybe<User>;
  payrollTeamMemberAddress?: Maybe<Address>;
  payslips: Array<Document>;
  personalInfo: EmploymentPersonalInfo;
  primaryDuty?: Maybe<Scalars['String']['output']>;
  privateNotes?: Maybe<Scalars['String']['output']>;
  probationEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  probationPeriod?: Maybe<Scalars['Iso8601Duration']['output']>;
  /** @deprecated Use probationPeriod for ISO 8601 compliance */
  probationPeriodType?: Maybe<EngagementProbationPeriodType>;
  /** @deprecated Use probationPeriod for ISO 8601 compliance */
  probationPeriodValue?: Maybe<Scalars['Int']['output']>;
  providedEquipmentList?: Maybe<Array<EquipmentListEnum>>;
  providedEquipmentOther?: Maybe<Scalars['String']['output']>;
  providedEquipmentPolicy?: Maybe<EquipmentPolicyEnum>;
  providedEquipmentPolicyBudget?: Maybe<Money>;
  publicHolidayDays?: Maybe<Scalars['Int']['output']>;
  pushedFields?: Maybe<Array<Scalars['String']['output']>>;
  reimbursementBalances: Array<ReimbursementBalance>;
  reimbursementBudgets: ReimbursementBudgetLegacyConnection;
  reimbursementPolicy?: Maybe<ReimbursementPolicy>;
  remoteWorkCosts?: Maybe<EngagementRemoteWorkCostObjectType>;
  requiredForms: Array<RequiredForm>;
  resignationNotice?: Maybe<ContractualResignation>;
  resignationNoticePeriod?: Maybe<CalendarDuration>;
  restrictiveCovenants?: Maybe<RestrictiveCovenants>;
  role?: Maybe<Scalars['String']['output']>;
  roleType?: Maybe<RoleType>;
  salaryAbsorbable?: Maybe<Scalars['Boolean']['output']>;
  /** returns annual salary OR predicted annual salary if an hourly rate is defined */
  salaryAmount?: Maybe<Scalars['Float']['output']>;
  salaryCurrencyCode?: Maybe<Scalars['String']['output']>;
  seniorityLevel?: Maybe<EngagementSeniorityLevelType>;
  serviceAgreementSignedEventDate?: Maybe<Scalars['ISO8601Date']['output']>;
  severance?: Maybe<EmploymentSeverance>;
  sickPay?: Maybe<SickPay>;
  signOnBonusAmount?: Maybe<Scalars['Float']['output']>;
  signOnBonusCurrencyCode?: Maybe<Scalars['String']['output']>;
  signatoryPointOfContact?: Maybe<ExternalPointOfContact>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  state: Scalars['String']['output'];
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  /** Health benefits only, to include perks use availablePlans on Engagement */
  suggestedBenefitPlans?: Maybe<Array<BenefitsPlan>>;
  syncedFields: Array<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  variableCompensations: VariableCompensationLegacyConnection;
  visa: EmploymentVisa;
  /** @deprecated Please use the 'visa' composite field instead */
  visaAcquisionFee?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Please use the 'visa' composite field instead */
  visaAcquisionFeeCurrencyCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use the 'visa' composite field instead */
  visaAcquisitionPayer: VisaAcquisitionPayerTypeEnum;
  /** @deprecated Please use the 'visa' composite field instead */
  visaDocumentUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use the 'visa' composite field instead */
  visaExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** @deprecated Please use the 'visa' composite field instead */
  visaRequired?: Maybe<Scalars['Boolean']['output']>;
  /** True if the Team Member's day-to-day work is focused on providing or supporting services within the country of residence. */
  workFocusedWithinCountryOfResidence?: Maybe<Scalars['Boolean']['output']>;
  workPermitRequired?: Maybe<Scalars['Boolean']['output']>;
  workSchedules?: Maybe<Array<WorkSchedule>>;
  workingHours?: Maybe<Scalars['String']['output']>;
};


export type EmploymentBenefitsEnrollmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EmploymentBenefitsProvisionedEnrollmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EmploymentEngagementChangeArgs = {
  engagementChangeId: Scalars['ID']['input'];
};


export type EmploymentReimbursementBalancesArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  labels?: InputMaybe<Array<ReimbursementBudgetLabelEnum>>;
};


export type EmploymentReimbursementBudgetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EmploymentVariableCompensationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type EmploymentAgreementsInfo = {
  __typename?: 'EmploymentAgreementsInfo';
  eSignStatus?: Maybe<ESignStatus>;
  generationType?: Maybe<GenerationTypeEnum>;
  minimumState?: Maybe<AgreementStateEnum>;
};

export type EmploymentAspect = AspectInterface & {
  __typename?: 'EmploymentAspect';
  authorizations?: Maybe<Authorization>;
  company?: Maybe<Company>;
  engagement?: Maybe<Engagement>;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type EmploymentCollection = {
  __typename?: 'EmploymentCollection';
  collection: Array<Employment>;
  metadata: CollectionMetadata;
};

export enum EmploymentCreationStateEnum {
  AssistedSetup = 'ASSISTED_SETUP',
  Draft = 'DRAFT'
}

/** Autogenerated input type of EmploymentLogRequestChange */
export type EmploymentLogRequestChangeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom: Scalars['ISO8601Date']['input'];
  engagementId: Scalars['ID']['input'];
  mergeEmploymentLogId: Scalars['ID']['input'];
  nextRole?: InputMaybe<Scalars['String']['input']>;
  nextSalary?: InputMaybe<Scalars['Float']['input']>;
  retroactivePayment?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of EmploymentLogRequestChange. */
export type EmploymentLogRequestChangePayload = {
  __typename?: 'EmploymentLogRequestChangePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagementChange?: Maybe<EngagementChange>;
  errors: Array<Scalars['String']['output']>;
};

export type EmploymentNotice = {
  __typename?: 'EmploymentNotice';
  amount?: Maybe<Money>;
  entitlement: Scalars['String']['output'];
  gardenLeave?: Maybe<Scalars['Boolean']['output']>;
  noticeType?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  periodDays?: Maybe<Scalars['Int']['output']>;
  periodDuration?: Maybe<Scalars['Int']['output']>;
};

export type EmploymentNoticeInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  entitlement?: InputMaybe<Scalars['String']['input']>;
  gardenLeave?: InputMaybe<Scalars['Boolean']['input']>;
  noticeType?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  periodDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type EmploymentPersonalInfo = {
  __typename?: 'EmploymentPersonalInfo';
  agreementsFields: Array<Scalars['String']['output']>;
  birthSex?: Maybe<BirthSex>;
  dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullLegalName: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<CountryIsoCode>;
  personalPhoneNumber?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  preferredPronoun?: Maybe<PreferredPronoun>;
  syncedFields?: Maybe<Array<Scalars['String']['output']>>;
  workEmailAddress?: Maybe<Scalars['String']['output']>;
};

export type EmploymentPersonalInfoAttributesInput = {
  birthSex?: InputMaybe<BirthSex>;
  dateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullLegalName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<CountryIsoCode>;
  personalPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  preferredPronoun?: InputMaybe<PreferredPronoun>;
  workEmailAddress?: InputMaybe<Scalars['String']['input']>;
};

export type EmploymentSeverance = {
  __typename?: 'EmploymentSeverance';
  amount?: Maybe<Money>;
  period?: Maybe<Scalars['String']['output']>;
  periodDuration?: Maybe<Scalars['Int']['output']>;
  severanceType: Scalars['String']['output'];
};

export type EmploymentSeveranceInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  periodDuration?: InputMaybe<Scalars['Int']['input']>;
  severanceType?: InputMaybe<Scalars['String']['input']>;
};

export type EmploymentTemplate = {
  __typename?: 'EmploymentTemplate';
  authorizations?: Maybe<Authorization>;
  benefitsEnrollmentTemplate?: Maybe<BenefitsEnrollmentTemplateType>;
  commissionPlan?: Maybe<Document>;
  commissionPlanOffered?: Maybe<Scalars['Boolean']['output']>;
  company: Company;
  countryCode?: Maybe<CountryIsoCode>;
  description?: Maybe<Scalars['String']['output']>;
  equityOffered?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  oysterScore?: Maybe<CountryIntelligenceOysterScore>;
  paidHolidayDays?: Maybe<Scalars['Float']['output']>;
  probationPeriod?: Maybe<Scalars['Iso8601Duration']['output']>;
  remoteWorkCosts?: Maybe<EngagementRemoteWorkCostObjectType>;
  status: EmploymentTemplateStatus;
  variableCompensationTemplates: Array<VariableCompensationTemplate>;
};

export enum EmploymentTemplateStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT'
}

export enum EmploymentTypeEnum {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME'
}

export type EmploymentVisa = {
  __typename?: 'EmploymentVisa';
  acquisionFee?: Maybe<Scalars['Float']['output']>;
  acquisionFeeCurrencyCode?: Maybe<Scalars['String']['output']>;
  acquisitionPayer: VisaAcquisitionPayerTypeEnum;
  document?: Maybe<Document>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  rightToWorkType?: Maybe<RightToWorkTypeEnum>;
};

export type EmploymentVisaInput = {
  acquisionFee?: InputMaybe<Scalars['Float']['input']>;
  acquisionFeeCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  acquisitionPayer?: InputMaybe<VisaAcquisitionPayerTypeEnum>;
  documentSignedUrl?: InputMaybe<Scalars['String']['input']>;
  expirationDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  rightToWorkType?: InputMaybe<RightToWorkTypeEnum>;
};

export type EmploymentsHiringCompanyProcess = {
  __typename?: 'EmploymentsHiringCompanyProcess';
  currentStep: EmploymentsHiringCompanyProcessStep;
  steps: Array<EmploymentsHiringCompanyProcessStep>;
};

export type EmploymentsHiringCompanyProcessStep = {
  __typename?: 'EmploymentsHiringCompanyProcessStep';
  name: EmploymentsHiringCompanyProcessStepName;
  progress: EmploymentsHiringStepProgress;
  /** The list of staff notes for this specific step, ordered by most recent last. */
  staffNotes: StaffNoteConnection;
};


export type EmploymentsHiringCompanyProcessStepStaffNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum EmploymentsHiringCompanyProcessStepName {
  Completed = 'COMPLETED',
  DocumentsUnderReview = 'DOCUMENTS_UNDER_REVIEW',
  DraftingHireDetails = 'DRAFTING_HIRE_DETAILS',
  InvitingTeamMember = 'INVITING_TEAM_MEMBER',
  OysterDraftingDocuments = 'OYSTER_DRAFTING_DOCUMENTS',
  OysterFinalizingDocuments = 'OYSTER_FINALIZING_DOCUMENTS',
  WaitingForSignatures = 'WAITING_FOR_SIGNATURES'
}

export type EmploymentsHiringEmployeeProcess = {
  __typename?: 'EmploymentsHiringEmployeeProcess';
  currentStep: EmploymentsHiringEmployeeProcessStep;
  steps: Array<EmploymentsHiringEmployeeProcessStep>;
};

export type EmploymentsHiringEmployeeProcessStep = {
  __typename?: 'EmploymentsHiringEmployeeProcessStep';
  name: EmploymentsHiringEmployeeProcessStepName;
  progress: EmploymentsHiringStepProgress;
  /** The list of staff notes for this specific step, ordered by most recent last. */
  staffNotes: StaffNoteConnection;
};


export type EmploymentsHiringEmployeeProcessStepStaffNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum EmploymentsHiringEmployeeProcessStepName {
  Completed = 'COMPLETED',
  DocumentsUnderReview = 'DOCUMENTS_UNDER_REVIEW',
  Onboarding = 'ONBOARDING',
  OysterDraftingDocuments = 'OYSTER_DRAFTING_DOCUMENTS',
  OysterFinalizingDocuments = 'OYSTER_FINALIZING_DOCUMENTS',
  WaitingForSignatures = 'WAITING_FOR_SIGNATURES'
}

export enum EmploymentsHiringStepProgress {
  Completed = 'COMPLETED',
  Current = 'CURRENT',
  Unstarted = 'UNSTARTED'
}

/** Autogenerated input type of EnableAccountingContractorVendorCreation */
export type EnableAccountingContractorVendorCreationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnableAccountingContractorVendorCreation. */
export type EnableAccountingContractorVendorCreationPayload = {
  __typename?: 'EnableAccountingContractorVendorCreationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
  feature: CompanyAvailableFeatures;
};

/** Autogenerated input type of EnableAccountingTrackingCategories */
export type EnableAccountingTrackingCategoriesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnableAccountingTrackingCategories. */
export type EnableAccountingTrackingCategoriesPayload = {
  __typename?: 'EnableAccountingTrackingCategoriesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
  feature: CompanyAvailableFeatures;
};

/** Autogenerated input type of EnableAgreement */
export type EnableAgreementInput = {
  agreementType: AgreementTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiringId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnableAgreement. */
export type EnableAgreementPayload = {
  __typename?: 'EnableAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of EnableFeature */
export type EnableFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  feature: CompanyAvailableFeatures;
};

/** Autogenerated return type of EnableFeature. */
export type EnableFeaturePayload = {
  __typename?: 'EnableFeaturePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
  feature: CompanyAvailableFeatures;
};

/** Autogenerated input type of EngageEmploymentWithPartiallySignedAgreements */
export type EngageEmploymentWithPartiallySignedAgreementsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employmentId: Scalars['String']['input'];
};

/** Autogenerated return type of EngageEmploymentWithPartiallySignedAgreements. */
export type EngageEmploymentWithPartiallySignedAgreementsPayload = {
  __typename?: 'EngageEmploymentWithPartiallySignedAgreementsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
};

export type Engagement = {
  __typename?: 'Engagement';
  accrualCycleSpan: AccrualCycleSpan;
  accrualCycleSpans: Array<AccrualCycleSpan>;
  activeAddOns?: Maybe<AddOnCollection>;
  /** Returns an active subscription, or a pending subscription, or null - in that order */
  activeOrPendingSubscription?: Maybe<Subscription>;
  /** Returns an active subscription, or null */
  activeSubscription?: Maybe<Subscription>;
  allowances: VariableCompensationLegacyConnection;
  allowedToSubmitExpenses?: Maybe<Scalars['Boolean']['output']>;
  assignedStaff?: Maybe<User>;
  authorizations?: Maybe<Authorization>;
  availableAddOnPlans?: Maybe<NewPlanCollection>;
  availableBenefitPlans: BenefitsPlanCollection;
  availableTimeTrackingEntryTypes: Array<TimeSheetEntryTypeEnum>;
  benefitsDescription?: Maybe<Scalars['String']['output']>;
  benefitsEnrolledPackages: BenefitsEnrolledPackageCollection;
  benefitsEnrollments: BenefitsEnrollmentCollection;
  benefitsProvisionedAddons: BenefitsPlanCollection;
  benefitsProvisionedEnrollments: BenefitsProvisionedEnrollmentCollection;
  canOverrideCarryoverExpiringPeriod: Scalars['Boolean']['output'];
  /** Past termination attempts for this engagement, sorted   by most recent first. */
  cancelledTerminations: Array<Termination>;
  carryoverAdjustmentDisabled?: Maybe<Scalars['Boolean']['output']>;
  carryoverAdjustmentMaxAmount?: Maybe<Scalars['Float']['output']>;
  carryoverAmountLimitationPolicy?: Maybe<CarryoverAmountLimitationPolicyEnum>;
  carryoverAnnualLimit?: Maybe<Scalars['Float']['output']>;
  carryoverDate?: Maybe<Scalars['ISO8601Date']['output']>;
  carryoverExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  carryoverExpirationPeriodPolicy?: Maybe<CarryoverExpirationPeriodPolicyEnum>;
  carryoverExpiringPeriodInMonthsAdjustment?: Maybe<Scalars['Int']['output']>;
  cartaGrantsCount: Scalars['Int']['output'];
  cartaId?: Maybe<Scalars['String']['output']>;
  cbaLevel?: Maybe<Scalars['String']['output']>;
  changeReasons?: Maybe<Array<ChangeReason>>;
  coEmployee?: Maybe<User>;
  company: Company;
  contract?: Maybe<Contract>;
  contractorAgreementsFields: Array<Scalars['String']['output']>;
  costCenter?: Maybe<CostCenter>;
  costOfOffboardingAvailable: Scalars['Boolean']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy?: Maybe<User>;
  cutoffMonthDay: Scalars['Int']['output'];
  cutoffTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  deactivatedAddOns?: Maybe<AddOnCollection>;
  department?: Maybe<Department>;
  dependents: DependentCollection;
  depositBeforeLiability?: Maybe<Scalars['Boolean']['output']>;
  directHire?: Maybe<Scalars['Boolean']['output']>;
  directManager?: Maybe<Array<User>>;
  discountOverride?: Maybe<DiscountOverride>;
  discountOverrides?: Maybe<DiscountOverrideCollection>;
  discountRedemption?: Maybe<DiscountRedemption>;
  discountRedemptions?: Maybe<DiscountRedemptionCollection>;
  documents: Array<Document>;
  eligibleToNightWork: Scalars['Boolean']['output'];
  eligibleToOnCall: Scalars['Boolean']['output'];
  employerOfRecord?: Maybe<EmployerOfRecord>;
  employment?: Maybe<Employment>;
  employmentComplianceCheck?: Maybe<Scalars['Boolean']['output']>;
  employmentComplianceDetails?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  engagedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  engagementChanges?: Maybe<Array<EngagementChange>>;
  engagementType: EngagementType;
  entitlementCountryCarryoverAnnualLimit?: Maybe<Scalars['Int']['output']>;
  entitlementCountryCarryoverExpiringPeriodInMonths?: Maybe<Scalars['Int']['output']>;
  entitlementCountryEnabled: Scalars['Boolean']['output'];
  entitlementCounts: EntitlementCounts;
  equityGrants: Array<EquityGrant>;
  exemptionForm: ExemptionForm;
  exercisableGrants: Array<EquityGrant>;
  expensesAdmins?: Maybe<Array<User>>;
  expensesSource: ExpenseSourceEnumType;
  expiredAddOns?: Maybe<AddOnCollection>;
  failedCartaGrantsCount: Scalars['Int']['output'];
  flexibleWorkArrangement: Scalars['Boolean']['output'];
  flexibleWorkArrangementAvailable: Scalars['Boolean']['output'];
  globalPayrollOffboardingCountry?: Maybe<GlobalPayrollOffboardingCountry>;
  /** Returns a boolean to indicate whether this engagement has an associated address */
  hasAddress: Scalars['Boolean']['output'];
  /** Returns state whether engagement has deposit invoices */
  hasDepositInvoices: Scalars['Boolean']['output'];
  hiringSuccessLead?: Maybe<User>;
  holidayDataForYearAvailable: Scalars['Boolean']['output'];
  holidaysDataAvailable: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  initialStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  invitation?: Maybe<Invitation>;
  isAccrualFrequencyAnnual: Scalars['Boolean']['output'];
  isPayrollTeamMember: Scalars['Boolean']['output'];
  isPeoTeamMember: Scalars['Boolean']['output'];
  /** Whether a USA-based employee is not eligible (exempt) or eligible (non-exempt) for overtime pay. */
  isUsaExemptEmployee?: Maybe<Scalars['Boolean']['output']>;
  languageCode?: Maybe<TranslationsLanguageCodeEnum>;
  lastDayOn?: Maybe<Scalars['ISO8601Date']['output']>;
  lastSubmittedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  lastWorkingDay?: Maybe<Scalars['ISO8601Date']['output']>;
  maxCarryoverDays?: Maybe<Scalars['Int']['output']>;
  maxDaysByCoefficientOfPaidHolidayDays?: Maybe<Scalars['Float']['output']>;
  medicalNote?: Maybe<Scalars['String']['output']>;
  mergeConnection?: Maybe<MergeConnection>;
  minDaysToUse?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextCutoffTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  nextStates: Array<EngagementStateTransition>;
  nightWorkEnabled: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  offboardingSpecialist?: Maybe<User>;
  onCallEnabled: Scalars['Boolean']['output'];
  onboardingData?: Maybe<OnboardingData>;
  oysterExpensesEnabled: Scalars['Boolean']['output'];
  paidHolidayDays?: Maybe<Scalars['Float']['output']>;
  /**
   * Returns state whether payment management is enabled for engagement
   * - depends on engagement type and country.
   */
  paymentMethodManagementEnabled: Scalars['Boolean']['output'];
  paymentMethods: Array<EngagementBankAccount>;
  paymentsEngagementSettings: PaymentsEngagementSettings;
  payoutProvider: PayoutProvider;
  payrollCurrencyCode?: Maybe<Scalars['String']['output']>;
  payrollSpecialist?: Maybe<User>;
  payrollTeamMemberAddress?: Maybe<Address>;
  pendingAddOns?: Maybe<AddOnCollection>;
  pendingAmendmentProcesses?: Maybe<Array<AmendmentProcessType>>;
  pendingEngagementChange?: Maybe<EngagementChange>;
  /** Returns a pending subscription, or an active subscription, or null -  in that order */
  pendingOrActiveSubscription?: Maybe<Subscription>;
  /** Returns a pending subscription, or null */
  pendingSubscription?: Maybe<Subscription>;
  probationEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  ptoDaysTaken?: Maybe<Scalars['Float']['output']>;
  reimbursementBalances: Array<ReimbursementBalance>;
  reimbursementBudgets: ReimbursementBudgetLegacyConnection;
  requiredForms: Array<RequiredForm>;
  resignationLetterData?: Maybe<ResignationLetterData>;
  role?: Maybe<Scalars['String']['output']>;
  selfServiceDocuments: Array<SelfServiceDocument>;
  seniorityLevel?: Maybe<EngagementSeniorityLevelType>;
  sickPay?: Maybe<SickPay>;
  signatoryPointOfContact?: Maybe<ExternalPointOfContact>;
  /** Includes soft-deleted documents */
  staffDocuments: Array<Document>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  state: EngagementState;
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  teamMember?: Maybe<User>;
  teamMemberDateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  teamMemberName?: Maybe<Scalars['String']['output']>;
  termination?: Maybe<Termination>;
  terminationDraft?: Maybe<Termination>;
  terminationRules?: Maybe<TerminationRules>;
  timeOffHalfDayDisabledTypes: Array<TimeOffTypeEnum>;
  timeOffHourlySupportEnabled: Scalars['Boolean']['output'];
  timeOffManagementEnabled: Scalars['Boolean']['output'];
  timeOffRequests: TimeOffRequestCollection;
  timeOffTransactions: TimeOffTransactionCollection;
  timeSheetClosedMonths?: Maybe<Array<Scalars['Int']['output']>>;
  timeSheets: TimeSheetCollection;
  timeTrackingEnabled: Scalars['Boolean']['output'];
  timeTrackingToolOverride: TimeTrackingToolOverrideEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vacationRequestRestrictionHelpCenterArticleLink?: Maybe<Scalars['String']['output']>;
  vacationRequestRestrictionPeriodInMonths?: Maybe<Scalars['Int']['output']>;
  vacationRequestRestrictionPeriodText?: Maybe<Scalars['String']['output']>;
  vacationTimeOffRequestsAvailableFromDate: Scalars['ISO8601Date']['output'];
  variableCompensations: VariableCompensationLegacyConnection;
  vendorExternalId?: Maybe<Scalars['String']['output']>;
  withValidRegionAddress: Scalars['Boolean']['output'];
  workSchedule?: Maybe<TimeSheetWorkSchedule>;
};


export type EngagementActiveAddOnsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementAllowancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementAvailableAddOnPlansArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementAvailableBenefitPlansArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementBenefitsEnrolledPackagesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementBenefitsEnrollmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementBenefitsProvisionedAddonsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementBenefitsProvisionedEnrollmentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementDeactivatedAddOnsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementDependentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementDiscountOverridesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementDiscountRedemptionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementExpiredAddOnsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementHolidayDataForYearAvailableArgs = {
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementOnboardingDataArgs = {
  integrationId: Scalars['String']['input'];
};


export type EngagementPaymentMethodsArgs = {
  type?: InputMaybe<PaymetMethodEnumType>;
};


export type EngagementPayoutProviderArgs = {
  countryCode: Scalars['String']['input'];
  currencyCode: Scalars['String']['input'];
};


export type EngagementPendingAddOnsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementReimbursementBalancesArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  labels?: InputMaybe<Array<ReimbursementBudgetLabelEnum>>;
};


export type EngagementReimbursementBudgetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementSelfServiceDocumentsArgs = {
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type EngagementTimeOffRequestsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  periodStart?: InputMaybe<Scalars['ISO8601Date']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
  statuses?: InputMaybe<Array<TimeOffRequestStateEnumType>>;
  timeOffTypes?: InputMaybe<Array<TimeOffTypeEnum>>;
};


export type EngagementTimeOffTransactionsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  periodEnd: Scalars['ISO8601Date']['input'];
  periodStart: Scalars['ISO8601Date']['input'];
};


export type EngagementTimeSheetClosedMonthsArgs = {
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementTimeSheetsArgs = {
  combinedStatuses?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
  timeSheetCreation?: InputMaybe<Scalars['String']['input']>;
  timeSheetType?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type EngagementVariableCompensationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type EngagementBankAccount = {
  __typename?: 'EngagementBankAccount';
  accountHolderName?: Maybe<Scalars['String']['output']>;
  authorizations?: Maybe<Authorization>;
  countryCode?: Maybe<CountryIsoCode>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  forExpenses: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  maskedData: PaymentMethodBankAccountMaskedData;
  primary: Scalars['Boolean']['output'];
  rawData: Scalars['JSON']['output'];
  state: PaymentMethodState;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type EngagementChange = {
  __typename?: 'EngagementChange';
  amendmentProcess?: Maybe<AmendmentProcessType>;
  anyRelatedAmendmentsSharedInProgress: Scalars['Boolean']['output'];
  applicableFrom: Scalars['ISO8601Date']['output'];
  authorizations?: Maybe<Authorization>;
  availableActions: Array<EngagementChangeAvailableActionEnumType>;
  cancellationReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  changeType: EngagementChangeChangeType;
  compensationChanged?: Maybe<Scalars['Boolean']['output']>;
  contractorAgreementAmendment: EngagementChangeDocument;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  effectiveFrom: Scalars['ISO8601Date']['output'];
  employment: Scalars['Boolean']['output'];
  employmentAgreementAmendment: EngagementChangeDocument;
  engagement: Engagement;
  engagementAllowances: Array<Allowance>;
  engagementBonuses: Array<Bonus>;
  expirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  extended: Scalars['Boolean']['output'];
  fromIntegration: Scalars['Boolean']['output'];
  hasAmendmentFlowAutomatable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includedInABulk: Scalars['Boolean']['output'];
  isCurrentContractExtension?: Maybe<Scalars['Boolean']['output']>;
  isCurrentModification?: Maybe<Scalars['Boolean']['output']>;
  isPayrollTeamMember: Scalars['Boolean']['output'];
  mayApprove: Scalars['Boolean']['output'];
  newAllowances: Array<Allowance>;
  newBonuses: Array<Bonus>;
  nextAllowedToSubmitExpenses?: Maybe<Scalars['Boolean']['output']>;
  nextEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  nextExpenseLimit?: Maybe<Scalars['Float']['output']>;
  nextExpenseLimitCurrencyCode?: Maybe<Scalars['String']['output']>;
  nextHourlyRate?: Maybe<Scalars['Float']['output']>;
  nextJobDescription?: Maybe<Scalars['String']['output']>;
  nextJobDescriptionTranslation?: Maybe<Scalars['String']['output']>;
  nextJobRoleTranslation?: Maybe<Scalars['String']['output']>;
  nextRole?: Maybe<Scalars['String']['output']>;
  nextSalary?: Maybe<Scalars['Float']['output']>;
  nextSalaryAbsorbable?: Maybe<Scalars['Boolean']['output']>;
  nextScopeOfWork?: Maybe<Scalars['String']['output']>;
  nextSeniorityLevel?: Maybe<EngagementSeniorityLevelType>;
  onlyRoleChanged: Scalars['Boolean']['output'];
  onlyVariableCompensationsChanged: Scalars['Boolean']['output'];
  oysterServiceAgreementAmendment: EngagementChangeDocument;
  positionDetailsChanged?: Maybe<Scalars['Boolean']['output']>;
  previousAllowedToSubmitExpenses?: Maybe<Scalars['Boolean']['output']>;
  previousEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  previousExpenseLimit?: Maybe<Scalars['Float']['output']>;
  previousExpenseLimitCurrencyCode?: Maybe<Scalars['String']['output']>;
  previousHourlyRate?: Maybe<Scalars['Float']['output']>;
  previousJobDescription?: Maybe<Scalars['String']['output']>;
  previousJobDescriptionTranslation?: Maybe<Scalars['String']['output']>;
  previousJobRoleTranslation?: Maybe<Scalars['String']['output']>;
  previousRole?: Maybe<Scalars['String']['output']>;
  previousSalary?: Maybe<Scalars['Float']['output']>;
  previousSalaryAbsorbable?: Maybe<Scalars['Boolean']['output']>;
  previousScopeOfWork?: Maybe<Scalars['String']['output']>;
  previousSeniorityLevel?: Maybe<EngagementSeniorityLevelType>;
  removedAllowances: Array<Allowance>;
  removedBonuses: Array<Bonus>;
  requester: User;
  requesterName: Scalars['String']['output'];
  retroactivePayment?: Maybe<Scalars['Float']['output']>;
  serviceAgreementEvent?: Maybe<ServiceAgreementEvent>;
  state: EngagementChangeStateEnumType;
  translationLanguageCode?: Maybe<TranslationsLanguageCodeEnum>;
  zendeskTicketUrl?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of EngagementChangeAttachDocument */
export type EngagementChangeAttachDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  docType: Scalars['String']['input'];
  engagementChangeId: Scalars['ID']['input'];
  signedId: Scalars['String']['input'];
};

/** Autogenerated return type of EngagementChangeAttachDocument. */
export type EngagementChangeAttachDocumentPayload = {
  __typename?: 'EngagementChangeAttachDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagementChange: EngagementChange;
  errors: Array<Scalars['String']['output']>;
};

export enum EngagementChangeAvailableActionEnumType {
  Approve = 'APPROVE',
  Backdate = 'BACKDATE',
  Cancel = 'CANCEL',
  Preview = 'PREVIEW',
  ResumeAmendmentProcess = 'RESUME_AMENDMENT_PROCESS',
  Review = 'REVIEW',
  StartAmendmentProcess = 'START_AMENDMENT_PROCESS'
}

export enum EngagementChangeChangeType {
  Extension = 'EXTENSION',
  Modification = 'MODIFICATION'
}

export type EngagementChangeCollection = {
  __typename?: 'EngagementChangeCollection';
  collection: Array<EngagementChange>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of EngagementChangeDetachDocument */
export type EngagementChangeDetachDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  docType: Scalars['String']['input'];
  engagementChangeId: Scalars['ID']['input'];
};

/** Autogenerated return type of EngagementChangeDetachDocument. */
export type EngagementChangeDetachDocumentPayload = {
  __typename?: 'EngagementChangeDetachDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagementChange: EngagementChange;
  errors: Array<Scalars['String']['output']>;
};

export type EngagementChangeDocument = {
  __typename?: 'EngagementChangeDocument';
  attachIsDisabled: Scalars['Boolean']['output'];
  detachIsDisabled: Scalars['Boolean']['output'];
  file?: Maybe<FileUploaderType>;
};

/** Autogenerated input type of EngagementChangeModificationAndExtensionRequest */
export type EngagementChangeModificationAndExtensionRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom: Scalars['ISO8601Date']['input'];
  engagementId: Scalars['ID']['input'];
  newAllowances?: InputMaybe<Array<AllowanceInput>>;
  newBonuses?: InputMaybe<Array<BonusInput>>;
  nextAllowedToSubmitExpenses?: InputMaybe<Scalars['Boolean']['input']>;
  nextEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  nextExpenseLimit?: InputMaybe<Scalars['Float']['input']>;
  nextHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  nextRole?: InputMaybe<Scalars['String']['input']>;
  nextSalary?: InputMaybe<Scalars['Float']['input']>;
  nextScopeOfWork?: InputMaybe<Scalars['String']['input']>;
  nextServiceEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  removedAllowanceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  removedBonusIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retroactivePayment?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of EngagementChangeModificationAndExtensionRequest. */
export type EngagementChangeModificationAndExtensionRequestPayload = {
  __typename?: 'EngagementChangeModificationAndExtensionRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagementChanges?: Maybe<EngagementChangeCollection>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of EngagementChangeRequest */
export type EngagementChangeRequestInput = {
  changeType: EngagementChangeChangeType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  effectiveFrom: Scalars['ISO8601Date']['input'];
  engagementId: Scalars['ID']['input'];
  mergeEmploymentLogId?: InputMaybe<Scalars['ID']['input']>;
  newAllowances?: InputMaybe<Array<AllowanceInput>>;
  newBonuses?: InputMaybe<Array<BonusInput>>;
  nextAllowedToSubmitExpenses?: InputMaybe<Scalars['Boolean']['input']>;
  nextEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  nextExpenseLimit?: InputMaybe<Scalars['Float']['input']>;
  nextHourlyRate?: InputMaybe<Scalars['Float']['input']>;
  nextJobDescription?: InputMaybe<Scalars['String']['input']>;
  nextJobDescriptionTranslation?: InputMaybe<Scalars['String']['input']>;
  nextJobRoleTranslation?: InputMaybe<Scalars['String']['input']>;
  nextRole?: InputMaybe<Scalars['String']['input']>;
  nextSalary?: InputMaybe<Scalars['Float']['input']>;
  nextSalaryAbsorbable?: InputMaybe<Scalars['Boolean']['input']>;
  nextScopeOfWork?: InputMaybe<Scalars['String']['input']>;
  nextSeniorityLevel?: InputMaybe<EngagementSeniorityLevelType>;
  nextServiceEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  removedAllowanceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  removedBonusIds?: InputMaybe<Array<Scalars['String']['input']>>;
  retroactivePayment?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of EngagementChangeRequest. */
export type EngagementChangeRequestPayload = {
  __typename?: 'EngagementChangeRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<Engagement>;
  engagementChange?: Maybe<EngagementChange>;
  errors: Array<Scalars['String']['output']>;
};

export enum EngagementChangeStateEnumType {
  AmendmentProcessStarted = 'AMENDMENT_PROCESS_STARTED',
  Applied = 'APPLIED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  PendingCancellation = 'PENDING_CANCELLATION',
  Submitted = 'SUBMITTED'
}

export type EngagementCollection = {
  __typename?: 'EngagementCollection';
  collection: Array<Engagement>;
  metadata: CollectionMetadata;
};

export type EngagementExportTemplate = {
  __typename?: 'EngagementExportTemplate';
  authorizations?: Maybe<Authorization>;
  countryCode: Scalars['String']['output'];
  countryName: Scalars['String']['output'];
  file?: Maybe<DownloadLink>;
  id: Scalars['ID']['output'];
};

export type EngagementExportTemplateCollection = {
  __typename?: 'EngagementExportTemplateCollection';
  collection: Array<EngagementExportTemplate>;
  metadata: CollectionMetadata;
};

export enum EngagementNewHireStatusType {
  ExistingContractor = 'EXISTING_CONTRACTOR',
  ExistingEmployee = 'EXISTING_EMPLOYEE',
  NewHire = 'NEW_HIRE'
}

export enum EngagementPaymentDayType {
  SucceedingMonthDay_1 = 'SUCCEEDING_MONTH_DAY_1',
  SucceedingMonthDay_2 = 'SUCCEEDING_MONTH_DAY_2',
  SucceedingMonthDay_3 = 'SUCCEEDING_MONTH_DAY_3',
  SucceedingMonthDay_4 = 'SUCCEEDING_MONTH_DAY_4',
  SucceedingMonthDay_5 = 'SUCCEEDING_MONTH_DAY_5',
  SucceedingMonthDay_6 = 'SUCCEEDING_MONTH_DAY_6',
  SucceedingMonthDay_7 = 'SUCCEEDING_MONTH_DAY_7',
  SucceedingMonthDay_8 = 'SUCCEEDING_MONTH_DAY_8',
  SucceedingMonthDay_9 = 'SUCCEEDING_MONTH_DAY_9',
  SucceedingMonthDay_10 = 'SUCCEEDING_MONTH_DAY_10',
  SucceedingMonthDay_11 = 'SUCCEEDING_MONTH_DAY_11',
  SucceedingMonthDay_12 = 'SUCCEEDING_MONTH_DAY_12',
  SucceedingMonthDay_13 = 'SUCCEEDING_MONTH_DAY_13',
  SucceedingMonthDay_14 = 'SUCCEEDING_MONTH_DAY_14',
  SucceedingMonthDay_15 = 'SUCCEEDING_MONTH_DAY_15',
  SucceedingMonthDay_16 = 'SUCCEEDING_MONTH_DAY_16',
  SucceedingMonthDay_17 = 'SUCCEEDING_MONTH_DAY_17',
  SucceedingMonthDay_18 = 'SUCCEEDING_MONTH_DAY_18',
  SucceedingMonthDay_19 = 'SUCCEEDING_MONTH_DAY_19',
  SucceedingMonthDay_20 = 'SUCCEEDING_MONTH_DAY_20',
  SucceedingMonthDay_21 = 'SUCCEEDING_MONTH_DAY_21',
  SucceedingMonthDay_22 = 'SUCCEEDING_MONTH_DAY_22',
  SucceedingMonthDay_23 = 'SUCCEEDING_MONTH_DAY_23',
  SucceedingMonthDay_24 = 'SUCCEEDING_MONTH_DAY_24',
  SucceedingMonthDay_25 = 'SUCCEEDING_MONTH_DAY_25',
  SucceedingMonthDay_26 = 'SUCCEEDING_MONTH_DAY_26',
  SucceedingMonthDay_27 = 'SUCCEEDING_MONTH_DAY_27',
  SucceedingMonthDay_28 = 'SUCCEEDING_MONTH_DAY_28',
  SucceedingMonthDay_29 = 'SUCCEEDING_MONTH_DAY_29',
  SucceedingMonthDay_30 = 'SUCCEEDING_MONTH_DAY_30',
  WorkedMonthLastDay = 'WORKED_MONTH_LAST_DAY'
}

export enum EngagementProbationPeriodType {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type EngagementRemoteWorkCostAllowancePolicyInputType = {
  /** Policy indicating the allowance the customer will receive from the company */
  allowancePolicy: ReimbursementPolicyEnum;
  /** The amount the customer will pay, or top-up, to its team member accordingly to the selected allowance type */
  allowancePolicySubunit?: InputMaybe<Scalars['MoneyInt']['input']>;
};

export type EngagementRemoteWorkCostAllowancePolicyObjectType = EngagementRemoteWorkCostsBaseObjectInterface & {
  __typename?: 'EngagementRemoteWorkCostAllowancePolicyObjectType';
  /** Indicates if the current Remote Work Cost is active and applied to the employment */
  active: Scalars['Boolean']['output'];
  /** Policy indicating the allowance the customer will receive from the company, it can be statutory (read-only) or not */
  allowancePolicy?: Maybe<ReimbursementPolicyEnum>;
  /** The total amount the customer will pay to its team member accordingly to the selected allowance type */
  allowancePolicySubunit: Scalars['MoneyInt']['output'];
  /** Returns the valid types of allowance policies which this Remote Work Cost can be switched to when editing it */
  compatibleAllowancePolicies?: Maybe<Array<ReimbursementPolicyEnum>>;
  /** Returns the valid types of equipment policies which this Remote Work Cost can we switched when editing it */
  compatibleEquipmentPolicies?: Maybe<Array<EquipmentPolicyEnum>>;
  /**
   * Returns true if the employment originates from an employment template and the
   * policy varies from that template. Otherwise, it returns false.
   */
  editedAfterCreationFromTemplate: Scalars['Boolean']['output'];
  /** Indicates if this policy is statutory according to the team member region and laws */
  isStatutory: Scalars['Boolean']['output'];
  /** Indicates if the current Remote Work Cost is selectable to the current employment */
  selectable: Scalars['Boolean']['output'];
  /** The statutory amount the customer have to pay to its team member accordingly to its region, if required */
  statutoryPolicySubunit: Scalars['MoneyInt']['output'];
  /** The amount the customer will top-up to its team member accordingly the team member region and allowance policy */
  topUpPolicySubunit: Scalars['MoneyInt']['output'];
};

export type EngagementRemoteWorkCostEquipmentBudgetObjectType = EngagementRemoteWorkCostsBaseObjectInterface & {
  __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType';
  /** Indicates if the current Remote Work Cost is active and applied to the employment */
  active: Scalars['Boolean']['output'];
  /** Returns the valid types of allowance policies which this Remote Work Cost can be switched to when editing it */
  compatibleAllowancePolicies?: Maybe<Array<ReimbursementPolicyEnum>>;
  /** Returns the valid types of equipment policies which this Remote Work Cost can we switched when editing it */
  compatibleEquipmentPolicies?: Maybe<Array<EquipmentPolicyEnum>>;
  /**
   * Returns true if the employment originates from an employment template and the
   * policy varies from that template. Otherwise, it returns false.
   */
  editedAfterCreationFromTemplate: Scalars['Boolean']['output'];
  /** The maximum amount of equipment budget the customer will reimburse its team member for equipment purchases */
  equipmentBudgetSubunit?: Maybe<Scalars['MoneyInt']['output']>;
  /** Indicates if the current Remote Work Cost is selectable to the current employment */
  selectable: Scalars['Boolean']['output'];
};

export type EngagementRemoteWorkCostEquipmentInputType = {
  /** An array of EquipmentListEnum items assigned to the team member */
  equipmentList: Array<EquipmentListEnum>;
  /** Any other equipment assigned to the team member which is not present in the EquipmentListEnum list */
  equipmentOther?: InputMaybe<Scalars['String']['input']>;
};

export type EngagementRemoteWorkCostEquipmentObjectType = EngagementRemoteWorkCostsBaseObjectInterface & EquipmentsInterface & {
  __typename?: 'EngagementRemoteWorkCostEquipmentObjectType';
  /** Indicates if the current Remote Work Cost is active and applied to the employment */
  active: Scalars['Boolean']['output'];
  /** Returns the valid types of allowance policies which this Remote Work Cost can be switched to when editing it */
  compatibleAllowancePolicies?: Maybe<Array<ReimbursementPolicyEnum>>;
  /** Returns the valid types of equipment policies which this Remote Work Cost can we switched when editing it */
  compatibleEquipmentPolicies?: Maybe<Array<EquipmentPolicyEnum>>;
  /**
   * Returns true if the employment originates from an employment template and the
   * policy varies from that template. Otherwise, it returns false.
   */
  editedAfterCreationFromTemplate: Scalars['Boolean']['output'];
  /** An array of EquipmentListEnum items assigned to the team member */
  equipmentList?: Maybe<Array<EquipmentListEnum>>;
  /** Any other equipment assigned to the team member which is not present in the EquipmentListEnum list */
  equipmentOther?: Maybe<Scalars['String']['output']>;
  /** Indicates if the current Remote Work Cost is selectable to the current employment */
  selectable: Scalars['Boolean']['output'];
};

export type EngagementRemoteWorkCostInputType = {
  /** Receives the allowance policy along with its amount, which the customer provides to its team member */
  allowancePolicy?: InputMaybe<EngagementRemoteWorkCostAllowancePolicyInputType>;
  /**
   * Receives the reimbursement amount, which the customer provides to its team
   * member, or null if the customer doesn't provide a reimbursement
   */
  equipmentBudgetSubunit?: InputMaybe<Scalars['MoneyInt']['input']>;
  /**
   * Receives an object containing the equipment list owned by the team member
   * and an optional string containing other equipment, or null if the team member doesn't provide an equipment list
   */
  equipmentListOwnedByTeamMember?: InputMaybe<EngagementRemoteWorkCostEquipmentInputType>;
  /**
   * Receives an object containing the equipment list provided by the customer
   * to its team member and an optional string containing other equipment, or null
   * if the customer doesn't provide an equipment list
   */
  equipmentListProvidedByCustomer?: InputMaybe<EngagementRemoteWorkCostEquipmentInputType>;
  /**
   * Receives the one-time payment amount, which the customer provides to its team
   * member, or null if the customer doesn't provide a one-time payment amount
   */
  equipmentOneTimePaymentSubunit?: InputMaybe<Scalars['MoneyInt']['input']>;
};

export type EngagementRemoteWorkCostObjectType = {
  __typename?: 'EngagementRemoteWorkCostObjectType';
  /**
   * Returns allowance policy along with its amount, which the customer provides to
   * its team member, or null if the customer doesn't provide an allowance policy
   */
  allowancePolicy?: Maybe<EngagementRemoteWorkCostAllowancePolicyObjectType>;
  /**
   * Returns the reimbursement amount, which the customer provides to its team
   * member, or null if the customer doesn't provide a reimbursement
   */
  equipmentBudget?: Maybe<EngagementRemoteWorkCostEquipmentBudgetObjectType>;
  /**
   * Returns an object containing the equipment list owned by the team member
   * and an string containing other equipment, or null if the team member doesn't provide an equipment list
   */
  equipmentListOwnedByTeamMember?: Maybe<EngagementRemoteWorkCostEquipmentObjectType>;
  /**
   * Returns an object containing the equipment list provided by the customer to its team member
   * and an string containing other equipment, or null if the customer doesn't provide an equipment list
   */
  equipmentListProvidedByCustomer?: Maybe<EngagementRemoteWorkCostEquipmentObjectType>;
  /**
   * Returns the one-time payment amount, which the customer provides to its team
   * member, or null if the customer doesn't provide a one-time payment
   */
  equipmentOneTimePayment?: Maybe<EngagementRemoteWorkCostEquipmentBudgetObjectType>;
};

export type EngagementRemoteWorkCostsBaseObjectInterface = {
  /** Indicates if the current Remote Work Cost is active and applied to the employment */
  active: Scalars['Boolean']['output'];
  /** Returns the valid types of allowance policies which this Remote Work Cost can be switched to when editing it */
  compatibleAllowancePolicies?: Maybe<Array<ReimbursementPolicyEnum>>;
  /** Returns the valid types of equipment policies which this Remote Work Cost can we switched when editing it */
  compatibleEquipmentPolicies?: Maybe<Array<EquipmentPolicyEnum>>;
  /**
   * Returns true if the employment originates from an employment template and the
   * policy varies from that template. Otherwise, it returns false.
   */
  editedAfterCreationFromTemplate: Scalars['Boolean']['output'];
  /** Indicates if the current Remote Work Cost is selectable to the current employment */
  selectable: Scalars['Boolean']['output'];
};

export enum EngagementSeniorityLevelType {
  Csuite = 'CSUITE',
  Director = 'DIRECTOR',
  Head = 'HEAD',
  Junior = 'JUNIOR',
  Lead = 'LEAD',
  Mid = 'MID',
  Principal = 'PRINCIPAL',
  Senior = 'SENIOR',
  Vp = 'VP'
}

export enum EngagementState {
  AssistedSetup = 'ASSISTED_SETUP',
  Canceled = 'CANCELED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Engaged = 'ENGAGED',
  InProgress = 'IN_PROGRESS',
  OnHold = 'ON_HOLD',
  Terminated = 'TERMINATED',
  WaitingForSignature = 'WAITING_FOR_SIGNATURE'
}

export type EngagementStateTransition = {
  __typename?: 'EngagementStateTransition';
  allowed: Scalars['Boolean']['output'];
  state: EngagementState;
};

export enum EngagementType {
  Contract = 'CONTRACT',
  Employment = 'EMPLOYMENT'
}

/** Autogenerated input type of EnrolPackage */
export type EnrolPackageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
  plansCostContribution?: InputMaybe<Array<BenefitsEnrollmentCostContributionInput>>;
};

/** Autogenerated return type of EnrolPackage. */
export type EnrolPackagePayload = {
  __typename?: 'EnrolPackagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of EnrollDependents */
export type EnrollDependentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dependentIds: Array<Scalars['ID']['input']>;
  enrollmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnrollDependents. */
export type EnrollDependentsPayload = {
  __typename?: 'EnrollDependentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  enrollment?: Maybe<BenefitsEnrollment>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of EnrollTeamMember */
export type EnrollTeamMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  costContributions?: InputMaybe<Array<BenefitsEnrollmentCostContributorInput>>;
  dependentsEmployerContribution?: InputMaybe<Scalars['Float']['input']>;
  dependentsEmployerContributionMaxCount?: InputMaybe<Scalars['Int']['input']>;
  employerContribution?: InputMaybe<Scalars['Float']['input']>;
  engagementId: Scalars['ID']['input'];
  enrollmentPrices?: InputMaybe<Array<BenefitsEnrollmentPriceInput>>;
  planId: Scalars['ID']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of EnrollTeamMember. */
export type EnrollTeamMemberPayload = {
  __typename?: 'EnrollTeamMemberPayload';
  benefitEnrollment?: Maybe<BenefitsEnrollment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type EnrollmentCancellationInput = {
  coverageEndDate: Scalars['ISO8601Date']['input'];
  enrollmentId: Scalars['ID']['input'];
};

export type EnrollmentHistoryEntry = {
  __typename?: 'EnrollmentHistoryEntry';
  changedAt: Scalars['ISO8601DateTime']['output'];
  changedField: Scalars['String']['output'];
  changedFrom?: Maybe<Scalars['String']['output']>;
  changedOn?: Maybe<Scalars['String']['output']>;
  changedTo?: Maybe<Scalars['String']['output']>;
  effectiveDate: Scalars['ISO8601Date']['output'];
  event: Scalars['String']['output'];
  holderName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  oysterStaff: Scalars['Boolean']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  whatdunnit?: Maybe<Scalars['String']['output']>;
};

export type EntitlementAdjustment = {
  __typename?: 'EntitlementAdjustment';
  amountDays: Scalars['Float']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  oysterCreated?: Maybe<Scalars['Boolean']['output']>;
  reason: TimeOffTransactionReasonEnumType;
};

export type EntitlementCounts = {
  __typename?: 'EntitlementCounts';
  availableBalance: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  daysAccrued: Scalars['Float']['output'];
  daysAccruedUnavailable: Scalars['Float']['output'];
  daysAdjustedAdhoc: Scalars['Float']['output'];
  daysCarried: Scalars['Float']['output'];
  daysOfAnnualEntitlement: Scalars['Float']['output'];
  daysTaken: Scalars['Float']['output'];
  daysUpcoming: Scalars['Float']['output'];
};

export type Envelope = {
  __typename?: 'Envelope';
  automationState: EnvelopeAutomationStateEnum;
  currentSigners: Array<EnvelopeRecipientType>;
  envelopeType: EnvelopeTypeEnum;
  events: Array<EnvelopeEventType>;
  id: Scalars['ID']['output'];
  isUpdateNeeded: Scalars['Boolean']['output'];
  lastEmailAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  recipients: Array<EnvelopeRecipientType>;
  state: EnvelopeStateEnum;
};

export enum EnvelopeAutomationStateEnum {
  Idle = 'IDLE',
  Resending = 'RESENDING',
  ResendFailed = 'RESEND_FAILED',
  Sending = 'SENDING',
  SendFailed = 'SEND_FAILED',
  UpdateFailed = 'UPDATE_FAILED',
  Updating = 'UPDATING',
  WebhookProcessingFailed = 'WEBHOOK_PROCESSING_FAILED'
}

export type EnvelopeEventType = {
  __typename?: 'EnvelopeEventType';
  actorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventType: EnvelopeEventTypeEnum;
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export enum EnvelopeEventTypeEnum {
  Created = 'CREATED',
  Declined = 'DECLINED',
  Reassigned = 'REASSIGNED',
  RecipientSigned = 'RECIPIENT_SIGNED',
  Resent = 'RESENT',
  Sent = 'SENT',
  Signed = 'SIGNED',
  SignerUpdated = 'SIGNER_UPDATED',
  Updated = 'UPDATED',
  Voided = 'VOIDED'
}

export enum EnvelopeRecipientStatusEnum {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type EnvelopeRecipientType = {
  __typename?: 'EnvelopeRecipientType';
  eSignType?: Maybe<AgreementESignTypeEnum>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<AgreementPartyTypeEnum>;
  recipientType: EnvelopeRecipientTypeEnum;
  status?: Maybe<EnvelopeRecipientStatusEnum>;
  verificationCode?: Maybe<Scalars['String']['output']>;
};

export enum EnvelopeRecipientTypeEnum {
  Cc = 'CC',
  Signer = 'SIGNER'
}

export enum EnvelopeStateEnum {
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Sent = 'SENT',
  Signed = 'SIGNED',
  Voided = 'VOIDED'
}

export enum EnvelopeTypeEnum {
  ContractorAgreementAmendmentEnvelope = 'CONTRACTOR_AGREEMENT_AMENDMENT_ENVELOPE',
  ContractorMergedAgreementEnvelope = 'CONTRACTOR_MERGED_AGREEMENT_ENVELOPE',
  EmploymentAgreements = 'EMPLOYMENT_AGREEMENTS',
  EmploymentAgreementAmendmentEnvelope = 'EMPLOYMENT_AGREEMENT_AMENDMENT_ENVELOPE',
  IntentLetter = 'INTENT_LETTER',
  SepaMandateAgreementEnvelope = 'SEPA_MANDATE_AGREEMENT_ENVELOPE',
  ServiceAgreement = 'SERVICE_AGREEMENT',
  TerminationOfServiceAgreement = 'TERMINATION_OF_SERVICE_AGREEMENT'
}

export enum EorCountryHiringConfidenceEnumType {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export enum EorCountryReadyToHireEnum {
  ReadyToHireNo = 'READY_TO_HIRE_NO',
  ReadyToHireYes = 'READY_TO_HIRE_YES',
  ReadyToHireYesWithCaveat = 'READY_TO_HIRE_YES_WITH_CAVEAT'
}

export enum EquipmentListEnum {
  ComputerMonitor = 'COMPUTER_MONITOR',
  Headset = 'HEADSET',
  Keyboard = 'KEYBOARD',
  LaptopComputer = 'LAPTOP_COMPUTER',
  MobilePhone = 'MOBILE_PHONE',
  Mouse = 'MOUSE',
  Printer = 'PRINTER'
}

export enum EquipmentPolicyEnum {
  BringYourOwn = 'BRING_YOUR_OWN',
  EquipmentBudget = 'EQUIPMENT_BUDGET',
  EquipmentOneTimePayment = 'EQUIPMENT_ONE_TIME_PAYMENT',
  EquipmentProvided = 'EQUIPMENT_PROVIDED'
}

export type EquipmentsInterface = {
  /** An array of EquipmentListEnum items assigned to the team member */
  equipmentList?: Maybe<Array<EquipmentListEnum>>;
  /** Any other equipment assigned to the team member which is not present in the EquipmentListEnum list */
  equipmentOther?: Maybe<Scalars['String']['output']>;
};

export type EquityCartaIntegration = {
  __typename?: 'EquityCartaIntegration';
  authRequestUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** When the integration's data was last synced from Carta */
  lastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type EquityCartaStakeholder = {
  __typename?: 'EquityCartaStakeholder';
  email: Scalars['String']['output'];
  employeeId: Scalars['String']['output'];
  engagement?: Maybe<Engagement>;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  issuerId: Scalars['String']['output'];
};

export type EquityCartaStakeholderCollection = {
  __typename?: 'EquityCartaStakeholderCollection';
  nextPageToken?: Maybe<Scalars['String']['output']>;
  stakeholders: Array<EquityCartaStakeholder>;
};

export type EquityCompanyPlan = {
  __typename?: 'EquityCompanyPlan';
  company?: Maybe<Company>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonJobTitle?: Maybe<Scalars['String']['output']>;
  contactPersonName?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Document>>;
  equityManagementSoftwareName?: Maybe<Array<Scalars['String']['output']>>;
  grantorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  planName?: Maybe<Scalars['String']['output']>;
  vestingCliffMonths?: Maybe<Scalars['Int']['output']>;
  vestingCliffShares?: Maybe<Scalars['Float']['output']>;
  vestingScheduleMonths?: Maybe<Scalars['Int']['output']>;
};

export type EquityCompanyValuation = {
  __typename?: 'EquityCompanyValuation';
  company: Company;
  documents?: Maybe<Array<Document>>;
  effectiveDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  valuation: Money;
};

export type EquityCountryTax = {
  __typename?: 'EquityCountryTax';
  /** This is the country code in ISO 3166-1 alpha-2 format */
  countryCode?: Maybe<Scalars['String']['output']>;
  csh?: Maybe<EquityTax>;
  rsu?: Maybe<EquityTax>;
  sop?: Maybe<EquityTax>;
};

export type EquityGrant = {
  __typename?: 'EquityGrant';
  authorizations?: Maybe<Authorization>;
  companyValuation?: Maybe<EquityCompanyValuation>;
  /** Country Code  */
  countryCode: Scalars['String']['output'];
  /** Equity grant created at date */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  documents?: Maybe<Array<Document>>;
  /** Early Exercise Event */
  earlyExerciseEvent?: Maybe<Array<Scalars['String']['output']>>;
  engagement: Engagement;
  /** TM Engagement ID */
  engagementId: Scalars['ID']['output'];
  /** Equity Sub Type */
  equitySubType?: Maybe<EquitySubTypeEnum>;
  /** Equity Type */
  equityType: EquityTypeEnum;
  /** Amount of grant worth */
  grantAmount?: Maybe<Money>;
  /** Granted on Date */
  grantDate: Scalars['ISO8601Date']['output'];
  /** Amount of shares granted */
  grantShares?: Maybe<Scalars['Float']['output']>;
  /** Checks if the customer granted the equity in the software */
  grantedInSoftware: Scalars['Boolean']['output'];
  /** Composite ID */
  id: Scalars['ID']['output'];
  /** Equity Plan Type */
  planType: EquityPlanTypeEnum;
  /** Recurring or One Time grant */
  recurring: Scalars['Boolean']['output'];
  sharesExercisable: Scalars['Float']['output'];
  sharesExercised: Scalars['Float']['output'];
  sharesVested: Scalars['Float']['output'];
  /** To get the source of the grant */
  source?: Maybe<Scalars['String']['output']>;
  /** Grant Letter signing status */
  status: EquityStatusEnum;
  vestingCliffMonths?: Maybe<Scalars['Int']['output']>;
  /** Grant Vesting cliff shares */
  vestingCliffShares?: Maybe<Scalars['Float']['output']>;
  vestingScheduleMonths?: Maybe<Scalars['Int']['output']>;
  /** Vesting Started on Date */
  vestingStartDate: Scalars['ISO8601Date']['output'];
};

export type EquityGrantCollection = {
  __typename?: 'EquityGrantCollection';
  collection: Array<EquityGrant>;
  metadata: CollectionMetadata;
};

export type EquityIssue = {
  __typename?: 'EquityIssue';
  authorizations?: Maybe<Authorization>;
  /** This is the country code in ISO 3166-1 alpha-2 format */
  countryCode: Scalars['String']['output'];
  /** This number represents the risk for the given issue. Lowest risk: 1, Highest risk: 3 */
  heatmapScale?: Maybe<Scalars['Int']['output']>;
  /** HTML formatted description of the issue */
  htmlBody?: Maybe<Scalars['String']['output']>;
  /** Identifier for the given equity issue */
  id: Scalars['ID']['output'];
  /** The phases this issue applies to. Possible values: 1-4 */
  phases?: Maybe<Array<Scalars['Int']['output']>>;
  /** Plans affected by the issue. Posible plans: ["SOP", "RSU", "CSH"] */
  plans: Array<EquityTypeEnum>;
  /** Who is responsible for this issue. Possible values: LOC (Local Company), PAR (Parent Company), EMP (Employee) */
  responsibilityParty?: Maybe<ResponsibilityEnum>;
  /** Issue's title */
  title?: Maybe<Scalars['String']['output']>;
};

export type EquityIssueHeatmapItem = {
  __typename?: 'EquityIssueHeatmapItem';
  /** This is the country code in ISO 3166-1 alpha-2 format */
  countryCode: Scalars['String']['output'];
  /** This number represents the risk for the given country to provide CASH plans. Lowest risk: 1, Highest risk: 3 */
  cshRiskTier: Scalars['Int']['output'];
  /**
   * This number represents the risk for the given country to provide RESTRICTED
   * STOCK UNIT plans. Lowest risk: 1, Highest risk: 3
   */
  rsuRiskTier: Scalars['Int']['output'];
  /** This number represents the risk for the given country to provide STOCK OPTIONS plans. Lowest risk: 1, Highest risk: 3 */
  sopRiskTier: Scalars['Int']['output'];
  /** This flag indicates whether a Country is supported by Oyster */
  supported: Scalars['Boolean']['output'];
};

export type EquityPayrollProvider = {
  __typename?: 'EquityPayrollProvider';
  authorizations?: Maybe<Authorization>;
  countryCodes: Array<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum EquityPlanTypeEnum {
  GroupPlan = 'GROUP_PLAN',
  IndividualPlan = 'INDIVIDUAL_PLAN'
}

export enum EquityStatusEnum {
  Declined = 'DECLINED',
  Done = 'DONE',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  ReadyForSignature = 'READY_FOR_SIGNATURE'
}

export enum EquitySubTypeEnum {
  Csop = 'CSOP',
  Esop = 'ESOP',
  Espp = 'ESPP',
  Iso = 'ISO',
  Nso = 'NSO',
  Other = 'OTHER',
  Vsop = 'VSOP'
}

export type EquitySyncError = {
  __typename?: 'EquitySyncError';
  engagement: Engagement;
  id: Scalars['ID']['output'];
  syncedAtDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type EquityTax = {
  __typename?: 'EquityTax';
  capitalGainsTax: EquityTaxTimePhase;
  employeeSocialTax: EquityTaxTimePhase;
  employerSocialTax: EquityTaxTimePhase;
  incomeTax: EquityTaxTimePhase;
  otherTax: EquityTaxTimePhase;
};

export type EquityTaxEvent = {
  __typename?: 'EquityTaxEvent';
  /**
   * Means that there is a maximum amount the taxpayer will have to satisfy, as
   * opposed to a flat rate with no maximum. Other sources of income could come
   * into play as well.
   */
  capped?: Maybe<Scalars['Int']['output']>;
  /** This is the country code in ISO 3166-1 alpha-2 format */
  countryCode?: Maybe<Scalars['String']['output']>;
  /**
   * These are optional notes. For some common rates there is no need for them.
   * While for other items (mainly the ones typed 'Other' those notes may be the only content.
   */
  htmlBody?: Maybe<Scalars['String']['output']>;
  /** It tells for which plans is the tax event applied. Possible plans: SOP, RSU, CSH */
  plans?: Maybe<Array<Scalars['String']['output']>>;
  /** N/A */
  rate?: Maybe<Scalars['Int']['output']>;
  /** Indicates who pays the tax. */
  responsibility?: Maybe<Scalars['String']['output']>;
  /**
   * Represents the event type. Possible types:
   * Capital Gains => CGT
   * Employer Social Tax => ESO
   * Employee Social Tax => SOC
   * Income Tax => INC
   * Other => OTH
   */
  taxEventType?: Maybe<Scalars['String']['output']>;
  /**
   * This number is the point in time (in an equity compensation offer's life cycle). The names we use are as follows:
   *                              0	    |   1	 |     2	   |  3	  |   4
   * ----------------------------------------------------------------------
   * Cash Plan	             | all phases | award | receipt	 |  -	  | leavers
   * Restricted Stock Units | all phases | award | vesting	 | sale | leavers
   * Stock Option Plan	     | all phases | grant | exercise | sale | leavers
   */
  timePhase?: Maybe<Scalars['Int']['output']>;
  /** Title of the tax event. It can be NULL */
  title?: Maybe<Scalars['String']['output']>;
};

export type EquityTaxTimePhase = {
  __typename?: 'EquityTaxTimePhase';
  allPhases: Array<EquityTaxEvent>;
  phaseFour: Array<EquityTaxEvent>;
  phaseOne: Array<EquityTaxEvent>;
  phaseThree: Array<EquityTaxEvent>;
  phaseTwo: Array<EquityTaxEvent>;
};

export enum EquityTypeEnum {
  Csh = 'CSH',
  Rsu = 'RSU',
  Sop = 'SOP'
}

export type EquityWithholdingRequest = {
  __typename?: 'EquityWithholdingRequest';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  authorizations?: Maybe<Authorization>;
  company: Company;
  countryCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  documents?: Maybe<Array<Document>>;
  earlyExerciseEvent?: Maybe<Scalars['String']['output']>;
  engagement: Engagement;
  exerciseDate: Scalars['ISO8601DateTime']['output'];
  fairMarketValue: Money;
  grant: EquityGrant;
  /** Composite ID */
  id: Scalars['ID']['output'];
  /** Shares being exercised in this event */
  shares: Scalars['Float']['output'];
  source?: Maybe<Scalars['String']['output']>;
  status: EquityWithholdingRequestStatusEnum;
};

export type EquityWithholdingRequestCollection = {
  __typename?: 'EquityWithholdingRequestCollection';
  collection: Array<EquityWithholdingRequest>;
  metadata: CollectionMetadata;
};

export enum EquityWithholdingRequestStatusEnum {
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  Draft = 'DRAFT',
  Processing = 'PROCESSING'
}

export enum ExchangeRateTypeEnum {
  Contractors = 'CONTRACTORS',
  FullTimeEmployees = 'FULL_TIME_EMPLOYEES'
}

/** Autogenerated input type of ExecuteActionLink */
export type ExecuteActionLinkInput = {
  actionLinkSgid: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ExecuteActionLink. */
export type ExecuteActionLinkPayload = {
  __typename?: 'ExecuteActionLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  results: ExecutionResults;
};

export type ExecutionResults = {
  __typename?: 'ExecutionResults';
  description?: Maybe<Scalars['String']['output']>;
  detailsUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ExemptionForm = {
  __typename?: 'ExemptionForm';
  engagementAttributesSnapshot?: Maybe<ExemptionFormEngagementSnapshotCollection>;
  responses?: Maybe<ExemptionFormResponseCollection>;
  submittedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  typeformHiddenFields?: Maybe<ExemptionFormTypeformHiddenFields>;
};


export type ExemptionFormEngagementAttributesSnapshotArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type ExemptionFormResponsesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type ExemptionFormEngagementSnapshot = {
  __typename?: 'ExemptionFormEngagementSnapshot';
  fieldName: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ExemptionFormEngagementSnapshotCollection = {
  __typename?: 'ExemptionFormEngagementSnapshotCollection';
  collection: Array<ExemptionFormEngagementSnapshot>;
  metadata: CollectionMetadata;
};

export type ExemptionFormResponse = {
  __typename?: 'ExemptionFormResponse';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type ExemptionFormResponseCollection = {
  __typename?: 'ExemptionFormResponseCollection';
  collection: Array<ExemptionFormResponse>;
  metadata: CollectionMetadata;
};

export type ExemptionFormTypeformHiddenFields = {
  __typename?: 'ExemptionFormTypeformHiddenFields';
  annualSalaryAdministrative: Scalars['String']['output'];
  annualSalaryAdministrativeNyOther?: Maybe<Scalars['String']['output']>;
  annualSalaryComputers: Scalars['String']['output'];
  annualSalaryComputersNyOther?: Maybe<Scalars['String']['output']>;
  annualSalaryCreatives: Scalars['String']['output'];
  annualSalaryCreativesNyOther?: Maybe<Scalars['String']['output']>;
  annualSalaryExecutives: Scalars['String']['output'];
  annualSalaryExecutivesNyOther?: Maybe<Scalars['String']['output']>;
  annualSalaryLearned: Scalars['String']['output'];
  annualSalaryLearnedNyOther?: Maybe<Scalars['String']['output']>;
  hourlyRateAdministrative: Scalars['String']['output'];
  hourlyRateAdministrativeNyOther?: Maybe<Scalars['String']['output']>;
  hourlyRateComputers: Scalars['String']['output'];
  hourlyRateComputersNyOther?: Maybe<Scalars['String']['output']>;
  hourlyRateCreatives: Scalars['String']['output'];
  hourlyRateCreativesNyOther?: Maybe<Scalars['String']['output']>;
  hourlyRateExecutives: Scalars['String']['output'];
  hourlyRateExecutivesNyOther?: Maybe<Scalars['String']['output']>;
  hourlyRateLearned: Scalars['String']['output'];
  hourlyRateLearnedNyOther?: Maybe<Scalars['String']['output']>;
  salaryType: Scalars['String']['output'];
};

export type Expense = {
  __typename?: 'Expense';
  amount: Scalars['Float']['output'];
  amountCurrencyCode: Scalars['String']['output'];
  approver?: Maybe<ExpenseApprover>;
  authorizations?: Maybe<Authorization>;
  category: ExpenseCategory;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creator?: Maybe<ExpenseCreator>;
  declineReason?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  engagement: Engagement;
  expenseDate: Scalars['ISO8601Date']['output'];
  id: Scalars['String']['output'];
  invoice?: Maybe<Invoice>;
  isDeletable: Scalars['Boolean']['output'];
  isReviewable: Scalars['Boolean']['output'];
  payout?: Maybe<Money>;
  receipt?: Maybe<DownloadLink>;
  reviewState: ExpenseReviewState;
  reviewedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  sentToEorAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  source?: Maybe<ExpenseSourceEnumType>;
  state: ExpenseStateEnumType;
  submittedAt: Scalars['ISO8601DateTime']['output'];
  syncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  targetPaymentDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  title: Scalars['String']['output'];
  viewCategory: Scalars['String']['output'];
};

export type ExpenseApprover = {
  __typename?: 'ExpenseApprover';
  authorizations?: Maybe<Authorization>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum ExpenseCategory {
  Benefits = 'BENEFITS',
  Car = 'CAR',
  Equipment = 'EQUIPMENT',
  Food = 'FOOD',
  HomeOffice = 'HOME_OFFICE',
  LearningAndDevelopment = 'LEARNING_AND_DEVELOPMENT',
  OfficeSupplies = 'OFFICE_SUPPLIES',
  Other = 'OTHER',
  Rent = 'RENT',
  Travel = 'TRAVEL'
}

export type ExpenseCollection = {
  __typename?: 'ExpenseCollection';
  collection: Array<Expense>;
  metadata: CollectionMetadata;
};

export type ExpenseCreator = {
  __typename?: 'ExpenseCreator';
  authorizations?: Maybe<Authorization>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ExpenseReimbursementBalance = {
  __typename?: 'ExpenseReimbursementBalance';
  /** The composite ID of an expense */
  expenseId: Scalars['ID']['output'];
  /** balance of corresponding budget if exists and effective */
  reimbursementBalance: ReimbursementBalance;
};

export enum ExpenseReviewState {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Unreviewed = 'UNREVIEWED'
}

export enum ExpenseSourceEnumType {
  Concur = 'CONCUR',
  Expensify = 'EXPENSIFY',
  Oyster = 'OYSTER'
}

export enum ExpenseStateEnumType {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Paid = 'PAID',
  Pending = 'PENDING',
  SentToVendor = 'SENT_TO_VENDOR'
}

export enum ExpenseTransitionEvent {
  Approve = 'APPROVE',
  Decline = 'DECLINE',
  UndoReview = 'UNDO_REVIEW'
}

export type ExpensesEngagementMappingType = {
  __typename?: 'ExpensesEngagementMappingType';
  engagement: Engagement;
  mapped: Scalars['Boolean']['output'];
};

export type ExpensesEngagementMappingTypeCollection = {
  __typename?: 'ExpensesEngagementMappingTypeCollection';
  collection: Array<ExpensesEngagementMappingType>;
  metadata: CollectionMetadata;
};

export enum ExpensesIntegrationSyncDataTypeEnum {
  Employees = 'EMPLOYEES',
  Policies = 'POLICIES'
}

export type ExpensesIntegrationType = {
  __typename?: 'ExpensesIntegrationType';
  /** List of alerts for the current integration */
  alerts: Array<Alert>;
  /** Integration credentials to authorize API requests */
  credentials: ExpensifyCredentialsType;
  /** List of engagements with the information if they are mapped to an employee or not in Expensify */
  engagementsMappings: Array<ExpensesEngagementMappingType>;
  /** Integration platform identifier which represents certain integration (e.g. expensify) */
  platform: Scalars['String']['output'];
  /** Policies for current integration */
  policies: Array<ExpensifyPolicyType>;
  /** Integration state which describes if integration is active, pending etc */
  state: Scalars['String']['output'];
  /** Useful stats about the integration, such as last-synced-at timestamps */
  stats: ExpensifyStatsType;
};

export type ExpensifyCredentialsInput = {
  /** Credentials identifier needed for API requests to Expensify */
  partnerUserId: Scalars['String']['input'];
  /** Credentials token needed for API requests to Expensify */
  partnerUserSecret: Scalars['String']['input'];
};

export type ExpensifyCredentialsType = {
  __typename?: 'ExpensifyCredentialsType';
  /** Credentials identifier needed for API requests to Expensify */
  partnerUserId: Scalars['String']['output'];
  /** Credentials token needed for API requests to Expensify */
  partnerUserSecret: Scalars['String']['output'];
};

export type ExpensifyPolicyType = {
  __typename?: 'ExpensifyPolicyType';
  /** Identifier of the policy provided by Expensify, unique for the Expensify integration */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /**
   * Selected policy in Oyster context means that integration knows
   * which policies it can use to get expenses reports.
   */
  selected: Scalars['Boolean']['output'];
};

export type ExpensifyStatsType = {
  __typename?: 'ExpensifyStatsType';
  /** Last timestamp in which engagements were mapped to employees */
  engagementsLastMappedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Last timestamp in which the Expensify policies have been synced */
  policiesLastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of ExportDocxForAgreement */
export type ExportDocxForAgreementInput = {
  agreement: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ExportDocxForAgreement. */
export type ExportDocxForAgreementPayload = {
  __typename?: 'ExportDocxForAgreementPayload';
  agreement?: Maybe<Agreement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type ExternalPointOfContact = AuditableObject & {
  __typename?: 'ExternalPointOfContact';
  areasOfDomain: Array<Scalars['String']['output']>;
  auditHistory: Array<AuditItem>;
  authorizations?: Maybe<Authorization>;
  backupEmail?: Maybe<Scalars['String']['output']>;
  backupJobTitle?: Maybe<Scalars['String']['output']>;
  backupName?: Maybe<Scalars['String']['output']>;
  backupPhoneCountryCode?: Maybe<Scalars['String']['output']>;
  backupPhoneNumber?: Maybe<Scalars['String']['output']>;
  company: Company;
  countries: Array<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customerNotes?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  includedInServiceComms: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedBy?: Maybe<UserBasic>;
};


export type ExternalPointOfContactAuditHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  only?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExternalPointOfContactCollection = {
  __typename?: 'ExternalPointOfContactCollection';
  collection: Array<ExternalPointOfContact>;
  metadata: CollectionMetadata;
};

export type ExternalTool = {
  __typename?: 'ExternalTool';
  description?: Maybe<Scalars['String']['output']>;
  eor: EmployerOfRecord;
  id: Scalars['ID']['output'];
  toolType: ExternalToolTypeEnum;
  url: Scalars['String']['output'];
};

export type ExternalToolCollection = {
  __typename?: 'ExternalToolCollection';
  collection: Array<ExternalTool>;
  metadata: CollectionMetadata;
};

export type ExternalToolInputType = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  toolType: ExternalToolTypeEnum;
  url: Scalars['String']['input'];
};

export enum ExternalToolTypeEnum {
  Expenses = 'EXPENSES',
  Payroll = 'PAYROLL',
  Timesheet = 'TIMESHEET',
  TimeOff = 'TIME_OFF'
}

export type FxMarkupAdjustment = {
  __typename?: 'FXMarkupAdjustment';
  adjustmentType: FxMarkupAdjustmentTypeEnum;
  adjustmentValue: Scalars['Float']['output'];
  company: Company;
  id: Scalars['ID']['output'];
};

export enum FxMarkupAdjustmentTypeEnum {
  DiscountPercentage = 'DISCOUNT_PERCENTAGE',
  ExtraCostPercentage = 'EXTRA_COST_PERCENTAGE'
}

export type FxMarkupGroup = {
  __typename?: 'FXMarkupGroup';
  authorizations?: Maybe<Authorization>;
  groupType: FxMarkupGroupTypeEnum;
  id: Scalars['ID']['output'];
  marginPercentage: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export enum FxMarkupGroupTypeEnum {
  Custom = 'CUSTOM',
  Default = 'DEFAULT',
  Standard = 'STANDARD'
}

export type FxMarkupPair = {
  __typename?: 'FXMarkupPair';
  authorizations?: Maybe<Authorization>;
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  marginPercentage: Scalars['Float']['output'];
  markupGroup: FxMarkupGroup;
  to: Scalars['String']['output'];
};

export type FxMarkupPairCollection = {
  __typename?: 'FXMarkupPairCollection';
  collection: Array<FxMarkupPair>;
  metadata: CollectionMetadata;
};

export enum FeatureFlag {
  /** Used for Beta Integrations, ADP Workforcenow (oysterhr/iam) */
  AdpworkforcenowhrisIntegration = 'ADPWORKFORCENOWHRIS_INTEGRATION',
  /** Enables the Oyster AI widget on every page (oysterhr/intelligence-ai) */
  AiEverywhereInAnywhere = 'AI_EVERYWHERE_IN_ANYWHERE',
  /** Enables the Ticket Deflection Bot that allows users to ask time-off related questions (oysterhr/intelligence-ai) */
  AiTicketDeflectionBot = 'AI_TICKET_DEFLECTION_BOT',
  /** Used for Beta Integrations, SSO by auth0-Okta (oysterhr/iam) */
  Auth0OktaIntegration = 'AUTH0_OKTA_INTEGRATION',
  /** Used for Beta Integrations, SSO by auth0-Microsoft azure (oysterhr/iam) */
  Auth0WaadIntegration = 'AUTH0_WAAD_INTEGRATION',
  /** Enables the automatic updating of contractor profile details from the TM profile (oysterhr/contractors-and-compensation) */
  CctAutoSyncTmProfileDetails = 'CCT_AUTO_SYNC_TM_PROFILE_DETAILS',
  /** Do not display Figures data in the hiring flow (oysterhr/contractors-and-compensation) */
  CctHideDataFromFiguresOnTheHiringFlow = 'CCT_HIDE_DATA_FROM_FIGURES_ON_THE_HIRING_FLOW',
  /** Enables the ADP platform for Compliance Checker (oysterhr/contractors-and-compensation) */
  CipAdpworkforcenowPlatform = 'CIP_ADPWORKFORCENOW_PLATFORM',
  /** Enables the Gusto platform for Compliance Checker (oysterhr/contractors-and-compensation) */
  CipGustoPlatform = 'CIP_GUSTO_PLATFORM',
  /** Enables the local employment regulations feature (oysterhr/contractors-and-compensation) */
  CipLocalEmploymentRegulations = 'CIP_LOCAL_EMPLOYMENT_REGULATIONS',
  /** Used for Concur Integration which is still in beta (oysterhr/payroll-applications) */
  ConcurIntegration = 'CONCUR_INTEGRATION',
  /** Allows custom pricelists for new team members (oysterhr/growth-monetization) */
  GmCustomPricesForNewMembers = 'GM_CUSTOM_PRICES_FOR_NEW_MEMBERS',
  /** Enables monetization of Global Payroll (oysterhr/growth-monetization) */
  GmGlobalPayrollMonetizationEnabled = 'GM_GLOBAL_PAYROLL_MONETIZATION_ENABLED',
  /** Shows the Global Payroll package on the package selection page (oysterhr/growth-monetization) */
  GmShowPayrollPackage = 'GM_SHOW_PAYROLL_PACKAGE',
  /** Enables the API Hire Rulesets feature (oysterhr/team-hire-backend) */
  HireApiHireRulesets = 'HIRE_API_HIRE_RULESETS',
  /** Enables company engagements table redesign with bulk actions in the Staff view (oysterhr/team-hire-frontend) */
  HireBulkActions = 'HIRE_BULK_ACTIONS',
  /**
   * Enables bulk actions for sending invitations, assigning entities, and
   * assigning HSMs in the Staff view (oysterhr/team-hire-frontend)
   */
  HireBulkProcessingPhase2 = 'HIRE_BULK_PROCESSING_PHASE2',
  /**
   * Enables bulk status change (engaged, assisted setup, ...) in the company
   * engagements table in the Staff view (oysterhr/team-hire-frontend)
   */
  HireBulkProcessingStatus = 'HIRE_BULK_PROCESSING_STATUS',
  /** Enables the ability to engage employments with partially signed agreements (oysterhr/team-hire-frontend) */
  HireEngageAnywaysButton = 'HIRE_ENGAGE_ANYWAYS_BUTTON',
  /** Enables hire limitations for non-paying companies (bad debt epic) (oysterhr/team-hire-frontend) */
  HireLimitRestrictedCompany = 'HIRE_LIMIT_RESTRICTED_COMPANY',
  /** Enables the new Staff company header (oysterhr/team-hire-frontend) */
  HireStaffCompanyHeaderV2 = 'HIRE_STAFF_COMPANY_HEADER_V2',
  /** Enables the Staff View Engagement Export Templates feature (oysterhr/team-hire-frontend) */
  HireStaffViewEngagementExportTemplates = 'HIRE_STAFF_VIEW_ENGAGEMENT_EXPORT_TEMPLATES',
  /** Enables the phase 2 of the Team Management for company admins feature - https://www.notion.so/oysterhr/Team-Management-Project-Teams-5e102afcdc8b4290a6b65c9c976fccec (oysterhr/iam) */
  IamCompanyAdminTeamManagementPhase2 = 'IAM_COMPANY_ADMIN_TEAM_MANAGEMENT_PHASE2',
  /** Enables a script that prevent CSRF errors related with multiple tabs opened (oysterhr/iam) */
  IamCsrfTabManagement = 'IAM_CSRF_TAB_MANAGEMENT',
  /** Okta initiated SSO path to use auth0 instead of old custom omniauth setup (oysterhr/iam) */
  IamOktaAuth0Redirects = 'IAM_OKTA_AUTH0_REDIRECTS',
  /** Enable Trinet Integration for Canadian TMs (oysterhr/iam) */
  IamTrinetCanada = 'IAM_TRINET_CANADA',
  /** Enables two factor authentication for users (oysterhr/iam) */
  IamTwoFactorAuthentication = 'IAM_TWO_FACTOR_AUTHENTICATION',
  /** Used to allow access to the documents and payslips endpoints (oysterhr/inex_eng) */
  InexApiDocumentsPayslipsEndpoints = 'INEX_API_DOCUMENTS_PAYSLIPS_ENDPOINTS',
  /**
   * Shows a facilities (available API features) attribute on API Rulesets
   * endpoints for a given country and subdivision. (oysterhr/inex_eng)
   */
  InexApiFacilitiesRulesetsEndpoints = 'INEX_API_FACILITIES_RULESETS_ENDPOINTS',
  /** Used to disable tracking category mapping for specific customers (oysterhr/payroll-applications) */
  InexErpDisableTrackingCategoriesMapping = 'INEX_ERP_DISABLE_TRACKING_CATEGORIES_MAPPING',
  /** Enable the rendering of routes for the Harbor module (oysterhr/inex_eng) */
  InexHarbor = 'INEX_HARBOR',
  /** Enable the override of private document urls by Harbor (oysterhr/inex_eng) */
  InexHarborPrivateDocuments = 'INEX_HARBOR_PRIVATE_DOCUMENTS',
  /** Used for Accounting Integrations (ERP) to sync credit note applications (oysterhr/payroll-applications) */
  InexSyncCreditNoteApplicationsToErp = 'INEX_SYNC_CREDIT_NOTE_APPLICATIONS_TO_ERP',
  /** Used to sync credit note PDF attachments to Netsuite (customer integration) (oysterhr/payroll-applications) */
  InexSyncCreditNoteAttachmentsToNetsuite = 'INEX_SYNC_CREDIT_NOTE_ATTACHMENTS_TO_NETSUITE',
  /** Enables features related to second version of compare workforce feature (oysterhr/contractors-and-compensation) */
  KniWorkforceCompensationSecondMvp = 'KNI_WORKFORCE_COMPENSATION_SECOND_MVP',
  /** Enables the Looker embedded report feature (oysterhr/payroll-applications) */
  LookerEmbeddedReport = 'LOOKER_EMBEDDED_REPORT',
  /** Allows user to block direct debit for customer (oysterhr/team-payments) */
  PayAllowedToBlockDd = 'PAY_ALLOWED_TO_BLOCK_DD',
  /** Allows user to deactivate direct debit enforcement permanently for a customer (oysterhr/team-payments) */
  PayDirectDebitEnforcementFullManagement = 'PAY_DIRECT_DEBIT_ENFORCEMENT_FULL_MANAGEMENT',
  /** Shows button to disable the payouts for an engagement (oysterhr/team-payments) */
  PayEngagementsDisablePayoutsButton = 'PAY_ENGAGEMENTS_DISABLE_PAYOUTS_BUTTON',
  /** Enables assignment and usage of bank accounts on engagements not users (oysterhr/team-payments) */
  PayEngagementBankAccounts = 'PAY_ENGAGEMENT_BANK_ACCOUNTS',
  /**
   * This flag talks about access to Payout Automation page on the staff view.
   * Might not be permanent flag due to this feature might not be used soon anymore
   * (oysterhr/team-payments)
   */
  PayPayoutAutomationAccess = 'PAY_PAYOUT_AUTOMATION_ACCESS',
  /** Enables the new FX page (oysterhr/team-payments) */
  PayShowNewFxPage = 'PAY_SHOW_NEW_FX_PAGE',
  /** Allow team member to manage dependents (oysterhr/payroll-applications) */
  PaAllowTmToManageDependents = 'PA_ALLOW_TM_TO_MANAGE_DEPENDENTS',
  /**
   * Enables the alteryx flow for payroll cycles, which is automated document
   * transferring system (oysterhr/payroll-applications)
   */
  PaAlteryxFileTransfer = 'PA_ALTERYX_FILE_TRANSFER',
  /** Covers benefits management on CA view for payroll TMs (oysterhr/payroll-applications) */
  PaBenefitsManagementForCa = 'PA_BENEFITS_MANAGEMENT_FOR_CA',
  /** Enables the benefit cost split feature (oysterhr/payroll-applications) */
  PaBenefitCostSplit = 'PA_BENEFIT_COST_SPLIT',
  /** Enables the TM consent for benefits cost split (oysterhr/payroll-applications) */
  PaBenefitCostSplitTmConsent = 'PA_BENEFIT_COST_SPLIT_TM_CONSENT',
  /** Enables the bi weekly PIR generation flow (oysterhr/payroll-applications) */
  PaBiWeeklyPir = 'PA_BI_WEEKLY_PIR',
  /** Enrollment historical changes table changed by column (oysterhr/payroll-applications) */
  PaEnrollmentHistoricalChangesTableChangedByColumn = 'PA_ENROLLMENT_HISTORICAL_CHANGES_TABLE_CHANGED_BY_COLUMN',
  /**
   * Only tally net working days within the cycle for paid time off (flexible
   * payroll cycle project) (oysterhr/payroll-applications)
   */
  PaFlexiblePayrollCycleDatesNetWorkingDays = 'PA_FLEXIBLE_PAYROLL_CYCLE_DATES_NET_WORKING_DAYS',
  /** Allows Company to bulk create PAYG invoices (oysterhr/payroll-cycle) */
  PcAllowCompanyBulkCreatePaygInvoices = 'PC_ALLOW_COMPANY_BULK_CREATE_PAYG_INVOICES',
  /**
   * Allows Staff to create/generate/apply credit notes, and
   * void/regenerate/dispute/create manual invoices (oysterhr/payroll-cycle)
   */
  PcAllowCreditNoteAndInvoiceActions = 'PC_ALLOW_CREDIT_NOTE_AND_INVOICE_ACTIONS',
  /** Allows Staff to manually create contractor invoices (oysterhr/payroll-cycle) */
  PcAllowStaffCreatingContractorInvoices = 'PC_ALLOW_STAFF_CREATING_CONTRACTOR_INVOICES',
  /** Allows Staff to manually generate deposit invoices (oysterhr/payroll-cycle) */
  PcAllowStaffDepositInvoiceGeneration = 'PC_ALLOW_STAFF_DEPOSIT_INVOICE_GENERATION',
  /** Allows Staff to manage deposit enforcement section for companies (oysterhr/payroll-cycle) */
  PcAllowStaffManagingDepositEnforcement = 'PC_ALLOW_STAFF_MANAGING_DEPOSIT_ENFORCEMENT',
  /** Allows Staff to manage payment terms (oysterhr/payroll-cycle) */
  PcAllowStaffManagingPaymentTerms = 'PC_ALLOW_STAFF_MANAGING_PAYMENT_TERMS',
  /** Attaches contractor invoices to customer emails upon completion of the invoice creation process (oysterhr/payroll-cycle) */
  PcAttachContractorInvoicesToNotifications = 'PC_ATTACH_CONTRACTOR_INVOICES_TO_NOTIFICATIONS',
  /**
   * Enables the bad debt calculation feature, which sets the payments status for a
   * company based on invoices that are not paid (oysterhr/payroll-cycle)
   */
  PcBadDebtCalculation = 'PC_BAD_DEBT_CALCULATION',
  /** Restrict changing non-payment restrictions and upload NOB letter by the group of users (oysterhr/payroll-cycle) */
  PcBadDebtManagement = 'PC_BAD_DEBT_MANAGEMENT',
  /** Enables functionality of epic "Restrict the void and regeneration of invoices" (oysterhr/payroll-cycle) */
  PcEpicRestrictVoidRegenerate = 'PC_EPIC_RESTRICT_VOID_REGENERATE',
  /** Allows usage of flexible payroll cycle dates (flexible payroll cycle project) (oysterhr/payroll-cycle) */
  PcFlexiblePayrollCycleDates = 'PC_FLEXIBLE_PAYROLL_CYCLE_DATES',
  /** Shows GlobalPayroll invoice types and payment terms settings for them. (oysterhr/payroll-cycle) */
  PcShowGlobalPayrollInvoices = 'PC_SHOW_GLOBAL_PAYROLL_INVOICES',
  /** Shows OysterPlatformPlans invoice types and payment terms settings for them. (oysterhr/payroll-cycle) */
  PcShowPlatformPlansInvoices = 'PC_SHOW_PLATFORM_PLANS_INVOICES',
  /** Configures the non-standard hours on the engagement settings (oysterhr/tmi) */
  TmiTimeTrackingNonStandardHoursEngagementSettings = 'TMI_TIME_TRACKING_NON_STANDARD_HOURS_ENGAGEMENT_SETTINGS',
  /** Enables the time-off breakdown feature on the time-tracking page (oysterhr/tmi) */
  TmiTimeTrackingTimeOffBreakdown = 'TMI_TIME_TRACKING_TIME_OFF_BREAKDOWN',
  /** Enables the new time sheet approval flow (oysterhr/tmi) */
  TmiTimeTrackingTimeSheetApprovalFlow = 'TMI_TIME_TRACKING_TIME_SHEET_APPROVAL_FLOW',
  /** Enables the new time sheet submission flow (oysterhr/tmi) */
  TmiTimeTrackingTimeSheetSubmissionFlow = 'TMI_TIME_TRACKING_TIME_SHEET_SUBMISSION_FLOW',
  /** Enables the summary view on the time-tracking page (oysterhr/tmi) */
  TmiTimeTrackingViewSummary = 'TMI_TIME_TRACKING_VIEW_SUMMARY',
  /** Restrict certain actions for bad-debt restricted Customers (oysterhr/transitions) */
  TBadDebtManagement = 'T_BAD_DEBT_MANAGEMENT',
  /**
   * Enable a special group of users to self-serve engagement change backdating
   * instead of going through ESD (oysterhr/transitions)
   */
  TEngagementChangeBackdating = 'T_ENGAGEMENT_CHANGE_BACKDATING',
  /** Enable 25 more countries for GP offboarding (oysterhr/transitions) */
  TGpOffboardingNewCountries = 'T_GP_OFFBOARDING_NEW_COUNTRIES',
  /** Enable payroll payout month for GP (oysterhr/transitions) */
  TGpPayrollPayoutMonth = 'T_GP_PAYROLL_PAYOUT_MONTH',
  /** Enable a tab for the OS to view company contract changes (oysterhr/transitions) */
  TOsContractChangesView = 'T_OS_CONTRACT_CHANGES_VIEW'
}

export type FileUploaderType = {
  __typename?: 'FileUploaderType';
  filename: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum FilterEngagementType {
  Contract = 'CONTRACT',
  Employment = 'EMPLOYMENT',
  Payroll = 'PAYROLL'
}

/** Autogenerated input type of FinalizeWorkforceReportResults */
export type FinalizeWorkforceReportResultsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};

/** Autogenerated return type of FinalizeWorkforceReportResults. */
export type FinalizeWorkforceReportResultsPayload = {
  __typename?: 'FinalizeWorkforceReportResultsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  workforceReport: WorkforceReport;
};

export type FixedAmount = {
  __typename?: 'FixedAmount';
  amount?: Maybe<Scalars['String']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
};

export type FixedAmountInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
};

export type FormFieldError = {
  __typename?: 'FormFieldError';
  fieldId: Scalars['ID']['output'];
  /**
   * Full error message from the Rails model. Typically message prefaced by
   * the humanized attribute name, e.g. "Last name can't be blank" for
   * fieldId "lastName" and message "can't be blank"
   */
  fullMessage?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  target?: Maybe<Scalars['String']['output']>;
};

export type Frequencies = {
  __typename?: 'Frequencies';
  employee: Scalars['String']['output'];
  employment: Scalars['String']['output'];
  timeOff: Scalars['String']['output'];
};

export type FtePayoutCountryPayrollType = {
  __typename?: 'FtePayoutCountryPayrollType';
  authorizations?: Maybe<Authorization>;
  /** Indicates whether some employees don't have payment methods */
  bankDetailsMissing: Scalars['Boolean']['output'];
  /** Alpha2 code of the country for which this payroll was created */
  countryCode: CountryIsoCode;
  id: Scalars['ID']['output'];
  /** Strong id of the last import process */
  lastBulkImportId?: Maybe<Scalars['ID']['output']>;
  /** Month and year combined into name */
  name: Scalars['String']['output'];
  /** File with monthly payroll and payment details generated for country payroll */
  paymentFile?: Maybe<DownloadLink>;
  /** Current country payroll state */
  state: CountryPayrollStateEnumType;
  teamMembers: FtePayoutTeamMemberTypeCollection;
  /** Date when the payroll file was uploaded */
  uploadDate: Scalars['ISO8601DateTime']['output'];
};


export type FtePayoutCountryPayrollTypeTeamMembersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type FtePayoutCountryPayrollTypeCollection = {
  __typename?: 'FtePayoutCountryPayrollTypeCollection';
  collection: Array<FtePayoutCountryPayrollType>;
  metadata: CollectionMetadata;
};

export type FtePayoutTeamMemberType = {
  __typename?: 'FtePayoutTeamMemberType';
  /** Team member's net amount imported from country payroll file */
  amount: Money;
  authorizations?: Maybe<Authorization>;
  /** Name of the team member company */
  companyName: Scalars['String']['output'];
  /** Team member name */
  memberName: Scalars['String']['output'];
};

export type FtePayoutTeamMemberTypeCollection = {
  __typename?: 'FtePayoutTeamMemberTypeCollection';
  collection: Array<FtePayoutTeamMemberType>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of GdprDeleteCompany */
export type GdprDeleteCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
};

/** Autogenerated return type of GdprDeleteCompany. */
export type GdprDeleteCompanyPayload = {
  __typename?: 'GdprDeleteCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of GdprDeleteUser */
export type GdprDeleteUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of GdprDeleteUser. */
export type GdprDeleteUserPayload = {
  __typename?: 'GdprDeleteUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of GdprExportCompany */
export type GdprExportCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  exportFormat: Scalars['String']['input'];
};

/** Autogenerated return type of GdprExportCompany. */
export type GdprExportCompanyPayload = {
  __typename?: 'GdprExportCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of GdprExportUser */
export type GdprExportUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  exportFormat: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of GdprExportUser. */
export type GdprExportUserPayload = {
  __typename?: 'GdprExportUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of GenerateAgreementsAsync */
export type GenerateAgreementsAsyncInput = {
  actorParty: AgreementPartyTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiringId: Scalars['ID']['input'];
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of GenerateAgreementsAsync. */
export type GenerateAgreementsAsyncPayload = {
  __typename?: 'GenerateAgreementsAsyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of GenerateContractorAgreementsAsync */
export type GenerateContractorAgreementsAsyncInput = {
  actorParty: AgreementPartyTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
};

/** Autogenerated return type of GenerateContractorAgreementsAsync. */
export type GenerateContractorAgreementsAsyncPayload = {
  __typename?: 'GenerateContractorAgreementsAsyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of GenerateSignableAgreementFile */
export type GenerateSignableAgreementFileInput = {
  agreement: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GenerateSignableAgreementFile. */
export type GenerateSignableAgreementFilePayload = {
  __typename?: 'GenerateSignableAgreementFilePayload';
  agreement?: Maybe<Agreement>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type GeneratedDocument = {
  __typename?: 'GeneratedDocument';
  clmTemplateId: Scalars['String']['output'];
  documentType: AgreementTypeEnum;
  fileSignableDocx?: Maybe<DownloadLink>;
  fileSignablePdf?: Maybe<DownloadLink>;
  generationErrors?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  missingKeywords?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  notImplementedTemplateVariables?: Maybe<Array<Scalars['String']['output']>>;
  note?: Maybe<Scalars['String']['output']>;
  partyEditRightsConfigured: Scalars['Boolean']['output'];
  state: DocumentStateEnum;
  unknownTemplateVariableOptions?: Maybe<Array<AgreementTemplateVariable>>;
};

export type GenerationEngagement = {
  __typename?: 'GenerationEngagement';
  documents: Array<GeneratedDocument>;
  engagement: Engagement;
};

export enum GenerationTypeEnum {
  Automated = 'AUTOMATED',
  Hybrid = 'HYBRID',
  Manual = 'MANUAL'
}

export enum GlobalPayrollEorEntityTypeEnum {
  Direct = 'DIRECT',
  Indirect = 'INDIRECT',
  Payroll = 'PAYROLL'
}

export type GlobalPayrollOffboardingCountry = {
  __typename?: 'GlobalPayrollOffboardingCountry';
  currency?: Maybe<Scalars['String']['output']>;
  pearlSupported?: Maybe<Scalars['Boolean']['output']>;
};

export enum GlobalPayrollPayrollCycleTypeEnum {
  BiWeekly = 'BI_WEEKLY',
  Monthly = 'MONTHLY',
  SemiMonthly = 'SEMI_MONTHLY'
}

/** Autogenerated input type of GlobalPayrollTerminationCreate */
export type GlobalPayrollTerminationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  lastDayOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lastWorkingDay?: InputMaybe<Scalars['ISO8601Date']['input']>;
  offboardingCategoryId?: InputMaybe<Scalars['ID']['input']>;
  payrollPayoutMonthChange?: InputMaybe<Scalars['Boolean']['input']>;
  payrollPayoutMonthReason?: InputMaybe<Scalars['String']['input']>;
  proposedPayoutMonth?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of GlobalPayrollTerminationCreate. */
export type GlobalPayrollTerminationCreatePayload = {
  __typename?: 'GlobalPayrollTerminationCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

/** Autogenerated input type of GlobalPayrollTerminationTerminate */
export type GlobalPayrollTerminationTerminateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of GlobalPayrollTerminationTerminate. */
export type GlobalPayrollTerminationTerminatePayload = {
  __typename?: 'GlobalPayrollTerminationTerminatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

/** Autogenerated input type of GlobalPayrollTerminationUpdate */
export type GlobalPayrollTerminationUpdateInput = {
  additionalTerminationPayments?: InputMaybe<Array<AdditionalTerminationPaymentInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deductNegativePto?: InputMaybe<Scalars['Boolean']['input']>;
  lastDayOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lastWorkingDay?: InputMaybe<Scalars['ISO8601Date']['input']>;
  mutualTermination?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notifyCustomerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  offboardingCategoryId?: InputMaybe<Scalars['ID']['input']>;
  otherPayments?: InputMaybe<Scalars['Boolean']['input']>;
  payrollPayoutMonthChange?: InputMaybe<Scalars['Boolean']['input']>;
  payrollPayoutMonthReason?: InputMaybe<Scalars['String']['input']>;
  proposedPayoutMonth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  ptoAccurate?: InputMaybe<Scalars['Boolean']['input']>;
  ptoDaysRemaining?: InputMaybe<Scalars['Float']['input']>;
  ptoInaccurateNote?: InputMaybe<Scalars['String']['input']>;
  roeCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<TerminationState>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of GlobalPayrollTerminationUpdate. */
export type GlobalPayrollTerminationUpdatePayload = {
  __typename?: 'GlobalPayrollTerminationUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

export type HireRecord = {
  __typename?: 'HireRecord';
  createdAt: Scalars['ISO8601DateTime']['output'];
  departmentId?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integrationName?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  onboardingFields: Scalars['JSON']['output'];
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HireRecordCollection = {
  __typename?: 'HireRecordCollection';
  collection: Array<HireRecord>;
  metadata: CollectionMetadata;
};

export type Hires = {
  __typename?: 'Hires';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  records: HireRecordCollection;
  type: IntegrationTypeEnum;
};


export type HiresRecordsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type Hiring = AuditableObject & {
  __typename?: 'Hiring';
  agreement?: Maybe<Agreement>;
  agreements: Array<Agreement>;
  agreementsSynced: Scalars['Boolean']['output'];
  auditHistory: Array<AuditItem>;
  authorizations?: Maybe<Authorization>;
  banners: Array<BannerTypeEnum>;
  companyProcess: EmploymentsHiringCompanyProcess;
  disabledAgreements: Array<Agreement>;
  employeeProcess: EmploymentsHiringEmployeeProcess;
  employeeVisitedDashboard: Scalars['Boolean']['output'];
  employmentAgreementsESignType?: Maybe<AgreementESignTypeEnum>;
  employmentAgreementsInfo?: Maybe<EmploymentAgreementsInfo>;
  envelope?: Maybe<Envelope>;
  envelopes: Array<Envelope>;
  externalOnboardingFormUrl?: Maybe<Scalars['String']['output']>;
  hiringProcess?: Maybe<HiringProcess>;
  id: Scalars['ID']['output'];
  isAgreementESignEnabled: Scalars['Boolean']['output'];
  isEmploymentAgreementSigned: Scalars['Boolean']['output'];
  isEmploymentAgreementsEnvelopePartiallySigned: Scalars['Boolean']['output'];
  isOsaSigned: Scalars['Boolean']['output'];
  onboardingForm?: Maybe<CustomFormsResponse>;
  selfServiceOnboarding: Scalars['Boolean']['output'];
  teamMemberAgreements: Array<Agreement>;
};


export type HiringAgreementArgs = {
  agreementType: AgreementTypeEnum;
};


export type HiringAgreementsArgs = {
  states?: InputMaybe<Array<AgreementStateEnum>>;
};


export type HiringAuditHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  only?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type HiringEnvelopeArgs = {
  envelopeType: EnvelopeTypeEnum;
};

/** Autogenerated input type of HiringAdminUpdateTaskState */
export type HiringAdminUpdateTaskStateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiringId: Scalars['ID']['input'];
  targetState: TodoTasksTaskState;
  taskName: Scalars['String']['input'];
};

/** Autogenerated return type of HiringAdminUpdateTaskState. */
export type HiringAdminUpdateTaskStatePayload = {
  __typename?: 'HiringAdminUpdateTaskStatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  hiring?: Maybe<Hiring>;
};

export type HiringBulkProcessing = {
  __typename?: 'HiringBulkProcessing';
  /** The total number of items that were processed. */
  countTotal?: Maybe<Scalars['Int']['output']>;
  /** The number of items that were processed by engagement type. */
  countsByEngagementType: Array<HiringBulkProcessingCountByEngagementType>;
  id: Scalars['ID']['output'];
  initiatedOn: Scalars['ISO8601DateTime']['output'];
  operation: HiringBulkProcessingOperation;
  performer: User;
  report: HiringBulkProcessingReport;
  state: HiringBulkProcessingState;
  strongId: Scalars['String']['output'];
};

export type HiringBulkProcessingCollection = {
  __typename?: 'HiringBulkProcessingCollection';
  collection: Array<HiringBulkProcessing>;
  metadata: CollectionMetadata;
};

export type HiringBulkProcessingCompanyEngagement = {
  __typename?: 'HiringBulkProcessingCompanyEngagement';
  engagementType: EngagementType;
  id: Scalars['String']['output'];
  invitation?: Maybe<Invitation>;
  state: EngagementState;
};

export type HiringBulkProcessingCompanyEngagementCollection = {
  __typename?: 'HiringBulkProcessingCompanyEngagementCollection';
  collection: Array<HiringBulkProcessingCompanyEngagement>;
  metadata: CollectionMetadata;
};

export type HiringBulkProcessingCountByEngagementType = {
  __typename?: 'HiringBulkProcessingCountByEngagementType';
  count: Scalars['Int']['output'];
  engagementType: HiringBulkProcessingEngagementType;
};

export enum HiringBulkProcessingEngagementType {
  Contract = 'CONTRACT',
  Employment = 'EMPLOYMENT',
  Payroll = 'PAYROLL'
}

export enum HiringBulkProcessingOperation {
  Invite = 'INVITE',
  TransitionState = 'TRANSITION_STATE',
  UpdateEntity = 'UPDATE_ENTITY',
  UpdateHiringSuccessManager = 'UPDATE_HIRING_SUCCESS_MANAGER'
}

export type HiringBulkProcessingOperationArguments = {
  invite?: InputMaybe<HiringBulkProcessingOperationsInvite>;
  transitionState?: InputMaybe<Array<HiringBulkProcessingOperationsTransitionState>>;
  updateEntity?: InputMaybe<HiringBulkProcessingOperationsUpdateEntity>;
  updateHiringSuccessManager?: InputMaybe<HiringBulkProcessingOperationsUpdateHiringSuccessManager>;
};

export type HiringBulkProcessingOperationsInvite = {
  resendInvitations: Scalars['Boolean']['input'];
};

export type HiringBulkProcessingOperationsTransitionState = {
  changeReasonDescription?: InputMaybe<Scalars['String']['input']>;
  changeReasonType?: InputMaybe<ReasonTypeEnum>;
  changeType?: InputMaybe<ChangeTypeEnum>;
  engagementType: HiringBulkProcessingEngagementType;
  newValue: EngagementState;
  originalValue: EngagementState;
};

export type HiringBulkProcessingOperationsUpdateEntity = {
  employerOfRecordId: Scalars['ID']['input'];
};

export type HiringBulkProcessingOperationsUpdateHiringSuccessManager = {
  assignedStaffId: Scalars['ID']['input'];
};

export type HiringBulkProcessingReport = {
  __typename?: 'HiringBulkProcessingReport';
  completed?: Maybe<Array<HiringBulkProcessingReportItem>>;
  /** The list of execution errors that prevented the whole process from running. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  failed?: Maybe<Array<HiringBulkProcessingReportItem>>;
};

export type HiringBulkProcessingReportItem = {
  __typename?: 'HiringBulkProcessingReportItem';
  engagement?: Maybe<Engagement>;
  engagementType: HiringBulkProcessingEngagementType;
  /** The list of errors that occurred during the proccessing of this team members. */
  errors?: Maybe<Array<Scalars['String']['output']>>;
  hasExceptionOccurred?: Maybe<Scalars['Boolean']['output']>;
  newValue?: Maybe<Scalars['String']['output']>;
  originalValue?: Maybe<Scalars['String']['output']>;
  strongId?: Maybe<Scalars['String']['output']>;
};

export enum HiringBulkProcessingState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

/** Autogenerated input type of HiringCreateBulkProcessing */
export type HiringCreateBulkProcessingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  engagementAttributes?: InputMaybe<Scalars['JSON']['input']>;
  engagementIds: Array<Scalars['ID']['input']>;
  operation: HiringBulkProcessingOperation;
  operationArguments?: InputMaybe<HiringBulkProcessingOperationArguments>;
  performerId: Scalars['ID']['input'];
};

/** Autogenerated return type of HiringCreateBulkProcessing. */
export type HiringCreateBulkProcessingPayload = {
  __typename?: 'HiringCreateBulkProcessingPayload';
  bulkProcessing?: Maybe<HiringBulkProcessing>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type HiringProcess = {
  __typename?: 'HiringProcess';
  agreementsActionsBlocked: Scalars['Boolean']['output'];
  agreementsFieldsBlocked: Scalars['Boolean']['output'];
  authorizations?: Maybe<Authorization>;
  completedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  customerTasks: Array<TodoTasksTask>;
  exemptionFormCompleted: Scalars['Boolean']['output'];
  hiringFormCompleted: Scalars['Boolean']['output'];
  notes: Array<StaffNote>;
  onboardingFormProgress: HiringProcessOnboardingFormProgress;
  resellerEndClientRepresentativeTasks: Array<TodoTasksTask>;
  settings: Array<TodoTasksTask>;
  staffTasks: Array<TodoTasksTask>;
  teamMemberTasks: Array<TodoTasksTask>;
};

export enum HiringProcessOnboardingFormProgress {
  Completed = 'COMPLETED',
  Started = 'STARTED',
  Unstarted = 'UNSTARTED'
}

export type HistoricEvent = {
  __typename?: 'HistoricEvent';
  changes: Array<Change>;
  date: Scalars['ISO8601Date']['output'];
  eventType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  userName: Scalars['String']['output'];
  versionId: Scalars['Int']['output'];
};

export type HrisIntegration = {
  __typename?: 'HrisIntegration';
  company: Company;
  id: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  onboardingTemplates?: Maybe<Array<CompanyCode>>;
  platformName: HrisIntegrationPlatformNameEnum;
  setupToken?: Maybe<Scalars['String']['output']>;
  state: HrisIntegrationStateEnum;
  syncFailedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum HrisIntegrationPlatformNameEnum {
  AdpWorkforceNow = 'ADP_WORKFORCE_NOW',
  Trinet = 'TRINET'
}

export enum HrisIntegrationStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  PendingValidation = 'PENDING_VALIDATION',
  StoredCredentials = 'STORED_CREDENTIALS'
}

/** Autogenerated input type of ImportIntegrationHire */
export type ImportIntegrationHireInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
  mergeId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ImportIntegrationHire. */
export type ImportIntegrationHirePayload = {
  __typename?: 'ImportIntegrationHirePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  integration: MergeIntegration;
};

/** Autogenerated input type of InitializeEsignatureAuthorization */
export type InitializeEsignatureAuthorizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

/** Autogenerated return type of InitializeEsignatureAuthorization. */
export type InitializeEsignatureAuthorizationPayload = {
  __typename?: 'InitializeEsignatureAuthorizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  redirectUrl: Scalars['String']['output'];
};

/** Autogenerated input type of InitializePayrollInvoicing */
export type InitializePayrollInvoicingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companiesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of InitializePayrollInvoicing. */
export type InitializePayrollInvoicingPayload = {
  __typename?: 'InitializePayrollInvoicingPayload';
  backgroundProcessParent?: Maybe<BackgroundProcessParent>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type Integration = {
  __typename?: 'Integration';
  /** (optional) The user who authorized the integration */
  authorizer?: Maybe<User>;
  beta: Scalars['Boolean']['output'];
  /** (optional) The description of the integration (used by third-party integrations) */
  description?: Maybe<Scalars['String']['output']>;
  /** (optional) The logo of the integration (used by third-party integrations) */
  logo?: Maybe<Scalars['String']['output']>;
  /** (optional) The name of the integration (used by third-party integrations) */
  name?: Maybe<Scalars['String']['output']>;
  /** Integration platform identifier which represents certain integration (e.g. slack) */
  platform: Scalars['String']['output'];
  /**
   * The type of the integrated platform, e.g.:
   * COMMUNICATION, ACCOUNTING or HRIS
   */
  platformType: PlatformTypeEnum;
  /**
   * Integration provider which is responsible for this integration instance
   * e.g. codat or app
   */
  provider: Scalars['String']['output'];
  /** A unique reference for the integration */
  reference: Scalars['String']['output'];
  /** Integration state which describes if integration is active, authorized etc */
  state: Scalars['String']['output'];
};

export type IntegrationAddOn = {
  __typename?: 'IntegrationAddOn';
  active: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  reEnableInfo?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type IntegrationAddOnInput = {
  active: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
};

export enum IntegrationPlatformNameEnum {
  Bamboohr = 'BAMBOOHR',
  Greenhouse = 'GREENHOUSE',
  Hibob = 'HIBOB',
  Personio = 'PERSONIO',
  Workday = 'WORKDAY'
}

export enum IntegrationTypeEnum {
  Ats = 'ATS',
  Hris = 'HRIS'
}

export type IntelligenceBenefit = {
  __typename?: 'IntelligenceBenefit';
  /** Benefits available for given country code */
  countryBenefits: CountryBenefitsCollection;
  /** Number of currently effective national holidays for the year */
  effectiveNationalHolidaysForYear: Scalars['Int']['output'];
  timeOffRules: CountryIntelligenceRulesTimeOffCollection;
};


export type IntelligenceBenefitCountryBenefitsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type IntelligenceBenefitTimeOffRulesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type InternalDocumentGeneration = {
  __typename?: 'InternalDocumentGeneration';
  actor: User;
  generationEngagements: Array<GenerationEngagement>;
  id: Scalars['ID']['output'];
  zipArchive?: Maybe<DownloadLink>;
};

export enum InternalToolEnum {
  BenefitsAdvisor = 'BENEFITS_ADVISOR',
  CostCalculator = 'COST_CALCULATOR',
  CountryEmploymentComparison = 'COUNTRY_EMPLOYMENT_COMPARISON',
  CountryProfiles = 'COUNTRY_PROFILES',
  EmployeeMisclassificationAnalyzer = 'EMPLOYEE_MISCLASSIFICATION_ANALYZER',
  EmploymentCostComparison = 'EMPLOYMENT_COST_COMPARISON',
  EquityAssessment = 'EQUITY_ASSESSMENT',
  EquityTaxCalculator = 'EQUITY_TAX_CALCULATOR',
  GlobalSalaryConverter = 'GLOBAL_SALARY_CONVERTER',
  OysterPartners = 'OYSTER_PARTNERS',
  SalaryInsightsTool = 'SALARY_INSIGHTS_TOOL'
}

export type Invitation = {
  __typename?: 'Invitation';
  authorizations?: Maybe<Authorization>;
  company: Company;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<User>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  postInvitationAction?: Maybe<Scalars['String']['output']>;
  roles: Array<InvitationRoleTypeEnum>;
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  usedTokenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export enum InvitationRoleTypeEnum {
  Admin = 'ADMIN',
  ClientRepresentative = 'CLIENT_REPRESENTATIVE',
  Colleague = 'COLLEAGUE',
  CompanyAdmin = 'COMPANY_ADMIN',
  Contractor = 'CONTRACTOR',
  DirectManager = 'DIRECT_MANAGER',
  ExpensesAdmin = 'EXPENSES_ADMIN',
  ExternalRecruiter = 'EXTERNAL_RECRUITER',
  InvoicesAdmin = 'INVOICES_ADMIN',
  PayrollAdmin = 'PAYROLL_ADMIN',
  ResellerAdmin = 'RESELLER_ADMIN',
  TimeOffAdmin = 'TIME_OFF_ADMIN'
}

/** Autogenerated input type of InviteContractor */
export type InviteContractorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['String']['input'];
};

/** Autogenerated return type of InviteContractor. */
export type InviteContractorPayload = {
  __typename?: 'InviteContractorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of InviteTeamMember */
export type InviteTeamMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employmentId: Scalars['String']['input'];
};

/** Autogenerated return type of InviteTeamMember. */
export type InviteTeamMemberPayload = {
  __typename?: 'InviteTeamMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  employment: Employment;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of InviteUserToCompany */
export type InviteUserToCompanyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  roles: Array<AuthorizationRoleEnumType>;
};

/** Autogenerated return type of InviteUserToCompany. */
export type InviteUserToCompanyPayload = {
  __typename?: 'InviteUserToCompanyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Money;
  amountCurrencyCode: Scalars['String']['output'];
  amountDue: Money;
  amountTaxExcluded: Scalars['Float']['output'];
  amountTaxIncluded: Scalars['Float']['output'];
  /** The list of credit notes applied to this invoice */
  appliedCreditNotes?: Maybe<Array<CreditNote>>;
  approver?: Maybe<User>;
  authorizations?: Maybe<Authorization>;
  autoApprovedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  availableCreditFor?: Maybe<Money>;
  canDispute: Scalars['Boolean']['output'];
  changesetHistory: Array<HistoricEvent>;
  chargePaymentRequest: ChargePaymentRequest;
  client: Company;
  company: Company;
  contract?: Maybe<Contract>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdBy?: Maybe<User>;
  createdByUserType?: Maybe<Scalars['String']['output']>;
  /** The list of credit notes applications */
  creditNoteApplications?: Maybe<Array<CreditNoteApplication>>;
  disputes: Array<InvoiceDispute>;
  dueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  file?: Maybe<DownloadLink>;
  fileIsPresent: Scalars['Boolean']['output'];
  fromPayroll: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['ISO8601Date']['output']>;
  isOverdue: Scalars['Boolean']['output'];
  isSendable: Scalars['Boolean']['output'];
  kind: InvoiceKind;
  lastPayinReminderSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lineItems: Array<InvoiceLineItem>;
  notes?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Invoice where pre paid amount was used to lower (final) amount */
  paidInvoice?: Maybe<Invoice>;
  paymentPeriod?: Maybe<Scalars['String']['output']>;
  paymentPeriodEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentPeriodStartDate?: Maybe<Scalars['ISO8601Date']['output']>;
  paymentsGroup?: Maybe<PaymentsGroup>;
  payoutPaymentRequest: PayoutPaymentRequest;
  payrollEntity?: Maybe<EmployerOfRecord>;
  payrollRecords: Array<PayrollRecord>;
  prePaidAmount?: Maybe<Money>;
  referenceCode: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The list of staff notes for this invoice, ordered by most recent last. */
  staffNotes: StaffNoteConnection;
  state: InvoiceState;
  subkind: InvoiceSubkind;
  supportingFile?: Maybe<DownloadLink>;
  supportingFileIsPresent: Scalars['Boolean']['output'];
  taxRate?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Money>;
  voidedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type InvoiceAvailableCreditForArgs = {
  engagementId: Scalars['ID']['input'];
};


export type InvoicePayrollRecordsArgs = {
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type InvoiceStaffNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum InvoiceBusinessState {
  Approved = 'APPROVED',
  AutoApproved = 'AUTO_APPROVED',
  Disputed = 'DISPUTED',
  Draft = 'DRAFT',
  Paid = 'PAID',
  Processing = 'PROCESSING',
  ReadyForReview = 'READY_FOR_REVIEW',
  Voided = 'VOIDED',
  WaitingApproval = 'WAITING_APPROVAL'
}

export type InvoiceCollection = {
  __typename?: 'InvoiceCollection';
  collection: Array<Invoice>;
  metadata: CollectionMetadata;
};

export type InvoiceDispute = {
  __typename?: 'InvoiceDispute';
  actor: InvoiceDisputeActor;
  canceled: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  reason: Scalars['String']['output'];
};

export type InvoiceDisputeActor = {
  __typename?: 'InvoiceDisputeActor';
  name: Scalars['String']['output'];
};

export type InvoiceFiltersAttributes = {
  chargeCurrency?: InputMaybe<CurrencyEnum>;
  chargeStates?: InputMaybe<Array<ChargeState>>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  createdByUserType?: InputMaybe<Array<CreatedByUserEnum>>;
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceBusinessStates?: InputMaybe<Array<InvoiceBusinessState>>;
  invoiceStates?: InputMaybe<Array<InvoiceState>>;
  notInPaymentsGroup?: InputMaybe<Scalars['Boolean']['input']>;
  onlyKind?: InputMaybe<InvoiceKind>;
  paymentPeriodEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentPeriodStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  paymentsGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  payoutStates?: InputMaybe<Array<PayoutViewState>>;
  payrollDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  payrollEntityId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subkinds?: InputMaybe<Array<InvoiceSubkind>>;
};

export enum InvoiceKind {
  Contractor = 'CONTRACTOR',
  Oyster = 'OYSTER'
}

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  engagementStrongId?: Maybe<Scalars['String']['output']>;
  fxOysterRate?: Maybe<Rate>;
  quantity: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type InvoiceLineItemInput = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  unitPrice: Scalars['Float']['input'];
};

export enum InvoiceState {
  Disputed = 'DISPUTED',
  Draft = 'DRAFT',
  Paid = 'PAID',
  Processing = 'PROCESSING',
  Voided = 'VOIDED',
  WaitingApproval = 'WAITING_APPROVAL'
}

export enum InvoiceSubkind {
  ContractorAdHocPayment = 'CONTRACTOR_AD_HOC_PAYMENT',
  ContractorExpenseReimbursement = 'CONTRACTOR_EXPENSE_REIMBURSEMENT',
  ContractorMonthlyPayment = 'CONTRACTOR_MONTHLY_PAYMENT',
  OysterContractorsFee = 'OYSTER_CONTRACTORS_FEE',
  OysterDeposit = 'OYSTER_DEPOSIT',
  OysterGlobalPayroll = 'OYSTER_GLOBAL_PAYROLL',
  OysterManualInvoice = 'OYSTER_MANUAL_INVOICE',
  OysterPayroll = 'OYSTER_PAYROLL',
  OysterPlatformPlans = 'OYSTER_PLATFORM_PLANS',
  OysterPrefunding = 'OYSTER_PREFUNDING',
  OysterSalaryInsights = 'OYSTER_SALARY_INSIGHTS',
  OysterScale = 'OYSTER_SCALE',
  OysterSettlement = 'OYSTER_SETTLEMENT',
  OysterTrueUps = 'OYSTER_TRUE_UPS'
}

export enum InvoiceSummaryQueryKind {
  Deposit = 'DEPOSIT',
  Unpaid = 'UNPAID',
  UnpaidOverdue = 'UNPAID_OVERDUE'
}

export enum InvoiceTransitionEvent {
  Dispute = 'DISPUTE',
  Pay = 'PAY',
  Reinstate = 'REINSTATE',
  Review = 'REVIEW',
  SendToCustomer = 'SEND_TO_CUSTOMER',
  Unpay = 'UNPAY',
  Unvoid = 'UNVOID',
  Void = 'VOID'
}

export type InvoicesMonthYear = {
  __typename?: 'InvoicesMonthYear';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type InvoicesMonthYearCollection = {
  __typename?: 'InvoicesMonthYearCollection';
  collection: Array<InvoicesMonthYear>;
  metadata: CollectionMetadata;
};

export type InvoicesTotalAmountSum = {
  __typename?: 'InvoicesTotalAmountSum';
  averageDueDays: Scalars['Int']['output'];
  totalAmount: Money;
  totalCount: Scalars['Int']['output'];
};

export type InvoicingCompanySettings = AuditableObject & {
  __typename?: 'InvoicingCompanySettings';
  applyCreditNotes: Scalars['Boolean']['output'];
  auditHistory: Array<AuditItem>;
  authorizations?: Maybe<Authorization>;
  depositBeforeLiability: Scalars['Boolean']['output'];
  depositInvoicePaymentTerm: Scalars['Int']['output'];
  engagementsWithMonthsOfDeposit: EngagementCollection;
  globalPayrollPaymentTerm?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  invoicePaymentTerm: Scalars['Int']['output'];
  monthsOfDeposit: Scalars['Float']['output'];
  platformPlansPaymentTerm?: Maybe<Scalars['Int']['output']>;
  salaryInsightsPaymentTerm?: Maybe<Scalars['Int']['output']>;
  scalePaymentTerm?: Maybe<Scalars['Int']['output']>;
  settlementPaymentTermsDay?: Maybe<Scalars['Int']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  taxableBenefits: Scalars['Boolean']['output'];
};


export type InvoicingCompanySettingsAuditHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  only?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type InvoicingCompanySettingsEngagementsWithMonthsOfDepositArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export enum InvoicingCreditNoteTransitionEventEnum {
  Apply = 'APPLY',
  Issue = 'ISSUE',
  PartiallyApply = 'PARTIALLY_APPLY',
  Refund = 'REFUND',
  Void = 'VOID'
}

export type InvoicingEmployeeSettings = AuditableObject & {
  __typename?: 'InvoicingEmployeeSettings';
  auditHistory: Array<AuditItem>;
  authorizations?: Maybe<Authorization>;
  depositInvoiceRequired: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  includeOnInvoices: Scalars['Boolean']['output'];
  monthsOfDeposit?: Maybe<Scalars['Float']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
};


export type InvoicingEmployeeSettingsAuditHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  only?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IsoCountry = {
  __typename?: 'IsoCountry';
  alpha2: Scalars['String']['output'];
  commonName: Scalars['String']['output'];
  isoLongName: Scalars['String']['output'];
  isoShortName: Scalars['String']['output'];
  subdivisions: Array<Subdivision>;
};

export type Item = {
  __typename?: 'Item';
  identifier: PayrollComponentTypeEnum;
  title: Scalars['String']['output'];
};

export type KybVerification = {
  __typename?: 'KybVerification';
  authorizations?: Maybe<Authorization>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  externalId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  status: KybVerificationStatusEnumType;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum KybVerificationStatusEnumType {
  Bypassed = 'bypassed',
  InAudit = 'in_audit',
  InReview = 'in_review',
  Open = 'open',
  Pending = 'pending',
  Rejected = 'rejected',
  Requested = 'requested',
  Verified = 'verified'
}

/** Autogenerated input type of KycBeginVerification */
export type KycBeginVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of KycBeginVerification. */
export type KycBeginVerificationPayload = {
  __typename?: 'KycBeginVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type KycVerification = {
  __typename?: 'KycVerification';
  authorizations?: Maybe<Authorization>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  latestWebhookData?: Maybe<Scalars['JSON']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  sessionUrl?: Maybe<Scalars['String']['output']>;
  status: KycVerificationStatusEnumType;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User that manually created the verification */
  verifier?: Maybe<User>;
};

export enum KycVerificationStatusEnumType {
  Abandoned = 'abandoned',
  Approved = 'approved',
  Declined = 'declined',
  Expired = 'expired',
  NotStarted = 'not_started',
  ResubmissionRequired = 'resubmission_required',
  Started = 'started',
  Submitted = 'submitted'
}

/** Autogenerated input type of LinkCostCentersToTrackingCategories */
export type LinkCostCentersToTrackingCategoriesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Oyster company identifier (only company admins or staff) */
  companyId: Scalars['ID']['input'];
  /** A set of oyster cost centers associated with tracking categories provided by Codat */
  mapping: Array<TrackingCategoryMappingInput>;
  /** Codat platform key reference (e.g. quickbooksonline) */
  platform: Scalars['String']['input'];
};

/** Autogenerated return type of LinkCostCentersToTrackingCategories. */
export type LinkCostCentersToTrackingCategoriesPayload = {
  __typename?: 'LinkCostCentersToTrackingCategoriesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** The list associated oyster cost centers with tracking categories provided by Codat */
  mapping: Array<AccountingTrackingCategoryMappingType>;
};

/** Autogenerated input type of LinkPayrollTypesWithAccountingAccounts */
export type LinkPayrollTypesWithAccountingAccountsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Oyster company identifier (only company admins or staff) */
  companyId: Scalars['ID']['input'];
  /** A set of oyster payroll types associated with accounts provided by Codat */
  mapping: Array<AccountMappingInput>;
  /** Codat platform key reference (e.g. quickbooksonline) */
  platform: Scalars['String']['input'];
};

/** Autogenerated return type of LinkPayrollTypesWithAccountingAccounts. */
export type LinkPayrollTypesWithAccountingAccountsPayload = {
  __typename?: 'LinkPayrollTypesWithAccountingAccountsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** The list associated oyster payroll types with accounts provided by Codat */
  mapping: Array<AccountingPayrollTypeToAccountMappingType>;
};

export type MandatoryCosts = {
  __typename?: 'MandatoryCosts';
  holidayEntitlement: Scalars['Float']['output'];
  noticePayment: Scalars['Float']['output'];
  severancePayment: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

/** Autogenerated input type of ManualSyncIntegration */
export type ManualSyncIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  integrationType: Scalars['String']['input'];
};

/** Autogenerated return type of ManualSyncIntegration. */
export type ManualSyncIntegrationPayload = {
  __typename?: 'ManualSyncIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of MarkAsViewed */
export type MarkAsViewedInput = {
  agreementType: AgreementTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiringId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkAsViewed. */
export type MarkAsViewedPayload = {
  __typename?: 'MarkAsViewedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of MarkCoEmployeeOnboardingComplete */
export type MarkCoEmployeeOnboardingCompleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of MarkCoEmployeeOnboardingComplete. */
export type MarkCoEmployeeOnboardingCompletePayload = {
  __typename?: 'MarkCoEmployeeOnboardingCompletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum MatchPrecisionLevelEnum {
  Best = 'BEST',
  Exact = 'EXACT',
  Good = 'GOOD',
  Low = 'LOW',
  Manual = 'MANUAL',
  Unknown = 'UNKNOWN'
}

export type MergeConnection = {
  __typename?: 'MergeConnection';
  integrationName: Scalars['String']['output'];
};

export type MergeEmploymentLog = {
  __typename?: 'MergeEmploymentLog';
  effectiveDate: Scalars['ISO8601DateTime']['output'];
  engagement: Engagement;
  id: Scalars['String']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  originalSalary?: Maybe<Scalars['String']['output']>;
  payPeriod?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['Float']['output']>;
  salaryCurrencyCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MergeEmploymentLogCollection = {
  __typename?: 'MergeEmploymentLogCollection';
  collection: Array<MergeEmploymentLog>;
  metadata: CollectionMetadata;
};

export type MergeIntegration = {
  __typename?: 'MergeIntegration';
  addOns: Array<IntegrationAddOn>;
  company: Company;
  customTimeOffMappings?: Maybe<Array<TimeOffMapping>>;
  id: Scalars['String']['output'];
  integrationType: IntegrationTypeEnum;
  issue?: Maybe<MergeIntegrationIssue>;
  issues?: Maybe<MergeIntegrationIssueCollection>;
  platformName: IntegrationPlatformNameEnum;
  searchHires: Array<SearchHires>;
  status: Scalars['String']['output'];
  syncFailedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  syncFrequencies?: Maybe<Frequencies>;
  syncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  timeOffMappings?: Maybe<TimeOffMappings>;
  timeOffRequestTypes?: Maybe<Array<Scalars['String']['output']>>;
  unresolvedIssuesCount: Scalars['Int']['output'];
};


export type MergeIntegrationIssueArgs = {
  id: Scalars['ID']['input'];
};


export type MergeIntegrationIssuesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type MergeIntegrationSearchHiresArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailType?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type MergeIntegrationCollection = {
  __typename?: 'MergeIntegrationCollection';
  collection: Array<MergeIntegration>;
  metadata: CollectionMetadata;
};

export type MergeIntegrationIssue = {
  __typename?: 'MergeIntegrationIssue';
  details: Scalars['String']['output'];
  firstIncidentAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  lastUpdate: Scalars['ISO8601DateTime']['output'];
  severity: MergeIssueSeverityEnum;
  suggestedFix?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type MergeIntegrationIssueCollection = {
  __typename?: 'MergeIntegrationIssueCollection';
  collection: Array<MergeIntegrationIssue>;
  metadata: CollectionMetadata;
};

export enum MergeIssueSeverityEnum {
  Critical = 'CRITICAL',
  Incident = 'INCIDENT'
}

export type MergeLink = {
  __typename?: 'MergeLink';
  token: Scalars['String']['output'];
};

export type MergedTimeOff = {
  __typename?: 'MergedTimeOff';
  amountDays: Scalars['Float']['output'];
  endDate: Scalars['ISO8601Date']['output'];
  reason: Scalars['String']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  timeOffType: Scalars['String']['output'];
};

export type MergedTimeOffCollection = {
  __typename?: 'MergedTimeOffCollection';
  collection: Array<MergedTimeOff>;
  metadata: CollectionMetadata;
};

export type MonetizationInput = {
  planId?: InputMaybe<Scalars['ID']['input']>;
};

export type Money = {
  __typename?: 'Money';
  currencyCode: Scalars['String']['output'];
  formatted: Scalars['String']['output'];
  /**
   * Returns the money amount using the fractional monetary unit of the currency.
   *
   * For many currencies the subunit is cents. In that case, for example, USD 1570.99
   * would be represented as 157099 cents.
   *
   * The reason why this exists is to help us circumvert the rounding limitations of
   * floating point precision numbers.
   */
  subunit: Scalars['MoneyInt']['output'];
  subunitToUnit: Scalars['Int']['output'];
};

/** Allows query money field with currency as a field name */
export type MoneyByCurrency = {
  __typename?: 'MoneyByCurrency';
  AED: Money;
  AFN: Money;
  ALL: Money;
  AMD: Money;
  ANG: Money;
  AOA: Money;
  ARS: Money;
  AUD: Money;
  AWG: Money;
  AZN: Money;
  BAM: Money;
  BBD: Money;
  BDT: Money;
  BGN: Money;
  BHD: Money;
  BIF: Money;
  BMD: Money;
  BND: Money;
  BOB: Money;
  BRL: Money;
  BSD: Money;
  BTN: Money;
  BWP: Money;
  BYN: Money;
  BYR: Money;
  BZD: Money;
  CAD: Money;
  CDF: Money;
  CHF: Money;
  CLF: Money;
  CLP: Money;
  CNY: Money;
  COP: Money;
  CRC: Money;
  CUC: Money;
  CUP: Money;
  CVE: Money;
  CZK: Money;
  DJF: Money;
  DKK: Money;
  DOP: Money;
  DZD: Money;
  EGP: Money;
  ERN: Money;
  ETB: Money;
  EUR: Money;
  FJD: Money;
  FKP: Money;
  GBP: Money;
  GEL: Money;
  GHS: Money;
  GIP: Money;
  GMD: Money;
  GNF: Money;
  GTQ: Money;
  GYD: Money;
  HKD: Money;
  HNL: Money;
  HRK: Money;
  HTG: Money;
  HUF: Money;
  IDR: Money;
  ILS: Money;
  INR: Money;
  IQD: Money;
  IRR: Money;
  ISK: Money;
  JMD: Money;
  JOD: Money;
  JPY: Money;
  KES: Money;
  KGS: Money;
  KHR: Money;
  KMF: Money;
  KPW: Money;
  KRW: Money;
  KWD: Money;
  KYD: Money;
  KZT: Money;
  LAK: Money;
  LBP: Money;
  LKR: Money;
  LRD: Money;
  LSL: Money;
  LYD: Money;
  MAD: Money;
  MDL: Money;
  MGA: Money;
  MKD: Money;
  MMK: Money;
  MNT: Money;
  MOP: Money;
  MRU: Money;
  MUR: Money;
  MVR: Money;
  MWK: Money;
  MXN: Money;
  MYR: Money;
  MZN: Money;
  NAD: Money;
  NGN: Money;
  NIO: Money;
  NOK: Money;
  NPR: Money;
  NZD: Money;
  OMR: Money;
  PAB: Money;
  PEN: Money;
  PGK: Money;
  PHP: Money;
  PKR: Money;
  PLN: Money;
  PYG: Money;
  QAR: Money;
  RON: Money;
  RSD: Money;
  RUB: Money;
  RWF: Money;
  SAR: Money;
  SBD: Money;
  SCR: Money;
  SDG: Money;
  SEK: Money;
  SGD: Money;
  SHP: Money;
  SKK: Money;
  SLL: Money;
  SOS: Money;
  SRD: Money;
  SSP: Money;
  STD: Money;
  SVC: Money;
  SYP: Money;
  SZL: Money;
  THB: Money;
  TJS: Money;
  TMT: Money;
  TND: Money;
  TOP: Money;
  TRY: Money;
  TTD: Money;
  TWD: Money;
  TZS: Money;
  UAH: Money;
  UGX: Money;
  USD: Money;
  UYU: Money;
  UZS: Money;
  VES: Money;
  VND: Money;
  VUV: Money;
  WST: Money;
  XAF: Money;
  XCD: Money;
  XOF: Money;
  YER: Money;
  ZAR: Money;
  ZMK: Money;
  ZMW: Money;
  ZWL: Money;
  currencyCode: Scalars['String']['output'];
  formatted: Scalars['String']['output'];
  /**
   * Returns the money amount using the fractional monetary unit of the currency.
   *
   * For many currencies the subunit is cents. In that case, for example, USD 1570.99
   * would be represented as 157099 cents.
   *
   * The reason why this exists is to help us circumvert the rounding limitations of
   * floating point precision numbers.
   */
  subunit: Scalars['MoneyInt']['output'];
  subunitToUnit: Scalars['Int']['output'];
};

export type MoneyCollection = {
  __typename?: 'MoneyCollection';
  collection: Array<Money>;
  metadata: CollectionMetadata;
};

export type MoneyInput = {
  currencyCode: Scalars['String']['input'];
  subunit: Scalars['MoneyInt']['input'];
};

export type MonthlyFee = {
  __typename?: 'MonthlyFee';
  calculationDependencyType: CalculationDependencyTypeEnum;
  currency: Scalars['String']['output'];
  dependencyCurrency?: Maybe<Scalars['String']['output']>;
  employerOfRecordId?: Maybe<Scalars['String']['output']>;
  fixedPayments?: Maybe<Array<MonthlyFeeFixedPayment>>;
  monthlyFeeType: MonthlyFeeTypeEnum;
  ranges?: Maybe<Array<MonthlyFeeRange>>;
  strongId?: Maybe<Scalars['String']['output']>;
};

export type MonthlyFeeFixedPayment = {
  __typename?: 'MonthlyFeeFixedPayment';
  amountSubunit: Scalars['MoneyInt']['output'];
  kind: MonthlyFeeFixedPaymentKindTypeEnum;
  strongId: Scalars['String']['output'];
};

export type MonthlyFeeFixedPaymentInput = {
  amountSubunit?: InputMaybe<Scalars['MoneyInt']['input']>;
  kind?: InputMaybe<MonthlyFeeFixedPaymentKindTypeEnum>;
  strongId?: InputMaybe<Scalars['String']['input']>;
};

export enum MonthlyFeeFixedPaymentKindTypeEnum {
  Expat = 'EXPAT',
  General = 'GENERAL',
  Local = 'LOCAL'
}

export type MonthlyFeeInput = {
  calculationDependencyType?: InputMaybe<CalculationDependencyTypeEnum>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dependencyCurrency?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordId?: InputMaybe<Scalars['String']['input']>;
  fixedPayments?: InputMaybe<Array<MonthlyFeeFixedPaymentInput>>;
  monthlyFeeType?: InputMaybe<MonthlyFeeTypeEnum>;
  ranges?: InputMaybe<Array<MonthlyFeeRangeInput>>;
  strongId?: InputMaybe<Scalars['String']['input']>;
};

export type MonthlyFeeRange = {
  __typename?: 'MonthlyFeeRange';
  amountSubunit?: Maybe<Scalars['MoneyInt']['output']>;
  kind?: Maybe<MonthlyFeeRangeKindTypeEnum>;
  maxDependency?: Maybe<Scalars['Int']['output']>;
  maximumAmountThresholdSubunit?: Maybe<Scalars['MoneyInt']['output']>;
  minDependency?: Maybe<Scalars['Int']['output']>;
  minimumAmountThresholdSubunit?: Maybe<Scalars['MoneyInt']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  strongId?: Maybe<Scalars['String']['output']>;
};

export type MonthlyFeeRangeInput = {
  amountSubunit?: InputMaybe<Scalars['MoneyInt']['input']>;
  kind?: InputMaybe<MonthlyFeeRangeKindTypeEnum>;
  maxDependency?: InputMaybe<Scalars['Int']['input']>;
  maximumAmountThresholdSubunit?: InputMaybe<Scalars['MoneyInt']['input']>;
  minDependency?: InputMaybe<Scalars['Int']['input']>;
  minimumAmountThresholdSubunit?: InputMaybe<Scalars['MoneyInt']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  strongId?: InputMaybe<Scalars['String']['input']>;
};

export enum MonthlyFeeRangeKindTypeEnum {
  AmountBased = 'AMOUNT_BASED',
  Percentage = 'PERCENTAGE'
}

export enum MonthlyFeeTypeEnum {
  FlatFee = 'FLAT_FEE',
  Headcount = 'HEADCOUNT',
  SalaryRange = 'SALARY_RANGE'
}

export enum MonthsEnum {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptTerms?: Maybe<AuthorizationAcceptTermsPayload>;
  /** Activating an ADP Workforce Now integration involves either creating a new integration or making an existing one active. */
  activateAdpWorkforceNowIntegration?: Maybe<ActivateAdpWorkforceNowIntegrationPayload>;
  activateDirectDebitEnforcement?: Maybe<ActivateDirectDebitEnforcementPayload>;
  activateDiscount?: Maybe<ActivateDiscountPayload>;
  /** Activating an Trinet integration involves either creating a new integration or making an existing one active. */
  activateTrinetIntegration?: Maybe<ActivateTrinetIntegrationPayload>;
  addBillingEmailAddress?: Maybe<AddBillingEmailAddressPayload>;
  addCartaIdsToEngagements?: Maybe<AddCartaIDsToEngagementsPayload>;
  addCompanyAdmin?: Maybe<AddCompanyAdminPayload>;
  addDependentToEnrollment?: Maybe<AddDependentToEnrollmentPayload>;
  addInvoicesToPaymentsGroup?: Maybe<AddInvoicesToPaymentsGroupPayload>;
  addOnDeactivate?: Maybe<AddOnDeactivatePayload>;
  addOnStartTrial?: Maybe<AddOnStartTrialPayload>;
  addOnSubscribe?: Maybe<AddOnSubscribePayload>;
  addSignatoryPointOfContact?: Maybe<AddSignatoryPointOfContactPayload>;
  adjustChargeStateManually?: Maybe<AdjustChargeStateManuallyPayload>;
  adjustPayoutStateManually?: Maybe<AdjustPayoutStateManuallyPayload>;
  agreeToEquityTerms?: Maybe<AgreeToTermsPayload>;
  applyCreditNote?: Maybe<ApplyCreditNotePayload>;
  /** Approves the country payroll and freeze the payroll records */
  approveCountryPayroll?: Maybe<ApproveCountryPayrollPayload>;
  approveEngagementChange?: Maybe<ApproveEngagementChangePayload>;
  approveExpenses?: Maybe<ApproveExpensesPayload>;
  /** @deprecated Is being replaced with invoicingBulkApprove mutation */
  approveInvoices?: Maybe<ApproveInvoicesPayload>;
  approveResignationCancellation?: Maybe<ApproveResignationCancellationPayload>;
  approveTermination?: Maybe<TerminationApprovePayload>;
  approveTerminationCancellation?: Maybe<TerminationApproveCancellationPayload>;
  approveTimeOffRequest?: Maybe<TimeOffRequestApprovePayload>;
  assignCostCenter?: Maybe<AssignCostCenterToEngagementPayload>;
  assignDepartment?: Maybe<AssignDepartmentPayload>;
  assignSignatoryPointOfContact?: Maybe<AssignSignatoryPointOfContactPayload>;
  assignStaffMembers?: Maybe<AssignStaffMembersPayload>;
  assignTeamMemberDirectManager?: Maybe<AssignTeamMemberDirectManagerPayload>;
  attachDocument?: Maybe<EngagementChangeAttachDocumentPayload>;
  authorizeDirectDebitOnPaymentMethod?: Maybe<AuthorizeDirectDebitOnPaymentMethodPayload>;
  backdateEngagementChange?: Maybe<BackdateEngagementChangePayload>;
  beginKycVerification?: Maybe<KycBeginVerificationPayload>;
  /** Blocks direct debit payments for a given company, stops all pending payouts. */
  blockAutomatedPayments?: Maybe<BlockAutomatedPaymentsPayload>;
  bookDemo?: Maybe<BookDemoPayload>;
  bulkAddTmsToInProgress?: Maybe<AddTmsToInProgressBulkOffboadingPayload>;
  bulkCreatePaySupplements?: Maybe<BulkCreatePaySupplementsPayload>;
  bulkUpdateTerminations?: Maybe<BulkUpdateTerminationsPayload>;
  bypassKybVerification?: Maybe<BypassKybVerificationPayload>;
  calculateDepositRecord?: Maybe<CalculateDepositRecordPayload>;
  cancelBulkEngagementChange?: Maybe<CancelBulkEngagementChangePayload>;
  cancelBulkEngagementChangeEntry?: Maybe<CancelBulkEngagementChangeEntryPayload>;
  cancelEngagementChange?: Maybe<CancelEngagementChangePayload>;
  cancelOysterSafe?: Maybe<CancelOysterSafePayload>;
  cancelTermination?: Maybe<TerminationCancelPayload>;
  cancelTimeOffRequest?: Maybe<TimeOffRequestCancelPayload>;
  cancelVariableCompensation?: Maybe<CancelVariableCompensationPayload>;
  changeAccount?: Maybe<ChangeAccountPayload>;
  /**
   * Changes primary accounting vendor for uploading objects to accounting systems.
   * If vendorId null, will unset all primary.
   */
  changeAccountingPrimaryVendor?: Maybe<ChangeAccountingPrimaryVendorPayload>;
  changeAddress?: Maybe<ChangeAddressPayload>;
  changeCompany?: Maybe<ChangeCompanyPayload>;
  changeCustomerBankAccountSigner?: Maybe<ChangeCustomerBankAccountSignerPayload>;
  changeEmail?: Maybe<ChangeEmailPayload>;
  changeEquityPlan?: Maybe<ChangeEquityPlanPayload>;
  changeOysterAdminProfile?: Maybe<ChangeOysterAdminProfilePayload>;
  changePackage?: Maybe<ChangePackagePayload>;
  changeStateCreditNote?: Maybe<ChangeStatePayload>;
  changeUserBan?: Maybe<ChangeUserBanPayload>;
  changeUserPersonalInfo?: Maybe<ChangeUserPersonalInfoPayload>;
  chargeInvoices?: Maybe<ChargeInvoicesPayload>;
  companyOidcSsoEnable?: Maybe<CompanyOidcSsoEnablePayload>;
  companyOktaSsoEnable?: Maybe<CompanyOktaSsoEnablePayload>;
  companySamlSsoEnable?: Maybe<CompanySamlSsoEnablePayload>;
  companySsoDisable?: Maybe<CompanySsoDisablePayload>;
  companyWaadSsoEnable?: Maybe<CompanyWaadSsoEnablePayload>;
  /**
   * Completes the configuration of an ADP Workforce Now integration. The selected onboarding template code is
   * saved on the integration's metadata and integration state is changed to online.
   */
  completeAdpWorkforceNowConfiguration?: Maybe<CompleteAdpWorkforceNowConfigurationPayload>;
  completeGrant?: Maybe<CompleteGrantPayload>;
  confirmEngagementChangeCancellation?: Maybe<ConfirmEngagementChangeCancellationPayload>;
  confirmMandateLodging?: Maybe<ConfirmMandateLodgingPayload>;
  confirmTimeSheet?: Maybe<ConfirmTimeSheetPayload>;
  connectAccountingPlatform?: Maybe<ConnectAccountingPlatformPayload>;
  connectExpensesPlatform?: Maybe<ConnectExpensesPlatformPayload>;
  connectToMergeIntegration?: Maybe<ConnectToMergeIntegrationPayload>;
  contractorAgreesOysterSafe?: Maybe<ContractorAgreesOysterSafePayload>;
  contractorDisagreesOysterSafe?: Maybe<ContractorDisagreesOysterSafePayload>;
  /** Trigger the creation of vendors for all unlinked contractors of the given company */
  createAccountingVendorsForUnlinkedContractors?: Maybe<CreateAccountingVendorsForUnlinkedContractorsPayload>;
  createAdditionalPayment?: Maybe<AdditionalTerminationPaymentCreatePayload>;
  createAmendmentTimeSheet?: Maybe<CreateAmendmentTimeSheetMutationPayload>;
  createBacsCheckoutSession?: Maybe<CreateBacsCheckoutSessionPayload>;
  createBankAccountPaymentMethod?: Maybe<CreateBankAccountPaymentMethodPayload>;
  createBulkEngagementChange?: Maybe<CreateBulkEngagementChangePayload>;
  createBulkOffboarding?: Maybe<BulkCreatePayload>;
  createBulkOnboarding?: Maybe<CreateBulkOnboardingPayload>;
  createCobranding?: Maybe<CreateCobrandingPayload>;
  createContract?: Maybe<CreateContractPayload>;
  createContractorInvoice?: Maybe<CreateContractorInvoicePayload>;
  createCostCenter?: Maybe<CreateCostCenterPayload>;
  createCustomPrice?: Maybe<CreateCustomPricePayload>;
  createCustomReasonMappings?: Maybe<CreateCustomReasonMappingsPayload>;
  createCustomTimeOffMappings?: Maybe<CreateCustomTimeOffMappingsPayload>;
  createCustomerBankAccount?: Maybe<CreateCustomerBankAccountPayload>;
  createDepartment?: Maybe<DepartmentCreatePayload>;
  createDependent?: Maybe<CreateDependentPayload>;
  createDepositInvoice?: Maybe<CreatePayload>;
  createDocument?: Maybe<CreateDocumentPayload>;
  createDraftEquityGrant?: Maybe<CreateDraftGrantPayload>;
  createEmployerOfRecord?: Maybe<CreateEmployerOfRecordPayload>;
  /** Creates an employer of record country */
  createEmployerOfRecordCountry?: Maybe<CreateEmployerOfRecordCountryPayload>;
  createEmployment?: Maybe<CreateEmploymentPayload>;
  createEmploymentTemplate?: Maybe<CreateEmploymentTemplatePayload>;
  createEnrollmentTemplate?: Maybe<CreateEnrollmentTemplatePayload>;
  createEntitlementAdjustment?: Maybe<TimeOffTransactionCreateEntitlementAdjustmentPayload>;
  createEquityGrant?: Maybe<CreateGrantPayload>;
  createEquityWithholdingRequest?: Maybe<CreateWithholdingRequestPayload>;
  createExpense?: Maybe<CreateExpensePayload>;
  createExternalPointOfContact?: Maybe<CreateExternalPointOfContactPayload>;
  createGpTermination?: Maybe<GlobalPayrollTerminationCreatePayload>;
  createInvoice?: Maybe<CreateInvoicePayload>;
  createJobRoleSearch?: Maybe<CreateJobRoleSearchPayload>;
  createManualKycVerification?: Maybe<CreateManualKycVerificationPayload>;
  /** Triggers the Employer Create Hire action (HQ domain). If the action succeeds then we create a merge integration. */
  createMergeHire?: Maybe<CreateMergeHirePayload>;
  /** Creates an OAuth2 application to use with our Public REST API */
  createOauthApplication?: Maybe<CreateOauthApplicationPayload>;
  createOffboardingForm?: Maybe<TerminationCreatePayload>;
  createOktaCredential?: Maybe<CreateOktaCredentialPayload>;
  createOrUpdateSeniorityLevelMatch?: Maybe<CreateOrUpdateSeniorityLevelMatchPayload>;
  createPadCheckoutSession?: Maybe<CreatePadCheckoutSessionPayload>;
  createPaymentMethodStripeAch?: Maybe<CreatePaymentMethodStripeAchPayload>;
  createPaymentMethodStripeAchViaPlaid?: Maybe<CreatePaymentMethodStripeAchViaPlaidPayload>;
  createPaymentMethodStripeSepa?: Maybe<CreatePaymentMethodStripeSepaPayload>;
  createPaymentsGroup?: Maybe<CreatePaymentsGroupPayload>;
  createPayrollCycleDocument?: Maybe<CreatePayrollCycleDocumentPayload>;
  createPayrollEntity?: Maybe<CreatePayrollEntityPayload>;
  createPerlRequest?: Maybe<CreatePerlRequestPayload>;
  createReimbursementBudget?: Maybe<CreateReimbursementBudgetPayload>;
  createResellerEndClient?: Maybe<CreateResellerEndClientPayload>;
  createResignation?: Maybe<ResignationCreatePayload>;
  createSageAssistantChat?: Maybe<CreateSageAssistantChatPayload>;
  createScaleSubscription?: Maybe<CreateScaleSubscriptionPayload>;
  createSeedEngagement?: Maybe<CreateSeedEngagementPayload>;
  createSelfServiceDocument?: Maybe<SelfServiceDocumentCreatePayload>;
  createSepaSetupIntent?: Maybe<CreateSepaSetupIntentPayload>;
  createServiceAgreementChangeAcknowledgement?: Maybe<CreateServiceAgreementChangeAcknowledgementPayload>;
  createTimeOffHoliday?: Maybe<TimeOffHolidayCreatePayload>;
  createTimeOffRequest?: Maybe<TimeOffRequestCreatePayload>;
  createTimeOffTransaction?: Maybe<TimeOffTransactionCreatePayload>;
  createTimeSheet?: Maybe<CreateTimeSheetMutationPayload>;
  createTimeSheetEntry?: Maybe<CreateTimeSheetEntryPayload>;
  createTimeSheetReport?: Maybe<TimeSheetReportCreatePayload>;
  createToolLegalConsent?: Maybe<CreateToolLegalConsentPayload>;
  createVariableCompensation?: Maybe<CreateVariableCompensationPayload>;
  createVariableCompensationTemplate?: Maybe<CreateVariableCompensationTemplatePayload>;
  customDiscount?: Maybe<CustomDiscountPayload>;
  /** Deactivating an ADP Workforce Now integration. */
  deactivateAdpWorkforceNowIntegration?: Maybe<DeactivateAdpWorkforceNowIntegrationPayload>;
  deactivateCustomPrice?: Maybe<DeactivateCustomPricePayload>;
  deactivateDirectDebitEnforcement?: Maybe<DeactivateDirectDebitEnforcementPayload>;
  deactivateDiscount?: Maybe<DeactivateDiscountPayload>;
  deactivateDiscountOverride?: Maybe<DeactivateDiscountOverridePayload>;
  deactivateDiscountRedemption?: Maybe<DeactivateDiscountRedemptionPayload>;
  deactivateScaleSubscription?: Maybe<DeactivateScaleSubscriptionPayload>;
  /** Deactivating an Trinet integration. */
  deactivateTrinetIntegration?: Maybe<DeactivateTrinetIntegrationPayload>;
  /**
   * Deletes Codat integrations. On background revokes access, removes all data from accounting system
   * in Codat and local databases.
   */
  deleteAccountingIntegration?: Maybe<DeleteAccountingIntegrationPayload>;
  deleteCobranding?: Maybe<DeleteCobrandingPayload>;
  deleteCustomTimeOffMappings?: Maybe<DeleteCustomTimeOffMappingsPayload>;
  /** Deletes expenses integrations. On background marks integrations as deleted. */
  deleteExpensesIntegration?: Maybe<DeleteExpensesIntegrationPayload>;
  /** Delete the current markup adjustment (discount, extra-cost) for a Company */
  deleteFXMarkupAdjustment?: Maybe<DeleteFxMarkupAdjustmentPayload>;
  /**
   * Deletes a merge integration. Deletion here means that the integration is disabled, all data is
   * preserved, but updates stop. Can be re-enabled by "recreating" the integration.
   */
  deleteMergeIntegration?: Maybe<DeleteMergeIntegrationPayload>;
  deletePaymentsGroup?: Maybe<DeletePaymentsGroupPayload>;
  deleteTimeOffHoliday?: Maybe<TimeOffHolidayDeletePayload>;
  destroyAdditionalPayment?: Maybe<AdditionalTerminationPaymentDestroyPayload>;
  destroyAddress?: Maybe<DestroyAddressPayload>;
  destroyComplianceCheckerSetupAndData?: Maybe<DestroyComplianceCheckerSetupAndDataPayload>;
  destroyContract?: Maybe<DestroyContractPayload>;
  destroyContractorInvoice?: Maybe<DestroyContractorInvoicePayload>;
  destroyCostCenter?: Maybe<DestroyCostCenterPayload>;
  destroyCreditNote?: Maybe<DestroyCreditNotePayload>;
  destroyDepartment?: Maybe<DepartmentDestroyPayload>;
  destroyDependent?: Maybe<DestroyDependentPayload>;
  destroyDocument?: Maybe<DestroyDocumentPayload>;
  destroyEmployerOfRecord?: Maybe<DestroyEmployerOfRecordPayload>;
  destroyEmployment?: Maybe<DestroyEmploymentPayload>;
  destroyEmploymentTemplate?: Maybe<DestroyEmploymentTemplatePayload>;
  destroyEquityGrant?: Maybe<DestroyGrantPayload>;
  destroyEquityWithholdingRequest?: Maybe<DestroyEquityWithholdingRequestPayload>;
  destroyExpense?: Maybe<DestroyExpensePayload>;
  destroyExternalPointOfContact?: Maybe<DestroyExternalPointOfContactPayload>;
  destroyIntegrationHire?: Maybe<DestroyIntegrationHirePayload>;
  destroyInvoice?: Maybe<DestroyInvoicePayload>;
  /** Destroys an Oauth2 application used to access our Public REST API */
  destroyOauthApplication?: Maybe<DestroyOauthApplicationPayload>;
  destroyOysterAdminProfile?: Maybe<DestroyOysterAdminProfilePayload>;
  destroyPaySupplement?: Maybe<DestroyPaySupplementPayload>;
  destroyPaymentMethod?: Maybe<DestroyPaymentMethodPayload>;
  destroyPayrollCycleDocuments?: Maybe<DestroyPayrollCycleDocumentsPayload>;
  destroyReimbursementBudget?: Maybe<DestroyReimbursementBudgetPayload>;
  destroyTermination?: Maybe<TerminationDestroyPayload>;
  destroyTimeSheet?: Maybe<DestroyTimeSheetMutationPayload>;
  destroyTimeSheetEntry?: Maybe<DestroyTimeSheetEntryPayload>;
  destroyVariableCompensationTemplate?: Maybe<DestroyVariableCompensationTemplatePayload>;
  detachDocument?: Maybe<EngagementChangeDetachDocumentPayload>;
  disableAccountingContractorVendorCreation?: Maybe<DisableAccountingContractorVendorCreationPayload>;
  disableAccountingTrackingCategories?: Maybe<DisableAccountingTrackingCategoriesPayload>;
  disableAgreement?: Maybe<DisableAgreementPayload>;
  disableESign?: Maybe<DisableESignPayload>;
  disableESignOsa?: Maybe<DisableESignOsaPayload>;
  disableFeature?: Maybe<DisableFeaturePayload>;
  disableOffboardingESign?: Maybe<DisableOffboardingESignPayload>;
  documentGeneratorCreateGeneration?: Maybe<DocumentGeneratorCreateGenerationPayload>;
  documentGeneratorSendArchive?: Maybe<DocumentGeneratorSendArchivePayload>;
  editCompanySubscription?: Maybe<EditCompanySubscriptionPayload>;
  employerCreateHire?: Maybe<EmployerCreateHirePayload>;
  employerRequestEnrollment?: Maybe<RequestEnrollmentPayload>;
  employerUpdateHire?: Maybe<EmployerUpdateHirePayload>;
  employmentLogRequestChange?: Maybe<EmploymentLogRequestChangePayload>;
  enableAccountingContractorVendorCreation?: Maybe<EnableAccountingContractorVendorCreationPayload>;
  enableAccountingTrackingCategories?: Maybe<EnableAccountingTrackingCategoriesPayload>;
  enableAgreement?: Maybe<EnableAgreementPayload>;
  enableFeature?: Maybe<EnableFeaturePayload>;
  engageEmploymentWithPartiallySignedAgreements?: Maybe<EngageEmploymentWithPartiallySignedAgreementsPayload>;
  enrolPackage?: Maybe<EnrolPackagePayload>;
  enrollDependents?: Maybe<EnrollDependentsPayload>;
  equityCreateCompanyPlan?: Maybe<CreateCompanyPlanPayload>;
  equityCreateCompanyValuation?: Maybe<CreateCompanyValuationPayload>;
  equityUpdateCompanyPlan?: Maybe<UpdateCompanyPlanPayload>;
  executeActionLink?: Maybe<ExecuteActionLinkPayload>;
  exportDocxForAgreement?: Maybe<ExportDocxForAgreementPayload>;
  finalizeWorkforceReportResults?: Maybe<FinalizeWorkforceReportResultsPayload>;
  gdprDeleteCompany?: Maybe<GdprDeleteCompanyPayload>;
  gdprDeleteUser?: Maybe<GdprDeleteUserPayload>;
  gdprExportCompany?: Maybe<GdprExportCompanyPayload>;
  gdprExportUser?: Maybe<GdprExportUserPayload>;
  generateAgreementsAsync?: Maybe<GenerateAgreementsAsyncPayload>;
  generateContractorAgreementsAsync?: Maybe<GenerateContractorAgreementsAsyncPayload>;
  generateSignableAgreementFile?: Maybe<GenerateSignableAgreementFilePayload>;
  hiringAdminUpdateTaskState?: Maybe<HiringAdminUpdateTaskStatePayload>;
  hiringCreateBulkProcessing?: Maybe<HiringCreateBulkProcessingPayload>;
  /** Starts processing of the country payroll file */
  importCountryPayroll?: Maybe<ImportCountryPayrollPayload>;
  initializeEsignatureAuthorization?: Maybe<InitializeEsignatureAuthorizationPayload>;
  initializePayrollInvoicing?: Maybe<InitializePayrollInvoicingPayload>;
  initiateContractTermination?: Maybe<ContractorsTerminationCreatePayload>;
  /** Imports selected hire record to Oyster app */
  integrationImportHire?: Maybe<ImportIntegrationHirePayload>;
  inviteContractor?: Maybe<InviteContractorPayload>;
  inviteTeamMember?: Maybe<InviteTeamMemberPayload>;
  inviteUserToCompany?: Maybe<InviteUserToCompanyPayload>;
  invoicingBulkApprove?: Maybe<ApprovePayload>;
  invoicingDraftCreditNote?: Maybe<DraftCreditNotePayload>;
  invoicingEditCreditNote?: Maybe<EditCreditNotePayload>;
  invoicingUpdateCompanySettings?: Maybe<UpdateCompanySettingsPayload>;
  invoicingUpdateEmployeeSettings?: Maybe<UpdateEmployeeSettingsPayload>;
  /** Associates Oyster cost centers with tracking categories from Codat for the given company */
  linkCostCentersToTrackingCategories?: Maybe<LinkCostCentersToTrackingCategoriesPayload>;
  /** Associates Oyster payroll types with accounts from Codat for the given company */
  linkPayrollTypesWithAccountingAccounts?: Maybe<LinkPayrollTypesWithAccountingAccountsPayload>;
  /** Triggers a manual sync of a merge integration, then pulls newly synced updates. */
  manualSyncMergeIntegration?: Maybe<ManualSyncIntegrationPayload>;
  markAgreementAsViewed?: Maybe<MarkAsViewedPayload>;
  markCoEmployeeOnboardingComplete?: Maybe<MarkCoEmployeeOnboardingCompletePayload>;
  nextAmendmentState?: Maybe<NextAmendmentStatePayload>;
  /** Disables OTP and resets OTP fields. */
  otpDisable: OtpDisablePayload;
  /** Enable TOTP if provided token is valid. */
  otpEnable: OtpEnablePayload;
  /** Enables OTP by email. */
  otpEnableByEmail: OtpEnableByEmailPayload;
  /** Send HOTP token by email. */
  otpSendByEmail: SendOtpByEmailPayload;
  payrollCycleDefaultTransition?: Maybe<PayrollCycleDefaultTransitionPayload>;
  postOysterSafeComment?: Maybe<PostOysterSafeCommentPayload>;
  postStaffNote?: Maybe<PostStaffNotePayload>;
  processBulkImportFile?: Maybe<ProcessBulkImportFilePayload>;
  processContractorsInvoicesBulkGeneration?: Maybe<ProcessContractorsInvoicesBulkGenerationPayload>;
  processWorkforceReportFile?: Maybe<ProcessWorkforceReportFilePayload>;
  processWorkforceReportRoleMatches?: Maybe<ProcessWorkforceReportRoleMatchesPayload>;
  processWorkforceReportSeniorityLevels?: Maybe<ProcessWorkforceReportSeniorityLevelsPayload>;
  provisionPackage?: Maybe<ProvisionPackagePayload>;
  purgeUnattachedFile?: Maybe<PurgeUnattachedFilePayload>;
  reSendInvitation?: Maybe<ReSendPayload>;
  reattachPdf?: Maybe<ReattachPdfPayload>;
  reconfirmMandateLodging?: Maybe<ReconfirmMandateLodgingPayload>;
  recordCostCalculatorVisit?: Maybe<RecordCostCalculatorVisitPayload>;
  recordFirstDashboardVisit?: Maybe<RecordFirstDashboardVisitPayload>;
  redeemDiscount?: Maybe<RedeemDiscountPayload>;
  regenerateComplianceCheckerReport?: Maybe<RegenerateComplianceCheckerReportPayload>;
  /** Securely regenerates the secret for a given OAuth application */
  regenerateOauthApplicationSecret?: Maybe<RegenerateOauthApplicationSecretPayload>;
  regeneratePayrollInvoice?: Maybe<RegeneratePayrollInvoicePayload>;
  regenerateYearlyForms?: Maybe<RegenerateYearlyFormsPayload>;
  reinitiateCharge?: Maybe<ReinitiateChargePayload>;
  reinitiatePayout?: Maybe<ReinitiatePayoutPayload>;
  rejectPayrollCycleDocuments?: Maybe<RejectPayrollCycleDocumentsPayload>;
  rejectTimeOffRequest?: Maybe<TimeOffRequestRejectPayload>;
  removeBillingEmailAddress?: Maybe<RemoveBillingEmailAddressPayload>;
  removeBulkEngagementChange?: Maybe<RemoveBulkEngagementChangePayload>;
  removeBulkEngagementChangeEntry?: Maybe<RemoveBulkEngagementChangeEntryPayload>;
  removeInvoicesFromPaymentsGroup?: Maybe<RemoveInvoicesFromPaymentsGroupPayload>;
  removeTeamMemberDirectManager?: Maybe<RemoveTeamMemberDirectManagerPayload>;
  requestCensusDataReport?: Maybe<RequestCensusDataReportPayload>;
  requestEngagementChange?: Maybe<EngagementChangeRequestPayload>;
  requestEngagementChangeAssistance?: Maybe<RequestEngagementChangeAssistancePayload>;
  requestEngagementModificationAndExtensionChange?: Maybe<EngagementChangeModificationAndExtensionRequestPayload>;
  requestEnrollmentsChangesReport?: Maybe<Benefits_Enrollment_Changes_Request_ReportPayload>;
  requestKybVerification?: Maybe<RequestKybVerificationPayload>;
  requestReconciliationReport?: Maybe<RequestReportPayload>;
  requestResignationCancellation?: Maybe<RequestResignationCancellationPayload>;
  requestScaleQuote?: Maybe<RequestScaleQuotePayload>;
  requestTermination?: Maybe<TerminationCreatePayload>;
  resetExpensesPaymentMethod?: Maybe<ResetExpensesPaymentMethodPayload>;
  reviewExpense?: Maybe<ReviewExpensePayload>;
  revokeDirectDebitAuthorization?: Maybe<RevokeDirectDebitAuthorizationPayload>;
  revokeInvitation?: Maybe<RevokePayload>;
  /** Revokes all OAuth access tokens and grants for a given application and user. */
  revokeOauthConnections?: Maybe<RevokeOauthConnectionsPayload>;
  revokeSso?: Maybe<RevokeSsoPayload>;
  revokeUserAccess?: Maybe<RevokeUserAccessPayload>;
  saveEmploymentHiringOnboardingForm?: Maybe<SaveEmploymentHiringOnboardingFormPayload>;
  /** Selects expenses policies for the given integration for getting expenses reports from integrations */
  selectExpensifyPolicies?: Maybe<SelectExpensifyPoliciesPayload>;
  sendAgreementEnvelope?: Maybe<SendAgreementEnvelopePayload>;
  /**
   * Generates a verification key, stores it in Redis and sends it by email
   * to be used for the verification step later during Concur set-up
   */
  sendConcurVerificationKey?: Maybe<SendConcurVerificationKeyPayload>;
  sendContractorInvoice?: Maybe<SendContractorInvoicePayload>;
  sendEnvelopeReminder?: Maybe<SendEnvelopeReminderPayload>;
  sendEquityIntentLetterForSignature?: Maybe<SendIntentLetterForSignaturePayload>;
  sendMandateReminder?: Maybe<SendMandateReminderPayload>;
  sendPayinReminderInvoice?: Maybe<SendPayinReminderInvoicePayload>;
  /** Sets the onboarding data for an ADP Workforce Now integration. */
  setAdpWorkforceNowOnboardingData?: Maybe<SetAdpWorkforceNowOnboardingDataPayload>;
  setChargeCompletedAt?: Maybe<SetCompletedAtPayload>;
  setExpensesPaymentMethod?: Maybe<SetExpensesPaymentMethodPayload>;
  setPrimaryPaymentMethod?: Maybe<SetPrimaryPaymentMethodPayload>;
  setupComplianceChecker?: Maybe<SetupComplianceCheckerPayload>;
  staffSubmitEmploymentHiringOnboardingForm?: Maybe<StaffSubmitEmploymentHiringOnboardingFormPayload>;
  startAmendmentProcess?: Maybe<StartAmendmentProcessPayload>;
  startCartaSync?: Maybe<StartCartaSyncPayload>;
  /**
   * Attempts to store subscriber credentials for the ADP Workforce Now integration fetched via API.
   * Credentials are only accessible if the user has provided consent for the integration.
   */
  storeAdpWorkforceNowCredentialsAfterConsent?: Maybe<StoreAdpWorkforceNowCredentialsAfterConsentPayload>;
  submitBulkEngagementChange?: Maybe<SubmitBulkEngagementChangePayload>;
  submitComplianceCheckerReportFeedback?: Maybe<SubmitComplianceCheckerReportFeedbackPayload>;
  submitMisclassificationAnalyzerResponse?: Maybe<SubmitResponsePayload>;
  submitSageAssistantFeedback?: Maybe<SubmitSageAssistantFeedbackPayload>;
  submitSageAssistantSupportTicket?: Maybe<SubmitSageAssistantSupportTicketPayload>;
  subscribe?: Maybe<SubscribePayload>;
  subscribeEngagementsToCustomPrice?: Maybe<SubscribeEngagementsToCustomPricePayload>;
  subscribeOysterSafe?: Maybe<SubscribeOysterSafePayload>;
  syncAccountingData?: Maybe<SyncAccountingDataPayload>;
  syncExpensesIntegration?: Maybe<SyncExpensesIntegrationPayload>;
  /** Sync the HRIS integration. */
  syncHrisIntegration?: Maybe<SyncHrisIntegrationPayload>;
  teamMemberEnrollBenefits?: Maybe<EnrollTeamMemberPayload>;
  terminateGpTermination?: Maybe<GlobalPayrollTerminationTerminatePayload>;
  terminationRunCompletionActions?: Maybe<TerminationRunCompletionActionsPayload>;
  toggleDepositBeforeLiability?: Maybe<ToggleDepositBeforeLiabilityPayload>;
  togglePaymentMethod?: Maybe<TogglePaymentMethodPayload>;
  transitionDependentEnrollment?: Maybe<TransitionDependentEnrollmentPayload>;
  transitionDependentEnrollmentToEnrolled?: Maybe<TransitionDependentEnrollmentToEnrolledPayload>;
  transitionEmployment?: Maybe<TransitionEmploymentPayload>;
  transitionEmploymentHiring?: Maybe<TransitionHiringPayload>;
  transitionEnrollment?: Maybe<TransitionEnrollmentPayload>;
  transitionInvoice?: Maybe<TransitionInvoicePayload>;
  transitionPaymentsGroupState?: Maybe<TransitionPaymentsGroupStatePayload>;
  transitionProvisionedEnrollment?: Maybe<TransitionProvisionedEnrollmentPayload>;
  transitionToEnrolled?: Maybe<TransitionEnrollmentToEnrolledPayload>;
  triggerEngagementInvitationNotifications?: Maybe<TriggerEngagementInvitationNotificationsPayload>;
  triggerHiringTaskAction?: Maybe<TriggerHiringTaskActionPayload>;
  /** Removes the block from direct debit payments and payouts. */
  unblockAutomatedPayments?: Maybe<UnblockAutomatedPaymentsPayload>;
  uninstallCarta?: Maybe<UninstallCartaPayload>;
  unlockAmendmentTimeSheet?: Maybe<UnlockAmendmentTimeSheetPayload>;
  unsubscribe?: Maybe<UnsubscribePayload>;
  /** Updates the default and credit account mappings in the accounting integration for the given company */
  updateAccountingBaseMappings?: Maybe<UpdateAccountingBaseMappingsPayload>;
  updateAdditionalAgreementsAfterSubmission?: Maybe<UpdateAdditionalAgreementsAfterSubmissionPayload>;
  updateAdditionalPayment?: Maybe<AdditionalTerminationPaymentUpdatePayload>;
  updateAgreementEnvelope?: Maybe<UpdateAgreementEnvelopePayload>;
  updateBenefitsAfterSubmission?: Maybe<UpdateBenefitsAfterSubmissionPayload>;
  updateBulkEngagementChange?: Maybe<UpdateBulkEngagementChangePayload>;
  updateBulkEngagementChangeEntry?: Maybe<UpdateBulkEngagementChangeEntryPayload>;
  updateBulkOffboarding?: Maybe<BulkUpdatePayload>;
  updateBulkOffboardingTm?: Maybe<BulkUpdateTmPayload>;
  updateCarryoverAmountLimitation?: Maybe<UpdateCarryoverAmountLimitationPayload>;
  updateCarryoverExpirationPeriod?: Maybe<UpdateCarryoverExpirationPeriodPayload>;
  updateCompanyPreferences?: Maybe<UpdatePreferencesPayload>;
  updateCompensationAfterSubmission?: Maybe<UpdateCompensationAfterSubmissionPayload>;
  updateComplianceCheckerMappings?: Maybe<UpdateComplianceCheckerMappingsPayload>;
  updateContract?: Maybe<UpdateContractPayload>;
  /** Update the tax residency info for a contract */
  updateContractTaxResidencyInfo?: Maybe<UpdateContractTaxResidencyInfoPayload>;
  /** Updates the work email address of a contract */
  updateContractWorkEmailAddress?: Maybe<UpdateContractWorkEmailAddressPayload>;
  updateContractorInvoice?: Maybe<UpdateContractorInvoicePayload>;
  updateCostCenter?: Maybe<UpdateCostCenterPayload>;
  /** Switches state of a country payroll to Paid or Downloaded */
  updateCountryPayrollState?: Maybe<UpdateCountryPayrollStatePayload>;
  updateCustomerBankAccount?: Maybe<UpdateCustomerBankAccountPayload>;
  updateDepartment?: Maybe<DepartmentUpdatePayload>;
  updateDependent?: Maybe<UpdateDependentPayload>;
  updateDependentEnrollment?: Maybe<UpdateDependentEnrollmentPayload>;
  updateDocument?: Maybe<UpdateDocumentPayload>;
  updateEmployerOfRecord?: Maybe<UpdateEmployerOfRecordPayload>;
  /** Updates an employer of record country */
  updateEmployerOfRecordCountry?: Maybe<UpdateEmployerOfRecordCountryPayload>;
  updateEmployment?: Maybe<UpdateEmploymentPayload>;
  updateEmploymentInformation?: Maybe<UpdateEmploymentInformationPayload>;
  updateEmploymentInformationAfterSubmission?: Maybe<UpdateEmploymentInformationAfterSubmissionPayload>;
  updateEmploymentTemplate?: Maybe<UpdateEmploymentTemplatePayload>;
  /** Updates the work email address of an employment */
  updateEmploymentWorkEmailAddress?: Maybe<UpdateEmploymentWorkEmailAddressPayload>;
  updateEngagementExportTemplate?: Maybe<UpdateEngagementExportTemplatePayload>;
  updateEngagementSettings?: Maybe<UpdateEngagementSettingsPayload>;
  updateEnrollment?: Maybe<UpdateEnrollmentPayload>;
  updateEnrollmentTemplate?: Maybe<UpdateEnrollmentTemplatePayload>;
  updateEquityGrant?: Maybe<UpdateGrantPayload>;
  updateEquityWithholdingRequestStatus?: Maybe<UpdateEquityWithholdingRequestStatusPayload>;
  updateExpense?: Maybe<UpdateExpensePayload>;
  updateExternalPointOfContact?: Maybe<UpdateExternalPointOfContactPayload>;
  /** Updates FX markup group's margin percentage and related markup pair margin percentages */
  updateFXMarkupGroup?: Maybe<UpdateFxMarkupGroupPayload>;
  /** Updates FX markup pair's markup group or margin percentage by from, to */
  updateFXMarkupPair?: Maybe<UpdateFxMarkupPairPayload>;
  updateFlexibleWorkArrangement?: Maybe<UpdateFlexibleWorkArrangementPayload>;
  updateGpTermination?: Maybe<GlobalPayrollTerminationUpdatePayload>;
  /** Updated integration add-ons (features field in DB) */
  updateIntegrationAddOns?: Maybe<UpdateIntegrationAddOnsPayload>;
  updateInvoice?: Maybe<UpdateInvoicePayload>;
  /** Enables or disables the monthly generation of invoices for fixed contractors. */
  updateInvoicingEnabledContractSetting?: Maybe<UpdateInvoicingEnabledContractSettingPayload>;
  updateMandateEmbeddedLink?: Maybe<UpdateMandateEmbeddedLinkPayload>;
  updateNewStarterSlackNotification?: Maybe<UpdateNewStarterSlackNotificationPayload>;
  /** Updates an Oauth2 application to use with our Public REST API */
  updateOauthApplication?: Maybe<UpdateOauthApplicationPayload>;
  updateOktaCredential?: Maybe<UpdateOktaCredentialPayload>;
  updatePaymentCurrency?: Maybe<UpdatePaymentCurrencyPayload>;
  updatePaymentOrderCharge?: Maybe<UpdatePayload>;
  updatePaymentsSettings?: Maybe<PaymentsSettingsUpdatePayload>;
  updatePayrollEntity?: Maybe<UpdatePayrollEntityPayload>;
  updatePersonalDetails?: Maybe<UpdatePersonalDetailsPayload>;
  updatePersonalInfoAfterSubmission?: Maybe<UpdatePersonalInfoAfterSubmissionPayload>;
  updateRefundDetails?: Maybe<UpdateRefundDetailsPayload>;
  updateReimbursementBudget?: Maybe<UpdateReimbursementBudgetPayload>;
  updateRequiredForm?: Maybe<UpdateRequiredFormPayload>;
  /** Update retroactive payment for engagement change */
  updateRetroactivePayment?: Maybe<UpdateRetroactivePaymentPayload>;
  updateRoleDetails?: Maybe<UpdateRoleDetailsPayload>;
  updateRoleInformationAfterSubmission?: Maybe<UpdateRoleInformationAfterSubmissionPayload>;
  updateRoleMatch?: Maybe<UpdateRoleMatchPayload>;
  /** Updates the selected company code (depends on the type argument) for an ADP Workforce Now integration. */
  updateSelectedAdpWorkforceNowCompanyCode?: Maybe<UpdateSelectedAdpWorkforceNowCompanyCodePayload>;
  updateStepsTermination?: Maybe<OffboardingStepsUpdatePayload>;
  updateSubdivisionCode?: Maybe<UpdateSubdivisionCodePayload>;
  updateTermination?: Maybe<TerminationUpdatePayload>;
  updateTimeOffAttachment?: Maybe<TimeOffRequestUpdateAttachmentPayload>;
  updateTimeOffHoliday?: Maybe<TimeOffHolidayUpdatePayload>;
  updateTimeOffMappings?: Maybe<UpdateTimeOffMappingsPayload>;
  updateTimeSheet?: Maybe<UpdateTimeSheetMutationPayload>;
  updateTimeSheetEntriesForDate?: Maybe<UpdateTimeSheetEntriesForDatePayload>;
  updateTimeSheetEntry?: Maybe<UpdateTimeSheetEntryMutationPayload>;
  updateTimeTrackingEngagementSettings?: Maybe<UpdateTimeTrackingEngagementSettingsPayload>;
  updateTimeTrackingToolOverride?: Maybe<UpdateTimeTrackingToolOverrideMutationPayload>;
  updateVariableCompensation?: Maybe<UpdateVariableCompensationPayload>;
  updateVariableCompensationTemplate?: Maybe<UpdateVariableCompensationTemplatePayload>;
  uploadAgreement?: Maybe<UploadAgreementPayload>;
  uploadAmendment?: Maybe<UploadAmendmentPayload>;
  /** Creates or updates a markup adjustment (discount, extra-cost) for a Company */
  upsertFXMarkupAdjustment?: Maybe<UpsertMarkupAdjustmentPayload>;
  upsertMonthlyFee?: Maybe<UpsertVendorMonthlyFeePayload>;
  upsertPaySupplement?: Maybe<UpsertPaySupplementPayload>;
  validateClmTemplate?: Maybe<ValidateClmTemplatePayload>;
  verifyAgreement?: Maybe<VerifyAgreementPayload>;
  verifyStripeAchPaymentMethod?: Maybe<VerifyStripeAchPaymentMethodPayload>;
  voidHiringEnvelope?: Maybe<VoidEnvelopePayload>;
};


export type MutationAcceptTermsArgs = {
  input: AuthorizationAcceptTermsInput;
};


export type MutationActivateAdpWorkforceNowIntegrationArgs = {
  input: ActivateAdpWorkforceNowIntegrationInput;
};


export type MutationActivateDirectDebitEnforcementArgs = {
  input: ActivateDirectDebitEnforcementInput;
};


export type MutationActivateDiscountArgs = {
  input: ActivateDiscountInput;
};


export type MutationActivateTrinetIntegrationArgs = {
  input: ActivateTrinetIntegrationInput;
};


export type MutationAddBillingEmailAddressArgs = {
  input: AddBillingEmailAddressInput;
};


export type MutationAddCartaIdsToEngagementsArgs = {
  input: AddCartaIDsToEngagementsInput;
};


export type MutationAddCompanyAdminArgs = {
  input: AddCompanyAdminInput;
};


export type MutationAddDependentToEnrollmentArgs = {
  input: AddDependentToEnrollmentInput;
};


export type MutationAddInvoicesToPaymentsGroupArgs = {
  input: AddInvoicesToPaymentsGroupInput;
};


export type MutationAddOnDeactivateArgs = {
  input: AddOnDeactivateInput;
};


export type MutationAddOnStartTrialArgs = {
  input: AddOnStartTrialInput;
};


export type MutationAddOnSubscribeArgs = {
  input: AddOnSubscribeInput;
};


export type MutationAddSignatoryPointOfContactArgs = {
  input: AddSignatoryPointOfContactInput;
};


export type MutationAdjustChargeStateManuallyArgs = {
  input: AdjustChargeStateManuallyInput;
};


export type MutationAdjustPayoutStateManuallyArgs = {
  input: AdjustPayoutStateManuallyInput;
};


export type MutationAgreeToEquityTermsArgs = {
  input: AgreeToTermsInput;
};


export type MutationApplyCreditNoteArgs = {
  input: ApplyCreditNoteInput;
};


export type MutationApproveCountryPayrollArgs = {
  input: ApproveCountryPayrollInput;
};


export type MutationApproveEngagementChangeArgs = {
  input: ApproveEngagementChangeInput;
};


export type MutationApproveExpensesArgs = {
  input: ApproveExpensesInput;
};


export type MutationApproveInvoicesArgs = {
  input: ApproveInvoicesInput;
};


export type MutationApproveResignationCancellationArgs = {
  input: ApproveResignationCancellationInput;
};


export type MutationApproveTerminationArgs = {
  input: TerminationApproveInput;
};


export type MutationApproveTerminationCancellationArgs = {
  input: TerminationApproveCancellationInput;
};


export type MutationApproveTimeOffRequestArgs = {
  input: TimeOffRequestApproveInput;
};


export type MutationAssignCostCenterArgs = {
  input: AssignCostCenterToEngagementInput;
};


export type MutationAssignDepartmentArgs = {
  input: AssignDepartmentInput;
};


export type MutationAssignSignatoryPointOfContactArgs = {
  input: AssignSignatoryPointOfContactInput;
};


export type MutationAssignStaffMembersArgs = {
  input: AssignStaffMembersInput;
};


export type MutationAssignTeamMemberDirectManagerArgs = {
  input: AssignTeamMemberDirectManagerInput;
};


export type MutationAttachDocumentArgs = {
  input: EngagementChangeAttachDocumentInput;
};


export type MutationAuthorizeDirectDebitOnPaymentMethodArgs = {
  input: AuthorizeDirectDebitOnPaymentMethodInput;
};


export type MutationBackdateEngagementChangeArgs = {
  input: BackdateEngagementChangeInput;
};


export type MutationBeginKycVerificationArgs = {
  input: KycBeginVerificationInput;
};


export type MutationBlockAutomatedPaymentsArgs = {
  input: BlockAutomatedPaymentsInput;
};


export type MutationBookDemoArgs = {
  input: BookDemoInput;
};


export type MutationBulkAddTmsToInProgressArgs = {
  input: AddTmsToInProgressBulkOffboadingInput;
};


export type MutationBulkCreatePaySupplementsArgs = {
  input: BulkCreatePaySupplementsInput;
};


export type MutationBulkUpdateTerminationsArgs = {
  input: BulkUpdateTerminationsInput;
};


export type MutationBypassKybVerificationArgs = {
  input: BypassKybVerificationInput;
};


export type MutationCalculateDepositRecordArgs = {
  input: CalculateDepositRecordInput;
};


export type MutationCancelBulkEngagementChangeArgs = {
  input: CancelBulkEngagementChangeInput;
};


export type MutationCancelBulkEngagementChangeEntryArgs = {
  input: CancelBulkEngagementChangeEntryInput;
};


export type MutationCancelEngagementChangeArgs = {
  input: CancelEngagementChangeInput;
};


export type MutationCancelOysterSafeArgs = {
  input: CancelOysterSafeInput;
};


export type MutationCancelTerminationArgs = {
  input: TerminationCancelInput;
};


export type MutationCancelTimeOffRequestArgs = {
  input: TimeOffRequestCancelInput;
};


export type MutationCancelVariableCompensationArgs = {
  input: CancelVariableCompensationInput;
};


export type MutationChangeAccountArgs = {
  input: ChangeAccountInput;
};


export type MutationChangeAccountingPrimaryVendorArgs = {
  input: ChangeAccountingPrimaryVendorInput;
};


export type MutationChangeAddressArgs = {
  input: ChangeAddressInput;
};


export type MutationChangeCompanyArgs = {
  input: ChangeCompanyInput;
};


export type MutationChangeCustomerBankAccountSignerArgs = {
  input: ChangeCustomerBankAccountSignerInput;
};


export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};


export type MutationChangeEquityPlanArgs = {
  input: ChangeEquityPlanInput;
};


export type MutationChangeOysterAdminProfileArgs = {
  input: ChangeOysterAdminProfileInput;
};


export type MutationChangePackageArgs = {
  input: ChangePackageInput;
};


export type MutationChangeStateCreditNoteArgs = {
  input: ChangeStateInput;
};


export type MutationChangeUserBanArgs = {
  input: ChangeUserBanInput;
};


export type MutationChangeUserPersonalInfoArgs = {
  input: ChangeUserPersonalInfoInput;
};


export type MutationChargeInvoicesArgs = {
  input: ChargeInvoicesInput;
};


export type MutationCompanyOidcSsoEnableArgs = {
  input: CompanyOidcSsoEnableInput;
};


export type MutationCompanyOktaSsoEnableArgs = {
  input: CompanyOktaSsoEnableInput;
};


export type MutationCompanySamlSsoEnableArgs = {
  input: CompanySamlSsoEnableInput;
};


export type MutationCompanySsoDisableArgs = {
  input: CompanySsoDisableInput;
};


export type MutationCompanyWaadSsoEnableArgs = {
  input: CompanyWaadSsoEnableInput;
};


export type MutationCompleteAdpWorkforceNowConfigurationArgs = {
  input: CompleteAdpWorkforceNowConfigurationInput;
};


export type MutationCompleteGrantArgs = {
  input: CompleteGrantInput;
};


export type MutationConfirmEngagementChangeCancellationArgs = {
  input: ConfirmEngagementChangeCancellationInput;
};


export type MutationConfirmMandateLodgingArgs = {
  input: ConfirmMandateLodgingInput;
};


export type MutationConfirmTimeSheetArgs = {
  input: ConfirmTimeSheetInput;
};


export type MutationConnectAccountingPlatformArgs = {
  input: ConnectAccountingPlatformInput;
};


export type MutationConnectExpensesPlatformArgs = {
  input: ConnectExpensesPlatformInput;
};


export type MutationConnectToMergeIntegrationArgs = {
  input: ConnectToMergeIntegrationInput;
};


export type MutationContractorAgreesOysterSafeArgs = {
  input: ContractorAgreesOysterSafeInput;
};


export type MutationContractorDisagreesOysterSafeArgs = {
  input: ContractorDisagreesOysterSafeInput;
};


export type MutationCreateAccountingVendorsForUnlinkedContractorsArgs = {
  input: CreateAccountingVendorsForUnlinkedContractorsInput;
};


export type MutationCreateAdditionalPaymentArgs = {
  input: AdditionalTerminationPaymentCreateInput;
};


export type MutationCreateAmendmentTimeSheetArgs = {
  input: CreateAmendmentTimeSheetMutationInput;
};


export type MutationCreateBacsCheckoutSessionArgs = {
  input: CreateBacsCheckoutSessionInput;
};


export type MutationCreateBankAccountPaymentMethodArgs = {
  input: CreateBankAccountPaymentMethodInput;
};


export type MutationCreateBulkEngagementChangeArgs = {
  input: CreateBulkEngagementChangeInput;
};


export type MutationCreateBulkOffboardingArgs = {
  input: BulkCreateInput;
};


export type MutationCreateBulkOnboardingArgs = {
  input: CreateBulkOnboardingInput;
};


export type MutationCreateCobrandingArgs = {
  input: CreateCobrandingInput;
};


export type MutationCreateContractArgs = {
  input: CreateContractInput;
};


export type MutationCreateContractorInvoiceArgs = {
  input: CreateContractorInvoiceInput;
};


export type MutationCreateCostCenterArgs = {
  input: CreateCostCenterInput;
};


export type MutationCreateCustomPriceArgs = {
  input: CreateCustomPriceInput;
};


export type MutationCreateCustomReasonMappingsArgs = {
  input: CreateCustomReasonMappingsInput;
};


export type MutationCreateCustomTimeOffMappingsArgs = {
  input: CreateCustomTimeOffMappingsInput;
};


export type MutationCreateCustomerBankAccountArgs = {
  input: CreateCustomerBankAccountInput;
};


export type MutationCreateDepartmentArgs = {
  input: DepartmentCreateInput;
};


export type MutationCreateDependentArgs = {
  input: CreateDependentInput;
};


export type MutationCreateDepositInvoiceArgs = {
  input: CreateInput;
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateDraftEquityGrantArgs = {
  input: CreateDraftGrantInput;
};


export type MutationCreateEmployerOfRecordArgs = {
  input: CreateEmployerOfRecordInput;
};


export type MutationCreateEmployerOfRecordCountryArgs = {
  input: CreateEmployerOfRecordCountryInput;
};


export type MutationCreateEmploymentArgs = {
  input: CreateEmploymentInput;
};


export type MutationCreateEmploymentTemplateArgs = {
  input: CreateEmploymentTemplateInput;
};


export type MutationCreateEnrollmentTemplateArgs = {
  input: CreateEnrollmentTemplateInput;
};


export type MutationCreateEntitlementAdjustmentArgs = {
  input: TimeOffTransactionCreateEntitlementAdjustmentInput;
};


export type MutationCreateEquityGrantArgs = {
  input: CreateGrantInput;
};


export type MutationCreateEquityWithholdingRequestArgs = {
  input: CreateWithholdingRequestInput;
};


export type MutationCreateExpenseArgs = {
  input: CreateExpenseInput;
};


export type MutationCreateExternalPointOfContactArgs = {
  input: CreateExternalPointOfContactInput;
};


export type MutationCreateGpTerminationArgs = {
  input: GlobalPayrollTerminationCreateInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateJobRoleSearchArgs = {
  input: CreateJobRoleSearchInput;
};


export type MutationCreateManualKycVerificationArgs = {
  input: CreateManualKycVerificationInput;
};


export type MutationCreateMergeHireArgs = {
  input: CreateMergeHireInput;
};


export type MutationCreateOauthApplicationArgs = {
  input: CreateOauthApplicationInput;
};


export type MutationCreateOffboardingFormArgs = {
  input: TerminationCreateInput;
};


export type MutationCreateOktaCredentialArgs = {
  input: CreateOktaCredentialInput;
};


export type MutationCreateOrUpdateSeniorityLevelMatchArgs = {
  input: CreateOrUpdateSeniorityLevelMatchInput;
};


export type MutationCreatePadCheckoutSessionArgs = {
  input: CreatePadCheckoutSessionInput;
};


export type MutationCreatePaymentMethodStripeAchArgs = {
  input: CreatePaymentMethodStripeAchInput;
};


export type MutationCreatePaymentMethodStripeAchViaPlaidArgs = {
  input: CreatePaymentMethodStripeAchViaPlaidInput;
};


export type MutationCreatePaymentMethodStripeSepaArgs = {
  input: CreatePaymentMethodStripeSepaInput;
};


export type MutationCreatePaymentsGroupArgs = {
  input: CreatePaymentsGroupInput;
};


export type MutationCreatePayrollCycleDocumentArgs = {
  input: CreatePayrollCycleDocumentInput;
};


export type MutationCreatePayrollEntityArgs = {
  input: CreatePayrollEntityInput;
};


export type MutationCreatePerlRequestArgs = {
  input: CreatePerlRequestInput;
};


export type MutationCreateReimbursementBudgetArgs = {
  input: CreateReimbursementBudgetInput;
};


export type MutationCreateResellerEndClientArgs = {
  input: CreateResellerEndClientInput;
};


export type MutationCreateResignationArgs = {
  input: ResignationCreateInput;
};


export type MutationCreateSageAssistantChatArgs = {
  input: CreateSageAssistantChatInput;
};


export type MutationCreateScaleSubscriptionArgs = {
  input: CreateScaleSubscriptionInput;
};


export type MutationCreateSeedEngagementArgs = {
  input: CreateSeedEngagementInput;
};


export type MutationCreateSelfServiceDocumentArgs = {
  input: SelfServiceDocumentCreateInput;
};


export type MutationCreateSepaSetupIntentArgs = {
  input: CreateSepaSetupIntentInput;
};


export type MutationCreateServiceAgreementChangeAcknowledgementArgs = {
  input: CreateServiceAgreementChangeAcknowledgementInput;
};


export type MutationCreateTimeOffHolidayArgs = {
  input: TimeOffHolidayCreateInput;
};


export type MutationCreateTimeOffRequestArgs = {
  input: TimeOffRequestCreateInput;
};


export type MutationCreateTimeOffTransactionArgs = {
  input: TimeOffTransactionCreateInput;
};


export type MutationCreateTimeSheetArgs = {
  input: CreateTimeSheetMutationInput;
};


export type MutationCreateTimeSheetEntryArgs = {
  input: CreateTimeSheetEntryInput;
};


export type MutationCreateTimeSheetReportArgs = {
  input: TimeSheetReportCreateInput;
};


export type MutationCreateToolLegalConsentArgs = {
  input: CreateToolLegalConsentInput;
};


export type MutationCreateVariableCompensationArgs = {
  input: CreateVariableCompensationInput;
};


export type MutationCreateVariableCompensationTemplateArgs = {
  input: CreateVariableCompensationTemplateInput;
};


export type MutationCustomDiscountArgs = {
  input: CustomDiscountInput;
};


export type MutationDeactivateAdpWorkforceNowIntegrationArgs = {
  input: DeactivateAdpWorkforceNowIntegrationInput;
};


export type MutationDeactivateCustomPriceArgs = {
  input: DeactivateCustomPriceInput;
};


export type MutationDeactivateDirectDebitEnforcementArgs = {
  input: DeactivateDirectDebitEnforcementInput;
};


export type MutationDeactivateDiscountArgs = {
  input: DeactivateDiscountInput;
};


export type MutationDeactivateDiscountOverrideArgs = {
  input: DeactivateDiscountOverrideInput;
};


export type MutationDeactivateDiscountRedemptionArgs = {
  input: DeactivateDiscountRedemptionInput;
};


export type MutationDeactivateScaleSubscriptionArgs = {
  input: DeactivateScaleSubscriptionInput;
};


export type MutationDeactivateTrinetIntegrationArgs = {
  input: DeactivateTrinetIntegrationInput;
};


export type MutationDeleteAccountingIntegrationArgs = {
  input: DeleteAccountingIntegrationInput;
};


export type MutationDeleteCobrandingArgs = {
  input: DeleteCobrandingInput;
};


export type MutationDeleteCustomTimeOffMappingsArgs = {
  input: DeleteCustomTimeOffMappingsInput;
};


export type MutationDeleteExpensesIntegrationArgs = {
  input: DeleteExpensesIntegrationInput;
};


export type MutationDeleteFxMarkupAdjustmentArgs = {
  input: DeleteFxMarkupAdjustmentInput;
};


export type MutationDeleteMergeIntegrationArgs = {
  input: DeleteMergeIntegrationInput;
};


export type MutationDeletePaymentsGroupArgs = {
  input: DeletePaymentsGroupInput;
};


export type MutationDeleteTimeOffHolidayArgs = {
  input: TimeOffHolidayDeleteInput;
};


export type MutationDestroyAdditionalPaymentArgs = {
  input: AdditionalTerminationPaymentDestroyInput;
};


export type MutationDestroyAddressArgs = {
  input: DestroyAddressInput;
};


export type MutationDestroyComplianceCheckerSetupAndDataArgs = {
  input: DestroyComplianceCheckerSetupAndDataInput;
};


export type MutationDestroyContractArgs = {
  input: DestroyContractInput;
};


export type MutationDestroyContractorInvoiceArgs = {
  input: DestroyContractorInvoiceInput;
};


export type MutationDestroyCostCenterArgs = {
  input: DestroyCostCenterInput;
};


export type MutationDestroyCreditNoteArgs = {
  input: DestroyCreditNoteInput;
};


export type MutationDestroyDepartmentArgs = {
  input: DepartmentDestroyInput;
};


export type MutationDestroyDependentArgs = {
  input: DestroyDependentInput;
};


export type MutationDestroyDocumentArgs = {
  input: DestroyDocumentInput;
};


export type MutationDestroyEmployerOfRecordArgs = {
  input: DestroyEmployerOfRecordInput;
};


export type MutationDestroyEmploymentArgs = {
  input: DestroyEmploymentInput;
};


export type MutationDestroyEmploymentTemplateArgs = {
  input: DestroyEmploymentTemplateInput;
};


export type MutationDestroyEquityGrantArgs = {
  input: DestroyGrantInput;
};


export type MutationDestroyEquityWithholdingRequestArgs = {
  input: DestroyEquityWithholdingRequestInput;
};


export type MutationDestroyExpenseArgs = {
  input: DestroyExpenseInput;
};


export type MutationDestroyExternalPointOfContactArgs = {
  input: DestroyExternalPointOfContactInput;
};


export type MutationDestroyIntegrationHireArgs = {
  input: DestroyIntegrationHireInput;
};


export type MutationDestroyInvoiceArgs = {
  input: DestroyInvoiceInput;
};


export type MutationDestroyOauthApplicationArgs = {
  input: DestroyOauthApplicationInput;
};


export type MutationDestroyOysterAdminProfileArgs = {
  input: DestroyOysterAdminProfileInput;
};


export type MutationDestroyPaySupplementArgs = {
  input: DestroyPaySupplementInput;
};


export type MutationDestroyPaymentMethodArgs = {
  input: DestroyPaymentMethodInput;
};


export type MutationDestroyPayrollCycleDocumentsArgs = {
  input: DestroyPayrollCycleDocumentsInput;
};


export type MutationDestroyReimbursementBudgetArgs = {
  input: DestroyReimbursementBudgetInput;
};


export type MutationDestroyTerminationArgs = {
  input: TerminationDestroyInput;
};


export type MutationDestroyTimeSheetArgs = {
  input: DestroyTimeSheetMutationInput;
};


export type MutationDestroyTimeSheetEntryArgs = {
  input: DestroyTimeSheetEntryInput;
};


export type MutationDestroyVariableCompensationTemplateArgs = {
  input: DestroyVariableCompensationTemplateInput;
};


export type MutationDetachDocumentArgs = {
  input: EngagementChangeDetachDocumentInput;
};


export type MutationDisableAccountingContractorVendorCreationArgs = {
  input: DisableAccountingContractorVendorCreationInput;
};


export type MutationDisableAccountingTrackingCategoriesArgs = {
  input: DisableAccountingTrackingCategoriesInput;
};


export type MutationDisableAgreementArgs = {
  input: DisableAgreementInput;
};


export type MutationDisableESignArgs = {
  input: DisableESignInput;
};


export type MutationDisableESignOsaArgs = {
  input: DisableESignOsaInput;
};


export type MutationDisableFeatureArgs = {
  input: DisableFeatureInput;
};


export type MutationDisableOffboardingESignArgs = {
  input: DisableOffboardingESignInput;
};


export type MutationDocumentGeneratorCreateGenerationArgs = {
  input: DocumentGeneratorCreateGenerationInput;
};


export type MutationDocumentGeneratorSendArchiveArgs = {
  input: DocumentGeneratorSendArchiveInput;
};


export type MutationEditCompanySubscriptionArgs = {
  input: EditCompanySubscriptionInput;
};


export type MutationEmployerCreateHireArgs = {
  input: EmployerCreateHireInput;
};


export type MutationEmployerRequestEnrollmentArgs = {
  input: RequestEnrollmentInput;
};


export type MutationEmployerUpdateHireArgs = {
  input: EmployerUpdateHireInput;
};


export type MutationEmploymentLogRequestChangeArgs = {
  input: EmploymentLogRequestChangeInput;
};


export type MutationEnableAccountingContractorVendorCreationArgs = {
  input: EnableAccountingContractorVendorCreationInput;
};


export type MutationEnableAccountingTrackingCategoriesArgs = {
  input: EnableAccountingTrackingCategoriesInput;
};


export type MutationEnableAgreementArgs = {
  input: EnableAgreementInput;
};


export type MutationEnableFeatureArgs = {
  input: EnableFeatureInput;
};


export type MutationEngageEmploymentWithPartiallySignedAgreementsArgs = {
  input: EngageEmploymentWithPartiallySignedAgreementsInput;
};


export type MutationEnrolPackageArgs = {
  input: EnrolPackageInput;
};


export type MutationEnrollDependentsArgs = {
  input: EnrollDependentsInput;
};


export type MutationEquityCreateCompanyPlanArgs = {
  input: CreateCompanyPlanInput;
};


export type MutationEquityCreateCompanyValuationArgs = {
  input: CreateCompanyValuationInput;
};


export type MutationEquityUpdateCompanyPlanArgs = {
  input: UpdateCompanyPlanInput;
};


export type MutationExecuteActionLinkArgs = {
  input: ExecuteActionLinkInput;
};


export type MutationExportDocxForAgreementArgs = {
  input: ExportDocxForAgreementInput;
};


export type MutationFinalizeWorkforceReportResultsArgs = {
  input: FinalizeWorkforceReportResultsInput;
};


export type MutationGdprDeleteCompanyArgs = {
  input: GdprDeleteCompanyInput;
};


export type MutationGdprDeleteUserArgs = {
  input: GdprDeleteUserInput;
};


export type MutationGdprExportCompanyArgs = {
  input: GdprExportCompanyInput;
};


export type MutationGdprExportUserArgs = {
  input: GdprExportUserInput;
};


export type MutationGenerateAgreementsAsyncArgs = {
  input: GenerateAgreementsAsyncInput;
};


export type MutationGenerateContractorAgreementsAsyncArgs = {
  input: GenerateContractorAgreementsAsyncInput;
};


export type MutationGenerateSignableAgreementFileArgs = {
  input: GenerateSignableAgreementFileInput;
};


export type MutationHiringAdminUpdateTaskStateArgs = {
  input: HiringAdminUpdateTaskStateInput;
};


export type MutationHiringCreateBulkProcessingArgs = {
  input: HiringCreateBulkProcessingInput;
};


export type MutationImportCountryPayrollArgs = {
  input: ImportCountryPayrollInput;
};


export type MutationInitializeEsignatureAuthorizationArgs = {
  input: InitializeEsignatureAuthorizationInput;
};


export type MutationInitializePayrollInvoicingArgs = {
  input: InitializePayrollInvoicingInput;
};


export type MutationInitiateContractTerminationArgs = {
  input: ContractorsTerminationCreateInput;
};


export type MutationIntegrationImportHireArgs = {
  input: ImportIntegrationHireInput;
};


export type MutationInviteContractorArgs = {
  input: InviteContractorInput;
};


export type MutationInviteTeamMemberArgs = {
  input: InviteTeamMemberInput;
};


export type MutationInviteUserToCompanyArgs = {
  input: InviteUserToCompanyInput;
};


export type MutationInvoicingBulkApproveArgs = {
  input: ApproveInput;
};


export type MutationInvoicingDraftCreditNoteArgs = {
  input: DraftCreditNoteInput;
};


export type MutationInvoicingEditCreditNoteArgs = {
  input: EditCreditNoteInput;
};


export type MutationInvoicingUpdateCompanySettingsArgs = {
  input: UpdateCompanySettingsInput;
};


export type MutationInvoicingUpdateEmployeeSettingsArgs = {
  input: UpdateEmployeeSettingsInput;
};


export type MutationLinkCostCentersToTrackingCategoriesArgs = {
  input: LinkCostCentersToTrackingCategoriesInput;
};


export type MutationLinkPayrollTypesWithAccountingAccountsArgs = {
  input: LinkPayrollTypesWithAccountingAccountsInput;
};


export type MutationManualSyncMergeIntegrationArgs = {
  input: ManualSyncIntegrationInput;
};


export type MutationMarkAgreementAsViewedArgs = {
  input: MarkAsViewedInput;
};


export type MutationMarkCoEmployeeOnboardingCompleteArgs = {
  input: MarkCoEmployeeOnboardingCompleteInput;
};


export type MutationNextAmendmentStateArgs = {
  input: NextAmendmentStateInput;
};


export type MutationOtpDisableArgs = {
  input: OtpDisableInput;
};


export type MutationOtpEnableArgs = {
  input: OtpEnableInput;
};


export type MutationOtpEnableByEmailArgs = {
  input: OtpEnableByEmailInput;
};


export type MutationOtpSendByEmailArgs = {
  input: SendOtpByEmailInput;
};


export type MutationPayrollCycleDefaultTransitionArgs = {
  input: PayrollCycleDefaultTransitionInput;
};


export type MutationPostOysterSafeCommentArgs = {
  input: PostOysterSafeCommentInput;
};


export type MutationPostStaffNoteArgs = {
  input: PostStaffNoteInput;
};


export type MutationProcessBulkImportFileArgs = {
  input: ProcessBulkImportFileInput;
};


export type MutationProcessContractorsInvoicesBulkGenerationArgs = {
  input: ProcessContractorsInvoicesBulkGenerationInput;
};


export type MutationProcessWorkforceReportFileArgs = {
  input: ProcessWorkforceReportFileInput;
};


export type MutationProcessWorkforceReportRoleMatchesArgs = {
  input: ProcessWorkforceReportRoleMatchesInput;
};


export type MutationProcessWorkforceReportSeniorityLevelsArgs = {
  input: ProcessWorkforceReportSeniorityLevelsInput;
};


export type MutationProvisionPackageArgs = {
  input: ProvisionPackageInput;
};


export type MutationPurgeUnattachedFileArgs = {
  input: PurgeUnattachedFileInput;
};


export type MutationReSendInvitationArgs = {
  input: ReSendInput;
};


export type MutationReattachPdfArgs = {
  input: ReattachPdfInput;
};


export type MutationReconfirmMandateLodgingArgs = {
  input: ReconfirmMandateLodgingInput;
};


export type MutationRecordCostCalculatorVisitArgs = {
  input: RecordCostCalculatorVisitInput;
};


export type MutationRecordFirstDashboardVisitArgs = {
  input: RecordFirstDashboardVisitInput;
};


export type MutationRedeemDiscountArgs = {
  input: RedeemDiscountInput;
};


export type MutationRegenerateComplianceCheckerReportArgs = {
  input: RegenerateComplianceCheckerReportInput;
};


export type MutationRegenerateOauthApplicationSecretArgs = {
  input: RegenerateOauthApplicationSecretInput;
};


export type MutationRegeneratePayrollInvoiceArgs = {
  input: RegeneratePayrollInvoiceInput;
};


export type MutationRegenerateYearlyFormsArgs = {
  input: RegenerateYearlyFormsInput;
};


export type MutationReinitiateChargeArgs = {
  input: ReinitiateChargeInput;
};


export type MutationReinitiatePayoutArgs = {
  input: ReinitiatePayoutInput;
};


export type MutationRejectPayrollCycleDocumentsArgs = {
  input: RejectPayrollCycleDocumentsInput;
};


export type MutationRejectTimeOffRequestArgs = {
  input: TimeOffRequestRejectInput;
};


export type MutationRemoveBillingEmailAddressArgs = {
  input: RemoveBillingEmailAddressInput;
};


export type MutationRemoveBulkEngagementChangeArgs = {
  input: RemoveBulkEngagementChangeInput;
};


export type MutationRemoveBulkEngagementChangeEntryArgs = {
  input: RemoveBulkEngagementChangeEntryInput;
};


export type MutationRemoveInvoicesFromPaymentsGroupArgs = {
  input: RemoveInvoicesFromPaymentsGroupInput;
};


export type MutationRemoveTeamMemberDirectManagerArgs = {
  input: RemoveTeamMemberDirectManagerInput;
};


export type MutationRequestCensusDataReportArgs = {
  input: RequestCensusDataReportInput;
};


export type MutationRequestEngagementChangeArgs = {
  input: EngagementChangeRequestInput;
};


export type MutationRequestEngagementChangeAssistanceArgs = {
  input: RequestEngagementChangeAssistanceInput;
};


export type MutationRequestEngagementModificationAndExtensionChangeArgs = {
  input: EngagementChangeModificationAndExtensionRequestInput;
};


export type MutationRequestEnrollmentsChangesReportArgs = {
  input: Benefits_Enrollment_Changes_Request_ReportInput;
};


export type MutationRequestKybVerificationArgs = {
  input: RequestKybVerificationInput;
};


export type MutationRequestReconciliationReportArgs = {
  input: RequestReportInput;
};


export type MutationRequestResignationCancellationArgs = {
  input: RequestResignationCancellationInput;
};


export type MutationRequestScaleQuoteArgs = {
  input: RequestScaleQuoteInput;
};


export type MutationRequestTerminationArgs = {
  input: TerminationCreateInput;
};


export type MutationResetExpensesPaymentMethodArgs = {
  input: ResetExpensesPaymentMethodInput;
};


export type MutationReviewExpenseArgs = {
  input: ReviewExpenseInput;
};


export type MutationRevokeDirectDebitAuthorizationArgs = {
  input: RevokeDirectDebitAuthorizationInput;
};


export type MutationRevokeInvitationArgs = {
  input: RevokeInput;
};


export type MutationRevokeOauthConnectionsArgs = {
  input: RevokeOauthConnectionsInput;
};


export type MutationRevokeSsoArgs = {
  input: RevokeSsoInput;
};


export type MutationRevokeUserAccessArgs = {
  input: RevokeUserAccessInput;
};


export type MutationSaveEmploymentHiringOnboardingFormArgs = {
  input: SaveEmploymentHiringOnboardingFormInput;
};


export type MutationSelectExpensifyPoliciesArgs = {
  input: SelectExpensifyPoliciesInput;
};


export type MutationSendAgreementEnvelopeArgs = {
  input: SendAgreementEnvelopeInput;
};


export type MutationSendConcurVerificationKeyArgs = {
  input: SendConcurVerificationKeyInput;
};


export type MutationSendContractorInvoiceArgs = {
  input: SendContractorInvoiceInput;
};


export type MutationSendEnvelopeReminderArgs = {
  input: SendEnvelopeReminderInput;
};


export type MutationSendEquityIntentLetterForSignatureArgs = {
  input: SendIntentLetterForSignatureInput;
};


export type MutationSendMandateReminderArgs = {
  input: SendMandateReminderInput;
};


export type MutationSendPayinReminderInvoiceArgs = {
  input: SendPayinReminderInvoiceInput;
};


export type MutationSetAdpWorkforceNowOnboardingDataArgs = {
  input: SetAdpWorkforceNowOnboardingDataInput;
};


export type MutationSetChargeCompletedAtArgs = {
  input: SetCompletedAtInput;
};


export type MutationSetExpensesPaymentMethodArgs = {
  input: SetExpensesPaymentMethodInput;
};


export type MutationSetPrimaryPaymentMethodArgs = {
  input: SetPrimaryPaymentMethodInput;
};


export type MutationSetupComplianceCheckerArgs = {
  input: SetupComplianceCheckerInput;
};


export type MutationStaffSubmitEmploymentHiringOnboardingFormArgs = {
  input: StaffSubmitEmploymentHiringOnboardingFormInput;
};


export type MutationStartAmendmentProcessArgs = {
  input: StartAmendmentProcessInput;
};


export type MutationStartCartaSyncArgs = {
  input: StartCartaSyncInput;
};


export type MutationStoreAdpWorkforceNowCredentialsAfterConsentArgs = {
  input: StoreAdpWorkforceNowCredentialsAfterConsentInput;
};


export type MutationSubmitBulkEngagementChangeArgs = {
  input: SubmitBulkEngagementChangeInput;
};


export type MutationSubmitComplianceCheckerReportFeedbackArgs = {
  input: SubmitComplianceCheckerReportFeedbackInput;
};


export type MutationSubmitMisclassificationAnalyzerResponseArgs = {
  input: SubmitResponseInput;
};


export type MutationSubmitSageAssistantFeedbackArgs = {
  input: SubmitSageAssistantFeedbackInput;
};


export type MutationSubmitSageAssistantSupportTicketArgs = {
  input: SubmitSageAssistantSupportTicketInput;
};


export type MutationSubscribeArgs = {
  input: SubscribeInput;
};


export type MutationSubscribeEngagementsToCustomPriceArgs = {
  input: SubscribeEngagementsToCustomPriceInput;
};


export type MutationSubscribeOysterSafeArgs = {
  input: SubscribeOysterSafeInput;
};


export type MutationSyncAccountingDataArgs = {
  input: SyncAccountingDataInput;
};


export type MutationSyncExpensesIntegrationArgs = {
  input: SyncExpensesIntegrationInput;
};


export type MutationSyncHrisIntegrationArgs = {
  input: SyncHrisIntegrationInput;
};


export type MutationTeamMemberEnrollBenefitsArgs = {
  input: EnrollTeamMemberInput;
};


export type MutationTerminateGpTerminationArgs = {
  input: GlobalPayrollTerminationTerminateInput;
};


export type MutationTerminationRunCompletionActionsArgs = {
  input: TerminationRunCompletionActionsInput;
};


export type MutationToggleDepositBeforeLiabilityArgs = {
  input: ToggleDepositBeforeLiabilityInput;
};


export type MutationTogglePaymentMethodArgs = {
  input: TogglePaymentMethodInput;
};


export type MutationTransitionDependentEnrollmentArgs = {
  input: TransitionDependentEnrollmentInput;
};


export type MutationTransitionDependentEnrollmentToEnrolledArgs = {
  input: TransitionDependentEnrollmentToEnrolledInput;
};


export type MutationTransitionEmploymentArgs = {
  input: TransitionEmploymentInput;
};


export type MutationTransitionEmploymentHiringArgs = {
  input: TransitionHiringInput;
};


export type MutationTransitionEnrollmentArgs = {
  input: TransitionEnrollmentInput;
};


export type MutationTransitionInvoiceArgs = {
  input: TransitionInvoiceInput;
};


export type MutationTransitionPaymentsGroupStateArgs = {
  input: TransitionPaymentsGroupStateInput;
};


export type MutationTransitionProvisionedEnrollmentArgs = {
  input: TransitionProvisionedEnrollmentInput;
};


export type MutationTransitionToEnrolledArgs = {
  input: TransitionEnrollmentToEnrolledInput;
};


export type MutationTriggerEngagementInvitationNotificationsArgs = {
  input: TriggerEngagementInvitationNotificationsInput;
};


export type MutationTriggerHiringTaskActionArgs = {
  input: TriggerHiringTaskActionInput;
};


export type MutationUnblockAutomatedPaymentsArgs = {
  input: UnblockAutomatedPaymentsInput;
};


export type MutationUninstallCartaArgs = {
  input: UninstallCartaInput;
};


export type MutationUnlockAmendmentTimeSheetArgs = {
  input: UnlockAmendmentTimeSheetInput;
};


export type MutationUnsubscribeArgs = {
  input: UnsubscribeInput;
};


export type MutationUpdateAccountingBaseMappingsArgs = {
  input: UpdateAccountingBaseMappingsInput;
};


export type MutationUpdateAdditionalAgreementsAfterSubmissionArgs = {
  input: UpdateAdditionalAgreementsAfterSubmissionInput;
};


export type MutationUpdateAdditionalPaymentArgs = {
  input: AdditionalTerminationPaymentUpdateInput;
};


export type MutationUpdateAgreementEnvelopeArgs = {
  input: UpdateAgreementEnvelopeInput;
};


export type MutationUpdateBenefitsAfterSubmissionArgs = {
  input: UpdateBenefitsAfterSubmissionInput;
};


export type MutationUpdateBulkEngagementChangeArgs = {
  input: UpdateBulkEngagementChangeInput;
};


export type MutationUpdateBulkEngagementChangeEntryArgs = {
  input: UpdateBulkEngagementChangeEntryInput;
};


export type MutationUpdateBulkOffboardingArgs = {
  input: BulkUpdateInput;
};


export type MutationUpdateBulkOffboardingTmArgs = {
  input: BulkUpdateTmInput;
};


export type MutationUpdateCarryoverAmountLimitationArgs = {
  input: UpdateCarryoverAmountLimitationInput;
};


export type MutationUpdateCarryoverExpirationPeriodArgs = {
  input: UpdateCarryoverExpirationPeriodInput;
};


export type MutationUpdateCompanyPreferencesArgs = {
  input: UpdatePreferencesInput;
};


export type MutationUpdateCompensationAfterSubmissionArgs = {
  input: UpdateCompensationAfterSubmissionInput;
};


export type MutationUpdateComplianceCheckerMappingsArgs = {
  input: UpdateComplianceCheckerMappingsInput;
};


export type MutationUpdateContractArgs = {
  input: UpdateContractInput;
};


export type MutationUpdateContractTaxResidencyInfoArgs = {
  input: UpdateContractTaxResidencyInfoInput;
};


export type MutationUpdateContractWorkEmailAddressArgs = {
  input: UpdateContractWorkEmailAddressInput;
};


export type MutationUpdateContractorInvoiceArgs = {
  input: UpdateContractorInvoiceInput;
};


export type MutationUpdateCostCenterArgs = {
  input: UpdateCostCenterInput;
};


export type MutationUpdateCountryPayrollStateArgs = {
  input: UpdateCountryPayrollStateInput;
};


export type MutationUpdateCustomerBankAccountArgs = {
  input: UpdateCustomerBankAccountInput;
};


export type MutationUpdateDepartmentArgs = {
  input: DepartmentUpdateInput;
};


export type MutationUpdateDependentArgs = {
  input: UpdateDependentInput;
};


export type MutationUpdateDependentEnrollmentArgs = {
  input: UpdateDependentEnrollmentInput;
};


export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};


export type MutationUpdateEmployerOfRecordArgs = {
  input: UpdateEmployerOfRecordInput;
};


export type MutationUpdateEmployerOfRecordCountryArgs = {
  input: UpdateEmployerOfRecordCountryInput;
};


export type MutationUpdateEmploymentArgs = {
  input: UpdateEmploymentInput;
};


export type MutationUpdateEmploymentInformationArgs = {
  input: UpdateEmploymentInformationInput;
};


export type MutationUpdateEmploymentInformationAfterSubmissionArgs = {
  input: UpdateEmploymentInformationAfterSubmissionInput;
};


export type MutationUpdateEmploymentTemplateArgs = {
  input: UpdateEmploymentTemplateInput;
};


export type MutationUpdateEmploymentWorkEmailAddressArgs = {
  input: UpdateEmploymentWorkEmailAddressInput;
};


export type MutationUpdateEngagementExportTemplateArgs = {
  input: UpdateEngagementExportTemplateInput;
};


export type MutationUpdateEngagementSettingsArgs = {
  input: UpdateEngagementSettingsInput;
};


export type MutationUpdateEnrollmentArgs = {
  input: UpdateEnrollmentInput;
};


export type MutationUpdateEnrollmentTemplateArgs = {
  input: UpdateEnrollmentTemplateInput;
};


export type MutationUpdateEquityGrantArgs = {
  input: UpdateGrantInput;
};


export type MutationUpdateEquityWithholdingRequestStatusArgs = {
  input: UpdateEquityWithholdingRequestStatusInput;
};


export type MutationUpdateExpenseArgs = {
  input: UpdateExpenseInput;
};


export type MutationUpdateExternalPointOfContactArgs = {
  input: UpdateExternalPointOfContactInput;
};


export type MutationUpdateFxMarkupGroupArgs = {
  input: UpdateFxMarkupGroupInput;
};


export type MutationUpdateFxMarkupPairArgs = {
  input: UpdateFxMarkupPairInput;
};


export type MutationUpdateFlexibleWorkArrangementArgs = {
  input: UpdateFlexibleWorkArrangementInput;
};


export type MutationUpdateGpTerminationArgs = {
  input: GlobalPayrollTerminationUpdateInput;
};


export type MutationUpdateIntegrationAddOnsArgs = {
  input: UpdateIntegrationAddOnsInput;
};


export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};


export type MutationUpdateInvoicingEnabledContractSettingArgs = {
  input: UpdateInvoicingEnabledContractSettingInput;
};


export type MutationUpdateMandateEmbeddedLinkArgs = {
  input: UpdateMandateEmbeddedLinkInput;
};


export type MutationUpdateNewStarterSlackNotificationArgs = {
  input: UpdateNewStarterSlackNotificationInput;
};


export type MutationUpdateOauthApplicationArgs = {
  input: UpdateOauthApplicationInput;
};


export type MutationUpdateOktaCredentialArgs = {
  input: UpdateOktaCredentialInput;
};


export type MutationUpdatePaymentCurrencyArgs = {
  input: UpdatePaymentCurrencyInput;
};


export type MutationUpdatePaymentOrderChargeArgs = {
  input: UpdateInput;
};


export type MutationUpdatePaymentsSettingsArgs = {
  input: PaymentsSettingsUpdateInput;
};


export type MutationUpdatePayrollEntityArgs = {
  input: UpdatePayrollEntityInput;
};


export type MutationUpdatePersonalDetailsArgs = {
  input: UpdatePersonalDetailsInput;
};


export type MutationUpdatePersonalInfoAfterSubmissionArgs = {
  input: UpdatePersonalInfoAfterSubmissionInput;
};


export type MutationUpdateRefundDetailsArgs = {
  input: UpdateRefundDetailsInput;
};


export type MutationUpdateReimbursementBudgetArgs = {
  input: UpdateReimbursementBudgetInput;
};


export type MutationUpdateRequiredFormArgs = {
  input: UpdateRequiredFormInput;
};


export type MutationUpdateRetroactivePaymentArgs = {
  input: UpdateRetroactivePaymentInput;
};


export type MutationUpdateRoleDetailsArgs = {
  input: UpdateRoleDetailsInput;
};


export type MutationUpdateRoleInformationAfterSubmissionArgs = {
  input: UpdateRoleInformationAfterSubmissionInput;
};


export type MutationUpdateRoleMatchArgs = {
  input: UpdateRoleMatchInput;
};


export type MutationUpdateSelectedAdpWorkforceNowCompanyCodeArgs = {
  input: UpdateSelectedAdpWorkforceNowCompanyCodeInput;
};


export type MutationUpdateStepsTerminationArgs = {
  input: OffboardingStepsUpdateInput;
};


export type MutationUpdateSubdivisionCodeArgs = {
  input: UpdateSubdivisionCodeInput;
};


export type MutationUpdateTerminationArgs = {
  input: TerminationUpdateInput;
};


export type MutationUpdateTimeOffAttachmentArgs = {
  input: TimeOffRequestUpdateAttachmentInput;
};


export type MutationUpdateTimeOffHolidayArgs = {
  input: TimeOffHolidayUpdateInput;
};


export type MutationUpdateTimeOffMappingsArgs = {
  input: UpdateTimeOffMappingsInput;
};


export type MutationUpdateTimeSheetArgs = {
  input: UpdateTimeSheetMutationInput;
};


export type MutationUpdateTimeSheetEntriesForDateArgs = {
  input: UpdateTimeSheetEntriesForDateInput;
};


export type MutationUpdateTimeSheetEntryArgs = {
  input: UpdateTimeSheetEntryMutationInput;
};


export type MutationUpdateTimeTrackingEngagementSettingsArgs = {
  input: UpdateTimeTrackingEngagementSettingsInput;
};


export type MutationUpdateTimeTrackingToolOverrideArgs = {
  input: UpdateTimeTrackingToolOverrideMutationInput;
};


export type MutationUpdateVariableCompensationArgs = {
  input: UpdateVariableCompensationInput;
};


export type MutationUpdateVariableCompensationTemplateArgs = {
  input: UpdateVariableCompensationTemplateInput;
};


export type MutationUploadAgreementArgs = {
  input: UploadAgreementInput;
};


export type MutationUploadAmendmentArgs = {
  input: UploadAmendmentInput;
};


export type MutationUpsertFxMarkupAdjustmentArgs = {
  input: UpsertMarkupAdjustmentInput;
};


export type MutationUpsertMonthlyFeeArgs = {
  input: UpsertVendorMonthlyFeeInput;
};


export type MutationUpsertPaySupplementArgs = {
  input: UpsertPaySupplementInput;
};


export type MutationValidateClmTemplateArgs = {
  input: ValidateClmTemplateInput;
};


export type MutationVerifyAgreementArgs = {
  input: VerifyAgreementInput;
};


export type MutationVerifyStripeAchPaymentMethodArgs = {
  input: VerifyStripeAchPaymentMethodInput;
};


export type MutationVoidHiringEnvelopeArgs = {
  input: VoidEnvelopeInput;
};

export enum Name {
  BranchAndSwiftCodes = 'BRANCH_AND_SWIFT_CODES',
  BranchCode = 'BRANCH_CODE',
  Iban = 'IBAN',
  Other = 'OTHER',
  SwiftCode = 'SWIFT_CODE'
}

export type NewPlan = {
  __typename?: 'NewPlan';
  authorizations?: Maybe<Authorization>;
  billingFrequency: BillingFrequencyEnum;
  billingFrequencyInMonths: Scalars['Int']['output'];
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isProratable: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The best matching PlanPrice for the plan based on the provided parameters. */
  planPrice?: Maybe<PlanPrice>;
  product: Scalars['String']['output'];
  supportedType: Scalars['String']['output'];
};


export type NewPlanPlanPriceArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  engagementId?: InputMaybe<Scalars['ID']['input']>;
};

export type NewPlanCollection = {
  __typename?: 'NewPlanCollection';
  collection: Array<NewPlan>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of NextAmendmentState */
export type NextAmendmentStateInput = {
  amendmentProcessId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyAdminId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of NextAmendmentState. */
export type NextAmendmentStatePayload = {
  __typename?: 'NextAmendmentStatePayload';
  amendmentProcess?: Maybe<AmendmentProcessType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type OauthApplication = {
  __typename?: 'OauthApplication';
  allowlisted: Scalars['Boolean']['output'];
  authorizationUrl: Scalars['String']['output'];
  authorizations?: Maybe<Authorization>;
  clientId: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  developerTermsAccepted: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
  scopes: Array<Scalars['String']['output']>;
  secret: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type OffboardingCategory = {
  __typename?: 'OffboardingCategory';
  id: Scalars['ID']['output'];
  minimumOffboardingDays: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentCategory?: Maybe<OffboardingCategory>;
  public?: Maybe<Scalars['Boolean']['output']>;
  publicSecondaryCategories: Array<OffboardingCategory>;
  secondaryOffboardingCategories: Array<OffboardingCategory>;
  specialCategoryType?: Maybe<Scalars['String']['output']>;
};

export type OffboardingPayType = {
  __typename?: 'OffboardingPayType';
  absoluteValue?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  percentageValue?: Maybe<Scalars['Boolean']['output']>;
};

export type OffboardingStep = {
  __typename?: 'OffboardingStep';
  caText?: Maybe<Scalars['String']['output']>;
  caTitle: Scalars['String']['output'];
  duration?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lane: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  osTitle: Scalars['String']['output'];
  skippable: Scalars['Boolean']['output'];
  step?: Maybe<Scalars['Int']['output']>;
};

export type OffboardingStepsTermination = {
  __typename?: 'OffboardingStepsTermination';
  id: Scalars['ID']['output'];
  offboardingStep: OffboardingStep;
  status: Scalars['String']['output'];
};

/** Autogenerated input type of OffboardingStepsUpdate */
export type OffboardingStepsUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  stepsTerminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of OffboardingStepsUpdate. */
export type OffboardingStepsUpdatePayload = {
  __typename?: 'OffboardingStepsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  stepsTermination: OffboardingStepsTermination;
};

export type OktaCredential = {
  __typename?: 'OktaCredential';
  authorizations?: Maybe<Authorization>;
  companiesIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  oktaClientId: Scalars['String']['output'];
  oktaClientSecret: Scalars['String']['output'];
  oktaIssuerUrl: Scalars['String']['output'];
  oysterClientSecret: Scalars['String']['output'];
};

export type OnboardingData = {
  __typename?: 'OnboardingData';
  onboardingCodeRemoteId: Scalars['String']['output'];
};

export type OperationError = {
  __typename?: 'OperationError';
  createdAt: Scalars['ISO8601DateTime']['output'];
  message: Scalars['String']['output'];
};

/** Autogenerated input type of OtpDisable */
export type OtpDisableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of OtpDisable. */
export type OtpDisablePayload = {
  __typename?: 'OtpDisablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of OtpEnableByEmail */
export type OtpEnableByEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of OtpEnableByEmail. */
export type OtpEnableByEmailPayload = {
  __typename?: 'OtpEnableByEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated input type of OtpEnable */
export type OtpEnableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated return type of OtpEnable. */
export type OtpEnablePayload = {
  __typename?: 'OtpEnablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type OtpProvisioningData = {
  __typename?: 'OtpProvisioningData';
  otpAuthSecret: Scalars['String']['output'];
  otpAuthenticatorQrcode: Scalars['String']['output'];
  otpProvisioningUri: Scalars['String']['output'];
  otpRecoveryTokens: Array<Scalars['String']['output']>;
};

export enum OtpStatusType {
  /** OTP is not currently enabled and can not be enabled by the user */
  Forbidden = 'FORBIDDEN',
  /** user must enable OTP or OTP by email */
  MustBeEnforced = 'MUST_BE_ENFORCED',
  /** OTP is not currently enabled but can be enabled by the user */
  Optional = 'OPTIONAL',
  /** TOTP is enabled */
  Otp = 'OTP',
  /** OTP by email is enabled */
  OtpByEmail = 'OTP_BY_EMAIL'
}

export type Owner = Hiring | Termination;

export type OysterAdminProfile = {
  __typename?: 'OysterAdminProfile';
  id?: Maybe<Scalars['String']['output']>;
};

export type OysterBandIndexCountry = {
  __typename?: 'OysterBandIndexCountry';
  countryCode: CountryIsoCode;
  obi: OysterBandIndexEnum;
};

export enum OysterBandIndexEnum {
  High = 'HIGH',
  Low = 'LOW',
  Mid = 'MID'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Partner = {
  __typename?: 'Partner';
  name: Scalars['String']['output'];
};

export enum PaySupplementAvailablePaymentTypeEnum {
  Bonus = 'BONUS',
  Commission = 'COMMISSION',
  DisabilityInsurance = 'DISABILITY_INSURANCE',
  EmployerPensionRetirementContribution = 'EMPLOYER_PENSION_RETIREMENT_CONTRIBUTION',
  HealthAndWellbeingAllowance = 'HEALTH_AND_WELLBEING_ALLOWANCE',
  HealthInsurance = 'HEALTH_INSURANCE',
  LifeInsurance = 'LIFE_INSURANCE',
  SustenanceAllowance = 'SUSTENANCE_ALLOWANCE',
  TravelAllowance = 'TRAVEL_ALLOWANCE',
  WorkFromHomeAllowance = 'WORK_FROM_HOME_ALLOWANCE'
}

export enum PaySupplementPaymentTypeEnum {
  Bonus = 'BONUS',
  CarAllowance = 'CAR_ALLOWANCE',
  Commission = 'COMMISSION',
  DisabilityInsurance = 'DISABILITY_INSURANCE',
  EmployerPensionRetirementContribution = 'EMPLOYER_PENSION_RETIREMENT_CONTRIBUTION',
  ExpenseReimbursement = 'EXPENSE_REIMBURSEMENT',
  HealthAndWellbeingAllowance = 'HEALTH_AND_WELLBEING_ALLOWANCE',
  HealthInsurance = 'HEALTH_INSURANCE',
  LearningDevelopmentAllowance = 'LEARNING_DEVELOPMENT_ALLOWANCE',
  LifeInsurance = 'LIFE_INSURANCE',
  MonthlyRateCatchUp = 'MONTHLY_RATE_CATCH_UP',
  Other = 'OTHER',
  RiskInsurance = 'RISK_INSURANCE',
  SustenanceAllowance = 'SUSTENANCE_ALLOWANCE',
  TravelAllowance = 'TRAVEL_ALLOWANCE',
  TravelInsurance = 'TRAVEL_INSURANCE',
  VacationBonus = 'VACATION_BONUS',
  WorkFromHomeAllowance = 'WORK_FROM_HOME_ALLOWANCE'
}

export enum PaySupplementStateEnumType {
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type PaySupplementType = {
  __typename?: 'PaySupplementType';
  amount: Scalars['Float']['output'];
  amountCurrencyCode: Scalars['String']['output'];
  authorizations?: Maybe<Authorization>;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy?: Maybe<User>;
  cutoffMonthDay: Scalars['Int']['output'];
  engagement?: Maybe<Engagement>;
  id: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  paymentType: PaySupplementPaymentTypeEnum;
  state: PaySupplementStateEnumType;
  teamMemberName: Scalars['String']['output'];
  transferred: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  updatedBy?: Maybe<User>;
  year: Scalars['Int']['output'];
};

export type PaySupplementTypeCollection = {
  __typename?: 'PaySupplementTypeCollection';
  collection: Array<PaySupplementType>;
  metadata: CollectionMetadata;
};

export enum PaybandLevelEnum {
  Above = 'ABOVE',
  Below = 'BELOW',
  Within = 'WITHIN'
}

export enum PaymentFrequencyEnum {
  Biannual = 'BIANNUAL',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

/**
 * Deprecated: This can only be used in mutation. Please use
 * 'EngagementBankAccountType', 'CorePaymentMethod' or 'B2BPaymentMethod' for typing.
 */
export type PaymentMethod = EngagementBankAccount | PaymentMethodStripeAch | PaymentMethodStripeBacs | PaymentMethodStripePad | PaymentMethodStripeSepa | PaymentMethodsCustomerBankAccountAchType | PaymentMethodsCustomerBankAccountSepaType;

export type PaymentMethodBankAccountMaskedData = {
  __typename?: 'PaymentMethodBankAccountMaskedData';
  accountNumber?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  routingCode?: Maybe<Scalars['String']['output']>;
  swiftOrBicCode?: Maybe<Scalars['String']['output']>;
};

export enum PaymentMethodEnumType {
  DirectDebit = 'DIRECT_DEBIT',
  WiredTransfer = 'WIRED_TRANSFER'
}

export enum PaymentMethodPurposeEnumType {
  Collection = 'COLLECTION',
  CollectionAndPassing = 'COLLECTION_AND_PASSING',
  Passing = 'PASSING'
}

export enum PaymentMethodState {
  AuthorizedByUser = 'AUTHORIZED_BY_USER',
  AuthorizedForDirectDebit = 'AUTHORIZED_FOR_DIRECT_DEBIT',
  Initialized = 'INITIALIZED',
  InVerification = 'IN_VERIFICATION',
  VerificationFailed = 'VERIFICATION_FAILED',
  Verified = 'VERIFIED',
  Verifying = 'VERIFYING'
}

export type PaymentMethodStripeAch = {
  __typename?: 'PaymentMethodStripeAch';
  accountHolderName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  authorizations?: Maybe<Authorization>;
  authorized: Scalars['Boolean']['output'];
  currencyCode: Scalars['String']['output'];
  directDebit: Scalars['Boolean']['output'];
  disabledForContractors?: Maybe<Scalars['Boolean']['output']>;
  disabledForFtes?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  mandate?: Maybe<StripeMandate>;
  primary: Scalars['Boolean']['output'];
  purpose?: Maybe<PaymentMethodPurposeEnumType>;
  requiresEsignatureAuthorization: Scalars['Boolean']['output'];
  routingNumber: Scalars['String']['output'];
  state: PaymentMethodState;
  verificationAttemptsCount: Scalars['Int']['output'];
};

export type PaymentMethodStripeBacs = {
  __typename?: 'PaymentMethodStripeBacs';
  accountNumber: Scalars['String']['output'];
  authorizations?: Maybe<Authorization>;
  authorized: Scalars['Boolean']['output'];
  currencyCode: Scalars['String']['output'];
  directDebit: Scalars['Boolean']['output'];
  disabledForContractors?: Maybe<Scalars['Boolean']['output']>;
  disabledForFtes?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  mandate?: Maybe<StripeMandate>;
  mandateUrl?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  purpose?: Maybe<PaymentMethodPurposeEnumType>;
  requiresEsignatureAuthorization: Scalars['Boolean']['output'];
  routingNumber: Scalars['String']['output'];
  state: PaymentMethodState;
};

export enum PaymentMethodStripeMandateStatusEnumType {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export type PaymentMethodStripePad = {
  __typename?: 'PaymentMethodStripePad';
  accountNumber: Scalars['String']['output'];
  authorizations?: Maybe<Authorization>;
  authorized: Scalars['Boolean']['output'];
  currencyCode: Scalars['String']['output'];
  directDebit: Scalars['Boolean']['output'];
  disabledForContractors?: Maybe<Scalars['Boolean']['output']>;
  disabledForFtes?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  mandate?: Maybe<StripeMandate>;
  primary: Scalars['Boolean']['output'];
  purpose?: Maybe<PaymentMethodPurposeEnumType>;
  requiresEsignatureAuthorization: Scalars['Boolean']['output'];
  routingNumber: Scalars['String']['output'];
  state: PaymentMethodState;
};

export type PaymentMethodStripeSepa = {
  __typename?: 'PaymentMethodStripeSepa';
  accountHolderName?: Maybe<Scalars['String']['output']>;
  accountNumber: Scalars['String']['output'];
  authorizations?: Maybe<Authorization>;
  authorized: Scalars['Boolean']['output'];
  billingAddress?: Maybe<Address>;
  currencyCode: Scalars['String']['output'];
  directDebit: Scalars['Boolean']['output'];
  disabledForContractors?: Maybe<Scalars['Boolean']['output']>;
  disabledForFtes?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  mandate?: Maybe<StripeMandate>;
  mandateUrl?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  purpose?: Maybe<PaymentMethodPurposeEnumType>;
  requiresEsignatureAuthorization: Scalars['Boolean']['output'];
  routingNumber: Scalars['String']['output'];
  state: PaymentMethodState;
};

/** Customer bank account details for ACH */
export type PaymentMethodsCustomerBankAccountAchInputType = {
  accountHolderName: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  achRoutingNumber: Scalars['String']['input'];
  countryCode: CountryIsoCode;
  currencyCode: CurrencyEnum;
  userNotSigner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentMethodsCustomerBankAccountAchType = {
  __typename?: 'PaymentMethodsCustomerBankAccountAchType';
  accountHolderName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  authorizations?: Maybe<Authorization>;
  authorized: Scalars['Boolean']['output'];
  countryCode: CountryIsoCode;
  currencyCode: CurrencyEnum;
  directDebit: Scalars['Boolean']['output'];
  disabledForFtes?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mandate?: Maybe<PaymentMethodsCustomerBankAccountMandateType>;
  primary: Scalars['Boolean']['output'];
  purpose?: Maybe<PaymentMethodPurposeEnumType>;
  requiresEsignatureAuthorization: Scalars['Boolean']['output'];
  routingNumber: Scalars['String']['output'];
  state: PaymentMethodState;
  userNotSigner?: Maybe<Scalars['Boolean']['output']>;
  verificationAttemptsCount: Scalars['Int']['output'];
  verificationMessage?: Maybe<Scalars['String']['output']>;
};

/** Customer bank account details */
export type PaymentMethodsCustomerBankAccountDetailsInput =
  { ach: PaymentMethodsCustomerBankAccountAchInputType; sepa?: never; }
  |  { ach?: never; sepa: PaymentMethodsCustomerBankAccountSepaInputType; };

export enum PaymentMethodsCustomerBankAccountEnumType {
  Ach = 'ACH',
  Sepa = 'SEPA'
}

export type PaymentMethodsCustomerBankAccountMandateType = {
  __typename?: 'PaymentMethodsCustomerBankAccountMandateType';
  activatedAt?: Maybe<Scalars['String']['output']>;
  certificateDownloadUrl?: Maybe<DownloadLink>;
  id: Scalars['ID']['output'];
  lodgedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  paymentMethod: B2BPaymentMethod;
  reference?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  signedDownloadUrl?: Maybe<DownloadLink>;
  signerRecipientViewUrl?: Maybe<Scalars['String']['output']>;
  state: CustomerBankAccountMandateStateEnumType;
};

/** Customer bank account details for SEPA */
export type PaymentMethodsCustomerBankAccountSepaInputType = {
  accountHolderName: Scalars['String']['input'];
  countryCode: CountryIsoCode;
  currencyCode: CurrencyEnum;
  email: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  swiftBicCode: Scalars['String']['input'];
};

export type PaymentMethodsCustomerBankAccountSepaType = {
  __typename?: 'PaymentMethodsCustomerBankAccountSepaType';
  accountHolderName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  authorizations?: Maybe<Authorization>;
  authorized: Scalars['Boolean']['output'];
  billingAddress: Address;
  countryCode: CountryIsoCode;
  currencyCode: CurrencyEnum;
  directDebit: Scalars['Boolean']['output'];
  disabledForFtes?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mandate?: Maybe<PaymentMethodsCustomerBankAccountMandateType>;
  primary: Scalars['Boolean']['output'];
  purpose?: Maybe<PaymentMethodPurposeEnumType>;
  requiresEsignatureAuthorization: Scalars['Boolean']['output'];
  routingNumber: Scalars['String']['output'];
  state: PaymentMethodState;
  swiftBicCode: Scalars['String']['output'];
  userNotSigner?: Maybe<Scalars['Boolean']['output']>;
  verificationAttemptsCount: Scalars['Int']['output'];
  verificationMessage?: Maybe<Scalars['String']['output']>;
};

export type PaymentOrder = {
  __typename?: 'PaymentOrder';
  amount: Money;
  automaticallyReconciled: Scalars['Boolean']['output'];
  changesetHistory: Array<HistoricEvent>;
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  errors?: Maybe<Array<OperationError>>;
  fxRate?: Maybe<RateWithMarkup>;
  idempotencyKey: Scalars['String']['output'];
  latestTransaction?: Maybe<PaymentOrderTransaction>;
  paymentMethod?: Maybe<PaymentMethod>;
  provider?: Maybe<Scalars['String']['output']>;
  providerTransactionId?: Maybe<Scalars['String']['output']>;
  state: PaymentOrderState;
  strongId: Scalars['String']['output'];
};

export type PaymentOrderCollection = {
  __typename?: 'PaymentOrderCollection';
  collection: Array<PaymentOrder>;
  metadata: CollectionMetadata;
};

export enum PaymentOrderState {
  AutomatedProcessConfirmed = 'AUTOMATED_PROCESS_CONFIRMED',
  AutomatedProcessFailed = 'AUTOMATED_PROCESS_FAILED',
  AutomatedProcessInProgress = 'AUTOMATED_PROCESS_IN_PROGRESS',
  ChargedBack = 'CHARGED_BACK',
  ManualProcessNotPaid = 'MANUAL_PROCESS_NOT_PAID',
  NotPaid = 'NOT_PAID',
  Paid = 'PAID',
  Pending = 'PENDING',
  Returned = 'RETURNED',
  Voided = 'VOIDED'
}

export type PaymentOrderTransaction = {
  __typename?: 'PaymentOrderTransaction';
  providerTransactionId?: Maybe<Scalars['String']['output']>;
  providerUrl?: Maybe<Scalars['String']['output']>;
};

export enum PaymentOrderTypeEnum {
  Charge = 'CHARGE',
  Payout = 'PAYOUT'
}

export enum PaymentScheduleEnum {
  Annually = 'ANNUALLY',
  Biannually = 'BIANNUALLY',
  Bimonthly = 'BIMONTHLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY'
}

export type PaymentTimelineEvent = {
  __typename?: 'PaymentTimelineEvent';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  name?: Maybe<PayoutViewState>;
};

export type PaymentTimelineItem = {
  __typename?: 'PaymentTimelineItem';
  bankAccount?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<PaymentTimelineEvent>>;
  status: PayoutViewState;
};

export type PaymentsCurrency = {
  __typename?: 'PaymentsCurrency';
  additionalMarkup?: Maybe<Scalars['Boolean']['output']>;
  buySupported: Scalars['Boolean']['output'];
  longerDelivery?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentsEngagementSettings = {
  __typename?: 'PaymentsEngagementSettings';
  authorizations?: Maybe<Authorization>;
  forcedProvider?: Maybe<PayoutProviderName>;
  payoutsDisabled: Scalars['Boolean']['output'];
};

export type PaymentsGroup = {
  __typename?: 'PaymentsGroup';
  amount: Money;
  authorizations?: Maybe<Authorization>;
  changesetHistory?: Maybe<Array<HistoricEvent>>;
  company: Company;
  createdAt: Scalars['ISO8601DateTime']['output'];
  errors?: Maybe<Array<OperationError>>;
  id: Scalars['ID']['output'];
  invoiceErrors?: Maybe<PaymentsGroupInvoiceErrorCollection>;
  invoices?: Maybe<InvoiceCollection>;
  invoicesCount: Scalars['Int']['output'];
  paidAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  referenceCode: Scalars['String']['output'];
  /** The list of staff notes for this group, ordered by most recent last. */
  staffNotes: StaffNoteConnection;
  state: PaymentsGroupStateType;
  wireSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type PaymentsGroupInvoiceErrorsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type PaymentsGroupInvoicesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type PaymentsGroupStaffNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentsGroupCollection = {
  __typename?: 'PaymentsGroupCollection';
  collection: Array<PaymentsGroup>;
  metadata: CollectionMetadata;
};

export type PaymentsGroupInvoiceError = {
  __typename?: 'PaymentsGroupInvoiceError';
  id: Scalars['ID']['output'];
  invoice: Invoice;
  message?: Maybe<Scalars['String']['output']>;
};

export type PaymentsGroupInvoiceErrorCollection = {
  __typename?: 'PaymentsGroupInvoiceErrorCollection';
  collection: Array<PaymentsGroupInvoiceError>;
  metadata: CollectionMetadata;
};

export enum PaymentsGroupStateEvent {
  ConfirmWireSent = 'CONFIRM_WIRE_SENT',
  Initiate = 'INITIATE',
  Pay = 'PAY',
  UnconfirmWireSent = 'UNCONFIRM_WIRE_SENT',
  Unpay = 'UNPAY'
}

export enum PaymentsGroupStateType {
  Paid = 'PAID',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  WireSent = 'WIRE_SENT'
}

export type PaymentsSettings = {
  __typename?: 'PaymentsSettings';
  antifraudChecksEnabled: Scalars['Boolean']['output'];
  antifraudUpdateReason?: Maybe<Scalars['String']['output']>;
  authorizations?: Maybe<Authorization>;
  automaticallyRemoveRestriction: Scalars['Boolean']['output'];
  badDebtCategory?: Maybe<BadDebtCategory>;
  contractorDdEnabled: Scalars['Boolean']['output'];
  contractorDdEnabledChangesetHistory: Array<HistoricEvent>;
  contractorDdUpdatedReason?: Maybe<Scalars['String']['output']>;
  flaggedAsFraudster: Scalars['Boolean']['output'];
  flaggedAsFraudsterReason?: Maybe<Scalars['String']['output']>;
  modifiedAntifraudChecksAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  modifiedAntifraudChecksBy?: Maybe<User>;
  modifiedFraudsterAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  modifiedFraudsterBy?: Maybe<User>;
  paymentsMandateSetup: Scalars['Boolean']['output'];
  restricted: Scalars['Boolean']['output'];
  restrictedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  restrictedBy?: Maybe<User>;
  restrictedReason?: Maybe<Scalars['String']['output']>;
  unflaggedAsFraudsterReason?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PaymentsSettingsUpdate */
export type PaymentsSettingsUpdateInput = {
  antifraudChecksEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  antifraudUpdateReason?: InputMaybe<Scalars['String']['input']>;
  automaticallyRemoveRestriction?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  contractorDdEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  contractorDdUpdatedReason?: InputMaybe<Scalars['String']['input']>;
  flaggedAsFraudster?: InputMaybe<Scalars['Boolean']['input']>;
  flaggedAsFraudsterReason?: InputMaybe<Scalars['String']['input']>;
  restricted?: InputMaybe<Scalars['Boolean']['input']>;
  restrictedReason?: InputMaybe<Scalars['String']['input']>;
  unflaggedAsFraudsterReason?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PaymentsSettingsUpdate. */
export type PaymentsSettingsUpdatePayload = {
  __typename?: 'PaymentsSettingsUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
};

export enum PaymetMethodEnumType {
  PaymentMethodBankAccount = 'PAYMENT_METHOD_BANK_ACCOUNT',
  PaymentMethodStripeAch = 'PAYMENT_METHOD_STRIPE_ACH',
  PaymentMethodStripeBacs = 'PAYMENT_METHOD_STRIPE_BACS',
  PaymentMethodStripePad = 'PAYMENT_METHOD_STRIPE_PAD',
  PaymentMethodStripeSepa = 'PAYMENT_METHOD_STRIPE_SEPA'
}

export type PayoutPaymentRequest = {
  __typename?: 'PayoutPaymentRequest';
  authorizations?: Maybe<Authorization>;
  canInitiateAutomaticPayment: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  idempotencyKey: Scalars['String']['output'];
  orders: Array<PaymentOrder>;
  ordersState: PayoutState;
  receiverId: Scalars['String']['output'];
  targetAmount: Money;
  timeline?: Maybe<Array<PaymentTimelineItem>>;
  viewState: PayoutViewState;
};


export type PayoutPaymentRequestOrdersArgs = {
  states?: InputMaybe<Array<PaymentOrderState>>;
};

export type PayoutProvider = {
  __typename?: 'PayoutProvider';
  authorizations?: Maybe<Authorization>;
  local: Scalars['Boolean']['output'];
  name: PayoutProviderName;
};

export enum PayoutProviderName {
  Moneycorp = 'MONEYCORP',
  Nium = 'NIUM',
  Unknown = 'UNKNOWN'
}

export enum PayoutState {
  AutomatedProcessFailed = 'AUTOMATED_PROCESS_FAILED',
  AutomatedProcessInProgress = 'AUTOMATED_PROCESS_IN_PROGRESS',
  NotPaid = 'NOT_PAID',
  NoPayment = 'NO_PAYMENT',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Pending = 'PENDING',
  Returned = 'RETURNED',
  Voided = 'VOIDED'
}

export enum PayoutStateTransition {
  FulfillManualPayOutProcess = 'FULFILL_MANUAL_PAY_OUT_PROCESS',
  ManuallyCancelPayOut = 'MANUALLY_CANCEL_PAY_OUT',
  ReturnPayment = 'RETURN_PAYMENT',
  Void = 'VOID'
}

export enum PayoutViewState {
  AutomatedProcessInProgress = 'AUTOMATED_PROCESS_IN_PROGRESS',
  Initiated = 'INITIATED',
  NotInitiated = 'NOT_INITIATED',
  NoPayment = 'NO_PAYMENT',
  Paid = 'PAID',
  Returned = 'RETURNED',
  Sent = 'SENT'
}

export type Payroll = {
  __typename?: 'Payroll';
  authorizations?: Maybe<Authorization>;
  contractorState?: Maybe<PayrollContractorStateTypeEnum>;
  cutoffTimeForPayroll?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  month: Scalars['Int']['output'];
  preFundingInvoice?: Maybe<Invoice>;
  records: Array<PayrollRecord>;
  settlementInvoice?: Maybe<Invoice>;
  state?: Maybe<PayrollStateTypeEnum>;
  taxableBenefits: Scalars['Boolean']['output'];
  totalContractorCost?: Maybe<Money>;
  totalPayrollRecords: Scalars['Int']['output'];
  totalPreFunding?: Maybe<Money>;
  totalSettlement?: Maybe<Money>;
  year: Scalars['Int']['output'];
};


export type PayrollRecordsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PayrollAttributesInput = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type PayrollChange = {
  __typename?: 'PayrollChange';
  applicableFrom: Scalars['ISO8601Date']['output'];
  needsRetroactive: Scalars['Boolean']['output'];
  retroactiveEnd?: Maybe<Scalars['ISO8601Date']['output']>;
  retroactiveStart?: Maybe<Scalars['ISO8601Date']['output']>;
};

export type PayrollComponent = {
  __typename?: 'PayrollComponent';
  amount?: Maybe<Money>;
  category: PayrollComponentCategoryEnum;
  preFundingInvoiceAmount?: Maybe<Money>;
  settlementInvoiceAmount?: Maybe<Money>;
  sources?: Maybe<Array<PayrollSource>>;
  type: PayrollComponentTypeEnum;
};


export type PayrollComponentAmountArgs = {
  customerCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<PayrollTypeEnum>;
};

export enum PayrollComponentCategoryEnum {
  Allowances = 'ALLOWANCES',
  Benefits = 'BENEFITS',
  Bonuses = 'BONUSES',
  Fees = 'FEES',
  MonthlyPayments = 'MONTHLY_PAYMENTS',
  Taxes = 'TAXES'
}

export enum PayrollComponentTypeEnum {
  Bonus = 'BONUS',
  Bonus_13Th_14ThMonth = 'BONUS_13TH_14TH_MONTH',
  Commission = 'COMMISSION',
  DisabilityInsurance = 'DISABILITY_INSURANCE',
  EmployerPensionRetirementContribution = 'EMPLOYER_PENSION_RETIREMENT_CONTRIBUTION',
  EmployerTaxesAndContributions = 'EMPLOYER_TAXES_AND_CONTRIBUTIONS',
  ExpenseReimbursement = 'EXPENSE_REIMBURSEMENT',
  Fee = 'FEE',
  GrossSalary = 'GROSS_SALARY',
  HealthAndWellbeingAllowance = 'HEALTH_AND_WELLBEING_ALLOWANCE',
  HealthFee = 'HEALTH_FEE',
  HealthInsurance = 'HEALTH_INSURANCE',
  HealthInsuranceBenefit = 'HEALTH_INSURANCE_BENEFIT',
  LearningDevelopmentAllowance = 'LEARNING_DEVELOPMENT_ALLOWANCE',
  LifeInsurance = 'LIFE_INSURANCE',
  LifeRiskInsurance = 'LIFE_RISK_INSURANCE',
  OtherEmployerCosts = 'OTHER_EMPLOYER_COSTS',
  OtherLocalAccruals = 'OTHER_LOCAL_ACCRUALS',
  OysterBenefitsFee = 'OYSTER_BENEFITS_FEE',
  Pension = 'PENSION',
  PensionBenefit = 'PENSION_BENEFIT',
  Perk = 'PERK',
  PerkBenefit = 'PERK_BENEFIT',
  RiskInsuranceBenefit = 'RISK_INSURANCE_BENEFIT',
  ServicesTaxesAndVat = 'SERVICES_TAXES_AND_VAT',
  SeverancePayment = 'SEVERANCE_PAYMENT',
  SignOnBonus = 'SIGN_ON_BONUS',
  SustenanceAllowance = 'SUSTENANCE_ALLOWANCE',
  TravelAllowance = 'TRAVEL_ALLOWANCE',
  TravelInsurance = 'TRAVEL_INSURANCE',
  TravelInsuranceBenefit = 'TRAVEL_INSURANCE_BENEFIT',
  UnusedVacationPayment = 'UNUSED_VACATION_PAYMENT',
  WorkFromHomeAllowance = 'WORK_FROM_HOME_ALLOWANCE'
}

export enum PayrollContractorStateTypeEnum {
  Completed = 'completed',
  Draft = 'draft',
  FinalizingContractorFees = 'finalizing_contractor_fees'
}

export type PayrollCycle = {
  __typename?: 'PayrollCycle';
  authorizations?: Maybe<Authorization>;
  cutOffDate: Scalars['ISO8601Date']['output'];
  cycleNumber: Scalars['Int']['output'];
  documentsHistory: PayrollCycleDocumentCollection;
  draftDocuments: PayrollCycleDocumentCollection;
  employerOfRecord: EmployerOfRecord;
  endDate: Scalars['ISO8601Date']['output'];
  frequency: PayrollCycleFrequencyEnum;
  id: Scalars['ID']['output'];
  isReverted: Scalars['Boolean']['output'];
  lastCycleOfMonth: Scalars['Boolean']['output'];
  latestDocuments: PayrollCycleDocumentCollection;
  month: Scalars['Int']['output'];
  payDate?: Maybe<Scalars['ISO8601Date']['output']>;
  pirGenerationDate: Scalars['ISO8601Date']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  state: PayrollCycleStateTypeEnum;
  teamMembersCount: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};


export type PayrollCycleDocumentsHistoryArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type PayrollCycleDraftDocumentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type PayrollCycleLatestDocumentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PayrollCycleCollection = {
  __typename?: 'PayrollCycleCollection';
  collection: Array<PayrollCycle>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of PayrollCycleDefaultTransition */
export type PayrollCycleDefaultTransitionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  event: PayrollCycleTransitionEventEnum;
  payrollCycleDocumentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  payrollCycleId?: InputMaybe<Scalars['ID']['input']>;
  /** True will skip awaiting_approval state and jump to approved state. */
  skipApproval?: InputMaybe<Scalars['Boolean']['input']>;
  /** True will skip the payroll cycle documents version validation */
  skipDocumentsVersionValidation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of PayrollCycleDefaultTransition. */
export type PayrollCycleDefaultTransitionPayload = {
  __typename?: 'PayrollCycleDefaultTransitionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  payrollCycle: PayrollCycle;
};

export type PayrollCycleDocument = {
  __typename?: 'PayrollCycleDocument';
  authorizations?: Maybe<Authorization>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<User>;
  documentType: Scalars['String']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type PayrollCycleDocumentCollection = {
  __typename?: 'PayrollCycleDocumentCollection';
  collection: Array<PayrollCycleDocument>;
  metadata: CollectionMetadata;
};

export enum PayrollCycleDocumentTypeEnum {
  AdditionalTimeOffReport = 'ADDITIONAL_TIME_OFF_REPORT',
  BankPayment = 'BANK_PAYMENT',
  Funding = 'FUNDING',
  G2N = 'G2N',
  Payments = 'PAYMENTS',
  Pir = 'PIR',
  Variance = 'VARIANCE'
}

export enum PayrollCycleFrequencyEnum {
  BiWeekly = 'BI_WEEKLY',
  Monthly = 'MONTHLY',
  SemiMonthly = 'SEMI_MONTHLY'
}

export enum PayrollCycleStateTypeEnum {
  Approved = 'APPROVED',
  AwaitingApproval = 'AWAITING_APPROVAL',
  ChangesRequested = 'CHANGES_REQUESTED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  GeneratePir = 'GENERATE_PIR',
  Processing = 'PROCESSING',
  ReadyForPayments = 'READY_FOR_PAYMENTS'
}

export enum PayrollCycleTransitionEventEnum {
  Approve = 'APPROVE',
  Complete = 'COMPLETE',
  InitiateCycle = 'INITIATE_CYCLE',
  Process = 'PROCESS',
  RequestChanges = 'REQUEST_CHANGES',
  SendForPayments = 'SEND_FOR_PAYMENTS',
  SendToCustomer = 'SEND_TO_CUSTOMER'
}

export type PayrollDepositRecord = {
  __typename?: 'PayrollDepositRecord';
  engagement?: Maybe<Engagement>;
  total: Money;
};

export type PayrollOysterComponent = {
  __typename?: 'PayrollOysterComponent';
  amount?: Maybe<Money>;
  sources?: Maybe<PayrollSourceCollection>;
  type: PayrollOysterComponentTypeEnum;
};


export type PayrollOysterComponentAmountArgs = {
  customerCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<PayrollTypeEnum>;
};


export type PayrollOysterComponentSourcesArgs = {
  customerCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export enum PayrollOysterComponentTypeEnum {
  Fee = 'FEE',
  HealthFee = 'HEALTH_FEE',
  LifeInsurance = 'LIFE_INSURANCE',
  OysterBenefitsFee = 'OYSTER_BENEFITS_FEE',
  Pension = 'PENSION',
  Perk = 'PERK'
}

export type PayrollPeriod = {
  __typename?: 'PayrollPeriod';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type PayrollRecord = {
  __typename?: 'PayrollRecord';
  authorizations?: Maybe<Authorization>;
  cutoffTimeForPayroll: Scalars['ISO8601DateTime']['output'];
  engagement?: Maybe<Engagement>;
  fxRateToPayrollCurrency?: Maybe<Rate>;
  fxRateToRecordCurrency?: Maybe<Rate>;
  monthlyPaymentTotal: Money;
  payrollComponents: Array<PayrollComponent>;
  payrollOysterComponents: Array<PayrollOysterComponent>;
  total: Money;
  useEstimatesOnInvoice: Scalars['Boolean']['output'];
};


export type PayrollRecordTotalArgs = {
  componentsIdentifiers?: InputMaybe<Array<PayrollComponentTypeEnum>>;
  customerCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<PayrollTypeEnum>;
};

export enum PayrollRecordTypeEnum {
  Contract = 'CONTRACT',
  Employment = 'EMPLOYMENT',
  PaygContract = 'PAYG_CONTRACT',
  PostTerminatedEmployment = 'POST_TERMINATED_EMPLOYMENT'
}

export type PayrollSource = {
  __typename?: 'PayrollSource';
  amount: Money;
  amountInCustomerCurrency: Money;
  description: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  sourceType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PayrollSourceCollection = {
  __typename?: 'PayrollSourceCollection';
  collection: Array<PayrollSource>;
  metadata: CollectionMetadata;
};

export enum PayrollStateTypeEnum {
  CalculatingTotalCosts = 'calculating_total_costs',
  Completed = 'completed',
  Draft = 'draft'
}

export enum PayrollTypeEnum {
  ActualInvoice = 'ACTUAL_INVOICE',
  Estimated = 'ESTIMATED',
  Forecasted = 'FORECASTED',
  PreFunding = 'PRE_FUNDING',
  SettlementInvoice = 'SETTLEMENT_INVOICE'
}

export type Percentiles = {
  __typename?: 'Percentiles';
  p10?: Maybe<Money>;
  p25?: Maybe<Money>;
  p50?: Maybe<Money>;
  p75?: Maybe<Money>;
  p90?: Maybe<Money>;
};

export enum PerlTypeEnum {
  Personalized = 'personalized',
  StandardPerlWithSalary = 'standard_perl_with_salary'
}

export type PlaidLink = {
  __typename?: 'PlaidLink';
  token: Scalars['String']['output'];
};

export type Plan = {
  __typename?: 'Plan';
  authorizations?: Maybe<Authorization>;
  category: PlanCategoryEnum;
  id: Scalars['ID']['output'];
  monthlyPrice: MoneyByCurrency;
  name: Scalars['String']['output'];
  periodInMonths: Scalars['Int']['output'];
  price: MoneyByCurrency;
  product: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

export enum PlanCategoryEnum {
  Contractor = 'CONTRACTOR',
  Eor = 'EOR',
  GlobalPayroll = 'GLOBAL_PAYROLL'
}

export type PlanPrice = {
  __typename?: 'PlanPrice';
  amount: Money;
  authorizations?: Maybe<Authorization>;
  /** Claimed prices for this plan price */
  claimedPrices?: Maybe<ClaimedPriceCollection>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['String']['output'];
  isCustom: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  oldPlan?: Maybe<Plan>;
  plan: NewPlan;
};


export type PlanPriceClaimedPricesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PlanPriceCollection = {
  __typename?: 'PlanPriceCollection';
  collection: Array<PlanPrice>;
  metadata: CollectionMetadata;
};

export enum PlatformTypeEnum {
  Accounting = 'ACCOUNTING',
  Ats = 'ATS',
  Automation = 'AUTOMATION',
  Communications = 'COMMUNICATIONS',
  Equity = 'EQUITY',
  Expenses = 'EXPENSES',
  Hris = 'HRIS',
  Identity = 'IDENTITY',
  Misc = 'MISC',
  Sam = 'SAM'
}

export type PolicySelection = {
  /** Id of the policy record */
  policyId: Scalars['ID']['input'];
  selected: Scalars['Boolean']['input'];
};

/** Autogenerated input type of PostOysterSafeComment */
export type PostOysterSafeCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  postingContext: Scalars['ID']['input'];
};

/** Autogenerated return type of PostOysterSafeComment. */
export type PostOysterSafeCommentPayload = {
  __typename?: 'PostOysterSafeCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<StaffNote>;
  errors: Array<Scalars['String']['output']>;
  postingContextComments?: Maybe<StaffNoteConnection>;
};


/** Autogenerated return type of PostOysterSafeComment. */
export type PostOysterSafeCommentPayloadPostingContextCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of PostStaffNote */
export type PostStaffNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  postingContext: Scalars['ID']['input'];
};

/** Autogenerated return type of PostStaffNote. */
export type PostStaffNotePayload = {
  __typename?: 'PostStaffNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  postingContextNotes?: Maybe<StaffNoteConnection>;
  staffNote?: Maybe<StaffNote>;
};


/** Autogenerated return type of PostStaffNote. */
export type PostStaffNotePayloadPostingContextNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PostTerminationPaymentAmount = {
  __typename?: 'PostTerminationPaymentAmount';
  flat?: Maybe<Money>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export enum PostTerminationPaymentAmountType {
  Flat = 'FLAT',
  PercentageMonthlyGross = 'PERCENTAGE_MONTHLY_GROSS'
}

export enum PostTerminationPaymentFrequency {
  MonthlyPostTermination = 'MONTHLY_POST_TERMINATION',
  OnTermination = 'ON_TERMINATION'
}

export type PostTerminationPaymentFrequencyRule = {
  __typename?: 'PostTerminationPaymentFrequencyRule';
  amountRecommended?: Maybe<PostTerminationPaymentAmount>;
  amountStatutory?: Maybe<PostTerminationPaymentAmount>;
  amountTopOfMarket?: Maybe<PostTerminationPaymentAmount>;
  frequency: PostTerminationPaymentFrequency;
  restrictedAreaRules: Array<PostTerminationRestrictedAreaPaymentRule>;
};

export type PostTerminationPaymentRule = {
  __typename?: 'PostTerminationPaymentRule';
  amountType: PostTerminationPaymentAmountType;
  frequencyRules: Array<PostTerminationPaymentFrequencyRule>;
};

export enum PostTerminationRestrictedArea {
  AdministrativeDivision = 'ADMINISTRATIVE_DIVISION',
  City = 'CITY',
  Country = 'COUNTRY',
  World = 'WORLD'
}

export type PostTerminationRestrictedAreaPaymentRule = {
  __typename?: 'PostTerminationRestrictedAreaPaymentRule';
  additionalAreasAllowed: Scalars['Boolean']['output'];
  amountRecommended?: Maybe<PostTerminationPaymentAmount>;
  amountStatutory?: Maybe<PostTerminationPaymentAmount>;
  amountTopOfMarket?: Maybe<PostTerminationPaymentAmount>;
  restrictedArea: PostTerminationRestrictedArea;
};

/** Company preferences attributes to be updated */
export type PreferencesInput = {
  addCustomAgreements?: InputMaybe<Scalars['Boolean']['input']>;
  addionalClausesToEmpyoymentAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  additionalClauses?: InputMaybe<Scalars['String']['input']>;
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  ccCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  customTerms?: InputMaybe<Scalars['String']['input']>;
  editedCcip?: InputMaybe<Scalars['Boolean']['input']>;
  experienceFeedback?: InputMaybe<Scalars['String']['input']>;
  holidayDays?: InputMaybe<Scalars['String']['input']>;
  includePublicHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  nonCompetePreference?: InputMaybe<Scalars['Boolean']['input']>;
  noticePeriodDays?: InputMaybe<Scalars['String']['input']>;
  ownAbsenceLoggingPlatform?: InputMaybe<Scalars['Boolean']['input']>;
  ownCcipDocument?: InputMaybe<Scalars['Boolean']['input']>;
  ownEaaSDocument?: InputMaybe<Scalars['Boolean']['input']>;
  ownExpensePlatform?: InputMaybe<Scalars['Boolean']['input']>;
  probationPeriodDays?: InputMaybe<Scalars['String']['input']>;
  standardOfficeStripend?: InputMaybe<Scalars['String']['input']>;
};

export enum PreferredPronoun {
  HeHim = 'HE_HIM',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  SheHer = 'SHE_HER',
  TheyThem = 'THEY_THEM'
}

/** Autogenerated input type of ProcessBulkImportFile */
export type ProcessBulkImportFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  signedImportFileId: Scalars['ID']['input'];
  type: BulkImportTypeEnum;
};

/** Autogenerated return type of ProcessBulkImportFile. */
export type ProcessBulkImportFilePayload = {
  __typename?: 'ProcessBulkImportFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  import?: Maybe<BulkImport>;
};

/** Autogenerated input type of ProcessContractorsInvoicesBulkGeneration */
export type ProcessContractorsInvoicesBulkGenerationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  signedImportFileId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessContractorsInvoicesBulkGeneration. */
export type ProcessContractorsInvoicesBulkGenerationPayload = {
  __typename?: 'ProcessContractorsInvoicesBulkGenerationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  import?: Maybe<BulkImport>;
};

/** Autogenerated input type of ProcessWorkforceReportFile */
export type ProcessWorkforceReportFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  csvDataUsageAcknowledge: Scalars['Boolean']['input'];
  csvSignedId: Scalars['String']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ProcessWorkforceReportFile. */
export type ProcessWorkforceReportFilePayload = {
  __typename?: 'ProcessWorkforceReportFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  workforceReport?: Maybe<WorkforceReport>;
};

/** Autogenerated input type of ProcessWorkforceReportRoleMatches */
export type ProcessWorkforceReportRoleMatchesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessWorkforceReportRoleMatches. */
export type ProcessWorkforceReportRoleMatchesPayload = {
  __typename?: 'ProcessWorkforceReportRoleMatchesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of ProcessWorkforceReportSeniorityLevels */
export type ProcessWorkforceReportSeniorityLevelsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProcessWorkforceReportSeniorityLevels. */
export type ProcessWorkforceReportSeniorityLevelsPayload = {
  __typename?: 'ProcessWorkforceReportSeniorityLevelsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  workforceReportSeniorityLevels?: Maybe<Array<WorkforceReportSeniorityLevel>>;
};

export enum ProvidersEnum {
  FiguresApi = 'FIGURES_API',
  OysterPolicy = 'OYSTER_POLICY'
}

/** Autogenerated input type of ProvisionPackage */
export type ProvisionPackageInput = {
  addonIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  benefitsDescription?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  pensions?: InputMaybe<Array<BenefitsEnrollmentPensionInput>>;
  plansCostContribution?: InputMaybe<Array<BenefitsEnrollmentCostContributionInput>>;
  tierId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ProvisionPackage. */
export type ProvisionPackagePayload = {
  __typename?: 'ProvisionPackagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement: Engagement;
  errors: Array<Scalars['String']['output']>;
};

export type PtoInfo = {
  __typename?: 'PtoInfo';
  daysApproved: Scalars['Float']['output'];
  daysRemaining: Scalars['Float']['output'];
  daysTaken: Scalars['Float']['output'];
  leaveYear: Scalars['Int']['output'];
  timeOffManagementEnabled: Scalars['Boolean']['output'];
};

/** Autogenerated input type of PurgeUnattachedFile */
export type PurgeUnattachedFileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  signedId: Scalars['String']['input'];
};

/** Autogenerated return type of PurgeUnattachedFile. */
export type PurgeUnattachedFilePayload = {
  __typename?: 'PurgeUnattachedFilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type QaItem = {
  __typename?: 'QaItem';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
  riskScore: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  accountingIntegration?: Maybe<AccountingIntegrationType>;
  addressSubject: AddressSubject;
  /** List of all companies merge integrations */
  allMergeIntegrations: MergeIntegrationCollection;
  amendmentFlow: AmendmentFlow;
  amendmentProcess?: Maybe<AmendmentProcessType>;
  amendmentProcessFrom?: Maybe<AmendmentProcessType>;
  approvedOffboardingTerminations?: Maybe<TerminationCollection>;
  aspects?: Maybe<Array<Aspect>>;
  /** List of the assigned engagements */
  assignedEngagementsOnboarding?: Maybe<EngagementCollection>;
  /** Fetches an object that can be audited given its composite id */
  auditableObject?: Maybe<AuditableObject>;
  /** Search and filter roles for a specific (user, company) pair */
  authorizationRoleFilter: Array<UserRole>;
  authorizations?: Maybe<Authorization>;
  /** Returns the list of all country codes which have benefits registered in the DB */
  availableCountryBenefits: CountryBenefitsCollection;
  /** Returns one integration for company */
  availableIntegration?: Maybe<AvailableIntegration>;
  /** Returns all available integrations for company */
  availableIntegrations: Array<AvailableIntegration>;
  /** Returns background processes with children */
  backgroundProcess: BackgroundProcessParent;
  /** Returns all background processes by type */
  backgroundProcesses: BackgroundProcessParentCollection;
  bankAccountRecipientRequirements: Array<BankAccountRecipientRequirements>;
  benefitPlans: BenefitsPlanCollection;
  benefitProviders: BenefitsProviderCollection;
  benefitReconciliationRun?: Maybe<BenefitsReconciliationRun>;
  benefitReconciliationRuns: BenefitsReconciliationRunCollection;
  benefitsCensusDataReport?: Maybe<BenefitsCensusDataReport>;
  benefitsEnrollment?: Maybe<BenefitsEnrollment>;
  benefitsEnrollments: BenefitsEnrollmentCollection;
  benefitsEnrollmentsChangesReports: BenefitsEnrollmentsChangesReportCollection;
  /** List of plans grouped by tiers for the engagement country code */
  benefitsOfferFor: BenefitsOffer;
  /** List of plans grouped by tiers for the hiring templates based on country code */
  benefitsTemplateOfferFor: BenefitsTemplateOffer;
  bulkEngagementChange?: Maybe<BulkEngagementChange>;
  bulkEngagementChangeEntry?: Maybe<BulkEngagementChangeEntry>;
  bulkImport: BulkImport;
  bulkImportVendorValidatorDownloadLink?: Maybe<DownloadLink>;
  bulkOffboarding?: Maybe<BulkOffboarding>;
  bulkOffboardingEmployments: EmploymentCollection;
  bulkOffboardingTerminations: TerminationCollection;
  /** Returns a list of bulk offboardings */
  bulkOffboardings: BulkOffboardingCollection;
  bulkOnboarding: BulkOnboarding;
  /** Returns details for multiple salary calculations */
  bulkSalaryCalculations: Array<SalaryCalculation>;
  chargePaymentRequest?: Maybe<ChargePaymentRequest>;
  clmValidationRequest?: Maybe<ClmValidationRequest>;
  coEmployees: Array<User>;
  companies: CompanyCollection;
  company?: Maybe<Company>;
  companyEquityGrants: EquityGrantCollection;
  companyEquityWithholdingRequests: EquityWithholdingRequestCollection;
  compensationInsights: CompensationInsights;
  complianceCheckerRulesChecked: CcRuleCheckedCollection;
  componentTypes: Array<Category>;
  concurDataCenters?: Maybe<Array<ConcurDataCenterType>>;
  concurIntegration?: Maybe<ConcurIntegrationType>;
  contract?: Maybe<Contract>;
  /** Dummy function for type needed by the public cost calculator graph endpoint */
  costCalculatorCountryType?: Maybe<QuotableCountry>;
  /** Dummy function for type needed by the public cost calculator graph endpoint */
  costCalculatorSalaryType?: Maybe<SalaryCalculation>;
  /**
   * Search for both countries and vendors by name.
   * It returns:
   *   - countries: All countries (EmployerOfRecordCountry) which name or alpha2 matches the `name`
   *   - vendors: All vendors (EmployerOfRecord) which name matches the `name` and
   * do not belong to previously found `countries`
   */
  countriesWithEmployerOfRecords: CountriesWithEmployerOfRecords;
  /** List of countries with timezones */
  countriesWithTimezones?: Maybe<Array<Country>>;
  country?: Maybe<IsoCountry>;
  countryIntelligence?: Maybe<CountryIntelligence>;
  countryIntelligences: CountryIntelligenceCollection;
  /** Returns country payroll with imported payroll records */
  countryPayroll: FtePayoutCountryPayrollType;
  /** List of the country payrolls */
  countryPayrolls?: Maybe<FtePayoutCountryPayrollTypeCollection>;
  /** Returns the input salary converted based on the relative CPI index of the two countries. */
  cpiConversion: Scalars['Float']['output'];
  creditNotes?: Maybe<CreditNoteCollection>;
  creditNotesMonthYear?: Maybe<CreditNotesMonthYearCollection>;
  /** Returns the conversion attributes from one currency to another */
  currencyConversion: CurrencyConversion;
  /** List of eligible engagements for a custom price */
  customPriceEligibleEngagements?: Maybe<EngagementCollection>;
  customerDashboard?: Maybe<Dashboard>;
  decisionTree: DecisionTrees;
  /** List of the active discounts in the system */
  discounts: DiscountCollection;
  documentDownloadLink?: Maybe<DownloadLink>;
  documentTemplates: DocumentTemplateCollection;
  embeddedSession?: Maybe<Session>;
  employeeContractorScaleMonetizationPlans?: Maybe<NewPlanCollection>;
  /** Search company users based on the query */
  employeeSearch: Array<User>;
  employerOfRecord: EmployerOfRecord;
  /** List of countries where Oyster HR vendors are operating */
  employerOfRecordCountries: Array<EmployerOfRecordCountry>;
  /** Returns the country by ID where one vendor is operating */
  employerOfRecordCountry: EmployerOfRecordCountry;
  /** Returns the country by Country Code */
  employerOfRecordCountryByCode?: Maybe<EmployerOfRecordCountry>;
  employersOfRecord: EmployerOfRecordCollection;
  employment?: Maybe<Employment>;
  employmentTemplate: EmploymentTemplate;
  engagement?: Maybe<Engagement>;
  engagementChange?: Maybe<EngagementChange>;
  engagementChanges: EngagementChangeCollection;
  engagementDependentFields?: Maybe<Scalars['JSON']['output']>;
  engagementEquityGrants: Array<EquityGrant>;
  engagementExportTemplates: EngagementExportTemplateCollection;
  engagements: EngagementCollection;
  /** Fetches data from the Carta API. Returns up to 200 results */
  equityCartaStakeholders: EquityCartaStakeholderCollection;
  equityGrant?: Maybe<EquityGrant>;
  /** Returns all equity issues */
  equityIssues: Array<EquityIssue>;
  /** Returns an array of objects that represents a risk heatmap for offering our equity plans in the corresponding country */
  equityIssuesHeatmap: Array<EquityIssueHeatmapItem>;
  equityPayrollProviders: Array<EquityPayrollProvider>;
  equitySupportedCountries: Array<Scalars['String']['output']>;
  /** Returns tax data and tax events grouped by country */
  equityTaxEvents: Array<EquityCountryTax>;
  equityWithholdingRequest: EquityWithholdingRequest;
  /** Returns exchange rate from Provider */
  exchangeRate: Rate;
  expense?: Maybe<Expense>;
  expenses: ExpenseCollection;
  expensesIntegration?: Maybe<ExpensesIntegrationType>;
  /** Returns the list of feature flags for the current user */
  featureFlags: Array<FeatureFlag>;
  fxMarkupGroups: Array<FxMarkupGroup>;
  fxMarkupPairs: FxMarkupPairCollection;
  generation?: Maybe<InternalDocumentGeneration>;
  hires: EngagementCollection;
  hiringBulkProcessing: HiringBulkProcessing;
  /**
   * Retrieves the engagements associated with the company with a page size limit equal to
   * the maximum number of TMs allowed. This field is only intended for use with the "Select all"
   * option in the company engagements table.
   */
  hiringBulkProcessingCompanyEngagements: HiringBulkProcessingCompanyEngagementCollection;
  /** Retrieves the selected engagements with a page size limit equal to the maximum number of TMs allowed. */
  hiringBulkProcessingSelectedEngagements: EngagementCollection;
  holidays: TimeOffHolidayCollection;
  hrisIntegration?: Maybe<HrisIntegration>;
  integrationHire?: Maybe<HireRecord>;
  integrationHires: HireRecordCollection;
  /** Returns all integrations for company */
  integrations: Array<Integration>;
  /** Returns a benefit list for compensation insights */
  intelligenceBenefits: IntelligenceBenefit;
  internalTools: Array<InternalToolEnum>;
  invoice?: Maybe<Invoice>;
  invoices?: Maybe<InvoiceCollection>;
  knowledgeBaseUrl?: Maybe<Scalars['String']['output']>;
  me?: Maybe<User>;
  mergeEmploymentLog?: Maybe<MergeEmploymentLog>;
  mergeEmploymentLogs: MergeEmploymentLogCollection;
  mergeIntegration?: Maybe<MergeIntegration>;
  mergeLink?: Maybe<MergeLink>;
  mergeLinkToken?: Maybe<ComplianceCheckerMergeLink>;
  misclassificationAnalyzerResponse?: Maybe<Response>;
  monetizationPlansForEngagement?: Maybe<NewPlanCollection>;
  /** Returns a list of termination pay types */
  offboardingPayTypes: Array<OffboardingPayType>;
  /** Returns a list of termination categories */
  parentOffboardingCategories: Array<OffboardingCategory>;
  paySupplement?: Maybe<PaySupplementType>;
  paySupplements: PaySupplementTypeCollection;
  paymentsGroups?: Maybe<PaymentsGroupCollection>;
  payoutPaymentRequest?: Maybe<PayoutPaymentRequest>;
  payrollChangeCalculation: PayrollChange;
  /** Returns the payroll cycle by ID */
  payrollCycle?: Maybe<PayrollCycle>;
  payrollCycleDocumentDownloadLink?: Maybe<DownloadLink>;
  payrollCycles?: Maybe<PayrollCycleCollection>;
  plaidLink: PlaidLink;
  platformAddOns?: Maybe<Array<IntegrationAddOn>>;
  ptoInfo: PtoInfo;
  questionnaire: Questionnaire;
  /**
   * List of countries and administrative division (states, provinces and
   * territories) that the cost calculator can generate quotes for
   */
  quotableCountries?: Maybe<Array<QuotableCountry>>;
  requiredForms: RequiredFormCollection;
  resellerAspects?: Maybe<CompanyAspectCollection>;
  /** Returns the list of end clients for the reseller */
  resellerEndClients: ResellerEndClientTypeCollection;
  /** Returns a list of resignation categories */
  resignationOffboardingCategories: Array<OffboardingCategory>;
  roleType: RoleType;
  roleTypes: Array<RoleType>;
  sageForest: SageForest;
  /** Returns the detail of the salary calculation */
  salaryCalculation: Array<SalaryCalculation>;
  searchPaymentOrders: PaymentOrderCollection;
  /** Returns a list of secondary termination categories */
  secondaryOffboardingCategories: Array<OffboardingCategory>;
  serviceAgreement: ServiceAgreement;
  slackIntegration: SlackIntegration;
  staffEngagementChanges: EngagementChangeCollection;
  staffEquityWithholdingRequests: EquityWithholdingRequestCollection;
  staffNotes: StaffNoteConnection;
  supportedCurrency: PaymentsCurrency;
  terminatedOffboardingsMaxSyncDownload?: Maybe<Scalars['Int']['output']>;
  /** Translated text to a provided language */
  textTranslation: TextTranslation;
  timeOffEntitlementCounts: EngagementCollection;
  timeOffHolidays: TimeOffHolidayCollection;
  timeOffRequests: TimeOffRequestCollection;
  timeOffSummary: TimeOffSummary;
  timeOffTransactions: TimeOffTransactionCollection;
  timeSheet: TimeSheet;
  timeSheetEntries: Array<TimeSheetEntry>;
  timeSheetEntriesGroupedByDate: Array<TimeSheetEntriesGroupedByDate>;
  timeSheetYearMonths?: Maybe<TimeSheetYearMonthCollection>;
  timeSheets: TimeSheetCollection;
  tmsCount: TmsCount;
  /** Returns the sum of several currencies normalized to one currency */
  totalMultipleCurrencies: Money;
  user?: Maybe<User>;
  users: UserCollection;
  validAuthorizationRoles: Array<AuthorizationRoleEnumType>;
  variableCompensationConfigurations: Array<VariableCompensationConfiguration>;
  variableCompensationTemplate: VariableCompensationTemplate;
  vatOptions?: Maybe<VatOptions>;
  vendorMonthlyFee: MonthlyFee;
  /** Returns a Workforce Legal Consent list */
  workforceLegalConsents: WorkforceLegalConsentCollection;
  /** Counts matched roles for the report */
  workforceReportMatchedRolesCount: Scalars['Int']['output'];
  /** Returns a Workforce report summary and results */
  workforceReportResultsData: WorkforceReportResultsData;
  /** Returns a Workforce report role match list */
  workforceReportRoleMatches: WorkforceReportRoleMatchByRecordCollection;
  /** Returns a Workforce report seniority level list */
  workforceReportSeniorityLevels: WorkforceReportSeniorityLevelCollection;
  /** Counts amount of unmatched roles for the report */
  workforceReportUnmatchedRolesCount: Scalars['Int']['output'];
  /** Returns a Workforce report list */
  workforceReports: WorkforceReportCollection;
  /** Returns a Workforce role match list */
  workforceRoleMatches: WorkforceReportRoleMatchCollection;
};


export type QueryAccountingIntegrationArgs = {
  companyId: Scalars['ID']['input'];
  platform: Scalars['String']['input'];
};


export type QueryAddressSubjectArgs = {
  addressSubjectId: Scalars['ID']['input'];
};


export type QueryAllMergeIntegrationsArgs = {
  integrationName?: InputMaybe<Array<IntegrationPlatformNameEnum>>;
  integrationStatus?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  tiers?: InputMaybe<Array<CompanyTier>>;
};


export type QueryAmendmentFlowArgs = {
  engagementId: Scalars['ID']['input'];
};


export type QueryAmendmentProcessArgs = {
  amendmentProcessId: Scalars['ID']['input'];
};


export type QueryAmendmentProcessFromArgs = {
  amendmentProcessId?: InputMaybe<Scalars['ID']['input']>;
  engagementChangeId?: InputMaybe<Scalars['ID']['input']>;
  engagementId: Scalars['ID']['input'];
};


export type QueryApprovedOffboardingTerminationsArgs = {
  company?: InputMaybe<Scalars['ID']['input']>;
  creditNoteState?: InputMaybe<Array<CreditNoteState>>;
  customerAccountCheck?: InputMaybe<Array<CustomerAccountCheckEnumType>>;
  depositRefundStatus?: InputMaybe<Array<DepositRefundStatusEnumType>>;
  onlyDepositRefundGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentMethod?: InputMaybe<Array<PaymentMethodEnumType>>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  teamMemberName?: InputMaybe<Scalars['String']['input']>;
  terminationDateFrom?: InputMaybe<Scalars['String']['input']>;
  terminationDateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssignedEngagementsOnboardingArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuditableObjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuthorizationRoleFilterArgs = {
  companyId: Scalars['ID']['input'];
  roles?: InputMaybe<AuthorizationRoleEnumType>;
  userIds: Array<Scalars['ID']['input']>;
};


export type QueryAvailableCountryBenefitsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAvailableIntegrationArgs = {
  companyId: Scalars['ID']['input'];
  platform: Scalars['String']['input'];
};


export type QueryAvailableIntegrationsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryBackgroundProcessArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBackgroundProcessesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBankAccountRecipientRequirementsArgs = {
  countryCode: Scalars['String']['input'];
  currencyCode: Scalars['String']['input'];
  engagementId: Scalars['ID']['input'];
};


export type QueryBenefitPlansArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBenefitProvidersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBenefitReconciliationRunArgs = {
  benefitsReconciliationRunId: Scalars['ID']['input'];
};


export type QueryBenefitReconciliationRunsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBenefitsCensusDataReportArgs = {
  censusDataReportId: Scalars['ID']['input'];
};


export type QueryBenefitsEnrollmentArgs = {
  enrollmentId: Scalars['ID']['input'];
};


export type QueryBenefitsEnrollmentsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  employersOfRecord?: InputMaybe<Array<Scalars['ID']['input']>>;
  engagementStates?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<BenefitsEnrollmentStateEnum>>;
  teamMemberCountryCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBenefitsEnrollmentsChangesReportsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBenefitsOfferForArgs = {
  engagementId: Scalars['ID']['input'];
};


export type QueryBenefitsTemplateOfferForArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryBulkEngagementChangeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBulkEngagementChangeEntryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBulkImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBulkImportVendorValidatorDownloadLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBulkOffboardingArgs = {
  bulkOffboardingId: Scalars['ID']['input'];
};


export type QueryBulkOffboardingEmploymentsArgs = {
  bulkOffboardingId?: InputMaybe<Scalars['ID']['input']>;
  companyId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  teamMemberNameQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBulkOffboardingTerminationsArgs = {
  bulkOffboardingId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBulkOffboardingsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<BulkOffboardingState>>;
};


export type QueryBulkOnboardingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBulkSalaryCalculationsArgs = {
  calculationQueries: Array<SalaryQueryInput>;
};


export type QueryChargePaymentRequestArgs = {
  paymentRequestId: Scalars['ID']['input'];
};


export type QueryCoEmployeesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCompaniesArgs = {
  automatedPaymentProcess?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<CountryIsoCode>;
  excludeDummy?: InputMaybe<Scalars['Boolean']['input']>;
  hasPayrollFor?: InputMaybe<PayrollAttributesInput>;
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  mandateStatus?: InputMaybe<Array<PaymentMethodStripeMandateStatusEnumType>>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentCurrencyCodes?: InputMaybe<Array<CompanyCurrencyEnumType>>;
  paymentMethodStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  tiers?: InputMaybe<Array<CompanyTier>>;
  withActiveEngagements?: InputMaybe<Scalars['Boolean']['input']>;
  withEngagedEmployments?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompanyArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCompanyEquityGrantsArgs = {
  companyId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyEquityWithholdingRequestsArgs = {
  companyId: Scalars['ID']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryComplianceCheckerRulesCheckedArgs = {
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  reportCategoryId: Scalars['ID']['input'];
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type QueryConcurIntegrationArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryContractArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryCostCalculatorSalaryTypeArgs = {
  calculationQueries: Array<SalaryQueryInput>;
};


export type QueryCountriesWithEmployerOfRecordsArgs = {
  query: Scalars['String']['input'];
};


export type QueryCountryArgs = {
  isoAlpha2Code: Scalars['String']['input'];
};


export type QueryCountryIntelligenceArgs = {
  countryCode: Scalars['String']['input'];
  subdivisionCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCountryIntelligencesArgs = {
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  expandSubdivisions?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountryPayrollArgs = {
  countryPayrollId: Scalars['ID']['input'];
};


export type QueryCountryPayrollsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type QueryCpiConversionArgs = {
  amount: Scalars['Float']['input'];
  from: CountryIsoCode;
  to: CountryIsoCode;
};


export type QueryCreditNotesArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  excludeDummy?: InputMaybe<Scalars['Boolean']['input']>;
  kinds?: InputMaybe<Array<CreditNoteKind>>;
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<CreditNoteState>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCreditNotesMonthYearArgs = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCurrencyConversionArgs = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type QueryCustomPriceEligibleEngagementsArgs = {
  companyId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerDashboardArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryDecisionTreeArgs = {
  countryCodes: Array<Scalars['String']['input']>;
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  levels?: InputMaybe<Array<DecisionTreesLevelInput>>;
  name: DecisionTreesName;
};


export type QueryDiscountsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocumentDownloadLinkArgs = {
  disposition?: InputMaybe<ContentDisposition>;
  documentId: Scalars['ID']['input'];
};


export type QueryDocumentTemplatesArgs = {
  countryCode: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmbeddedSessionArgs = {
  token: Scalars['ID']['input'];
};


export type QueryEmployeeContractorScaleMonetizationPlansArgs = {
  companyId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmployeeSearchArgs = {
  companyId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<CompanyUserRoleType>;
};


export type QueryEmployerOfRecordArgs = {
  employerOfRecordId: Scalars['ID']['input'];
};


export type QueryEmployerOfRecordCountryArgs = {
  employerOfRecordCountryId: Scalars['ID']['input'];
};


export type QueryEmployerOfRecordCountryByCodeArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryEmployersOfRecordArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortByEnum>;
};


export type QueryEmploymentArgs = {
  employmentId: Scalars['ID']['input'];
};


export type QueryEmploymentTemplateArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  countryCode?: InputMaybe<CountryIsoCode>;
  id?: InputMaybe<Scalars['ID']['input']>;
  oysterScore?: InputMaybe<CountryIntelligenceOysterScore>;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEngagementArgs = {
  engagementId: Scalars['ID']['input'];
};


export type QueryEngagementChangeArgs = {
  applicableFrom?: InputMaybe<Scalars['ISO8601Date']['input']>;
  engagementChangeId?: InputMaybe<Scalars['ID']['input']>;
  engagementId: Scalars['ID']['input'];
};


export type QueryEngagementChangesArgs = {
  engagementId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEngagementDependentFieldsArgs = {
  dependentId?: InputMaybe<Scalars['ID']['input']>;
  engagementId: Scalars['ID']['input'];
};


export type QueryEngagementEquityGrantsArgs = {
  engagementId: Scalars['ID']['input'];
};


export type QueryEngagementExportTemplatesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEngagementsArgs = {
  assignedStaffId?: InputMaybe<Scalars['ID']['input']>;
  belongsToDummyCompany?: InputMaybe<Scalars['Boolean']['input']>;
  bulkOnboard?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contractorBillingType?: InputMaybe<Scalars['String']['input']>;
  depositInvoiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  employersOfRecord?: InputMaybe<Array<Scalars['ID']['input']>>;
  employmentType?: InputMaybe<EmploymentTypeEnum>;
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  engagementType?: InputMaybe<EngagementType>;
  engagementTypes?: InputMaybe<Array<FilterEngagementType>>;
  kycVerifications?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Scalars['String']['input']>;
  teamMemberCountryCode?: InputMaybe<Scalars['String']['input']>;
  teamMemberMonetizationPlanName?: InputMaybe<Scalars['String']['input']>;
  teamMemberNameQuery?: InputMaybe<Scalars['String']['input']>;
  teamMemberNationality?: InputMaybe<Scalars['String']['input']>;
  withoutActiveTimeOffIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  withoutBenefitsEnrollments?: InputMaybe<Scalars['Boolean']['input']>;
  withoutDepositInvoice?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEquityCartaStakeholdersArgs = {
  automaticMatching?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['ID']['input'];
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEquityGrantArgs = {
  equityGrantId: Scalars['ID']['input'];
};


export type QueryEquityIssuesArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEquityIssuesHeatmapArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  riskTiers?: InputMaybe<Array<Scalars['Int']['input']>>;
  supported?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEquityTaxEventsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEquityWithholdingRequestArgs = {
  equityWithholdingRequestId: Scalars['ID']['input'];
};


export type QueryExchangeRateArgs = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
  type: ExchangeRateTypeEnum;
};


export type QueryExpenseArgs = {
  expenseId: Scalars['ID']['input'];
};


export type QueryExpensesArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
  states?: InputMaybe<Array<ExpenseStateEnumType>>;
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryExpensesIntegrationArgs = {
  companyId: Scalars['ID']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFeatureFlagsArgs = {
  actorId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFxMarkupGroupsArgs = {
  markupGroupTypes?: InputMaybe<Array<FxMarkupGroupTypeEnum>>;
};


export type QueryFxMarkupPairsArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGenerationArgs = {
  generationId: Scalars['String']['input'];
};


export type QueryHiresArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type QueryHiringBulkProcessingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHiringBulkProcessingCompanyEngagementsArgs = {
  assignedStaffId?: InputMaybe<Scalars['ID']['input']>;
  belongsToDummyCompany?: InputMaybe<Scalars['Boolean']['input']>;
  bulkOnboard?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['ID']['input'];
  contractorBillingType?: InputMaybe<Scalars['String']['input']>;
  employersOfRecord?: InputMaybe<Array<Scalars['ID']['input']>>;
  employmentType?: InputMaybe<EmploymentTypeEnum>;
  engagementTypes?: InputMaybe<Array<FilterEngagementType>>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Scalars['String']['input']>;
  teamMemberCountryCode?: InputMaybe<Scalars['String']['input']>;
  teamMemberMonetizationPlanName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHiringBulkProcessingSelectedEngagementsArgs = {
  engagementIds: Array<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHolidaysArgs = {
  countryCode: Scalars['String']['input'];
  endDate: Scalars['ISO8601Date']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHrisIntegrationArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  integrationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryIntegrationHireArgs = {
  hireId: Scalars['ID']['input'];
};


export type QueryIntegrationHiresArgs = {
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIntegrationsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryIntelligenceBenefitsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInternalToolsArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoiceArgs = {
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryInvoicesArgs = {
  chargeStates?: InputMaybe<Array<ChargeState>>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contractorUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  createdByUserType?: InputMaybe<Array<CreatedByUserEnum>>;
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  excludeDummy?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceBusinessStates?: InputMaybe<Array<InvoiceBusinessState>>;
  invoiceStates?: InputMaybe<Array<InvoiceState>>;
  notInPaymentsGroup?: InputMaybe<Scalars['Boolean']['input']>;
  onlyKind?: InputMaybe<InvoiceKind>;
  onlyUnpaidNonVoidInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentOrderStrongIds?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentsGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  payoutStates?: InputMaybe<Array<PayoutViewState>>;
  payrollEntityId?: InputMaybe<Scalars['ID']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  referenceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  subkinds?: InputMaybe<Array<InvoiceSubkind>>;
};


export type QueryKnowledgeBaseUrlArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryMergeEmploymentLogArgs = {
  mergeEmploymentLogId: Scalars['ID']['input'];
};


export type QueryMergeEmploymentLogsArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  excludeEngagementChangesCreated?: InputMaybe<Scalars['Boolean']['input']>;
  excludeRedundantLogs?: InputMaybe<Scalars['Boolean']['input']>;
  integrationId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type QueryMergeIntegrationArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  integrationType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMergeLinkArgs = {
  companyId: Scalars['ID']['input'];
  linkType: Scalars['String']['input'];
  platformName: IntegrationPlatformNameEnum;
};


export type QueryMergeLinkTokenArgs = {
  companyId: Scalars['ID']['input'];
  platformName: ComplianceCheckerHrisPlatformTypeEnum;
};


export type QueryMisclassificationAnalyzerResponseArgs = {
  engagementId: Scalars['ID']['input'];
};


export type QueryMonetizationPlansForEngagementArgs = {
  engagementId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOffboardingPayTypesArgs = {
  globalPayroll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryParentOffboardingCategoriesArgs = {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  globalPayroll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaySupplementArgs = {
  paySupplementId: Scalars['ID']['input'];
};


export type QueryPaySupplementsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordId?: InputMaybe<Scalars['ID']['input']>;
  engagementType?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<PaySupplementStateEnumType>;
  year?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentsGroupsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  referenceCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<PaymentsGroupStateType>>;
};


export type QueryPayoutPaymentRequestArgs = {
  paymentRequestId: Scalars['ID']['input'];
};


export type QueryPayrollChangeCalculationArgs = {
  effectiveFrom: Scalars['ISO8601Date']['input'];
  engagementId: Scalars['ID']['input'];
  varcompChanged: Scalars['Boolean']['input'];
};


export type QueryPayrollCycleArgs = {
  payrollCycleId: Scalars['ID']['input'];
};


export type QueryPayrollCycleDocumentDownloadLinkArgs = {
  disposition?: InputMaybe<ContentDisposition>;
  payrollCycleDocumentId: Scalars['ID']['input'];
};


export type QueryPayrollCyclesArgs = {
  employerOfRecordId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformAddOnsArgs = {
  linkType: Scalars['String']['input'];
  platformName: IntegrationPlatformNameEnum;
};


export type QueryPtoInfoArgs = {
  engagementId: Scalars['ID']['input'];
  offboardingDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryQuestionnaireArgs = {
  countryCode: CountryIsoCode;
};


export type QueryRequiredFormsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResellerAspectsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResellerEndClientsArgs = {
  countryCode?: InputMaybe<CountryIsoCode>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  resellerId: Scalars['ID']['input'];
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type QueryRoleTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRoleTypesArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySalaryCalculationArgs = {
  annualGrossSalary?: InputMaybe<Scalars['Float']['input']>;
  annualNetSalary?: InputMaybe<Scalars['Float']['input']>;
  countryCode?: InputMaybe<Array<Scalars['String']['input']>>;
  currencyCode: Scalars['String']['input'];
  feePeriodInMonths?: InputMaybe<Scalars['Int']['input']>;
  maxTzOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
  nativeCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  salaryFrequency?: InputMaybe<SalaryFrequencyEnumType>;
  selectedSalary?: InputMaybe<SelectedSalaryEnumType>;
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
  targetTz?: InputMaybe<Scalars['String']['input']>;
  vatParameters?: InputMaybe<VatParametersInput>;
};


export type QuerySearchPaymentOrdersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentOrderId: Scalars['String']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<PaymentOrderTypeEnum>>;
};


export type QuerySecondaryOffboardingCategoriesArgs = {
  mainCategoryId: Scalars['String']['input'];
};


export type QueryServiceAgreementArgs = {
  engagementId: Scalars['ID']['input'];
};


export type QuerySlackIntegrationArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryStaffEngagementChangesArgs = {
  companyId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<StaffEngagementChangesSortByEnum>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type QueryStaffEquityWithholdingRequestsArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStaffNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  postingContext: Scalars['ID']['input'];
};


export type QuerySupportedCurrencyArgs = {
  currencyCode: Scalars['String']['input'];
};


export type QueryTextTranslationArgs = {
  metadata: TextTranslationMetadataInput;
  sourceLanguage: TranslationsLanguageCodeEnum;
  targetLanguage: TranslationsLanguageCodeEnum;
  text: Scalars['String']['input'];
};


export type QueryTimeOffEntitlementCountsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  engagementType?: InputMaybe<FilterEngagementType>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTimeOffHolidaysArgs = {
  countryCode: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
};


export type QueryTimeOffRequestsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
  statuses?: InputMaybe<Array<TimeOffRequestStateEnumType>>;
  timeOffTypes?: InputMaybe<Array<TimeOffTypeEnum>>;
};


export type QueryTimeOffSummaryArgs = {
  countryCode: Scalars['String']['input'];
  endDate: Scalars['ISO8601Date']['input'];
  endDateHours?: InputMaybe<Scalars['Int']['input']>;
  endDateTimePeriod?: InputMaybe<Scalars['String']['input']>;
  isVacation?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
  startDateHours?: InputMaybe<Scalars['Int']['input']>;
  startDateTimePeriod?: InputMaybe<Scalars['String']['input']>;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTimeOffTransactionsArgs = {
  engagementId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  periodEnd: Scalars['ISO8601Date']['input'];
  periodStart: Scalars['ISO8601Date']['input'];
};


export type QueryTimeSheetArgs = {
  timeSheetId: Scalars['ID']['input'];
};


export type QueryTimeSheetEntriesArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  timeSheetId: Scalars['ID']['input'];
};


export type QueryTimeSheetEntriesGroupedByDateArgs = {
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  timeSheetId: Scalars['ID']['input'];
};


export type QueryTimeSheetYearMonthsArgs = {
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTimeSheetsArgs = {
  combinedStatuses?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  employersOfRecordIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employmentTypes?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
  timeSheetCreation?: InputMaybe<Scalars['String']['input']>;
  timeSheetType?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTotalMultipleCurrenciesArgs = {
  currencies: Array<MoneyInput>;
  currencyCode: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  isOysterAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  withOysterHrEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryValidAuthorizationRolesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryVariableCompensationConfigurationsArgs = {
  isContractor?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVariableCompensationTemplateArgs = {
  countryCode?: InputMaybe<CountryIsoCode>;
  id: Scalars['ID']['input'];
};


export type QueryVatOptionsArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryVendorMonthlyFeeArgs = {
  strongId: Scalars['String']['input'];
};


export type QueryWorkforceLegalConsentsArgs = {
  companyId: Scalars['ID']['input'];
  consentType?: InputMaybe<ConsentTypeEnum>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkforceReportMatchedRolesCountArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryWorkforceReportResultsDataArgs = {
  employeeExternalIdSortOrder?: InputMaybe<SortOrderEnumType>;
  reportId: Scalars['ID']['input'];
};


export type QueryWorkforceReportRoleMatchesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['ID']['input'];
};


export type QueryWorkforceReportSeniorityLevelsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['ID']['input'];
};


export type QueryWorkforceReportUnmatchedRolesCountArgs = {
  reportId: Scalars['ID']['input'];
};


export type QueryWorkforceReportsArgs = {
  companyId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type QueryWorkforceRoleMatchesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  reportId: Scalars['ID']['input'];
};

export type Question = {
  __typename?: 'Question';
  answers: Array<Answer>;
  authorizations?: Maybe<Authorization>;
  description?: Maybe<Scalars['String']['output']>;
  expertTip?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  authorizations?: Maybe<Authorization>;
  countryCode?: Maybe<CountryIsoCode>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questions: Array<Question>;
};

export type QuotableCountry = {
  __typename?: 'QuotableCountry';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stateOrProvinces: Array<Scalars['String']['output']>;
};

export type Rate = {
  __typename?: 'Rate';
  from: Scalars['String']['output'];
  id: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  to: Scalars['String']['output'];
};

export type RateWithMarkup = {
  __typename?: 'RateWithMarkup';
  from: Scalars['String']['output'];
  id: Scalars['String']['output'];
  marginPercentage: Scalars['Float']['output'];
  rate: Scalars['Float']['output'];
  to: Scalars['String']['output'];
};

/** Autogenerated input type of ReSend */
export type ReSendInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReSend. */
export type ReSendPayload = {
  __typename?: 'ReSendPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

export enum ReasonTypeEnum {
  CancelsDueToDepositEnforcement = 'CANCELS_DUE_TO_DEPOSIT_ENFORCEMENT',
  CanNoLongerWaitForTmRcw = 'CAN_NO_LONGER_WAIT_FOR_TM_RCW',
  ChangedToContractorProduct = 'CHANGED_TO_CONTRACTOR_PRODUCT',
  ChoosesNotToContinueWithTm = 'CHOOSES_NOT_TO_CONTINUE_WITH_TM',
  CustomerHasOutstandingPayment = 'CUSTOMER_HAS_OUTSTANDING_PAYMENT',
  CustomerLegalTeamReview = 'CUSTOMER_LEGAL_TEAM_REVIEW',
  CustomerNotReadyToHire = 'CUSTOMER_NOT_READY_TO_HIRE',
  CustomerPushingBackOnDepositEnforcement = 'CUSTOMER_PUSHING_BACK_ON_DEPOSIT_ENFORCEMENT',
  CustomerUnresponsive = 'CUSTOMER_UNRESPONSIVE',
  CustomizationRequest = 'CUSTOMIZATION_REQUEST',
  Deel = 'DEEL',
  DeferredHire = 'DEFERRED_HIRE',
  DeprioritizedTheRole = 'DEPRIORITIZED_THE_ROLE',
  EstablishedDirectEntityInCountryOfEmployment = 'ESTABLISHED_DIRECT_ENTITY_IN_COUNTRY_OF_EMPLOYMENT',
  Fraud = 'FRAUD',
  HiredLocallyInsteadOfRemotely = 'HIRED_LOCALLY_INSTEAD_OF_REMOTELY',
  IssueWithOysterEmploymentModel = 'ISSUE_WITH_OYSTER_EMPLOYMENT_MODEL',
  JobTitleUnsupported = 'JOB_TITLE_UNSUPPORTED',
  OfferNotAccepted = 'OFFER_NOT_ACCEPTED',
  Other = 'OTHER',
  OutOfOffice = 'OUT_OF_OFFICE',
  PreEmploymentMedicalCheck = 'PRE_EMPLOYMENT_MEDICAL_CHECK',
  Relocation = 'RELOCATION',
  Remote = 'REMOTE',
  RequestedByCs = 'REQUESTED_BY_CS',
  RtwDenied = 'RTW_DENIED',
  TmReviewingAgreementsWithLawyer = 'TM_REVIEWING_AGREEMENTS_WITH_LAWYER',
  TmUnresponsive = 'TM_UNRESPONSIVE',
  UnsatisfactoryOysterBenefits = 'UNSATISFACTORY_OYSTER_BENEFITS',
  WaitingDepositEnforcementPayment = 'WAITING_DEPOSIT_ENFORCEMENT_PAYMENT',
  WaitingOnRtw = 'WAITING_ON_RTW',
  WetSignature = 'WET_SIGNATURE'
}

/** Autogenerated input type of ReattachPdf */
export type ReattachPdfInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReattachPdf. */
export type ReattachPdfPayload = {
  __typename?: 'ReattachPdfPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  invoice?: Maybe<Invoice>;
};

/** Autogenerated input type of ReconfirmMandateLodging */
export type ReconfirmMandateLodgingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mandateId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReconfirmMandateLodging. */
export type ReconfirmMandateLodgingPayload = {
  __typename?: 'ReconfirmMandateLodgingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  mandate?: Maybe<PaymentMethodsCustomerBankAccountMandateType>;
};

/** Autogenerated input type of RecordCostCalculatorVisit */
export type RecordCostCalculatorVisitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
};

/** Autogenerated return type of RecordCostCalculatorVisit. */
export type RecordCostCalculatorVisitPayload = {
  __typename?: 'RecordCostCalculatorVisitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RecordFirstDashboardVisit */
export type RecordFirstDashboardVisitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiringId: Scalars['ID']['input'];
};

/** Autogenerated return type of RecordFirstDashboardVisit. */
export type RecordFirstDashboardVisitPayload = {
  __typename?: 'RecordFirstDashboardVisitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of RedeemDiscount */
export type RedeemDiscountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  discountId: Scalars['String']['input'];
  engagementId: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of RedeemDiscount. */
export type RedeemDiscountPayload = {
  __typename?: 'RedeemDiscountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  discountRedemption?: Maybe<DiscountRedemption>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RegenerateComplianceCheckerReport */
export type RegenerateComplianceCheckerReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegenerateComplianceCheckerReport. */
export type RegenerateComplianceCheckerReportPayload = {
  __typename?: 'RegenerateComplianceCheckerReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RegenerateOauthApplicationSecret */
export type RegenerateOauthApplicationSecretInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  oauthApplicationId: Scalars['String']['input'];
};

/** Autogenerated return type of RegenerateOauthApplicationSecret. */
export type RegenerateOauthApplicationSecretPayload = {
  __typename?: 'RegenerateOauthApplicationSecretPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  oauthApplication?: Maybe<OauthApplication>;
};

/** Autogenerated input type of RegeneratePayrollInvoice */
export type RegeneratePayrollInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegeneratePayrollInvoice. */
export type RegeneratePayrollInvoicePayload = {
  __typename?: 'RegeneratePayrollInvoicePayload';
  backgroundProcess?: Maybe<BackgroundProcessParent>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RegenerateYearlyForms */
export type RegenerateYearlyFormsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegenerateYearlyForms. */
export type RegenerateYearlyFormsPayload = {
  __typename?: 'RegenerateYearlyFormsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type ReimbursementBalance = {
  __typename?: 'ReimbursementBalance';
  budget: ReimbursementBudget;
  consumedAmount: Money;
  remainingAmount: Money;
};

export type ReimbursementBudget = {
  __typename?: 'ReimbursementBudget';
  amount: Money;
  /** The reason for changing a reimbursement budget. */
  changeReason?: Maybe<Scalars['String']['output']>;
  /** The label to be used for reimbursement budget when the "other" label is selected. */
  customLabel?: Maybe<Scalars['String']['output']>;
  /** The first day the reimbursement budget can be used. */
  effectiveDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** The last day the reimbursement budget can be used. */
  effectiveEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  label: ReimbursementBudgetLabelEnum;
  resetFrequency: ResetFrequencyEnum;
};

/** An edge in a connection. */
export type ReimbursementBudgetEdge = {
  __typename?: 'ReimbursementBudgetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ReimbursementBudget>;
};

export enum ReimbursementBudgetLabelEnum {
  Benefits = 'BENEFITS',
  Car = 'CAR',
  Equipment = 'EQUIPMENT',
  Food = 'FOOD',
  HomeOffice = 'HOME_OFFICE',
  LearningAndDevelopment = 'LEARNING_AND_DEVELOPMENT',
  OfficeSupplies = 'OFFICE_SUPPLIES',
  Other = 'OTHER',
  Rent = 'RENT',
  Travel = 'TRAVEL'
}

/** The connection type for ReimbursementBudget. */
export type ReimbursementBudgetLegacyConnection = {
  __typename?: 'ReimbursementBudgetLegacyConnection';
  collection: Array<ReimbursementBudget>;
  /**
   * A list of edges.
   * @deprecated Connection-based pagination is deprecated. Use the `collection` and `metadata` fields instead.
   */
  edges?: Maybe<Array<Maybe<ReimbursementBudgetEdge>>>;
  metadata: CollectionMetadata;
  /**
   * A list of nodes.
   * @deprecated Connection-based pagination is deprecated. Use the `collection` and `metadata` fields instead.
   */
  nodes?: Maybe<Array<Maybe<ReimbursementBudget>>>;
  /**
   * Information to aid in pagination.
   * @deprecated Connection-based pagination is deprecated. Use the `collection` and `metadata` fields instead.
   */
  pageInfo: PageInfo;
  /** @deprecated Connection-based pagination is deprecated. Use the `collection` and `metadata` fields instead. */
  totalCount: Scalars['Int']['output'];
};

export type ReimbursementPolicy = {
  __typename?: 'ReimbursementPolicy';
  /** Budget allocated to team member by company for the designated equipment policy */
  amount?: Maybe<Money>;
  /** Policy indicating equipment responsibility by the employer or team member */
  policy?: Maybe<ReimbursementPolicyEnum>;
};

export enum ReimbursementPolicyEnum {
  BasicReimbursement = 'BASIC_REIMBURSEMENT',
  MonthlyAllowance = 'MONTHLY_ALLOWANCE',
  NoReimbursement = 'NO_REIMBURSEMENT',
  OneTimeStipend = 'ONE_TIME_STIPEND'
}

export type ReimbursementPolicyInput = {
  amount?: InputMaybe<MoneyInput>;
  policy: ReimbursementPolicyEnum;
};

/** Autogenerated input type of ReinitiateCharge */
export type ReinitiateChargeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReinitiateCharge. */
export type ReinitiateChargePayload = {
  __typename?: 'ReinitiateChargePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentRequest: ChargePaymentRequest;
};

/** Autogenerated input type of ReinitiatePayout */
export type ReinitiatePayoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReinitiatePayout. */
export type ReinitiatePayoutPayload = {
  __typename?: 'ReinitiatePayoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentRequest: PayoutPaymentRequest;
};

/** Autogenerated input type of RejectPayrollCycleDocuments */
export type RejectPayrollCycleDocumentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  payrollCycleDocumentIds: Array<Scalars['ID']['input']>;
  payrollCycleId: Scalars['ID']['input'];
  state: PayrollCycleStateTypeEnum;
};

/** Autogenerated return type of RejectPayrollCycleDocuments. */
export type RejectPayrollCycleDocumentsPayload = {
  __typename?: 'RejectPayrollCycleDocumentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  payrollCycle: PayrollCycle;
  payrollCycleDocuments: Array<PayrollCycleDocument>;
};

export type RemainingCarryover = {
  __typename?: 'RemainingCarryover';
  amountDays: Scalars['Float']['output'];
  expirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Autogenerated input type of RemoveBillingEmailAddress */
export type RemoveBillingEmailAddressInput = {
  billingEmailAddressId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveBillingEmailAddress. */
export type RemoveBillingEmailAddressPayload = {
  __typename?: 'RemoveBillingEmailAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RemoveBulkEngagementChangeEntry */
export type RemoveBulkEngagementChangeEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveBulkEngagementChangeEntry. */
export type RemoveBulkEngagementChangeEntryPayload = {
  __typename?: 'RemoveBulkEngagementChangeEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<BulkEngagementChangeEntry>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RemoveBulkEngagementChange */
export type RemoveBulkEngagementChangeInput = {
  bulkEngagementChangeId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveBulkEngagementChange. */
export type RemoveBulkEngagementChangePayload = {
  __typename?: 'RemoveBulkEngagementChangePayload';
  bulkEngagementChange?: Maybe<BulkEngagementChange>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RemoveInvoicesFromPaymentsGroup */
export type RemoveInvoicesFromPaymentsGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceIds: Array<Scalars['ID']['input']>;
  paymentsGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveInvoicesFromPaymentsGroup. */
export type RemoveInvoicesFromPaymentsGroupPayload = {
  __typename?: 'RemoveInvoicesFromPaymentsGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentsGroup?: Maybe<PaymentsGroup>;
};

/** Autogenerated input type of RemoveTeamMemberDirectManager */
export type RemoveTeamMemberDirectManagerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  directManagerId: Scalars['ID']['input'];
  teamMemberId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveTeamMemberDirectManager. */
export type RemoveTeamMemberDirectManagerPayload = {
  __typename?: 'RemoveTeamMemberDirectManagerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: TeamMemberDirectManager;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RequestCensusDataReport */
export type RequestCensusDataReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enrollmentFilterCriteria?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of RequestCensusDataReport. */
export type RequestCensusDataReportPayload = {
  __typename?: 'RequestCensusDataReportPayload';
  censusDataReport: BenefitsCensusDataReport;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RequestEngagementChangeAssistance */
export type RequestEngagementChangeAssistanceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementChangeId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestEngagementChangeAssistance. */
export type RequestEngagementChangeAssistancePayload = {
  __typename?: 'RequestEngagementChangeAssistancePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RequestEnrollment */
export type RequestEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dependentsEmployerContribution?: InputMaybe<Scalars['Float']['input']>;
  dependentsEmployerContributionMaxCount?: InputMaybe<Scalars['Int']['input']>;
  employerContribution?: InputMaybe<Scalars['Float']['input']>;
  engagementId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestEnrollment. */
export type RequestEnrollmentPayload = {
  __typename?: 'RequestEnrollmentPayload';
  benefitEnrollment?: Maybe<BenefitsEnrollment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RequestKybVerification */
export type RequestKybVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestKybVerification. */
export type RequestKybVerificationPayload = {
  __typename?: 'RequestKybVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  kybVerification?: Maybe<KybVerification>;
};

/** Autogenerated input type of RequestReport */
export type RequestReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Exclusion list is being removed, and is currently ignored */
  exclusionListSignedId?: InputMaybe<Scalars['String']['input']>;
  inputFileSignedId: Scalars['String']['input'];
  providerId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestReport. */
export type RequestReportPayload = {
  __typename?: 'RequestReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  reconciliationRun?: Maybe<BenefitsReconciliationRun>;
};

/** Autogenerated input type of RequestResignationCancellation */
export type RequestResignationCancellationInput = {
  cancelReason: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestResignationCancellation. */
export type RequestResignationCancellationPayload = {
  __typename?: 'RequestResignationCancellationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RequestScaleQuote */
export type RequestScaleQuoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestScaleQuote. */
export type RequestScaleQuotePayload = {
  __typename?: 'RequestScaleQuotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

export type RequiredForm = {
  __typename?: 'RequiredForm';
  authorizations?: Maybe<Authorization>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  file?: Maybe<DownloadLink>;
  id: Scalars['String']['output'];
  kind: RequiredFormKind;
  providedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  requestedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  state: RequiredFormState;
  year?: Maybe<Scalars['Int']['output']>;
};

export type RequiredFormCollection = {
  __typename?: 'RequiredFormCollection';
  collection: Array<RequiredForm>;
  metadata: CollectionMetadata;
};

export enum RequiredFormKind {
  Us_1099Nec = 'US_1099NEC',
  UsW8Ben = 'US_W8BEN',
  UsW8Bene = 'US_W8BENE',
  UsW9 = 'US_W9'
}

export enum RequiredFormState {
  Expected = 'EXPECTED',
  Provided = 'PROVIDED'
}

export type ResellerEndClientType = {
  __typename?: 'ResellerEndClientType';
  /** Alpha2 code of the country for which this end client was created */
  countryCode: CountryIsoCode;
  id: Scalars['ID']['output'];
  /** End client name */
  name: Scalars['String']['output'];
};

export type ResellerEndClientTypeCollection = {
  __typename?: 'ResellerEndClientTypeCollection';
  collection: Array<ResellerEndClientType>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of ResetExpensesPaymentMethod */
export type ResetExpensesPaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResetExpensesPaymentMethod. */
export type ResetExpensesPaymentMethodPayload = {
  __typename?: 'ResetExpensesPaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod: EngagementBankAccount;
};

export enum ResetFrequencyEnum {
  Biannual = 'BIANNUAL',
  Monthly = 'MONTHLY',
  Never = 'NEVER',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

/** Autogenerated input type of ResignationCreate */
export type ResignationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  communicatedWithManager?: InputMaybe<Scalars['Boolean']['input']>;
  engagementId: Scalars['ID']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
  intendedDaysOff?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offboardingCategoryId?: InputMaybe<Scalars['ID']['input']>;
  proposedDate: Scalars['ISO8601Date']['input'];
  ptoInaccurateNote?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  reportedPtoTaken?: InputMaybe<Scalars['Float']['input']>;
  signedDocumentId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResignationCreate. */
export type ResignationCreatePayload = {
  __typename?: 'ResignationCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

export type ResignationLetterData = {
  __typename?: 'ResignationLetterData';
  canUpload: Scalars['Boolean']['output'];
  disclaimers?: Maybe<Array<Scalars['String']['output']>>;
  kleaAddress?: Maybe<Scalars['String']['output']>;
  templateUrl?: Maybe<Scalars['String']['output']>;
  wetSignatureRequired: Scalars['Boolean']['output'];
};

export type Response = {
  __typename?: 'Response';
  authorizations?: Maybe<Authorization>;
  engagement: Engagement;
  id: Scalars['ID']['output'];
  qaItems: Array<QaItem>;
  questionnaire: Questionnaire;
  riskResult: Scalars['String']['output'];
};

export enum ResponsibilityEnum {
  Emp = 'EMP',
  Loc = 'LOC',
  Par = 'PAR'
}

export type RestrictedClauses = {
  __typename?: 'RestrictedClauses';
  nonCompetition: Scalars['Boolean']['output'];
  nonSolicitation: Scalars['Boolean']['output'];
  nonSolicitationCustomers: Scalars['Boolean']['output'];
  nonSolicitationEmployees: Scalars['Boolean']['output'];
};

export type RestrictiveCovenants = {
  __typename?: 'RestrictiveCovenants';
  agreementsFields: Array<Scalars['String']['output']>;
  confidentiality: Scalars['Boolean']['output'];
  nonCompetition: Scalars['Boolean']['output'];
  nonSolicitation: Scalars['Boolean']['output'];
  nonSolicitationCustomers?: Maybe<Scalars['Boolean']['output']>;
  nonSolicitationEmployees?: Maybe<Scalars['Boolean']['output']>;
  postTerminationAcknowledged?: Maybe<Scalars['Boolean']['output']>;
  postTerminationAdditionalAreas: Array<CountryIsoCode>;
  postTerminationAmountAbsoluteSubunit?: Maybe<Scalars['MoneyInt']['output']>;
  postTerminationAmountPercentage?: Maybe<Scalars['Float']['output']>;
  postTerminationAreaOfBusiness?: Maybe<Scalars['String']['output']>;
  postTerminationAreaOfBusinessInLocalLanguage?: Maybe<Scalars['String']['output']>;
  postTerminationDurationMonths?: Maybe<Scalars['Int']['output']>;
  postTerminationPaymentFrequency?: Maybe<PostTerminationPaymentFrequency>;
  postTerminationRestrictedArea?: Maybe<PostTerminationRestrictedArea>;
};

export type RestrictiveCovenantsInput = {
  confidentiality?: InputMaybe<Scalars['Boolean']['input']>;
  nonCompetition?: InputMaybe<Scalars['Boolean']['input']>;
  nonSolicitation?: InputMaybe<Scalars['Boolean']['input']>;
  nonSolicitationCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  nonSolicitationEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  postTerminationAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  postTerminationAdditionalAreas?: InputMaybe<Array<CountryIsoCode>>;
  /**
   * Monetary amount of post-termination payment as an absolute value, e.g.
   * 100000¢ USD. The currency of the parent employment salary is always
   * used. Must be null unless postTerminationAmountPercentage is null.
   */
  postTerminationAmountAbsoluteSubunit?: InputMaybe<Scalars['MoneyInt']['input']>;
  /**
   * Monetary amount of post-termination payment as a percentage value, e.g.
   * 10.0%. The currency of the parent employment salary is always used. Must
   * be null unless postTerminationAmountAbsoluteSubunit is null.
   */
  postTerminationAmountPercentage?: InputMaybe<Scalars['Float']['input']>;
  postTerminationAreaOfBusiness?: InputMaybe<Scalars['String']['input']>;
  postTerminationAreaOfBusinessInLocalLanguage?: InputMaybe<Scalars['String']['input']>;
  /**
   * How long after termination the post-termination clauses are binding,
   * always in whole months.
   */
  postTerminationDurationMonths?: InputMaybe<Scalars['Int']['input']>;
  postTerminationPaymentFrequency?: InputMaybe<PostTerminationPaymentFrequency>;
  postTerminationRestrictedArea?: InputMaybe<PostTerminationRestrictedArea>;
};

export type ResultsSummary = {
  __typename?: 'ResultsSummary';
  aboveBandCount: Scalars['Int']['output'];
  belowBandCount: Scalars['Int']['output'];
  dataSource: Scalars['String']['output'];
  lastGeneratedAt: Scalars['ISO8601DateTime']['output'];
  matchedCount: Scalars['Int']['output'];
  withinBandCount: Scalars['Int']['output'];
};

/** Autogenerated input type of ReviewExpense */
export type ReviewExpenseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  declineReason?: InputMaybe<Scalars['String']['input']>;
  event: ExpenseTransitionEvent;
  expenseId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReviewExpense. */
export type ReviewExpensePayload = {
  __typename?: 'ReviewExpensePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  expense?: Maybe<Expense>;
};

/** Autogenerated input type of RevokeDirectDebitAuthorization */
export type RevokeDirectDebitAuthorizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

/** Autogenerated return type of RevokeDirectDebitAuthorization. */
export type RevokeDirectDebitAuthorizationPayload = {
  __typename?: 'RevokeDirectDebitAuthorizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod: PaymentMethod;
};

/** Autogenerated input type of Revoke */
export type RevokeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated input type of RevokeOauthConnections */
export type RevokeOauthConnectionsInput = {
  applicationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RevokeOauthConnections. */
export type RevokeOauthConnectionsPayload = {
  __typename?: 'RevokeOauthConnectionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated return type of Revoke. */
export type RevokePayload = {
  __typename?: 'RevokePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RevokeSso */
export type RevokeSsoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

/** Autogenerated return type of RevokeSso. */
export type RevokeSsoPayload = {
  __typename?: 'RevokeSsoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of RevokeUserAccess */
export type RevokeUserAccessInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  roles: Array<AuthorizationRoleEnumType>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RevokeUserAccess. */
export type RevokeUserAccessPayload = {
  __typename?: 'RevokeUserAccessPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

export enum RightToWorkTypeEnum {
  BlueCard = 'BLUE_CARD',
  Definite = 'DEFINITE',
  FamilyVisa = 'FAMILY_VISA',
  Indefinite = 'INDEFINITE',
  LongTermResidencePermit = 'LONG_TERM_RESIDENCE_PERMIT',
  Null = 'NULL',
  PermanentResidencePermit = 'PERMANENT_RESIDENCE_PERMIT',
  TemporaryResidencePermit = 'TEMPORARY_RESIDENCE_PERMIT',
  WorkPermit = 'WORK_PERMIT'
}

export enum RoleKeywordScoreType {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type RoleType = {
  __typename?: 'RoleType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keywordScore?: Maybe<RoleKeywordScoreType>;
  name: Scalars['String']['output'];
};

export type RoleTypeCollection = {
  __typename?: 'RoleTypeCollection';
  collection: Array<RoleType>;
  metadata: CollectionMetadata;
};

export type SageAssistantChatResponse = {
  __typename?: 'SageAssistantChatResponse';
  answer: Scalars['String']['output'];
  format: Scalars['String']['output'];
  intent?: Maybe<SageAssistantIntentEnum>;
  questionId: Scalars['String']['output'];
  suggestedContext?: Maybe<SageAssistantTimeOffOptionsTypeEnum>;
  suggestedTeamMember?: Maybe<User>;
};

export enum SageAssistantCountryListTypeEnum {
  Au = 'AU',
  Be = 'BE',
  Bg = 'BG',
  Br = 'BR',
  De = 'DE',
  Es = 'ES',
  Fr = 'FR',
  Gb = 'GB',
  Ie = 'IE',
  In = 'IN',
  It = 'IT',
  Nl = 'NL',
  Pl = 'PL',
  Pt = 'PT',
  Rs = 'RS',
  Sg = 'SG',
  Us = 'US'
}

export enum SageAssistantFeedbackOptionsTypeEnum {
  Confusing = 'CONFUSING',
  InaccurateAnswer = 'INACCURATE_ANSWER',
  Incomplete = 'INCOMPLETE',
  Other = 'OTHER',
  UnfulfilledAnswer = 'UNFULFILLED_ANSWER'
}

export enum SageAssistantIntentEnum {
  QueryKnowledgeAgent = 'QUERY_KNOWLEDGE_AGENT',
  SpeakToSupport = 'SPEAK_TO_SUPPORT'
}

export enum SageAssistantTimeOffOptionsTypeEnum {
  ParentalLeave = 'PARENTAL_LEAVE',
  Pto = 'PTO',
  SickLeave = 'SICK_LEAVE',
  Timesheets = 'TIMESHEETS',
  UnpaidLeave = 'UNPAID_LEAVE'
}

export type SageForest = {
  __typename?: 'SageForest';
  authorizations?: Maybe<Authorization>;
  availableCountries: Array<SageForestCountry>;
  availableTrees: Array<DecisionTreesName>;
  bestInClassScore: BestInClassScore;
};


export type SageForestAvailableTreesArgs = {
  countryCode?: InputMaybe<CountryIsoCode>;
};


export type SageForestBestInClassScoreArgs = {
  engagementId: Scalars['ID']['input'];
};

export type SageForestContinent = {
  __typename?: 'SageForestContinent';
  code: SageForestContinentCode;
  name: Scalars['String']['output'];
};

export enum SageForestContinentCode {
  Af = 'AF',
  An = 'AN',
  As = 'AS',
  Eu = 'EU',
  Na = 'NA',
  Oc = 'OC',
  Sa = 'SA'
}

export type SageForestCountry = {
  __typename?: 'SageForestCountry';
  continent: SageForestContinent;
  countryCode: CountryIsoCode;
  isPartOfEuropeanUnion: Scalars['Boolean']['output'];
};

export type SalaryBenchmark = {
  __typename?: 'SalaryBenchmark';
  high?: Maybe<Money>;
  level: EngagementSeniorityLevelType;
  low?: Maybe<Money>;
  mid?: Maybe<Money>;
  percentiles?: Maybe<Percentiles>;
  providerId: ProvidersEnum;
  trustLevel?: Maybe<TrustLevelEnum>;
};

export type SalaryCalculation = {
  __typename?: 'SalaryCalculation';
  annualGrossSalary: Scalars['Float']['output'];
  country: Country;
  currency: SalaryCurrency;
  fees: SalaryFees;
  salaryFrequency?: Maybe<SalaryFrequencyEnumType>;
  selectedSalary?: Maybe<SelectedSalaryEnumType>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  taxes: SalaryTaxes;
  totals: SalaryTotals;
  vat?: Maybe<Vat>;
  vatOptions?: Maybe<VatOptions>;
  vatParameters?: Maybe<VatParameters>;
};

export type SalaryCurrency = {
  __typename?: 'SalaryCurrency';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SalaryCurrencyConversion = {
  __typename?: 'SalaryCurrencyConversion';
  exchangeRateValue: Scalars['Float']['output'];
  expired: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  receivedAmount: Scalars['Float']['output'];
  receivedCurrencyCode: Scalars['String']['output'];
};

export type SalaryFee = {
  __typename?: 'SalaryFee';
  currencyCode?: Maybe<Scalars['String']['output']>;
  discount: Scalars['Int']['output'];
  discountRate?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  value: Scalars['Int']['output'];
  withoutDiscount: Scalars['Int']['output'];
};

export type SalaryFees = {
  __typename?: 'SalaryFees';
  oyster: SalaryOysterFee;
  vat?: Maybe<SalaryFee>;
};

export enum SalaryFrequencyEnumType {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

export type SalaryOysterFee = {
  __typename?: 'SalaryOysterFee';
  companysPlanPrice: SalaryFee;
  /** @deprecated The field `fee_in_company_payment_currency` is deprecated and will be removed soon. Use the `companys_plan_price` instead. */
  feeInCompanyPaymentCurrency: SalaryFee;
  feeInEngagementSalaryCurrency: SalaryFee;
};

export type SalaryQueryInput = {
  annualGrossSalary?: InputMaybe<Scalars['Float']['input']>;
  annualNetSalary?: InputMaybe<Scalars['Float']['input']>;
  countryCode: Scalars['String']['input'];
  currencyCode: Scalars['String']['input'];
  feePeriodInMonths?: InputMaybe<Scalars['Int']['input']>;
  maxTzOffsetMinutes?: InputMaybe<Scalars['Int']['input']>;
  nativeCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  salaryFrequency?: InputMaybe<SalaryFrequencyEnumType>;
  selectedSalary?: InputMaybe<SelectedSalaryEnumType>;
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
  targetTz?: InputMaybe<Scalars['String']['input']>;
  vatParameters?: InputMaybe<VatParametersInput>;
};

export type SalaryTax = {
  __typename?: 'SalaryTax';
  contributions: Array<TaxContribution>;
  group: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type SalaryTaxes = {
  __typename?: 'SalaryTaxes';
  employee: SalaryTax;
  employer: SalaryTax;
};

export type SalaryTotals = {
  __typename?: 'SalaryTotals';
  employerCosts: Scalars['Float']['output'];
  netSalary: Scalars['Float']['output'];
};

export type SaveEmploymentHiringOnboardingFormAnswerInput = {
  /** Id of the field being submitted */
  id: Scalars['ID']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type SaveEmploymentHiringOnboardingFormFieldError = {
  __typename?: 'SaveEmploymentHiringOnboardingFormFieldError';
  fieldId: Scalars['ID']['output'];
  /**
   * Full error message from the Rails model. Typically message prefaced by
   * the humanized attribute name, e.g. "Last name can't be blank" for
   * fieldId "lastName" and message "can't be blank"
   */
  fullMessage?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  target?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of SaveEmploymentHiringOnboardingForm */
export type SaveEmploymentHiringOnboardingFormInput = {
  answers: Array<SaveEmploymentHiringOnboardingFormAnswerInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiringId: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
  /**
   * Providing false allows you to save a draft form submission, skipping required fields.
   *
   * Using true will trigger all required fields validations and automatically transition
   * the form submission process to the next available page. In case this is the last page
   * of the form, that will transition the form state to COMPLETED.
   */
  submit: Scalars['Boolean']['input'];
};

/** Autogenerated return type of SaveEmploymentHiringOnboardingForm. */
export type SaveEmploymentHiringOnboardingFormPayload = {
  __typename?: 'SaveEmploymentHiringOnboardingFormPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<SaveEmploymentHiringOnboardingFormFieldError>>;
  hiring?: Maybe<Hiring>;
};

export type ScaleSubscription = {
  __typename?: 'ScaleSubscription';
  annualTotalPrice: Money;
  autoInvoice: Scalars['Boolean']['output'];
  availableSeatsCount: Scalars['Int']['output'];
  billingCycle: Scalars['Int']['output'];
  contractDurationInMonths: Scalars['Int']['output'];
  expiresOn: Scalars['ISO8601Date']['output'];
  hasAvailableSeats: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  issuedInvoices: InvoiceCollection;
  issuedInvoicesCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numberOfSeats: Scalars['Int']['output'];
  paymentSchedule?: Maybe<PaymentScheduleEnum>;
  paymentTermsInDays: Scalars['Int']['output'];
  pendingSeatsCount: Scalars['Int']['output'];
  pricePerSeat: Money;
  reservedSeatsCount: Scalars['Int']['output'];
  scaleAgreement?: Maybe<Document>;
  scheduledInvoices: ScheduledInvoiceCollection;
  scheduledInvoicesCount: Scalars['Int']['output'];
  startsOn: Scalars['ISO8601Date']['output'];
  takenSeatsCount: Scalars['Int']['output'];
};


export type ScaleSubscriptionIssuedInvoicesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type ScaleSubscriptionScheduledInvoicesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type ScheduleDayInput = {
  breakIntervalFrom?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
  breakIntervalTo?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
  day: WeekDaysEnum;
  from: Scalars['TimeWithoutSecondsAndTz']['input'];
  to: Scalars['TimeWithoutSecondsAndTz']['input'];
  type?: InputMaybe<TimeSheetEntryTypeEnum>;
};

export type ScheduledInvoice = {
  __typename?: 'ScheduledInvoice';
  dueAmount?: Maybe<Money>;
  dueOn: Scalars['ISO8601Date']['output'];
};

export type ScheduledInvoiceCollection = {
  __typename?: 'ScheduledInvoiceCollection';
  collection: Array<ScheduledInvoice>;
  metadata: CollectionMetadata;
};

export type SearchHires = {
  __typename?: 'SearchHires';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mergeId: Scalars['String']['output'];
  previouslyImported?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum SeedEngagementEnum {
  FixedContractor = 'FIXED_CONTRACTOR',
  Fte = 'FTE',
  PaygContractor = 'PAYG_CONTRACTOR',
  Payroll = 'PAYROLL'
}

/** Autogenerated input type of SelectExpensifyPolicies */
export type SelectExpensifyPoliciesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  selections: Array<PolicySelection>;
};

/** Autogenerated return type of SelectExpensifyPolicies. */
export type SelectExpensifyPoliciesPayload = {
  __typename?: 'SelectExpensifyPoliciesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of policies */
  policies?: Maybe<Array<ExpensifyPolicyType>>;
};

export enum SelectedSalaryEnumType {
  Gross = 'GROSS',
  Net = 'NET'
}

export type SelfServiceDocument = {
  __typename?: 'SelfServiceDocument';
  authorizations?: Maybe<Authorization>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  file?: Maybe<DownloadLink>;
  id: Scalars['ID']['output'];
  kind: SelfServiceDocumentKind;
  status: SelfServiceDocumentStatus;
};

/** Autogenerated input type of SelfServiceDocumentCreate */
export type SelfServiceDocumentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  documentKind: SelfServiceDocumentKind;
  engagementId: Scalars['ID']['input'];
  payload?: InputMaybe<Scalars['JSON']['input']>;
};

/** Autogenerated return type of SelfServiceDocumentCreate. */
export type SelfServiceDocumentCreatePayload = {
  __typename?: 'SelfServiceDocumentCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  document?: Maybe<SelfServiceDocument>;
  errors: Array<Scalars['String']['output']>;
};

export enum SelfServiceDocumentKind {
  EmploymentProofMortgage = 'EMPLOYMENT_PROOF_MORTGAGE',
  EmploymentProofVisa = 'EMPLOYMENT_PROOF_VISA',
  StandardPerl = 'STANDARD_PERL',
  StandardPerlWithSalary = 'STANDARD_PERL_WITH_SALARY'
}

export enum SelfServiceDocumentStatus {
  Ready = 'READY',
  Requested = 'REQUESTED'
}

/** Autogenerated input type of SendAgreementEnvelope */
export type SendAgreementEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  envelopeType: EnvelopeTypeEnum;
  hiringId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendAgreementEnvelope. */
export type SendAgreementEnvelopePayload = {
  __typename?: 'SendAgreementEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  owner: Owner;
};

/** Autogenerated input type of SendConcurVerificationKey */
export type SendConcurVerificationKeyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendConcurVerificationKey. */
export type SendConcurVerificationKeyPayload = {
  __typename?: 'SendConcurVerificationKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of SendContractorInvoice */
export type SendContractorInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendContractorInvoice. */
export type SendContractorInvoicePayload = {
  __typename?: 'SendContractorInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SendEnvelopeReminder */
export type SendEnvelopeReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  envelopeId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendEnvelopeReminder. */
export type SendEnvelopeReminderPayload = {
  __typename?: 'SendEnvelopeReminderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  envelope?: Maybe<Envelope>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SendIntentLetterForSignature */
export type SendIntentLetterForSignatureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equityGrantId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendIntentLetterForSignature. */
export type SendIntentLetterForSignaturePayload = {
  __typename?: 'SendIntentLetterForSignaturePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityGrant: EquityGrant;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SendMandateReminder */
export type SendMandateReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mandateId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendMandateReminder. */
export type SendMandateReminderPayload = {
  __typename?: 'SendMandateReminderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  mandate?: Maybe<PaymentMethodsCustomerBankAccountMandateType>;
};

/** Autogenerated input type of SendOtpByEmail */
export type SendOtpByEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendOtpByEmail. */
export type SendOtpByEmailPayload = {
  __typename?: 'SendOtpByEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SendPayinReminderInvoice */
export type SendPayinReminderInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendPayinReminderInvoice. */
export type SendPayinReminderInvoicePayload = {
  __typename?: 'SendPayinReminderInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  invoice: Invoice;
};

export type SeniorityLevel = {
  __typename?: 'SeniorityLevel';
  description?: Maybe<Scalars['String']['output']>;
  engagementOysterSeniorityLevel: EngagementSeniorityLevelType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  track?: Maybe<SeniorityLevelTracksEnum>;
};

export type SeniorityLevelCollection = {
  __typename?: 'SeniorityLevelCollection';
  collection: Array<SeniorityLevel>;
  metadata: CollectionMetadata;
};

export enum SeniorityLevelTracksEnum {
  IndividualContributor = 'INDIVIDUAL_CONTRIBUTOR',
  Manager = 'MANAGER'
}

export type SepaSetupIntent = {
  __typename?: 'SepaSetupIntent';
  clientSecret: Scalars['String']['output'];
};

export type ServiceAgreement = {
  __typename?: 'ServiceAgreement';
  activeOrPendingSubscription?: Maybe<Subscription>;
  authorizations?: Maybe<Authorization>;
  benefits: ServiceAgreementBenefits;
  costs: ServiceAgreementCosts;
  history: Array<ServiceAgreementMessage>;
  messages?: Maybe<Array<ServiceAgreementMessage>>;
};

export type ServiceAgreementBenefits = {
  __typename?: 'ServiceAgreementBenefits';
  packageCost: Money;
  packageSupportFee: Money;
};

export type ServiceAgreementChangeAcknowledgement = {
  __typename?: 'ServiceAgreementChangeAcknowledgement';
  acknowledgedAt: Scalars['ISO8601Date']['output'];
};

export type ServiceAgreementCosts = {
  __typename?: 'ServiceAgreementCosts';
  administrativeCost?: Maybe<Money>;
  benefitsCost: Money;
  discountPercentage: Scalars['Int']['output'];
  discountedUntil?: Maybe<Scalars['ISO8601Date']['output']>;
  oysterFee: Money;
  teamMemberServiceFee: Money;
  total: Money;
};

export type ServiceAgreementEvent = {
  __typename?: 'ServiceAgreementEvent';
  acknowledgedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Array<ServiceAgreementEventData>;
  targetId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type ServiceAgreementEventData = {
  __typename?: 'ServiceAgreementEventData';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ServiceAgreementMessage = {
  __typename?: 'ServiceAgreementMessage';
  acknowledgedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  data: Array<ServiceAgreementMessageData>;
  targetId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type ServiceAgreementMessageData = {
  __typename?: 'ServiceAgreementMessageData';
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type Session = CompleteHireSession;

/** Autogenerated input type of SetAdpWorkforceNowOnboardingData */
export type SetAdpWorkforceNowOnboardingDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  onboardingTemplateRemoteId: Scalars['String']['input'];
};

/** Autogenerated return type of SetAdpWorkforceNowOnboardingData. */
export type SetAdpWorkforceNowOnboardingDataPayload = {
  __typename?: 'SetAdpWorkforceNowOnboardingDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  targetTask: TodoTasksTask;
};

/** Autogenerated input type of SetCompletedAt */
export type SetCompletedAtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completedAt: Scalars['ISO8601DateTime']['input'];
  paymentRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetCompletedAt. */
export type SetCompletedAtPayload = {
  __typename?: 'SetCompletedAtPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentRequest: ChargePaymentRequest;
};

/** Autogenerated input type of SetExpensesPaymentMethod */
export type SetExpensesPaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetExpensesPaymentMethod. */
export type SetExpensesPaymentMethodPayload = {
  __typename?: 'SetExpensesPaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod: EngagementBankAccount;
};

/** Autogenerated input type of SetPrimaryPaymentMethod */
export type SetPrimaryPaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetPrimaryPaymentMethod. */
export type SetPrimaryPaymentMethodPayload = {
  __typename?: 'SetPrimaryPaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod: EngagementBankAccount;
};

/** Autogenerated input type of SetupComplianceChecker */
export type SetupComplianceCheckerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  platformName?: InputMaybe<ComplianceCheckerHrisPlatformTypeEnum>;
  publicToken?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SetupComplianceChecker. */
export type SetupComplianceCheckerPayload = {
  __typename?: 'SetupComplianceCheckerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  complianceCheckerReport?: Maybe<ComplianceCheckerReport>;
  errors: Array<Scalars['String']['output']>;
};

export type SickPay = {
  __typename?: 'SickPay';
  customDurationUnit?: Maybe<SickPayDurationUnitEnum>;
  customDurationValue?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  option: Scalars['String']['output'];
};

export enum SickPayDurationUnitEnum {
  Days = 'DAYS',
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type SickPayInput = {
  customDurationUnit?: InputMaybe<SickPayDurationUnitEnum>;
  customDurationValue?: InputMaybe<Scalars['Int']['input']>;
  option: Scalars['String']['input'];
};

export type SlackIntegration = {
  __typename?: 'SlackIntegration';
  authRequestUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAuthorized: Scalars['Boolean']['output'];
  isReady: Scalars['Boolean']['output'];
  slackTeamId?: Maybe<Scalars['String']['output']>;
  slackTeamName?: Maybe<Scalars['String']['output']>;
};

export enum SortByEnum {
  CountryAlpha2 = 'country_alpha2',
  Id = 'id',
  Name = 'name'
}

export enum SortOrderEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StaffAspect = AspectInterface & {
  __typename?: 'StaffAspect';
  authorizations?: Maybe<Authorization>;
  company?: Maybe<Company>;
  engagement?: Maybe<Engagement>;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum StaffEngagementChangesSortByEnum {
  DateOfRequest = 'DATE_OF_REQUEST',
  TeamMemberName = 'TEAM_MEMBER_NAME'
}

export type StaffNote = {
  __typename?: 'StaffNote';
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: Actor;
  id: Scalars['ID']['output'];
  scope: Scalars['String']['output'];
};

/** The connection type for StaffNote. */
export type StaffNoteConnection = {
  __typename?: 'StaffNoteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StaffNoteEdge>>>;
  id: Scalars['ID']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<StaffNote>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /**
   * Provide this posting context to the postStaffNote mutation in order to post a note
   * to this exact same context.
   */
  postingContext: Scalars['ID']['output'];
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StaffNoteEdge = {
  __typename?: 'StaffNoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<StaffNote>;
};

/** Autogenerated input type of StaffSubmitEmploymentHiringOnboardingForm */
export type StaffSubmitEmploymentHiringOnboardingFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiringId: Scalars['ID']['input'];
};

/** Autogenerated return type of StaffSubmitEmploymentHiringOnboardingForm. */
export type StaffSubmitEmploymentHiringOnboardingFormPayload = {
  __typename?: 'StaffSubmitEmploymentHiringOnboardingFormPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of StartAmendmentProcess */
export type StartAmendmentProcessInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementChangeId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartAmendmentProcess. */
export type StartAmendmentProcessPayload = {
  __typename?: 'StartAmendmentProcessPayload';
  amendmentProcess?: Maybe<AmendmentProcessType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagementChange?: Maybe<EngagementChange>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of StartCartaSync */
export type StartCartaSyncInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartCartaSync. */
export type StartCartaSyncPayload = {
  __typename?: 'StartCartaSyncPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of StoreAdpWorkforceNowCredentialsAfterConsent */
export type StoreAdpWorkforceNowCredentialsAfterConsentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of StoreAdpWorkforceNowCredentialsAfterConsent. */
export type StoreAdpWorkforceNowCredentialsAfterConsentPayload = {
  __typename?: 'StoreAdpWorkforceNowCredentialsAfterConsentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  integration?: Maybe<HrisIntegration>;
};

export type StripeMandate = {
  __typename?: 'StripeMandate';
  authorizations?: Maybe<Authorization>;
  company: Company;
  mandateId: Scalars['String']['output'];
  paymentMethod?: Maybe<CorePaymentMethod>;
  status: PaymentMethodStripeMandateStatusEnumType;
};

export type Subdivision = {
  __typename?: 'Subdivision';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** Autogenerated input type of SubmitBulkEngagementChange */
export type SubmitBulkEngagementChangeInput = {
  bulkEngagementChangeId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SubmitBulkEngagementChange. */
export type SubmitBulkEngagementChangePayload = {
  __typename?: 'SubmitBulkEngagementChangePayload';
  bulkEngagementChange?: Maybe<BulkEngagementChange>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SubmitComplianceCheckerReportFeedback */
export type SubmitComplianceCheckerReportFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
  userFeedbackMessage: Scalars['String']['input'];
  userFeedbackUseful: Scalars['Boolean']['input'];
};

/** Autogenerated return type of SubmitComplianceCheckerReportFeedback. */
export type SubmitComplianceCheckerReportFeedbackPayload = {
  __typename?: 'SubmitComplianceCheckerReportFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  complianceCheckerReport?: Maybe<ComplianceCheckerReport>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SubmitResponse */
export type SubmitResponseInput = {
  answerIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  questionnaireId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubmitResponse. */
export type SubmitResponsePayload = {
  __typename?: 'SubmitResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  response?: Maybe<Response>;
};

/** Autogenerated input type of SubmitSageAssistantFeedback */
export type SubmitSageAssistantFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  option?: InputMaybe<SageAssistantFeedbackOptionsTypeEnum>;
  positive: Scalars['Boolean']['input'];
  questionId: Scalars['String']['input'];
};

/** Autogenerated return type of SubmitSageAssistantFeedback. */
export type SubmitSageAssistantFeedbackPayload = {
  __typename?: 'SubmitSageAssistantFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SubmitSageAssistantSupportTicket */
export type SubmitSageAssistantSupportTicketInput = {
  answer: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  context?: InputMaybe<SupportCategoryOptionsTypeEnum>;
  description: Scalars['String']['input'];
  question: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  teamMemberId: Scalars['ID']['input'];
  timeOffContext?: InputMaybe<SageAssistantTimeOffOptionsTypeEnum>;
};

/** Autogenerated return type of SubmitSageAssistantSupportTicket. */
export type SubmitSageAssistantSupportTicketPayload = {
  __typename?: 'SubmitSageAssistantSupportTicketPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SubscribeEngagementsToCustomPrice */
export type SubscribeEngagementsToCustomPriceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  customPriceId: Scalars['String']['input'];
  engagementIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of SubscribeEngagementsToCustomPrice. */
export type SubscribeEngagementsToCustomPricePayload = {
  __typename?: 'SubscribeEngagementsToCustomPricePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
};

/** Autogenerated input type of Subscribe */
export type SubscribeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['String']['input'];
  monetizationPlanId?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated input type of SubscribeOysterSafe */
export type SubscribeOysterSafeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  oysterSafeId: Scalars['ID']['input'];
};

/** Autogenerated return type of SubscribeOysterSafe. */
export type SubscribeOysterSafePayload = {
  __typename?: 'SubscribeOysterSafePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  oysterSafe?: Maybe<ContractOysterSafe>;
};

/** Autogenerated return type of Subscribe. */
export type SubscribePayload = {
  __typename?: 'SubscribePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** The subscription that was updated or created. */
  subscription?: Maybe<Subscription>;
};

export type Subscription = {
  __typename?: 'Subscription';
  authorizations?: Maybe<Authorization>;
  discountOverride?: Maybe<DiscountOverride>;
  discountRedemption?: Maybe<DiscountRedemption>;
  engagement: Engagement;
  /** The price of a subscription (after discount) */
  finalPrice: Money;
  id: Scalars['ID']['output'];
  oldPlan?: Maybe<Plan>;
  plan: NewPlan;
  /** The price of a subscription (before discount) */
  price: Money;
  startsOn?: Maybe<Scalars['ISO8601Date']['output']>;
  supersededBy?: Maybe<Subscription>;
};

export enum SupportCategoryOptionsTypeEnum {
  ContractorManagementAccountContractorAccountChanges = 'CONTRACTOR_MANAGEMENT__ACCOUNT__CONTRACTOR_ACCOUNT_CHANGES',
  ContractorManagementAccountContractorBenefitsQuery = 'CONTRACTOR_MANAGEMENT__ACCOUNT__CONTRACTOR_BENEFITS_QUERY',
  ContractorManagementAccountContractorTaxForms = 'CONTRACTOR_MANAGEMENT__ACCOUNT__CONTRACTOR_TAX_FORMS',
  ContractorManagementAccountContractorTimeoffQuery = 'CONTRACTOR_MANAGEMENT__ACCOUNT__CONTRACTOR_TIMEOFF_QUERY',
  ContractorManagementContractsContractorAgreementChange = 'CONTRACTOR_MANAGEMENT__CONTRACTS__CONTRACTOR_AGREEMENT_CHANGE',
  ContractorManagementContractsContractorContractspecificQuery = 'CONTRACTOR_MANAGEMENT__CONTRACTS__CONTRACTOR_CONTRACTSPECIFIC_QUERY',
  ContractorManagementContractsContractorDocumentInquiries = 'CONTRACTOR_MANAGEMENT__CONTRACTS__CONTRACTOR_DOCUMENT_INQUIRIES',
  ContractorManagementHiringOnboardingContractorOnboardingError = 'CONTRACTOR_MANAGEMENT__HIRING__ONBOARDING__CONTRACTOR_ONBOARDING_ERROR',
  ContractorManagementHiringOnboardingHiringAContractor = 'CONTRACTOR_MANAGEMENT__HIRING__ONBOARDING__HIRING_A_CONTRACTOR',
  ContractorManagementHiringOnboardingOnboardingAContractor = 'CONTRACTOR_MANAGEMENT__HIRING__ONBOARDING__ONBOARDING_A_CONTRACTOR',
  ContractorManagementOffboardingCancelTerminationRequest = 'CONTRACTOR_MANAGEMENT__OFFBOARDING__CANCEL_TERMINATION_REQUEST',
  ContractorManagementOffboardingContractorOffboardingQuestion = 'CONTRACTOR_MANAGEMENT__OFFBOARDING__CONTRACTOR_OFFBOARDING_QUESTION',
  ContractorManagementOffboardingContractorOffboardingTerminationRequest = 'CONTRACTOR_MANAGEMENT__OFFBOARDING__CONTRACTOR_OFFBOARDING_TERMINATION_REQUEST',
  ContractorManagementOffboardingGeneralContractorOffboardingQuestion = 'CONTRACTOR_MANAGEMENT__OFFBOARDING__GENERAL_CONTRACTOR_OFFBOARDING_QUESTION',
  ContractorManagementPlatformContractorGeneralInformation = 'CONTRACTOR_MANAGEMENT__PLATFORM__CONTRACTOR_GENERAL_INFORMATION',
  ContractorManagementPlatformContractorPlatformIssue = 'CONTRACTOR_MANAGEMENT__PLATFORM__CONTRACTOR_PLATFORM_ISSUE',
  ContractorManagementPlatformContractorPlatformNavigationUse = 'CONTRACTOR_MANAGEMENT__PLATFORM__CONTRACTOR_PLATFORM_NAVIGATION__USE',
  ContractsAgreementsContractAmendmentAllowancebonusChange = 'CONTRACTS__AGREEMENTS__CONTRACT_AMENDMENT__ALLOWANCEBONUS_CHANGE',
  ContractsAgreementsContractAmendmentBenefitsPensionHolidayEntitlementChange = 'CONTRACTS__AGREEMENTS__CONTRACT_AMENDMENT__BENEFITS_PENSION__HOLIDAY_ENTITLEMENT_CHANGE',
  ContractsAgreementsContractAmendmentChangeEntity = 'CONTRACTS__AGREEMENTS__CONTRACT_AMENDMENT__CHANGE_ENTITY',
  ContractsAgreementsContractAmendmentContractrelatedQueries = 'CONTRACTS__AGREEMENTS__CONTRACT_AMENDMENT__CONTRACTRELATED_QUERIES',
  ContractsAgreementsContractAmendmentEmploymentType = 'CONTRACTS__AGREEMENTS__CONTRACT_AMENDMENT__EMPLOYMENT_TYPE',
  ContractsAgreementsContractAmendmentNameOrAddressChange = 'CONTRACTS__AGREEMENTS__CONTRACT_AMENDMENT__NAME_OR_ADDRESS_CHANGE',
  ContractsAgreementsContractAmendmentRolejobTitleChange = 'CONTRACTS__AGREEMENTS__CONTRACT_AMENDMENT__ROLEJOB_TITLE_CHANGE',
  ContractsAgreementsContractAmendmentSalaryChange = 'CONTRACTS__AGREEMENTS__CONTRACT_AMENDMENT__SALARY_CHANGE',
  ContractsAgreementsContractDocumentsErrorOnContractDocument = 'CONTRACTS__AGREEMENTS__CONTRACT_DOCUMENTS__ERROR_ON_CONTRACT_DOCUMENT',
  ContractsAgreementsContractDocumentsGeneralContractQuery = 'CONTRACTS__AGREEMENTS__CONTRACT_DOCUMENTS__GENERAL_CONTRACT_QUERY',
  DocumentsEmploymentVerification_3RdPartyVerificationRequest = 'DOCUMENTS__EMPLOYMENT_VERIFICATION__3RD_PARTY_VERIFICATION_REQUEST',
  DocumentsEmploymentVerificationRequestForCertificateOfEmployment = 'DOCUMENTS__EMPLOYMENT_VERIFICATION__REQUEST_FOR_CERTIFICATE_OF_EMPLOYMENT',
  DocumentsHealthSafetyHsDocumentation = 'DOCUMENTS__HEALTH__SAFETY__HS_DOCUMENTATION',
  DocumentsHealthSafetyHsTraining = 'DOCUMENTS__HEALTH__SAFETY__HS_TRAINING',
  DocumentsTravelA1CertificateRequest = 'DOCUMENTS__TRAVEL__A1_CERTIFICATE_REQUEST',
  DocumentsTravelGeneralTravelQuery = 'DOCUMENTS__TRAVEL__GENERAL_TRAVEL_QUERY',
  DocumentsTravelSupportingDocumentationRequest = 'DOCUMENTS__TRAVEL__SUPPORTING_DOCUMENTATION_REQUEST',
  ExpenseReimbursementsOtherReimbursementIssue = 'EXPENSE_REIMBURSEMENTS__OTHER_REIMBURSEMENT_ISSUE',
  ExpenseReimbursementsReimbursementCalculatedIncorrectly = 'EXPENSE_REIMBURSEMENTS__REIMBURSEMENT_CALCULATED_INCORRECTLY',
  ExpenseReimbursementsReimbursementDocumentationIssue = 'EXPENSE_REIMBURSEMENTS__REIMBURSEMENT_DOCUMENTATION_ISSUE',
  ExpenseReimbursementsReimbursementIsLate = 'EXPENSE_REIMBURSEMENTS__REIMBURSEMENT_IS_LATE',
  ExpenseReimbursementsTaxAppliedToReimbursement = 'EXPENSE_REIMBURSEMENTS__TAX_APPLIED_TO_REIMBURSEMENT',
  Fraud = 'FRAUD',
  InvoicingAccountManagementAccountStatementAccountStatementReport = 'INVOICING__ACCOUNT_MANAGEMENT__ACCOUNT_STATEMENT__ACCOUNT_STATEMENT_REPORT',
  InvoicingAccountManagementAccountStatementDepositAccountStatementReport = 'INVOICING__ACCOUNT_MANAGEMENT__ACCOUNT_STATEMENT__DEPOSIT_ACCOUNT_STATEMENT_REPORT',
  InvoicingAccountManagementAccountStatementOtherAccountStatementQuery = 'INVOICING__ACCOUNT_MANAGEMENT__ACCOUNT_STATEMENT__OTHER_ACCOUNT_STATEMENT_QUERY',
  InvoicingAccountManagementBillingAccountSettingsBillingCompanyAddress = 'INVOICING__ACCOUNT_MANAGEMENT__BILLING_ACCOUNT_SETTINGS__BILLING_COMPANY_ADDRESS',
  InvoicingAccountManagementBillingAccountSettingsBillingCurrency = 'INVOICING__ACCOUNT_MANAGEMENT__BILLING_ACCOUNT_SETTINGS__BILLING_CURRENCY',
  InvoicingAccountManagementBillingAccountSettingsBillingEmailChangeAndNotifications = 'INVOICING__ACCOUNT_MANAGEMENT__BILLING_ACCOUNT_SETTINGS__BILLING_EMAIL_CHANGE_AND_NOTIFICATIONS',
  InvoicingAccountManagementBillingAccountSettingsOtherBillingAccountSettingsQuery = 'INVOICING__ACCOUNT_MANAGEMENT__BILLING_ACCOUNT_SETTINGS__OTHER_BILLING_ACCOUNT_SETTINGS_QUERY',
  InvoicingAccountManagementCashCreditNoteApplicationCreditNoteAllocationQuery = 'INVOICING__ACCOUNT_MANAGEMENT__CASH__CREDIT_NOTE_APPLICATION__CREDIT_NOTE_ALLOCATION_QUERY',
  InvoicingAccountManagementCashCreditNoteApplicationPaymentAllocationQuery = 'INVOICING__ACCOUNT_MANAGEMENT__CASH__CREDIT_NOTE_APPLICATION__PAYMENT_ALLOCATION_QUERY',
  InvoicingAccountManagementCashCreditNoteApplicationRemoveAutoapplicationOfCreditNotes = 'INVOICING__ACCOUNT_MANAGEMENT__CASH__CREDIT_NOTE_APPLICATION__REMOVE_AUTOAPPLICATION_OF_CREDIT_NOTES',
  InvoicingAccountManagementInvoicingCalculationOfTeamMemberServiceCosts = 'INVOICING__ACCOUNT_MANAGEMENT__INVOICING__CALCULATION_OF_TEAM_MEMBER_SERVICE_COSTS',
  InvoicingAccountManagementInvoicingForeignExchangeRates = 'INVOICING__ACCOUNT_MANAGEMENT__INVOICING__FOREIGN_EXCHANGE_RATES',
  InvoicingAccountManagementInvoicingInvoicePaymentTerms = 'INVOICING__ACCOUNT_MANAGEMENT__INVOICING__INVOICE_PAYMENT_TERMS',
  InvoicingAccountManagementInvoicingOtherInvoiceQuery = 'INVOICING__ACCOUNT_MANAGEMENT__INVOICING__OTHER_INVOICE_QUERY',
  InvoicingAccountManagementInvoicingOystersFees = 'INVOICING__ACCOUNT_MANAGEMENT__INVOICING__OYSTERS_FEES',
  InvoicingAccountManagementInvoicingMissingOrIncorrectPayrollChanges = 'INVOICING___ACCOUNT_MANAGEMENT__INVOICING__MISSING_OR_INCORRECT_PAYROLL_CHANGES',
  OffboardQueryCancelledOffboarding = 'OFFBOARD_QUERY__CANCELLED_OFFBOARDING',
  OffboardQueryFixedTermExpiration = 'OFFBOARD_QUERY__FIXED_TERM_EXPIRATION',
  OffboardQueryFixedTermTermination = 'OFFBOARD_QUERY__FIXED_TERM_TERMINATION',
  OffboardQueryGeneralOffboardingQuery = 'OFFBOARD_QUERY__GENERAL_OFFBOARDING_QUERY',
  OffboardQueryMigration = 'OFFBOARD_QUERY__MIGRATION',
  OffboardQueryReleaseBeforeStartDate = 'OFFBOARD_QUERY__RELEASE_BEFORE_START_DATE',
  OffboardQueryResignation = 'OFFBOARD_QUERY__RESIGNATION',
  OffboardQueryTeamMemberTransferToAnotherEmployer = 'OFFBOARD_QUERY__TEAM_MEMBER_TRANSFER_TO_ANOTHER_EMPLOYER',
  OffboardQueryTermination = 'OFFBOARD_QUERY__TERMINATION',
  OffboardQueryUnemploymentInsurance = 'OFFBOARD_QUERY__UNEMPLOYMENT_INSURANCE',
  OysterBenefitsGlobalHealthLifeInsuranceChangesToCurrentPlan = 'OYSTER_BENEFITS__GLOBAL_HEALTH__LIFE_INSURANCE__CHANGES_TO_CURRENT_PLAN',
  OysterBenefitsGlobalHealthLifeInsuranceEnrollmentRequest = 'OYSTER_BENEFITS__GLOBAL_HEALTH__LIFE_INSURANCE__ENROLLMENT_REQUEST',
  OysterBenefitsGlobalHealthLifeInsuranceErrorOnCurrentPlan = 'OYSTER_BENEFITS__GLOBAL_HEALTH__LIFE_INSURANCE__ERROR_ON_CURRENT_PLAN',
  OysterBenefitsGlobalHealthLifeInsuranceGeneralHealthlifeInsuranceQuestion = 'OYSTER_BENEFITS__GLOBAL_HEALTH__LIFE_INSURANCE__GENERAL_HEALTHLIFE_INSURANCE_QUESTION',
  OysterBenefitsLocalBenefitsEnrollmentOrUpdateOfLocalBenefit = 'OYSTER_BENEFITS__LOCAL_BENEFITS__ENROLLMENT_OR_UPDATE_OF_LOCAL_BENEFIT',
  OysterBenefitsLocalBenefitsErrorOnLocalBenefits = 'OYSTER_BENEFITS__LOCAL_BENEFITS__ERROR_ON_LOCAL_BENEFITS',
  OysterBenefitsLocalBenefitsLocalBenefitQuestion = 'OYSTER_BENEFITS__LOCAL_BENEFITS__LOCAL_BENEFIT_QUESTION',
  PaymentsBankingIssue = 'PAYMENTS__BANKING_ISSUE',
  PaymentsContractorPaymentQuery = 'PAYMENTS__CONTRACTOR_PAYMENT_QUERY',
  PaymentsMyPaymentIsIncorrect = 'PAYMENTS__MY_PAYMENT_IS_INCORRECT',
  PaymentsMyPaymentIsLateOrMissing = 'PAYMENTS__MY_PAYMENT_IS_LATE_OR_MISSING',
  PaymentsOtherPaymentIssue = 'PAYMENTS__OTHER_PAYMENT_ISSUE',
  PaymentsPaymentsToOysterDirectDebitQuery = 'PAYMENTS__PAYMENTS_TO_OYSTER__DIRECT_DEBIT_QUERY',
  PaymentsPaymentsToOysterInvoicePaymentStatus = 'PAYMENTS__PAYMENTS_TO_OYSTER__INVOICE_PAYMENT_STATUS',
  PaymentsPaymentsToOysterOtherPaymentsToOysterQuery = 'PAYMENTS__PAYMENTS_TO_OYSTER__OTHER_PAYMENTS_TO_OYSTER_QUERY',
  PaymentsPaymentsToOysterPaymentIntegrations = 'PAYMENTS__PAYMENTS_TO_OYSTER__PAYMENT_INTEGRATIONS',
  PaymentsPaymentsToOysterValidateOystersBankDetails = 'PAYMENTS__PAYMENTS_TO_OYSTER__VALIDATE_OYSTERS_BANK_DETAILS',
  PaymentsPaymentsToOysterWirePaymentQuery = 'PAYMENTS__PAYMENTS_TO_OYSTER__WIRE_PAYMENT_QUERY',
  PaymentsPaymentsToTeamMembersContractorsPaymentQuery = 'PAYMENTS__PAYMENTS_TO_TEAM_MEMBERS__CONTRACTORS_PAYMENT_QUERY',
  PaymentsPaymentsToTeamMembersLateOrMissingTeamMemberPayment = 'PAYMENTS__PAYMENTS_TO_TEAM_MEMBERS__LATE_OR_MISSING_TEAM_MEMBER_PAYMENT',
  PaymentsPaymentsToTeamMembersOtherTeamMemberPaymentQuery = 'PAYMENTS__PAYMENTS_TO_TEAM_MEMBERS__OTHER_TEAM_MEMBER_PAYMENT_QUERY',
  PaymentsPaymentsToTeamMembersTeamMemberBankAccountIssue = 'PAYMENTS__PAYMENTS_TO_TEAM_MEMBERS__TEAM_MEMBER_BANK_ACCOUNT_ISSUE',
  PaymentsRefundsCreditNoteRefunds = 'PAYMENTS__REFUNDS__CREDIT_NOTE_REFUNDS',
  PaymentsRefundsDepositRefunds = 'PAYMENTS__REFUNDS__DEPOSIT_REFUNDS',
  PaymentsRefundsOtherRefundsQuery = 'PAYMENTS__REFUNDS__OTHER_REFUNDS_QUERY',
  PayrollPayrollQueries_1314ThMonthSalary = 'PAYROLL__PAYROLL_QUERIES__1314TH_MONTH_SALARY',
  PayrollPayrollQueriesAllowances = 'PAYROLL__PAYROLL_QUERIES__ALLOWANCES',
  PayrollPayrollQueriesBenefits = 'PAYROLL__PAYROLL_QUERIES__BENEFITS',
  PayrollPayrollQueriesBonusesCommissions = 'PAYROLL__PAYROLL_QUERIES__BONUSES__COMMISSIONS',
  PayrollPayrollQueriesDeductionsTaxes = 'PAYROLL__PAYROLL_QUERIES__DEDUCTIONS__TAXES',
  PayrollPayrollQueriesEmployerTaxesContributions = 'PAYROLL__PAYROLL_QUERIES__EMPLOYER_TAXES__CONTRIBUTIONS',
  PayrollPayrollQueriesGrossSalary = 'PAYROLL__PAYROLL_QUERIES__GROSS_SALARY',
  PayrollPayrollQueriesIncorrectIncomeTaxDeduction = 'PAYROLL__PAYROLL_QUERIES__INCORRECT_INCOME_TAX_DEDUCTION',
  PayrollPayrollQueriesIncorrectPayrollChange = 'PAYROLL__PAYROLL_QUERIES__INCORRECT_PAYROLL_CHANGE',
  PayrollPayrollQueriesMissingPayrollChange = 'PAYROLL__PAYROLL_QUERIES__MISSING_PAYROLL_CHANGE',
  PayrollPayrollQueriesOtherDeductionsIssue = 'PAYROLL__PAYROLL_QUERIES__OTHER_DEDUCTIONS_ISSUE',
  PayrollPayrollQueriesOtherPayrollQuery = 'PAYROLL__PAYROLL_QUERIES__OTHER_PAYROLL_QUERY',
  PayrollPayrollQueriesPensionContributions = 'PAYROLL__PAYROLL_QUERIES__PENSION_CONTRIBUTIONS',
  PayrollPayrollQueriesProrataCalculation = 'PAYROLL__PAYROLL_QUERIES__PRORATA_CALCULATION',
  PayrollPayrollQueriesProRataCalculationIssue = 'PAYROLL__PAYROLL_QUERIES__PRO_RATA_CALCULATION_ISSUE',
  PayrollPayrollQueriesStatutoryPayIssue = 'PAYROLL__PAYROLL_QUERIES__STATUTORY_PAY_ISSUE',
  PayrollPayrollQueriesTaxOnBenefitsInKind = 'PAYROLL__PAYROLL_QUERIES__TAX_ON_BENEFITS_IN_KIND',
  PayrollPayslipsICannotAccessMyPayslip = 'PAYROLL__PAYSLIPS__I_CANNOT_ACCESS_MY_PAYSLIP',
  PayrollPayslipsIHaveNotReceivedMyPayslip = 'PAYROLL__PAYSLIPS__I_HAVE_NOT_RECEIVED_MY_PAYSLIP',
  PayrollPayslipsOtherPayslipQuery = 'PAYROLL__PAYSLIPS__OTHER_PAYSLIP_QUERY',
  PayrollPayslipsTeamMemberCannotAccessTheirPayslip = 'PAYROLL__PAYSLIPS__TEAM_MEMBER_CANNOT_ACCESS_THEIR_PAYSLIP',
  PayrollPayslipsTeamMemberHasNotReceivedTheirPayslip = 'PAYROLL__PAYSLIPS__TEAM_MEMBER_HAS_NOT_RECEIVED_THEIR_PAYSLIP',
  PayrollTaxDocumentsAnnualTaxReturnsFilings = 'PAYROLL__TAX_DOCUMENTS__ANNUAL_TAX_RETURNS__FILINGS',
  PayrollTaxDocumentsOtherTaxDocumentQuery = 'PAYROLL__TAX_DOCUMENTS__OTHER_TAX_DOCUMENT_QUERY',
  PayrollTaxDocumentsTaxResidencyDocuments = 'PAYROLL__TAX_DOCUMENTS__TAX_RESIDENCY_DOCUMENTS',
  PlatformNavigationConfigurationAccountInformation = 'PLATFORM__NAVIGATION__CONFIGURATION__ACCOUNT_INFORMATION',
  PlatformNavigationConfigurationGeneralNavigationQuery = 'PLATFORM__NAVIGATION__CONFIGURATION__GENERAL_NAVIGATION_QUERY',
  PlatformNavigationConfigurationNotificationsIssue = 'PLATFORM__NAVIGATION__CONFIGURATION__NOTIFICATIONS_ISSUE',
  PlatformNavigationConfigurationNotificationsQuery = 'PLATFORM__NAVIGATION__CONFIGURATION__NOTIFICATIONS_QUERY',
  PlatformSystemIntegrationsHibobPersonioBamboohrEtcIntegrationError = 'PLATFORM__SYSTEM_INTEGRATIONS_HIBOB_PERSONIO_BAMBOOHR_ETC__INTEGRATION_ERROR',
  PlatformSystemIntegrationsHibobPersonioBamboohrEtcIntegrationQuery = 'PLATFORM__SYSTEM_INTEGRATIONS_HIBOB_PERSONIO_BAMBOOHR_ETC__INTEGRATION_QUERY',
  RightToWorkExpiredDocuments = 'RIGHT_TO_WORK__EXPIRED_DOCUMENTS',
  RightToWorkQueryForEngagedTeamMember = 'RIGHT_TO_WORK__QUERY_FOR_ENGAGED_TEAM_MEMBER',
  RightToWorkRenewalextension = 'RIGHT_TO_WORK__RENEWALEXTENSION',
  SensitiveHrQueryEmergencyResponse = 'SENSITIVE_HR_QUERY__EMERGENCY_RESPONSE',
  SensitiveHrQueryGeneralQuery = 'SENSITIVE_HR_QUERY__GENERAL_QUERY',
  SensitiveHrQueryLawEnforcementRelated = 'SENSITIVE_HR_QUERY__LAW_ENFORCEMENT_RELATED',
  SensitiveHrQueryPerformanceManagement = 'SENSITIVE_HR_QUERY__PERFORMANCE_MANAGEMENT',
  SensitiveHrQueryPerformanceRelated = 'SENSITIVE_HR_QUERY__PERFORMANCE_RELATED',
  SensitiveHrQuerySafetyRisk = 'SENSITIVE_HR_QUERY__SAFETY_RISK',
  SensitiveHrQuerySeriousMisconduct = 'SENSITIVE_HR_QUERY__SERIOUS_MISCONDUCT',
  SensitiveHrQueryTeamMemberComplaint = 'SENSITIVE_HR_QUERY__TEAM_MEMBER_COMPLAINT',
  StatutoryBenefitsInsuranceHealthBenefitEnrollmentOrUpdate = 'STATUTORY_BENEFITS__INSURANCE__HEALTH_BENEFIT_ENROLLMENT_OR_UPDATE',
  StatutoryBenefitsInsuranceHealthBenefitError = 'STATUTORY_BENEFITS__INSURANCE__HEALTH_BENEFIT_ERROR',
  StatutoryBenefitsInsuranceHealthBenefitQuery = 'STATUTORY_BENEFITS__INSURANCE__HEALTH_BENEFIT_QUERY',
  StatutoryBenefitsInsuranceWorkersCompensationClaim = 'STATUTORY_BENEFITS__INSURANCE__WORKERS_COMPENSATION_CLAIM',
  StatutoryBenefitsInsuranceWorkersCompensationQuery = 'STATUTORY_BENEFITS__INSURANCE__WORKERS_COMPENSATION_QUERY',
  StatutoryBenefitsOtherBenefitsClarificationOnOtherMandatoryBenefits = 'STATUTORY_BENEFITS__OTHER_BENEFITS__CLARIFICATION_ON_OTHER_MANDATORY_BENEFITS',
  StatutoryBenefitsPensionEnrollmentOrChangesToPension = 'STATUTORY_BENEFITS__PENSION__ENROLLMENT_OR_CHANGES_TO_PENSION',
  StatutoryBenefitsPensionGeneralPensionQuestion = 'STATUTORY_BENEFITS__PENSION__GENERAL_PENSION_QUESTION',
  StatutoryBenefitsPensionPensionError = 'STATUTORY_BENEFITS__PENSION__PENSION_ERROR',
  StatutoryBenefitsSocialSecuritySsBenefitQuery = 'STATUTORY_BENEFITS__SOCIAL_SECURITY__SS_BENEFIT_QUERY',
  StatutoryBenefitsSocialSecuritySsEnrollmentOrUpdate = 'STATUTORY_BENEFITS__SOCIAL_SECURITY__SS_ENROLLMENT_OR_UPDATE',
  StatutoryBenefitsSocialSecuritySsErrorOrIssue = 'STATUTORY_BENEFITS__SOCIAL_SECURITY__SS_ERROR_OR_ISSUE',
  TimeoffTimesheetsPaidTimeOffGeneralPtoQuery = 'TIMEOFF__TIMESHEETS__PAID_TIME_OFF__GENERAL_PTO_QUERY',
  TimeoffTimesheetsPaidTimeOffIncorrectPtoFiled = 'TIMEOFF__TIMESHEETS__PAID_TIME_OFF__INCORRECT_PTO_FILED',
  TimeoffTimesheetsPaidTimeOffPtoBalance = 'TIMEOFF__TIMESHEETS__PAID_TIME_OFF__PTO_BALANCE',
  TimeoffTimesheetsPaidTimeOffUnableToFilePto = 'TIMEOFF__TIMESHEETS__PAID_TIME_OFF__UNABLE_TO_FILE_PTO',
  TimeoffTimesheetsParentalLeaveFilingIssue = 'TIMEOFF__TIMESHEETS__PARENTAL_LEAVE__FILING_ISSUE',
  TimeoffTimesheetsParentalLeaveInformationRequest = 'TIMEOFF__TIMESHEETS__PARENTAL_LEAVE__INFORMATION_REQUEST',
  TimeoffTimesheetsParentalLeaveRequestExtension = 'TIMEOFF__TIMESHEETS__PARENTAL_LEAVE__REQUEST_EXTENSION',
  TimeoffTimesheetsParentalLeaveStatusOfParentalLeave = 'TIMEOFF__TIMESHEETS__PARENTAL_LEAVE__STATUS_OF_PARENTAL_LEAVE',
  TimeoffTimesheetsSickLeaveGeneralSickLeaveQuestion = 'TIMEOFF__TIMESHEETS__SICK_LEAVE__GENERAL_SICK_LEAVE_QUESTION',
  TimeoffTimesheetsSickLeaveIncorrectSickLeaveFiled = 'TIMEOFF__TIMESHEETS__SICK_LEAVE__INCORRECT_SICK_LEAVE_FILED',
  TimeoffTimesheetsSickLeaveUnableToSubmitRequest = 'TIMEOFF__TIMESHEETS__SICK_LEAVE__UNABLE_TO_SUBMIT_REQUEST',
  TimeoffTimesheetsTimesheetsEditingOrCorrectingEntry = 'TIMEOFF__TIMESHEETS__TIMESHEETS__EDITING_OR_CORRECTING_ENTRY',
  TimeoffTimesheetsTimesheetsGeneralTimesheetQuestion = 'TIMEOFF__TIMESHEETS__TIMESHEETS__GENERAL_TIMESHEET_QUESTION',
  TimeoffTimesheetsTimesheetsRecordingOvertimeoncallHours = 'TIMEOFF__TIMESHEETS__TIMESHEETS__RECORDING_OVERTIMEONCALL_HOURS',
  TimeoffTimesheetsUnpaidLeaveGeneralUnpaidLeaveQuestion = 'TIMEOFF__TIMESHEETS__UNPAID_LEAVE__GENERAL_UNPAID_LEAVE_QUESTION',
  TimeoffTimesheetsUnpaidLeaveIncorrectUnpaidLeaveFiling = 'TIMEOFF__TIMESHEETS__UNPAID_LEAVE__INCORRECT_UNPAID_LEAVE_FILING',
  TimeoffTimesheetsUnpaidLeaveUnableToSubmitRequest = 'TIMEOFF__TIMESHEETS__UNPAID_LEAVE__UNABLE_TO_SUBMIT_REQUEST',
  TotalRewardsEquityEquityEventEgGrantExercise = 'TOTAL_REWARDS_EQUITY__EQUITY_EVENT_EG_GRANT_EXERCISE',
  TotalRewardsEquityEquityPlan = 'TOTAL_REWARDS_EQUITY__EQUITY_PLAN',
  TotalRewardsEquityOtherEquityQuery = 'TOTAL_REWARDS_EQUITY__OTHER_EQUITY_QUERY'
}

/** Autogenerated input type of SyncAccountingData */
export type SyncAccountingDataInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  dataType: AccountingSyncDataTypeEnum;
  platform: Scalars['String']['input'];
};

/** Autogenerated return type of SyncAccountingData. */
export type SyncAccountingDataPayload = {
  __typename?: 'SyncAccountingDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of SyncExpensesIntegration */
export type SyncExpensesIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  dataType: ExpensesIntegrationSyncDataTypeEnum;
};

/** Autogenerated return type of SyncExpensesIntegration. */
export type SyncExpensesIntegrationPayload = {
  __typename?: 'SyncExpensesIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of SyncHrisIntegration */
export type SyncHrisIntegrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of SyncHrisIntegration. */
export type SyncHrisIntegrationPayload = {
  __typename?: 'SyncHrisIntegrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type TaxContribution = {
  __typename?: 'TaxContribution';
  amount: Scalars['Float']['output'];
  group?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<TaxContributionMetadata>;
  name: Scalars['String']['output'];
};

export type TaxContributionMetadata = {
  __typename?: 'TaxContributionMetadata';
  /** Benefit flag for best in class to avoid duplicates in hiring flow (only applies to Employer Taxes) */
  benefitBestInClass?: Maybe<Scalars['Boolean']['output']>;
  /** Benefit flag for competitive to avoid duplicates in hiring flow (only applies to Employer Taxes) */
  benefitCompetitive?: Maybe<Scalars['Boolean']['output']>;
  /** Benefit flag for essential to avoid duplicates in hiring flow (only applies to Employer Taxes) */
  benefitEssential?: Maybe<Scalars['Boolean']['output']>;
  /** Benefit flag for best in class to avoid duplicates in hiring flow (only applies to Employer Taxes) */
  benefitHealthAddon?: Maybe<Scalars['Boolean']['output']>;
};

export type Team = {
  __typename?: 'Team';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  managers: Array<User>;
  members: Array<User>;
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<DirectManagerPermissionEnumType>>;
};

export type TeamCollection = {
  __typename?: 'TeamCollection';
  collection: Array<Team>;
  metadata: CollectionMetadata;
};

export type TeamMemberDirectManager = {
  __typename?: 'TeamMemberDirectManager';
  authorizations?: Maybe<Authorization>;
  company: Company;
  directManager: User;
  permissions: Array<DirectManagerPermissionEnumType>;
  teamMember: User;
};

export type Termination = AuditableObject & {
  __typename?: 'Termination';
  additionalConsiderationAmount?: Maybe<Money>;
  additionalConsiderationAmountToBeConfirmed?: Maybe<Scalars['Boolean']['output']>;
  additionalNotesForDepositTeam?: Maybe<Scalars['Boolean']['output']>;
  additionalTerminationPayments: Array<AdditionalTerminationPayment>;
  agreements: Array<Agreement>;
  approver?: Maybe<TerminationUser>;
  auditHistory: Array<AuditItem>;
  authorizations?: Maybe<Authorization>;
  bulkOffboarding?: Maybe<BulkOffboarding>;
  bulkOffboardingStatusDraft: Scalars['Boolean']['output'];
  caStepsTerminationHistories?: Maybe<Array<TerminationStepsHistory>>;
  calculatedPayoutMonth?: Maybe<Scalars['ISO8601Date']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  cancelledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  cancelledBy?: Maybe<User>;
  commissionDetails?: Maybe<Scalars['String']['output']>;
  communicatedWithEmployee?: Maybe<Scalars['Boolean']['output']>;
  companyOffboardingStepsTerminations?: Maybe<Array<OffboardingStepsTermination>>;
  costOfOffboarding?: Maybe<CostOfOffboarding>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  creationOrigin?: Maybe<CreationOriginEnum>;
  customerAccountCheck?: Maybe<Scalars['String']['output']>;
  deductNegativePto: Scalars['Boolean']['output'];
  depositInvoice?: Maybe<Invoice>;
  /** The list of staff notes for this termination's deposit, ordered by most recent last. */
  depositNotes: StaffNoteConnection;
  depositRefundCreditNote?: Maybe<CreditNote>;
  depositRefundStatus?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  earlyOffboardingReason?: Maybe<Scalars['String']['output']>;
  earlyOffboardingRequested?: Maybe<Scalars['Boolean']['output']>;
  employment: Employment;
  engagement: Engagement;
  envelopes: Array<Envelope>;
  errors: Array<ActiveRecordError>;
  file?: Maybe<DownloadLink>;
  id: Scalars['ID']['output'];
  initiatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  integrationName?: Maybe<Scalars['String']['output']>;
  integrationSyncOn?: Maybe<Scalars['Boolean']['output']>;
  intendedDaysOff?: Maybe<Scalars['Float']['output']>;
  lastPayment?: Maybe<Scalars['Boolean']['output']>;
  lastPaymentAmount?: Maybe<Scalars['Float']['output']>;
  lastPaymentCurrencyCode?: Maybe<Scalars['String']['output']>;
  mutualTermination?: Maybe<Scalars['Boolean']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notifyCustomerAdmin?: Maybe<Scalars['Boolean']['output']>;
  offboardingSpecialist?: Maybe<TerminationUser>;
  offboardingStepsTerminations?: Maybe<Array<OffboardingStepsTermination>>;
  onLeave?: Maybe<Scalars['Boolean']['output']>;
  paidInFullCheckDate?: Maybe<Scalars['ISO8601Date']['output']>;
  paidInFullStatus: TerminationPaidInFullStatusType;
  payrollPayoutMonthChange?: Maybe<Scalars['Boolean']['output']>;
  payrollPayoutMonthReason?: Maybe<Scalars['String']['output']>;
  /** The list of payroll specialist notes for this termination, ordered by most recent last. */
  payrollSpecialistNotes: StaffNoteConnection;
  primaryCategory?: Maybe<OffboardingCategory>;
  proposedDate?: Maybe<Scalars['ISO8601Date']['output']>;
  proposedPayoutMonth?: Maybe<Scalars['ISO8601Date']['output']>;
  ptoAccurate?: Maybe<Scalars['Boolean']['output']>;
  ptoDaysRemaining?: Maybe<Scalars['Float']['output']>;
  ptoInaccurateNote?: Maybe<Scalars['String']['output']>;
  ptoInfo?: Maybe<PtoInfo>;
  reason?: Maybe<Scalars['String']['output']>;
  refundDate?: Maybe<Scalars['ISO8601Date']['output']>;
  refundPreference?: Maybe<Scalars['String']['output']>;
  reportedPtoTaken?: Maybe<Scalars['Float']['output']>;
  requestor: Actor;
  roeCode?: Maybe<Scalars['String']['output']>;
  secondaryCategory?: Maybe<OffboardingCategory>;
  serviceAgreementSignature?: Maybe<Scalars['ISO8601Date']['output']>;
  shouldRunCompletionActions: Scalars['Boolean']['output'];
  staffDepositNote?: Maybe<Scalars['String']['output']>;
  standardPerlWithSalaryAllowed?: Maybe<Scalars['Boolean']['output']>;
  state: TerminationState;
  teamMemberOwedCommission?: Maybe<Scalars['Boolean']['output']>;
  tmStepsTerminationHistories?: Maybe<Array<TerminationStepsHistory>>;
  tosAgreementGenerated?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};


export type TerminationAgreementsArgs = {
  states?: InputMaybe<Array<AgreementStateEnum>>;
};


export type TerminationAuditHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  only?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type TerminationDepositNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TerminationPayrollSpecialistNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of TerminationApproveCancellation */
export type TerminationApproveCancellationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of TerminationApproveCancellation. */
export type TerminationApproveCancellationPayload = {
  __typename?: 'TerminationApproveCancellationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

/** Autogenerated input type of TerminationApprove */
export type TerminationApproveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of TerminationApprove. */
export type TerminationApprovePayload = {
  __typename?: 'TerminationApprovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

/** Autogenerated input type of TerminationCancel */
export type TerminationCancelInput = {
  cancelReason: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of TerminationCancel. */
export type TerminationCancelPayload = {
  __typename?: 'TerminationCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

export type TerminationCollection = {
  __typename?: 'TerminationCollection';
  collection: Array<Termination>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of TerminationCreate */
export type TerminationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commissionDetails?: InputMaybe<Scalars['String']['input']>;
  communicatedWithEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  earlyOffboardingReason?: InputMaybe<Scalars['String']['input']>;
  earlyOffboardingRequested?: InputMaybe<Scalars['Boolean']['input']>;
  engagementId: Scalars['ID']['input'];
  intendedDaysOff?: InputMaybe<Scalars['Float']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onLeave?: InputMaybe<Scalars['Boolean']['input']>;
  primaryCategoryId?: InputMaybe<Scalars['ID']['input']>;
  proposedDate: Scalars['ISO8601Date']['input'];
  ptoInaccurateNote?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  secondaryCategoryId?: InputMaybe<Scalars['ID']['input']>;
  signedDocumentId?: InputMaybe<Scalars['String']['input']>;
  teamMemberOwedCommission?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of TerminationCreate. */
export type TerminationCreatePayload = {
  __typename?: 'TerminationCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

/** Autogenerated input type of TerminationDestroy */
export type TerminationDestroyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of TerminationDestroy. */
export type TerminationDestroyPayload = {
  __typename?: 'TerminationDestroyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

export type TerminationInput = {
  additionalConsiderationAmount?: InputMaybe<Scalars['Float']['input']>;
  additionalConsiderationAmountToBeConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  additionalConsiderationCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  additionalNotesForDepositTeam?: InputMaybe<Scalars['Boolean']['input']>;
  approve?: InputMaybe<Scalars['Boolean']['input']>;
  mutualTermination?: InputMaybe<Scalars['Boolean']['input']>;
  serviceAgreementSignature?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  staffDepositNote?: InputMaybe<Scalars['String']['input']>;
  termination?: InputMaybe<Scalars['ID']['input']>;
};

export enum TerminationPaidInFullStatusType {
  NotStarted = 'NOT_STARTED',
  PaidInFull = 'PAID_IN_FULL',
  PendingPayment = 'PENDING_PAYMENT'
}

/** Termination specific rules and constants */
export type TerminationRules = {
  __typename?: 'TerminationRules';
  defaultNoticePeriod: Scalars['Int']['output'];
  payrollCutOffDatetime: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of TerminationRunCompletionActions */
export type TerminationRunCompletionActionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of TerminationRunCompletionActions. */
export type TerminationRunCompletionActionsPayload = {
  __typename?: 'TerminationRunCompletionActionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination: Termination;
};

export enum TerminationState {
  Approved = 'APPROVED',
  CancellationRequested = 'CANCELLATION_REQUESTED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Initiated = 'INITIATED',
  Terminated = 'TERMINATED'
}

export type TerminationStepsHistory = {
  __typename?: 'TerminationStepsHistory';
  changedFrom?: Maybe<OffboardingStep>;
  changedTo?: Maybe<OffboardingStep>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  whodunnit: User;
};

/** Autogenerated input type of TerminationUpdate */
export type TerminationUpdateInput = {
  additionalConsiderationAmount?: InputMaybe<Scalars['Float']['input']>;
  additionalConsiderationAmountToBeConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  additionalConsiderationCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  additionalNotesForDepositTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commissionDetails?: InputMaybe<Scalars['String']['input']>;
  communicatedWithEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  earlyOffboardingReason?: InputMaybe<Scalars['String']['input']>;
  earlyOffboardingRequested?: InputMaybe<Scalars['Boolean']['input']>;
  intendedDaysOff?: InputMaybe<Scalars['Float']['input']>;
  lastDayOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lastWorkingDay?: InputMaybe<Scalars['ISO8601Date']['input']>;
  mutualTermination?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  noticeAttributes?: InputMaybe<EmploymentNoticeInput>;
  notifyCustomerAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  onLeave?: InputMaybe<Scalars['Boolean']['input']>;
  paidInFullCheckDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  primaryCategoryId?: InputMaybe<Scalars['ID']['input']>;
  proposedDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  ptoAccurate?: InputMaybe<Scalars['Boolean']['input']>;
  ptoInaccurateNote?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  secondaryCategoryId?: InputMaybe<Scalars['ID']['input']>;
  serviceAgreementSignature?: InputMaybe<Scalars['ISO8601Date']['input']>;
  severanceAttributes?: InputMaybe<EmploymentSeveranceInput>;
  staffDepositNote?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<TerminationState>;
  teamMemberOwedCommission?: InputMaybe<Scalars['Boolean']['input']>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of TerminationUpdate. */
export type TerminationUpdatePayload = {
  __typename?: 'TerminationUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export type TerminationUser = {
  __typename?: 'TerminationUser';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isOysterStaff: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type TextTranslation = {
  __typename?: 'TextTranslation';
  logIds: Array<Scalars['ID']['output']>;
  translatedText: Scalars['String']['output'];
};

export type TextTranslationMetadataInput = {
  actorId: Scalars['ID']['input'];
  fieldName?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['ID']['input']>;
};

export type ThemeInput = {
  accentBase: Scalars['String']['input'];
  accentLighten100: Scalars['String']['input'];
  primaryBase: Scalars['String']['input'];
  primaryDarken100: Scalars['String']['input'];
  primaryLighten50: Scalars['String']['input'];
  primaryLighten100: Scalars['String']['input'];
};

export type TimeOff = {
  __typename?: 'TimeOff';
  amount: Scalars['Iso8601Duration']['output'];
  reason: Scalars['String']['output'];
  timeOffType: Scalars['String']['output'];
};

export type TimeOffHoliday = {
  __typename?: 'TimeOffHoliday';
  countryCode: CountryIsoCode;
  date: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  modifiedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  subdivisionCode?: Maybe<Scalars['String']['output']>;
  subdivisionName?: Maybe<Scalars['String']['output']>;
  weekday: Scalars['Int']['output'];
};

export type TimeOffHolidayCollection = {
  __typename?: 'TimeOffHolidayCollection';
  collection: Array<TimeOffHoliday>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of TimeOffHolidayCreate */
export type TimeOffHolidayCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  date: Scalars['ISO8601Date']['input'];
  holidayName: Scalars['String']['input'];
  regionCode?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

/** Autogenerated return type of TimeOffHolidayCreate. */
export type TimeOffHolidayCreatePayload = {
  __typename?: 'TimeOffHolidayCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeOffHoliday?: Maybe<TimeOffHoliday>;
};

/** Autogenerated input type of TimeOffHolidayDelete */
export type TimeOffHolidayDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  holidayId: Scalars['ID']['input'];
};

/** Autogenerated return type of TimeOffHolidayDelete. */
export type TimeOffHolidayDeletePayload = {
  __typename?: 'TimeOffHolidayDeletePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  holiday: TimeOffHoliday;
};

/** Autogenerated input type of TimeOffHolidayUpdate */
export type TimeOffHolidayUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['ISO8601Date']['input'];
  holidayId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Autogenerated return type of TimeOffHolidayUpdate. */
export type TimeOffHolidayUpdatePayload = {
  __typename?: 'TimeOffHolidayUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeOffHoliday: TimeOffHoliday;
};

export type TimeOffMapping = {
  __typename?: 'TimeOffMapping';
  customSubtype?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mergeIntegrationId?: Maybe<Scalars['String']['output']>;
  oysterRequestType?: Maybe<Scalars['String']['output']>;
  remoteRequestType?: Maybe<Scalars['String']['output']>;
};

export type TimeOffMappings = {
  __typename?: 'TimeOffMappings';
  otherPaidBereavement?: Maybe<Array<Scalars['String']['output']>>;
  otherPaidCaregiverLeave?: Maybe<Array<Scalars['String']['output']>>;
  otherPaidCivicDuties?: Maybe<Array<Scalars['String']['output']>>;
  otherPaidEducationalLeave?: Maybe<Array<Scalars['String']['output']>>;
  otherPaidLocalHoliday?: Maybe<Array<Scalars['String']['output']>>;
  otherPaidMarriageLeave?: Maybe<Array<Scalars['String']['output']>>;
  otherPaidMilitaryMedicalExamination?: Maybe<Array<Scalars['String']['output']>>;
  otherPaidMilitaryPaidLeave?: Maybe<Array<Scalars['String']['output']>>;
  otherPaidMilitaryTrainingAssembly?: Maybe<Array<Scalars['String']['output']>>;
  otherPaidParentalLeave?: Maybe<Array<Scalars['String']['output']>>;
  otherPaidSabbatical?: Maybe<Array<Scalars['String']['output']>>;
  otherPaidTimeOffInLieu?: Maybe<Array<Scalars['String']['output']>>;
  sickLeavePaid?: Maybe<Array<Scalars['String']['output']>>;
  sickLeaveUnpaid?: Maybe<Array<Scalars['String']['output']>>;
  unmapped?: Maybe<Array<Scalars['String']['output']>>;
  unpaidLeaveBereavement?: Maybe<Array<Scalars['String']['output']>>;
  unpaidLeaveCaregiverLeave?: Maybe<Array<Scalars['String']['output']>>;
  unpaidLeaveCivicDuties?: Maybe<Array<Scalars['String']['output']>>;
  unpaidLeaveEducationalLeave?: Maybe<Array<Scalars['String']['output']>>;
  unpaidLeaveMarriageLeave?: Maybe<Array<Scalars['String']['output']>>;
  unpaidLeaveMilitaryMedicalExamination?: Maybe<Array<Scalars['String']['output']>>;
  unpaidLeaveMilitaryTrainingAssembly?: Maybe<Array<Scalars['String']['output']>>;
  unpaidLeaveMilitaryUnpaidLeave?: Maybe<Array<Scalars['String']['output']>>;
  unpaidLeaveParentalLeave?: Maybe<Array<Scalars['String']['output']>>;
  unpaidLeaveReligiousObservance?: Maybe<Array<Scalars['String']['output']>>;
  unpaidLeaveSabbatical?: Maybe<Array<Scalars['String']['output']>>;
  vacation?: Maybe<Array<Scalars['String']['output']>>;
};

export type TimeOffMappingsInput = {
  otherPaidBereavement: Array<Scalars['String']['input']>;
  otherPaidCaregiverLeave: Array<Scalars['String']['input']>;
  otherPaidCivicDuties: Array<Scalars['String']['input']>;
  otherPaidEducationalLeave: Array<Scalars['String']['input']>;
  otherPaidLocalHoliday: Array<Scalars['String']['input']>;
  otherPaidMarriageLeave: Array<Scalars['String']['input']>;
  otherPaidMilitaryMedicalExamination: Array<Scalars['String']['input']>;
  otherPaidMilitaryPaidLeave: Array<Scalars['String']['input']>;
  otherPaidMilitaryTrainingAssembly: Array<Scalars['String']['input']>;
  otherPaidParentalLeave: Array<Scalars['String']['input']>;
  otherPaidSabbatical: Array<Scalars['String']['input']>;
  otherPaidTimeOffInLieu: Array<Scalars['String']['input']>;
  sickLeavePaid: Array<Scalars['String']['input']>;
  sickLeaveUnpaid: Array<Scalars['String']['input']>;
  unpaidLeaveBereavement: Array<Scalars['String']['input']>;
  unpaidLeaveCaregiverLeave: Array<Scalars['String']['input']>;
  unpaidLeaveCivicDuties: Array<Scalars['String']['input']>;
  unpaidLeaveEducationalLeave: Array<Scalars['String']['input']>;
  unpaidLeaveMarriageLeave: Array<Scalars['String']['input']>;
  unpaidLeaveMilitaryMedicalExamination: Array<Scalars['String']['input']>;
  unpaidLeaveMilitaryTrainingAssembly: Array<Scalars['String']['input']>;
  unpaidLeaveMilitaryUnpaidLeave: Array<Scalars['String']['input']>;
  unpaidLeaveParentalLeave: Array<Scalars['String']['input']>;
  unpaidLeaveReligiousObservance: Array<Scalars['String']['input']>;
  unpaidLeaveSabbatical: Array<Scalars['String']['input']>;
  vacation: Array<Scalars['String']['input']>;
};

export type TimeOffRequest = {
  __typename?: 'TimeOffRequest';
  additionalFiles?: Maybe<Array<DownloadLink>>;
  approvedOrRejectedBy?: Maybe<Scalars['String']['output']>;
  approvedOrRejectedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  availableActions: Array<TimeOffRequestAvailableActionEnumType>;
  customReason?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['ISO8601Date']['output'];
  endDateTimePeriod?: Maybe<Scalars['String']['output']>;
  engagement: Engagement;
  file?: Maybe<DownloadLink>;
  id: Scalars['ID']['output'];
  mergeConnection?: Maybe<MergeConnection>;
  periodInDays: Scalars['Float']['output'];
  periodInDaysForAccrualCycle: Scalars['Float']['output'];
  periodInHours: Scalars['Float']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  requesterComments?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['ISO8601Date']['output'];
  startDateTimePeriod?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  submittedOn: Scalars['ISO8601Date']['output'];
  timeOffType: Scalars['String']['output'];
};


export type TimeOffRequestPeriodInDaysForAccrualCycleArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  startDate: Scalars['ISO8601Date']['input'];
};

/** Autogenerated input type of TimeOffRequestApprove */
export type TimeOffRequestApproveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  timeOffRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of TimeOffRequestApprove. */
export type TimeOffRequestApprovePayload = {
  __typename?: 'TimeOffRequestApprovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeOffRequest?: Maybe<TimeOffRequest>;
};

export enum TimeOffRequestAvailableActionEnumType {
  Approve = 'APPROVE',
  Cancel = 'CANCEL',
  Reject = 'REJECT'
}

/** Autogenerated input type of TimeOffRequestCancel */
export type TimeOffRequestCancelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  timeOffRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of TimeOffRequestCancel. */
export type TimeOffRequestCancelPayload = {
  __typename?: 'TimeOffRequestCancelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeOffRequest: TimeOffRequest;
};

export type TimeOffRequestCollection = {
  __typename?: 'TimeOffRequestCollection';
  collection: Array<TimeOffRequest>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of TimeOffRequestCreate */
export type TimeOffRequestCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['ISO8601DateTime']['input'];
  endDateHours?: InputMaybe<Scalars['Int']['input']>;
  endDateTimePeriod?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  requesterComments?: InputMaybe<Scalars['String']['input']>;
  signedDocumentId?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['ISO8601DateTime']['input'];
  startDateHours?: InputMaybe<Scalars['Int']['input']>;
  startDateTimePeriod?: InputMaybe<Scalars['String']['input']>;
  timeOffType: TimeOffTypeEnum;
};

/** Autogenerated return type of TimeOffRequestCreate. */
export type TimeOffRequestCreatePayload = {
  __typename?: 'TimeOffRequestCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeOffRequest?: Maybe<TimeOffRequest>;
};

/** Autogenerated input type of TimeOffRequestReject */
export type TimeOffRequestRejectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  timeOffRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of TimeOffRequestReject. */
export type TimeOffRequestRejectPayload = {
  __typename?: 'TimeOffRequestRejectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeOffRequest: TimeOffRequest;
};

export enum TimeOffRequestStateEnumType {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  Taken = 'TAKEN'
}

/** Autogenerated input type of TimeOffRequestUpdateAttachment */
export type TimeOffRequestUpdateAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  signedDocumentId?: InputMaybe<Scalars['String']['input']>;
  timeOffRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of TimeOffRequestUpdateAttachment. */
export type TimeOffRequestUpdateAttachmentPayload = {
  __typename?: 'TimeOffRequestUpdateAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeOffRequest: TimeOffRequest;
};

export type TimeOffStat = {
  __typename?: 'TimeOffStat';
  endDate: Scalars['ISO8601Date']['output'];
  requestType: TimeOffTypeEnum;
  startDate: Scalars['ISO8601Date']['output'];
  total: Scalars['Int']['output'];
};

export type TimeOffSummary = {
  __typename?: 'TimeOffSummary';
  totalHoursOff: Scalars['Int']['output'];
  totalNationalHolidays: Scalars['Float']['output'];
  totalWeekendDays: Scalars['Float']['output'];
};

export type TimeOffTransaction = {
  __typename?: 'TimeOffTransaction';
  amountDays: Scalars['Float']['output'];
  amountHours?: Maybe<Scalars['Float']['output']>;
  availableFromDate?: Maybe<Scalars['ISO8601Date']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  date: Scalars['ISO8601Date']['output'];
  expiresAt?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  oysterCreated?: Maybe<Scalars['Boolean']['output']>;
  reason: TimeOffTransactionReasonEnumType;
  timeOffRequest?: Maybe<TimeOffRequest>;
};

export type TimeOffTransactionCollection = {
  __typename?: 'TimeOffTransactionCollection';
  collection: Array<TimeOffTransaction>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of TimeOffTransactionCreateEntitlementAdjustment */
export type TimeOffTransactionCreateEntitlementAdjustmentInput = {
  amountDays: Scalars['Float']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  expirationPeriod?: InputMaybe<Scalars['Int']['input']>;
  note: Scalars['String']['input'];
  reason: TimeOffTransactionReasonEnumType;
};

/** Autogenerated return type of TimeOffTransactionCreateEntitlementAdjustment. */
export type TimeOffTransactionCreateEntitlementAdjustmentPayload = {
  __typename?: 'TimeOffTransactionCreateEntitlementAdjustmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entitlementAdjustment?: Maybe<EntitlementAdjustment>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of TimeOffTransactionCreate */
export type TimeOffTransactionCreateInput = {
  amountDays: Scalars['Float']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: TimeOffTransactionReasonEnumType;
};

/** Autogenerated return type of TimeOffTransactionCreate. */
export type TimeOffTransactionCreatePayload = {
  __typename?: 'TimeOffTransactionCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeOffTransaction?: Maybe<TimeOffTransaction>;
};

export enum TimeOffTransactionReasonEnumType {
  Accrual = 'ACCRUAL',
  AccrualPrevious = 'ACCRUAL_PREVIOUS',
  AccrualPreviousExpired = 'ACCRUAL_PREVIOUS_EXPIRED',
  Adhoc = 'ADHOC',
  Rollover = 'ROLLOVER',
  RolloverExpired = 'ROLLOVER_EXPIRED',
  TimeOff = 'TIME_OFF'
}

export enum TimeOffTypeEnum {
  Other = 'OTHER',
  SickLeave = 'SICK_LEAVE',
  Unmapped = 'UNMAPPED',
  UnpaidLeave = 'UNPAID_LEAVE',
  Vacation = 'VACATION'
}

export type TimeSheet = {
  __typename?: 'TimeSheet';
  amendmentTimeSheet?: Maybe<TimeSheet>;
  availableTimeTrackingEntryTypes: Array<TimeSheetEntryTypeEnum>;
  confirmedBy?: Maybe<TimeSheetConfirmedByEnum>;
  createdBy: TimeSheetCreatedByEnum;
  engagement: Engagement;
  flexibleWorkArrangement: Scalars['Boolean']['output'];
  hasAmendmentTimeSheet: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAmendment: Scalars['Boolean']['output'];
  locked: Scalars['Boolean']['output'];
  mergedTimeOffs: MergedTimeOffCollection;
  nightHoursWorked: Scalars['Iso8601Duration']['output'];
  onCallActiveHours: Scalars['Iso8601Duration']['output'];
  onCallPassiveHours: Scalars['Iso8601Duration']['output'];
  originalTimeSheetId?: Maybe<Scalars['ID']['output']>;
  overtime: Scalars['Iso8601Duration']['output'];
  regularHours: Scalars['Iso8601Duration']['output'];
  standbyHours: Scalars['Iso8601Duration']['output'];
  stateReason?: Maybe<TimeSheetStateReasonEnum>;
  status: TimeSheetStatusEnum;
  submittedBy?: Maybe<TimeSheetSubmittedByEnum>;
  timeOff: Scalars['Iso8601Duration']['output'];
  timePeriod: Scalars['ISO8601Date']['output'];
  totalHoursNotWorked: Scalars['Iso8601Duration']['output'];
  totalHoursWorked: Scalars['Iso8601Duration']['output'];
  totalHoursWorkedOnHolidays: Scalars['Iso8601Duration']['output'];
  totalHoursWorkedOnWeekdays: Scalars['Iso8601Duration']['output'];
  totalHoursWorkedOnWeekends: Scalars['Iso8601Duration']['output'];
};


export type TimeSheetMergedTimeOffsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeSheetCollection = {
  __typename?: 'TimeSheetCollection';
  collection: Array<TimeSheet>;
  metadata: CollectionMetadata;
};

export enum TimeSheetConfirmedByEnum {
  Admin = 'admin',
  Automation = 'automation'
}

export enum TimeSheetCreatedByEnum {
  Automation = 'automation',
  OysterStaff = 'oyster_staff',
  TeamMember = 'team_member'
}

export type TimeSheetEntriesGroupedByDate = {
  __typename?: 'TimeSheetEntriesGroupedByDate';
  date: Scalars['ISO8601Date']['output'];
  entries: Array<TimeSheetEntry>;
  id: Scalars['ID']['output'];
  timeOffSpan?: Maybe<TimeSheetEntryTimeOffSpan>;
  timeOffs: Array<TimeOff>;
};

export type TimeSheetEntry = {
  __typename?: 'TimeSheetEntry';
  breakIntervalDuration?: Maybe<Scalars['Iso8601Duration']['output']>;
  breakIntervalFrom?: Maybe<Scalars['TimeWithoutSecondsAndTz']['output']>;
  breakIntervalTo?: Maybe<Scalars['TimeWithoutSecondsAndTz']['output']>;
  date: Scalars['ISO8601Date']['output'];
  duration: Scalars['Iso8601Duration']['output'];
  from?: Maybe<Scalars['TimeWithoutSecondsAndTz']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['TimeWithoutSecondsAndTz']['output']>;
  type: TimeSheetEntryTypeEnum;
  workDuration: Scalars['Iso8601Duration']['output'];
};

export type TimeSheetEntryInput = {
  _destroy?: InputMaybe<Scalars['Boolean']['input']>;
  breakIntervalFrom?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
  breakIntervalTo?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
  from?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
  type?: InputMaybe<TimeSheetEntryTypeEnum>;
};

export enum TimeSheetEntryTimeOffSpan {
  FullDay = 'full_day',
  HalfDay = 'half_day'
}

export enum TimeSheetEntryTypeEnum {
  NightWork = 'NIGHT_WORK',
  OnCall = 'ON_CALL',
  OnCallActive = 'ON_CALL_ACTIVE',
  OnCallPassive = 'ON_CALL_PASSIVE',
  Overtime = 'OVERTIME',
  Regular = 'REGULAR',
  TimeOff = 'TIME_OFF'
}

/** Autogenerated input type of TimeSheetReportCreate */
export type TimeSheetReportCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  combinedStatuses?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  employersOfRecordIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employmentTypes?: InputMaybe<Scalars['String']['input']>;
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  requestOriginatedFrom: Scalars['String']['input'];
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
  timeSheetCreation?: InputMaybe<Scalars['String']['input']>;
  timeSheetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeSheetType?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of TimeSheetReportCreate. */
export type TimeSheetReportCreatePayload = {
  __typename?: 'TimeSheetReportCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export enum TimeSheetStateReasonEnum {
  StaffCreate = 'staff_create',
  StaffUpdate = 'staff_update'
}

export enum TimeSheetStatusEnum {
  Approved = 'APPROVED',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export enum TimeSheetSubmittedByEnum {
  Automation = 'automation',
  OysterStaff = 'oyster_staff',
  TeamMember = 'team_member'
}

export type TimeSheetWorkSchedule = {
  __typename?: 'TimeSheetWorkSchedule';
  collection: Array<TimeSheetWorkScheduleItem>;
  regularBreaks: Scalars['Boolean']['output'];
};

export type TimeSheetWorkScheduleItem = {
  __typename?: 'TimeSheetWorkScheduleItem';
  breakIntervalFrom?: Maybe<Scalars['ISO8601DateTime']['output']>;
  breakIntervalTo?: Maybe<Scalars['ISO8601DateTime']['output']>;
  day: WeekDaysEnum;
  from: Scalars['ISO8601DateTime']['output'];
  to: Scalars['ISO8601DateTime']['output'];
  type?: Maybe<TimeSheetEntryTypeEnum>;
};

export type TimeSheetYearMonth = {
  __typename?: 'TimeSheetYearMonth';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type TimeSheetYearMonthCollection = {
  __typename?: 'TimeSheetYearMonthCollection';
  collection: Array<TimeSheetYearMonth>;
  metadata: CollectionMetadata;
};

export enum TimeTrackingToolOverrideEnum {
  Default = 'DEFAULT',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type TimeZone = {
  __typename?: 'TimeZone';
  /** Standard time zone name (e.g. America/Los_Angeles) */
  identifier?: Maybe<Scalars['String']['output']>;
  /** UTC offset for timezone in minutes */
  utcOffset?: Maybe<Scalars['Int']['output']>;
};

export type TmsCount = {
  __typename?: 'TmsCount';
  byCountryCodes: Array<TmsCountCountryCode>;
  byEngagementTypes: Array<TmsCountEngagementType>;
};

export type TmsCountCountryCode = {
  __typename?: 'TmsCountCountryCode';
  count: Scalars['Int']['output'];
  countryCode: Scalars['String']['output'];
};

export type TmsCountEngagementType = {
  __typename?: 'TmsCountEngagementType';
  count: Scalars['Int']['output'];
  engagementType: Scalars['String']['output'];
};

export enum TodoTasksParty {
  ClientRepresentative = 'CLIENT_REPRESENTATIVE',
  Employee = 'EMPLOYEE',
  Employer = 'EMPLOYER',
  OysterStaff = 'OYSTER_STAFF'
}

export type TodoTasksTask = {
  __typename?: 'TodoTasksTask';
  category: TodoTasksTaskCategory;
  checkAvailableFor: Array<TodoTasksParty>;
  completedAt?: Maybe<Scalars['ISO8601Date']['output']>;
  completedBy?: Maybe<Actor>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parties: Array<TodoTasksParty>;
  position: Scalars['Int']['output'];
  state: TodoTasksTaskState;
  visibleTo: Array<TodoTasksParty>;
};

export enum TodoTasksTaskCategory {
  AdditionalTask = 'ADDITIONAL_TASK',
  AgreementTask = 'AGREEMENT_TASK',
  CompanyAdminTask = 'COMPANY_ADMIN_TASK',
  OysterSafeTask = 'OYSTER_SAFE_TASK',
  PrepaidTask = 'PREPAID_TASK',
  Settings = 'SETTINGS',
  TeamMemberTask = 'TEAM_MEMBER_TASK'
}

export enum TodoTasksTaskState {
  Blocked = 'BLOCKED',
  Completed = 'COMPLETED',
  Hidden = 'HIDDEN',
  Pending = 'PENDING'
}

/** Autogenerated input type of ToggleDepositBeforeLiability */
export type ToggleDepositBeforeLiabilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  depositBeforeLiability: Scalars['Boolean']['input'];
  engagementId: Scalars['ID']['input'];
};

/** Autogenerated return type of ToggleDepositBeforeLiability. */
export type ToggleDepositBeforeLiabilityPayload = {
  __typename?: 'ToggleDepositBeforeLiabilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of TogglePaymentMethod */
export type TogglePaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  disabledForContractors?: InputMaybe<Scalars['Boolean']['input']>;
  disabledForFtes?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

/** Autogenerated return type of TogglePaymentMethod. */
export type TogglePaymentMethodPayload = {
  __typename?: 'TogglePaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod: PaymentMethod;
};

/** Pair of tracking category and cost center IDs which will be associated with each other */
export type TrackingCategoryMappingInput = {
  costCenterId: Scalars['ID']['input'];
  trackingCategoryId: Scalars['ID']['input'];
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Float']['output'];
  amountCurrencyCode: Scalars['String']['output'];
  bankNumberLast4?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['String']['output'];
  invoiceName: Scalars['String']['output'];
  status: TransactionStatus;
};

export enum TransactionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Failed = 'FAILED',
  Initialized = 'INITIALIZED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

/** Autogenerated input type of TransitionDependentEnrollment */
export type TransitionDependentEnrollmentInput = {
  cancellationReason?: InputMaybe<BenefitsEnrollmentCancellationReasonEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverageEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dependentEnrollmentId: Scalars['ID']['input'];
  transitionEvent: BenefitsEnrollmentTransitionEventEnum;
};

/** Autogenerated return type of TransitionDependentEnrollment. */
export type TransitionDependentEnrollmentPayload = {
  __typename?: 'TransitionDependentEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dependentEnrollment?: Maybe<BenefitsDependentEnrollment>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of TransitionDependentEnrollmentToEnrolled */
export type TransitionDependentEnrollmentToEnrolledInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverageStartDate: Scalars['ISO8601Date']['input'];
  dependentEnrollmentId: Scalars['ID']['input'];
  employerContribution?: InputMaybe<MoneyInput>;
  pricePaidProvider: MoneyInput;
};

/** Autogenerated return type of TransitionDependentEnrollmentToEnrolled. */
export type TransitionDependentEnrollmentToEnrolledPayload = {
  __typename?: 'TransitionDependentEnrollmentToEnrolledPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dependentEnrollment?: Maybe<BenefitsDependentEnrollment>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of TransitionEmployment */
export type TransitionEmploymentInput = {
  changeReason?: InputMaybe<ChangeReasonPayloadInputType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employmentId?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  monetizationPlanId?: InputMaybe<Scalars['String']['input']>;
  signeeId?: InputMaybe<Scalars['String']['input']>;
  wantsToDiscuss?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of TransitionEmployment. */
export type TransitionEmploymentPayload = {
  __typename?: 'TransitionEmploymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  contract?: Maybe<Contract>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of TransitionEnrollment */
export type TransitionEnrollmentInput = {
  cancellationReason?: InputMaybe<BenefitsEnrollmentCancellationReasonEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverageEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  enrollmentId: Scalars['ID']['input'];
  transitionEvent: BenefitsEnrollmentTransitionEventEnum;
};

/** Autogenerated return type of TransitionEnrollment. */
export type TransitionEnrollmentPayload = {
  __typename?: 'TransitionEnrollmentPayload';
  benefitEnrollment?: Maybe<BenefitsEnrollment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of TransitionEnrollmentToEnrolled */
export type TransitionEnrollmentToEnrolledInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverageStartDate: Scalars['ISO8601Date']['input'];
  employerContribution?: InputMaybe<MoneyInput>;
  enrollmentId: Scalars['ID']['input'];
  pricePaidProvider: MoneyInput;
};

/** Autogenerated return type of TransitionEnrollmentToEnrolled. */
export type TransitionEnrollmentToEnrolledPayload = {
  __typename?: 'TransitionEnrollmentToEnrolledPayload';
  benefitsEnrollment?: Maybe<BenefitsEnrollment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of TransitionHiring */
export type TransitionHiringInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyStatusEvent?: InputMaybe<CompanyStatusTransitionEnum>;
  employeeStatusEvent?: InputMaybe<EmployeeStatusTransitionEnum>;
  hiringId: Scalars['ID']['input'];
};

/** Autogenerated return type of TransitionHiring. */
export type TransitionHiringPayload = {
  __typename?: 'TransitionHiringPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of TransitionInvoice */
export type TransitionInvoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  disputeReason?: InputMaybe<Scalars['String']['input']>;
  event: InvoiceTransitionEvent;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of TransitionInvoice. */
export type TransitionInvoicePayload = {
  __typename?: 'TransitionInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  invoice: Invoice;
};

/** Autogenerated input type of TransitionPaymentsGroupState */
export type TransitionPaymentsGroupStateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventTransition: PaymentsGroupStateEvent;
  paidAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  paymentsGroupId: Scalars['ID']['input'];
  wireSentAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Autogenerated return type of TransitionPaymentsGroupState. */
export type TransitionPaymentsGroupStatePayload = {
  __typename?: 'TransitionPaymentsGroupStatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentsGroup: PaymentsGroup;
};

/** Autogenerated input type of TransitionProvisionedEnrollment */
export type TransitionProvisionedEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  enrollmentId: Scalars['ID']['input'];
  transitionEvent: BenefitsProvisionedEnrollmentTransitionEventEnum;
};

/** Autogenerated return type of TransitionProvisionedEnrollment. */
export type TransitionProvisionedEnrollmentPayload = {
  __typename?: 'TransitionProvisionedEnrollmentPayload';
  benefitProvisionedEnrollment?: Maybe<BenefitsProvisionedEnrollment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

export enum TranslationsLanguageCodeEnum {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it',
  Pl = 'pl',
  Pt = 'pt',
  Ro = 'ro',
  Tr = 'tr'
}

/** Autogenerated input type of TriggerEngagementInvitationNotifications */
export type TriggerEngagementInvitationNotificationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of TriggerEngagementInvitationNotifications. */
export type TriggerEngagementInvitationNotificationsPayload = {
  __typename?: 'TriggerEngagementInvitationNotificationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of TriggerHiringTaskAction */
export type TriggerHiringTaskActionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hiringId: Scalars['ID']['input'];
  targetState: TodoTasksTaskState;
  taskName: Scalars['String']['input'];
};

/** Autogenerated return type of TriggerHiringTaskAction. */
export type TriggerHiringTaskActionPayload = {
  __typename?: 'TriggerHiringTaskActionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  hiring?: Maybe<Hiring>;
};

export enum TrustLevelEnum {
  AiGenerated = 'AI_GENERATED',
  Excellent = 'EXCELLENT',
  Fair = 'FAIR',
  Good = 'GOOD',
  None = 'NONE'
}

export enum TypesEngagementContractualResignationTypeEnum {
  FixedDuration = 'FIXED_DURATION',
  FollowStatutoryRules = 'FOLLOW_STATUTORY_RULES'
}

export enum TypesEngagementContractualTerminationTypeEnum {
  FixedDuration = 'FIXED_DURATION',
  FollowStatutoryRules = 'FOLLOW_STATUTORY_RULES'
}

/** Autogenerated input type of UnblockAutomatedPayments */
export type UnblockAutomatedPaymentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};

/** Autogenerated return type of UnblockAutomatedPayments. */
export type UnblockAutomatedPaymentsPayload = {
  __typename?: 'UnblockAutomatedPaymentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UninstallCarta */
export type UninstallCartaInput = {
  cartaIntegrationId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UninstallCarta. */
export type UninstallCartaPayload = {
  __typename?: 'UninstallCartaPayload';
  cartaIntegration?: Maybe<EquityCartaIntegration>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UnlockAmendmentTimeSheet */
export type UnlockAmendmentTimeSheetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  timeSheetId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlockAmendmentTimeSheet. */
export type UnlockAmendmentTimeSheetPayload = {
  __typename?: 'UnlockAmendmentTimeSheetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeSheet?: Maybe<TimeSheet>;
};

/** Autogenerated input type of Unsubscribe */
export type UnsubscribeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['String']['input'];
};

/** Autogenerated return type of Unsubscribe. */
export type UnsubscribePayload = {
  __typename?: 'UnsubscribePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAccountingBaseMappings */
export type UpdateAccountingBaseMappingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Oyster company identifier (only company admins or staff) */
  companyId: Scalars['ID']['input'];
  /** Account object reference (Accounting::AccountType.id). If null, will unset the credit account */
  creditAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Account object reference (Accounting::AccountType.id) */
  defaultAccountId: Scalars['ID']['input'];
  /** Codat platform key reference (e.g. quickbooksonline) */
  platform: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateAccountingBaseMappings. */
export type UpdateAccountingBaseMappingsPayload = {
  __typename?: 'UpdateAccountingBaseMappingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditAccount?: Maybe<AccountingAccountType>;
  defaultAccount?: Maybe<AccountingAccountType>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAdditionalAgreementsAfterSubmission */
export type UpdateAdditionalAgreementsAfterSubmissionInput = {
  actorParty: AgreementPartyTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Time at which the action to edit the form was started. */
  editActionStartTime: Scalars['ISO8601DateTime']['input'];
  employmentId: Scalars['ID']['input'];
  hiringId: Scalars['ID']['input'];
  restrictiveCovenantsAttributes?: InputMaybe<RestrictiveCovenantsInput>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateAdditionalAgreementsAfterSubmission. */
export type UpdateAdditionalAgreementsAfterSubmissionPayload = {
  __typename?: 'UpdateAdditionalAgreementsAfterSubmissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<FormFieldError>>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of UpdateAgreementEnvelope */
export type UpdateAgreementEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  envelopeType: EnvelopeTypeEnum;
  hiringId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateAgreementEnvelope. */
export type UpdateAgreementEnvelopePayload = {
  __typename?: 'UpdateAgreementEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of UpdateBenefitsAfterSubmission */
export type UpdateBenefitsAfterSubmissionInput = {
  actorParty: AgreementPartyTypeEnum;
  benefitsProvisionedEnrollmentAttributes?: InputMaybe<EmployerBenefitEnrollmentInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Time at which the action to edit the form was started. */
  editActionStartTime: Scalars['ISO8601DateTime']['input'];
  employmentId: Scalars['ID']['input'];
  hiringId: Scalars['ID']['input'];
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateBenefitsAfterSubmission. */
export type UpdateBenefitsAfterSubmissionPayload = {
  __typename?: 'UpdateBenefitsAfterSubmissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<FormFieldError>>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of UpdateBulkEngagementChangeEntry */
export type UpdateBulkEngagementChangeEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryId: Scalars['ID']['input'];
  entryInput: BulkEngagementChangeEntryInput;
};

/** Autogenerated return type of UpdateBulkEngagementChangeEntry. */
export type UpdateBulkEngagementChangeEntryPayload = {
  __typename?: 'UpdateBulkEngagementChangeEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<BulkEngagementChangeEntry>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateBulkEngagementChange */
export type UpdateBulkEngagementChangeInput = {
  bulkEngagementChangeId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entriesInput: Array<BulkEngagementChangeEntryInput>;
};

/** Autogenerated return type of UpdateBulkEngagementChange. */
export type UpdateBulkEngagementChangePayload = {
  __typename?: 'UpdateBulkEngagementChangePayload';
  bulkEngagementChange?: Maybe<BulkEngagementChange>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCarryoverAmountLimitation */
export type UpdateCarryoverAmountLimitationInput = {
  carryoverAmountLimitationPolicy: CarryoverAmountLimitationPolicyEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  maxCarryoverDays?: InputMaybe<Scalars['Int']['input']>;
  maxDaysByCoefficientOfPaidHolidayDays?: InputMaybe<Scalars['Int']['input']>;
  minDaysToUse?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateCarryoverAmountLimitation. */
export type UpdateCarryoverAmountLimitationPayload = {
  __typename?: 'UpdateCarryoverAmountLimitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCarryoverExpirationPeriod */
export type UpdateCarryoverExpirationPeriodInput = {
  carryoverExpirationPeriodPolicy: CarryoverExpirationPeriodPolicyEnum;
  carryoverExpiringPeriodInMonthsAdjustment?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCarryoverExpirationPeriod. */
export type UpdateCarryoverExpirationPeriodPayload = {
  __typename?: 'UpdateCarryoverExpirationPeriodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCompanyPlan */
export type UpdateCompanyPlanInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonJobTitle?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  equityManagementSoftwareName?: InputMaybe<Array<Scalars['String']['input']>>;
  equityPlanId: Scalars['ID']['input'];
  grantorName?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  vestingCliffMonths?: InputMaybe<Scalars['Int']['input']>;
  vestingCliffShares?: InputMaybe<Scalars['Float']['input']>;
  vestingScheduleMonths?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateCompanyPlan. */
export type UpdateCompanyPlanPayload = {
  __typename?: 'UpdateCompanyPlanPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityPlan: EquityCompanyPlan;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCompanySettings */
export type UpdateCompanySettingsInput = {
  applyCreditNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  depositBeforeLiability?: InputMaybe<Scalars['Boolean']['input']>;
  depositInvoicePaymentTerm?: InputMaybe<Scalars['Int']['input']>;
  depositInvoiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  globalPayrollPaymentTerm?: InputMaybe<Scalars['Int']['input']>;
  invoicePaymentTerm?: InputMaybe<Scalars['Int']['input']>;
  monthsOfDeposit?: InputMaybe<Scalars['Float']['input']>;
  overrideEmployeeDepositMonth?: InputMaybe<Scalars['Boolean']['input']>;
  platformPlansPaymentTerm?: InputMaybe<Scalars['Int']['input']>;
  salaryInsightsPaymentTerm?: InputMaybe<Scalars['Int']['input']>;
  scalePaymentTerm?: InputMaybe<Scalars['Int']['input']>;
  settlementPaymentTermsDay?: InputMaybe<Scalars['Int']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCompanySettings. */
export type UpdateCompanySettingsPayload = {
  __typename?: 'UpdateCompanySettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCompensationAfterSubmission */
export type UpdateCompensationAfterSubmissionInput = {
  actorParty: AgreementPartyTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commissionPlanAttributes?: InputMaybe<EmployerCommissionPlanInput>;
  /** Time at which the action to edit the form was started. */
  editActionStartTime: Scalars['ISO8601DateTime']['input'];
  employmentId: Scalars['ID']['input'];
  engagementAttributes?: InputMaybe<EmployerEmploymentInput>;
  hiringId: Scalars['ID']['input'];
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateCompensationAfterSubmission. */
export type UpdateCompensationAfterSubmissionPayload = {
  __typename?: 'UpdateCompensationAfterSubmissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<FormFieldError>>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of UpdateComplianceCheckerMappings */
export type UpdateComplianceCheckerMappingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  updateMappingsInput: Array<ComplianceCheckerUpdateIntegrationMappingsInput>;
};

/** Autogenerated return type of UpdateComplianceCheckerMappings. */
export type UpdateComplianceCheckerMappingsPayload = {
  __typename?: 'UpdateComplianceCheckerMappingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  complianceCheckerIntegrationMappings?: Maybe<Array<ComplianceCheckerIntegrationMapping>>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateContract */
export type UpdateContractInput = {
  additionalTerms?: InputMaybe<Scalars['String']['input']>;
  allowedToSubmitExpenses?: InputMaybe<Scalars['Boolean']['input']>;
  assuredContractor?: InputMaybe<Scalars['Boolean']['input']>;
  billingType?: InputMaybe<ContractBilling>;
  birthSex?: InputMaybe<ContractBirthSex>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commissionFileSignedId?: InputMaybe<Scalars['String']['input']>;
  companyAddress?: InputMaybe<AddressArguments>;
  companyContactName?: InputMaybe<Scalars['String']['input']>;
  companyKind?: InputMaybe<ContractCompanyKind>;
  companyLegalName?: InputMaybe<Scalars['String']['input']>;
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  companyVatReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  contractorKind?: InputMaybe<ContractContractorKind>;
  customerProvidedCountryCode?: InputMaybe<Scalars['String']['input']>;
  daysOfNotice?: InputMaybe<Scalars['Int']['input']>;
  daysToCure?: InputMaybe<Scalars['Int']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expenseLimit?: InputMaybe<Scalars['Float']['input']>;
  expenseLimitCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstPayment?: InputMaybe<Scalars['Float']['input']>;
  firstPaymentCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  individualAddress?: InputMaybe<AddressArguments>;
  individualCitizenshipCountryCode?: InputMaybe<Scalars['String']['input']>;
  individualDateOfBirth?: InputMaybe<Scalars['ISO8601Date']['input']>;
  individualIdDocumentNumber?: InputMaybe<Scalars['String']['input']>;
  individualTaxResidenceCountryCode?: InputMaybe<Scalars['String']['input']>;
  invoiceDefaultTaxRate?: InputMaybe<Scalars['Float']['input']>;
  ipClause?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastPayment?: InputMaybe<Scalars['Float']['input']>;
  lastPaymentCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherServiceType?: InputMaybe<Scalars['String']['input']>;
  ownContractFileSignedId?: InputMaybe<Scalars['String']['input']>;
  oysterSafeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  paygBillingType?: InputMaybe<ContractPaygBilling>;
  paymentFrequency?: InputMaybe<ContractPaymentFrequency>;
  paymentStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preexistingInventions?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Float']['input']>;
  rateCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  rateUnit?: InputMaybe<ContractRateUnit>;
  role?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Float']['input']>;
  salaryCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  scopeOfWork?: InputMaybe<Scalars['String']['input']>;
  serviceEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
  supervisorEmail?: InputMaybe<Scalars['String']['input']>;
  supervisorName?: InputMaybe<Scalars['String']['input']>;
  taxIdNumber?: InputMaybe<Scalars['String']['input']>;
  useOysterTemplate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateContract. */
export type UpdateContractPayload = {
  __typename?: 'UpdateContractPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateContractTaxResidencyInfo */
export type UpdateContractTaxResidencyInfoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['String']['input'];
  effectiveDateOfTaxResidency?: InputMaybe<Scalars['ISO8601Date']['input']>;
  individualTaxResidenceCountryCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateContractTaxResidencyInfo. */
export type UpdateContractTaxResidencyInfoPayload = {
  __typename?: 'UpdateContractTaxResidencyInfoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateContractWorkEmailAddress */
export type UpdateContractWorkEmailAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  workEmail: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateContractWorkEmailAddress. */
export type UpdateContractWorkEmailAddressPayload = {
  __typename?: 'UpdateContractWorkEmailAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateContractorInvoice */
export type UpdateContractorInvoiceInput = {
  amountCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  invoiceDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  invoiceId: Scalars['ID']['input'];
  lineItems?: InputMaybe<Array<InvoiceLineItemInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentPeriodEndDate: Scalars['ISO8601Date']['input'];
  paymentPeriodStartDate: Scalars['ISO8601Date']['input'];
  taxRate?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of UpdateContractorInvoice. */
export type UpdateContractorInvoicePayload = {
  __typename?: 'UpdateContractorInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  invoice?: Maybe<Invoice>;
};

/** Autogenerated input type of UpdateCostCenter */
export type UpdateCostCenterInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  costCenterId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCostCenter. */
export type UpdateCostCenterPayload = {
  __typename?: 'UpdateCostCenterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  costCenter?: Maybe<CostCenter>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCustomerBankAccount */
export type UpdateCustomerBankAccountInput = {
  bankDetails: PaymentMethodsCustomerBankAccountDetailsInput;
  billingAddress?: InputMaybe<AddressArguments>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  customerBankAccountId: Scalars['ID']['input'];
  userNotSigner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateCustomerBankAccount. */
export type UpdateCustomerBankAccountPayload = {
  __typename?: 'UpdateCustomerBankAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerBankAccount: B2BPaymentMethod;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateDependentEnrollment */
export type UpdateDependentEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverageStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dependentEnrollmentId: Scalars['ID']['input'];
  enrollmentPrices?: InputMaybe<Array<BenefitsEnrollmentPriceInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateDependentEnrollment. */
export type UpdateDependentEnrollmentPayload = {
  __typename?: 'UpdateDependentEnrollmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  dependentEnrollment: BenefitsDependentEnrollment;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateDependent */
export type UpdateDependentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dependentId: Scalars['ID']['input'];
  fieldsWithValues: Scalars['JSON']['input'];
};

/** Autogenerated return type of UpdateDependent. */
export type UpdateDependentPayload = {
  __typename?: 'UpdateDependentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement: Engagement;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateDocument */
export type UpdateDocumentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['ISO8601Date']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateDocument. */
export type UpdateDocumentPayload = {
  __typename?: 'UpdateDocumentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  document?: Maybe<Document>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEmployeeSettings */
export type UpdateEmployeeSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  depositInvoiceRequired?: InputMaybe<Scalars['Boolean']['input']>;
  employmentId: Scalars['ID']['input'];
  includeOnInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  monthsOfDeposit?: InputMaybe<Scalars['Float']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateEmployeeSettings. */
export type UpdateEmployeeSettingsPayload = {
  __typename?: 'UpdateEmployeeSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  employment?: Maybe<Employment>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEmployerOfRecordCountry */
export type UpdateEmployerOfRecordCountryInput = {
  averageTimeToHire?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  concurrentHireDescription?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordCountryId: Scalars['ID']['input'];
  hiringConfidence?: InputMaybe<EorCountryHiringConfidenceEnumType>;
  needToKnows?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateEmployerOfRecordCountry. */
export type UpdateEmployerOfRecordCountryPayload = {
  __typename?: 'UpdateEmployerOfRecordCountryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employerOfRecordCountry: EmployerOfRecordCountry;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEmployerOfRecord */
export type UpdateEmployerOfRecordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  cutOffMonthDay?: InputMaybe<Scalars['Int']['input']>;
  direct?: InputMaybe<Scalars['Boolean']['input']>;
  employerOfRecordCountryByAlpha2?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordCountryId?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordDetailAttributes?: InputMaybe<EmployerOfRecordDetailsAttributesInput>;
  employerOfRecordId: Scalars['String']['input'];
  entityType?: InputMaybe<GlobalPayrollEorEntityTypeEnum>;
  externalToolsAttributes?: InputMaybe<Array<ExternalToolInputType>>;
  financeEmail?: InputMaybe<Scalars['String']['input']>;
  kleaSubsidiaryAttributes?: InputMaybe<EmployerOfRecordKleaSubsidiaryAttributesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateEmployerOfRecord. */
export type UpdateEmployerOfRecordPayload = {
  __typename?: 'UpdateEmployerOfRecordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employerOfRecord?: Maybe<EmployerOfRecord>;
  employerOfRecordCountry?: Maybe<EmployerOfRecordCountry>;
  errors: Array<Scalars['String']['output']>;
  kleaSubsidiary?: Maybe<EmployerOfRecordKleaSubsidiary>;
};

/** Autogenerated input type of UpdateEmploymentInformationAfterSubmission */
export type UpdateEmploymentInformationAfterSubmissionInput = {
  actorParty: AgreementPartyTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractedTerminationNoticeAttributes?: InputMaybe<EmployerTypesTerminationNoticeInputType>;
  contractedTerminationNoticePeriod?: InputMaybe<CalendarDurationInput>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  /** Time at which the action to edit the form was started. */
  editActionStartTime: Scalars['ISO8601DateTime']['input'];
  employmentId: Scalars['ID']['input'];
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  fullTimeHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  hiringId: Scalars['ID']['input'];
  initialStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  managerEmailAddress?: InputMaybe<Scalars['String']['input']>;
  managerIsExpenseApprover?: InputMaybe<Scalars['Boolean']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  managerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  managerRole?: InputMaybe<Scalars['String']['input']>;
  partTimeDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  partTimeHoursPerDay?: InputMaybe<Scalars['Float']['input']>;
  probationPeriod?: InputMaybe<Scalars['Iso8601Duration']['input']>;
  resignationNoticeAttributes?: InputMaybe<EmployerTypesResignationNoticeInputType>;
  resignationNoticePeriod?: InputMaybe<CalendarDurationInput>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  workFocusedWithinCountryOfResidence?: InputMaybe<Scalars['Boolean']['input']>;
  workSchedules?: InputMaybe<Array<WorkScheduleInput>>;
};

/** Autogenerated return type of UpdateEmploymentInformationAfterSubmission. */
export type UpdateEmploymentInformationAfterSubmissionPayload = {
  __typename?: 'UpdateEmploymentInformationAfterSubmissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<FormFieldError>>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of UpdateEmploymentInformation */
export type UpdateEmploymentInformationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractedTerminationNoticeAttributes?: InputMaybe<EmployerTypesTerminationNoticeInputType>;
  contractedTerminationNoticePeriod?: InputMaybe<CalendarDurationInput>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  employmentId: Scalars['String']['input'];
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  fullTimeHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  initialStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  managerEmailAddress?: InputMaybe<Scalars['String']['input']>;
  managerIsExpenseApprover?: InputMaybe<Scalars['Boolean']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  managerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  managerRole?: InputMaybe<Scalars['String']['input']>;
  partTimeDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  partTimeHoursPerDay?: InputMaybe<Scalars['Float']['input']>;
  probationPeriod?: InputMaybe<Scalars['Iso8601Duration']['input']>;
  resignationNoticeAttributes?: InputMaybe<EmployerTypesResignationNoticeInputType>;
  resignationNoticePeriod?: InputMaybe<CalendarDurationInput>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  workFocusedWithinCountryOfResidence?: InputMaybe<Scalars['Boolean']['input']>;
  workSchedules?: InputMaybe<Array<WorkScheduleInput>>;
};

/** Autogenerated return type of UpdateEmploymentInformation. */
export type UpdateEmploymentInformationPayload = {
  __typename?: 'UpdateEmploymentInformationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors: Array<FormFieldError>;
};

/** Autogenerated input type of UpdateEmployment */
export type UpdateEmploymentInput = {
  allowedToSubmitExpenses?: InputMaybe<Scalars['Boolean']['input']>;
  annualBonusType?: InputMaybe<Scalars['String']['input']>;
  assignedStaffId?: InputMaybe<Scalars['ID']['input']>;
  benefitsDescription?: InputMaybe<Scalars['String']['input']>;
  bonusAmount?: InputMaybe<Scalars['Float']['input']>;
  bonusCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  cbaLevel?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commissionPlanOffered?: InputMaybe<Scalars['Boolean']['input']>;
  commissionPlanSignedId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  contractedSeveranceRequired?: InputMaybe<Scalars['String']['input']>;
  contractedTerminationNoticeAttributes?: InputMaybe<EmployerTypesTerminationNoticeInputType>;
  contractedTerminationNoticePeriod?: InputMaybe<CalendarDurationInput>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  creationState?: InputMaybe<EmploymentCreationStateEnum>;
  dailyResponsibility?: InputMaybe<Scalars['String']['input']>;
  decisionMakingAuthority?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  employerOfRecordId?: InputMaybe<Scalars['String']['input']>;
  employerTaxesAndContributionsAmount?: InputMaybe<Scalars['Float']['input']>;
  employerTaxesAndContributionsCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  employmentComplianceCheck?: InputMaybe<Scalars['Boolean']['input']>;
  employmentComplianceDetails?: InputMaybe<Scalars['String']['input']>;
  employmentId: Scalars['String']['input'];
  employmentType?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  equityOffered?: InputMaybe<Scalars['Boolean']['input']>;
  fullTimeHoursPerWeek?: InputMaybe<Scalars['Float']['input']>;
  hiringSuccessLeadId?: InputMaybe<Scalars['ID']['input']>;
  hourlyRate?: InputMaybe<Scalars['Float']['input']>;
  initialStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  internalBulkImport?: InputMaybe<Scalars['Boolean']['input']>;
  internalMigration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether a USA-based employee is not eligible (exempt) or eligible (non-exempt) for overtime pay. */
  isUsaExemptEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  jobDescriptionTranslation?: InputMaybe<Scalars['String']['input']>;
  jobRoleTranslation?: InputMaybe<Scalars['String']['input']>;
  lastDayOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  lastWorkingDay?: InputMaybe<Scalars['ISO8601Date']['input']>;
  localEmployerCostMonthlyAmount?: InputMaybe<Scalars['Float']['input']>;
  localEmployerCostMonthlyCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  localEmployerCostOneoffAmount?: InputMaybe<Scalars['Float']['input']>;
  localEmployerCostOneoffCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  managerEmailAddress?: InputMaybe<Scalars['String']['input']>;
  managerIsExpenseApprover?: InputMaybe<Scalars['Boolean']['input']>;
  managerName?: InputMaybe<Scalars['String']['input']>;
  managerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  managerRole?: InputMaybe<Scalars['String']['input']>;
  minimumQualification?: InputMaybe<Scalars['String']['input']>;
  monthlyCommission?: InputMaybe<Scalars['String']['input']>;
  monthsFor13thSalary?: InputMaybe<Array<MonthsEnum>>;
  monthsFor13thSalaryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  monthsFor14thSalary?: InputMaybe<Array<MonthsEnum>>;
  monthsFor14thSalaryEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  newHireStatus?: InputMaybe<EngagementNewHireStatusType>;
  notes?: InputMaybe<Scalars['String']['input']>;
  noticeAttributes?: InputMaybe<EmploymentNoticeInput>;
  offboardingSpecialistId?: InputMaybe<Scalars['ID']['input']>;
  offerLetterSendRequested?: InputMaybe<Scalars['Boolean']['input']>;
  paidHolidayDays?: InputMaybe<Scalars['Float']['input']>;
  partTimeDaysPerWeek?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Format like 6.4 hours represents 6h and 24m.
   * For example, 5 days with 6.4h per day is equivalent to 32h per week.
   * Maximum input value is 24 hours. Maximum number of digits after the decimal point is 1.
   */
  partTimeHoursPerDay?: InputMaybe<Scalars['Float']['input']>;
  paymentCadence?: InputMaybe<Scalars['String']['input']>;
  paymentDay?: InputMaybe<EngagementPaymentDayType>;
  payrollSpecialistId?: InputMaybe<Scalars['ID']['input']>;
  personalInfoAttributes?: InputMaybe<EmploymentPersonalInfoAttributesInput>;
  primaryDuty?: InputMaybe<Scalars['String']['input']>;
  privateNotes?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Duplicates startDate and probationPeriod */
  probationEnd?: InputMaybe<Scalars['ISO8601Date']['input']>;
  probationPeriod?: InputMaybe<Scalars['Iso8601Duration']['input']>;
  /** @deprecated Use probationPeriod for ISO 8601 compliance */
  probationPeriodType?: InputMaybe<EngagementProbationPeriodType>;
  /** @deprecated Use probationPeriod for ISO 8601 compliance */
  probationPeriodValue?: InputMaybe<Scalars['Int']['input']>;
  providedEquipmentList?: InputMaybe<Array<EquipmentListEnum>>;
  providedEquipmentOther?: InputMaybe<Scalars['String']['input']>;
  providedEquipmentPolicy?: InputMaybe<EquipmentPolicyEnum>;
  providedEquipmentPolicyBudgetAmount?: InputMaybe<Scalars['MoneyInt']['input']>;
  providerPlan?: InputMaybe<Scalars['String']['input']>;
  publicHolidayDays?: InputMaybe<Scalars['Int']['input']>;
  reimbursementPolicy?: InputMaybe<ReimbursementPolicyInput>;
  resignationNoticeAttributes?: InputMaybe<EmployerTypesResignationNoticeInputType>;
  resignationNoticePeriod?: InputMaybe<CalendarDurationInput>;
  restrictiveCovenants?: InputMaybe<RestrictiveCovenantsInput>;
  role?: InputMaybe<Scalars['String']['input']>;
  roleTypeId?: InputMaybe<Scalars['ID']['input']>;
  salaryAmount?: InputMaybe<Scalars['Float']['input']>;
  salaryCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  seniorityLevel?: InputMaybe<EngagementSeniorityLevelType>;
  severanceAttributes?: InputMaybe<EmploymentSeveranceInput>;
  sickPayAttributes?: InputMaybe<SickPayInput>;
  signOnBonusAmount?: InputMaybe<Scalars['Float']['input']>;
  signOnBonusCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
  terminationAttributes?: InputMaybe<TerminationInput>;
  vendorExternalId?: InputMaybe<Scalars['String']['input']>;
  visaAttributes?: InputMaybe<EmploymentVisaInput>;
  /** True if the Team Member's day-to-day work is focused on providing or supporting services within the country of residence. */
  workFocusedWithinCountryOfResidence?: InputMaybe<Scalars['Boolean']['input']>;
  workPermitRequired?: InputMaybe<Scalars['Boolean']['input']>;
  workSchedules?: InputMaybe<Array<WorkScheduleInput>>;
  workingHours?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateEmployment. */
export type UpdateEmploymentPayload = {
  __typename?: 'UpdateEmploymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  employment?: Maybe<Employment>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors: Array<FormFieldError>;
};

/** Autogenerated input type of UpdateEmploymentTemplate */
export type UpdateEmploymentTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commissionPlanOffered?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Signed id of the uploaded commission plan file. Null will destroy the
   * existing commission plan document, if any.
   */
  commissionPlanSignedId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<CountryIsoCode>;
  description?: InputMaybe<Scalars['String']['input']>;
  equityOffered?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  paidHolidayDays?: InputMaybe<Scalars['Float']['input']>;
  probationPeriod?: InputMaybe<Scalars['Iso8601Duration']['input']>;
  remoteWorkCosts?: InputMaybe<EngagementRemoteWorkCostInputType>;
  status?: InputMaybe<EmploymentTemplateStatus>;
};

/** Autogenerated return type of UpdateEmploymentTemplate. */
export type UpdateEmploymentTemplatePayload = {
  __typename?: 'UpdateEmploymentTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employmentTemplate?: Maybe<EmploymentTemplate>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors: Array<FormFieldError>;
};

/** Autogenerated input type of UpdateEmploymentWorkEmailAddress */
export type UpdateEmploymentWorkEmailAddressInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employmentId?: InputMaybe<Scalars['ID']['input']>;
  workEmailAddress?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateEmploymentWorkEmailAddress. */
export type UpdateEmploymentWorkEmailAddressPayload = {
  __typename?: 'UpdateEmploymentWorkEmailAddressPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment: Employment;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEngagementExportTemplate */
export type UpdateEngagementExportTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  fileSignedId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateEngagementExportTemplate. */
export type UpdateEngagementExportTemplatePayload = {
  __typename?: 'UpdateEngagementExportTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  template: EngagementExportTemplate;
};

/** Autogenerated input type of UpdateEngagementSettings */
export type UpdateEngagementSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['String']['input'];
  forcedProvider?: InputMaybe<PayoutProviderName>;
  payoutsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateEngagementSettings. */
export type UpdateEngagementSettingsPayload = {
  __typename?: 'UpdateEngagementSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnrollment */
export type UpdateEnrollmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  costContributions?: InputMaybe<Array<BenefitsEnrollmentCostContributorInput>>;
  dependentsEmployerContribution?: InputMaybe<Scalars['Float']['input']>;
  dependentsEmployerContributionMaxCount?: InputMaybe<Scalars['Int']['input']>;
  employerContribution?: InputMaybe<Scalars['Float']['input']>;
  enrollmentId: Scalars['ID']['input'];
  enrollmentPrices?: InputMaybe<Array<BenefitsEnrollmentPriceInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of UpdateEnrollment. */
export type UpdateEnrollmentPayload = {
  __typename?: 'UpdateEnrollmentPayload';
  benefitEnrollment?: Maybe<BenefitsEnrollment>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnrollmentTemplate */
export type UpdateEnrollmentTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employmentTemplateId: Scalars['ID']['input'];
  enrollmentTemplateInput: BenefitsEnrollmentTemplateInput;
};

/** Autogenerated return type of UpdateEnrollmentTemplate. */
export type UpdateEnrollmentTemplatePayload = {
  __typename?: 'UpdateEnrollmentTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employmentTemplate?: Maybe<EmploymentTemplate>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEquityWithholdingRequestStatus */
export type UpdateEquityWithholdingRequestStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  equityWithholdingRequestId: Scalars['ID']['input'];
  status: EquityWithholdingRequestStatusEnum;
};

/** Autogenerated return type of UpdateEquityWithholdingRequestStatus. */
export type UpdateEquityWithholdingRequestStatusPayload = {
  __typename?: 'UpdateEquityWithholdingRequestStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityWithholdingRequest?: Maybe<EquityWithholdingRequest>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateExpense */
export type UpdateExpenseInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountCurrencyCode?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<ExpenseCategory>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expenseDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  expenseId: Scalars['ID']['input'];
  payout?: InputMaybe<MoneyInput>;
  receiptId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateExpense. */
export type UpdateExpensePayload = {
  __typename?: 'UpdateExpensePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  expense?: Maybe<Expense>;
};

/** Autogenerated input type of UpdateExternalPointOfContact */
export type UpdateExternalPointOfContactInput = {
  areasOfDomain: Array<Scalars['String']['input']>;
  backupEmail?: InputMaybe<Scalars['String']['input']>;
  backupJobTitle?: InputMaybe<Scalars['String']['input']>;
  backupName?: InputMaybe<Scalars['String']['input']>;
  backupPhoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  backupPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countries: Array<Scalars['String']['input']>;
  customerNotes?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalPointOfContactId: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  includedInServiceComms: Scalars['Boolean']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateExternalPointOfContact. */
export type UpdateExternalPointOfContactPayload = {
  __typename?: 'UpdateExternalPointOfContactPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  externalPointOfContact?: Maybe<ExternalPointOfContact>;
};

/** Autogenerated input type of UpdateFXMarkupGroup */
export type UpdateFxMarkupGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  marginPercentage: Scalars['Float']['input'];
  markupGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFXMarkupGroup. */
export type UpdateFxMarkupGroupPayload = {
  __typename?: 'UpdateFXMarkupGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  markupGroup?: Maybe<FxMarkupGroup>;
};

/** Autogenerated input type of UpdateFXMarkupPair */
export type UpdateFxMarkupPairInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  marginPercentage?: InputMaybe<Scalars['Float']['input']>;
  markupGroupId?: InputMaybe<Scalars['ID']['input']>;
  to: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateFXMarkupPair. */
export type UpdateFxMarkupPairPayload = {
  __typename?: 'UpdateFXMarkupPairPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  markupPair?: Maybe<FxMarkupPair>;
};

/** Autogenerated input type of UpdateFlexibleWorkArrangement */
export type UpdateFlexibleWorkArrangementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  flexibleWorkArrangement: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateFlexibleWorkArrangement. */
export type UpdateFlexibleWorkArrangementPayload = {
  __typename?: 'UpdateFlexibleWorkArrangementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateGrant */
export type UpdateGrantInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyValuationId: Scalars['ID']['input'];
  countryCode: Scalars['String']['input'];
  earlyExerciseEvent?: InputMaybe<Array<Scalars['String']['input']>>;
  equityGrantId: Scalars['ID']['input'];
  equitySubType?: InputMaybe<EquitySubTypeEnum>;
  equityType: EquityTypeEnum;
  grantAmount?: InputMaybe<Scalars['Float']['input']>;
  grantAmountCurrency?: InputMaybe<Scalars['String']['input']>;
  grantDate: Scalars['ISO8601Date']['input'];
  grantShares?: InputMaybe<Scalars['Float']['input']>;
  grantedInSoftware: Scalars['Boolean']['input'];
  planType: EquityPlanTypeEnum;
  recurring: Scalars['Boolean']['input'];
  vestingCliffMonths?: InputMaybe<Scalars['Int']['input']>;
  vestingCliffShares?: InputMaybe<Scalars['Float']['input']>;
  vestingScheduleMonths?: InputMaybe<Scalars['Int']['input']>;
  vestingStartDate: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of UpdateGrant. */
export type UpdateGrantPayload = {
  __typename?: 'UpdateGrantPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  equityGrant: EquityGrant;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of Update */
export type UpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completedAt: Scalars['ISO8601DateTime']['input'];
  paymentOrderId: Scalars['ID']['input'];
};

/** Autogenerated input type of UpdateIntegrationAddOns */
export type UpdateIntegrationAddOnsInput = {
  addOns: Array<IntegrationAddOnInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateIntegrationAddOns. */
export type UpdateIntegrationAddOnsPayload = {
  __typename?: 'UpdateIntegrationAddOnsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  integration: MergeIntegration;
};

/** Autogenerated input type of UpdateInvoice */
export type UpdateInvoiceInput = {
  amount: Scalars['Float']['input'];
  amountCurrencyCode: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  dueDate: Scalars['ISO8601Date']['input'];
  invoiceDate: Scalars['ISO8601Date']['input'];
  invoiceId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  referenceCode: Scalars['String']['input'];
  signedDocumentId?: InputMaybe<Scalars['String']['input']>;
  signedSupportingDocumentId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateInvoice. */
export type UpdateInvoicePayload = {
  __typename?: 'UpdateInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  invoice: Invoice;
};

/** Autogenerated input type of UpdateInvoicingEnabledContractSetting */
export type UpdateInvoicingEnabledContractSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['ID']['input'];
  invoicingEnabled: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateInvoicingEnabledContractSetting. */
export type UpdateInvoicingEnabledContractSettingPayload = {
  __typename?: 'UpdateInvoicingEnabledContractSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contract?: Maybe<Contract>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateMandateEmbeddedLink */
export type UpdateMandateEmbeddedLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  mandateId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateMandateEmbeddedLink. */
export type UpdateMandateEmbeddedLinkPayload = {
  __typename?: 'UpdateMandateEmbeddedLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  mandate?: Maybe<PaymentMethodsCustomerBankAccountMandateType>;
};

/** Autogenerated input type of UpdateNewStarterSlackNotification */
export type UpdateNewStarterSlackNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newState: Scalars['Boolean']['input'];
  slackIntegrationId: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateNewStarterSlackNotification. */
export type UpdateNewStarterSlackNotificationPayload = {
  __typename?: 'UpdateNewStarterSlackNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateOauthApplication */
export type UpdateOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developerTermsAccepted: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of UpdateOauthApplication. */
export type UpdateOauthApplicationPayload = {
  __typename?: 'UpdateOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  oauthApplication: OauthApplication;
};

/** Autogenerated input type of UpdateOktaCredential */
export type UpdateOktaCredentialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  oktaClientId: Scalars['String']['input'];
  oktaClientSecret: Scalars['String']['input'];
  oktaCredentialId: Scalars['String']['input'];
  oktaIssuerUrl: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateOktaCredential. */
export type UpdateOktaCredentialPayload = {
  __typename?: 'UpdateOktaCredentialPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  oktaCredential?: Maybe<OktaCredential>;
};

/** Autogenerated return type of Update. */
export type UpdatePayload = {
  __typename?: 'UpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentOrder: PaymentOrder;
};

/** Autogenerated input type of UpdatePaymentCurrency */
export type UpdatePaymentCurrencyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currencyCode: Scalars['String']['input'];
  engagementId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePaymentCurrency. */
export type UpdatePaymentCurrencyPayload = {
  __typename?: 'UpdatePaymentCurrencyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdatePayrollEntity */
export type UpdatePayrollEntityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  cutOffMonthDay?: InputMaybe<Scalars['Int']['input']>;
  employerOfRecordCountryByAlpha2?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordCountryId?: InputMaybe<Scalars['String']['input']>;
  employerOfRecordDetailAttributes?: InputMaybe<EmployerOfRecordDetailsAttributesInput>;
  employerOfRecordId: Scalars['String']['input'];
  externalToolsAttributes?: InputMaybe<Array<ExternalToolInputType>>;
  financeEmail?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdatePayrollEntity. */
export type UpdatePayrollEntityPayload = {
  __typename?: 'UpdatePayrollEntityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employerOfRecord?: Maybe<EmployerOfRecord>;
  employerOfRecordCountry?: Maybe<EmployerOfRecordCountry>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdatePersonalDetails */
export type UpdatePersonalDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  employmentComplianceCheck?: InputMaybe<Scalars['Boolean']['input']>;
  employmentComplianceDetails?: InputMaybe<Scalars['String']['input']>;
  employmentId: Scalars['String']['input'];
  personalInfoAttributes?: InputMaybe<EmploymentPersonalInfoAttributesInput>;
  subdivisionCode?: InputMaybe<Scalars['String']['input']>;
  visaAttributes?: InputMaybe<EmploymentVisaInput>;
};

/** Autogenerated return type of UpdatePersonalDetails. */
export type UpdatePersonalDetailsPayload = {
  __typename?: 'UpdatePersonalDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors: Array<FormFieldError>;
};

/** Autogenerated input type of UpdatePersonalInfoAfterSubmission */
export type UpdatePersonalInfoAfterSubmissionInput = {
  actorParty: AgreementPartyTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Time at which the action to edit the form was started. */
  editActionStartTime: Scalars['ISO8601DateTime']['input'];
  employmentId: Scalars['ID']['input'];
  hiringId: Scalars['ID']['input'];
  personalInfoAttributes?: InputMaybe<EmployerEmploymentsPersonalInfoAttributesInput>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  visaAttributes?: InputMaybe<EmployerEmploymentVisaInput>;
};

/** Autogenerated return type of UpdatePersonalInfoAfterSubmission. */
export type UpdatePersonalInfoAfterSubmissionPayload = {
  __typename?: 'UpdatePersonalInfoAfterSubmissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<FormFieldError>>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of UpdatePreferences */
export type UpdatePreferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  preferences: PreferencesInput;
};

/** Autogenerated return type of UpdatePreferences. */
export type UpdatePreferencesPayload = {
  __typename?: 'UpdatePreferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of UpdateRefundDetails */
export type UpdateRefundDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  refundDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  refundPreference?: InputMaybe<Scalars['String']['input']>;
  terminationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateRefundDetails. */
export type UpdateRefundDetailsPayload = {
  __typename?: 'UpdateRefundDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  termination?: Maybe<Termination>;
};

/** Autogenerated input type of UpdateReimbursementBudget */
export type UpdateReimbursementBudgetInput = {
  amountSubunit?: InputMaybe<Scalars['MoneyInt']['input']>;
  changeReason: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Provide a label to be used for reimbursement budget when the "other" label is selected. */
  customLabel?: InputMaybe<Scalars['String']['input']>;
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  effectiveEndDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  label?: InputMaybe<ReimbursementBudgetLabelEnum>;
  reimbursementBudgetId: Scalars['ID']['input'];
  resetFrequency?: InputMaybe<ResetFrequencyEnum>;
};

/** Autogenerated return type of UpdateReimbursementBudget. */
export type UpdateReimbursementBudgetPayload = {
  __typename?: 'UpdateReimbursementBudgetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  reimbursementBudget?: Maybe<ReimbursementBudget>;
};

/** Autogenerated input type of UpdateRequiredForm */
export type UpdateRequiredFormInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  requiredFormId: Scalars['ID']['input'];
  signedDocumentId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRequiredForm. */
export type UpdateRequiredFormPayload = {
  __typename?: 'UpdateRequiredFormPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  requiredForm: RequiredForm;
};

/** Autogenerated input type of UpdateRetroactivePayment */
export type UpdateRetroactivePaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementChangeId: Scalars['ID']['input'];
  retroactivePayment: Scalars['Float']['input'];
};

/** Autogenerated return type of UpdateRetroactivePayment. */
export type UpdateRetroactivePaymentPayload = {
  __typename?: 'UpdateRetroactivePaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagementChange?: Maybe<EngagementChange>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateRoleDetails */
export type UpdateRoleDetailsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dailyResponsibility?: InputMaybe<Scalars['String']['input']>;
  decisionMakingAuthority?: InputMaybe<Scalars['String']['input']>;
  employmentId: Scalars['String']['input'];
  initialStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  minimumQualification?: InputMaybe<Scalars['String']['input']>;
  newHireStatus?: InputMaybe<EngagementNewHireStatusType>;
  primaryDuty?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roleTypeId?: InputMaybe<Scalars['ID']['input']>;
  seniorityLevel?: InputMaybe<EngagementSeniorityLevelType>;
};

/** Autogenerated return type of UpdateRoleDetails. */
export type UpdateRoleDetailsPayload = {
  __typename?: 'UpdateRoleDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors: Array<FormFieldError>;
};

/** Autogenerated input type of UpdateRoleInformationAfterSubmission */
export type UpdateRoleInformationAfterSubmissionInput = {
  actorParty: AgreementPartyTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dailyResponsibility?: InputMaybe<Scalars['String']['input']>;
  decisionMakingAuthority?: InputMaybe<Scalars['String']['input']>;
  /** Time at which the action to edit the form was started. */
  editActionStartTime: Scalars['ISO8601DateTime']['input'];
  employmentId: Scalars['ID']['input'];
  hiringId: Scalars['ID']['input'];
  initialStartDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  minimumQualification?: InputMaybe<Scalars['String']['input']>;
  newHireStatus?: InputMaybe<EngagementNewHireStatusType>;
  primaryDuty?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roleTypeId?: InputMaybe<Scalars['ID']['input']>;
  sendNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  seniorityLevel?: InputMaybe<EngagementSeniorityLevelType>;
};

/** Autogenerated return type of UpdateRoleInformationAfterSubmission. */
export type UpdateRoleInformationAfterSubmissionPayload = {
  __typename?: 'UpdateRoleInformationAfterSubmissionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  errors: Array<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<FormFieldError>>;
  hiring?: Maybe<Hiring>;
};

/** Autogenerated input type of UpdateRoleMatch */
export type UpdateRoleMatchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  roleMatchId: Scalars['ID']['input'];
  roleTypeId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateRoleMatch. */
export type UpdateRoleMatchPayload = {
  __typename?: 'UpdateRoleMatchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  roleMatch: WorkforceReportRoleMatch;
};

/** Autogenerated input type of UpdateSelectedAdpWorkforceNowCompanyCode */
export type UpdateSelectedAdpWorkforceNowCompanyCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  codeRemoteId: Scalars['String']['input'];
  codeType: CompanyCodeTypeEnum;
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSelectedAdpWorkforceNowCompanyCode. */
export type UpdateSelectedAdpWorkforceNowCompanyCodePayload = {
  __typename?: 'UpdateSelectedAdpWorkforceNowCompanyCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  integration?: Maybe<HrisIntegration>;
};

/** Autogenerated input type of UpdateSubdivisionCode */
export type UpdateSubdivisionCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  subdivisionCode: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateSubdivisionCode. */
export type UpdateSubdivisionCodePayload = {
  __typename?: 'UpdateSubdivisionCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateTimeOffMappings */
export type UpdateTimeOffMappingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
  timeOffMappings: TimeOffMappingsInput;
};

/** Autogenerated return type of UpdateTimeOffMappings. */
export type UpdateTimeOffMappingsPayload = {
  __typename?: 'UpdateTimeOffMappingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateTimeSheetEntriesForDate */
export type UpdateTimeSheetEntriesForDateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['ISO8601Date']['input'];
  entries: Array<TimeSheetEntryInput>;
  timeSheetId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTimeSheetEntriesForDate. */
export type UpdateTimeSheetEntriesForDatePayload = {
  __typename?: 'UpdateTimeSheetEntriesForDatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Array<TimeSheetEntry>>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateTimeSheetEntryMutation */
export type UpdateTimeSheetEntryMutationInput = {
  breakIntervalFrom?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
  breakIntervalTo?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  timeSheetEntryId: Scalars['ID']['input'];
  to?: InputMaybe<Scalars['TimeWithoutSecondsAndTz']['input']>;
};

/** Autogenerated return type of UpdateTimeSheetEntryMutation. */
export type UpdateTimeSheetEntryMutationPayload = {
  __typename?: 'UpdateTimeSheetEntryMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeSheetEntry?: Maybe<TimeSheetEntry>;
};

/** Autogenerated input type of UpdateTimeSheetMutation */
export type UpdateTimeSheetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  completeTimeSheet: Scalars['Boolean']['input'];
  timeSheetId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTimeSheetMutation. */
export type UpdateTimeSheetMutationPayload = {
  __typename?: 'UpdateTimeSheetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  timeSheet?: Maybe<TimeSheet>;
};

/** Autogenerated input type of UpdateTimeTrackingEngagementSettings */
export type UpdateTimeTrackingEngagementSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  nightWorkEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  onCallEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  workSchedule?: InputMaybe<Array<ScheduleDayInput>>;
};

/** Autogenerated return type of UpdateTimeTrackingEngagementSettings. */
export type UpdateTimeTrackingEngagementSettingsPayload = {
  __typename?: 'UpdateTimeTrackingEngagementSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateTimeTrackingToolOverrideMutation */
export type UpdateTimeTrackingToolOverrideMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['ID']['input'];
  override: TimeTrackingToolOverrideEnum;
};

/** Autogenerated return type of UpdateTimeTrackingToolOverrideMutation. */
export type UpdateTimeTrackingToolOverrideMutationPayload = {
  __typename?: 'UpdateTimeTrackingToolOverrideMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateVariableCompensation */
export type UpdateVariableCompensationInput = {
  amountAsPercentage?: InputMaybe<Scalars['Float']['input']>;
  amountSubunit?: InputMaybe<Scalars['MoneyInt']['input']>;
  changeReason: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  compensationType?: InputMaybe<VariableCompensationTypeEnum>;
  customLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * A date representing a month after which this change will be effective.
   *
   * Only required if the engagement is engaged.
   */
  effectiveDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  guaranteed?: InputMaybe<Scalars['Boolean']['input']>;
  includedInGrossSalary?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<VariableCompensationLabelEnum>;
  paymentFrequency?: InputMaybe<PaymentFrequencyEnum>;
  prorated?: InputMaybe<Scalars['Boolean']['input']>;
  selectedMonths?: InputMaybe<Array<MonthsEnum>>;
  statutory?: InputMaybe<Scalars['Boolean']['input']>;
  variableCompensationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateVariableCompensation. */
export type UpdateVariableCompensationPayload = {
  __typename?: 'UpdateVariableCompensationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /**
   * The existing variable compensation record with updated fields. If the record was already
   * sent to the employer of record for processing, only the effective end date and change
   * reason are updated. Instead, a new variable compensation is created with the updated
   * fields. Null if there are errors.
   */
  existingVariableCompensation?: Maybe<VariableCompensation>;
  /**
   * The new variable compensation record created if the existing record was already sent to
   * the employer of record for processing. Null if the existing record has not been sent and
   * was updated directly, or if there are errors.
   */
  newVariableCompensation?: Maybe<VariableCompensation>;
};

/** Autogenerated input type of UpdateVariableCompensationTemplate */
export type UpdateVariableCompensationTemplateInput = {
  amount?: InputMaybe<MoneyInput>;
  amountAsPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  compensationType?: InputMaybe<VariableCompensationTypeEnum>;
  guaranteed?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<VariableCompensationLabelEnum>;
  paymentFrequency?: InputMaybe<PaymentFrequencyEnum>;
  prorated?: InputMaybe<Scalars['Boolean']['input']>;
  selectedMonths?: InputMaybe<Array<MonthsEnum>>;
};

/** Autogenerated return type of UpdateVariableCompensationTemplate. */
export type UpdateVariableCompensationTemplatePayload = {
  __typename?: 'UpdateVariableCompensationTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  variableCompensationTemplate?: Maybe<VariableCompensationTemplate>;
};

/** Autogenerated input type of UploadAgreement */
export type UploadAgreementInput = {
  agreementId: Scalars['ID']['input'];
  agreementState: AgreementStateEnum;
  agreementType: AgreementTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employmentId?: InputMaybe<Scalars['String']['input']>;
  fileSignedId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sendNotifications: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UploadAgreement. */
export type UploadAgreementPayload = {
  __typename?: 'UploadAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UploadAmendment */
export type UploadAmendmentInput = {
  agreementState: AgreementStateEnum;
  amendmentProcessId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fileSignedId: Scalars['String']['input'];
};

/** Autogenerated return type of UploadAmendment. */
export type UploadAmendmentPayload = {
  __typename?: 'UploadAmendmentPayload';
  amendmentProcess?: Maybe<AmendmentProcessType>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpsertMarkupAdjustment */
export type UpsertMarkupAdjustmentInput = {
  adjustmentType: FxMarkupAdjustmentTypeEnum;
  adjustmentValue: Scalars['Float']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpsertMarkupAdjustment. */
export type UpsertMarkupAdjustmentPayload = {
  __typename?: 'UpsertMarkupAdjustmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company: Company;
  errors: Array<Scalars['String']['output']>;
  markupAdjustment?: Maybe<FxMarkupAdjustment>;
};

/** Autogenerated input type of UpsertPaySupplement */
export type UpsertPaySupplementInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementId: Scalars['String']['input'];
  month?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paySupplementId?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaySupplementAvailablePaymentTypeEnum>;
  state?: InputMaybe<PaySupplementStateEnumType>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpsertPaySupplement. */
export type UpsertPaySupplementPayload = {
  __typename?: 'UpsertPaySupplementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpsertVendorMonthlyFee */
export type UpsertVendorMonthlyFeeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  data: MonthlyFeeInput;
};

/** Autogenerated return type of UpsertVendorMonthlyFee. */
export type UpsertVendorMonthlyFeePayload = {
  __typename?: 'UpsertVendorMonthlyFeePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  monthlyFee?: Maybe<MonthlyFee>;
};

export type User = {
  __typename?: 'User';
  authorizations?: Maybe<Authorization>;
  /** Returns automatic kyc verifications for user */
  autoKycVerifications: Array<KycVerification>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  banned: Scalars['Boolean']['output'];
  carryoverBalance: Array<RemainingCarryover>;
  companiesAsAdmin: Array<Company>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  contractorInvoices: Array<Invoice>;
  createdAsAccountType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  engagements: Array<Engagement>;
  entitlementCounts: EntitlementCounts;
  /** Used to address the TM. */
  friendlyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Returns kyc verifications for user */
  kycVerifications: Array<KycVerification>;
  /** Returns the latest kyc verification for user */
  latestKycVerification?: Maybe<KycVerification>;
  livingAddress?: Maybe<Address>;
  mailingAddress?: Maybe<Address>;
  /** Returns manual kyc verifications for user */
  manualKycVerifications: Array<KycVerification>;
  name?: Maybe<Scalars['String']['output']>;
  /** Returns a specific OAuth application owned by the user */
  oauthApplication?: Maybe<OauthApplication>;
  /** Returns an array of available OAuth application scopes */
  oauthApplicationScopes?: Maybe<Array<Scalars['String']['output']>>;
  /** Returns an array of OAuth applications owned by the company */
  oauthApplications: Array<OauthApplication>;
  otpProvisioningData?: Maybe<OtpProvisioningData>;
  otpStatus: OtpStatusType;
  ownExpenses: ExpenseCollection;
  oysterAdmin: Scalars['Boolean']['output'];
  oysterAdminProfile?: Maybe<OysterAdminProfile>;
  pendingInvitationsReceived: Array<Invitation>;
  /** Used in forms to return a preferred name value if available. */
  preferredName?: Maybe<Scalars['String']['output']>;
  /**
   * Used in forms to return the value of the `users.preferred_name` column.
   * This is necessary so that the form can see if a value has been entered
   */
  preferredNameActual?: Maybe<Scalars['String']['output']>;
  pushedFields?: Maybe<Array<Scalars['String']['output']>>;
  requiredForms: Array<RequiredForm>;
  residenceCountryCode?: Maybe<Scalars['String']['output']>;
  roles: Array<AuthorizationRoleType>;
  skipKycVerification: Scalars['Boolean']['output'];
  ssoEnabled: Scalars['Boolean']['output'];
  ssoProvider?: Maybe<Scalars['String']['output']>;
  strongId: Scalars['String']['output'];
  syncedFields: Array<Scalars['String']['output']>;
  timeOffIntegrationPlatformName?: Maybe<IntegrationPlatformNameEnum>;
  timeOffRequests: TimeOffRequestCollection;
  timeOffStats: Array<TimeOffStat>;
  unconfirmedEmail?: Maybe<Scalars['String']['output']>;
  /** Returns the Papertrail logs for user */
  userAuditLog: UserAuditLogCollection;
  userPersonalInfo?: Maybe<UserPersonalInfo>;
};


export type UserCarryoverBalanceArgs = {
  engagementId: Scalars['ID']['input'];
};


export type UserContractorInvoicesArgs = {
  createdByUserType?: InputMaybe<Array<CreatedByUserEnum>>;
  paymentPeriod?: InputMaybe<Scalars['ISO8601Date']['input']>;
  payoutStates?: InputMaybe<Array<PayoutViewState>>;
  subkinds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type UserEngagementsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserEntitlementCountsArgs = {
  engagementId: Scalars['ID']['input'];
};


export type UserOauthApplicationArgs = {
  oauthApplicationId: Scalars['String']['input'];
};


export type UserOauthApplicationsArgs = {
  companyId: Scalars['String']['input'];
};


export type UserOwnExpensesArgs = {
  engagementIds: Array<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
};


export type UserRequiredFormsArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
  formIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type UserRolesArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserTimeOffIntegrationPlatformNameArgs = {
  engagementId: Scalars['ID']['input'];
};


export type UserTimeOffRequestsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrderEnumType>;
  statuses?: InputMaybe<Array<TimeOffRequestStateEnumType>>;
  timeOffTypes?: InputMaybe<Array<TimeOffTypeEnum>>;
};


export type UserTimeOffStatsArgs = {
  engagementId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserUserAuditLogArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAuditLog = {
  __typename?: 'UserAuditLog';
  createdAt: Scalars['ISO8601DateTime']['output'];
  event?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  objectChanges?: Maybe<Scalars['JSON']['output']>;
  user?: Maybe<User>;
};

export type UserAuditLogCollection = {
  __typename?: 'UserAuditLogCollection';
  collection: Array<UserAuditLog>;
  metadata: CollectionMetadata;
};

export type UserBasic = {
  __typename?: 'UserBasic';
  id: Scalars['String']['output'];
  isOysterStaff: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type UserCollection = {
  __typename?: 'UserCollection';
  collection: Array<User>;
  metadata: CollectionMetadata;
};

export type UserGrants = {
  __typename?: 'UserGrants';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitationId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  roles: Array<AuthorizationRoleEnumType>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserGrantsCollection = {
  __typename?: 'UserGrantsCollection';
  collection: Array<UserGrants>;
  metadata: CollectionMetadata;
};

export type UserPersonalInfo = {
  __typename?: 'UserPersonalInfo';
  authorizations?: Maybe<Authorization>;
  citizenships: Array<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['ISO8601Date']['output']>;
  emergencyPhoneCountryCode?: Maybe<Scalars['String']['output']>;
  emergencyPhoneNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pushedFields?: Maybe<Array<Scalars['String']['output']>>;
  syncedFields?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type UserRole = {
  __typename?: 'UserRole';
  companyId: Scalars['ID']['output'];
  engagementId?: Maybe<Scalars['String']['output']>;
  roleNames?: Maybe<Array<AuthorizationRoleEnumType>>;
  teamMember: Scalars['Boolean']['output'];
  user: User;
};

export type Vat = {
  __typename?: 'VAT';
  salesPercentage?: Maybe<Scalars['Float']['output']>;
  salesWithinCountry?: Maybe<Scalars['Boolean']['output']>;
  serviceWithinCountry: Scalars['Boolean']['output'];
};

export type VatOptions = {
  __typename?: 'VATOptions';
  countryName: Scalars['String']['output'];
  requiresSalesPercentageToCountry: Scalars['Boolean']['output'];
  requiresSalesToCountry: Scalars['Boolean']['output'];
  requiresWorksInCountryOfResidence: Scalars['Boolean']['output'];
};

export type VatParameters = {
  __typename?: 'VATParameters';
  salesPercentageToCountry?: Maybe<Scalars['Float']['output']>;
  salesToCountry?: Maybe<Scalars['Boolean']['output']>;
  worksInCountryOfResidence?: Maybe<Scalars['Boolean']['output']>;
};

export type VatParametersInput = {
  salesPercentageToCountry?: InputMaybe<Scalars['Float']['input']>;
  salesToCountry?: InputMaybe<Scalars['Boolean']['input']>;
  worksInCountryOfResidence?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of ValidateClmTemplate */
export type ValidateClmTemplateInput = {
  agreementType: AgreementTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clmTemplateId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  eSignType: AgreementESignTypeEnum;
  employmentStrongId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ValidateClmTemplate. */
export type ValidateClmTemplatePayload = {
  __typename?: 'ValidateClmTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Array<AgreementTemplateVariable>>;
  errors: Array<Scalars['String']['output']>;
  file?: Maybe<DownloadLink>;
  mismatchedOptions?: Maybe<Array<AgreementTemplateVariable>>;
  missingKeywords?: Maybe<Array<Scalars['String']['output']>>;
  notMappedVariables?: Maybe<Array<Scalars['String']['output']>>;
  partyEditRightsConfigured: Scalars['Boolean']['output'];
  validationRequest?: Maybe<ClmValidationRequest>;
};

export type VariableCompensation = {
  __typename?: 'VariableCompensation';
  /** True if the compensation has already been sent to the employer of record for processing. */
  alreadySentToEor: Scalars['Boolean']['output'];
  amount?: Maybe<Money>;
  /**
   * When bonus_type is COMMISSION_PERCENTAGE, this value will provide the percentage
   * amount of the commission. Formatted like 17.5 to represent "seventeen and
   * a half percent".
   */
  amountAsPercentage?: Maybe<Scalars['Float']['output']>;
  /** This field is the reason for the change */
  changeReason?: Maybe<Scalars['String']['output']>;
  compensationType: VariableCompensationTypeEnum;
  /**
   * This is the label to be used for the allowance, bonus or commission when the compensation type "other"
   * is selected.
   */
  customLabel?: Maybe<Scalars['String']['output']>;
  /**
   * It will return true if this variable compensation is linked to a template and
   * has been edited after its creation
   */
  editedAfterCreationFromTemplate?: Maybe<Scalars['Boolean']['output']>;
  /** This is the first day that the allowance can be used on a payment or invoice */
  effectiveDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** This is the last possible day that this allowance could be used on a payment or invoice */
  effectiveEndDate?: Maybe<Scalars['ISO8601Date']['output']>;
  guaranteed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  includedInGrossSalary?: Maybe<Scalars['Boolean']['output']>;
  label: VariableCompensationLabelEnum;
  paymentFrequency: PaymentFrequencyEnum;
  /** Determines whether a bonus should be prorated calculated if the engagement is ended before bonus accrual date */
  prorated?: Maybe<Scalars['Boolean']['output']>;
  selectedMonths: Array<MonthsEnum>;
  statutory?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates the compensation is generated by a custom workflow and should not be editable from the standard list */
  systemGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** The template that this compensation was created from */
  variableCompensationTemplate?: Maybe<VariableCompensationTemplate>;
};


export type VariableCompensationAlreadySentToEorArgs = {
  checkDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type VariableCompensationConfiguration = {
  __typename?: 'VariableCompensationConfiguration';
  /** Specifies which type of variable compensation this represents, e.g. "BONUS". */
  compensationType: VariableCompensationTypeEnum;
  /**
   * Specifies configuration of the "guaranteed" field. False indicates that the compensation is discretionary.
   * Null indicates that the field is omitted for this compensation subtype ("label").
   */
  guaranteed?: Maybe<ConfigurationBooleanField>;
  /** Specifies configuration of the "included in gross salary" field. */
  includedInGrossSalary: ConfigurationBooleanField;
  /** Specifies which subtype ("label") of variable compensation this represents, e.g. "SIGN_ON_BONUS". */
  label: VariableCompensationLabelEnum;
  /** Specifies configuration of the "payment frequency" field. */
  paymentFrequency: ConfigurationPaymentFrequencyEnumField;
  /**
   * True indicates that the amount is represented as a percentage of gross salary (e.g. 5%), while false
   * indicates that the amount is represented as an absolute value (e.g. $1000).
   */
  percentage: ConfigurationBooleanField;
  /**
   * Given a Bonus variable compensation it indicates whether the default payments
   * are prorated upon early termination/resignation
   */
  prorated?: Maybe<ConfigurationBooleanField>;
  /** Specifies configuration of the "statutory" field. */
  statutory: ConfigurationBooleanField;
};

/** An edge in a connection. */
export type VariableCompensationEdge = {
  __typename?: 'VariableCompensationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VariableCompensation>;
};

export enum VariableCompensationLabelEnum {
  Bonus = 'BONUS',
  Bonus_13ThMonth = 'BONUS_13TH_MONTH',
  Bonus_14ThMonth = 'BONUS_14TH_MONTH',
  Car = 'CAR',
  CommissionAmount = 'COMMISSION_AMOUNT',
  CommissionPercentage = 'COMMISSION_PERCENTAGE',
  EndOfYear = 'END_OF_YEAR',
  HealthAndWellbeing = 'HEALTH_AND_WELLBEING',
  HolidayBonus = 'HOLIDAY_BONUS',
  LearningDevelopment = 'LEARNING_DEVELOPMENT',
  Other = 'OTHER',
  Performance = 'PERFORMANCE',
  ReferralBonus = 'REFERRAL_BONUS',
  Retention = 'RETENTION',
  SignOnBonus = 'SIGN_ON_BONUS',
  Sustenance = 'SUSTENANCE',
  Travel = 'TRAVEL',
  VacationBonus = 'VACATION_BONUS',
  WorkFromHome = 'WORK_FROM_HOME',
  WorkFromHomeEquipment = 'WORK_FROM_HOME_EQUIPMENT'
}

/** The connection type for VariableCompensation. */
export type VariableCompensationLegacyConnection = {
  __typename?: 'VariableCompensationLegacyConnection';
  collection: Array<VariableCompensation>;
  /**
   * A list of edges.
   * @deprecated Connection-based pagination is deprecated. Use the `collection` and `metadata` fields instead.
   */
  edges?: Maybe<Array<Maybe<VariableCompensationEdge>>>;
  metadata: CollectionMetadata;
  /**
   * A list of nodes.
   * @deprecated Connection-based pagination is deprecated. Use the `collection` and `metadata` fields instead.
   */
  nodes?: Maybe<Array<Maybe<VariableCompensation>>>;
  /**
   * Information to aid in pagination.
   * @deprecated Connection-based pagination is deprecated. Use the `collection` and `metadata` fields instead.
   */
  pageInfo: PageInfo;
  /** @deprecated Connection-based pagination is deprecated. Use the `collection` and `metadata` fields instead. */
  totalCount: Scalars['Int']['output'];
};

export type VariableCompensationTemplate = {
  __typename?: 'VariableCompensationTemplate';
  amount?: Maybe<Money>;
  amountAsPercentage?: Maybe<Scalars['Float']['output']>;
  authorizations?: Maybe<Authorization>;
  compensationType: VariableCompensationTypeEnum;
  employmentTemplate: EmploymentTemplate;
  guaranteed?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Composite id of the variable compensation template, or null for
   * system-generated statutory variable compensation templates (which
   * are never persisted).
   */
  id?: Maybe<Scalars['ID']['output']>;
  label: VariableCompensationLabelEnum;
  paymentFrequency: PaymentFrequencyEnum;
  prorated?: Maybe<Scalars['Boolean']['output']>;
  selectedMonths?: Maybe<Array<MonthsEnum>>;
  statutory: Scalars['Boolean']['output'];
  systemGenerated: Scalars['Boolean']['output'];
};

export enum VariableCompensationTypeEnum {
  Allowance = 'ALLOWANCE',
  Bonus = 'BONUS'
}

/** Autogenerated input type of VerifyAgreement */
export type VerifyAgreementInput = {
  agreementId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employmentId: Scalars['ID']['input'];
};

/** Autogenerated return type of VerifyAgreement. */
export type VerifyAgreementPayload = {
  __typename?: 'VerifyAgreementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<Employment>;
  engagement?: Maybe<Engagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of VerifyStripeAchPaymentMethod */
export type VerifyStripeAchPaymentMethodInput = {
  amount1: Scalars['Int']['input'];
  amount2: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['ID']['input'];
};

/** Autogenerated return type of VerifyStripeAchPaymentMethod. */
export type VerifyStripeAchPaymentMethodPayload = {
  __typename?: 'VerifyStripeAchPaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paymentMethod: PaymentMethodStripeAch;
};

export enum VisaAcquisitionPayerTypeEnum {
  Customer = 'CUSTOMER',
  Oyster = 'OYSTER',
  TeamMember = 'TEAM_MEMBER',
  Unknown = 'UNKNOWN'
}

/** Autogenerated input type of VoidEnvelope */
export type VoidEnvelopeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  envelopeId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

/** Autogenerated return type of VoidEnvelope. */
export type VoidEnvelopePayload = {
  __typename?: 'VoidEnvelopePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  envelope?: Maybe<Envelope>;
  errors: Array<Scalars['String']['output']>;
};

export enum WeekDaysEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type Widget = {
  __typename?: 'Widget';
  data?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  widgets: Array<Widget>;
};

export type WorkSchedule = {
  __typename?: 'WorkSchedule';
  day: DayOfWeekEnum;
  /** working hours end time, in %H:%M format eg. 17:00 */
  endTime: Scalars['String']['output'];
  /** working hours start time, in %H:%M format eg. 9:00 */
  startTime: Scalars['String']['output'];
};

export type WorkScheduleInput = {
  day: DayOfWeekEnum;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type WorkforceLegalConsent = {
  __typename?: 'WorkforceLegalConsent';
  authorizations?: Maybe<Authorization>;
  consentAcknowledgedAt: Scalars['ISO8601DateTime']['output'];
  consentType: ConsentTypeEnum;
  id: Scalars['ID']['output'];
};

export type WorkforceLegalConsentCollection = {
  __typename?: 'WorkforceLegalConsentCollection';
  collection: Array<WorkforceLegalConsent>;
  metadata: CollectionMetadata;
};

export type WorkforceReport = {
  __typename?: 'WorkforceReport';
  authorizations?: Maybe<Authorization>;
  csvDataUsageAcknowledgeAt: Scalars['ISO8601DateTime']['output'];
  csvFile: DownloadLink;
  fileErrors: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recordErrors: WorkforceReportRecordErrorCollection;
  records: WorkforceReportRecordCollection;
  status: WorkforceReportStatus;
};


export type WorkforceReportRecordErrorsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type WorkforceReportRecordsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkforceReportCollection = {
  __typename?: 'WorkforceReportCollection';
  collection: Array<WorkforceReport>;
  metadata: CollectionMetadata;
};

export type WorkforceReportRecord = {
  __typename?: 'WorkforceReportRecord';
  annualGrossSalary: Money;
  csvRowNumber: Scalars['Int']['output'];
  employeeExternalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobRoleName: Scalars['String']['output'];
  locationCountryCode: CountryIsoCode;
  seniorityLevel: Scalars['String']['output'];
};

export type WorkforceReportRecordCollection = {
  __typename?: 'WorkforceReportRecordCollection';
  collection: Array<WorkforceReportRecord>;
  metadata: CollectionMetadata;
};

export type WorkforceReportRecordError = {
  __typename?: 'WorkforceReportRecordError';
  csvRowNumber?: Maybe<Scalars['Int']['output']>;
  employeeExternalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locationCountryCode?: Maybe<Scalars['String']['output']>;
  recordErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export type WorkforceReportRecordErrorCollection = {
  __typename?: 'WorkforceReportRecordErrorCollection';
  collection: Array<WorkforceReportRecordError>;
  metadata: CollectionMetadata;
};

export type WorkforceReportResult = {
  __typename?: 'WorkforceReportResult';
  id: Scalars['ID']['output'];
  paybandLabel?: Maybe<PaybandLevelEnum>;
  paybandMax: Money;
  paybandMin: Money;
  paybandPercentage: Scalars['Float']['output'];
  record: WorkforceReportRecord;
  roleMatch: WorkforceReportRoleMatch;
  seniorityLevel: WorkforceReportSeniorityLevel;
};

export type WorkforceReportResultCollection = {
  __typename?: 'WorkforceReportResultCollection';
  collection: Array<WorkforceReportResult>;
  metadata: CollectionMetadata;
};

export type WorkforceReportResultsData = {
  __typename?: 'WorkforceReportResultsData';
  /** Returns a Workforce report results list */
  results: WorkforceReportResultCollection;
  resultsSummary: ResultsSummary;
};


export type WorkforceReportResultsDataResultsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type WorkforceReportRoleMatch = {
  __typename?: 'WorkforceReportRoleMatch';
  authorizations?: Maybe<Authorization>;
  companyRoleName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  matchPrecisionLevel: MatchPrecisionLevelEnum;
  recordsCount: Scalars['Int']['output'];
  roleType?: Maybe<RoleType>;
};

export type WorkforceReportRoleMatchByRecord = {
  __typename?: 'WorkforceReportRoleMatchByRecord';
  authorizations?: Maybe<Authorization>;
  employeesMatchedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  roleMatch: WorkforceReportRoleMatch;
  seniorityLevel?: Maybe<WorkforceReportSeniorityLevel>;
};

export type WorkforceReportRoleMatchByRecordCollection = {
  __typename?: 'WorkforceReportRoleMatchByRecordCollection';
  collection: Array<WorkforceReportRoleMatchByRecord>;
  metadata: CollectionMetadata;
};

export type WorkforceReportRoleMatchCollection = {
  __typename?: 'WorkforceReportRoleMatchCollection';
  collection: Array<WorkforceReportRoleMatch>;
  metadata: CollectionMetadata;
};

export type WorkforceReportSeniorityLevel = {
  __typename?: 'WorkforceReportSeniorityLevel';
  authorizations?: Maybe<Authorization>;
  companySeniorityLevel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internalSeniorityLevel?: Maybe<SeniorityLevel>;
  oysterSeniorityLevel?: Maybe<Scalars['String']['output']>;
};

export type WorkforceReportSeniorityLevelCollection = {
  __typename?: 'WorkforceReportSeniorityLevelCollection';
  collection: Array<WorkforceReportSeniorityLevel>;
  metadata: CollectionMetadata;
};

export enum WorkforceReportStatus {
  FileProcessingCompleted = 'FILE_PROCESSING_COMPLETED',
  FileProcessingFailed = 'FILE_PROCESSING_FAILED',
  FileProcessingStarted = 'FILE_PROCESSING_STARTED',
  ReportFinalized = 'REPORT_FINALIZED',
  RoleMatchesCreated = 'ROLE_MATCHES_CREATED',
  SeniorityLevelsMatched = 'SENIORITY_LEVELS_MATCHED'
}

/** Autogenerated input type of approveCountryPayroll */
export type ApproveCountryPayrollInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryPayrollId: Scalars['ID']['input'];
};

/** Autogenerated return type of approveCountryPayroll. */
export type ApproveCountryPayrollPayload = {
  __typename?: 'approveCountryPayrollPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryPayroll?: Maybe<FtePayoutCountryPayrollType>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of benefits_enrollment_changes_request_report */
export type Benefits_Enrollment_Changes_Request_ReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
};

/** Autogenerated return type of benefits_enrollment_changes_request_report. */
export type Benefits_Enrollment_Changes_Request_ReportPayload = {
  __typename?: 'benefits_enrollment_changes_request_reportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of documentGeneratorCreateGeneration */
export type DocumentGeneratorCreateGenerationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  engagementDocuments: Array<CreateGenerationInput>;
};

/** Autogenerated return type of documentGeneratorCreateGeneration. */
export type DocumentGeneratorCreateGenerationPayload = {
  __typename?: 'documentGeneratorCreateGenerationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  generation?: Maybe<InternalDocumentGeneration>;
};

/** Autogenerated input type of documentGeneratorSendArchive */
export type DocumentGeneratorSendArchiveInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  generationId: Scalars['ID']['input'];
};

/** Autogenerated return type of documentGeneratorSendArchive. */
export type DocumentGeneratorSendArchivePayload = {
  __typename?: 'documentGeneratorSendArchivePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of importCountryPayroll */
export type ImportCountryPayrollInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryCode: CountryIsoCode;
  importFileId: Scalars['ID']['input'];
  yearMonth: Scalars['String']['input'];
};

/** Autogenerated return type of importCountryPayroll. */
export type ImportCountryPayrollPayload = {
  __typename?: 'importCountryPayrollPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryPayroll?: Maybe<FtePayoutCountryPayrollType>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of updateCountryPayrollState */
export type UpdateCountryPayrollStateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  countryPayrollId: Scalars['ID']['input'];
  event: CountryPayrollTransitionEvent;
};

/** Autogenerated return type of updateCountryPayrollState. */
export type UpdateCountryPayrollStatePayload = {
  __typename?: 'updateCountryPayrollStatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  countryPayroll: FtePayoutCountryPayrollType;
  errors: Array<Scalars['String']['output']>;
};

export type ProcessHighwayFragment = { __typename?: 'Hiring', companyProcess: { __typename?: 'EmploymentsHiringCompanyProcess', steps: Array<{ __typename?: 'EmploymentsHiringCompanyProcessStep', name: EmploymentsHiringCompanyProcessStepName, progress: EmploymentsHiringStepProgress, staffNotes: { __typename?: 'StaffNoteConnection', id: string, totalCount: number, postingContext: string } }> }, employeeProcess: { __typename?: 'EmploymentsHiringEmployeeProcess', steps: Array<{ __typename?: 'EmploymentsHiringEmployeeProcessStep', name: EmploymentsHiringEmployeeProcessStepName, progress: EmploymentsHiringStepProgress, staffNotes: { __typename?: 'StaffNoteConnection', id: string, totalCount: number, postingContext: string } }> } };

export type ProcessHighwayStaffNotesFragment = { __typename?: 'StaffNoteConnection', id: string, totalCount: number, postingContext: string };

export type HiringFormEmploymentFieldsFragment = { __typename?: 'Employment', id: string, state: string, countryCode?: string | null, subdivisionCode?: string | null, role?: string | null, seniorityLevel?: EngagementSeniorityLevelType | null, engagementType: EngagementType, employmentType?: string | null, partTimeDaysPerWeek?: number | null, partTimeHoursPerDay?: number | null, fullTimeHoursPerWeek?: number | null, managerRole?: string | null, managerName?: string | null, startDate?: any | null, initialStartDate?: any | null, isPayrollTeamMember: boolean, probationEnd?: any | null, endDate?: any | null, jobDescription?: string | null, minimumQualification?: string | null, dailyResponsibility?: string | null, primaryDuty?: string | null, decisionMakingAuthority?: string | null, salaryAmount?: number | null, salaryCurrencyCode?: string | null, hourlyRate?: number | null, lockedCurrencyCode?: CurrencyEnum | null, bonusAmount?: number | null, bonusCurrencyCode?: string | null, providedEquipmentList?: Array<EquipmentListEnum> | null, providedEquipmentOther?: string | null, providedEquipmentPolicy?: EquipmentPolicyEnum | null, benefitsDescription?: string | null, privateNotes?: string | null, offerLetterSendRequested: boolean, newHireStatus: EngagementNewHireStatusType, managerEmailAddress?: string | null, managerPhoneNumber?: string | null, managerIsExpenseApprover: boolean, probationPeriodValue?: number | null, probationPeriodType?: EngagementProbationPeriodType | null, probationPeriod?: any | null, paidHolidayDays?: number | null, commissionPlanOffered?: boolean | null, equityOffered?: boolean | null, visaDocumentUrl?: string | null, visaRequired?: boolean | null, workFocusedWithinCountryOfResidence?: boolean | null, cutoffMonthDay: number, employmentComplianceCheck?: boolean | null, employmentComplianceDetails?: string | null, depositBeforeLiability?: boolean | null, availableAllowancePolicies: Array<ReimbursementPolicyEnum>, personalInfo: { __typename?: 'EmploymentPersonalInfo', fullLegalName: string, email?: string | null, nationality?: CountryIsoCode | null }, providedEquipmentPolicyBudget?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string, subunitToUnit: number } | null, reimbursementPolicy?: { __typename?: 'ReimbursementPolicy', policy?: ReimbursementPolicyEnum | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string, subunitToUnit: number } | null } | null, commissionPlan?: { __typename?: 'Document', id: string, title: string, description?: string | null, filename: string } | null, company: { __typename?: 'Company', id: string, countrySales?: { __typename?: 'CountrySales', mightSellInChina?: boolean | null, mightSellInIsrael?: boolean | null, mightSellInColombia?: boolean | null, mightSellInBolivia?: boolean | null } | null, authorizations?: { __typename?: 'Authorization', actions: Array<string>, fields: Array<string> } | null }, department?: { __typename?: 'Department', id: string, name?: string | null } | null, suggestedBenefitPlans?: Array<{ __typename?: 'BenefitsPlan', id: string, descriptiveName: string, name: string, provider: { __typename?: 'BenefitsProvider', name: string }, priceEstimate?: { __typename?: 'BenefitsPlanPrice', currencies: Array<{ __typename?: 'Money', subunit: any, formatted: string, currencyCode: string, subunitToUnit: number }> } | null }> | null, benefitsEnrollments: { __typename?: 'BenefitsEnrollmentCollection', collection: Array<{ __typename?: 'BenefitsEnrollment', id: string, plan: { __typename?: 'BenefitsPlan', id: string } }> }, benefitsProvisionedEnrollments: { __typename?: 'BenefitsProvisionedEnrollmentCollection', collection: Array<{ __typename?: 'BenefitsProvisionedEnrollment', id: string, plan: { __typename?: 'BenefitsPlan', id: string } }> }, hiring?: { __typename?: 'Hiring', id: string, selfServiceOnboarding: boolean, isAgreementESignEnabled: boolean, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isAutomated: boolean, lastUpdate?: { __typename?: 'AgreementIteration', timestamp: any } | null }> } | null, variableCompensations: { __typename?: 'VariableCompensationLegacyConnection', nodes?: Array<{ __typename?: 'VariableCompensation', id: string, label: VariableCompensationLabelEnum, changeReason?: string | null, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, customLabel?: string | null, effectiveEndDate?: any | null, effectiveDate?: any | null, guaranteed?: boolean | null, includedInGrossSalary?: boolean | null, statutory?: boolean | null, systemGenerated?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths: Array<MonthsEnum>, prorated?: boolean | null, editedAfterCreationFromTemplate?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null, variableCompensationTemplate?: { __typename?: 'VariableCompensationTemplate', id?: string | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null } | null } | null> | null }, visa: { __typename?: 'EmploymentVisa', acquisionFee?: number | null, acquisionFeeCurrencyCode?: string | null, acquisitionPayer: VisaAcquisitionPayerTypeEnum, documentUrl?: string | null, expirationDate?: any | null, required?: boolean | null, document?: { __typename?: 'Document', id: string, title: string, description?: string | null, filename: string } | null }, restrictiveCovenants?: { __typename?: 'RestrictiveCovenants', confidentiality: boolean, nonCompetition: boolean, nonSolicitation: boolean, nonSolicitationCustomers?: boolean | null, nonSolicitationEmployees?: boolean | null, postTerminationDurationMonths?: number | null, postTerminationAmountAbsoluteSubunit?: any | null, postTerminationAmountPercentage?: number | null, postTerminationPaymentFrequency?: PostTerminationPaymentFrequency | null, postTerminationAcknowledged?: boolean | null, postTerminationRestrictedArea?: PostTerminationRestrictedArea | null, postTerminationAreaOfBusiness?: string | null, postTerminationAreaOfBusinessInLocalLanguage?: string | null, postTerminationAdditionalAreas: Array<CountryIsoCode> } | null, employmentTemplate?: { __typename?: 'EmploymentTemplate', commissionPlanOffered?: boolean | null, countryCode?: CountryIsoCode | null, description?: string | null, equityOffered?: boolean | null, id?: string | null, name: string, oysterScore?: CountryIntelligenceOysterScore | null, paidHolidayDays?: number | null, probationPeriod?: any | null, status: EmploymentTemplateStatus, commissionPlan?: { __typename?: 'Document', id: string, title: string, description?: string | null, filename: string } | null, company: { __typename?: 'Company', id: string, paymentCurrencyCode?: string | null }, variableCompensationTemplates: Array<{ __typename?: 'VariableCompensationTemplate', id?: string | null, label: VariableCompensationLabelEnum, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, guaranteed?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths?: Array<MonthsEnum> | null, statutory: boolean, systemGenerated: boolean, prorated?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null }>, remoteWorkCosts?: { __typename?: 'EngagementRemoteWorkCostObjectType', equipmentListProvidedByCustomer?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentListOwnedByTeamMember?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentBudget?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentOneTimePayment?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, allowancePolicy?: { __typename?: 'EngagementRemoteWorkCostAllowancePolicyObjectType', active: boolean, selectable: boolean, isStatutory: boolean, statutoryPolicySubunit: any, topUpPolicySubunit: any, allowancePolicySubunit: any, allowancePolicy?: ReimbursementPolicyEnum | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, compatibleAllowancePolicies?: Array<ReimbursementPolicyEnum> | null } | null } | null, benefitsEnrollmentTemplate?: { __typename?: 'BenefitsEnrollmentTemplateType', id: string, tier?: { __typename?: 'BenefitsTier', id: string, name: string, includedPlans: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> } | null, pensions?: Array<{ __typename?: 'BenefitsEnrollmentTemplatePensionType', plan: { __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string }, planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null }, costContribution?: { __typename?: 'BenefitsEnrollmentTemplatePensionCostContributionType', contributor: BenefitsEnrollmentCostContributorEnum, amountAsPercentage: number } | null }> | null, supplementaryBenefits?: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, category: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> | null, preferredCostSplit?: Array<{ __typename?: 'CostSplitSetting', planId: string, employerContribution: number, dependentsEmployerContribution: number, dependentsEmployerContributionMaxCount: number, plan: { __typename?: 'BenefitsPlan', id: string, name: string, costSplitAllowed: boolean, provider: { __typename?: 'BenefitsProvider', name: string } } }> | null } | null } | null, reimbursementBudgets: { __typename?: 'ReimbursementBudgetLegacyConnection', nodes?: Array<{ __typename?: 'ReimbursementBudget', id: string, label: ReimbursementBudgetLabelEnum, changeReason?: string | null, customLabel?: string | null, effectiveDate?: any | null, effectiveEndDate?: any | null, resetFrequency: ResetFrequencyEnum, amount: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } } | null> | null }, roleType?: { __typename?: 'RoleType', id: string, name: string, description?: string | null } | null, sickPay?: { __typename?: 'SickPay', customDurationUnit?: SickPayDurationUnitEnum | null, customDurationValue?: number | null, id: string, option: string } | null, latestSalaryCurrencyConversion?: { __typename?: 'SalaryCurrencyConversion', id: string, exchangeRateValue: number, expired: boolean, receivedCurrencyCode: string, receivedAmount: number } | null, workSchedules?: Array<{ __typename?: 'WorkSchedule', day: DayOfWeekEnum, startTime: string, endTime: string }> | null, resignationNotice?: { __typename?: 'ContractualResignation', type: TypesEngagementContractualResignationTypeEnum, duration?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null, remoteWorkCosts?: { __typename?: 'EngagementRemoteWorkCostObjectType', equipmentListProvidedByCustomer?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, equipmentListOwnedByTeamMember?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, equipmentBudget?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, equipmentOneTimePayment?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, allowancePolicy?: { __typename?: 'EngagementRemoteWorkCostAllowancePolicyObjectType', active: boolean, selectable: boolean, isStatutory: boolean, statutoryPolicySubunit: any, topUpPolicySubunit: any, allowancePolicySubunit: any, allowancePolicy?: ReimbursementPolicyEnum | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, compatibleAllowancePolicies?: Array<ReimbursementPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null } | null, contractedTerminationNotice?: { __typename?: 'ContractualTermination', type: TypesEngagementContractualTerminationTypeEnum, duration?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null };

export type HiringFteCompanyRegenerationInfoAlertFragmentFragment = { __typename?: 'Hiring', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, isAutomated: boolean }> };

export type HiringFteCompanyRegenerationInfoModalFragmentFragment = { __typename?: 'Hiring', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, isAutomated: boolean, agreementType: AgreementTypeEnum, lastUpdate?: { __typename?: 'AgreementIteration', timestamp: any } | null }> };

export type RestrictiveCovenantsSectionFragmentFragment = { __typename?: 'RestrictiveCovenants', confidentiality: boolean, nonCompetition: boolean, nonSolicitation: boolean, nonSolicitationCustomers?: boolean | null, nonSolicitationEmployees?: boolean | null, postTerminationDurationMonths?: number | null, postTerminationAmountAbsoluteSubunit?: any | null, postTerminationAmountPercentage?: number | null, postTerminationPaymentFrequency?: PostTerminationPaymentFrequency | null, postTerminationAcknowledged?: boolean | null, postTerminationRestrictedArea?: PostTerminationRestrictedArea | null, postTerminationAreaOfBusiness?: string | null, postTerminationAreaOfBusinessInLocalLanguage?: string | null, postTerminationAdditionalAreas: Array<CountryIsoCode> };

export type BenefitsEngagementFragmentFragment = { __typename?: 'Engagement', subdivisionCode?: string | null, benefitsDescription?: string | null, benefitsProvisionedAddons: { __typename?: 'BenefitsPlanCollection', collection: Array<{ __typename?: 'BenefitsPlan', id: string, category: string, planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null }> }, benefitsEnrolledPackages: { __typename?: 'BenefitsEnrolledPackageCollection', collection: Array<{ __typename?: 'BenefitsEnrolledPackage', tier: { __typename?: 'BenefitsTier', id: string } }> }, variableCompensations: { __typename?: 'VariableCompensationLegacyConnection', nodes?: Array<{ __typename?: 'VariableCompensation', id: string, label: VariableCompensationLabelEnum, changeReason?: string | null, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, customLabel?: string | null, effectiveEndDate?: any | null, effectiveDate?: any | null, guaranteed?: boolean | null, includedInGrossSalary?: boolean | null, statutory?: boolean | null, systemGenerated?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths: Array<MonthsEnum>, prorated?: boolean | null, editedAfterCreationFromTemplate?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null, variableCompensationTemplate?: { __typename?: 'VariableCompensationTemplate', id?: string | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null } | null } | null> | null }, benefitsProvisionedEnrollments: { __typename?: 'BenefitsProvisionedEnrollmentCollection', collection: Array<{ __typename?: 'BenefitsProvisionedEnrollment', plan: { __typename?: 'BenefitsPlan', id: string, name: string, category: string, guideUrl?: string | null, coverageTypes: Array<BenefitsCoverageTypeEnum>, descriptiveName: string, provider: { __typename?: 'BenefitsProvider', name: string }, planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null }, enrollmentCostContributions?: { __typename?: 'BenefitsEnrollmentCostContributionCollection', collection: Array<{ __typename?: 'BenefitsEnrollmentCostContribution', id: string, contributor: BenefitsEnrollmentCostContributorEnum, amount?: any | null, amountAsPercentage?: number | null }> } | null }> }, equityGrants: Array<{ __typename?: 'EquityGrant', id: string, status: EquityStatusEnum, grantDate: any, equityType: EquityTypeEnum, grantShares?: number | null, equitySubType?: EquitySubTypeEnum | null, vestingStartDate: any, vestingCliffMonths?: number | null, vestingCliffShares?: number | null, vestingScheduleMonths?: number | null, grantAmount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string, subunitToUnit: number } | null }> };

export type ResignationNoticeFragmentFragment = { __typename?: 'Employment', resignationNotice?: { __typename?: 'ContractualResignation', type: TypesEngagementContractualResignationTypeEnum, duration?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null };

export type ContractedTerminationNoticeFragmentFragment = { __typename?: 'Employment', contractedTerminationNotice?: { __typename?: 'ContractualTermination', type: TypesEngagementContractualTerminationTypeEnum, duration?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null };

export type CountrySalesFieldsFragment = { __typename?: 'CountrySales', mightSellInChina?: boolean | null, mightSellInIsrael?: boolean | null, mightSellInColombia?: boolean | null, mightSellInBolivia?: boolean | null };

export type CustomerProcessHighwayFragment = { __typename?: 'Hiring', companyProcess: { __typename?: 'EmploymentsHiringCompanyProcess', currentStep: { __typename?: 'EmploymentsHiringCompanyProcessStep', name: EmploymentsHiringCompanyProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringCompanyProcessStep', progress: EmploymentsHiringStepProgress, name: EmploymentsHiringCompanyProcessStepName }> }, employeeProcess: { __typename?: 'EmploymentsHiringEmployeeProcess', currentStep: { __typename?: 'EmploymentsHiringEmployeeProcessStep', name: EmploymentsHiringEmployeeProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringEmployeeProcessStep', progress: EmploymentsHiringStepProgress, name: EmploymentsHiringEmployeeProcessStepName }> } };

export type BenefitsEnrollmentTemplateFragmentFragment = { __typename?: 'BenefitsEnrollmentTemplateType', id: string, tier?: { __typename?: 'BenefitsTier', id: string, name: string, includedPlans: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> } | null, pensions?: Array<{ __typename?: 'BenefitsEnrollmentTemplatePensionType', plan: { __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string }, planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null }, costContribution?: { __typename?: 'BenefitsEnrollmentTemplatePensionCostContributionType', contributor: BenefitsEnrollmentCostContributorEnum, amountAsPercentage: number } | null }> | null, supplementaryBenefits?: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, category: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> | null, preferredCostSplit?: Array<{ __typename?: 'CostSplitSetting', planId: string, employerContribution: number, dependentsEmployerContribution: number, dependentsEmployerContributionMaxCount: number, plan: { __typename?: 'BenefitsPlan', id: string, name: string, costSplitAllowed: boolean, provider: { __typename?: 'BenefitsProvider', name: string } } }> | null };

export type EmploymentTemplateFragmentFragment = { __typename?: 'EmploymentTemplate', commissionPlanOffered?: boolean | null, countryCode?: CountryIsoCode | null, description?: string | null, equityOffered?: boolean | null, id?: string | null, name: string, oysterScore?: CountryIntelligenceOysterScore | null, paidHolidayDays?: number | null, probationPeriod?: any | null, status: EmploymentTemplateStatus, commissionPlan?: { __typename?: 'Document', id: string, title: string, description?: string | null, filename: string } | null, company: { __typename?: 'Company', id: string, paymentCurrencyCode?: string | null }, variableCompensationTemplates: Array<{ __typename?: 'VariableCompensationTemplate', id?: string | null, label: VariableCompensationLabelEnum, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, guaranteed?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths?: Array<MonthsEnum> | null, statutory: boolean, systemGenerated: boolean, prorated?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null }>, remoteWorkCosts?: { __typename?: 'EngagementRemoteWorkCostObjectType', equipmentListProvidedByCustomer?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentListOwnedByTeamMember?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentBudget?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentOneTimePayment?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, allowancePolicy?: { __typename?: 'EngagementRemoteWorkCostAllowancePolicyObjectType', active: boolean, selectable: boolean, isStatutory: boolean, statutoryPolicySubunit: any, topUpPolicySubunit: any, allowancePolicySubunit: any, allowancePolicy?: ReimbursementPolicyEnum | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, compatibleAllowancePolicies?: Array<ReimbursementPolicyEnum> | null } | null } | null, benefitsEnrollmentTemplate?: { __typename?: 'BenefitsEnrollmentTemplateType', id: string, tier?: { __typename?: 'BenefitsTier', id: string, name: string, includedPlans: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> } | null, pensions?: Array<{ __typename?: 'BenefitsEnrollmentTemplatePensionType', plan: { __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string }, planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null }, costContribution?: { __typename?: 'BenefitsEnrollmentTemplatePensionCostContributionType', contributor: BenefitsEnrollmentCostContributorEnum, amountAsPercentage: number } | null }> | null, supplementaryBenefits?: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, category: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> | null, preferredCostSplit?: Array<{ __typename?: 'CostSplitSetting', planId: string, employerContribution: number, dependentsEmployerContribution: number, dependentsEmployerContributionMaxCount: number, plan: { __typename?: 'BenefitsPlan', id: string, name: string, costSplitAllowed: boolean, provider: { __typename?: 'BenefitsProvider', name: string } } }> | null } | null };

export type EnrollmentCostContributionsFieldsFragment = { __typename?: 'BenefitsEnrollmentCostContribution', id: string, contributor: BenefitsEnrollmentCostContributorEnum, amount?: any | null, amountAsPercentage?: number | null };

export type MoneyFieldsFragment = { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string, subunitToUnit: number };

export type PlanContributionSettingFragmentFragment = { __typename?: 'BenefitsPlan', planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null };

export type ProvisionedEnrollmentCostContributionsFragmentFragment = { __typename?: 'BenefitsProvisionedEnrollment', enrollmentCostContributions?: { __typename?: 'BenefitsEnrollmentCostContributionCollection', collection: Array<{ __typename?: 'BenefitsEnrollmentCostContribution', id: string, contributor: BenefitsEnrollmentCostContributorEnum, amount?: any | null, amountAsPercentage?: number | null }> } | null };

export type ReimbursementBudgetFragmentFragment = { __typename?: 'ReimbursementBudget', id: string, label: ReimbursementBudgetLabelEnum, changeReason?: string | null, customLabel?: string | null, effectiveDate?: any | null, effectiveEndDate?: any | null, resetFrequency: ResetFrequencyEnum, amount: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } };

export type RemoteWorkCostsFragmentFragment = { __typename?: 'Employment', availableAllowancePolicies: Array<ReimbursementPolicyEnum>, remoteWorkCosts?: { __typename?: 'EngagementRemoteWorkCostObjectType', equipmentListProvidedByCustomer?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, equipmentListOwnedByTeamMember?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, equipmentBudget?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, equipmentOneTimePayment?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, allowancePolicy?: { __typename?: 'EngagementRemoteWorkCostAllowancePolicyObjectType', active: boolean, selectable: boolean, isStatutory: boolean, statutoryPolicySubunit: any, topUpPolicySubunit: any, allowancePolicySubunit: any, allowancePolicy?: ReimbursementPolicyEnum | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, compatibleAllowancePolicies?: Array<ReimbursementPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null } | null };

export type RemoteWorkCostsTemplateFragmentFragment = { __typename?: 'EngagementRemoteWorkCostObjectType', equipmentListProvidedByCustomer?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentListOwnedByTeamMember?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentBudget?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentOneTimePayment?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, allowancePolicy?: { __typename?: 'EngagementRemoteWorkCostAllowancePolicyObjectType', active: boolean, selectable: boolean, isStatutory: boolean, statutoryPolicySubunit: any, topUpPolicySubunit: any, allowancePolicySubunit: any, allowancePolicy?: ReimbursementPolicyEnum | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, compatibleAllowancePolicies?: Array<ReimbursementPolicyEnum> | null } | null };

export type RoleTypeFragmentFragment = { __typename?: 'RoleType', id: string, name: string, description?: string | null };

export type TodoTasksTaskDetailsFragment = { __typename?: 'TodoTasksTask', category: TodoTasksTaskCategory, checkAvailableFor: Array<TodoTasksParty>, id: string, name: string, parties: Array<TodoTasksParty>, position: number, state: TodoTasksTaskState, visibleTo: Array<TodoTasksParty>, completedAt?: any | null, completedBy?: { __typename?: 'Actor', name?: string | null, isOysterStaff: boolean } | null };

export type VariableCompensationFragmentFragment = { __typename?: 'VariableCompensation', id: string, label: VariableCompensationLabelEnum, changeReason?: string | null, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, customLabel?: string | null, effectiveEndDate?: any | null, effectiveDate?: any | null, guaranteed?: boolean | null, includedInGrossSalary?: boolean | null, statutory?: boolean | null, systemGenerated?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths: Array<MonthsEnum>, prorated?: boolean | null, editedAfterCreationFromTemplate?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null, variableCompensationTemplate?: { __typename?: 'VariableCompensationTemplate', id?: string | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null } | null };

export type BonusInputFragmentFragment = { __typename?: 'Bonus', label: string, customLabel?: string | null, amountType: string, amountAsPercentage?: string | null, paymentFrequency: PaymentFrequencyEnum, guaranteed?: boolean | null, selectedMonths: Array<MonthsEnum>, fixedAmount?: { __typename?: 'FixedAmount', amount?: string | null, currencyCode?: string | null } | null };

export type AllowanceInputFragmentFragment = { __typename?: 'Allowance', label: string, customLabel?: string | null, amountType: string, amountAsPercentage?: string | null, paymentFrequency: PaymentFrequencyEnum, guaranteed?: boolean | null, selectedMonths: Array<MonthsEnum>, fixedAmount?: { __typename?: 'FixedAmount', amount?: string | null, currencyCode?: string | null } | null };

export type VariableCompensationTemplateFragmentFragment = { __typename?: 'VariableCompensationTemplate', id?: string | null, label: VariableCompensationLabelEnum, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, guaranteed?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths?: Array<MonthsEnum> | null, statutory: boolean, systemGenerated: boolean, prorated?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null };

export type VariableCompensationTemplatePayloadFragmentFragment = { __typename?: 'VariableCompensationTemplate', id?: string | null, label: VariableCompensationLabelEnum, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, guaranteed?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths?: Array<MonthsEnum> | null, prorated?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null };

export type CalendarDurationFragmentFragment = { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null };

export type CalendarDurationRangeFragmentFragment = { __typename?: 'CalendarDurationRange', max?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null, min?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null };

export type AllowancesRulesFragmentFragment = { __typename?: 'CountryIntelligenceRulesAllowances', type: CountryIntelligenceRulesAllowancesType, partOfGrossSalary: boolean, paidWhen?: CountryIntelligenceRulesAllowancesPaidWhen | null, oysterScore: CountryIntelligenceOysterScore, value?: Array<string> | null, approximation: boolean };

export type ProbationRulesFragmentFragment = { __typename?: 'CountryIntelligenceRulesProbation', oysterScore: CountryIntelligenceOysterScore, employmentType: CountryIntelligenceEmploymentType, teamMemberLevel?: CountryIntelligenceTeamMemberLevel | null, teamMemberSeniorities?: Array<CountryIntelligenceTeamMemberSeniority> | null, duration: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null }, extension?: { __typename?: 'CountryIntelligenceRulesProbationExtension', deadline?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null, maxAdditionalDuration?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null, tenureRange?: { __typename?: 'CalendarDurationRange', max?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null, min?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null };

export type ResignationRulesFragmentFragment = { __typename?: 'CountryIntelligenceRulesResignation', duringProbation: boolean, tenureRange?: { __typename?: 'CalendarDurationRange', max?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null, min?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null, notice: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } };

export type TerminationRulesFragmentFragment = { __typename?: 'CountryIntelligenceRulesTermination', duringProbation: boolean, tenureRange?: { __typename?: 'CalendarDurationRange', max?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null, min?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null, notice: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } };

export type TimeOffRulesFragmentFragment = { __typename?: 'CountryIntelligenceRulesTimeOff', type?: CountryIntelligenceRulesTimeOffType | null, oysterScore?: CountryIntelligenceOysterScore | null, amountPerYear?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null };

export type RestrictiveCovenantsRulesFragment = { __typename?: 'CountryIntelligenceRulesRestrictiveCovenants', postTermination?: { __typename?: 'CountryIntelligenceRulesRestrictiveCovenantsPostTermination', paymentRequired: boolean, maxDuration?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null, suggestedDurations: Array<{ __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null }>, paymentRules: Array<{ __typename?: 'PostTerminationPaymentRule', amountType: PostTerminationPaymentAmountType, frequencyRules: Array<{ __typename?: 'PostTerminationPaymentFrequencyRule', frequency: PostTerminationPaymentFrequency, amountTopOfMarket?: { __typename?: 'PostTerminationPaymentAmount', percentage?: number | null, flat?: { __typename?: 'Money', currencyCode: string, subunit: any, subunitToUnit: number, formatted: string } | null } | null, amountRecommended?: { __typename?: 'PostTerminationPaymentAmount', percentage?: number | null, flat?: { __typename?: 'Money', currencyCode: string, subunit: any, subunitToUnit: number, formatted: string } | null } | null, amountStatutory?: { __typename?: 'PostTerminationPaymentAmount', percentage?: number | null, flat?: { __typename?: 'Money', currencyCode: string, subunit: any, subunitToUnit: number, formatted: string } | null } | null, restrictedAreaRules: Array<{ __typename?: 'PostTerminationRestrictedAreaPaymentRule', additionalAreasAllowed: boolean, restrictedArea: PostTerminationRestrictedArea, amountTopOfMarket?: { __typename?: 'PostTerminationPaymentAmount', percentage?: number | null, flat?: { __typename?: 'Money', currencyCode: string, subunit: any, subunitToUnit: number, formatted: string } | null } | null, amountRecommended?: { __typename?: 'PostTerminationPaymentAmount', percentage?: number | null, flat?: { __typename?: 'Money', currencyCode: string, subunit: any, subunitToUnit: number, formatted: string } | null } | null, amountStatutory?: { __typename?: 'PostTerminationPaymentAmount', percentage?: number | null, flat?: { __typename?: 'Money', currencyCode: string, subunit: any, subunitToUnit: number, formatted: string } | null } | null }> }> }> } | null, restrictedClauses?: { __typename?: 'RestrictedClauses', nonCompetition: boolean, nonSolicitation: boolean, nonSolicitationCustomers: boolean, nonSolicitationEmployees: boolean } | null };

export type CompanyBulkProcessingFragment = { __typename?: 'HiringBulkProcessing', id: string, strongId: string, countTotal?: number | null, initiatedOn: any, state: HiringBulkProcessingState, countsByEngagementType: Array<{ __typename?: 'HiringBulkProcessingCountByEngagementType', count: number, engagementType: HiringBulkProcessingEngagementType }>, report: { __typename?: 'HiringBulkProcessingReport', errors?: Array<string> | null, failed?: Array<{ __typename?: 'HiringBulkProcessingReportItem', errors?: Array<string> | null, strongId?: string | null }> | null } };

export type StaffGetCompanyBulkOnboardingsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StaffGetCompanyBulkOnboardingsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, bulkOnboardings?: { __typename?: 'BulkOnboardingCollection', collection: Array<{ __typename?: 'BulkOnboarding', id: string, strongId: string, engagementType: BulkOnboardingEngagementType, countTotal?: number | null, initiatedOn: any, state: BulkOnboardingStateEnum, mode: BulkOnboardingModeEnum, performer: { __typename?: 'User', email: string }, report: { __typename?: 'BulkOnboardingReport', errors?: Array<string> | null, completed?: Array<{ __typename?: 'BulkOnboardingReportItem', countryCode?: CountryIsoCode | null, email?: string | null, errors?: Array<string> | null, name?: string | null, strongId?: string | null }> | null, failed?: Array<{ __typename?: 'BulkOnboardingReportItem', countryCode?: CountryIsoCode | null, email?: string | null, errors?: Array<string> | null, name?: string | null, strongId?: string | null }> | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } | null } | null };

export type BulkOnboardingFragmentFragment = { __typename?: 'BulkOnboarding', id: string, strongId: string, engagementType: BulkOnboardingEngagementType, countTotal?: number | null, initiatedOn: any, state: BulkOnboardingStateEnum, mode: BulkOnboardingModeEnum, performer: { __typename?: 'User', email: string }, report: { __typename?: 'BulkOnboardingReport', errors?: Array<string> | null, completed?: Array<{ __typename?: 'BulkOnboardingReportItem', countryCode?: CountryIsoCode | null, email?: string | null, errors?: Array<string> | null, name?: string | null, strongId?: string | null }> | null, failed?: Array<{ __typename?: 'BulkOnboardingReportItem', countryCode?: CountryIsoCode | null, email?: string | null, errors?: Array<string> | null, name?: string | null, strongId?: string | null }> | null } };

export type CompanyBulkProcessingEngagementsIdsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  engagementTypes?: InputMaybe<Array<FilterEngagementType> | FilterEngagementType>;
  employmentType?: InputMaybe<EmploymentTypeEnum>;
  contractorBillingType?: InputMaybe<Scalars['String']['input']>;
  teamMemberMonetizationPlanName?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Scalars['String']['input']>;
  assignedStaffId?: InputMaybe<Scalars['ID']['input']>;
  teamMemberCountryCode?: InputMaybe<Scalars['String']['input']>;
  employersOfRecord?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  dummy?: InputMaybe<Scalars['Boolean']['input']>;
  bulkOnboard?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CompanyBulkProcessingEngagementsIdsQuery = { __typename?: 'Query', hiringBulkProcessingCompanyEngagements: { __typename?: 'HiringBulkProcessingCompanyEngagementCollection', metadata: { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number, currentPage: number, limitValue: number }, collection: Array<{ __typename?: 'HiringBulkProcessingCompanyEngagement', id: string, state: EngagementState, engagementType: EngagementType, invitation?: { __typename?: 'Invitation', id: string, usedTokenAt?: any | null } | null }> } };

export type BulkProcessingEngagementInfoFragment = { __typename?: 'HiringBulkProcessingCompanyEngagement', id: string, state: EngagementState, engagementType: EngagementType, invitation?: { __typename?: 'Invitation', id: string, usedTokenAt?: any | null } | null };

export type StaffGetCompanyBulkProcessingsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StaffGetCompanyBulkProcessingsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, hiringBulkProcessings?: { __typename?: 'HiringBulkProcessingCollection', collection: Array<{ __typename?: 'HiringBulkProcessing', id: string, strongId: string, countTotal?: number | null, initiatedOn: any, state: HiringBulkProcessingState, countsByEngagementType: Array<{ __typename?: 'HiringBulkProcessingCountByEngagementType', count: number, engagementType: HiringBulkProcessingEngagementType }>, report: { __typename?: 'HiringBulkProcessingReport', errors?: Array<string> | null, failed?: Array<{ __typename?: 'HiringBulkProcessingReportItem', errors?: Array<string> | null, strongId?: string | null }> | null } }>, metadata: { __typename?: 'CollectionMetadata', currentPage: number, limitValue: number, totalCount: number, totalPages: number } } | null } | null };

export type BulkProcessingReportItemFragment = { __typename?: 'HiringBulkProcessingReportItem', engagementType: HiringBulkProcessingEngagementType, strongId?: string | null, originalValue?: string | null, newValue?: string | null, errors?: Array<string> | null, hasExceptionOccurred?: boolean | null, engagement?: { __typename?: 'Engagement', id: string, teamMemberName?: string | null, engagementType: EngagementType, isPayrollTeamMember: boolean, countryCode?: string | null, contract?: { __typename?: 'Contract', billingType: ContractBilling } | null, employment?: { __typename?: 'Employment', employmentType?: string | null } | null, teamMember?: { __typename?: 'User', id: string, avatarUrl?: string | null } | null } | null };

export type BulkProcessingEngagementFragment = { __typename?: 'Engagement', id: string, teamMemberName?: string | null, engagementType: EngagementType, isPayrollTeamMember: boolean, countryCode?: string | null, contract?: { __typename?: 'Contract', billingType: ContractBilling } | null, employment?: { __typename?: 'Employment', employmentType?: string | null } | null, teamMember?: { __typename?: 'User', id: string, avatarUrl?: string | null } | null };

export type StaffGetBulkProcessingQueryVariables = Exact<{
  bulkProcessingId: Scalars['ID']['input'];
}>;


export type StaffGetBulkProcessingQuery = { __typename?: 'Query', hiringBulkProcessing: { __typename?: 'HiringBulkProcessing', id: string, initiatedOn: any, countTotal?: number | null, operation: HiringBulkProcessingOperation, countsByEngagementType: Array<{ __typename?: 'HiringBulkProcessingCountByEngagementType', engagementType: HiringBulkProcessingEngagementType, count: number }>, report: { __typename?: 'HiringBulkProcessingReport', errors?: Array<string> | null, completed?: Array<{ __typename?: 'HiringBulkProcessingReportItem', engagementType: HiringBulkProcessingEngagementType, strongId?: string | null, originalValue?: string | null, newValue?: string | null, errors?: Array<string> | null, hasExceptionOccurred?: boolean | null, engagement?: { __typename?: 'Engagement', id: string, teamMemberName?: string | null, engagementType: EngagementType, isPayrollTeamMember: boolean, countryCode?: string | null, contract?: { __typename?: 'Contract', billingType: ContractBilling } | null, employment?: { __typename?: 'Employment', employmentType?: string | null } | null, teamMember?: { __typename?: 'User', id: string, avatarUrl?: string | null } | null } | null }> | null, failed?: Array<{ __typename?: 'HiringBulkProcessingReportItem', engagementType: HiringBulkProcessingEngagementType, strongId?: string | null, originalValue?: string | null, newValue?: string | null, errors?: Array<string> | null, hasExceptionOccurred?: boolean | null, engagement?: { __typename?: 'Engagement', id: string, teamMemberName?: string | null, engagementType: EngagementType, isPayrollTeamMember: boolean, countryCode?: string | null, contract?: { __typename?: 'Contract', billingType: ContractBilling } | null, employment?: { __typename?: 'Employment', employmentType?: string | null } | null, teamMember?: { __typename?: 'User', id: string, avatarUrl?: string | null } | null } | null }> | null } } };

export type HiringBulkProcessingQueryVariables = Exact<{
  bulkProcessingId: Scalars['ID']['input'];
}>;


export type HiringBulkProcessingQuery = { __typename?: 'Query', hiringBulkProcessing: { __typename?: 'HiringBulkProcessing', strongId: string, operation: HiringBulkProcessingOperation, countTotal?: number | null, initiatedOn: any, state: HiringBulkProcessingState, performer: { __typename?: 'User', email: string }, countsByEngagementType: Array<{ __typename?: 'HiringBulkProcessingCountByEngagementType', engagementType: HiringBulkProcessingEngagementType, count: number }>, report: { __typename?: 'HiringBulkProcessingReport', errors?: Array<string> | null, completed?: Array<{ __typename?: 'HiringBulkProcessingReportItem', strongId?: string | null, engagementType: HiringBulkProcessingEngagementType, originalValue?: string | null, newValue?: string | null, errors?: Array<string> | null }> | null, failed?: Array<{ __typename?: 'HiringBulkProcessingReportItem', strongId?: string | null, engagementType: HiringBulkProcessingEngagementType, originalValue?: string | null, newValue?: string | null, errors?: Array<string> | null }> | null } } };

export type HiringCreateBulkProcessingMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  performerId: Scalars['ID']['input'];
  engagementIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  operation: HiringBulkProcessingOperation;
  operationArguments?: InputMaybe<HiringBulkProcessingOperationArguments>;
  engagementAttributes?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type HiringCreateBulkProcessingMutation = { __typename?: 'Mutation', hiringCreateBulkProcessing?: { __typename?: 'HiringCreateBulkProcessingPayload', errors: Array<string>, bulkProcessing?: { __typename?: 'HiringBulkProcessing', id: string, operation: HiringBulkProcessingOperation, initiatedOn: any, state: HiringBulkProcessingState, countTotal?: number | null, performer: { __typename?: 'User', id: string } } | null } | null };

export type EngagementsStaffGetStateChangeAffectedEngagementsQueryVariables = Exact<{
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type EngagementsStaffGetStateChangeAffectedEngagementsQuery = { __typename?: 'Query', engagements: { __typename?: 'EngagementCollection', collection: Array<{ __typename?: 'Engagement', countryCode?: string | null, engagementType: EngagementType, id: string, isPayrollTeamMember: boolean, role?: string | null, state: EngagementState, teamMemberName?: string | null, contract?: { __typename?: 'Contract', id: string, billingType: ContractBilling } | null, employment?: { __typename?: 'Employment', employmentType?: string | null, personalInfo: { __typename?: 'EmploymentPersonalInfo', fullLegalName: string } } | null, teamMember?: { __typename?: 'User', avatarUrl?: string | null } | null }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number, currentPage: number, limitValue: number } } };

export type EngagementStateAffectedEngagementsFragment = { __typename?: 'Engagement', countryCode?: string | null, engagementType: EngagementType, id: string, isPayrollTeamMember: boolean, role?: string | null, state: EngagementState, teamMemberName?: string | null, contract?: { __typename?: 'Contract', id: string, billingType: ContractBilling } | null, employment?: { __typename?: 'Employment', employmentType?: string | null, personalInfo: { __typename?: 'EmploymentPersonalInfo', fullLegalName: string } } | null, teamMember?: { __typename?: 'User', avatarUrl?: string | null } | null };

export type BulkProcessingSelectedEngagementsQueryVariables = Exact<{
  engagementIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BulkProcessingSelectedEngagementsQuery = { __typename?: 'Query', hiringBulkProcessingSelectedEngagements: { __typename?: 'EngagementCollection', collection: Array<{ __typename?: 'Engagement', id: string, engagementType: EngagementType, isPayrollTeamMember: boolean, state: EngagementState }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number, currentPage: number, limitValue: number } } };

export type EngagementStateSelectorFragment = { __typename?: 'Engagement', id: string, engagementType: EngagementType, isPayrollTeamMember: boolean, state: EngagementState };

export type StaffGetAgreementHistoryQueryQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
  agreementType: AgreementTypeEnum;
}>;


export type StaffGetAgreementHistoryQueryQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', hiring?: { __typename?: 'Hiring', agreement?: { __typename?: 'Agreement', id: string, events?: Array<{ __typename?: 'AgreementEventType', eventType: AgreementEventTypeEnum, createdAt: any, actorName?: string | null }> | null, envelope?: { __typename?: 'Envelope', events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any, actorName?: string | null, metadata?: any | null }> } | null } | null } | null } | null };

export type HiringEmploymentAgreementsStaffAddSignatoryPointOfContactMutationVariables = Exact<{
  input: AddSignatoryPointOfContactInput;
}>;


export type HiringEmploymentAgreementsStaffAddSignatoryPointOfContactMutation = { __typename?: 'Mutation', addSignatoryPointOfContact?: { __typename?: 'AddSignatoryPointOfContactPayload', errors?: Array<string> | null, company?: { __typename?: 'Company', id: string, authorizations?: { __typename?: 'Authorization', actions: Array<string> } | null, pointsOfContact: { __typename?: 'ExternalPointOfContactCollection', collection: Array<{ __typename?: 'ExternalPointOfContact', id: string, areasOfDomain: Array<string>, email: string, fullName: string, jobTitle?: string | null }> }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null } | null, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', fullName: string, email: string, id: string, phoneNumber?: string | null, phoneCountryCode?: string | null } | null } | null };

export type HiringEmploymentAgreementsCompanyAddSignatoryPointOfContactMutationVariables = Exact<{
  input: AddSignatoryPointOfContactInput;
}>;


export type HiringEmploymentAgreementsCompanyAddSignatoryPointOfContactMutation = { __typename?: 'Mutation', addSignatoryPointOfContact?: { __typename?: 'AddSignatoryPointOfContactPayload', errors?: Array<string> | null, company?: { __typename?: 'Company', id: string, authorizations?: { __typename?: 'Authorization', actions: Array<string> } | null, pointsOfContact: { __typename?: 'ExternalPointOfContactCollection', collection: Array<{ __typename?: 'ExternalPointOfContact', id: string, areasOfDomain: Array<string>, email: string, fullName: string, jobTitle?: string | null }> }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null } | null, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', fullName: string, email: string, id: string, phoneNumber?: string | null, phoneCountryCode?: string | null } | null } | null };

export type StaffDisableESignOsaMutationVariables = Exact<{
  input: DisableESignOsaInput;
}>;


export type StaffDisableESignOsaMutation = { __typename?: 'Mutation', disableESignOsa?: { __typename?: 'DisableESignOsaPayload', errors: Array<string>, hiring?: { __typename?: 'Hiring', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isESignEnabled: boolean }> } | null } | null };

export type EmploymentSignatoryFragmentFragment = { __typename?: 'Employment', signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null };

export type CompanySignatoryFragmentFragment = { __typename?: 'Company', authorizations?: { __typename?: 'Authorization', actions: Array<string> } | null, pointsOfContact: { __typename?: 'ExternalPointOfContactCollection', collection: Array<{ __typename?: 'ExternalPointOfContact', id: string, areasOfDomain: Array<string>, email: string, fullName: string, jobTitle?: string | null }> }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null };

export type HiringEmploymentAgreementsSignatoryDataFragment = { __typename?: 'Employment', id: string, company: { __typename?: 'Company', id: string, authorizations?: { __typename?: 'Authorization', actions: Array<string> } | null, pointsOfContact: { __typename?: 'ExternalPointOfContactCollection', collection: Array<{ __typename?: 'ExternalPointOfContact', id: string, areasOfDomain: Array<string>, email: string, fullName: string, jobTitle?: string | null }> }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null };

export type HiringEmploymentAgreementsStaffGetSignatoryDataQueryVariables = Exact<{
  engagementId: Scalars['ID']['input'];
}>;


export type HiringEmploymentAgreementsStaffGetSignatoryDataQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, company: { __typename?: 'Company', id: string, authorizations?: { __typename?: 'Authorization', actions: Array<string> } | null, pointsOfContact: { __typename?: 'ExternalPointOfContactCollection', collection: Array<{ __typename?: 'ExternalPointOfContact', id: string, areasOfDomain: Array<string>, email: string, fullName: string, jobTitle?: string | null }> }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null } | null };

export type HiringEmploymentAgreementsCompanyGetSignatoryDataQueryVariables = Exact<{
  engagementId: Scalars['ID']['input'];
}>;


export type HiringEmploymentAgreementsCompanyGetSignatoryDataQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, company: { __typename?: 'Company', id: string, authorizations?: { __typename?: 'Authorization', actions: Array<string> } | null, pointsOfContact: { __typename?: 'ExternalPointOfContactCollection', collection: Array<{ __typename?: 'ExternalPointOfContact', id: string, areasOfDomain: Array<string>, email: string, fullName: string, jobTitle?: string | null }> }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null } | null };

export type HiringEmploymentAgreementsStaffAssignSignatoryPointOfContactMutationVariables = Exact<{
  input: AssignSignatoryPointOfContactInput;
}>;


export type HiringEmploymentAgreementsStaffAssignSignatoryPointOfContactMutation = { __typename?: 'Mutation', assignSignatoryPointOfContact?: { __typename?: 'AssignSignatoryPointOfContactPayload', errors?: Array<string> | null, employment?: { __typename?: 'Employment', id: string, company: { __typename?: 'Company', id: string, authorizations?: { __typename?: 'Authorization', actions: Array<string> } | null, pointsOfContact: { __typename?: 'ExternalPointOfContactCollection', collection: Array<{ __typename?: 'ExternalPointOfContact', id: string, areasOfDomain: Array<string>, email: string, fullName: string, jobTitle?: string | null }> }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null } | null } | null };

export type HiringEmploymentAgreementsCompanyAssignSignatoryPointOfContactMutationVariables = Exact<{
  input: AssignSignatoryPointOfContactInput;
}>;


export type HiringEmploymentAgreementsCompanyAssignSignatoryPointOfContactMutation = { __typename?: 'Mutation', assignSignatoryPointOfContact?: { __typename?: 'AssignSignatoryPointOfContactPayload', errors?: Array<string> | null, employment?: { __typename?: 'Employment', id: string, company: { __typename?: 'Company', id: string, authorizations?: { __typename?: 'Authorization', actions: Array<string> } | null, pointsOfContact: { __typename?: 'ExternalPointOfContactCollection', collection: Array<{ __typename?: 'ExternalPointOfContact', id: string, areasOfDomain: Array<string>, email: string, fullName: string, jobTitle?: string | null }> }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null }, signatoryPointOfContact?: { __typename?: 'ExternalPointOfContact', id: string, email: string, fullName: string, jobTitle?: string | null } | null } | null } | null };

export type UpdateAgreementEnvelopeMutationVariables = Exact<{
  input: UpdateAgreementEnvelopeInput;
}>;


export type UpdateAgreementEnvelopeMutation = { __typename?: 'Mutation', updateAgreementEnvelope?: { __typename?: 'UpdateAgreementEnvelopePayload', errors: Array<string>, hiring?: { __typename?: 'Hiring', id: string, envelopes: Array<{ __typename?: 'Envelope', id: string, envelopeType: EnvelopeTypeEnum, isUpdateNeeded: boolean, automationState: EnvelopeAutomationStateEnum }>, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }> } | null } | null };

export type AgreementDetailsQueryVariables = Exact<{
  agreementType: AgreementTypeEnum;
  employmentId: Scalars['ID']['input'];
}>;


export type AgreementDetailsQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, hiring?: { __typename?: 'Hiring', id: string, agreement?: { __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null } | null } | null } | null };

export type DisableAgreementESignMutationMutationVariables = Exact<{
  input: DisableESignInput;
}>;


export type DisableAgreementESignMutationMutation = { __typename?: 'Mutation', disableESign?: { __typename?: 'DisableESignPayload', owner: { __typename?: 'Hiring', id: string, agreements: Array<{ __typename?: 'Agreement', agreementType: AgreementTypeEnum, isESignEnabled: boolean }> } | { __typename?: 'Termination', id: string, agreements: Array<{ __typename?: 'Agreement', agreementType: AgreementTypeEnum, isESignEnabled: boolean }> } } | null };

export type GetAgreementEnvelopeQueryVariables = Exact<{
  engagementId: Scalars['ID']['input'];
  agreementType: AgreementTypeEnum;
  isContractor: Scalars['Boolean']['input'];
}>;


export type GetAgreementEnvelopeQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, hiring?: { __typename?: 'Hiring', id: string, agreement?: { __typename?: 'Agreement', envelope?: { __typename?: 'Envelope', id: string, automationState: EnvelopeAutomationStateEnum, events: Array<{ __typename?: 'EnvelopeEventType', actorName?: string | null, createdAt: any, eventType: EnvelopeEventTypeEnum, metadata?: any | null }>, recipients: Array<{ __typename?: 'EnvelopeRecipientType', email?: string | null, name?: string | null, party?: AgreementPartyTypeEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, currentSigners: Array<{ __typename?: 'EnvelopeRecipientType', email?: string | null, name?: string | null, party?: AgreementPartyTypeEnum | null }> } | null } | null } | null } | null, engagement?: { __typename?: 'Engagement', id: string, contract?: { __typename?: 'Contract', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, envelope?: { __typename?: 'Envelope', id: string, automationState: EnvelopeAutomationStateEnum, events: Array<{ __typename?: 'EnvelopeEventType', actorName?: string | null, createdAt: any, eventType: EnvelopeEventTypeEnum, metadata?: any | null }>, recipients: Array<{ __typename?: 'EnvelopeRecipientType', email?: string | null, name?: string | null, party?: AgreementPartyTypeEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, currentSigners: Array<{ __typename?: 'EnvelopeRecipientType', email?: string | null, name?: string | null, party?: AgreementPartyTypeEnum | null }> } | null }> } | null } | null };

export type SendReminderModalEnvelopeFragment = { __typename?: 'Envelope', id: string, automationState: EnvelopeAutomationStateEnum, events: Array<{ __typename?: 'EnvelopeEventType', actorName?: string | null, createdAt: any, eventType: EnvelopeEventTypeEnum, metadata?: any | null }>, recipients: Array<{ __typename?: 'EnvelopeRecipientType', email?: string | null, name?: string | null, party?: AgreementPartyTypeEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, currentSigners: Array<{ __typename?: 'EnvelopeRecipientType', email?: string | null, name?: string | null, party?: AgreementPartyTypeEnum | null }> };

export type SendAgreementEnvelopeMutationVariables = Exact<{
  input: SendAgreementEnvelopeInput;
}>;


export type SendAgreementEnvelopeMutation = { __typename?: 'Mutation', sendAgreementEnvelope?: { __typename?: 'SendAgreementEnvelopePayload', errors: Array<string>, owner: { __typename?: 'Hiring', id: string, envelopes: Array<{ __typename?: 'Envelope', id: string, envelopeType: EnvelopeTypeEnum, isUpdateNeeded: boolean, automationState: EnvelopeAutomationStateEnum }>, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }> } | { __typename?: 'Termination' } } | null };

export type HiringAgreementsStaffGetAgreementsForEngagedEngagementsQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;


export type HiringAgreementsStaffGetAgreementsForEngagedEngagementsQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', hiring?: { __typename?: 'Hiring', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }> } | null } | null, engagement?: { __typename?: 'Engagement', termination?: { __typename?: 'Termination', agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }> } | null } | null };

export type AgreementDetailsFragment = { __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null };

export type EnvelopeDetailsFragment = { __typename?: 'Envelope', id: string, envelopeType: EnvelopeTypeEnum, isUpdateNeeded: boolean, automationState: EnvelopeAutomationStateEnum };

export type TeamMemberAgreementFragment = { __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, state: AgreementStateEnum, lastUpdate?: { __typename?: 'AgreementIteration', timestamp: any, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null } } | null };

export type EnvelopePollingQueryQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;


export type EnvelopePollingQueryQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, hiring?: { __typename?: 'Hiring', id: string, envelopes: Array<{ __typename?: 'Envelope', id: string, envelopeType: EnvelopeTypeEnum, isUpdateNeeded: boolean, automationState: EnvelopeAutomationStateEnum }>, agreements: Array<{ __typename?: 'Agreement', agreementType: AgreementTypeEnum, isESignEnabled: boolean, state: AgreementStateEnum }> } | null } | null };

export type ContractAgreementsQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
  fetchAgreements: Scalars['Boolean']['input'];
  fetchDisabledAgreements: Scalars['Boolean']['input'];
}>;


export type ContractAgreementsQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, hiring?: { __typename?: 'Hiring', id: string, agreementsSynced?: boolean, disabledAgreements?: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }>, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }> } | null } | null, engagement?: { __typename?: 'Engagement', termination?: { __typename?: 'Termination', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }> } | null } | null };

export type GenerateContractAgreementsMutationVariables = Exact<{
  input: GenerateAgreementsAsyncInput;
}>;


export type GenerateContractAgreementsMutation = { __typename?: 'Mutation', generateAgreementsAsync?: { __typename?: 'GenerateAgreementsAsyncPayload', errors: Array<string>, hiring?: { __typename?: 'Hiring', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }>, companyProcess: { __typename?: 'EmploymentsHiringCompanyProcess', currentStep: { __typename?: 'EmploymentsHiringCompanyProcessStep', name: EmploymentsHiringCompanyProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringCompanyProcessStep', progress: EmploymentsHiringStepProgress, name: EmploymentsHiringCompanyProcessStepName }> }, employeeProcess: { __typename?: 'EmploymentsHiringEmployeeProcess', currentStep: { __typename?: 'EmploymentsHiringEmployeeProcessStep', name: EmploymentsHiringEmployeeProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringEmployeeProcessStep', progress: EmploymentsHiringStepProgress, name: EmploymentsHiringEmployeeProcessStepName }> } } | null } | null };

export type HiringProcessFragmentFragment = { __typename?: 'Employment', hiring?: { __typename?: 'Hiring', hiringProcess?: { __typename?: 'HiringProcess', agreementsFieldsBlocked: boolean } | null, companyProcess: { __typename?: 'EmploymentsHiringCompanyProcess', currentStep: { __typename?: 'EmploymentsHiringCompanyProcessStep', name: EmploymentsHiringCompanyProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringCompanyProcessStep', name: EmploymentsHiringCompanyProcessStepName, progress: EmploymentsHiringStepProgress }> }, employeeProcess: { __typename?: 'EmploymentsHiringEmployeeProcess', currentStep: { __typename?: 'EmploymentsHiringEmployeeProcessStep', name: EmploymentsHiringEmployeeProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringEmployeeProcessStep', name: EmploymentsHiringEmployeeProcessStepName, progress: EmploymentsHiringStepProgress }> } } | null };

export type ContractFieldsQueryFteQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;


export type ContractFieldsQueryFteQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, agreementsFields: Array<string>, state: string, personalInfo: { __typename?: 'EmploymentPersonalInfo', agreementsFields: Array<string> }, restrictiveCovenants?: { __typename?: 'RestrictiveCovenants', agreementsFields: Array<string> } | null, hiring?: { __typename?: 'Hiring', hiringProcess?: { __typename?: 'HiringProcess', agreementsFieldsBlocked: boolean } | null, companyProcess: { __typename?: 'EmploymentsHiringCompanyProcess', currentStep: { __typename?: 'EmploymentsHiringCompanyProcessStep', name: EmploymentsHiringCompanyProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringCompanyProcessStep', name: EmploymentsHiringCompanyProcessStepName, progress: EmploymentsHiringStepProgress }> }, employeeProcess: { __typename?: 'EmploymentsHiringEmployeeProcess', currentStep: { __typename?: 'EmploymentsHiringEmployeeProcessStep', name: EmploymentsHiringEmployeeProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringEmployeeProcessStep', name: EmploymentsHiringEmployeeProcessStepName, progress: EmploymentsHiringStepProgress }> } } | null } | null };

export type ContractFieldsQueryContractorQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;


export type ContractFieldsQueryContractorQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, agreementsFields: Array<string>, state: string, restrictiveCovenants?: { __typename?: 'RestrictiveCovenants', agreementsFields: Array<string> } | null, hiring?: { __typename?: 'Hiring', hiringProcess?: { __typename?: 'HiringProcess', agreementsFieldsBlocked: boolean } | null, companyProcess: { __typename?: 'EmploymentsHiringCompanyProcess', currentStep: { __typename?: 'EmploymentsHiringCompanyProcessStep', name: EmploymentsHiringCompanyProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringCompanyProcessStep', name: EmploymentsHiringCompanyProcessStepName, progress: EmploymentsHiringStepProgress }> }, employeeProcess: { __typename?: 'EmploymentsHiringEmployeeProcess', currentStep: { __typename?: 'EmploymentsHiringEmployeeProcessStep', name: EmploymentsHiringEmployeeProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringEmployeeProcessStep', name: EmploymentsHiringEmployeeProcessStepName, progress: EmploymentsHiringStepProgress }> } } | null } | null };

export type HiringEmploymentAgreementsComanyGetAgreementsGenerationStateViaPollingQueryVariables = Exact<{
  contractId: Scalars['ID']['input'];
}>;


export type HiringEmploymentAgreementsComanyGetAgreementsGenerationStateViaPollingQuery = { __typename?: 'Query', contract?: { __typename?: 'Contract', id: string, engagementId: string, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }>, hiringProcess?: { __typename?: 'ContractHiringProcess', customerTasks: Array<{ __typename?: 'TodoTasksTask', id: string, state: TodoTasksTaskState }> } | null } | null };

export type GenerateContractorAgreementsMutationVariables = Exact<{
  input: GenerateContractorAgreementsAsyncInput;
}>;


export type GenerateContractorAgreementsMutation = { __typename?: 'Mutation', generateContractorAgreementsAsync?: { __typename?: 'GenerateContractorAgreementsAsyncPayload', errors: Array<string>, contract?: { __typename?: 'Contract', id: string, engagementId: string, customerProvidedCountryCode: string, billingType: ContractBilling, scopeOfWork?: string | null, role?: string | null, name?: string | null, startDate?: any | null, salary?: number | null, salaryCurrencyCode?: string | null, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }> } | null } | null };

export type DisableAgreementMutationVariables = Exact<{
  input: DisableAgreementInput;
}>;


export type DisableAgreementMutation = { __typename?: 'Mutation', disableAgreement?: { __typename?: 'DisableAgreementPayload', errors: Array<string>, hiring?: { __typename?: 'Hiring', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, state: AgreementStateEnum }>, disabledAgreements: Array<{ __typename?: 'Agreement', id: string, state: AgreementStateEnum }>, envelopes: Array<{ __typename?: 'Envelope', id: string, isUpdateNeeded: boolean, automationState: EnvelopeAutomationStateEnum }> } | null } | null };

export type EnableAgreementMutationVariables = Exact<{
  input: EnableAgreementInput;
}>;


export type EnableAgreementMutation = { __typename?: 'Mutation', enableAgreement?: { __typename?: 'EnableAgreementPayload', errors: Array<string>, hiring?: { __typename?: 'Hiring', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, state: AgreementStateEnum, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum } | null }>, disabledAgreements: Array<{ __typename?: 'Agreement', id: string, state: AgreementStateEnum }>, envelopes: Array<{ __typename?: 'Envelope', id: string, isUpdateNeeded: boolean, automationState: EnvelopeAutomationStateEnum }> } | null } | null };

export type ExportDocxForAgreementMutationVariables = Exact<{
  input: ExportDocxForAgreementInput;
}>;


export type ExportDocxForAgreementMutation = { __typename?: 'Mutation', exportDocxForAgreement?: { __typename?: 'ExportDocxForAgreementPayload', agreement?: { __typename?: 'Agreement', id: string, lastUpdate?: { __typename?: 'AgreementIteration', fileDocx?: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null } | null } | null } | null } | null };

export type GenerateSignableAgreementFileMutationVariables = Exact<{
  input: GenerateSignableAgreementFileInput;
}>;


export type GenerateSignableAgreementFileMutation = { __typename?: 'Mutation', generateSignableAgreementFile?: { __typename?: 'GenerateSignableAgreementFilePayload', agreement?: { __typename?: 'Agreement', id: string, lastUpdate?: { __typename?: 'AgreementIteration', fileSignable?: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null } | null } | null } | null } | null };

export type MarkAgreementAsViewedMutationVariables = Exact<{
  input: MarkAsViewedInput;
}>;


export type MarkAgreementAsViewedMutation = { __typename?: 'Mutation', markAgreementAsViewed?: { __typename?: 'MarkAsViewedPayload', hiring?: { __typename?: 'Hiring', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, lastUpdate?: { __typename?: 'AgreementIteration', viewedByMe: boolean } | null }> } | null } | null };

export type SendEnvelopeReminderMutationVariables = Exact<{
  input: SendEnvelopeReminderInput;
}>;


export type SendEnvelopeReminderMutation = { __typename?: 'Mutation', sendEnvelopeReminder?: { __typename?: 'SendEnvelopeReminderPayload', envelope?: { __typename?: 'Envelope', id: string, automationState: EnvelopeAutomationStateEnum, events: Array<{ __typename?: 'EnvelopeEventType', actorName?: string | null, createdAt: any, eventType: EnvelopeEventTypeEnum }> } | null } | null };

export type UploadAgreementMutationVariables = Exact<{
  input: UploadAgreementInput;
}>;


export type UploadAgreementMutation = { __typename?: 'Mutation', uploadAgreement?: { __typename?: 'UploadAgreementPayload', errors: Array<string>, employment?: { __typename?: 'Employment', id: string, hiring?: { __typename?: 'Hiring', id: string, isAgreementESignEnabled: boolean, isOsaSigned: boolean, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }>, companyProcess: { __typename?: 'EmploymentsHiringCompanyProcess', steps: Array<{ __typename?: 'EmploymentsHiringCompanyProcessStep', name: EmploymentsHiringCompanyProcessStepName, progress: EmploymentsHiringStepProgress, staffNotes: { __typename?: 'StaffNoteConnection', id: string, totalCount: number, postingContext: string } }> }, employeeProcess: { __typename?: 'EmploymentsHiringEmployeeProcess', steps: Array<{ __typename?: 'EmploymentsHiringEmployeeProcessStep', name: EmploymentsHiringEmployeeProcessStepName, progress: EmploymentsHiringStepProgress, staffNotes: { __typename?: 'StaffNoteConnection', id: string, totalCount: number, postingContext: string } }> } } | null, invitation?: { __typename?: 'Invitation', sentAt?: any | null } | null } | null, engagement?: { __typename?: 'Engagement', id: string, termination?: { __typename?: 'Termination', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }> } | null } | null } | null };

export type ValidateClmTemplateMutationVariables = Exact<{
  input: ValidateClmTemplateInput;
}>;


export type ValidateClmTemplateMutation = { __typename?: 'Mutation', validateClmTemplate?: { __typename?: 'ValidateClmTemplatePayload', notMappedVariables?: Array<string> | null, missingKeywords?: Array<string> | null, partyEditRightsConfigured: boolean, errors: Array<string>, file?: { __typename?: 'DownloadLink', url?: string | null, byteSize: number, createdAt: any, base64?: string | null, contentType: string } | null, mismatchedOptions?: Array<{ __typename?: 'AgreementTemplateVariableArrayType', name: string, value?: Array<string> | null } | { __typename?: 'AgreementTemplateVariableStringType' }> | null } | null };

export type VerifyAgreementMutationVariables = Exact<{
  input: VerifyAgreementInput;
}>;


export type VerifyAgreementMutation = { __typename?: 'Mutation', verifyAgreement?: { __typename?: 'VerifyAgreementPayload', errors: Array<string>, employment?: { __typename?: 'Employment', id: string, invitation?: { __typename?: 'Invitation', sentAt?: any | null } | null, hiring?: { __typename?: 'Hiring', banners: Array<BannerTypeEnum>, id: string, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }>, envelopes: Array<{ __typename?: 'Envelope', id: string, automationState: EnvelopeAutomationStateEnum, isUpdateNeeded: boolean }>, companyProcess: { __typename?: 'EmploymentsHiringCompanyProcess', currentStep: { __typename?: 'EmploymentsHiringCompanyProcessStep', name: EmploymentsHiringCompanyProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringCompanyProcessStep', progress: EmploymentsHiringStepProgress, name: EmploymentsHiringCompanyProcessStepName }> }, employeeProcess: { __typename?: 'EmploymentsHiringEmployeeProcess', currentStep: { __typename?: 'EmploymentsHiringEmployeeProcessStep', name: EmploymentsHiringEmployeeProcessStepName, progress: EmploymentsHiringStepProgress }, steps: Array<{ __typename?: 'EmploymentsHiringEmployeeProcessStep', progress: EmploymentsHiringStepProgress, name: EmploymentsHiringEmployeeProcessStepName }> } } | null } | null, engagement?: { __typename?: 'Engagement', id: string, termination?: { __typename?: 'Termination', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isSynced: boolean, state: AgreementStateEnum, parties: Array<AgreementPartyTypeEnum>, isAutomated: boolean, reasonForBecomingManual?: AgreementReasonForBecomingManualEnum | null, lastVerifiedAt?: any | null, isESignEnabled: boolean, requiredPlaceholders?: Array<AgreementPlaceholderEnum> | null, lastUpdate?: { __typename?: 'AgreementIteration', party: AgreementPartyTypeEnum, viewedByMe: boolean, timestamp: any, userName?: string | null, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null, contentType: string } } | null, automation?: { __typename?: 'AgreementAutomation', state?: AgreementAutomationStateEnum | null } | null, envelope?: { __typename?: 'Envelope', id: string, state: EnvelopeStateEnum, automationState: EnvelopeAutomationStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', name?: string | null, email?: string | null, party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, recipientType: EnvelopeRecipientTypeEnum }>, events: Array<{ __typename?: 'EnvelopeEventType', eventType: EnvelopeEventTypeEnum, createdAt: any }> } | null }> } | null } | null } | null };

export type VoidHiringEnvelopeMutationVariables = Exact<{
  input: VoidEnvelopeInput;
}>;


export type VoidHiringEnvelopeMutation = { __typename?: 'Mutation', voidHiringEnvelope?: { __typename?: 'VoidEnvelopePayload', errors: Array<string>, envelope?: { __typename?: 'Envelope', id: string, automationState: EnvelopeAutomationStateEnum, state: EnvelopeStateEnum } | null } | null };

export type HiringAgreementsTmGetAgreementsQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;


export type HiringAgreementsTmGetAgreementsQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, hiring?: { __typename?: 'Hiring', id: string, teamMemberAgreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, state: AgreementStateEnum, lastUpdate?: { __typename?: 'AgreementIteration', timestamp: any, file: { __typename?: 'DownloadLink', filename?: string | null, url?: string | null } } | null }> } | null } | null };

export type BestInClassScoreQueryVariables = Exact<{
  engagementId: Scalars['ID']['input'];
}>;


export type BestInClassScoreQuery = { __typename?: 'Query', sageForest: { __typename?: 'SageForest', bestInClassScore: { __typename?: 'BestInClassScore', score: number, insights: Array<{ __typename?: 'BestInClassInsightType', attribute: BestInClassAttribute, valueForMaxScore?: string | null }> } } };

export type DirectDebitForDepositInvoiceFragmentFragment = { __typename?: 'Company', directDebitAuthorized: boolean, directDebitAvailable: boolean, directDebitEnforced: boolean, directDebitConstraint?: { __typename?: 'DirectDebitConstraint', blocked: boolean } | null, invoicingSettings?: { __typename?: 'InvoicingCompanySettings', depositBeforeLiability: boolean } | null };

export type HiringFteStaffGetSecurityDepositInvoiceQueryVariables = Exact<{
  resellerOrCompanyId: Scalars['ID']['input'];
  subkinds?: InputMaybe<Array<InvoiceSubkind> | InvoiceSubkind>;
  engagementIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type HiringFteStaffGetSecurityDepositInvoiceQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, invoices: { __typename?: 'InvoiceCollection', collection: Array<{ __typename?: 'Invoice', id: string, createdAt?: any | null }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number, currentPage: number, limitValue: number } } } | null };

export type AdditionalSalariesInfoQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  subdivisionCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AdditionalSalariesInfoQuery = { __typename?: 'Query', countryIntelligence?: { __typename?: 'CountryIntelligence', additionalSalariesRules: { __typename?: 'CountryIntelligenceRulesAdditionalSalaries', customerInfoMessage?: string | null, customerInfoTitle?: string | null, salaries?: Array<{ __typename?: 'CountryIntelligenceRulesAdditionalSalariesSalaries', arePaymentMonthsEditable: boolean, canBeProrated: boolean, defaultSelectedMonths: Array<number>, isDefaultEnabled: boolean, isEditable: boolean, isPartOfGrossSalary: boolean, maxSelectedMonths: number, salary: number }> | null } } | null };

export type VariableCompensationSalaryEstimationQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;


export type VariableCompensationSalaryEstimationQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, employmentType?: string | null, fullTimeHoursPerWeek?: number | null, partTimeDaysPerWeek?: number | null, partTimeHoursPerDay?: number | null, countryCode?: string | null, hourlyRate?: number | null } | null };

export type SickPayIntelligenceQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  subdivisionCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SickPayIntelligenceQuery = { __typename?: 'Query', countryIntelligence?: { __typename?: 'CountryIntelligence', sickPayRule: { __typename?: 'CountryIntelligenceRulesSickPay', customDurationOption?: string | null, options?: Array<string> | null, maxCustomDuration?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } } | null };

export type HiringFteCompanyCreateDocumentHiringFlowMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  signedDocumentId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type HiringFteCompanyCreateDocumentHiringFlowMutation = { __typename?: 'Mutation', createDocument?: { __typename?: 'CreateDocumentPayload', errors: Array<string> } | null };

export type HiringFteCompanyGetEngagementRelatedDocumentsHiringFlowQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HiringFteCompanyGetEngagementRelatedDocumentsHiringFlowQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', id: string, documents: Array<{ __typename?: 'Document', id: string, filename: string, title: string }> } | null };

export type HiringFteCompanyDestroyDocumentHiringFlowMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type HiringFteCompanyDestroyDocumentHiringFlowMutation = { __typename?: 'Mutation', destroyDocument?: { __typename?: 'DestroyDocumentPayload', errors: Array<string> } | null };

export type HiringFteCompanyGetProbationPeriodIntelligenceRulesQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  subdivisionCodes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  teamMemberSeniority?: InputMaybe<CountryIntelligenceTeamMemberSeniority>;
  employmentType?: InputMaybe<CountryIntelligenceEmploymentType>;
}>;


export type HiringFteCompanyGetProbationPeriodIntelligenceRulesQuery = { __typename?: 'Query', countryIntelligence?: { __typename?: 'CountryIntelligence', isoAlpha2Code: string, probationRules: Array<{ __typename?: 'CountryIntelligenceRulesProbation', oysterScore: CountryIntelligenceOysterScore, employmentType: CountryIntelligenceEmploymentType, teamMemberLevel?: CountryIntelligenceTeamMemberLevel | null, teamMemberSeniorities?: Array<CountryIntelligenceTeamMemberSeniority> | null, duration: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null }, extension?: { __typename?: 'CountryIntelligenceRulesProbationExtension', deadline?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null, maxAdditionalDuration?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null, tenureRange?: { __typename?: 'CalendarDurationRange', max?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null, min?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null }> } | null };

export type UpdateEmploymentInformationMutationVariables = Exact<{
  input: UpdateEmploymentInformationInput;
}>;


export type UpdateEmploymentInformationMutation = { __typename?: 'Mutation', updateEmploymentInformation?: { __typename?: 'UpdateEmploymentInformationPayload', employment?: { __typename?: 'Employment', id: string, state: string, countryCode?: string | null, subdivisionCode?: string | null, role?: string | null, seniorityLevel?: EngagementSeniorityLevelType | null, engagementType: EngagementType, employmentType?: string | null, partTimeDaysPerWeek?: number | null, partTimeHoursPerDay?: number | null, fullTimeHoursPerWeek?: number | null, managerRole?: string | null, managerName?: string | null, startDate?: any | null, initialStartDate?: any | null, isPayrollTeamMember: boolean, probationEnd?: any | null, endDate?: any | null, jobDescription?: string | null, minimumQualification?: string | null, dailyResponsibility?: string | null, primaryDuty?: string | null, decisionMakingAuthority?: string | null, salaryAmount?: number | null, salaryCurrencyCode?: string | null, hourlyRate?: number | null, lockedCurrencyCode?: CurrencyEnum | null, bonusAmount?: number | null, bonusCurrencyCode?: string | null, providedEquipmentList?: Array<EquipmentListEnum> | null, providedEquipmentOther?: string | null, providedEquipmentPolicy?: EquipmentPolicyEnum | null, benefitsDescription?: string | null, privateNotes?: string | null, offerLetterSendRequested: boolean, newHireStatus: EngagementNewHireStatusType, managerEmailAddress?: string | null, managerPhoneNumber?: string | null, managerIsExpenseApprover: boolean, probationPeriodValue?: number | null, probationPeriodType?: EngagementProbationPeriodType | null, probationPeriod?: any | null, paidHolidayDays?: number | null, commissionPlanOffered?: boolean | null, equityOffered?: boolean | null, visaDocumentUrl?: string | null, visaRequired?: boolean | null, workFocusedWithinCountryOfResidence?: boolean | null, cutoffMonthDay: number, employmentComplianceCheck?: boolean | null, employmentComplianceDetails?: string | null, depositBeforeLiability?: boolean | null, availableAllowancePolicies: Array<ReimbursementPolicyEnum>, personalInfo: { __typename?: 'EmploymentPersonalInfo', fullLegalName: string, email?: string | null, nationality?: CountryIsoCode | null }, providedEquipmentPolicyBudget?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string, subunitToUnit: number } | null, reimbursementPolicy?: { __typename?: 'ReimbursementPolicy', policy?: ReimbursementPolicyEnum | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string, subunitToUnit: number } | null } | null, commissionPlan?: { __typename?: 'Document', id: string, title: string, description?: string | null, filename: string } | null, company: { __typename?: 'Company', id: string, countrySales?: { __typename?: 'CountrySales', mightSellInChina?: boolean | null, mightSellInIsrael?: boolean | null, mightSellInColombia?: boolean | null, mightSellInBolivia?: boolean | null } | null, authorizations?: { __typename?: 'Authorization', actions: Array<string>, fields: Array<string> } | null }, department?: { __typename?: 'Department', id: string, name?: string | null } | null, suggestedBenefitPlans?: Array<{ __typename?: 'BenefitsPlan', id: string, descriptiveName: string, name: string, provider: { __typename?: 'BenefitsProvider', name: string }, priceEstimate?: { __typename?: 'BenefitsPlanPrice', currencies: Array<{ __typename?: 'Money', subunit: any, formatted: string, currencyCode: string, subunitToUnit: number }> } | null }> | null, benefitsEnrollments: { __typename?: 'BenefitsEnrollmentCollection', collection: Array<{ __typename?: 'BenefitsEnrollment', id: string, plan: { __typename?: 'BenefitsPlan', id: string } }> }, benefitsProvisionedEnrollments: { __typename?: 'BenefitsProvisionedEnrollmentCollection', collection: Array<{ __typename?: 'BenefitsProvisionedEnrollment', id: string, plan: { __typename?: 'BenefitsPlan', id: string } }> }, hiring?: { __typename?: 'Hiring', id: string, selfServiceOnboarding: boolean, isAgreementESignEnabled: boolean, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isAutomated: boolean, lastUpdate?: { __typename?: 'AgreementIteration', timestamp: any } | null }> } | null, variableCompensations: { __typename?: 'VariableCompensationLegacyConnection', nodes?: Array<{ __typename?: 'VariableCompensation', id: string, label: VariableCompensationLabelEnum, changeReason?: string | null, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, customLabel?: string | null, effectiveEndDate?: any | null, effectiveDate?: any | null, guaranteed?: boolean | null, includedInGrossSalary?: boolean | null, statutory?: boolean | null, systemGenerated?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths: Array<MonthsEnum>, prorated?: boolean | null, editedAfterCreationFromTemplate?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null, variableCompensationTemplate?: { __typename?: 'VariableCompensationTemplate', id?: string | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null } | null } | null> | null }, visa: { __typename?: 'EmploymentVisa', acquisionFee?: number | null, acquisionFeeCurrencyCode?: string | null, acquisitionPayer: VisaAcquisitionPayerTypeEnum, documentUrl?: string | null, expirationDate?: any | null, required?: boolean | null, document?: { __typename?: 'Document', id: string, title: string, description?: string | null, filename: string } | null }, restrictiveCovenants?: { __typename?: 'RestrictiveCovenants', confidentiality: boolean, nonCompetition: boolean, nonSolicitation: boolean, nonSolicitationCustomers?: boolean | null, nonSolicitationEmployees?: boolean | null, postTerminationDurationMonths?: number | null, postTerminationAmountAbsoluteSubunit?: any | null, postTerminationAmountPercentage?: number | null, postTerminationPaymentFrequency?: PostTerminationPaymentFrequency | null, postTerminationAcknowledged?: boolean | null, postTerminationRestrictedArea?: PostTerminationRestrictedArea | null, postTerminationAreaOfBusiness?: string | null, postTerminationAreaOfBusinessInLocalLanguage?: string | null, postTerminationAdditionalAreas: Array<CountryIsoCode> } | null, employmentTemplate?: { __typename?: 'EmploymentTemplate', commissionPlanOffered?: boolean | null, countryCode?: CountryIsoCode | null, description?: string | null, equityOffered?: boolean | null, id?: string | null, name: string, oysterScore?: CountryIntelligenceOysterScore | null, paidHolidayDays?: number | null, probationPeriod?: any | null, status: EmploymentTemplateStatus, commissionPlan?: { __typename?: 'Document', id: string, title: string, description?: string | null, filename: string } | null, company: { __typename?: 'Company', id: string, paymentCurrencyCode?: string | null }, variableCompensationTemplates: Array<{ __typename?: 'VariableCompensationTemplate', id?: string | null, label: VariableCompensationLabelEnum, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, guaranteed?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths?: Array<MonthsEnum> | null, statutory: boolean, systemGenerated: boolean, prorated?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null }>, remoteWorkCosts?: { __typename?: 'EngagementRemoteWorkCostObjectType', equipmentListProvidedByCustomer?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentListOwnedByTeamMember?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentBudget?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentOneTimePayment?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, allowancePolicy?: { __typename?: 'EngagementRemoteWorkCostAllowancePolicyObjectType', active: boolean, selectable: boolean, isStatutory: boolean, statutoryPolicySubunit: any, topUpPolicySubunit: any, allowancePolicySubunit: any, allowancePolicy?: ReimbursementPolicyEnum | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, compatibleAllowancePolicies?: Array<ReimbursementPolicyEnum> | null } | null } | null, benefitsEnrollmentTemplate?: { __typename?: 'BenefitsEnrollmentTemplateType', id: string, tier?: { __typename?: 'BenefitsTier', id: string, name: string, includedPlans: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> } | null, pensions?: Array<{ __typename?: 'BenefitsEnrollmentTemplatePensionType', plan: { __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string }, planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null }, costContribution?: { __typename?: 'BenefitsEnrollmentTemplatePensionCostContributionType', contributor: BenefitsEnrollmentCostContributorEnum, amountAsPercentage: number } | null }> | null, supplementaryBenefits?: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, category: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> | null, preferredCostSplit?: Array<{ __typename?: 'CostSplitSetting', planId: string, employerContribution: number, dependentsEmployerContribution: number, dependentsEmployerContributionMaxCount: number, plan: { __typename?: 'BenefitsPlan', id: string, name: string, costSplitAllowed: boolean, provider: { __typename?: 'BenefitsProvider', name: string } } }> | null } | null } | null, reimbursementBudgets: { __typename?: 'ReimbursementBudgetLegacyConnection', nodes?: Array<{ __typename?: 'ReimbursementBudget', id: string, label: ReimbursementBudgetLabelEnum, changeReason?: string | null, customLabel?: string | null, effectiveDate?: any | null, effectiveEndDate?: any | null, resetFrequency: ResetFrequencyEnum, amount: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } } | null> | null }, roleType?: { __typename?: 'RoleType', id: string, name: string, description?: string | null } | null, sickPay?: { __typename?: 'SickPay', customDurationUnit?: SickPayDurationUnitEnum | null, customDurationValue?: number | null, id: string, option: string } | null, latestSalaryCurrencyConversion?: { __typename?: 'SalaryCurrencyConversion', id: string, exchangeRateValue: number, expired: boolean, receivedCurrencyCode: string, receivedAmount: number } | null, workSchedules?: Array<{ __typename?: 'WorkSchedule', day: DayOfWeekEnum, startTime: string, endTime: string }> | null, resignationNotice?: { __typename?: 'ContractualResignation', type: TypesEngagementContractualResignationTypeEnum, duration?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null, remoteWorkCosts?: { __typename?: 'EngagementRemoteWorkCostObjectType', equipmentListProvidedByCustomer?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, equipmentListOwnedByTeamMember?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, equipmentBudget?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, equipmentOneTimePayment?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null, allowancePolicy?: { __typename?: 'EngagementRemoteWorkCostAllowancePolicyObjectType', active: boolean, selectable: boolean, isStatutory: boolean, statutoryPolicySubunit: any, topUpPolicySubunit: any, allowancePolicySubunit: any, allowancePolicy?: ReimbursementPolicyEnum | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, compatibleAllowancePolicies?: Array<ReimbursementPolicyEnum> | null, editedAfterCreationFromTemplate: boolean } | null } | null, contractedTerminationNotice?: { __typename?: 'ContractualTermination', type: TypesEngagementContractualTerminationTypeEnum, duration?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null } | null, fieldErrors: Array<{ __typename?: 'FormFieldError', fieldId: string, message: string, target?: string | null }> } | null };

export type RoleTypesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type RoleTypesQuery = { __typename?: 'Query', roleTypes: Array<{ __typename?: 'RoleType', id: string, name: string, description?: string | null }> };

export type HiringFteDetailsPageQueryQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;


export type HiringFteDetailsPageQueryQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, isPayrollTeamMember: boolean, countryCode?: string | null, personalInfo: { __typename?: 'EmploymentPersonalInfo', fullLegalName: string }, hiring?: { __typename?: 'Hiring', id: string, employmentAgreementsInfo?: { __typename?: 'EmploymentAgreementsInfo', generationType?: GenerationTypeEnum | null, minimumState?: AgreementStateEnum | null } | null } | null } | null, engagement?: { __typename?: 'Engagement', id: string, engagementType: EngagementType } | null };

export type HiringFteEmployeeGetOnboardingFormDataQueryVariables = Exact<{
  engagementId: Scalars['ID']['input'];
}>;


export type HiringFteEmployeeGetOnboardingFormDataQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', id: string, employment?: { __typename?: 'Employment', id: string, personalInfo: { __typename?: 'EmploymentPersonalInfo', fullLegalName: string }, hiring?: { __typename?: 'Hiring', id: string, onboardingForm?: { __typename?: 'CustomFormsResponse', id: string, pageResponses: Array<{ __typename?: 'CustomFormsResponsePage', state: CustomFormsResponseState, schema: { __typename?: 'CustomFormsSchemaPage', id: string, title: string, subtitle?: string | null, pageNumber: number, fields: Array<{ __typename?: 'CustomFormsSchemaFieldGroup', title?: string | null, id: string, type: CustomFormsSchemaFieldType, fields: Array<{ __typename?: 'CustomFormsSchemaFieldGroup', id: string, type: CustomFormsSchemaFieldType } | { __typename?: 'CustomFormsSchemaInputField', id: string, type: CustomFormsSchemaFieldType }> } | { __typename?: 'CustomFormsSchemaInputField', id: string, label: string, type: CustomFormsSchemaFieldType }> }, answers: Array<{ __typename?: 'CustomFormsResponseBankAccountAnswer', id: string, bankAccountValue: boolean } | { __typename?: 'CustomFormsResponseFileAnswer', id: string, fileValue: { __typename?: 'CustomFormsResponseFileAnswerValue', description?: string | null, filename: string, signedDocumentId: string, downloadUrl?: { __typename?: 'DownloadLink', url?: string | null } | null } } | { __typename?: 'CustomFormsResponseMultiStringAnswer', id: string, multiStringValue?: Array<string> | null } | { __typename?: 'CustomFormsResponseStringAnswer', id: string, stringValue?: string | null }> }> } | null } | null } | null } | null };

export type ExemptionFieldsFragmentFragment = { __typename?: 'Engagement', employment?: { __typename?: 'Employment', countryCode?: string | null, subdivisionCode?: string | null, role?: string | null, seniorityLevel?: EngagementSeniorityLevelType | null, minimumQualification?: string | null, dailyResponsibility?: string | null, primaryDuty?: string | null, decisionMakingAuthority?: string | null, hourlyRate?: number | null, salaryAmount?: number | null, salaryCurrencyCode?: string | null, roleType?: { __typename?: 'RoleType', description?: string | null, name: string } | null, hiring?: { __typename?: 'Hiring', hiringProcess?: { __typename?: 'HiringProcess', exemptionFormCompleted: boolean } | null } | null } | null, exemptionForm: { __typename?: 'ExemptionForm', submittedAt?: any | null, engagementAttributesSnapshot?: { __typename?: 'ExemptionFormEngagementSnapshotCollection', collection: Array<{ __typename?: 'ExemptionFormEngagementSnapshot', fieldName: string, value?: string | null }> } | null, responses?: { __typename?: 'ExemptionFormResponseCollection', collection: Array<{ __typename?: 'ExemptionFormResponse', answer: string, question: string }> } | null, typeformHiddenFields?: { __typename?: 'ExemptionFormTypeformHiddenFields', annualSalaryAdministrative: string, annualSalaryAdministrativeNyOther?: string | null, annualSalaryComputers: string, annualSalaryComputersNyOther?: string | null, annualSalaryCreatives: string, annualSalaryCreativesNyOther?: string | null, annualSalaryExecutives: string, annualSalaryExecutivesNyOther?: string | null, annualSalaryLearned: string, annualSalaryLearnedNyOther?: string | null, hourlyRateAdministrative: string, hourlyRateAdministrativeNyOther?: string | null, hourlyRateComputers: string, hourlyRateComputersNyOther?: string | null, hourlyRateCreatives: string, hourlyRateCreativesNyOther?: string | null, hourlyRateExecutives: string, hourlyRateExecutivesNyOther?: string | null, hourlyRateLearned: string, hourlyRateLearnedNyOther?: string | null, salaryType: string } | null } };

export type HiringFteGetExemptionFormAnswersQueryVariables = Exact<{
  engagementId: Scalars['ID']['input'];
  staffView?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HiringFteGetExemptionFormAnswersQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', id: string, employment?: { __typename?: 'Employment', id: string, isUsaExemptEmployee?: boolean | null, countryCode?: string | null, subdivisionCode?: string | null, role?: string | null, seniorityLevel?: EngagementSeniorityLevelType | null, minimumQualification?: string | null, dailyResponsibility?: string | null, primaryDuty?: string | null, decisionMakingAuthority?: string | null, hourlyRate?: number | null, salaryAmount?: number | null, salaryCurrencyCode?: string | null, company: { __typename?: 'Company', name?: string | null }, roleType?: { __typename?: 'RoleType', description?: string | null, name: string } | null, hiring?: { __typename?: 'Hiring', hiringProcess?: { __typename?: 'HiringProcess', exemptionFormCompleted: boolean } | null } | null } | null, exemptionForm: { __typename?: 'ExemptionForm', submittedAt?: any | null, engagementAttributesSnapshot?: { __typename?: 'ExemptionFormEngagementSnapshotCollection', collection: Array<{ __typename?: 'ExemptionFormEngagementSnapshot', fieldName: string, value?: string | null }> } | null, responses?: { __typename?: 'ExemptionFormResponseCollection', collection: Array<{ __typename?: 'ExemptionFormResponse', answer: string, question: string }> } | null, typeformHiddenFields?: { __typename?: 'ExemptionFormTypeformHiddenFields', annualSalaryAdministrative: string, annualSalaryAdministrativeNyOther?: string | null, annualSalaryComputers: string, annualSalaryComputersNyOther?: string | null, annualSalaryCreatives: string, annualSalaryCreativesNyOther?: string | null, annualSalaryExecutives: string, annualSalaryExecutivesNyOther?: string | null, annualSalaryLearned: string, annualSalaryLearnedNyOther?: string | null, hourlyRateAdministrative: string, hourlyRateAdministrativeNyOther?: string | null, hourlyRateComputers: string, hourlyRateComputersNyOther?: string | null, hourlyRateCreatives: string, hourlyRateCreativesNyOther?: string | null, hourlyRateExecutives: string, hourlyRateExecutivesNyOther?: string | null, hourlyRateLearned: string, hourlyRateLearnedNyOther?: string | null, salaryType: string } | null } } | null };

export type HiringAgreementsEmployeeVerificationCodeQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;


export type HiringAgreementsEmployeeVerificationCodeQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, hiring?: { __typename?: 'Hiring', employmentAgreementsESignType?: AgreementESignTypeEnum | null, envelope?: { __typename?: 'Envelope', state: EnvelopeStateEnum, recipients: Array<{ __typename?: 'EnvelopeRecipientType', party?: AgreementPartyTypeEnum | null, status?: EnvelopeRecipientStatusEnum | null, verificationCode?: string | null, eSignType?: AgreementESignTypeEnum | null }> } | null } | null } | null };

export type InviteTeamMemberOnHiringOverviewMutationMutationVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;


export type InviteTeamMemberOnHiringOverviewMutationMutation = { __typename?: 'Mutation', triggerEngagementInvitationNotifications?: { __typename?: 'TriggerEngagementInvitationNotificationsPayload', errors: Array<string>, engagement?: { __typename?: 'Employment', id: string, invitation?: { __typename?: 'Invitation', id: string, sentAt?: any | null } | null, hiring?: { __typename?: 'Hiring', id: string, hiringProcess?: { __typename?: 'HiringProcess', customerTasks: Array<{ __typename?: 'TodoTasksTask', category: TodoTasksTaskCategory, checkAvailableFor: Array<TodoTasksParty>, id: string, name: string, parties: Array<TodoTasksParty>, position: number, state: TodoTasksTaskState, visibleTo: Array<TodoTasksParty>, completedAt?: any | null, completedBy?: { __typename?: 'Actor', name?: string | null, isOysterStaff: boolean } | null }> } | null } | null } | null } | null };

export type HiringAdminUpdateTaskStateMutationVariables = Exact<{
  input: HiringAdminUpdateTaskStateInput;
}>;


export type HiringAdminUpdateTaskStateMutation = { __typename?: 'Mutation', hiringAdminUpdateTaskState?: { __typename?: 'HiringAdminUpdateTaskStatePayload', errors: Array<string>, hiring?: { __typename?: 'Hiring', id: string, hiringProcess?: { __typename?: 'HiringProcess', customerTasks: Array<{ __typename?: 'TodoTasksTask', category: TodoTasksTaskCategory, checkAvailableFor: Array<TodoTasksParty>, id: string, name: string, parties: Array<TodoTasksParty>, position: number, state: TodoTasksTaskState, visibleTo: Array<TodoTasksParty>, completedAt?: any | null, completedBy?: { __typename?: 'Actor', name?: string | null, isOysterStaff: boolean } | null }> } | null } | null } | null };

export type StaffNoteDetailsFragment = { __typename?: 'StaffNote', content: string, createdAt: any, id: string, scope: string, createdBy: { __typename?: 'Actor', id?: string | null, name?: string | null, type: ActorType } };

export type CompanyProcessOverviewQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;


export type CompanyProcessOverviewQuery = { __typename?: 'Query', employment?: { __typename?: 'Employment', id: string, personalInfo: { __typename?: 'EmploymentPersonalInfo', fullLegalName: string, firstName?: string | null }, hiring?: { __typename?: 'Hiring', id: string, hiringProcess?: { __typename?: 'HiringProcess', completedAt?: any | null, customerTasks: Array<{ __typename?: 'TodoTasksTask', category: TodoTasksTaskCategory, checkAvailableFor: Array<TodoTasksParty>, id: string, name: string, parties: Array<TodoTasksParty>, position: number, state: TodoTasksTaskState, visibleTo: Array<TodoTasksParty>, completedAt?: any | null, completedBy?: { __typename?: 'Actor', name?: string | null, isOysterStaff: boolean } | null }>, resellerEndClientRepresentativeTasks: Array<{ __typename?: 'TodoTasksTask', category: TodoTasksTaskCategory, checkAvailableFor: Array<TodoTasksParty>, id: string, name: string, parties: Array<TodoTasksParty>, position: number, state: TodoTasksTaskState, visibleTo: Array<TodoTasksParty>, completedAt?: any | null, completedBy?: { __typename?: 'Actor', name?: string | null, isOysterStaff: boolean } | null }> } | null } | null } | null };

export type HiringProcessOvewviewStaffCreateNoteMutationVariables = Exact<{
  input: PostStaffNoteInput;
}>;


export type HiringProcessOvewviewStaffCreateNoteMutation = { __typename?: 'Mutation', postStaffNote?: { __typename?: 'PostStaffNotePayload', staffNote?: { __typename?: 'StaffNote', content: string, createdAt: any, id: string, scope: string, createdBy: { __typename?: 'Actor', id?: string | null, name?: string | null, type: ActorType } } | null } | null };

export type MarkTaskAsCompletedMutationVariables = Exact<{
  input: TriggerHiringTaskActionInput;
}>;


export type MarkTaskAsCompletedMutation = { __typename?: 'Mutation', triggerHiringTaskAction?: { __typename?: 'TriggerHiringTaskActionPayload', hiring?: { __typename?: 'Hiring', id: string, hiringProcess?: { __typename?: 'HiringProcess', agreementsFieldsBlocked: boolean, agreementsActionsBlocked: boolean, completedAt?: any | null, staffTasks: Array<{ __typename?: 'TodoTasksTask', category: TodoTasksTaskCategory, checkAvailableFor: Array<TodoTasksParty>, id: string, name: string, parties: Array<TodoTasksParty>, position: number, state: TodoTasksTaskState, visibleTo: Array<TodoTasksParty>, completedAt?: any | null, completedBy?: { __typename?: 'Actor', name?: string | null, isOysterStaff: boolean } | null }>, settings: Array<{ __typename?: 'TodoTasksTask', category: TodoTasksTaskCategory, checkAvailableFor: Array<TodoTasksParty>, id: string, name: string, parties: Array<TodoTasksParty>, position: number, state: TodoTasksTaskState, visibleTo: Array<TodoTasksParty>, completedAt?: any | null, completedBy?: { __typename?: 'Actor', name?: string | null, isOysterStaff: boolean } | null }> } | null } | null } | null };

export type StaffProcessOverviewQueryVariables = Exact<{
  engagementId: Scalars['ID']['input'];
}>;


export type StaffProcessOverviewQuery = { __typename?: 'Query', engagement?: { __typename?: 'Engagement', id: string, exemptionForm: { __typename?: 'ExemptionForm', responses?: { __typename?: 'ExemptionFormResponseCollection', collection: Array<{ __typename?: 'ExemptionFormResponse', answer: string, question: string }> } | null }, employment?: { __typename?: 'Employment', id: string, startDate?: any | null, countryCode?: string | null, state: string, isPayrollTeamMember: boolean, depositBeforeLiability?: boolean | null, personalInfo: { __typename?: 'EmploymentPersonalInfo', fullLegalName: string, firstName?: string | null, email?: string | null }, company: { __typename?: 'Company', id: string, name?: string | null, depositInvoiceRequired: boolean }, invitation?: { __typename?: 'Invitation', id: string, sentAt?: any | null } | null, hiring?: { __typename?: 'Hiring', id: string, agreements: Array<{ __typename?: 'Agreement', id: string, agreementType: AgreementTypeEnum, isAutomated: boolean }>, hiringProcess?: { __typename?: 'HiringProcess', completedAt?: any | null, agreementsFieldsBlocked: boolean, agreementsActionsBlocked: boolean, exemptionFormCompleted: boolean, staffTasks: Array<{ __typename?: 'TodoTasksTask', category: TodoTasksTaskCategory, checkAvailableFor: Array<TodoTasksParty>, id: string, name: string, parties: Array<TodoTasksParty>, position: number, state: TodoTasksTaskState, visibleTo: Array<TodoTasksParty>, completedAt?: any | null, completedBy?: { __typename?: 'Actor', name?: string | null, isOysterStaff: boolean } | null }>, notes: Array<{ __typename?: 'StaffNote', content: string, createdAt: any, id: string, scope: string, createdBy: { __typename?: 'Actor', id?: string | null, name?: string | null, type: ActorType } }>, settings: Array<{ __typename?: 'TodoTasksTask', category: TodoTasksTaskCategory, checkAvailableFor: Array<TodoTasksParty>, id: string, name: string, parties: Array<TodoTasksParty>, position: number, state: TodoTasksTaskState, visibleTo: Array<TodoTasksParty>, completedAt?: any | null, completedBy?: { __typename?: 'Actor', name?: string | null, isOysterStaff: boolean } | null }> } | null } | null } | null } | null };

export type CompanyMandatoryDetailsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type CompanyMandatoryDetailsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, name?: string | null, legallyRegisteredName?: string | null, size?: CompanySize | null, countryCode?: string | null, registrationNumber?: string | null, agreementsFields: Array<string>, contractorAgreementsFields: Array<string>, publicUrl?: string | null, modeName: CompanyModeNameType, authorizations?: { __typename?: 'Authorization', actions: Array<string> } | null, address?: { __typename?: 'Address', id: string, createdAt: any, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null } | null, billingAddress?: { __typename?: 'Address', id: string, createdAt: any, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null } | null } | null };

export type CompanyMandatoryDetailsFragment = { __typename?: 'Company', id: string, name?: string | null, legallyRegisteredName?: string | null, size?: CompanySize | null, countryCode?: string | null, registrationNumber?: string | null, agreementsFields: Array<string>, contractorAgreementsFields: Array<string>, publicUrl?: string | null, modeName: CompanyModeNameType, authorizations?: { __typename?: 'Authorization', actions: Array<string> } | null, address?: { __typename?: 'Address', id: string, createdAt: any, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null } | null, billingAddress?: { __typename?: 'Address', id: string, createdAt: any, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, countryCode?: string | null } | null };

export type HiringTemplateCardFragment = { __typename?: 'EmploymentTemplate', id?: string | null, name: string, description?: string | null, countryCode?: CountryIsoCode | null, oysterScore?: CountryIntelligenceOysterScore | null, status: EmploymentTemplateStatus, company: { __typename?: 'Company', id: string, name?: string | null } };

export type HiringTemplatesCompanyGetPreferencesTabHiringTemplatesQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type HiringTemplatesCompanyGetPreferencesTabHiringTemplatesQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, name?: string | null, employmentTemplates: Array<{ __typename?: 'EmploymentTemplate', id?: string | null, name: string, description?: string | null, countryCode?: CountryIsoCode | null, oysterScore?: CountryIntelligenceOysterScore | null, status: EmploymentTemplateStatus, company: { __typename?: 'Company', id: string, name?: string | null } }> } | null };

export type SelectHiringTemplateFragment = { __typename?: 'EmploymentTemplate', id?: string | null, name: string, description?: string | null, countryCode?: CountryIsoCode | null, oysterScore?: CountryIntelligenceOysterScore | null, status: EmploymentTemplateStatus, company: { __typename?: 'Company', id: string, name?: string | null } };

export type ListHiringTemplatesFragment = { __typename?: 'EmploymentTemplate', id?: string | null, name: string, description?: string | null, countryCode?: CountryIsoCode | null, oysterScore?: CountryIntelligenceOysterScore | null, status: EmploymentTemplateStatus, company: { __typename?: 'Company', id: string, name?: string | null } };

export type CreateEnrollmentTemplateMutationVariables = Exact<{
  employmentTemplateId: Scalars['ID']['input'];
  enrollmentTemplateInput: BenefitsEnrollmentTemplateInput;
}>;


export type CreateEnrollmentTemplateMutation = { __typename?: 'Mutation', createEnrollmentTemplate?: { __typename?: 'CreateEnrollmentTemplatePayload', errors: Array<string>, employmentTemplate?: { __typename?: 'EmploymentTemplate', id?: string | null, benefitsEnrollmentTemplate?: { __typename?: 'BenefitsEnrollmentTemplateType', id: string, tier?: { __typename?: 'BenefitsTier', id: string, name: string, includedPlans: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> } | null, pensions?: Array<{ __typename?: 'BenefitsEnrollmentTemplatePensionType', plan: { __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string }, planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null }, costContribution?: { __typename?: 'BenefitsEnrollmentTemplatePensionCostContributionType', contributor: BenefitsEnrollmentCostContributorEnum, amountAsPercentage: number } | null }> | null, supplementaryBenefits?: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, category: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> | null, preferredCostSplit?: Array<{ __typename?: 'CostSplitSetting', planId: string, employerContribution: number, dependentsEmployerContribution: number, dependentsEmployerContributionMaxCount: number, plan: { __typename?: 'BenefitsPlan', id: string, name: string, costSplitAllowed: boolean, provider: { __typename?: 'BenefitsProvider', name: string } } }> | null } | null } | null } | null };

export type CreateEmploymentHiringTemplateMutationVariables = Exact<{
  input: CreateEmploymentTemplateInput;
}>;


export type CreateEmploymentHiringTemplateMutation = { __typename?: 'Mutation', createEmploymentTemplate?: { __typename?: 'CreateEmploymentTemplatePayload', errors: Array<string>, employmentTemplate?: { __typename?: 'EmploymentTemplate', commissionPlanOffered?: boolean | null, countryCode?: CountryIsoCode | null, description?: string | null, equityOffered?: boolean | null, id?: string | null, name: string, oysterScore?: CountryIntelligenceOysterScore | null, paidHolidayDays?: number | null, probationPeriod?: any | null, status: EmploymentTemplateStatus, commissionPlan?: { __typename?: 'Document', id: string, title: string, description?: string | null, filename: string } | null, company: { __typename?: 'Company', id: string, paymentCurrencyCode?: string | null }, variableCompensationTemplates: Array<{ __typename?: 'VariableCompensationTemplate', id?: string | null, label: VariableCompensationLabelEnum, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, guaranteed?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths?: Array<MonthsEnum> | null, statutory: boolean, systemGenerated: boolean, prorated?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null }>, remoteWorkCosts?: { __typename?: 'EngagementRemoteWorkCostObjectType', equipmentListProvidedByCustomer?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentListOwnedByTeamMember?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentBudget?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentOneTimePayment?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, allowancePolicy?: { __typename?: 'EngagementRemoteWorkCostAllowancePolicyObjectType', active: boolean, selectable: boolean, isStatutory: boolean, statutoryPolicySubunit: any, topUpPolicySubunit: any, allowancePolicySubunit: any, allowancePolicy?: ReimbursementPolicyEnum | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, compatibleAllowancePolicies?: Array<ReimbursementPolicyEnum> | null } | null } | null, benefitsEnrollmentTemplate?: { __typename?: 'BenefitsEnrollmentTemplateType', id: string, tier?: { __typename?: 'BenefitsTier', id: string, name: string, includedPlans: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> } | null, pensions?: Array<{ __typename?: 'BenefitsEnrollmentTemplatePensionType', plan: { __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string }, planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null }, costContribution?: { __typename?: 'BenefitsEnrollmentTemplatePensionCostContributionType', contributor: BenefitsEnrollmentCostContributorEnum, amountAsPercentage: number } | null }> | null, supplementaryBenefits?: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, category: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> | null, preferredCostSplit?: Array<{ __typename?: 'CostSplitSetting', planId: string, employerContribution: number, dependentsEmployerContribution: number, dependentsEmployerContributionMaxCount: number, plan: { __typename?: 'BenefitsPlan', id: string, name: string, costSplitAllowed: boolean, provider: { __typename?: 'BenefitsProvider', name: string } } }> | null } | null } | null } | null };

export type DestroyEmploymentHiringTemplateMutationVariables = Exact<{
  input: DestroyEmploymentTemplateInput;
}>;


export type DestroyEmploymentHiringTemplateMutation = { __typename?: 'Mutation', destroyEmploymentTemplate?: { __typename?: 'DestroyEmploymentTemplatePayload', errors: Array<string> } | null };

export type EmploymentTemplateQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  countryCode?: InputMaybe<CountryIsoCode>;
  oysterScore?: InputMaybe<CountryIntelligenceOysterScore>;
}>;


export type EmploymentTemplateQuery = { __typename?: 'Query', employmentTemplate: { __typename?: 'EmploymentTemplate', commissionPlanOffered?: boolean | null, countryCode?: CountryIsoCode | null, description?: string | null, equityOffered?: boolean | null, id?: string | null, name: string, oysterScore?: CountryIntelligenceOysterScore | null, paidHolidayDays?: number | null, probationPeriod?: any | null, status: EmploymentTemplateStatus, commissionPlan?: { __typename?: 'Document', id: string, title: string, description?: string | null, filename: string } | null, company: { __typename?: 'Company', id: string, paymentCurrencyCode?: string | null }, variableCompensationTemplates: Array<{ __typename?: 'VariableCompensationTemplate', id?: string | null, label: VariableCompensationLabelEnum, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, guaranteed?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths?: Array<MonthsEnum> | null, statutory: boolean, systemGenerated: boolean, prorated?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null }>, remoteWorkCosts?: { __typename?: 'EngagementRemoteWorkCostObjectType', equipmentListProvidedByCustomer?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentListOwnedByTeamMember?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentBudget?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentOneTimePayment?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, allowancePolicy?: { __typename?: 'EngagementRemoteWorkCostAllowancePolicyObjectType', active: boolean, selectable: boolean, isStatutory: boolean, statutoryPolicySubunit: any, topUpPolicySubunit: any, allowancePolicySubunit: any, allowancePolicy?: ReimbursementPolicyEnum | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, compatibleAllowancePolicies?: Array<ReimbursementPolicyEnum> | null } | null } | null, benefitsEnrollmentTemplate?: { __typename?: 'BenefitsEnrollmentTemplateType', id: string, tier?: { __typename?: 'BenefitsTier', id: string, name: string, includedPlans: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> } | null, pensions?: Array<{ __typename?: 'BenefitsEnrollmentTemplatePensionType', plan: { __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string }, planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null }, costContribution?: { __typename?: 'BenefitsEnrollmentTemplatePensionCostContributionType', contributor: BenefitsEnrollmentCostContributorEnum, amountAsPercentage: number } | null }> | null, supplementaryBenefits?: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, category: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> | null, preferredCostSplit?: Array<{ __typename?: 'CostSplitSetting', planId: string, employerContribution: number, dependentsEmployerContribution: number, dependentsEmployerContributionMaxCount: number, plan: { __typename?: 'BenefitsPlan', id: string, name: string, costSplitAllowed: boolean, provider: { __typename?: 'BenefitsProvider', name: string } } }> | null } | null } };

export type HiringTemplatesCompanyGetProbationPeriodIntelligenceRulesQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
}>;


export type HiringTemplatesCompanyGetProbationPeriodIntelligenceRulesQuery = { __typename?: 'Query', countryIntelligence?: { __typename?: 'CountryIntelligence', isoAlpha2Code: string, probationRules: Array<{ __typename?: 'CountryIntelligenceRulesProbation', oysterScore: CountryIntelligenceOysterScore, employmentType: CountryIntelligenceEmploymentType, teamMemberLevel?: CountryIntelligenceTeamMemberLevel | null, teamMemberSeniorities?: Array<CountryIntelligenceTeamMemberSeniority> | null, duration: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null }, extension?: { __typename?: 'CountryIntelligenceRulesProbationExtension', deadline?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null, maxAdditionalDuration?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null, tenureRange?: { __typename?: 'CalendarDurationRange', max?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null, min?: { __typename?: 'CalendarDuration', unit: CalendarDurationType, value?: number | null } | null } | null }> } | null };

export type UpdateEnrollmentTemplateMutationVariables = Exact<{
  employmentTemplateId: Scalars['ID']['input'];
  enrollmentTemplateInput: BenefitsEnrollmentTemplateInput;
}>;


export type UpdateEnrollmentTemplateMutation = { __typename?: 'Mutation', updateEnrollmentTemplate?: { __typename?: 'UpdateEnrollmentTemplatePayload', errors: Array<string>, employmentTemplate?: { __typename?: 'EmploymentTemplate', id?: string | null, benefitsEnrollmentTemplate?: { __typename?: 'BenefitsEnrollmentTemplateType', id: string, tier?: { __typename?: 'BenefitsTier', id: string, name: string, includedPlans: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> } | null, pensions?: Array<{ __typename?: 'BenefitsEnrollmentTemplatePensionType', plan: { __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string }, planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null }, costContribution?: { __typename?: 'BenefitsEnrollmentTemplatePensionCostContributionType', contributor: BenefitsEnrollmentCostContributorEnum, amountAsPercentage: number } | null }> | null, supplementaryBenefits?: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, category: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> | null, preferredCostSplit?: Array<{ __typename?: 'CostSplitSetting', planId: string, employerContribution: number, dependentsEmployerContribution: number, dependentsEmployerContributionMaxCount: number, plan: { __typename?: 'BenefitsPlan', id: string, name: string, costSplitAllowed: boolean, provider: { __typename?: 'BenefitsProvider', name: string } } }> | null } | null } | null } | null };

export type UpdateEmploymentHiringTemplateMutationVariables = Exact<{
  input: UpdateEmploymentTemplateInput;
}>;


export type UpdateEmploymentHiringTemplateMutation = { __typename?: 'Mutation', updateEmploymentTemplate?: { __typename?: 'UpdateEmploymentTemplatePayload', errors: Array<string>, employmentTemplate?: { __typename?: 'EmploymentTemplate', commissionPlanOffered?: boolean | null, countryCode?: CountryIsoCode | null, description?: string | null, equityOffered?: boolean | null, id?: string | null, name: string, oysterScore?: CountryIntelligenceOysterScore | null, paidHolidayDays?: number | null, probationPeriod?: any | null, status: EmploymentTemplateStatus, commissionPlan?: { __typename?: 'Document', id: string, title: string, description?: string | null, filename: string } | null, company: { __typename?: 'Company', id: string, paymentCurrencyCode?: string | null }, variableCompensationTemplates: Array<{ __typename?: 'VariableCompensationTemplate', id?: string | null, label: VariableCompensationLabelEnum, amountAsPercentage?: number | null, compensationType: VariableCompensationTypeEnum, guaranteed?: boolean | null, paymentFrequency: PaymentFrequencyEnum, selectedMonths?: Array<MonthsEnum> | null, statutory: boolean, systemGenerated: boolean, prorated?: boolean | null, amount?: { __typename?: 'Money', subunit: any, formatted: string, currencyCode: string } | null }>, remoteWorkCosts?: { __typename?: 'EngagementRemoteWorkCostObjectType', equipmentListProvidedByCustomer?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentListOwnedByTeamMember?: { __typename?: 'EngagementRemoteWorkCostEquipmentObjectType', active: boolean, selectable: boolean, equipmentOther?: string | null, equipmentList?: Array<EquipmentListEnum> | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentBudget?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, equipmentOneTimePayment?: { __typename?: 'EngagementRemoteWorkCostEquipmentBudgetObjectType', active: boolean, selectable: boolean, equipmentBudgetSubunit?: any | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null } | null, allowancePolicy?: { __typename?: 'EngagementRemoteWorkCostAllowancePolicyObjectType', active: boolean, selectable: boolean, isStatutory: boolean, statutoryPolicySubunit: any, topUpPolicySubunit: any, allowancePolicySubunit: any, allowancePolicy?: ReimbursementPolicyEnum | null, compatibleEquipmentPolicies?: Array<EquipmentPolicyEnum> | null, compatibleAllowancePolicies?: Array<ReimbursementPolicyEnum> | null } | null } | null, benefitsEnrollmentTemplate?: { __typename?: 'BenefitsEnrollmentTemplateType', id: string, tier?: { __typename?: 'BenefitsTier', id: string, name: string, includedPlans: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> } | null, pensions?: Array<{ __typename?: 'BenefitsEnrollmentTemplatePensionType', plan: { __typename?: 'BenefitsPlan', id: string, name: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string }, planContributionSetting?: { __typename?: 'BenefitsPlanContributionSettingType', id: string, amount?: number | null, percentage?: number | null, employerCanCustomize: boolean, minimumPercentage?: number | null, maximumPercentage?: number | null, minimumAmountSubunit?: number | null, maximumAmountSubunit?: number | null } | null }, costContribution?: { __typename?: 'BenefitsEnrollmentTemplatePensionCostContributionType', contributor: BenefitsEnrollmentCostContributorEnum, amountAsPercentage: number } | null }> | null, supplementaryBenefits?: Array<{ __typename?: 'BenefitsPlan', id: string, name: string, category: string, provider: { __typename?: 'BenefitsProvider', id: string, name: string } }> | null, preferredCostSplit?: Array<{ __typename?: 'CostSplitSetting', planId: string, employerContribution: number, dependentsEmployerContribution: number, dependentsEmployerContributionMaxCount: number, plan: { __typename?: 'BenefitsPlan', id: string, name: string, costSplitAllowed: boolean, provider: { __typename?: 'BenefitsProvider', name: string } } }> | null } | null } | null } | null };

export const ProcessHighwayStaffNotesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProcessHighwayStaffNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffNoteConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"postingContext"}}]}}]} as unknown as DocumentNode<ProcessHighwayStaffNotesFragment, unknown>;
export const ProcessHighwayFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProcessHighway"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"staffNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProcessHighwayStaffNotes"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"staffNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProcessHighwayStaffNotes"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProcessHighwayStaffNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffNoteConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"postingContext"}}]}}]} as unknown as DocumentNode<ProcessHighwayFragment, unknown>;
export const MoneyFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MoneyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"subunitToUnit"}}]}}]} as unknown as DocumentNode<MoneyFieldsFragment, unknown>;
export const CountrySalesFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySalesFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountrySales"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mightSellInChina"}},{"kind":"Field","name":{"kind":"Name","value":"mightSellInIsrael"}},{"kind":"Field","name":{"kind":"Name","value":"mightSellInColombia"}},{"kind":"Field","name":{"kind":"Name","value":"mightSellInBolivia"}}]}}]} as unknown as DocumentNode<CountrySalesFieldsFragment, unknown>;
export const HiringFteCompanyRegenerationInfoAlertFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringFTECompanyRegenerationInfoAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}}]}}]}}]} as unknown as DocumentNode<HiringFteCompanyRegenerationInfoAlertFragmentFragment, unknown>;
export const HiringFteCompanyRegenerationInfoModalFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringFTECompanyRegenerationInfoModalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]} as unknown as DocumentNode<HiringFteCompanyRegenerationInfoModalFragmentFragment, unknown>;
export const VariableCompensationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeReason"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"customLabel"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"includedInGrossSalary"}},{"kind":"Field","name":{"kind":"Name","value":"statutory"}},{"kind":"Field","name":{"kind":"Name","value":"systemGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensationTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}}]} as unknown as DocumentNode<VariableCompensationFragmentFragment, unknown>;
export const RestrictiveCovenantsSectionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RestrictiveCovenantsSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestrictiveCovenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confidentiality"}},{"kind":"Field","name":{"kind":"Name","value":"nonCompetition"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitation"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitationCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitationEmployees"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationDurationMonths"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAmountAbsoluteSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAmountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationPaymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAcknowledged"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationRestrictedArea"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAreaOfBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAreaOfBusinessInLocalLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAdditionalAreas"}}]}}]} as unknown as DocumentNode<RestrictiveCovenantsSectionFragmentFragment, unknown>;
export const ResignationNoticeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResignationNoticeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resignationNotice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ResignationNoticeFragmentFragment, unknown>;
export const VariableCompensationTemplateFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensationTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"statutory"}},{"kind":"Field","name":{"kind":"Name","value":"systemGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}}]}}]} as unknown as DocumentNode<VariableCompensationTemplateFragmentFragment, unknown>;
export const RemoteWorkCostsTemplateFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EngagementRemoteWorkCostObjectType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentListProvidedByCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentListOwnedByTeamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOneTimePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"isStatutory"}},{"kind":"Field","name":{"kind":"Name","value":"statutoryPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"topUpPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAllowancePolicies"}}]}}]}}]} as unknown as DocumentNode<RemoteWorkCostsTemplateFragmentFragment, unknown>;
export const PlanContributionSettingFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContributionSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planContributionSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"employerCanCustomize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"maximumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmountSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"maximumAmountSubunit"}}]}}]}}]} as unknown as DocumentNode<PlanContributionSettingFragmentFragment, unknown>;
export const BenefitsEnrollmentTemplateFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContributionSettingFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costContribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredCostSplit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"costSplitAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContributionMaxCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContributionSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planContributionSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"employerCanCustomize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"maximumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmountSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"maximumAmountSubunit"}}]}}]}}]} as unknown as DocumentNode<BenefitsEnrollmentTemplateFragmentFragment, unknown>;
export const EmploymentTemplateFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commissionPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissionPlanOffered"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"equityOffered"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"paidHolidayDays"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensationTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remoteWorkCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsEnrollmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContributionSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planContributionSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"employerCanCustomize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"maximumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmountSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"maximumAmountSubunit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensationTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"statutory"}},{"kind":"Field","name":{"kind":"Name","value":"systemGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EngagementRemoteWorkCostObjectType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentListProvidedByCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentListOwnedByTeamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOneTimePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"isStatutory"}},{"kind":"Field","name":{"kind":"Name","value":"statutoryPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"topUpPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAllowancePolicies"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContributionSettingFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costContribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredCostSplit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"costSplitAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContributionMaxCount"}}]}}]}}]} as unknown as DocumentNode<EmploymentTemplateFragmentFragment, unknown>;
export const ReimbursementBudgetFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReimbursementBudgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReimbursementBudget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeReason"}},{"kind":"Field","name":{"kind":"Name","value":"customLabel"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"resetFrequency"}}]}}]} as unknown as DocumentNode<ReimbursementBudgetFragmentFragment, unknown>;
export const RemoteWorkCostsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RemoteWorkCostsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAllowancePolicies"}},{"kind":"Field","name":{"kind":"Name","value":"remoteWorkCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentListProvidedByCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentListOwnedByTeamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOneTimePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"isStatutory"}},{"kind":"Field","name":{"kind":"Name","value":"statutoryPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"topUpPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAllowancePolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}}]}}]}}]} as unknown as DocumentNode<RemoteWorkCostsFragmentFragment, unknown>;
export const RoleTypeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoleTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<RoleTypeFragmentFragment, unknown>;
export const ContractedTerminationNoticeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractedTerminationNoticeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractedTerminationNotice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<ContractedTerminationNoticeFragmentFragment, unknown>;
export const HiringFormEmploymentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringFormEmploymentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"personalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"nationality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionCode"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"seniorityLevel"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"partTimeDaysPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"partTimeHoursPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"fullTimeHoursPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"managerRole"}},{"kind":"Field","name":{"kind":"Name","value":"managerName"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"initialStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"isPayrollTeamMember"}},{"kind":"Field","name":{"kind":"Name","value":"probationEnd"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"jobDescription"}},{"kind":"Field","name":{"kind":"Name","value":"minimumQualification"}},{"kind":"Field","name":{"kind":"Name","value":"dailyResponsibility"}},{"kind":"Field","name":{"kind":"Name","value":"primaryDuty"}},{"kind":"Field","name":{"kind":"Name","value":"decisionMakingAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"salaryAmount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"lockedCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"bonusAmount"}},{"kind":"Field","name":{"kind":"Name","value":"bonusCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"providedEquipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"providedEquipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"providedEquipmentPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"providedEquipmentPolicyBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MoneyFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reimbursementPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policy"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MoneyFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsDescription"}},{"kind":"Field","name":{"kind":"Name","value":"privateNotes"}},{"kind":"Field","name":{"kind":"Name","value":"offerLetterSendRequested"}},{"kind":"Field","name":{"kind":"Name","value":"newHireStatus"}},{"kind":"Field","name":{"kind":"Name","value":"managerEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"managerPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"managerIsExpenseApprover"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriodValue"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriodType"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"paidHolidayDays"}},{"kind":"Field","name":{"kind":"Name","value":"commissionPlanOffered"}},{"kind":"Field","name":{"kind":"Name","value":"commissionPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equityOffered"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countrySales"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySalesFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}},{"kind":"Field","name":{"kind":"Name","value":"fields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedBenefitPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"descriptiveName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceEstimate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MoneyFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsEnrollments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsProvisionedEnrollments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selfServiceOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"isAgreementESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringFTECompanyRegenerationInfoAlertFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringFTECompanyRegenerationInfoModalFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VariableCompensationFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visaDocumentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"visaRequired"}},{"kind":"Field","name":{"kind":"Name","value":"visa"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acquisionFee"}},{"kind":"Field","name":{"kind":"Name","value":"acquisionFeeCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionPayer"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}},{"kind":"Field","name":{"kind":"Name","value":"restrictiveCovenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestrictiveCovenantsSectionFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResignationNoticeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"workFocusedWithinCountryOfResidence"}},{"kind":"Field","name":{"kind":"Name","value":"employmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmploymentTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reimbursementBudgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReimbursementBudgetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RemoteWorkCostsFragment"}},{"kind":"Field","name":{"kind":"Name","value":"roleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoleTypeFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractedTerminationNoticeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffMonthDay"}},{"kind":"Field","name":{"kind":"Name","value":"sickPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customDurationUnit"}},{"kind":"Field","name":{"kind":"Name","value":"customDurationValue"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"option"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestSalaryCurrencyConversion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeRateValue"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"receivedCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"receivedAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employmentComplianceCheck"}},{"kind":"Field","name":{"kind":"Name","value":"employmentComplianceDetails"}},{"kind":"Field","name":{"kind":"Name","value":"depositBeforeLiability"}},{"kind":"Field","name":{"kind":"Name","value":"workSchedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensationTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"statutory"}},{"kind":"Field","name":{"kind":"Name","value":"systemGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EngagementRemoteWorkCostObjectType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentListProvidedByCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentListOwnedByTeamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOneTimePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"isStatutory"}},{"kind":"Field","name":{"kind":"Name","value":"statutoryPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"topUpPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAllowancePolicies"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContributionSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planContributionSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"employerCanCustomize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"maximumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmountSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"maximumAmountSubunit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContributionSettingFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costContribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredCostSplit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"costSplitAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContributionMaxCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MoneyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"subunitToUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySalesFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountrySales"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mightSellInChina"}},{"kind":"Field","name":{"kind":"Name","value":"mightSellInIsrael"}},{"kind":"Field","name":{"kind":"Name","value":"mightSellInColombia"}},{"kind":"Field","name":{"kind":"Name","value":"mightSellInBolivia"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringFTECompanyRegenerationInfoAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringFTECompanyRegenerationInfoModalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeReason"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"customLabel"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"includedInGrossSalary"}},{"kind":"Field","name":{"kind":"Name","value":"statutory"}},{"kind":"Field","name":{"kind":"Name","value":"systemGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensationTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RestrictiveCovenantsSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestrictiveCovenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confidentiality"}},{"kind":"Field","name":{"kind":"Name","value":"nonCompetition"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitation"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitationCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitationEmployees"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationDurationMonths"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAmountAbsoluteSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAmountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationPaymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAcknowledged"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationRestrictedArea"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAreaOfBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAreaOfBusinessInLocalLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAdditionalAreas"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResignationNoticeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resignationNotice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commissionPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissionPlanOffered"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"equityOffered"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"paidHolidayDays"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensationTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remoteWorkCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsEnrollmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReimbursementBudgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReimbursementBudget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeReason"}},{"kind":"Field","name":{"kind":"Name","value":"customLabel"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"resetFrequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RemoteWorkCostsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAllowancePolicies"}},{"kind":"Field","name":{"kind":"Name","value":"remoteWorkCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentListProvidedByCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentListOwnedByTeamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOneTimePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"isStatutory"}},{"kind":"Field","name":{"kind":"Name","value":"statutoryPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"topUpPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAllowancePolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoleTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractedTerminationNoticeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractedTerminationNotice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<HiringFormEmploymentFieldsFragment, unknown>;
export const EnrollmentCostContributionsFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnrollmentCostContributionsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentCostContribution"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}}]} as unknown as DocumentNode<EnrollmentCostContributionsFieldsFragment, unknown>;
export const ProvisionedEnrollmentCostContributionsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvisionedEnrollmentCostContributionsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsProvisionedEnrollment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enrollmentCostContributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnrollmentCostContributionsFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnrollmentCostContributionsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentCostContribution"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}}]} as unknown as DocumentNode<ProvisionedEnrollmentCostContributionsFragmentFragment, unknown>;
export const BenefitsEngagementFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BenefitsEngagementFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subdivisionCode"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsDescription"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsProvisionedAddons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContributionSettingFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsEnrolledPackages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VariableCompensationFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsProvisionedEnrollments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"guideUrl"}},{"kind":"Field","name":{"kind":"Name","value":"coverageTypes"}},{"kind":"Field","name":{"kind":"Name","value":"descriptiveName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContributionSettingFragment"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProvisionedEnrollmentCostContributionsFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"equityGrants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"grantDate"}},{"kind":"Field","name":{"kind":"Name","value":"equityType"}},{"kind":"Field","name":{"kind":"Name","value":"grantShares"}},{"kind":"Field","name":{"kind":"Name","value":"equitySubType"}},{"kind":"Field","name":{"kind":"Name","value":"grantAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MoneyFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vestingStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"vestingCliffMonths"}},{"kind":"Field","name":{"kind":"Name","value":"vestingCliffShares"}},{"kind":"Field","name":{"kind":"Name","value":"vestingScheduleMonths"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnrollmentCostContributionsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentCostContribution"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContributionSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planContributionSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"employerCanCustomize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"maximumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmountSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"maximumAmountSubunit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeReason"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"customLabel"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"includedInGrossSalary"}},{"kind":"Field","name":{"kind":"Name","value":"statutory"}},{"kind":"Field","name":{"kind":"Name","value":"systemGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensationTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProvisionedEnrollmentCostContributionsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsProvisionedEnrollment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enrollmentCostContributions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnrollmentCostContributionsFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MoneyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"subunitToUnit"}}]}}]} as unknown as DocumentNode<BenefitsEngagementFragmentFragment, unknown>;
export const CustomerProcessHighwayFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerProcessHighway"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CustomerProcessHighwayFragment, unknown>;
export const TodoTasksTaskDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TodoTasksTaskDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TodoTasksTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"checkAvailableFor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"visibleTo"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isOysterStaff"}}]}}]}}]} as unknown as DocumentNode<TodoTasksTaskDetailsFragment, unknown>;
export const BonusInputFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BonusInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Bonus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"customLabel"}},{"kind":"Field","name":{"kind":"Name","value":"amountType"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}}]}}]} as unknown as DocumentNode<BonusInputFragmentFragment, unknown>;
export const AllowanceInputFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllowanceInputFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Allowance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"customLabel"}},{"kind":"Field","name":{"kind":"Name","value":"amountType"}},{"kind":"Field","name":{"kind":"Name","value":"fixedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}}]}}]} as unknown as DocumentNode<AllowanceInputFragmentFragment, unknown>;
export const VariableCompensationTemplatePayloadFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationTemplatePayloadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensationTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}}]}}]} as unknown as DocumentNode<VariableCompensationTemplatePayloadFragmentFragment, unknown>;
export const AllowancesRulesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AllowancesRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIntelligenceRulesAllowances"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"partOfGrossSalary"}},{"kind":"Field","name":{"kind":"Name","value":"paidWhen"}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"approximation"}}]}}]} as unknown as DocumentNode<AllowancesRulesFragmentFragment, unknown>;
export const CalendarDurationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<CalendarDurationFragmentFragment, unknown>;
export const CalendarDurationRangeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationRangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDurationRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<CalendarDurationRangeFragmentFragment, unknown>;
export const ProbationRulesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProbationRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIntelligenceRulesProbation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberLevel"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberSeniorities"}},{"kind":"Field","name":{"kind":"Name","value":"extension"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deadline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxAdditionalDuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenureRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationRangeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationRangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDurationRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}}]}}]} as unknown as DocumentNode<ProbationRulesFragmentFragment, unknown>;
export const ResignationRulesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResignationRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIntelligenceRulesResignation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duringProbation"}},{"kind":"Field","name":{"kind":"Name","value":"tenureRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationRangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationRangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDurationRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}}]}}]} as unknown as DocumentNode<ResignationRulesFragmentFragment, unknown>;
export const TerminationRulesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TerminationRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIntelligenceRulesTermination"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duringProbation"}},{"kind":"Field","name":{"kind":"Name","value":"tenureRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationRangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationRangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDurationRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}}]}}]} as unknown as DocumentNode<TerminationRulesFragmentFragment, unknown>;
export const TimeOffRulesFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TimeOffRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIntelligenceRulesTimeOff"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amountPerYear"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<TimeOffRulesFragmentFragment, unknown>;
export const RestrictiveCovenantsRulesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RestrictiveCovenantsRules"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIntelligenceRulesRestrictiveCovenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postTermination"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nonCompetition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nonCompetition"}}},{"kind":"Argument","name":{"kind":"Name","value":"nonSolicitationEmployees"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nonSolicitationEmployees"}}},{"kind":"Argument","name":{"kind":"Name","value":"nonSolicitationCustomers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nonSolicitationCustomers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"maxDuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedDurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountType"}},{"kind":"Field","name":{"kind":"Name","value":"frequencyRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountTopOfMarket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"subunitToUnit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountRecommended"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"subunitToUnit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountStatutory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"subunitToUnit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedAreaRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additionalAreasAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"restrictedArea"}},{"kind":"Field","name":{"kind":"Name","value":"amountTopOfMarket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"subunitToUnit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountRecommended"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"subunitToUnit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountStatutory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"flat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"subunitToUnit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"restrictedClauses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"subdivisionCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subdivisionCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nonCompetition"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitation"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitationCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitationEmployees"}}]}}]}}]} as unknown as DocumentNode<RestrictiveCovenantsRulesFragment, unknown>;
export const CompanyBulkProcessingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyBulkProcessing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HiringBulkProcessing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}},{"kind":"Field","name":{"kind":"Name","value":"countTotal"}},{"kind":"Field","name":{"kind":"Name","value":"countsByEngagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"failed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyBulkProcessingFragment, unknown>;
export const BulkOnboardingFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BulkOnboardingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BulkOnboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"countTotal"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"performer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<BulkOnboardingFragmentFragment, unknown>;
export const BulkProcessingEngagementInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BulkProcessingEngagementInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HiringBulkProcessingCompanyEngagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"usedTokenAt"}}]}}]}}]} as unknown as DocumentNode<BulkProcessingEngagementInfoFragment, unknown>;
export const BulkProcessingEngagementFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BulkProcessingEngagement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberName"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPayrollTeamMember"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]} as unknown as DocumentNode<BulkProcessingEngagementFragment, unknown>;
export const BulkProcessingReportItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BulkProcessingReportItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HiringBulkProcessingReportItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}},{"kind":"Field","name":{"kind":"Name","value":"originalValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"hasExceptionOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BulkProcessingEngagement"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BulkProcessingEngagement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberName"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPayrollTeamMember"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]} as unknown as DocumentNode<BulkProcessingReportItemFragment, unknown>;
export const EngagementStateAffectedEngagementsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EngagementStateAffectedEngagements"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billingType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"personalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullLegalName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPayrollTeamMember"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberName"}}]}}]} as unknown as DocumentNode<EngagementStateAffectedEngagementsFragment, unknown>;
export const EngagementStateSelectorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EngagementStateSelector"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"isPayrollTeamMember"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]} as unknown as DocumentNode<EngagementStateSelectorFragment, unknown>;
export const EmploymentSignatoryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentSignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]} as unknown as DocumentNode<EmploymentSignatoryFragmentFragment, unknown>;
export const CompanySignatoryFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanySignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"areaOfDomain"},"value":{"kind":"StringValue","value":"Signatory","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"400"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areasOfDomain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]} as unknown as DocumentNode<CompanySignatoryFragmentFragment, unknown>;
export const HiringEmploymentAgreementsSignatoryDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringEmploymentAgreementsSignatoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmploymentSignatoryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignatoryFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentSignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanySignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"areaOfDomain"},"value":{"kind":"StringValue","value":"Signatory","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"400"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areasOfDomain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]} as unknown as DocumentNode<HiringEmploymentAgreementsSignatoryDataFragment, unknown>;
export const SendReminderModalEnvelopeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SendReminderModalEnvelope"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Envelope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actorName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSigners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"party"}}]}}]}}]} as unknown as DocumentNode<SendReminderModalEnvelopeFragment, unknown>;
export const AgreementDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgreementDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isSynced"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForBecomingManual"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredPlaceholders"}}]}}]} as unknown as DocumentNode<AgreementDetailsFragment, unknown>;
export const EnvelopeDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnvelopeDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Envelope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"envelopeType"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdateNeeded"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}}]}}]} as unknown as DocumentNode<EnvelopeDetailsFragment, unknown>;
export const TeamMemberAgreementFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMemberAgreement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<TeamMemberAgreementFragment, unknown>;
export const HiringProcessFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringProcessFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiringProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementsFieldsBlocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}}]}}]}}]} as unknown as DocumentNode<HiringProcessFragmentFragment, unknown>;
export const DirectDebitForDepositInvoiceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DirectDebitForDepositInvoiceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directDebitConstraint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"directDebitAuthorized"}},{"kind":"Field","name":{"kind":"Name","value":"directDebitAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"directDebitEnforced"}},{"kind":"Field","name":{"kind":"Name","value":"invoicingSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositBeforeLiability"}}]}}]}}]} as unknown as DocumentNode<DirectDebitForDepositInvoiceFragmentFragment, unknown>;
export const ExemptionFieldsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExemptionFieldsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionCode"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"roleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniorityLevel"}},{"kind":"Field","name":{"kind":"Name","value":"minimumQualification"}},{"kind":"Field","name":{"kind":"Name","value":"dailyResponsibility"}},{"kind":"Field","name":{"kind":"Name","value":"primaryDuty"}},{"kind":"Field","name":{"kind":"Name","value":"decisionMakingAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"salaryAmount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiringProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exemptionFormCompleted"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptionForm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagementAttributesSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"question"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementAttributesSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"typeformHiddenFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualSalaryAdministrative"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryAdministrativeNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryComputers"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryComputersNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryCreatives"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryCreativesNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryExecutives"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryExecutivesNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryLearned"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryLearnedNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateAdministrative"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateAdministrativeNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateComputers"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateComputersNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateCreatives"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateCreativesNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateExecutives"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateExecutivesNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateLearned"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateLearnedNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"salaryType"}}]}}]}}]}}]} as unknown as DocumentNode<ExemptionFieldsFragmentFragment, unknown>;
export const StaffNoteDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StaffNoteDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}}]} as unknown as DocumentNode<StaffNoteDetailsFragment, unknown>;
export const CompanyMandatoryDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyMandatoryDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"legallyRegisteredName"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"agreementsFields"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAgreementsFields"}},{"kind":"Field","name":{"kind":"Name","value":"publicUrl"}},{"kind":"Field","name":{"kind":"Name","value":"modeName"}},{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]} as unknown as DocumentNode<CompanyMandatoryDetailsFragment, unknown>;
export const HiringTemplateCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringTemplateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<HiringTemplateCardFragment, unknown>;
export const ListHiringTemplatesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListHiringTemplates"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringTemplateCard"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringTemplateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ListHiringTemplatesFragment, unknown>;
export const SelectHiringTemplateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SelectHiringTemplate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListHiringTemplates"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringTemplateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListHiringTemplates"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringTemplateCard"}}]}}]} as unknown as DocumentNode<SelectHiringTemplateFragment, unknown>;
export const StaffGetCompanyBulkOnboardingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StaffGetCompanyBulkOnboardings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bulkOnboardings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BulkOnboardingFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"limitValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BulkOnboardingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BulkOnboarding"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"countTotal"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"performer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<StaffGetCompanyBulkOnboardingsQuery, StaffGetCompanyBulkOnboardingsQueryVariables>;
export const CompanyBulkProcessingEngagementsIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyBulkProcessingEngagementsIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterEngagementType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTypeEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractorBillingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamMemberMonetizationPlanName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"states"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignedStaffId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamMemberCountryCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employersOfRecord"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dummy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bulkOnboard"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiringBulkProcessingCompanyEngagements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"engagementTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"employmentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentType"}}},{"kind":"Argument","name":{"kind":"Name","value":"contractorBillingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractorBillingType"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamMemberMonetizationPlanName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamMemberMonetizationPlanName"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"states"},"value":{"kind":"Variable","name":{"kind":"Name","value":"states"}}},{"kind":"Argument","name":{"kind":"Name","value":"assignedStaffId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignedStaffId"}}},{"kind":"Argument","name":{"kind":"Name","value":"teamMemberCountryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamMemberCountryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"employersOfRecord"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employersOfRecord"}}},{"kind":"Argument","name":{"kind":"Name","value":"belongsToDummyCompany"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dummy"}}},{"kind":"Argument","name":{"kind":"Name","value":"bulkOnboard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bulkOnboard"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"limitValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BulkProcessingEngagementInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BulkProcessingEngagementInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HiringBulkProcessingCompanyEngagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"usedTokenAt"}}]}}]}}]} as unknown as DocumentNode<CompanyBulkProcessingEngagementsIdsQuery, CompanyBulkProcessingEngagementsIdsQueryVariables>;
export const StaffGetCompanyBulkProcessingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StaffGetCompanyBulkProcessings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiringBulkProcessings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyBulkProcessing"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"limitValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyBulkProcessing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HiringBulkProcessing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}},{"kind":"Field","name":{"kind":"Name","value":"countTotal"}},{"kind":"Field","name":{"kind":"Name","value":"countsByEngagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"failed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}}]}}]}}]}}]} as unknown as DocumentNode<StaffGetCompanyBulkProcessingsQuery, StaffGetCompanyBulkProcessingsQueryVariables>;
export const StaffGetBulkProcessingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StaffGetBulkProcessing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bulkProcessingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiringBulkProcessing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bulkProcessingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"countTotal"}},{"kind":"Field","name":{"kind":"Name","value":"operation"}},{"kind":"Field","name":{"kind":"Name","value":"countsByEngagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"completed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BulkProcessingReportItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BulkProcessingReportItem"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BulkProcessingEngagement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberName"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isPayrollTeamMember"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BulkProcessingReportItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HiringBulkProcessingReportItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"strongId"}},{"kind":"Field","name":{"kind":"Name","value":"originalValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"hasExceptionOccurred"}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BulkProcessingEngagement"}}]}}]}}]} as unknown as DocumentNode<StaffGetBulkProcessingQuery, StaffGetBulkProcessingQueryVariables>;
export const HiringBulkProcessingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringBulkProcessing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bulkProcessingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiringBulkProcessing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bulkProcessingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strongId"}},{"kind":"Field","name":{"kind":"Name","value":"performer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operation"}},{"kind":"Field","name":{"kind":"Name","value":"countTotal"}},{"kind":"Field","name":{"kind":"Name","value":"countsByEngagementType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strongId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"originalValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"failed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"strongId"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"originalValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<HiringBulkProcessingQuery, HiringBulkProcessingQueryVariables>;
export const HiringCreateBulkProcessingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HiringCreateBulkProcessing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"performerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HiringBulkProcessingOperation"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operationArguments"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"HiringBulkProcessingOperationArguments"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementAttributes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiringCreateBulkProcessing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"performerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"performerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"engagementIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operation"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operationArguments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operationArguments"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"engagementAttributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementAttributes"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkProcessing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"performer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operation"}},{"kind":"Field","name":{"kind":"Name","value":"initiatedOn"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"countTotal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<HiringCreateBulkProcessingMutation, HiringCreateBulkProcessingMutationVariables>;
export const EngagementsStaffGetStateChangeAffectedEngagementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EngagementsStaffGetStateChangeAffectedEngagements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"engagementIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EngagementStateAffectedEngagements"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"limitValue"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EngagementStateAffectedEngagements"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"billingType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"personalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullLegalName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPayrollTeamMember"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberName"}}]}}]} as unknown as DocumentNode<EngagementsStaffGetStateChangeAffectedEngagementsQuery, EngagementsStaffGetStateChangeAffectedEngagementsQueryVariables>;
export const BulkProcessingSelectedEngagementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BulkProcessingSelectedEngagements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiringBulkProcessingSelectedEngagements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"engagementIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EngagementStateSelector"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"limitValue"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EngagementStateSelector"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"isPayrollTeamMember"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]} as unknown as DocumentNode<BulkProcessingSelectedEngagementsQuery, BulkProcessingSelectedEngagementsQueryVariables>;
export const StaffGetAgreementHistoryQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StaffGetAgreementHistoryQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgreementTypeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agreementType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"actorName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"actorName"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StaffGetAgreementHistoryQueryQuery, StaffGetAgreementHistoryQueryQueryVariables>;
export const HiringEmploymentAgreementsStaffAddSignatoryPointOfContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HiringEmploymentAgreementsStaffAddSignatoryPointOfContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddSignatoryPointOfContactInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addSignatoryPointOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignatoryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCountryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanySignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"areaOfDomain"},"value":{"kind":"StringValue","value":"Signatory","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"400"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areasOfDomain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]} as unknown as DocumentNode<HiringEmploymentAgreementsStaffAddSignatoryPointOfContactMutation, HiringEmploymentAgreementsStaffAddSignatoryPointOfContactMutationVariables>;
export const HiringEmploymentAgreementsCompanyAddSignatoryPointOfContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HiringEmploymentAgreementsCompanyAddSignatoryPointOfContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddSignatoryPointOfContactInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addSignatoryPointOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignatoryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCountryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanySignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"areaOfDomain"},"value":{"kind":"StringValue","value":"Signatory","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"400"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areasOfDomain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]} as unknown as DocumentNode<HiringEmploymentAgreementsCompanyAddSignatoryPointOfContactMutation, HiringEmploymentAgreementsCompanyAddSignatoryPointOfContactMutationVariables>;
export const StaffDisableESignOsaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StaffDisableESignOSA"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisableESignOsaInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disableESignOsa"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<StaffDisableESignOsaMutation, StaffDisableESignOsaMutationVariables>;
export const HiringEmploymentAgreementsStaffGetSignatoryDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringEmploymentAgreementsStaffGetSignatoryData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringEmploymentAgreementsSignatoryData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentSignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanySignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"areaOfDomain"},"value":{"kind":"StringValue","value":"Signatory","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"400"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areasOfDomain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringEmploymentAgreementsSignatoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmploymentSignatoryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignatoryFragment"}}]}}]}}]} as unknown as DocumentNode<HiringEmploymentAgreementsStaffGetSignatoryDataQuery, HiringEmploymentAgreementsStaffGetSignatoryDataQueryVariables>;
export const HiringEmploymentAgreementsCompanyGetSignatoryDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringEmploymentAgreementsCompanyGetSignatoryData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringEmploymentAgreementsSignatoryData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentSignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanySignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"areaOfDomain"},"value":{"kind":"StringValue","value":"Signatory","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"400"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areasOfDomain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringEmploymentAgreementsSignatoryData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmploymentSignatoryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignatoryFragment"}}]}}]}}]} as unknown as DocumentNode<HiringEmploymentAgreementsCompanyGetSignatoryDataQuery, HiringEmploymentAgreementsCompanyGetSignatoryDataQueryVariables>;
export const HiringEmploymentAgreementsStaffAssignSignatoryPointOfContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HiringEmploymentAgreementsStaffAssignSignatoryPointOfContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignSignatoryPointOfContactInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignSignatoryPointOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmploymentSignatoryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignatoryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentSignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanySignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"areaOfDomain"},"value":{"kind":"StringValue","value":"Signatory","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"400"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areasOfDomain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]} as unknown as DocumentNode<HiringEmploymentAgreementsStaffAssignSignatoryPointOfContactMutation, HiringEmploymentAgreementsStaffAssignSignatoryPointOfContactMutationVariables>;
export const HiringEmploymentAgreementsCompanyAssignSignatoryPointOfContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HiringEmploymentAgreementsCompanyAssignSignatoryPointOfContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignSignatoryPointOfContactInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignSignatoryPointOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmploymentSignatoryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanySignatoryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentSignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanySignatoryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsOfContact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"areaOfDomain"},"value":{"kind":"StringValue","value":"Signatory","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"400"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"areasOfDomain"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatoryPointOfContact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}}]}}]}}]} as unknown as DocumentNode<HiringEmploymentAgreementsCompanyAssignSignatoryPointOfContactMutation, HiringEmploymentAgreementsCompanyAssignSignatoryPointOfContactMutationVariables>;
export const UpdateAgreementEnvelopeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAgreementEnvelope"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAgreementEnvelopeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAgreementEnvelope"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"envelopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnvelopeDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnvelopeDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Envelope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"envelopeType"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdateNeeded"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgreementDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isSynced"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForBecomingManual"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredPlaceholders"}}]}}]} as unknown as DocumentNode<UpdateAgreementEnvelopeMutation, UpdateAgreementEnvelopeMutationVariables>;
export const AgreementDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AgreementDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgreementTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agreementType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgreementDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isSynced"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForBecomingManual"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredPlaceholders"}}]}}]} as unknown as DocumentNode<AgreementDetailsQuery, AgreementDetailsQueryVariables>;
export const DisableAgreementESignMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableAgreementESignMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisableESignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disableESign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Termination"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DisableAgreementESignMutationMutation, DisableAgreementESignMutationMutationVariables>;
export const GetAgreementEnvelopeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgreementEnvelope"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgreementTypeEnum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isContractor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isContractor"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agreementType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SendReminderModalEnvelope"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"engagementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isContractor"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SendReminderModalEnvelope"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SendReminderModalEnvelope"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Envelope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actorName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentSigners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"party"}}]}}]}}]} as unknown as DocumentNode<GetAgreementEnvelopeQuery, GetAgreementEnvelopeQueryVariables>;
export const SendAgreementEnvelopeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendAgreementEnvelope"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendAgreementEnvelopeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendAgreementEnvelope"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"envelopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnvelopeDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnvelopeDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Envelope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"envelopeType"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdateNeeded"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgreementDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isSynced"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForBecomingManual"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredPlaceholders"}}]}}]} as unknown as DocumentNode<SendAgreementEnvelopeMutation, SendAgreementEnvelopeMutationVariables>;
export const HiringAgreementsStaffGetAgreementsForEngagedEngagementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringAgreementsStaffGetAgreementsForEngagedEngagements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"engagementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgreementDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isSynced"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForBecomingManual"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredPlaceholders"}}]}}]} as unknown as DocumentNode<HiringAgreementsStaffGetAgreementsForEngagedEngagementsQuery, HiringAgreementsStaffGetAgreementsForEngagedEngagementsQueryVariables>;
export const EnvelopePollingQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EnvelopePollingQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"envelopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnvelopeDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnvelopeDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Envelope"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"envelopeType"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdateNeeded"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}}]}}]} as unknown as DocumentNode<EnvelopePollingQueryQuery, EnvelopePollingQueryQueryVariables>;
export const ContractAgreementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractAgreements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fetchAgreements"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fetchDisabledAgreements"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementsSynced"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fetchAgreements"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"disabledAgreements"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fetchDisabledAgreements"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"engagementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgreementDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isSynced"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForBecomingManual"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredPlaceholders"}}]}}]} as unknown as DocumentNode<ContractAgreementsQuery, ContractAgreementsQueryVariables>;
export const GenerateContractAgreementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateContractAgreements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateAgreementsAsyncInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateAgreementsAsync"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerProcessHighway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgreementDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isSynced"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForBecomingManual"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredPlaceholders"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerProcessHighway"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GenerateContractAgreementsMutation, GenerateContractAgreementsMutationVariables>;
export const ContractFieldsQueryFteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractFieldsQueryFTE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementsFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringProcessFragment"}},{"kind":"Field","name":{"kind":"Name","value":"personalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementsFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"restrictiveCovenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementsFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringProcessFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiringProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementsFieldsBlocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractFieldsQueryFteQuery, ContractFieldsQueryFteQueryVariables>;
export const ContractFieldsQueryContractorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractFieldsQueryContractor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementsFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringProcessFragment"}},{"kind":"Field","name":{"kind":"Name","value":"restrictiveCovenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementsFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringProcessFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiringProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementsFieldsBlocked"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractFieldsQueryContractorQuery, ContractFieldsQueryContractorQueryVariables>;
export const HiringEmploymentAgreementsComanyGetAgreementsGenerationStateViaPollingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringEmploymentAgreementsComanyGetAgreementsGenerationStateViaPolling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contractId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contractId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"engagementId"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiringProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgreementDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isSynced"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForBecomingManual"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredPlaceholders"}}]}}]} as unknown as DocumentNode<HiringEmploymentAgreementsComanyGetAgreementsGenerationStateViaPollingQuery, HiringEmploymentAgreementsComanyGetAgreementsGenerationStateViaPollingQueryVariables>;
export const GenerateContractorAgreementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateContractorAgreements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateContractorAgreementsAsyncInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateContractorAgreementsAsync"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"engagementId"}},{"kind":"Field","name":{"kind":"Name","value":"customerProvidedCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"billingType"}},{"kind":"Field","name":{"kind":"Name","value":"scopeOfWork"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"salary"}},{"kind":"Field","name":{"kind":"Name","value":"salaryCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgreementDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isSynced"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForBecomingManual"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredPlaceholders"}}]}}]} as unknown as DocumentNode<GenerateContractorAgreementsMutation, GenerateContractorAgreementsMutationVariables>;
export const DisableAgreementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DisableAgreement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DisableAgreementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"disableAgreement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabledAgreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"envelopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdateNeeded"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DisableAgreementMutation, DisableAgreementMutationVariables>;
export const EnableAgreementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnableAgreement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EnableAgreementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableAgreement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"party"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"disabledAgreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"envelopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdateNeeded"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<EnableAgreementMutation, EnableAgreementMutationVariables>;
export const ExportDocxForAgreementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExportDocxForAgreement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportDocxForAgreementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportDocxForAgreement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileDocx"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExportDocxForAgreementMutation, ExportDocxForAgreementMutationVariables>;
export const GenerateSignableAgreementFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateSignableAgreementFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateSignableAgreementFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateSignableAgreementFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileSignable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GenerateSignableAgreementFileMutation, GenerateSignableAgreementFileMutationVariables>;
export const MarkAgreementAsViewedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkAgreementAsViewed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkAsViewedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAgreementAsViewed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<MarkAgreementAsViewedMutation, MarkAgreementAsViewedMutationVariables>;
export const SendEnvelopeReminderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendEnvelopeReminder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendEnvelopeReminderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEnvelopeReminder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actorName"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SendEnvelopeReminderMutation, SendEnvelopeReminderMutationVariables>;
export const UploadAgreementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadAgreement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadAgreementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadAgreement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAgreementESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isOsaSigned"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProcessHighway"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"termination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProcessHighwayStaffNotes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffNoteConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"postingContext"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgreementDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isSynced"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForBecomingManual"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredPlaceholders"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProcessHighway"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"staffNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProcessHighwayStaffNotes"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"staffNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProcessHighwayStaffNotes"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UploadAgreementMutation, UploadAgreementMutationVariables>;
export const ValidateClmTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidateClmTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidateClmTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateClmTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"byteSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mismatchedOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgreementTemplateVariableArrayType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notMappedVariables"}},{"kind":"Field","name":{"kind":"Name","value":"missingKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"partyEditRightsConfigured"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<ValidateClmTemplateMutation, ValidateClmTemplateMutationVariables>;
export const VerifyAgreementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyAgreement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyAgreementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyAgreement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"banners"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"envelopes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"isUpdateNeeded"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CustomerProcessHighway"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"termination"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgreementDetails"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgreementDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isSynced"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"reasonForBecomingManual"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"viewedByMe"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recipientType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredPlaceholders"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CustomerProcessHighway"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<VerifyAgreementMutation, VerifyAgreementMutationVariables>;
export const VoidHiringEnvelopeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VoidHiringEnvelope"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VoidEnvelopeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voidHiringEnvelope"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"envelope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"automationState"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<VoidHiringEnvelopeMutation, VoidHiringEnvelopeMutationVariables>;
export const HiringAgreementsTmGetAgreementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringAgreementsTMGetAgreements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberAgreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamMemberAgreement"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamMemberAgreement"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Agreement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<HiringAgreementsTmGetAgreementsQuery, HiringAgreementsTmGetAgreementsQueryVariables>;
export const BestInClassScoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BestInClassScore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sageForest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bestInClassScore"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"engagementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"insights"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"}},{"kind":"Field","name":{"kind":"Name","value":"valueForMaxScore"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BestInClassScoreQuery, BestInClassScoreQueryVariables>;
export const HiringFteStaffGetSecurityDepositInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringFTEStaffGetSecurityDepositInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resellerOrCompanyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subkinds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceSubkind"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resellerOrCompanyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subkinds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subkinds"}}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"engagementIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"limitValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<HiringFteStaffGetSecurityDepositInvoiceQuery, HiringFteStaffGetSecurityDepositInvoiceQueryVariables>;
export const AdditionalSalariesInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdditionalSalariesInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subdivisionCodes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryIntelligence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"subdivisionCodes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subdivisionCodes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additionalSalariesRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerInfoMessage"}},{"kind":"Field","name":{"kind":"Name","value":"customerInfoTitle"}},{"kind":"Field","name":{"kind":"Name","value":"salaries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"arePaymentMonthsEditable"}},{"kind":"Field","name":{"kind":"Name","value":"canBeProrated"}},{"kind":"Field","name":{"kind":"Name","value":"defaultSelectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"isDefaultEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isEditable"}},{"kind":"Field","name":{"kind":"Name","value":"isPartOfGrossSalary"}},{"kind":"Field","name":{"kind":"Name","value":"maxSelectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"salary"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdditionalSalariesInfoQuery, AdditionalSalariesInfoQueryVariables>;
export const VariableCompensationSalaryEstimationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VariableCompensationSalaryEstimation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"fullTimeHoursPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"partTimeDaysPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"partTimeHoursPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}}]}}]}}]} as unknown as DocumentNode<VariableCompensationSalaryEstimationQuery, VariableCompensationSalaryEstimationQueryVariables>;
export const SickPayIntelligenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SickPayIntelligence"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subdivisionCodes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryIntelligence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"subdivisionCodes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subdivisionCodes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sickPayRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customDurationOption"}},{"kind":"Field","name":{"kind":"Name","value":"maxCustomDuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"}}]}}]}}]}}]} as unknown as DocumentNode<SickPayIntelligenceQuery, SickPayIntelligenceQueryVariables>;
export const HiringFteCompanyCreateDocumentHiringFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HiringFTECompanyCreateDocumentHiringFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signedDocumentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"signedDocumentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signedDocumentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<HiringFteCompanyCreateDocumentHiringFlowMutation, HiringFteCompanyCreateDocumentHiringFlowMutationVariables>;
export const HiringFteCompanyGetEngagementRelatedDocumentsHiringFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringFTECompanyGetEngagementRelatedDocumentsHiringFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"engagementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<HiringFteCompanyGetEngagementRelatedDocumentsHiringFlowQuery, HiringFteCompanyGetEngagementRelatedDocumentsHiringFlowQueryVariables>;
export const HiringFteCompanyDestroyDocumentHiringFlowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HiringFTECompanyDestroyDocumentHiringFlow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"destroyDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<HiringFteCompanyDestroyDocumentHiringFlowMutation, HiringFteCompanyDestroyDocumentHiringFlowMutationVariables>;
export const HiringFteCompanyGetProbationPeriodIntelligenceRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringFTECompanyGetProbationPeriodIntelligenceRules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subdivisionCodes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamMemberSeniority"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIntelligenceTeamMemberSeniority"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIntelligenceEmploymentType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryIntelligence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"subdivisionCodes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subdivisionCodes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoAlpha2Code"}},{"kind":"Field","name":{"kind":"Name","value":"probationRules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamMemberSeniority"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamMemberSeniority"}}},{"kind":"Argument","name":{"kind":"Name","value":"employmentType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProbationRulesFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationRangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDurationRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProbationRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIntelligenceRulesProbation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberLevel"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberSeniorities"}},{"kind":"Field","name":{"kind":"Name","value":"extension"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deadline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxAdditionalDuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenureRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationRangeFragment"}}]}}]}}]} as unknown as DocumentNode<HiringFteCompanyGetProbationPeriodIntelligenceRulesQuery, HiringFteCompanyGetProbationPeriodIntelligenceRulesQueryVariables>;
export const UpdateEmploymentInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEmploymentInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEmploymentInformationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmploymentInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringFormEmploymentFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MoneyFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"subunitToUnit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CountrySalesFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountrySales"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mightSellInChina"}},{"kind":"Field","name":{"kind":"Name","value":"mightSellInIsrael"}},{"kind":"Field","name":{"kind":"Name","value":"mightSellInColombia"}},{"kind":"Field","name":{"kind":"Name","value":"mightSellInBolivia"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringFTECompanyRegenerationInfoAlertFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringFTECompanyRegenerationInfoModalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Hiring"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeReason"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"customLabel"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"includedInGrossSalary"}},{"kind":"Field","name":{"kind":"Name","value":"statutory"}},{"kind":"Field","name":{"kind":"Name","value":"systemGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensationTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RestrictiveCovenantsSectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestrictiveCovenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confidentiality"}},{"kind":"Field","name":{"kind":"Name","value":"nonCompetition"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitation"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitationCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"nonSolicitationEmployees"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationDurationMonths"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAmountAbsoluteSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAmountPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationPaymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAcknowledged"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationRestrictedArea"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAreaOfBusiness"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAreaOfBusinessInLocalLanguage"}},{"kind":"Field","name":{"kind":"Name","value":"postTerminationAdditionalAreas"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResignationNoticeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resignationNotice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensationTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"statutory"}},{"kind":"Field","name":{"kind":"Name","value":"systemGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EngagementRemoteWorkCostObjectType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentListProvidedByCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentListOwnedByTeamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOneTimePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"isStatutory"}},{"kind":"Field","name":{"kind":"Name","value":"statutoryPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"topUpPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAllowancePolicies"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContributionSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planContributionSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"employerCanCustomize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"maximumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmountSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"maximumAmountSubunit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContributionSettingFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costContribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredCostSplit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"costSplitAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContributionMaxCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commissionPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissionPlanOffered"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"equityOffered"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"paidHolidayDays"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensationTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remoteWorkCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsEnrollmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReimbursementBudgetFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReimbursementBudget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeReason"}},{"kind":"Field","name":{"kind":"Name","value":"customLabel"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"resetFrequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RemoteWorkCostsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAllowancePolicies"}},{"kind":"Field","name":{"kind":"Name","value":"remoteWorkCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentListProvidedByCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentListOwnedByTeamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOneTimePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"isStatutory"}},{"kind":"Field","name":{"kind":"Name","value":"statutoryPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"topUpPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAllowancePolicies"}},{"kind":"Field","name":{"kind":"Name","value":"editedAfterCreationFromTemplate"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoleTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContractedTerminationNoticeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractedTerminationNotice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringFormEmploymentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Employment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"personalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"nationality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionCode"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"seniorityLevel"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"partTimeDaysPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"partTimeHoursPerDay"}},{"kind":"Field","name":{"kind":"Name","value":"fullTimeHoursPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"managerRole"}},{"kind":"Field","name":{"kind":"Name","value":"managerName"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"initialStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"isPayrollTeamMember"}},{"kind":"Field","name":{"kind":"Name","value":"probationEnd"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"jobDescription"}},{"kind":"Field","name":{"kind":"Name","value":"minimumQualification"}},{"kind":"Field","name":{"kind":"Name","value":"dailyResponsibility"}},{"kind":"Field","name":{"kind":"Name","value":"primaryDuty"}},{"kind":"Field","name":{"kind":"Name","value":"decisionMakingAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"salaryAmount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"lockedCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"bonusAmount"}},{"kind":"Field","name":{"kind":"Name","value":"bonusCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"providedEquipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"providedEquipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"providedEquipmentPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"providedEquipmentPolicyBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MoneyFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reimbursementPolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"policy"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MoneyFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsDescription"}},{"kind":"Field","name":{"kind":"Name","value":"privateNotes"}},{"kind":"Field","name":{"kind":"Name","value":"offerLetterSendRequested"}},{"kind":"Field","name":{"kind":"Name","value":"newHireStatus"}},{"kind":"Field","name":{"kind":"Name","value":"managerEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"managerPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"managerIsExpenseApprover"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriodValue"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriodType"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"paidHolidayDays"}},{"kind":"Field","name":{"kind":"Name","value":"commissionPlanOffered"}},{"kind":"Field","name":{"kind":"Name","value":"commissionPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equityOffered"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countrySales"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CountrySalesFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}},{"kind":"Field","name":{"kind":"Name","value":"fields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedBenefitPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"descriptiveName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priceEstimate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MoneyFields"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsEnrollments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsProvisionedEnrollments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selfServiceOnboarding"}},{"kind":"Field","name":{"kind":"Name","value":"isAgreementESignEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringFTECompanyRegenerationInfoAlertFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringFTECompanyRegenerationInfoModalFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VariableCompensationFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"visaDocumentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"visaRequired"}},{"kind":"Field","name":{"kind":"Name","value":"visa"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acquisionFee"}},{"kind":"Field","name":{"kind":"Name","value":"acquisionFeeCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionPayer"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}}]}},{"kind":"Field","name":{"kind":"Name","value":"restrictiveCovenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestrictiveCovenantsSectionFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResignationNoticeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"workFocusedWithinCountryOfResidence"}},{"kind":"Field","name":{"kind":"Name","value":"employmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmploymentTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reimbursementBudgets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReimbursementBudgetFragment"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RemoteWorkCostsFragment"}},{"kind":"Field","name":{"kind":"Name","value":"roleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoleTypeFragment"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContractedTerminationNoticeFragment"}},{"kind":"Field","name":{"kind":"Name","value":"cutoffMonthDay"}},{"kind":"Field","name":{"kind":"Name","value":"sickPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customDurationUnit"}},{"kind":"Field","name":{"kind":"Name","value":"customDurationValue"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"option"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestSalaryCurrencyConversion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeRateValue"}},{"kind":"Field","name":{"kind":"Name","value":"expired"}},{"kind":"Field","name":{"kind":"Name","value":"receivedCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"receivedAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employmentComplianceCheck"}},{"kind":"Field","name":{"kind":"Name","value":"employmentComplianceDetails"}},{"kind":"Field","name":{"kind":"Name","value":"depositBeforeLiability"}},{"kind":"Field","name":{"kind":"Name","value":"workSchedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}}]} as unknown as DocumentNode<UpdateEmploymentInformationMutation, UpdateEmploymentInformationMutationVariables>;
export const RoleTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"roleTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roleTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RoleTypeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RoleTypeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RoleType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<RoleTypesQuery, RoleTypesQueryVariables>;
export const HiringFteDetailsPageQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringFTEDetailsPageQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPayrollTeamMember"}},{"kind":"Field","name":{"kind":"Name","value":"personalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullLegalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employmentAgreementsInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generationType"}},{"kind":"Field","name":{"kind":"Name","value":"minimumState"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"engagementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"engagementType"}}]}}]}}]} as unknown as DocumentNode<HiringFteDetailsPageQueryQuery, HiringFteDetailsPageQueryQueryVariables>;
export const HiringFteEmployeeGetOnboardingFormDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringFTEEmployeeGetOnboardingFormData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"engagementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"personalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullLegalName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"onboardingForm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageResponses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomFormsSchemaInputField"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomFormsSchemaFieldGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"answers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomFormsResponseStringAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"stringValue"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomFormsResponseFileAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"fileValue"},"name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"signedDocumentId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomFormsResponseMultiStringAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"multiStringValue"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CustomFormsResponseBankAccountAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"bankAccountValue"},"name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"schema"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<HiringFteEmployeeGetOnboardingFormDataQuery, HiringFteEmployeeGetOnboardingFormDataQueryVariables>;
export const HiringFteGetExemptionFormAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringFTEGetExemptionFormAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"staffView"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"engagementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExemptionFieldsFragment"}},{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isUsaExemptEmployee"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"staffView"}}}]}]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExemptionFieldsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Engagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"subdivisionCode"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"roleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seniorityLevel"}},{"kind":"Field","name":{"kind":"Name","value":"minimumQualification"}},{"kind":"Field","name":{"kind":"Name","value":"dailyResponsibility"}},{"kind":"Field","name":{"kind":"Name","value":"primaryDuty"}},{"kind":"Field","name":{"kind":"Name","value":"decisionMakingAuthority"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRate"}},{"kind":"Field","name":{"kind":"Name","value":"salaryAmount"}},{"kind":"Field","name":{"kind":"Name","value":"salaryCurrencyCode"}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiringProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exemptionFormCompleted"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"exemptionForm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"engagementAttributesSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"question"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"engagementAttributesSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldName"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"typeformHiddenFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualSalaryAdministrative"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryAdministrativeNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryComputers"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryComputersNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryCreatives"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryCreativesNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryExecutives"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryExecutivesNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryLearned"}},{"kind":"Field","name":{"kind":"Name","value":"annualSalaryLearnedNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateAdministrative"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateAdministrativeNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateComputers"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateComputersNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateCreatives"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateCreativesNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateExecutives"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateExecutivesNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateLearned"}},{"kind":"Field","name":{"kind":"Name","value":"hourlyRateLearnedNyOther"}},{"kind":"Field","name":{"kind":"Name","value":"salaryType"}}]}}]}}]}}]} as unknown as DocumentNode<HiringFteGetExemptionFormAnswersQuery, HiringFteGetExemptionFormAnswersQueryVariables>;
export const HiringAgreementsEmployeeVerificationCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringAgreementsEmployeeVerificationCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employmentAgreementsESignType"}},{"kind":"Field","name":{"kind":"Name","value":"envelope"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"envelopeType"},"value":{"kind":"EnumValue","value":"EMPLOYMENT_AGREEMENTS"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"party"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"verificationCode"}},{"kind":"Field","name":{"kind":"Name","value":"eSignType"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<HiringAgreementsEmployeeVerificationCodeQuery, HiringAgreementsEmployeeVerificationCodeQueryVariables>;
export const InviteTeamMemberOnHiringOverviewMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteTeamMemberOnHiringOverviewMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerEngagementInvitationNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"engagementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiringProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TodoTasksTaskDetails"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TodoTasksTaskDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TodoTasksTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"checkAvailableFor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"visibleTo"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isOysterStaff"}}]}}]}}]} as unknown as DocumentNode<InviteTeamMemberOnHiringOverviewMutationMutation, InviteTeamMemberOnHiringOverviewMutationMutationVariables>;
export const HiringAdminUpdateTaskStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HiringAdminUpdateTaskState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HiringAdminUpdateTaskStateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiringAdminUpdateTaskState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiringProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TodoTasksTaskDetails"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TodoTasksTaskDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TodoTasksTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"checkAvailableFor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"visibleTo"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isOysterStaff"}}]}}]}}]} as unknown as DocumentNode<HiringAdminUpdateTaskStateMutation, HiringAdminUpdateTaskStateMutationVariables>;
export const CompanyProcessOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyProcessOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"employmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"personalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiringProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"customerTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TodoTasksTaskDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resellerEndClientRepresentativeTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TodoTasksTaskDetails"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TodoTasksTaskDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TodoTasksTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"checkAvailableFor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"visibleTo"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isOysterStaff"}}]}}]}}]} as unknown as DocumentNode<CompanyProcessOverviewQuery, CompanyProcessOverviewQueryVariables>;
export const HiringProcessOvewviewStaffCreateNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HiringProcessOvewviewStaffCreateNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PostStaffNoteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postStaffNote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffNote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StaffNoteDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StaffNoteDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}}]} as unknown as DocumentNode<HiringProcessOvewviewStaffCreateNoteMutation, HiringProcessOvewviewStaffCreateNoteMutationVariables>;
export const MarkTaskAsCompletedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkTaskAsCompleted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TriggerHiringTaskActionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"triggerHiringTaskAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hiringProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreementsFieldsBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"agreementsActionsBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"staffTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TodoTasksTaskDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TodoTasksTaskDetails"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TodoTasksTaskDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TodoTasksTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"checkAvailableFor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"visibleTo"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isOysterStaff"}}]}}]}}]} as unknown as DocumentNode<MarkTaskAsCompletedMutation, MarkTaskAsCompletedMutationVariables>;
export const StaffProcessOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StaffProcessOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"engagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"engagementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"engagementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"exemptionForm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"question"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"employment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"isPayrollTeamMember"}},{"kind":"Field","name":{"kind":"Name","value":"personalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullLegalName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"depositInvoiceRequired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}},{"kind":"Field","name":{"kind":"Name","value":"isAutomated"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hiringProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"agreementsFieldsBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"agreementsActionsBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"exemptionFormCompleted"}},{"kind":"Field","name":{"kind":"Name","value":"staffTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TodoTasksTaskDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StaffNoteDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TodoTasksTaskDetails"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositBeforeLiability"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TodoTasksTaskDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TodoTasksTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"checkAvailableFor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parties"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"visibleTo"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"completedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isOysterStaff"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StaffNoteDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffNote"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}}]} as unknown as DocumentNode<StaffProcessOverviewQuery, StaffProcessOverviewQueryVariables>;
export const CompanyMandatoryDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyMandatoryDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompanyMandatoryDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompanyMandatoryDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Company"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"legallyRegisteredName"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"agreementsFields"}},{"kind":"Field","name":{"kind":"Name","value":"contractorAgreementsFields"}},{"kind":"Field","name":{"kind":"Name","value":"publicUrl"}},{"kind":"Field","name":{"kind":"Name","value":"modeName"}},{"kind":"Field","name":{"kind":"Name","value":"authorizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]} as unknown as DocumentNode<CompanyMandatoryDetailsQuery, CompanyMandatoryDetailsQueryVariables>;
export const HiringTemplatesCompanyGetPreferencesTabHiringTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringTemplatesCompanyGetPreferencesTabHiringTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"employmentTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HiringTemplateCard"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HiringTemplateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<HiringTemplatesCompanyGetPreferencesTabHiringTemplatesQuery, HiringTemplatesCompanyGetPreferencesTabHiringTemplatesQueryVariables>;
export const CreateEnrollmentTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createEnrollmentTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enrollmentTemplateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEnrollmentTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employmentTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentTemplateId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"enrollmentTemplateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enrollmentTemplateInput"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"employmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsEnrollmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContributionSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planContributionSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"employerCanCustomize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"maximumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmountSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"maximumAmountSubunit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContributionSettingFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costContribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredCostSplit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"costSplitAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContributionMaxCount"}}]}}]}}]} as unknown as DocumentNode<CreateEnrollmentTemplateMutation, CreateEnrollmentTemplateMutationVariables>;
export const CreateEmploymentHiringTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEmploymentHiringTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEmploymentTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEmploymentTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"employmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmploymentTemplateFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensationTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"statutory"}},{"kind":"Field","name":{"kind":"Name","value":"systemGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EngagementRemoteWorkCostObjectType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentListProvidedByCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentListOwnedByTeamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOneTimePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"isStatutory"}},{"kind":"Field","name":{"kind":"Name","value":"statutoryPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"topUpPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAllowancePolicies"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContributionSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planContributionSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"employerCanCustomize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"maximumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmountSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"maximumAmountSubunit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContributionSettingFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costContribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredCostSplit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"costSplitAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContributionMaxCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commissionPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissionPlanOffered"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"equityOffered"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"paidHolidayDays"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensationTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remoteWorkCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsEnrollmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"}}]}}]}}]} as unknown as DocumentNode<CreateEmploymentHiringTemplateMutation, CreateEmploymentHiringTemplateMutationVariables>;
export const DestroyEmploymentHiringTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DestroyEmploymentHiringTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DestroyEmploymentTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"destroyEmploymentTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DestroyEmploymentHiringTemplateMutation, DestroyEmploymentHiringTemplateMutationVariables>;
export const EmploymentTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmploymentTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIsoCode"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"oysterScore"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIntelligenceOysterScore"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"employmentTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"oysterScore"},"value":{"kind":"Variable","name":{"kind":"Name","value":"oysterScore"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmploymentTemplateFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensationTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"statutory"}},{"kind":"Field","name":{"kind":"Name","value":"systemGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EngagementRemoteWorkCostObjectType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentListProvidedByCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentListOwnedByTeamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOneTimePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"isStatutory"}},{"kind":"Field","name":{"kind":"Name","value":"statutoryPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"topUpPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAllowancePolicies"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContributionSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planContributionSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"employerCanCustomize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"maximumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmountSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"maximumAmountSubunit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContributionSettingFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costContribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredCostSplit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"costSplitAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContributionMaxCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commissionPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissionPlanOffered"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"equityOffered"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"paidHolidayDays"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensationTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remoteWorkCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsEnrollmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"}}]}}]}}]} as unknown as DocumentNode<EmploymentTemplateQuery, EmploymentTemplateQueryVariables>;
export const HiringTemplatesCompanyGetProbationPeriodIntelligenceRulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HiringTemplatesCompanyGetProbationPeriodIntelligenceRules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryIntelligence"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"countryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoAlpha2Code"}},{"kind":"Field","name":{"kind":"Name","value":"probationRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProbationRulesFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDuration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarDurationRangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalendarDurationRange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProbationRulesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CountryIntelligenceRulesProbation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"employmentType"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberLevel"}},{"kind":"Field","name":{"kind":"Name","value":"teamMemberSeniorities"}},{"kind":"Field","name":{"kind":"Name","value":"extension"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deadline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxAdditionalDuration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenureRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarDurationRangeFragment"}}]}}]}}]} as unknown as DocumentNode<HiringTemplatesCompanyGetProbationPeriodIntelligenceRulesQuery, HiringTemplatesCompanyGetProbationPeriodIntelligenceRulesQueryVariables>;
export const UpdateEnrollmentTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEnrollmentTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"employmentTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enrollmentTemplateInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEnrollmentTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"employmentTemplateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"employmentTemplateId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"enrollmentTemplateInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enrollmentTemplateInput"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"employmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsEnrollmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContributionSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planContributionSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"employerCanCustomize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"maximumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmountSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"maximumAmountSubunit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContributionSettingFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costContribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredCostSplit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"costSplitAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContributionMaxCount"}}]}}]}}]} as unknown as DocumentNode<UpdateEnrollmentTemplateMutation, UpdateEnrollmentTemplateMutationVariables>;
export const UpdateEmploymentHiringTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEmploymentHiringTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEmploymentTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEmploymentTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"employmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmploymentTemplateFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VariableCompensationTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subunit"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"currencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"compensationType"}},{"kind":"Field","name":{"kind":"Name","value":"guaranteed"}},{"kind":"Field","name":{"kind":"Name","value":"paymentFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"selectedMonths"}},{"kind":"Field","name":{"kind":"Name","value":"statutory"}},{"kind":"Field","name":{"kind":"Name","value":"systemGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"prorated"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EngagementRemoteWorkCostObjectType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"equipmentListProvidedByCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentListOwnedByTeamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOther"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentList"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudget"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"equipmentOneTimePayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentBudgetSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"selectable"}},{"kind":"Field","name":{"kind":"Name","value":"isStatutory"}},{"kind":"Field","name":{"kind":"Name","value":"statutoryPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"topUpPolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicySubunit"}},{"kind":"Field","name":{"kind":"Name","value":"allowancePolicy"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleEquipmentPolicies"}},{"kind":"Field","name":{"kind":"Name","value":"compatibleAllowancePolicies"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanContributionSettingFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsPlan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planContributionSetting"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"employerCanCustomize"}},{"kind":"Field","name":{"kind":"Name","value":"minimumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"maximumPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"minimumAmountSubunit"}},{"kind":"Field","name":{"kind":"Name","value":"maximumAmountSubunit"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"includedPlans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanContributionSettingFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"costContribution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contributor"}},{"kind":"Field","name":{"kind":"Name","value":"amountAsPercentage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplementaryBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"preferredCostSplit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"costSplitAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContribution"}},{"kind":"Field","name":{"kind":"Name","value":"dependentsEmployerContributionMaxCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmploymentTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EmploymentTemplate"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commissionPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissionPlanOffered"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paymentCurrencyCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"equityOffered"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oysterScore"}},{"kind":"Field","name":{"kind":"Name","value":"paidHolidayDays"}},{"kind":"Field","name":{"kind":"Name","value":"probationPeriod"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"variableCompensationTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VariableCompensationTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remoteWorkCosts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RemoteWorkCostsTemplateFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsEnrollmentTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BenefitsEnrollmentTemplateFragment"}}]}}]}}]} as unknown as DocumentNode<UpdateEmploymentHiringTemplateMutation, UpdateEmploymentHiringTemplateMutationVariables>;